(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.eP.bA === region.gr.bA)
	{
		return 'on line ' + region.eP.bA;
	}
	return 'on lines ' + region.eP.bA + ' through ' + region.gr.bA;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lN,
		impl.n4,
		impl.nF,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		h: func(record.h),
		nC: record.nC,
		m_: record.m_
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.h;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.nC;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.m_) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lN,
		impl.n4,
		impl.nF,
		function(sendToApp, initialModel) {
			var view = impl.oc;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lN,
		impl.n4,
		impl.nF,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.eI && impl.eI(sendToApp)
			var view = impl.oc;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.cg);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.dd) && (_VirtualDom_doc.title = title = doc.dd);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.mF;
	var onUrlRequest = impl.mG;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		eI: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.iy === next.iy
							&& curr.dE === next.dE
							&& curr.il.a === next.il.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		lN: function(flags)
		{
			return A3(impl.lN, flags, _Browser_getUrl(), key);
		},
		oc: impl.oc,
		n4: impl.n4,
		nF: impl.nF
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { lE: 'hidden', kl: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { lE: 'mozHidden', kl: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { lE: 'msHidden', kl: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { lE: 'webkitHidden', kl: 'webkitvisibilitychange' }
		: { lE: 'hidden', kl: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		nh: _Browser_getScene(),
		jH: {
			dj: _Browser_window.pageXOffset,
			jK: _Browser_window.pageYOffset,
			bc: _Browser_doc.documentElement.clientWidth,
			bu: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		bc: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		bu: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			nh: {
				bc: node.scrollWidth,
				bu: node.scrollHeight
			},
			jH: {
				dj: node.scrollLeft,
				jK: node.scrollTop,
				bc: node.clientWidth,
				bu: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			nh: _Browser_getScene(),
			jH: {
				dj: x,
				jK: y,
				bc: _Browser_doc.documentElement.clientWidth,
				bu: _Browser_doc.documentElement.clientHeight
			},
			kZ: {
				dj: x + rect.left,
				jK: y + rect.top,
				bc: rect.width,
				bu: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.k6.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.k6.b, xhr)); });
		$elm$core$Maybe$isJust(request.ju) && _Http_track(router, xhr, request.ju.a);

		try {
			xhr.open(request.mf, request.n8, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.n8));
		}

		_Http_configureRequest(xhr, request);

		request.cg.a && xhr.setRequestHeader('Content-Type', request.cg.a);
		xhr.send(request.cg.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.lB; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.nU.a || 0;
	xhr.responseType = request.k6.d;
	xhr.withCredentials = request.jS;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		n8: xhr.responseURL,
		nA: xhr.status,
		nB: xhr.statusText,
		lB: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			nq: event.loaded,
			ns: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			m7: event.loaded,
			ns: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.mo) { flags += 'm'; }
	if (options.kk) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $author$project$Types$OnUrlChange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$OnUrlRequest = function (a) {
	return {$: 2, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.p) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.r),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.r);
		} else {
			var treeLen = builder.p * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.s) : builder.s;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.p);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.r) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.r);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{s: nodeList, p: (len / $elm$core$Array$branchFactor) | 0, r: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {lo: fragment, dE: host, mM: path, il: port_, iy: protocol, iA: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$NativeBridge$Active = 1;
var $author$project$Types$ClosedMenu = 1;
var $author$project$Types$GetTimezone = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Core$Data$AuthUser$Sponsor = 0;
var $author$project$Core$Data$AuthUser$Sugar = 1;
var $author$project$Core$Data$AuthUser$sponsorPhotoURL = 'https://happymatches.com/assets/images/sponsor.jpg';
var $author$project$Core$Data$AuthUser$sugarPhotoURL = 'https://happymatches.com/assets/images/sugar.jpg';
var $author$project$Core$Data$AuthUser$photoURLtoUserKind = function (userKind) {
	if (userKind.$ === 1) {
		return $elm$core$Result$Err('toUserKind is Nothing');
	} else {
		var string = userKind.a;
		return _Utils_eq(string, $author$project$Core$Data$AuthUser$sponsorPhotoURL) ? $elm$core$Result$Ok(0) : (_Utils_eq(string, $author$project$Core$Data$AuthUser$sugarPhotoURL) ? $elm$core$Result$Ok(1) : $elm$core$Result$Err('toUserKind Invalid value:' + string));
	}
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Core$Data$AuthUser$authUserToUser = function (_v0) {
	var uid = _v0.eX;
	var email = _v0.dt;
	var displayName = _v0.ds;
	var photoURL = _v0.mQ;
	var _v1 = $author$project$Core$Data$AuthUser$photoURLtoUserKind(photoURL);
	if (!_v1.$) {
		var kind = _v1.a;
		return $elm$core$Maybe$Just(
			{
				ds: A2($elm$core$Maybe$withDefault, '', displayName),
				dt: email,
				ho: kind,
				eX: uid
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $author$project$Data$Route$AboutUsRoute = {$: 1};
var $author$project$Data$Route$BlockRoute = {$: 22};
var $author$project$Data$Route$ChatRoute = {$: 21};
var $author$project$Data$Route$ContactUsRoute = {$: 2};
var $author$project$Data$Route$ContentRoute = function (a) {
	return {$: 23, a: a};
};
var $author$project$Data$Route$DeactivateProfileRoute = {$: 14};
var $author$project$Data$Route$FaceVerificationProcessingRoute = {$: 6};
var $author$project$Data$Route$FaceVerificationRoute = {$: 5};
var $author$project$Data$Route$FavoriteProfileRoute = 2;
var $author$project$Data$Route$FavoritedMeRoute = 1;
var $author$project$Data$Route$ForgetPasswordRoute = {$: 9};
var $author$project$Data$Route$HomeRoute = {$: 0};
var $author$project$Data$Route$LoginRoute = {$: 10};
var $author$project$Data$Route$LogoutRoute = {$: 11};
var $author$project$Data$Route$MembershipRoute = {$: 17};
var $author$project$Data$Route$NotFoundRoute = {$: 24};
var $author$project$Data$Route$PageRoute = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Route$PostCategoryRoute = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Route$PostHomeRoute = {$: 0};
var $author$project$Data$Route$PostRoute = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Route$PrivacyRoute = {$: 4};
var $author$project$Data$Route$ProcessingDeactivateProfileRoute = {$: 15};
var $author$project$Data$Route$ProfileDetailRoute = function (a) {
	return {$: 20, a: a};
};
var $author$project$Data$Route$RegisterRoute = {$: 12};
var $author$project$Data$Route$RelatedProfileRoute = function (a) {
	return {$: 19, a: a};
};
var $author$project$Data$Route$SearchRoute = {$: 18};
var $author$project$Data$Route$TermsRoute = {$: 3};
var $author$project$Data$Route$UpdatePasswordRoute = {$: 16};
var $author$project$Data$Route$UpdateProfileRoute = {$: 13};
var $author$project$Data$Route$VerifiedEmailFail = {$: 8};
var $author$project$Data$Route$VerifiedEmailSuccess = {$: 7};
var $author$project$Data$Route$ViewedMeRoute = 0;
var $author$project$NativeBridge$Lt = 2;
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$NativeBridge$Eq = 0;
var $author$project$NativeBridge$Gt = 1;
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$NativeBridge$versionComparison = F2(
	function (a, b) {
		var listB = A2($elm$core$String$split, '.', b);
		var listA = A2($elm$core$String$split, '.', a);
		var getInt = function (list) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2(
						$elm$core$Maybe$withDefault,
						'0',
						$elm$core$List$head(list))));
		};
		var xA = getInt(listA);
		var xB = getInt(listB);
		var yA = getInt(
			A2($elm$core$List$drop, 1, listA));
		var yB = getInt(
			A2($elm$core$List$drop, 1, listB));
		var zA = getInt(
			A2($elm$core$List$drop, 2, listA));
		var zB = getInt(
			A2($elm$core$List$drop, 2, listB));
		return _Utils_eq(a, b) ? 0 : ((_Utils_cmp(xA, xB) > 0) ? 1 : ((_Utils_cmp(xA, xB) < 0) ? 2 : ((_Utils_cmp(yA, yB) > 0) ? 1 : ((_Utils_cmp(yA, yB) < 0) ? 2 : ((_Utils_cmp(zA, zB) > 0) ? 1 : 2)))));
	});
var $author$project$Data$Membership$availableForApp = function (device) {
	if (device.$ === 1) {
		if (!device.a.$) {
			var version = device.a.a;
			return A2($author$project$NativeBridge$versionComparison, version, '1.0.1') !== 2;
		} else {
			var version = device.a.a;
			return A2($author$project$NativeBridge$versionComparison, version, '1.0.2') !== 2;
		}
	} else {
		return true;
	}
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Basics$not = _Basics_not;
var $author$project$Data$Route$removeExtension = function (string) {
	return A2(
		$elm$core$Maybe$withDefault,
		string,
		$elm$core$List$head(
			A2($elm$core$String$split, '.', string)));
};
var $author$project$Data$Route$getUrls = function (url) {
	return A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
		A2(
			$elm$core$String$split,
			'/',
			$author$project$Data$Route$removeExtension(url.mM)));
};
var $author$project$Data$Route$getRoute = F2(
	function (device, url) {
		var _v0 = $author$project$Data$Route$getUrls(url);
		_v0$30:
		while (true) {
			if (!_v0.b) {
				return $author$project$Data$Route$HomeRoute;
			} else {
				switch (_v0.a) {
					case 'index':
						if (!_v0.b.b) {
							return $author$project$Data$Route$HomeRoute;
						} else {
							break _v0$30;
						}
					case 'mobile':
						if (!_v0.b.b) {
							return $author$project$Data$Route$HomeRoute;
						} else {
							break _v0$30;
						}
					case 'about-us':
						return $author$project$Data$Route$AboutUsRoute;
					case 'contact-us':
						return $author$project$Data$Route$ContactUsRoute;
					case 'terms-and-conditions':
						return $author$project$Data$Route$TermsRoute;
					case 'privacy-policy':
						return $author$project$Data$Route$PrivacyRoute;
					case 'face-verification-processing':
						return $author$project$Data$Route$FaceVerificationProcessingRoute;
					case 'face-verification':
						return $author$project$Data$Route$FaceVerificationRoute;
					case 'verified-email-success':
						return $author$project$Data$Route$VerifiedEmailSuccess;
					case 'verified-email-fail':
						return $author$project$Data$Route$VerifiedEmailFail;
					case 'register':
						return $author$project$Data$Route$RegisterRoute;
					case 'login':
						return $author$project$Data$Route$LoginRoute;
					case 'logout':
						return $author$project$Data$Route$LogoutRoute;
					case 'forget-password':
						return $author$project$Data$Route$ForgetPasswordRoute;
					case 'my-profile':
						return $author$project$Data$Route$UpdateProfileRoute;
					case 'update-password':
						return $author$project$Data$Route$UpdatePasswordRoute;
					case 'membership':
						return $author$project$Data$Membership$availableForApp(device) ? $author$project$Data$Route$MembershipRoute : $author$project$Data$Route$NotFoundRoute;
					case 'delete-my-profile':
						return $author$project$Data$Route$DeactivateProfileRoute;
					case 'deleting-my-profile':
						return $author$project$Data$Route$ProcessingDeactivateProfileRoute;
					case 'search':
						return $author$project$Data$Route$SearchRoute;
					case 'viewed-me':
						return $author$project$Data$Route$RelatedProfileRoute(0);
					case 'favorited-me':
						return $author$project$Data$Route$RelatedProfileRoute(1);
					case 'favorite-profile':
						return $author$project$Data$Route$RelatedProfileRoute(2);
					case 'user-detail':
						if (_v0.b.b) {
							var _v1 = _v0.b;
							var userID = _v1.a;
							return $author$project$Data$Route$ProfileDetailRoute(userID);
						} else {
							break _v0$30;
						}
					case 'chat':
						return $author$project$Data$Route$ChatRoute;
					case 'block':
						return $author$project$Data$Route$BlockRoute;
					case 'blog':
						if (!_v0.b.b) {
							return $author$project$Data$Route$ContentRoute($author$project$Data$Route$PostHomeRoute);
						} else {
							if (!_v0.b.b.b) {
								var _v2 = _v0.b;
								var urlSafeCategory = _v2.a;
								var category = A2(
									$elm$core$String$join,
									' ',
									A2($elm$core$String$split, '-', urlSafeCategory));
								return $author$project$Data$Route$ContentRoute(
									$author$project$Data$Route$PostCategoryRoute(category));
							} else {
								var rest = _v0.b;
								var postUrl = A2($elm$core$String$join, '/', rest);
								return $author$project$Data$Route$ContentRoute(
									$author$project$Data$Route$PostRoute(postUrl));
							}
						}
					default:
						break _v0$30;
				}
			}
		}
		var pagePaths = _v0;
		var pageUrl = A2($elm$core$String$join, '/', pagePaths);
		return $author$project$Data$Route$ContentRoute(
			$author$project$Data$Route$PageRoute(pageUrl));
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$here = _Time_here(0);
var $author$project$Data$Alert$Alerts = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $author$project$Data$Alert$initial = $elm$core$Dict$empty;
var $author$project$Types$OnAuth = function (a) {
	return {$: 13, a: a};
};
var $author$project$Types$OnBlock = function (a) {
	return {$: 10, a: a};
};
var $author$project$Types$OnChat = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$OnDeactivate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Types$OnDetail = function (a) {
	return {$: 5, a: a};
};
var $author$project$Types$OnEmailVerification = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$OnMembership = function (a) {
	return {$: 9, a: a};
};
var $author$project$Types$OnProfile = function (a) {
	return {$: 6, a: a};
};
var $author$project$Types$OnRelatedProfiles = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$OnSearch = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$OnUpdatePassword = function (a) {
	return {$: 8, a: a};
};
var $author$project$Type$Block$Init = {$: 0};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Model$Block$initialModel = _Utils_Tuple2(
	{hs: 10, iv: $author$project$Type$Block$Init, n3: $elm$core$Maybe$Nothing},
	$elm$core$Platform$Cmd$none);
var $author$project$Type$Chat$Close = {$: 1};
var $author$project$Model$Chat$channelID = {
	bE: 'noop',
	d5: 'onGetRemoteRoom',
	d6: function (partnerID) {
		return 'onLoadInitialMessages/' + partnerID;
	},
	d7: 'onLoadInitialRooms',
	d8: function (partnerID) {
		return 'onLoadMessages/' + partnerID;
	},
	d9: 'onLoadRooms',
	ea: function (partnerID) {
		return 'onPartnerOnlineStatus/' + partnerID;
	},
	eb: function (partnerID) {
		return 'onSubNewMessages/' + partnerID;
	},
	ec: 'onSubPartnerLastRead',
	ed: 'onSubUpdatedRooms'
};
var $author$project$View$Theme$images = {
	jN: {j3: '/assets/images/banners/aboutUs.jpg', kx: '/assets/images/aboutus/connect.png', kS: '/assets/images/aboutus/discover.png', l8: '/assets/images/aboutus/meetup.png', mj: '/assets/images/banners/aboutUs-mobile.jpg'},
	jO: '/assets/images/accessibility.svg',
	jZ: '/assets/images/apple-app-badge.png',
	j0: '/assets/images/arrowDown.svg',
	fa: '/assets/images/attach.svg',
	kb: '/assets/images/blog.png',
	kc: '/assets/images/blogDark.png',
	km: '/assets/images/chat.svg',
	kn: '/assets/images/chatDark.png',
	kr: '/assets/images/chevronLeft.svg',
	ku: '/assets/images/closeBlack.svg',
	kv: '/assets/images/closeWhite.svg',
	kC: '/assets/images/backgrounds/coupleDancingDark.jpg',
	kD: '/assets/images/crossHeart.png',
	kN: '/assets/images/defaultAvatar.png',
	kO: '/assets/images/deleteIcon.svg',
	kW: '/assets/images/done.svg',
	kY: '/assets/images/dropdownArrow.svg',
	dt: '/assets/images/email.svg',
	go: '/assets/images/face.svg',
	k0: '/assets/images/faceDark.svg',
	k4: '/assets/images/expandLess.svg',
	k5: '/assets/images/expandMore.svg',
	lg: '/assets/images/favorite.svg',
	lk: '/assets/images/flowerLeft.jpg',
	ll: '/assets/images/flowerRight.jpg',
	lu: '/assets/images/google-play-badge.png',
	lD: '/assets/images/heart.png',
	bu: '/assets/images/height.svg',
	lG: {j3: '/assets/images/banners/home.jpg', kx: '/assets/images/home/connect.png', kS: '/assets/images/home/discover.png', l8: '/assets/images/home/meetup.png', mj: '/assets/images/banners/home-mobile.jpg', nw: '/assets/images/home/special.jpg', nz: '/assets/images/home/sponsors.png', nI: '/assets/images/home/sugarBoy.jpg', nK: '/assets/images/home/sugarGirl.jpg', nL: '/assets/images/home/sugarHalf.jpg'},
	bv: '/assets/images/infoIcon.svg',
	hv: '/assets/images/loading.svg',
	hy: '/assets/images/location.svg',
	l2: '/assets/images/logoGrey.svg',
	l3: '/assets/images/logoOrange.svg',
	hA: '/assets/images/logoWhite.svg',
	l4: '/assets/images/logoWhiteFull.svg',
	hD: {dq: '/assets/images/media/datingAdviceLogo.png', kI: '/assets/images/media/datingNewsLogo.png'},
	hE: '/assets/images/menu.svg',
	ml: '/assets/images/more.svg',
	mC: '/assets/images/notification.svg',
	mN: '/assets/images/penIcon.svg',
	mO: '/assets/images/person.svg',
	mV: '/assets/images/popupClose.png',
	mX: '/assets/images/popupLeftArrow.png',
	mY: '/assets/images/popupRightArrow.png',
	m0: '/assets/images/privatePhotoLockIcon.png',
	io: '/assets/images/privatePhotoRequestIcon.png',
	m3: '/assets/images/profileList.png',
	m4: '/assets/images/profileListDark.png',
	ex: '/assets/images/removeIcon.svg',
	nn: '/assets/images/searchIcon.svg',
	no: '/assets/images/selectArrow.svg',
	iU: '/assets/images/send.svg',
	nr: '/assets/images/shield.png',
	nu: '/assets/images/smiley.svg',
	c5: {ld: '/assets/images/social/facebook.svg', lR: '/assets/images/social/instagram.svg', l0: '/assets/images/social/linkedin.svg', n$: '/assets/images/social/twitter.svg'},
	nx: {j3: '/assets/images/banners/sponsor.png', g0: '/assets/images/sponsor/howItWorks.jpg', lS: '/assets/images/sponsor/intro.png'},
	nG: {j3: '/assets/images/banners/sugar.png', g0: '/assets/images/sugar/howItWorks.jpg', lS: '/assets/images/sugar/intro.png'},
	nO: '/assets/images/swapCall.svg',
	of: '/assets/images/wc.svg'
};
var $author$project$PopupPhoto$Init = 2;
var $author$project$PopupPhoto$initialModel = function (config) {
	return {bl: config, K: 0, bL: _List_Nil, eQ: 2};
};
var $author$project$Data$Chat$State = $elm$core$Basics$identity;
var $author$project$Data$Chat$Message$initialState = F2(
	function (channelID, user) {
		return {aa: channelID, H: $elm$core$Dict$empty, az: $elm$core$Dict$empty, W: user};
	});
var $author$project$Data$Chat$Room$CanLoadMore = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $author$project$Data$Chat$Room$futurePosix = $elm$time$Time$millisToPosix(9999999999999);
var $author$project$Firebase$Firestore$Eq = 2;
var $author$project$Firebase$Firestore$Gt = 0;
var $author$project$Firebase$Firestore$Collection = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Firebase$Firestore$Path = $elm$core$Basics$identity;
var $author$project$Firebase$Firestore$collection = function (pathString) {
	return A2($author$project$Firebase$Firestore$Collection, pathString, _List_Nil);
};
var $author$project$Data$Chat$Room$dbPartnerField = function (user) {
	var _v0 = user.ho;
	if (_v0 === 1) {
		return 'sponsor';
	} else {
		return 'sugar';
	}
};
var $author$project$Data$Chat$Room$dbUserField = function (user) {
	var _v0 = user.ho;
	if (_v0 === 1) {
		return 'sugar';
	} else {
		return 'sponsor';
	}
};
var $author$project$Firebase$Firestore$OnSnapshotCollection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Firebase$Firestore$QueryCollection = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Firebase$Firestore$onSnapshotCollection = function (col) {
	return A2(
		$author$project$Firebase$Firestore$QueryCollection,
		col,
		$author$project$Firebase$Firestore$OnSnapshotCollection(
			{dP: false}));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Firebase$Internal$Port$elmFirebaseSend = _Platform_outgoingPort('elmFirebaseSend', $elm$json$Json$Encode$string);
var $author$project$Firebase$Firestore$boolToString = function (value) {
	return value ? 'true' : 'false';
};
var $author$project$Firebase$Firestore$directionToString = function (dir) {
	if (!dir) {
		return 'asc';
	} else {
		return 'desc';
	}
};
var $author$project$Firebase$Firestore$opToString = function (op) {
	switch (op) {
		case 0:
			return '>';
		case 1:
			return '>=';
		case 2:
			return '==';
		case 3:
			return '<';
		case 4:
			return '<=';
		default:
			return 'array-contains';
	}
};
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$Firebase$Firestore$clauseToCommandData = function (clause) {
	switch (clause.$) {
		case 0:
			var fieldName = clause.a;
			var op = clause.b;
			var value = clause.c;
			return _List_fromArray(
				[
					'where',
					fieldName,
					$author$project$Firebase$Firestore$opToString(op),
					value
				]);
		case 1:
			var fieldName = clause.a;
			var op = clause.b;
			var posix = clause.c;
			return _List_fromArray(
				[
					'whereTime',
					fieldName,
					$author$project$Firebase$Firestore$opToString(op),
					$elm$core$String$fromInt(
					$elm$time$Time$posixToMillis(posix))
				]);
		case 2:
			var fieldName = clause.a;
			var op = clause.b;
			var value = clause.c;
			return _List_fromArray(
				[
					'whereBool',
					fieldName,
					$author$project$Firebase$Firestore$opToString(op),
					$author$project$Firebase$Firestore$boolToString(value)
				]);
		case 3:
			var value = clause.a;
			return _List_fromArray(
				[
					'limit',
					$elm$core$String$fromInt(value)
				]);
		default:
			var fieldName = clause.a;
			var direction = clause.b;
			return _List_fromArray(
				[
					'orderBy',
					fieldName,
					$author$project$Firebase$Firestore$directionToString(direction)
				]);
	}
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Firebase$Firestore$encodeCommandData = function (command) {
	return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, command);
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Firebase$Firestore$encodeCollection = F3(
	function (queryID, _v0, command) {
		var path = _v0.a;
		var clauses = _v0.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'requestType',
					$elm$json$Json$Encode$string('firestore')),
					_Utils_Tuple2(
					'queryID',
					$elm$json$Json$Encode$string(queryID)),
					_Utils_Tuple2(
					'ref',
					$author$project$Firebase$Firestore$encodeCommandData(
						_List_fromArray(
							['collection', path]))),
					_Utils_Tuple2(
					'clauses',
					A2(
						$elm$json$Json$Encode$list,
						$author$project$Firebase$Firestore$encodeCommandData,
						A2($elm$core$List$map, $author$project$Firebase$Firestore$clauseToCommandData, clauses))),
					_Utils_Tuple2(
					'cmd',
					$author$project$Firebase$Firestore$encodeCommandData(command))
				]));
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Firebase$Firestore$queryListenOptionsToJson = function (_v0) {
	var includeMetadataChanges = _v0.dP;
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'includeMetadataChanges',
					$elm$json$Json$Encode$bool(includeMetadataChanges))
				])));
};
var $author$project$Firebase$Firestore$collectionQueryToJson = F3(
	function (queryID, col, ops) {
		switch (ops.$) {
			case 0:
				var json = ops.a;
				return A3(
					$author$project$Firebase$Firestore$encodeCollection,
					queryID,
					col,
					_List_fromArray(
						['AddDoc', json]));
			case 1:
				return A3(
					$author$project$Firebase$Firestore$encodeCollection,
					queryID,
					col,
					_List_fromArray(
						['GetCollection']));
			case 2:
				var options = ops.a;
				return A3(
					$author$project$Firebase$Firestore$encodeCollection,
					queryID,
					col,
					_List_fromArray(
						[
							'OnSnapshotCollection',
							$author$project$Firebase$Firestore$queryListenOptionsToJson(options)
						]));
			default:
				return A3(
					$author$project$Firebase$Firestore$encodeCollection,
					queryID,
					col,
					_List_fromArray(
						['GenerateID']));
		}
	});
var $author$project$Firebase$Firestore$encodeDoc = F3(
	function (queryID, _v0, command) {
		var path = _v0;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'requestType',
					$elm$json$Json$Encode$string('firestore')),
					_Utils_Tuple2(
					'queryID',
					$elm$json$Json$Encode$string(queryID)),
					_Utils_Tuple2(
					'ref',
					$author$project$Firebase$Firestore$encodeCommandData(
						_List_fromArray(
							['doc', path]))),
					_Utils_Tuple2(
					'cmd',
					$author$project$Firebase$Firestore$encodeCommandData(command))
				]));
	});
var $author$project$Firebase$Firestore$docQueryToJson = F3(
	function (queryID, document, ops) {
		var encodeDoc_ = A2($author$project$Firebase$Firestore$encodeDoc, queryID, document);
		switch (ops.$) {
			case 0:
				return encodeDoc_(
					_List_fromArray(
						['GetDoc']));
			case 1:
				var json = ops.a;
				return encodeDoc_(
					_List_fromArray(
						['SetDoc', json]));
			case 2:
				var json = ops.a;
				return encodeDoc_(
					_List_fromArray(
						['SetDocWithMerge', json]));
			case 3:
				var json = ops.a;
				return encodeDoc_(
					_List_fromArray(
						['UpdateDoc', json]));
			case 4:
				return encodeDoc_(
					_List_fromArray(
						['DeleteDoc']));
			default:
				return encodeDoc_(
					_List_fromArray(
						['OnSnapshotDoc']));
		}
	});
var $author$project$Firebase$Firestore$queryToJson = F2(
	function (queryID, query) {
		if (!query.$) {
			var document = query.a;
			var docOps = query.b;
			return A2(
				$elm$json$Json$Encode$encode,
				0,
				A3($author$project$Firebase$Firestore$docQueryToJson, queryID, document, docOps));
		} else {
			var col = query.a;
			var colOps = query.b;
			return A2(
				$elm$json$Json$Encode$encode,
				0,
				A3($author$project$Firebase$Firestore$collectionQueryToJson, queryID, col, colOps));
		}
	});
var $author$project$Firebase$Firestore$send = F2(
	function (queryID, query) {
		return $author$project$Firebase$Internal$Port$elmFirebaseSend(
			A2($author$project$Firebase$Firestore$queryToJson, queryID, query));
	});
var $author$project$Firebase$Firestore$WhereTime = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Firebase$Firestore$whereTime = F4(
	function (fieldPath, op, value, _v0) {
		var path = _v0.a;
		var clauses = _v0.b;
		return A2(
			$author$project$Firebase$Firestore$Collection,
			path,
			_Utils_ap(
				clauses,
				_List_fromArray(
					[
						A3($author$project$Firebase$Firestore$WhereTime, fieldPath, op, value)
					])));
	});
var $author$project$Firebase$Firestore$Where = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Firebase$Firestore$where_ = F4(
	function (fieldPath, op, value, _v0) {
		var path = _v0.a;
		var clauses = _v0.b;
		return A2(
			$author$project$Firebase$Firestore$Collection,
			path,
			_Utils_ap(
				clauses,
				_List_fromArray(
					[
						A3($author$project$Firebase$Firestore$Where, fieldPath, op, value)
					])));
	});
var $author$project$Data$Chat$Room$subPartnerLastRead = F2(
	function (startTime, state) {
		return A2(
			$author$project$Firebase$Firestore$send,
			state.aa.ec,
			$author$project$Firebase$Firestore$onSnapshotCollection(
				A4(
					$author$project$Firebase$Firestore$whereTime,
					$author$project$Data$Chat$Room$dbPartnerField(state.W) + '.lastRead',
					0,
					startTime,
					A4(
						$author$project$Firebase$Firestore$where_,
						$author$project$Data$Chat$Room$dbUserField(state.W) + '.uid',
						2,
						state.W.eX,
						$author$project$Firebase$Firestore$collection('/chat/room/lastMessages')))));
	});
var $author$project$Data$Chat$RoomStatus$Available = 0;
var $author$project$Firebase$Firestore$Gte = 1;
var $author$project$Data$Chat$RoomStatus$statusString = function (status) {
	if (!status) {
		return 'Available';
	} else {
		return 'Blocked';
	}
};
var $author$project$Data$Chat$Room$subUpdatedRooms = F2(
	function (startTime, state) {
		var availableStatus = $author$project$Data$Chat$RoomStatus$statusString(0);
		var _v0 = state;
		var user = _v0.W;
		var channelID = _v0.aa;
		var userRoomStatusField = $author$project$Data$Chat$Room$dbUserField(user) + '.status.room';
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID.ed,
			$author$project$Firebase$Firestore$onSnapshotCollection(
				A4(
					$author$project$Firebase$Firestore$where_,
					'receiverID',
					2,
					user.eX,
					A4(
						$author$project$Firebase$Firestore$where_,
						userRoomStatusField,
						2,
						availableStatus,
						A4(
							$author$project$Firebase$Firestore$whereTime,
							'lastMessageCreatedAt',
							1,
							startTime,
							$author$project$Firebase$Firestore$collection('/chat/room/lastMessages'))))));
	});
var $author$project$Data$Chat$Room$initialState = F3(
	function (channelID, currentTime, user) {
		var state = {
			cb: 1,
			aa: channelID,
			f8: $elm$core$Maybe$Nothing,
			lV: false,
			T: $author$project$Data$Chat$Room$CanLoadMore($author$project$Data$Chat$Room$futurePosix),
			bK: $elm$core$Dict$empty,
			ao: $elm$core$Dict$empty,
			W: user
		};
		return _Utils_Tuple2(
			state,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Data$Chat$Room$subUpdatedRooms, currentTime, state),
						A2($author$project$Data$Chat$Room$subPartnerLastRead, currentTime, state)
					])));
	});
var $author$project$Data$Chat$initialState = F3(
	function (channelID, user, currentTime) {
		var roomChannels = {bE: channelID.bE, d5: channelID.d5, d7: channelID.d7, d9: channelID.d9, ea: channelID.ea, ec: channelID.ec, ed: channelID.ed};
		var messageChannels = {bE: channelID.bE, d6: channelID.d6, d8: channelID.d8, eb: channelID.eb};
		var messageState = A2($author$project$Data$Chat$Message$initialState, messageChannels, user);
		var _v0 = A3($author$project$Data$Chat$Room$initialState, roomChannels, currentTime, user);
		var roomState = _v0.a;
		var roomCmd = _v0.b;
		return _Utils_Tuple2(
			{h: messageState, a: roomState},
			roomCmd);
	});
var $author$project$Model$Chat$initialModel = F2(
	function (user, currentTime) {
		var _v0 = A3($author$project$Data$Chat$initialState, $author$project$Model$Chat$channelID, user, currentTime);
		var chatState = _v0.a;
		var chatCmd = _v0.b;
		return _Utils_Tuple2(
			{
				ka: $elm$core$Maybe$Nothing,
				Q: $author$project$Type$Chat$Close,
				ah: $elm$core$Dict$empty,
				bC: $elm$core$Dict$empty,
				ee: false,
				bN: $author$project$PopupPhoto$initialModel(
					{f_: $author$project$View$Theme$images.mV, l_: $author$project$View$Theme$images.mX, eq: 'PopupForChatMessage', nf: $author$project$View$Theme$images.mY}),
				aA: $elm$core$Maybe$Nothing,
				i8: chatState
			},
			chatCmd);
	});
var $author$project$Form$applyConfig = F2(
	function (configs, form) {
		applyConfig:
		while (true) {
			if (configs.b) {
				var config = configs.a;
				var rest = configs.b;
				var $temp$configs = rest,
					$temp$form = config(form);
				configs = $temp$configs;
				form = $temp$form;
				continue applyConfig;
			} else {
				return form;
			}
		}
	});
var $author$project$Form$createForm = function (configs) {
	var initialForm = {gs: $elm$core$Maybe$Nothing, j: $elm$core$Dict$empty, jc: false};
	return A2($author$project$Form$applyConfig, configs, initialForm);
};
var $author$project$Form$IsString = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $author$project$Form$fieldString = F4(
	function (name, value, validators, form) {
		var field = $author$project$Form$IsString(
			{
				x: $elm$core$Result$Err(''),
				ba: validators,
				v: value
			});
		return _Utils_update(
			form,
			{
				j: A3($elm$core$Dict$insert, name, field, form.j)
			});
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Form$IsBool = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$IsListString = function (a) {
	return {$: 2, a: a};
};
var $author$project$Form$IsTime = function (a) {
	return {$: 3, a: a};
};
var $author$project$Form$validateValue = F2(
	function (validators, value) {
		validateValue:
		while (true) {
			if (validators.b) {
				var validator = validators.a;
				var rest = validators.b;
				var _v1 = validator(value);
				if (!_v1.$) {
					var $temp$validators = rest,
						$temp$value = value;
					validators = $temp$validators;
					value = $temp$value;
					continue validateValue;
				} else {
					var msg = _v1.a;
					return $elm$core$Result$Err(msg);
				}
			} else {
				return $elm$core$Result$Ok(value);
			}
		}
	});
var $author$project$Form$updateField = F2(
	function (field, value) {
		return _Utils_update(
			field,
			{
				x: A2($author$project$Form$validateValue, field.ba, value),
				v: value
			});
	});
var $author$project$Form$validateField = function (field) {
	switch (field.$) {
		case 0:
			var field_ = field.a;
			return $author$project$Form$IsString(
				A2($author$project$Form$updateField, field_, field_.v));
		case 1:
			var field_ = field.a;
			return $author$project$Form$IsBool(
				A2($author$project$Form$updateField, field_, field_.v));
		case 2:
			var field_ = field.a;
			return $author$project$Form$IsListString(
				A2($author$project$Form$updateField, field_, field_.v));
		default:
			var field_ = field.a;
			return $author$project$Form$IsTime(
				A2($author$project$Form$updateField, field_, field_.v));
	}
};
var $author$project$Form$validate = function (form) {
	return _Utils_update(
		form,
		{
			j: A2(
				$elm$core$Dict$map,
				$elm$core$Basics$always($author$project$Form$validateField),
				form.j)
		});
};
var $author$project$Form$Validators$validateMinChars = F2(
	function (minimumLength, value) {
		return (_Utils_cmp(
			$elm$core$String$length(value),
			minimumLength) < 0) ? $elm$core$Result$Err(
			'Field must be at least ' + ($elm$core$String$fromInt(minimumLength) + ' characters long.')) : $elm$core$Result$Ok(value);
	});
var $author$project$Form$Validators$validatePassword = function (password) {
	return A2($author$project$Form$Validators$validateMinChars, 6, password);
};
var $author$project$Model$Deactivate$initialModel = function () {
	var form = $author$project$Form$validate(
		$author$project$Form$createForm(
			_List_fromArray(
				[
					A3(
					$author$project$Form$fieldString,
					'password',
					'',
					_List_fromArray(
						[$author$project$Form$Validators$validatePassword]))
				])));
	return _Utils_Tuple2(
		{dk: $elm$core$Maybe$Nothing, ln: form, iC: false},
		$elm$core$Platform$Cmd$none);
}();
var $author$project$Model$Detail$channelIDs = {
	fT: function (userID) {
		return 'checkFavoriteStatusResult/' + userID;
	},
	f6: function (userID) {
		return 'createReportUserDetail/' + userID;
	},
	gh: function (userID) {
		return 'deleteFavoriteProfile/' + userID;
	},
	gE: function (userID) {
		return 'getBlockStatus/' + userID;
	},
	lr: function (partnerID) {
		return 'getChatRoomAtDetail/' + partnerID;
	},
	gI: function (userID) {
		return 'getProfilePrivatePhotosResult/' + userID;
	},
	gJ: function (userID) {
		return 'getProfilePublicPhotosResult/' + userID;
	},
	dB: 'getProfileResult',
	bE: 'noop',
	i_: function (userID) {
		return 'setFavoriteProfile/' + userID;
	},
	n1: function (partnerID) {
		return 'unBlockChatRoomAtDetail/' + partnerID;
	},
	n3: function (userID) {
		return 'unBlockUserAtDetail/' + userID;
	}
};
var $author$project$Firebase$Firestore$GetCollection = {$: 1};
var $author$project$Firebase$Firestore$getCollection = function (col) {
	return A2($author$project$Firebase$Firestore$QueryCollection, col, $author$project$Firebase$Firestore$GetCollection);
};
var $author$project$Core$Data$Profile$Photo$privatePhotosPath = function (userID) {
	return '/profiles/' + (userID + '/privatePhotos/');
};
var $author$project$Core$Data$Profile$Photo$getPrivatePhotos = F2(
	function (userID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getCollection(
				$author$project$Firebase$Firestore$collection(
					$author$project$Core$Data$Profile$Photo$privatePhotosPath(userID))));
	});
var $author$project$Model$Detail$checkAndGetUserPrivatePhotos = function (userID) {
	return A2(
		$author$project$Core$Data$Profile$Photo$getPrivatePhotos,
		userID,
		$author$project$Model$Detail$channelIDs.gI(userID));
};
var $author$project$Firebase$Firestore$Doc = $elm$core$Basics$identity;
var $author$project$Firebase$Firestore$doc = function (pathString) {
	return pathString;
};
var $author$project$Firebase$Firestore$GetDoc = {$: 0};
var $author$project$Firebase$Firestore$Query = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Firebase$Firestore$getDoc = function (document) {
	return A2($author$project$Firebase$Firestore$Query, document, $author$project$Firebase$Firestore$GetDoc);
};
var $author$project$Data$BlockProfile$get = F3(
	function (channelID, userID, blockedUserID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getDoc(
				$author$project$Firebase$Firestore$doc('/profiles/' + (userID + ('/blockProfile/' + blockedUserID)))));
	});
var $author$project$Model$Detail$getBlockStatus = F2(
	function (currentUserID, userID) {
		return A3(
			$author$project$Data$BlockProfile$get,
			$author$project$Model$Detail$channelIDs.gE(userID),
			currentUserID,
			userID);
	});
var $author$project$Core$Data$Profile$getProfile = F2(
	function (userID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getDoc(
				$author$project$Firebase$Firestore$doc('/profiles/' + userID)));
	});
var $author$project$Core$Data$Profile$Photo$publicPhotosPath = function (userID) {
	return '/profiles/' + (userID + '/publicPhotos/');
};
var $author$project$Core$Data$Profile$Photo$getPublicPhotos = F2(
	function (userID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getCollection(
				$author$project$Firebase$Firestore$collection(
					$author$project$Core$Data$Profile$Photo$publicPhotosPath(userID))));
	});
var $author$project$Model$Detail$getPublicPhotos = function (userID) {
	return A2(
		$author$project$Core$Data$Profile$Photo$getPublicPhotos,
		userID,
		$author$project$Model$Detail$channelIDs.gJ(userID));
};
var $author$project$Model$Detail$initialModel = F2(
	function (currentUserID, hasUserID) {
		return _Utils_Tuple2(
			{
				gs: $elm$core$Maybe$Nothing,
				ep: $author$project$PopupPhoto$initialModel(
					{f_: $author$project$View$Theme$images.mV, l_: $author$project$View$Theme$images.mX, eq: 'PopupForProfileDetail', nf: $author$project$View$Theme$images.mY}),
				iw: $elm$core$Dict$empty
			},
			function () {
				if (!hasUserID.$) {
					var userID = hasUserID.a;
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Core$Data$Profile$getProfile, userID, $author$project$Model$Detail$channelIDs.dB),
								$author$project$Model$Detail$getPublicPhotos(userID),
								$author$project$Model$Detail$checkAndGetUserPrivatePhotos(userID),
								A2($author$project$Model$Detail$getBlockStatus, currentUserID, userID)
							]));
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			}());
	});
var $author$project$Type$EmailVerification$Init = {$: 0};
var $author$project$Model$EmailVerification$initialModel = F2(
	function (apiUrl, userID) {
		return _Utils_Tuple2(
			{ca: 0, dl: apiUrl, eQ: $author$project$Type$EmailVerification$Init, a9: userID},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Type$Membership$Android = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$Membership$Empty = {$: 0};
var $author$project$Type$Membership$Ios = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$Membership$OnAndroid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$Membership$OnIos = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$Membership$OnWeb = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$Membership$Web = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Membership$Android$Init = 0;
var $author$project$Data$Membership$Ready = 0;
var $author$project$Model$Membership$Android$channelIDs = {jg: 'syncAndroidMembershipResult'};
var $author$project$Data$Membership$initialApiState = function (status) {
	return {dk: $elm$core$Maybe$Nothing, iJ: 0, eQ: status};
};
var $author$project$Firebase$Firestore$OnSnapshotDoc = {$: 5};
var $author$project$Firebase$Firestore$onSnapshotDoc = function (document) {
	return A2($author$project$Firebase$Firestore$Query, document, $author$project$Firebase$Firestore$OnSnapshotDoc);
};
var $author$project$Data$Membership$Android$receive = F2(
	function (userID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$onSnapshotDoc(
				$author$project$Firebase$Firestore$doc('/backend/membership/iapAndroid/' + userID)));
	});
var $author$project$NativeBridge$sendCustom = _Platform_outgoingPort('sendCustom', $elm$core$Basics$identity);
var $author$project$Model$Membership$Android$initialModel = F2(
	function (userID, apiEndPoints) {
		return _Utils_Tuple2(
			{
				n: $author$project$Data$Membership$initialApiState(0),
				cr: apiEndPoints,
				a$: 0,
				c4: $elm$core$Maybe$Nothing,
				je: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Data$Membership$Android$receive, userID, $author$project$Model$Membership$Android$channelIDs.jg),
						$author$project$NativeBridge$sendCustom(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'function',
									$elm$json$Json$Encode$string('refreshToken'))
								])))
					])));
	});
var $author$project$Data$Membership$Ios$Init = 0;
var $author$project$Model$Membership$Ios$channelIDs = {jg: 'syncIosMembershipResult'};
var $author$project$Data$Membership$Ios$receive = F2(
	function (userID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$onSnapshotDoc(
				$author$project$Firebase$Firestore$doc('/backend/membership/iapIos/' + userID)));
	});
var $author$project$Model$Membership$Ios$initialModel = F2(
	function (userID, apiEndPoints) {
		return _Utils_Tuple2(
			{
				n: $author$project$Data$Membership$initialApiState(0),
				cr: apiEndPoints,
				a$: 0,
				c4: $elm$core$Maybe$Nothing,
				je: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Data$Membership$Ios$receive, userID, $author$project$Model$Membership$Ios$channelIDs.jg),
						$author$project$NativeBridge$sendCustom(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'function',
									$elm$json$Json$Encode$string('refreshReceiptAtStartUp'))
								])))
					])));
	});
var $author$project$Model$Membership$Web$channelIDs = {jg: 'syncWebMembershipResult'};
var $author$project$Data$Membership$Web$receive = F2(
	function (userID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$onSnapshotDoc(
				$author$project$Firebase$Firestore$doc('/backend/membership/multiCards/' + userID)));
	});
var $author$project$Model$Membership$Web$initialModel = F3(
	function (userID, multiCardsConfig, apiEndPoints) {
		return _Utils_Tuple2(
			{
				n: $author$project$Data$Membership$initialApiState(0),
				kX: $elm$core$Maybe$Nothing,
				cr: apiEndPoints,
				mn: multiCardsConfig,
				mt: $elm$core$Maybe$Nothing,
				c4: $elm$core$Maybe$Nothing,
				nE: $elm$core$Maybe$Nothing
			},
			A2($author$project$Data$Membership$Web$receive, userID, $author$project$Model$Membership$Web$channelIDs.jg));
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Model$Membership$initialModel = F4(
	function (device, _v0, multiCardsConfig, _v1) {
		var uid = _v0.eX;
		var kind = _v0.ho;
		var multiCardsApiEndPoints = _v1.mm;
		var iOsApiEndPoints = _v1.lI;
		var androidApiEndPoints = _v1.jU;
		if (!kind) {
			if (!device.$) {
				var _v4 = A3($author$project$Model$Membership$Web$initialModel, uid, multiCardsConfig, multiCardsApiEndPoints);
				var web = _v4.a;
				var webCmd = _v4.b;
				return _Utils_Tuple2(
					$author$project$Type$Membership$Web(web),
					A2($elm$core$Platform$Cmd$map, $author$project$Type$Membership$OnWeb, webCmd));
			} else {
				if (!device.a.$) {
					var _v5 = A2($author$project$Model$Membership$Ios$initialModel, uid, iOsApiEndPoints);
					var iOs = _v5.a;
					var iOsCmd = _v5.b;
					return _Utils_Tuple2(
						$author$project$Type$Membership$Ios(iOs),
						A2($elm$core$Platform$Cmd$map, $author$project$Type$Membership$OnIos, iOsCmd));
				} else {
					var _v6 = A2($author$project$Model$Membership$Android$initialModel, uid, androidApiEndPoints);
					var android = _v6.a;
					var androidCmd = _v6.b;
					return _Utils_Tuple2(
						$author$project$Type$Membership$Android(android),
						A2($elm$core$Platform$Cmd$map, $author$project$Type$Membership$OnAndroid, androidCmd));
				}
			}
		} else {
			return _Utils_Tuple2($author$project$Type$Membership$Empty, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Profile$NotSynced = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Profile$channelIDs = {
	bE: 'noop',
	eS: function (photoKind) {
		return 'syncMyPhotos/' + photoKind;
	},
	jh: 'syncMyProfileResult',
	jy: 'updateProfileResponse'
};
var $author$project$Core$Data$Profile$syncProfile = F2(
	function (userID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$onSnapshotDoc(
				$author$project$Firebase$Firestore$doc('/profiles/' + userID)));
	});
var $author$project$Model$Profile$initialModel = function (userID) {
	return _Utils_Tuple2(
		$author$project$Type$Profile$NotSynced(0),
		A2($author$project$Core$Data$Profile$syncProfile, userID, $author$project$Model$Profile$channelIDs.jh));
};
var $author$project$Model$RelatedProfiles$initialModel = function () {
	var initProfileState = {an: $elm$core$Maybe$Nothing, A: 10};
	return _Utils_Tuple2(
		{lh: initProfileState, li: initProfileState, ix: 10, oe: initProfileState},
		$elm$core$Platform$Cmd$none);
}();
var $author$project$Type$Search$InputCityMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$fieldBool = F4(
	function (name, value, validators, form) {
		var field = $author$project$Form$IsBool(
			{
				x: $elm$core$Result$Err(''),
				ba: validators,
				v: value
			});
		return _Utils_update(
			form,
			{
				j: A3($elm$core$Dict$insert, name, field, form.j)
			});
	});
var $author$project$Form$fieldListString = F4(
	function (name, value, validators, form) {
		var field = $author$project$Form$IsListString(
			{
				x: $elm$core$Result$Err(''),
				ba: validators,
				v: value
			});
		return _Utils_update(
			form,
			{
				j: A3($elm$core$Dict$insert, name, field, form.j)
			});
	});
var $author$project$Helpers$City$Types$ToAutoComplete = $elm$core$Basics$identity;
var $author$project$Core$Helpers$City$Data$cities = '\nTay Ninh - Vietnam\nLuan Chau - Vietnam\nBac Kan - Vietnam\nLang Son - Vietnam\nSon La - Vietnam\nTuyen Quang - Vietnam\nYen Bai - Vietnam\nHai Duong - Vietnam\nThai Binh - Vietnam\nTuy Hoa - Vietnam\nThu Dau Mot - Vietnam\nDong Ha - Vietnam\nCao Lanh - Vietnam\nTruc Giang - Vietnam\nTra Vinh - Vietnam\nVinh Long - Vietnam\nCao Bang - Vietnam\nHong Gai - Vietnam\nCam Pha - Vietnam\nLao Chi - Vietnam\nHoa Binh - Vietnam\nSon Tay - Vietnam\nNinh Binh - Vietnam\nViet Tri - Vietnam\nBac Giang - Vietnam\nHa Tinh - Vietnam\nBuon Me Thuot - Vietnam\nDa Lat - Vietnam\nPhan Rang - Vietnam\nHon Quan - Vietnam\nKon Tum - Vietnam\nQuang Ngai - Vietnam\nQuang Tri - Vietnam\nVung Tau - Vietnam\nPhan Thiet - Vietnam\nLong Xuyen - Vietnam\nChau Doc - Vietnam\nRach Gia - Vietnam\nTan An - Vietnam\nMy Tho - Vietnam\nBac Lieu - Vietnam\nCa Mau - Vietnam\nSoc Trang - Vietnam\nHa Giang - Vietnam\nThai Nguyen - Vietnam\nThanh Hoa - Vietnam\nNam Dinh - Vietnam\nVinh - Vietnam\nDong Hoi - Vietnam\nPlay Ku - Vietnam\nNha Trang - Vietnam\nCam Ranh - Vietnam\nQui Nhon - Vietnam\nHue - Vietnam\nBien Hoa - Vietnam\nCan Tho - Vietnam\nHaiphong - Vietnam\nDa Nang - Vietnam\nHanoi - Vietnam\nHo Chi Minh City - Vietnam\nQal eh-ye Now - Afghanistan\nChaghcharan - Afghanistan\nLashkar Gah - Afghanistan\nZaranj - Afghanistan\nTarin Kowt - Afghanistan\nZareh Sharan - Afghanistan\nAsadabad - Afghanistan\nTaloqan - Afghanistan\nMahmud-E Eraqi - Afghanistan\nMehtar Lam - Afghanistan\nBaraki Barak - Afghanistan\nAybak - Afghanistan\nMayda Shahr - Afghanistan\nKarokh - Afghanistan\nSheberghan - Afghanistan\nPol-e Khomri - Afghanistan\nBalkh - Afghanistan\nMeymaneh - Afghanistan\nAndkhvoy - Afghanistan\nQalat - Afghanistan\nGhazni - Afghanistan\nFeyzabad - Afghanistan\nKondoz - Afghanistan\nJalalabad - Afghanistan\nCharikar - Afghanistan\nGardiz - Afghanistan\nBamian - Afghanistan\nBaghlan - Afghanistan\nFarah - Afghanistan\nHerat - Afghanistan\nMazar-e Sharif - Afghanistan\nKandahar - Afghanistan\nKabul - Afghanistan\nMariehamn - Aland\nKruje - Albania\nFier - Albania\nLushnje - Albania\nPuke - Albania\nBajram Curri - Albania\nKukes - Albania\nSarande - Albania\nErseke - Albania\nPogradec - Albania\nKorce - Albania\nBerat - Albania\nCorovode - Albania\nGramsh - Albania\nLibrazhd - Albania\nTepelene - Albania\nPermet - Albania\nGjirokaster - Albania\nPeshkopi - Albania\nBurrel - Albania\nLezhe - Albania\nRreshen - Albania\nVlore - Albania\nElbasan - Albania\nDurres - Albania\nShkoder - Albania\nTirana - Albania\nJijel - Algeria\nTizi-Ouzou - Algeria\nBordj Bou Arreridj - Algeria\nM\'sila - Algeria\nGuelma - Algeria\nOum el Bouaghi - Algeria\nTimimoun - Algeria\nSidi bel Abbes - Algeria\nTlimcen - Algeria\nBeni Ounif - Algeria\nAbadla - Algeria\nSefra - Algeria\nSkikda - Algeria\nDjanet - Algeria\nI-n-Amenas - Algeria\nIn Amguel - Algeria\nEl Bayadh - Algeria\nEl Oued - Algeria\nHassi Messaoud - Algeria\nChlef - Algeria\nMascara - Algeria\nMostaganem - Algeria\nSaida - Algeria\nTiarat - Algeria\nBejaia - Algeria\nBlida - Algeria\nBouira - Algeria\nMedea - Algeria\nSouk Ahras - Algeria\nTebessa - Algeria\nAdrar - Algeria\nReggane - Algeria\nBechar - Algeria\nTindouf - Algeria\nIllizi - Algeria\nArak - Algeria\nI-n-Salah - Algeria\nEl Golea - Algeria\nLaghouat - Algeria\nTouggourt - Algeria\nOuargla - Algeria\nBiskra - Algeria\nDjelfa - Algeria\nSetif - Algeria\nBatna - Algeria\nAnnaba - Algeria\nConstantine - Algeria\nOran - Algeria\nTamanrasset - Algeria\nGhardaia - Algeria\nAlgiers - Algeria\nPago Pago - American Samoa\nAndorra - Andorra\nMucusso - Angola\nLucapa - Angola\nCapenda-Camulemba - Angola\nSaurimo - Angola\nMuconda - Angola\nCacolo - Angola\nCaxito - Angola\nCamabatela - Angola\nNdalatando - Angola\nQuibala - Angola\nCalulo - Angola\nWaku Kungo - Angola\nSongo - Angola\nMbanza-Congo - Angola\nNzeto - Angola\nSoyo - Angola\nCabinda - Angola\nCalucinga - Angola\nCamacupa - Angola\nCubal - Angola\nMavinga - Angola\nCuito Caunavale - Angola\nLuiana - Angola\nOndjiva - Angola\nChitado - Angola\nChibemba - Angola\nChibia - Angola\nQuipungo - Angola\nLuau - Angola\nCangamba - Angola\nLumbala Nguimbo - Angola\nCazombo - Angola\nDundo - Angola\nAmbriz - Angola\nDondo - Angola\nSumbe - Angola\nUige - Angola\nKuito - Angola\nLobito - Angola\nXangongo - Angola\nLuena - Angola\nTombua - Angola\nMalanje - Angola\nBenguela - Angola\nLubango - Angola\nNamibe - Angola\nMenongue - Angola\nHuambo - Angola\nLuanda - Angola\nSaint John\'s - Antigua and Barbuda\n28 de Noviembre - Argentina\nGobernador Gregores - Argentina\nComondante Luis Piedrabuena - Argentina\nPaso Rio Mayo - Argentina\nAlto Rio Sanguer - Argentina\nEl Maiten - Argentina\nPuerto Madryn - Argentina\nTrelew - Argentina\nLas Heras - Argentina\nSan Martin - Argentina\nUspallata - Argentina\nCutral Co - Argentina\nPunta Alta - Argentina\nSan Nicolas - Argentina\nCampana - Argentina\nChacabuco - Argentina\nMercedes - Argentina\nLincoln - Argentina\nChivilcoy - Argentina\nVeinticinco de Mayo - Argentina\nNueve de Julio - Argentina\nDolores - Argentina\nPedro Luro - Argentina\nTres Arroyos - Argentina\nCoronel Suarez - Argentina\nBalcarce - Argentina\n25 de Mayo - Argentina\nGeneral Roca - Argentina\nComallo - Argentina\nIngeniero Jacobacci - Argentina\nGeneral Conesa - Argentina\nChoele Choel - Argentina\nSan Francisco - Argentina\nAlta Gracia - Argentina\nVilla Maria - Argentina\nBell Ville - Argentina\nVilla Rumipal - Argentina\nVilla Carlos Paz - Argentina\nChumbicha - Argentina\nTinogasta - Argentina\nAbra Pampa - Argentina\nHumahuaca - Argentina\nSusques - Argentina\nChepes - Argentina\nYacuiba - Argentina\nTartagal - Argentina\nJoaquin V. Gonzalez - Argentina\nGeneral Guemes - Argentina\nTrancas - Argentina\nPresidencia Roque Saenz Pena - Argentina\nPampa del Infierno - Argentina\nVilla Angela - Argentina\nIngeniero Guillermo N. Juarez - Argentina\nComandante Fontana - Argentina\nDoctor Pedro P. Pena - Argentina\nSan Lorenzo - Argentina\nCorrientes - Argentina\nConcepcion del Uruguay - Argentina\nVictoria - Argentina\nGualeguay - Argentina\nParana - Argentina\nVilla Constitucion - Argentina\nRafaela - Argentina\nEldorado - Argentina\nRodeo - Argentina\nLas Plumas - Argentina\nGastre - Argentina\nTelsen - Argentina\nMalargue - Argentina\nTunuyan - Argentina\nLa Paz - Argentina\nChos Malal - Argentina\nLas Lajas - Argentina\nZarate - Argentina\nCarhue - Argentina\nDarregueira - Argentina\nJuarez - Argentina\nMar de Ajo - Argentina\nLobos - Argentina\nChascomus - Argentina\nJunin - Argentina\nLa Plata - Argentina\nPergamino - Argentina\nLujan - Argentina\nAzul - Argentina\nVillalonga - Argentina\nVictorica - Argentina\nGeneral Pico - Argentina\nSan Antonio Oeste - Argentina\nSierra Colorado - Argentina\nRio Tercero - Argentina\nBelen - Argentina\nRinconada - Argentina\nSan Pedro - Argentina\nLibertador General San Martin - Argentina\nChilecito - Argentina\nChamical - Argentina\nLos Blancos - Argentina\nCafayate - Argentina\nCerrillos - Argentina\nSan Antonio de los Cobres - Argentina\nAnatuya - Argentina\nFrias - Argentina\nMonte Quemado - Argentina\nJuan Jose Castelli - Argentina\nCharata - Argentina\nLas Lomitas - Argentina\nConcordia - Argentina\nSunchales - Argentina\nSan Justo - Argentina\nVera - Argentina\nReconquista - Argentina\nVenado Tuerto - Argentina\nEsquel - Argentina\nZapala - Argentina\nOlavarria - Argentina\nTandil - Argentina\nViedma - Argentina\nSan Luis - Argentina\nRio Cuarto - Argentina\nSan Salvador de Jujuy - Argentina\nSan Ramon de la Nueva Oran - Argentina\nGoya - Argentina\nPuerto San Julian - Argentina\nPerito Moreno - Argentina\nRio Grande - Argentina\nUshuaia - Argentina\nSarmiento - Argentina\nSan Rafael - Argentina\nNecochea - Argentina\nRio Colorado - Argentina\nCatamarca - Argentina\nLa Rioja - Argentina\nSantiago del Estero - Argentina\nResistencia - Argentina\nGualeguaychu - Argentina\nEl Calafate - Argentina\nSan Juan - Argentina\nRawson - Argentina\nNeuquen - Argentina\nSanta Rosa - Argentina\nSan Carlos de Bariloche - Argentina\nSalta - Argentina\nTucuman - Argentina\nFormosa - Argentina\nSanta Fe - Argentina\nRosario - Argentina\nPuerto Deseado - Argentina\nRio Gallegos - Argentina\nComodoro Rivadavia - Argentina\nMendoza - Argentina\nBahia Blanca - Argentina\nMar del Plata - Argentina\nCordoba - Argentina\nPosadas - Argentina\nBuenos Aires - Argentina\nAshtarak - Armenia\nIjevan - Armenia\nArtashat - Armenia\nGavarr - Armenia\nYeghegnadzor - Armenia\nGyumri - Armenia\nVanadzor - Armenia\nYerevan - Armenia\nOranjestad - Aruba\nWodonga - Australia\nCentral Coast - Australia\nSunshine Coast - Australia\nBourke - Australia\nPine Creek - Australia\nAdelaide River - Australia\nMcMinns Lagoon - Australia\nNewcastle Waters - Australia\nRavensthorpe - Australia\nWagin - Australia\nRoebourne - Australia\nPannawonica - Australia\nTom Price - Australia\nKalbarri - Australia\nMount Magnet - Australia\nMorawa - Australia\nPort Denison - Australia\nMerredin - Australia\nMount Barker - Australia\nKatanning - Australia\nNarrogin - Australia\nGingin - Australia\nBunbury - Australia\nKwinana - Australia\nSouthern Cross - Australia\nKaltukatjara - Australia\nQueanbeyan - Australia\nTweed Heads - Australia\nIvanhoe - Australia\nWilcannia - Australia\nMerimbula - Australia\nEchuca - Australia\nDeniliquin - Australia\nNowra - Australia\nUlladulla - Australia\nBatemans Bay - Australia\nCooma - Australia\nTumut - Australia\nLeeton - Australia\nYoung - Australia\nCowra - Australia\nForbes - Australia\nGoulburn - Australia\nKiama - Australia\nKatoomba - Australia\nLithgow - Australia\nParkes - Australia\nBathurst - Australia\nMaitland - Australia\nSingleton - Australia\nMudgee - Australia\nMuswellbrook - Australia\nTaree - Australia\nKempsey - Australia\nGunnedah - Australia\nCoffs Harbour - Australia\nNarrabri - Australia\nInverell - Australia\nYamba - Australia\nBallina - Australia\nWagga Wagga - Australia\nScone - Australia\nByron Bay - Australia\nBerri - Australia\nPeterborough - Australia\nWallaroo - Australia\nClare - Australia\nMeningie - Australia\nKingston South East - Australia\nBordertown - Australia\nPenola - Australia\nKingoonya - Australia\nKimba - Australia\nStreaky Bay - Australia\nCowell - Australia\nTumby Bay - Australia\nAndamooka - Australia\nWoomera - Australia\nPort Pirie - Australia\nGawler - Australia\nMurray Bridge - Australia\nVictor Harbor - Australia\nHamilton - Australia\nOuyen - Australia\nColac - Australia\nStawell - Australia\nHorsham - Australia\nArarat - Australia\nBairnsdale - Australia\nSale - Australia\nTraralgon - Australia\nWonthaggi - Australia\nCranbourne - Australia\nBallarat - Australia\nMelton - Australia\nSeymour - Australia\nShepparton - Australia\nCobram - Australia\nSwan Hill - Australia\nSunbury - Australia\nProserpine - Australia\nTheodore - Australia\nEidsvold - Australia\nBarcaldine - Australia\nWinton - Australia\nLongreach - Australia\nCaboolture - Australia\nWarwick - Australia\nKingaroy - Australia\nDalby - Australia\nBongaree - Australia\nGympie - Australia\nIngham - Australia\nBirdsville - Australia\nBedourie - Australia\nBoulia - Australia\nRichmond - Australia\nBurketown - Australia\nHervey Bay - Australia\nBiloela - Australia\nYeppoon - Australia\nEmerald - Australia\nMoranbah - Australia\nCharters Towers - Australia\nAyr - Australia\nAtherton - Australia\nPort Douglas - Australia\nSmithton - Australia\nScottsdale - Australia\nBicheno - Australia\nOatlands - Australia\nQueenstown - Australia\nKingston - Australia\nTennant Creek - Australia\nYulara - Australia\nErldunda - Australia\nNorseman - Australia\nHalls Creek - Australia\nKununurra - Australia\nDerby - Australia\nOnslow - Australia\nExmouth - Australia\nCarnarvon - Australia\nNewman - Australia\nMeekatharra - Australia\nThree Springs - Australia\nManjimup - Australia\nNortham - Australia\nEsperance - Australia\nLeonara - Australia\nLaverton - Australia\nWyndham - Australia\nAlbury - Australia\nForster-Tuncurry - Australia\nPort Macquarie - Australia\nTamworth - Australia\nGrafton - Australia\nMoree - Australia\nGoondiwindi - Australia\nLismore - Australia\nWollongong - Australia\nCeduna - Australia\nMount Gambier - Australia\nPort Augusta - Australia\nWarrnambool - Australia\nMildura - Australia\nGeelong - Australia\nCamooweal - Australia\nQuilpie - Australia\nCharleville - Australia\nHughenden - Australia\nCaloundra - Australia\nRoma - Australia\nToowoomba - Australia\nGeorgetown - Australia\nThargomindah - Australia\nWeipa - Australia\nKarumba - Australia\nCloncurry - Australia\nMaryborough - Australia\nBundaberg - Australia\nGladstone - Australia\nBowen - Australia\nInnisfail - Australia\nMackay - Australia\nBurnie - Australia\nLaunceston - Australia\nKatherine - Australia\nBusselton - Australia\nMandurah - Australia\nBroome - Australia\nKalgoorlie - Australia\nAlbany - Australia\nPort Hedland - Australia\nKarratha - Australia\nGeraldton - Australia\nGriffith - Australia\nOrange - Australia\nDubbo - Australia\nArmidale - Australia\nBroken Hill - Australia\nPort Lincoln - Australia\nWhyalla - Australia\nPortland - Australia\nBendigo - Australia\nWangaratta - Australia\nWindorah - Australia\nMount Isa - Australia\nRockhampton - Australia\nCairns - Australia\nGold Coast - Australia\nDevonport - Australia\nDarwin - Australia\nAlice Springs - Australia\nCanberra - Australia\nNewcastle - Australia\nAdelaide - Australia\nTownsville - Australia\nBrisbane - Australia\nHobart - Australia\nPerth - Australia\nMelbourne - Australia\nSydney - Australia\nBregenz - Austria\nEisenstadt - Austria\nWiener Neustadt - Austria\nGraz - Austria\nKlagenfurt - Austria\nLinz - Austria\nPassau - Austria\nSalzburg - Austria\nInnsbruck - Austria\nVienna - Austria\nGadabay - Azerbaijan\nGoranboy - Azerbaijan\nTovuz - Azerbaijan\nAgdam - Azerbaijan\nQabala - Azerbaijan\nOguz - Azerbaijan\nGanca - Azerbaijan\nYevlax - Azerbaijan\nSumqayt - Azerbaijan\nAli Bayramli - Azerbaijan\nGoycay - Azerbaijan\nLankaran - Azerbaijan\nSaki - Azerbaijan\nStepanakert - Azerbaijan\nKapan - Azerbaijan\nNaxcivan - Azerbaijan\nBaku - Azerbaijan\nManama - Bahrain\nTangail - Bangladesh\nSylhet - Bangladesh\nMymensingh - Bangladesh\nJamalpur - Bangladesh\nNarayanganj - Bangladesh\nJessore - Bangladesh\nBarisal - Bangladesh\nComilla - Bangladesh\nPabna - Bangladesh\nNawabganj - Bangladesh\nSaidpur - Bangladesh\nRangpur - Bangladesh\nKhulna - Bangladesh\nRajshahi - Bangladesh\nDhaka - Bangladesh\nChittagong - Bangladesh\nBridgetown - Barbados\nBaranavichy - Belarus\nPolatsk - Belarus\nMaladzyechna - Belarus\nPinsk - Belarus\nMazyr - Belarus\nMahilyow - Belarus\nBabruysk - Belarus\nOrsha - Belarus\nLida - Belarus\nHrodna - Belarus\nBarysaw - Belarus\nHomyel - Belarus\nVitsyebsk - Belarus\nBrest - Belarus\nMinsk - Belarus\nMons - Belgium\nHasselt - Belgium\nArlon - Belgium\nGent - Belgium\nLiege - Belgium\nBrugge - Belgium\nNamur - Belgium\nCharleroi - Belgium\nAntwerpen - Belgium\nBrussels - Belgium\nEl Cayo - Belize\nCorozal - Belize\nDangriga - Belize\nBelize City - Belize\nOrange Walk - Belize\nPunta Gorda - Belize\nBelmopan - Belize\nLokossa - Benin\nKandi - Benin\nOuidah - Benin\nAbomey - Benin\nNatitingou - Benin\nDjougou - Benin\nParakou - Benin\nPorto-Novo - Benin\nCotonou - Benin\nHamilton - Bermuda\nParo - Bhutan\nPunakha - Bhutan\nWangdue Prodrang - Bhutan\nThimphu - Bhutan\nPunata - Bolivia\nCliza - Bolivia\nQuillacollo - Bolivia\nPuerto Villarroel - Bolivia\nTarabuco - Bolivia\nGuayaramerin - Bolivia\nSanta Ana - Bolivia\nBaures - Bolivia\nSica Sica - Bolivia\nRurrenabaque - Bolivia\nSorata - Bolivia\nAchacachi - Bolivia\nViacha - Bolivia\nQuime - Bolivia\nLlallagua - Bolivia\nUncia - Bolivia\nUyuni - Bolivia\nVilla Martin - Bolivia\nBetanzos - Bolivia\nPortachuelo - Bolivia\nSamaipata - Bolivia\nCuevo - Bolivia\nSan Carlos - Bolivia\nSan Lorenzo - Bolivia\nEntre Rios - Bolivia\nAiquile - Bolivia\nPadilla - Bolivia\nCamargo - Bolivia\nReyes - Bolivia\nSan Borja - Bolivia\nMagdalena - Bolivia\nSan Ramon - Bolivia\nPuerto Heath - Bolivia\nCharana - Bolivia\nPuerto Acosta - Bolivia\nApolo - Bolivia\nCoroico - Bolivia\nCoro Coro - Bolivia\nSabaya - Bolivia\nChallapata - Bolivia\nLlica - Bolivia\nPotosi - Bolivia\nVillazon - Bolivia\nTupiza - Bolivia\nMontero - Bolivia\nPiso Firme - Bolivia\nRobore - Bolivia\nPuerto Quijarro - Bolivia\nSan Ignacio - Bolivia\nAscension - Bolivia\nSan Javier - Bolivia\nSan Rafael - Bolivia\nVallegrande - Bolivia\nPuerto Suarez - Bolivia\nCharagua - Bolivia\nVillamontes - Bolivia\nBermejo - Bolivia\nCochabamba - Bolivia\nOruro - Bolivia\nCamiri - Bolivia\nCobija - Bolivia\nSan Matias - Bolivia\nSan Jose - Bolivia\nTrinidad - Bolivia\nTarija - Bolivia\nSucre - Bolivia\nRiberalta - Bolivia\nLa Paz - Bolivia\nSanta Cruz - Bolivia\nZenica - Bosnia and Herzegovina\nMostar - Bosnia and Herzegovina\nTuzla - Bosnia and Herzegovina\nPrijedor - Bosnia and Herzegovina\nBanja Luka - Bosnia and Herzegovina\nSarajevo - Bosnia and Herzegovina\nMochudi - Botswana\nGhanzi - Botswana\nLokhwabe - Botswana\nLehututu - Botswana\nTshabong - Botswana\nTsau - Botswana\nNokaneng - Botswana\nMohembo - Botswana\nMaun - Botswana\nKasane - Botswana\nNata - Botswana\nMopipi - Botswana\nPalapye - Botswana\nLobatse - Botswana\nKanye - Botswana\nMolepolole - Botswana\nFrancistown - Botswana\nMahalapye - Botswana\nSerowe - Botswana\nGaborone - Botswana\nGrajau - Brazil\nPresidente Dutra - Brazil\nItapecuru Mirim - Brazil\nSao Jose de Ribamar - Brazil\nSanta Ines - Brazil\nRosario - Brazil\nTimon - Brazil\nCapanema - Brazil\nPortel - Brazil\nItupiranga - Brazil\nPimenta Bueno - Brazil\nPonta Pora - Brazil\nMaracaju - Brazil\nJardim - Brazil\nTres Lagoas - Brazil\nGuanhaes - Brazil\nLeopoldina - Brazil\nNova Lima - Brazil\nPouso Alegre - Brazil\nItauna - Brazil\nCaratinga - Brazil\nDiamantina - Brazil\nNanuque - Brazil\nBarbacena - Brazil\nPocos de Caldas - Brazil\nGuaxupe - Brazil\nSao Joao del Rei - Brazil\nMuriae - Brazil\nPassos - Brazil\nConselheiro Lafaiete - Brazil\nFormiga - Brazil\nFrutal - Brazil\nIturama - Brazil\nItuiutaba - Brazil\nAraguari - Brazil\nAlmenara - Brazil\nVarzea Grande - Brazil\nCaceres - Brazil\nSantana do Livramento - Brazil\nCanoas - Brazil\nQuarai - Brazil\nSanta Vitoria do Palmar - Brazil\nSao Lourenco do Sul - Brazil\nCanela - Brazil\nSao Gabriel - Brazil\nRosario do Sul - Brazil\nCachoeira do Sul - Brazil\nOsorio - Brazil\nSanta Cruz do Sul - Brazil\nSao Luiz Gonzaga - Brazil\nSanto Angelo - Brazil\nCarazinho - Brazil\nErechim - Brazil\nGuaira - Brazil\nArapongas - Brazil\nParanagua - Brazil\nSao Jose dos Pinhais - Brazil\nGuarapuava - Brazil\nRio Negro - Brazil\nApucarana - Brazil\nLapa - Brazil\nIrati - Brazil\nCastro - Brazil\nTelemaco Borba - Brazil\nJacarezinho - Brazil\nConcordia - Brazil\nBlumenau - Brazil\nBrusque - Brazil\nArarangua - Brazil\nJaragua do Sul - Brazil\nTubarao - Brazil\nLaguna - Brazil\nJoacaba - Brazil\nCacador - Brazil\nCanoinhas - Brazil\nCamocim - Brazil\nRussas - Brazil\nSobral - Brazil\nIguatu - Brazil\nQuixada - Brazil\nCaninde - Brazil\nCampo Maior - Brazil\nBarras - Brazil\nRio Largo - Brazil\nPalmeira dos Indios - Brazil\nSanta Cruz Cabralia - Brazil\nPaulo Afonso - Brazil\nBrumado - Brazil\nJaguaquara - Brazil\nItapetinga - Brazil\nUbaitaba - Brazil\nCachoeiro de Itapemirim - Brazil\nBarra Mansa - Brazil\nNova Iguacu - Brazil\nDuque de Caxias - Brazil\nNiteroi - Brazil\nCabo Frio - Brazil\nMacae - Brazil\nMiracema - Brazil\nApodi - Brazil\nSanta Cruz - Brazil\nMorrinhos - Brazil\nCeres - Brazil\nCatalao - Brazil\nCristalina - Brazil\nTrindade - Brazil\nIpora - Brazil\nInhumas - Brazil\nItaberai - Brazil\nSanto Andre - Brazil\nPindamonhangaba - Brazil\nRio Claro - Brazil\nOurinhos - Brazil\nItanhaem - Brazil\nJaboticabal - Brazil\nBraganca Paulista - Brazil\nJundiai - Brazil\nSao Jose dos Campos - Brazil\nGuaratingueta - Brazil\nPirassununga - Brazil\nAmericana - Brazil\nPiracicaba - Brazil\nSao Joao da Boa Vista - Brazil\nSao Carlos - Brazil\nTupa - Brazil\nPenapolis - Brazil\nPresidente Prudente - Brazil\nRegistro - Brazil\nTatui - Brazil\nAvare - Brazil\nGarca - Brazil\nCatanduva - Brazil\nBatatais - Brazil\nBarretos - Brazil\nMarilia - Brazil\nItu - Brazil\nItapetininga - Brazil\nJaboatao - Brazil\nOlinda - Brazil\nCabo de Santo Agostinho - Brazil\nCarpina - Brazil\nArcoverde - Brazil\nManacapuru - Brazil\nMaues - Brazil\nPedreiras - Brazil\nCodo - Brazil\nCoroata - Brazil\nChapadinha - Brazil\nPinheiro - Brazil\nBarra do Corda - Brazil\nViana - Brazil\nColinas - Brazil\nViseu - Brazil\nCapitao Poco - Brazil\nCastanhal - Brazil\nSalinopolis - Brazil\nAlenquer - Brazil\nOriximina - Brazil\nXinguara - Brazil\nJacunda - Brazil\nUruara - Brazil\nAltamira - Brazil\nParagominas - Brazil\nCameta - Brazil\nRolim de Moura - Brazil\nAriquemes - Brazil\nAbuna - Brazil\nTocantinopolis - Brazil\nGurupi - Brazil\nAquidauana - Brazil\nParanaiba - Brazil\nSete Lagoas - Brazil\nDivinopolis - Brazil\nIpatinga - Brazil\nAraxa - Brazil\nLavras - Brazil\nUba - Brazil\nCampo Belo - Brazil\nPonte Nova - Brazil\nCurvelo - Brazil\nParacatu - Brazil\nBocaiuva - Brazil\nAracuai - Brazil\nJanauba - Brazil\nJuina - Brazil\nBarra do Garcas - Brazil\nPontes e Lacerda - Brazil\nBarra do Bugres - Brazil\nRondonopolis - Brazil\nUruguaiana - Brazil\nSao Borja - Brazil\nNovo Hamburgo - Brazil\nRio Grande - Brazil\nCamaqua - Brazil\nBento Goncalves - Brazil\nVacaria - Brazil\nIjui - Brazil\nSanta Rosa - Brazil\nMaringa - Brazil\nCascavel - Brazil\nCampo Murao - Brazil\nFoz do Iguacu - Brazil\nSao Francisco do Sul - Brazil\nPorto Uniao - Brazil\nItajai - Brazil\nImbituba - Brazil\nLajes - Brazil\nGranja - Brazil\nItapipoca - Brazil\nParacuru - Brazil\nAcarau - Brazil\nTaua - Brazil\nCrateus - Brazil\nBaturite - Brazil\nIpu - Brazil\nFloriano - Brazil\nPiripiri - Brazil\nPenedo - Brazil\nItabuna - Brazil\nItamaraju - Brazil\nGuanambi - Brazil\nPorto Seguro - Brazil\nValenca - Brazil\nSerrinha - Brazil\nTucano - Brazil\nSenhor do Bonfim - Brazil\nRemanso - Brazil\nItambe - Brazil\nBom Jesus da Lapa - Brazil\nItaberaba - Brazil\nSao Mateus - Brazil\nPatos - Brazil\nVolta Redonda - Brazil\nPetropolis - Brazil\nNova Cruz - Brazil\nCaico - Brazil\nAcu - Brazil\nEstancia - Brazil\nCaracarai - Brazil\nPorto Santana - Brazil\nRio Verde - Brazil\nPires do Rio - Brazil\nAnapolis - Brazil\nGoianesia - Brazil\nNiquelandia - Brazil\nItumbiara - Brazil\nJatai - Brazil\nMineiros - Brazil\nFormosa - Brazil\nSao Jose do Rio Preto - Brazil\nLimeira - Brazil\nTaubate - Brazil\nJau - Brazil\nAssis - Brazil\nItapeva - Brazil\nBotucatu - Brazil\nNovo Horizonte - Brazil\nAndradina - Brazil\nFernandopolis - Brazil\nBarreiros - Brazil\nSalgueiro - Brazil\nGoiana - Brazil\nTimbauba - Brazil\nBacabal - Brazil\nBraganca - Brazil\nObidos - Brazil\nGuajara-Miram - Brazil\nPorto Nacional - Brazil\nDourados - Brazil\nGovernador Valadares - Brazil\nPirapora - Brazil\nJuiz de Fora - Brazil\nSanta Maria - Brazil\nPasso Fundo - Brazil\nXapeco - Brazil\nJoinville - Brazil\nJuazeiro do Norte - Brazil\nNova Vicosa - Brazil\nAlagoinhas - Brazil\nJuazeiro - Brazil\nVitoria - Brazil\nJoao Pessoa - Brazil\nCampina Grande - Brazil\nNova Friburgo - Brazil\nAracatuba - Brazil\nSena Madureira - Brazil\nFonte Boa - Brazil\nEirunepe - Brazil\nManicore - Brazil\nBarcelos - Brazil\nTonantins - Brazil\nTefe - Brazil\nCoari - Brazil\nSao Cabriel da Cachoeira - Brazil\nNovo Airao - Brazil\nItacoatiara - Brazil\nParintins - Brazil\nCrato - Brazil\nImperatriz - Brazil\nBalsas - Brazil\nBreves - Brazil\nJacareacanga - Brazil\nTucurui - Brazil\nItaituba - Brazil\nConceicao do Araguaia - Brazil\nAbaetetuba - Brazil\nPrincipe da Beira - Brazil\nAraguaina - Brazil\nPalmas - Brazil\nTeofilo Otoni - Brazil\nUberaba - Brazil\nJanuaria - Brazil\nMato Grosso - Brazil\nAripuana - Brazil\nSinop - Brazil\nJaguarao - Brazil\nBage - Brazil\nLondrina - Brazil\nCriciuma - Brazil\nAracati - Brazil\nIco - Brazil\nParnaiba - Brazil\nPicos - Brazil\nArapiraca - Brazil\nJequie - Brazil\nIlheus - Brazil\nCanavieiras - Brazil\nSanta Maria da Vitoria - Brazil\nIrece - Brazil\nXique-Xique - Brazil\nLinhares - Brazil\nCampos - Brazil\nMossoro - Brazil\nAracaju - Brazil\nLaranjal do Jari - Brazil\nAmapa - Brazil\nVila Velha - Brazil\nSantos - Brazil\nBauru - Brazil\nIguape - Brazil\nFranca - Brazil\nGaranhuns - Brazil\nCaruaru - Brazil\nRio Branco - Brazil\nSao Luis - Brazil\nPorto Velho - Brazil\nAlvorada - Brazil\nCorumba - Brazil\nBelo Horizonte - Brazil\nMontes Claros - Brazil\nUberlandia - Brazil\nColider - Brazil\nAlta Floresta - Brazil\nCuiaba - Brazil\nPelotas - Brazil\nCaxias do Sul - Brazil\nPonta Grossa - Brazil\nTeresina - Brazil\nMaceio - Brazil\nVitoria da Conquista - Brazil\nBarreiras - Brazil\nNatal - Brazil\nCampinas - Brazil\nSorocaba - Brazil\nRibeirao Preto - Brazil\nPetrolina - Brazil\nCruzeiro do Sul - Brazil\nManaus - Brazil\nCaxias - Brazil\nSantarem - Brazil\nMaraba - Brazil\nVilhena - Brazil\nJi-Parana - Brazil\nCampo Grande - Brazil\nFlorianopolis - Brazil\nFeira de Santana - Brazil\nBoa Vista - Brazil\nMacapa - Brazil\nBelem - Brazil\nBrasilia - Brazil\nPorto Alegre - Brazil\nCuritiba - Brazil\nFortaleza - Brazil\nSalvador - Brazil\nGoiania - Brazil\nRecife - Brazil\nRio de Janeiro - Brazil\nSao Paulo - Brazil\nBandar Seri Begawan - Brunei\nLovec - Bulgaria\nMontana - Bulgaria\nRazgrad - Bulgaria\nSliven - Bulgaria\nPlovdiv - Bulgaria\nPernik - Bulgaria\nVratsa - Bulgaria\nShumen - Bulgaria\nKhaskovo - Bulgaria\nStara Zagora - Bulgaria\nPleven - Bulgaria\nTurnovo - Bulgaria\nKyustendil - Bulgaria\nDobrich - Bulgaria\nVarna - Bulgaria\nRuse - Bulgaria\nBurgas - Bulgaria\nSofia - Bulgaria\nFada Ngourma - Burkina Faso\nOrodara - Burkina Faso\nSolenzo - Burkina Faso\nNouna - Burkina Faso\nDedougou - Burkina Faso\nGorom Gorom - Burkina Faso\nDjibo - Burkina Faso\nTougan - Burkina Faso\nKombissiri - Burkina Faso\nZiniare - Burkina Faso\nYako - Burkina Faso\nReo - Burkina Faso\nLeo - Burkina Faso\nSapouy - Burkina Faso\nBoulsa - Burkina Faso\nZorgo - Burkina Faso\nKoupela - Burkina Faso\nPo - Burkina Faso\nManga - Burkina Faso\nDiebougou - Burkina Faso\nGaoua - Burkina Faso\nBogande - Burkina Faso\nDori - Burkina Faso\nSebba - Burkina Faso\nDiapaga - Burkina Faso\nKoudougou - Burkina Faso\nOuahigouya - Burkina Faso\nKaya - Burkina Faso\nTenkodogo - Burkina Faso\nBanfora - Burkina Faso\nBobo Dioulasso - Burkina Faso\nOuagadougou - Burkina Faso\nCankuzo - Burundi\nKarusi - Burundi\nRutana - Burundi\nRuyigi - Burundi\nBubanza - Burundi\nKayanza - Burundi\nMakamba - Burundi\nNgozi - Burundi\nKirundo - Burundi\nMuramvya - Burundi\nBururi - Burundi\nMuyinga - Burundi\nGitega - Burundi\nBujumbura - Burundi\nKampong Spoe - Cambodia\nKampong Thum - Cambodia\nPrey Veng - Cambodia\nPhnum Tbeng Meanchey - Cambodia\nStoeng Treng - Cambodia\nKracheh - Cambodia\nSenmonorom - Cambodia\nLumphat - Cambodia\nSvay Rieng - Cambodia\nSisophon - Cambodia\nKrong Koh Kong - Cambodia\nPursat - Cambodia\nKampong Cham - Cambodia\nKompong Chhnang - Cambodia\nKampot - Cambodia\nTakeo - Cambodia\nBattambang - Cambodia\nSiem Reap - Cambodia\nPhnom Penh - Cambodia\nBuea - Cameroon\nBafang - Cameroon\nFoumban - Cameroon\nBafoussam - Cameroon\nKumba - Cameroon\nEyumojok - Cameroon\nLimbe - Cameroon\nKribi - Cameroon\nNkongsamba - Cameroon\nEdea - Cameroon\nWum - Cameroon\nKumbo - Cameroon\nBafia - Cameroon\nMbalmayo - Cameroon\nEseka - Cameroon\nBertoua - Cameroon\nAbong Mbang - Cameroon\nBatouri - Cameroon\nBelabo - Cameroon\nMeiganga - Cameroon\nNgaoundere - Cameroon\nTibati - Cameroon\nKontcha - Cameroon\nGuider - Cameroon\nMbe - Cameroon\nDouala - Cameroon\nEbolowa - Cameroon\nBamenda - Cameroon\nGaroua - Cameroon\nMaroua - Cameroon\nYaounde - Cameroon\nQuebec City - Canada\nWaterloo - Canada\nCambridge - Canada\nSt. Catharines - Canada\nNiagara Falls - Canada\nGuelph - Canada\nKanata - Canada\nGatineau - Canada\nSelkirk - Canada\nBerens River - Canada\nPukatawagan - Canada\nGimli - Canada\nIsland Lake - Canada\nMelville - Canada\nWeyburn - Canada\nLa Ronge - Canada\nStony Rapids - Canada\nCamrose - Canada\nHinton - Canada\nVegreville - Canada\nStettler - Canada\nLac La Biche - Canada\nWetaskiwin - Canada\nMeander River - Canada\nCreston - Canada\nCranbrook - Canada\nTerrace - Canada\nChilliwack - Canada\nHall Beach - Canada\nLutselke - Canada\nHay River - Canada\nDeline - Canada\nPaulatuk - Canada\nTsiigehtchic - Canada\nOwen Sound - Canada\nOrillia - Canada\nKapuskasing - Canada\nThessalon - Canada\nGeraldton - Canada\nBelleville - Canada\nSarnia - Canada\nPeterborough - Canada\nOshawa - Canada\nLondon - Canada\nKitchener - Canada\nNew Liskeard - Canada\nBrockville - Canada\nBig Beaver House - Canada\nPort-Menier - Canada\nRiviere-du-Loup - Canada\nDrummondville - Canada\nSherbrooke - Canada\nCap-Chat - Canada\nBaie-Comeau - Canada\nNatashquan - Canada\nEastmain - Canada\nSchefferville - Canada\nSalluit - Canada\nAmos - Canada\nJoliette - Canada\nSt.-Jerome - Canada\nSt-Augustin - Canada\nRouyn-Noranda - Canada\nLa Sarre - Canada\nNew Glasgow - Canada\nLiverpool - Canada\nAmherst - Canada\nBaddeck - Canada\nLa Scie - Canada\nHopedale - Canada\nHappy Valley - Goose Bay - Canada\nPort Hope Simpson - Canada\nTofino - Canada\nSteinbach - Canada\nNelson House - Canada\nShamattawa - Canada\nOxford House - Canada\nYorkton - Canada\nSwift Current - Canada\nBiggar - Canada\nKindersley - Canada\nMeadow Lake - Canada\nHudson Bay - Canada\nLethbridge - Canada\nBrooks - Canada\nLake Louise - Canada\nAthabasca - Canada\nFort Chipewyan - Canada\nBella Bella - Canada\nSandspit - Canada\nCampbell River - Canada\nPort Hardy - Canada\nNanaimo - Canada\nQuesnel - Canada\nAbbotsford - Canada\nDawson Creek - Canada\nPenticton - Canada\nNelson - Canada\nLillooet - Canada\nPowell River - Canada\nRevelstoke - Canada\nBurns Lake - Canada\nDease Lake - Canada\nCoral Harbour - Canada\nBaker Lake - Canada\nNorman Wells - Canada\nFort McPherson - Canada\nBurwash Landing - Canada\nOrangeville - Canada\nLittle Current - Canada\nChapleau - Canada\nWawa - Canada\nHearst - Canada\nMarathon - Canada\nSioux Lookout - Canada\nRed Lake - Canada\nDeer Lake - Canada\nCat Lake - Canada\nCornwall - Canada\nKingston - Canada\nBarrie - Canada\nParry Sound - Canada\nWiarton - Canada\nCobalt - Canada\nCochrane - Canada\nNipigon - Canada\nAtikokan - Canada\nRimouski - Canada\nSaint-Georges - Canada\nVictoriaville - Canada\nChevery - Canada\nMistassini - Canada\nKangirsuk - Canada\nShawinigan - Canada\nMatagami - Canada\nMont-Laurier - Canada\nPembroke - Canada\nRadisson - Canada\nSaint John - Canada\nEdmundston - Canada\nShelburne - Canada\nAntigonish - Canada\nDigby - Canada\nStephenville - Canada\nArgentia - Canada\nSt. Anthony - Canada\nChannel-Port aux Basques - Canada\nBuchans - Canada\nTrout River - Canada\nChurchill Falls - Canada\nForteau - Canada\nTrepassey - Canada\nBrochet - Canada\nLynn Lake - Canada\nGillam - Canada\nNorth Battleford - Canada\nPrince Albert - Canada\nCourtenay - Canada\nKelowna - Canada\nPangnirtung - Canada\nHolman - Canada\nDryden - Canada\nAttawapiskat - Canada\nHamilton - Canada\nWindsor - Canada\nTrois-Rivieres - Canada\nSept-Iles - Canada\nCorner Brook - Canada\nNorway House - Canada\nFlin Flon - Canada\nDauphin - Canada\nThe Pas - Canada\nUranium City - Canada\nMoose Jaw - Canada\nJasper - Canada\nMedicine Hat - Canada\nRed Deer - Canada\nBanff - Canada\nGrand Prairie - Canada\nSmithers - Canada\nKamloops - Canada\nWilliams Lake - Canada\nPrince George - Canada\nFort Nelson - Canada\nPond Inlet - Canada\nCape Dorset - Canada\nKimmirut - Canada\nGjoa Haven - Canada\nGrise Fiord - Canada\nAlert - Canada\nEnnadai - Canada\nRankin Inlet - Canada\nFort Resolution - Canada\nFort Simpson - Canada\nInuvik - Canada\nTuktoyaktuk - Canada\nWatson Lake - Canada\nLansdowne House - Canada\nMoosonee - Canada\nSudbury - Canada\nKenora - Canada\nGaspe - Canada\nMingan - Canada\nDolbeau - Canada\nVal d\'Or - Canada\nIvugivik - Canada\nInukjuak - Canada\nChicoutimi - Canada\nMoncton - Canada\nFredericton - Canada\nBathurst - Canada\nYarmouth - Canada\nGander - Canada\nCartwright - Canada\nRigolet - Canada\nPort Burwell - Canada\nThompson - Canada\nBrandon - Canada\nFort Smith - Canada\nFort McMurray - Canada\nPeace River - Canada\nFort St. John - Canada\nIqaluit - Canada\nCambridge Bay - Canada\nKugluktuk - Canada\nChesterfield Inlet - Canada\nArviat - Canada\nTaloyoak - Canada\nIgloolik - Canada\nDawson City - Canada\nTimmins - Canada\nNorth Bay - Canada\nKuujjuarapik - Canada\nKuujjuaq - Canada\nSydney - Canada\nLabrador City - Canada\nWinnipeg - Canada\nChurchill - Canada\nRegina - Canada\nSaskatoon - Canada\nCalgary - Canada\nPrince Rupert - Canada\nVictoria - Canada\nArctic Bay - Canada\nResolute - Canada\nRepulse Bay - Canada\nYellowknife - Canada\nFort Good Hope - Canada\nWhitehorse - Canada\nOttawa - Canada\nFort Severn - Canada\nThunder Bay - Canada\nHalifax - Canada\nSt. John\'s - Canada\nNain - Canada\nCharlottetown - Canada\nEdmonton - Canada\nMontreal - Canada\nVancouver - Canada\nToronto - Canada\nMindelo - Cape Verde\nPraia - Cape Verde\nGeorge Town - Cayman Islands\nMobaye - Central African Republic\nMbaiki - Central African Republic\nCarnot - Central African Republic\nBozoum - Central African Republic\nKaga Bandoro - Central African Republic\nZemio - Central African Republic\nYakossi - Central African Republic\nNola - Central African Republic\nSibut - Central African Republic\nBossangoa - Central African Republic\nBirao - Central African Republic\nOuadda - Central African Republic\nBangassou - Central African Republic\nBossembele - Central African Republic\nBerberati - Central African Republic\nBria - Central African Republic\nBouar - Central African Republic\nBambari - Central African Republic\nNdele - Central African Republic\nObo - Central African Republic\nBangui - Central African Republic\nLai - Chad\nZouar - Chad\nBol - Chad\nAti - Chad\nOum Hadjer - Chad\nMongo - Chad\nDoba - Chad\nPala - Chad\nBongor - Chad\nKelo - Chad\nFada - Chad\nFaya Largeau - Chad\nMao - Chad\nBiltine - Chad\nSarh - Chad\nAm Timan - Chad\nMoundou - Chad\nNdjamena - Chad\nAbeche - Chad\nRio Verde - Chile\nCuya - Chile\nChuquicamata - Chile\nMaria Elena - Chile\nTierra Amarilla - Chile\nCombarbala - Chile\nSan Bernardo - Chile\nSan Felipe - Chile\nVina del Mar - Chile\nLa Ligua - Chile\nQuillota - Chile\nNueva Imperial - Chile\nLoncoche - Chile\nVillarica - Chile\nTolten - Chile\nLonquimay - Chile\nAngol - Chile\nCollipulli - Chile\nLa Union - Chile\nRio Bueno - Chile\nCoronel - Chile\nTalcahuano - Chile\nQuirihue - Chile\nCuranilahue - Chile\nSanta Barbara - Chile\nPichilemu - Chile\nSan Fernando - Chile\nPuerto Varas - Chile\nCalbuco - Chile\nCastro - Chile\nChonchi - Chile\nLinares - Chile\nCauquenes - Chile\nCochrane - Chile\nLagunas - Chile\nPozo Almonte - Chile\nToconao - Chile\nHuasco - Chile\nDiego de Almagro - Chile\nCaldera - Chile\nCoquimbo - Chile\nVicuna - Chile\nIllapel - Chile\nSalamanca - Chile\nLos Andes - Chile\nSan Antonio - Chile\nVictoria - Chile\nCarahue - Chile\nLos Lagos - Chile\nLota - Chile\nLebu - Chile\nQuellon - Chile\nConstitucion - Chile\nVilla O\'Higgins - Chile\nPuerto Aisen - Chile\nPuerto Natales - Chile\nPuerto Williams - Chile\nTemuco - Chile\nTocopilla - Chile\nCalama - Chile\nMejillones - Chile\nTaltal - Chile\nVallenar - Chile\nChanaral - Chile\nOvalle - Chile\nChillan - Chile\nRancagua - Chile\nOsorno - Chile\nAncud - Chile\nTalca - Chile\nCurico - Chile\nCoihaique - Chile\nArica - Chile\nCopiapo - Chile\nLa Serena - Chile\nLos Angeles - Chile\nPunta Arenas - Chile\nIquique - Chile\nAntofagasta - Chile\nValparaiso - Chile\nValdivia - Chile\nConcepcion - Chile\nPuerto Montt - Chile\nSantiago - Chile\nZhongshan - China\nYumen - China\nLinxia - China\nZhuozhou - China\nSanming - China\nHuizhou - China\nChaozhou - China\nGyangze - China\nYangquan - China\nShiyan - China\nDanjiangkou - China\nShashi - China\nAnlu - China\nZixing - China\nDeyang - China\nTengchong - China\nMengzi - China\nChuxiong - China\nHengshui - China\nXuanhua - China\nLuohe - China\nBeipiao - China\nWafangdian - China\nZhucheng - China\nHangu - China\nXinyi - China\nYangzhou - China\nLinhai - China\nHuangyan - China\nDaan - China\nChangling - China\nTonghua - China\nBaishan - China\nYanji - China\nErgun Zuoqi - China\nShangdu - China\nOrongen Zizhiqi - China\nZalantun - China\nWuchuan - China\nHanggin Houqi - China\nAnda - China\nQinggang - China\nAngangxi - China\nHulan Ergi - China\nQingan - China\nBaiquan - China\nSuileng - China\nLinkou - China\nLongxi - China\nPingliang - China\nAnxi - China\nMinxian - China\nJinchang - China\nGuide - China\nQinzhou - China\nYishan - China\nBeihai - China\nHechi - China\nTongren - China\nFengjie - China\nChangping - China\nShaowu - China\nLongyan - China\nZhangzhou - China\nPutian - China\nFuan - China\nChangting - China\nNanping - China\nNinde - China\nJieshou - China\nTongling - China\nMaanshan - China\nYangjiang - China\nMeizhou - China\nHeyuan - China\nQingyuan - China\nZhaoqing - China\nLianxian - China\nJiangmen - China\nMaoming - China\nGar - China\nTurpan - China\nQuiemo - China\nKoktokay - China\nHancheng - China\nWeinan - China\nShuozhou - China\nXinzhou - China\nJincheng - China\nJiexiu - China\nChangzhi - China\nGuangshui - China\nJingmen - China\nZicheng - China\nShishou - China\nXiaogan - China\nPuqi - China\nYunxian - China\nJinshi - China\nChenzhou - China\nZhijiang - China\nXiangtan - China\nZigong - China\nYaan - China\nLangzhong - China\nRongzhag - China\nSimao - China\nWenshan - China\nZhanyi - China\nHuize - China\nChengde - China\nCangzhou - China\nBaoding - China\nHuanghua - China\nDingzhou - China\nNangong - China\nLinqing - China\nXiangtai - China\nPuyang - China\nHebi - China\nXuchang - China\nZhoukou - China\nDengzhou - China\nTieling - China\nChaoyang - China\nHuanren - China\nZhuanghe - China\nYishui - China\nShanxian - China\nPingyi - China\nPingdu - China\nLaiwu - China\nBuizhou - China\nLiaocheng - China\nRizhao - China\nDezhou - China\nLinchuan - China\nFengcheng - China\nJian - China\nShangrao - China\nJingdezhen - China\nTaizhou - China\nShuyang - China\nLianyungang - China\nLishui - China\nJiaojing - China\nQuzhou - China\nFuyu - China\nDunhua - China\nNongan - China\nTaonan - China\nLiuhe - China\nHuinan - China\nPanshi - China\nJiaohe - China\nLinjiang - China\nWangqing - China\nHelong - China\nShulan - China\nJiutai - China\nAlxa Zuoqi - China\nLinxi - China\nKailu - China\nBairin Zuoqi - China\nYitulihe - China\nYakeshi - China\nBugt - China\nWuyuan - China\nBayan Obo - China\nFengzhen - China\nSuihua - China\nShuangyashan - China\nShangzhi - China\nFujin - China\nYian - China\nTailai - China\nLongjiang - China\nGannan - China\nHailun - China\nMishan - China\nTieli - China\nShuangcheng - China\nZhaodong - China\nLanxi - China\nKeshan - China\nNancha - China\nXinqing - China\nHulin - China\nBoli - China\nNingan - China\nJyekundo - China\nLiuzhou - China\nXingyi - China\nAnshun - China\nZunyi - China\nWanzhou - China\nHuaibei - China\nWuhu - China\nLuan - China\nBengbu - China\nAnqing - China\nFoshan - China\nNagchu - China\nNyingchi - China\nChamdo - China\nKorla - China\nKuqa - China\nTacheng - China\nShihezi - China\nKaramay - China\nAksu - China\nSanya - China\nHaikou - China\nHanzhong - China\nBaoji - China\nTongchuan - China\nLinfen - China\nYuci - China\nDatong - China\nJianamen - China\nYichang - China\nXiantao - China\nMacheng - China\nHuangshi - China\nZhuzhou - China\nYongzhou - China\nYiyang - China\nChangde - China\nShaoyang - China\nLeshan - China\nPanzhihua - China\nFulin - China\nGuangyuan - China\nLuzhou - China\nYibin - China\nZhaotang - China\nLijiang - China\nYuxi - China\nDali - China\nQinhuangdao - China\nLangfang - China\nZhangjiakou - China\nTangshan - China\nAnyang - China\nJiaozuo - China\nKaifeng - China\nShangqiu - China\nPingdingshan - China\nXinyang - China\nXinxiang - China\nLuoyang - China\nLiaoyang - China\nDandong - China\nYingkow - China\nJinzhou - China\nFuxin - China\nBenxi - China\nFushun - China\nJining - China\nWeifang - China\nTaian - China\nHeze - China\nLaiyang - China\nXinyu - China\nGanzhou - China\nJiujiang - China\nChangzhou - China\nZhenjiang - China\nNantong - China\nJiaxing - China\nHuzhou - China\nShaoxing - China\nJinhua - China\nLiaoyuan - China\nTumen - China\nSiping - China\nBaicheng - China\nWuhai - China\nErenhot - China\nArxan - China\nManzhouli - China\nXilinhot - China\nHeihe - China\nQitaihe - China\nYichun - China\nHegang - China\nNenjiang - China\nNehe - China\nMudangiang - China\nXuanzhou - China\nZhuhai - China\nXianyang - China\nXiangfan - China\nSuining - China\nLingyuan - China\nWeihai - China\nYancheng - China\nFuyang - China\nXiamen - China\nNanchong - China\nNeijiang - China\nNanyang - China\nJinxi - China\nYantai - China\nZaozhuang - China\nSuzhou - China\nXuzhou - China\nWuxi - China\nJilin - China\nZhangye - China\nWuwei - China\nDunhuang - China\nTianshui - China\nDulan - China\nGolmud - China\nBose - China\nWuzhou - China\nLupanshui - China\nQuanzhou - China\nHefei - China\nZhanjiang - China\nShaoguan - China\nXigaze - China\nShache - China\nYining - China\nAltay - China\nShizuishan - China\nYulin - China\nAnkang - China\nHouma - China\nYueyang - China\nHengyang - China\nMianyang - China\nXichang - China\nBaoshan - China\nGejiu - China\nShijianzhuang - China\nHandan - China\nAnshan - China\nDalian - China\nQingdao - China\nLinyi - China\nHuaiyin - China\nWenzhou - China\nNingbo - China\nTongliao - China\nHohhot - China\nChifeng - China\nUlanhot - China\nHailar - China\nJiamusi - China\nBeian - China\nDaqing - China\nJixi - China\nJiayuguan - China\nXining - China\nGuilin - China\nHuainan - China\nShantou - China\nLhasa - China\nHami - China\nHotan - China\nKashgar - China\nYinchuan - China\nPingxiang - China\nQiqihar - China\nShenzhen - China\nZibo - China\nLanzhou - China\nNanning - China\nGuiyang - China\nChongqing - China\nFuzhou - China\nGuangzhou - China\nDongguan - China\nXian - China\nTaiyuan - China\nWuhan - China\nChangsha - China\nKunming - China\nZhengzhou - China\nShenyeng - China\nJinan - China\nTianjin - China\nNanchang - China\nNanjing - China\nHangzhou - China\nChangchun - China\nBaotou - China\nHarbin - China\nUrumqi - China\nChengdu - China\nBeijing - China\nShanghai - China\nYopal - Colombia\nSan Andres - Colombia\nSonson - Colombia\nSogamoso - Colombia\nBarrancabermeja - Colombia\nGirardot - Colombia\nCampoalegre - Colombia\nTuquerres - Colombia\nMocoa - Colombia\nCartago - Colombia\nSoledad - Colombia\nSabanalarga - Colombia\nArjona - Colombia\nMagangue - Colombia\nValledupar - Colombia\nSan Jose del Guaviare - Colombia\nPuerto Lopez - Colombia\nYarumal - Colombia\nPuerto Berrio - Colombia\nTurbo - Colombia\nTunja - Colombia\nChiquinquira - Colombia\nDuitama - Colombia\nAyapel - Colombia\nLorica - Colombia\nSocorro - Colombia\nRiohacha - Colombia\nArmenia - Colombia\nPereira - Colombia\nHonda - Colombia\nSan Vicente del Caguan - Colombia\nFlorencia - Colombia\nGuapi - Colombia\nNeiva - Colombia\nGarzon - Colombia\nIpiales - Colombia\nBuenaventura - Colombia\nTulua - Colombia\nEl Carmen de Bolivar - Colombia\nJurado - Colombia\nNuqui - Colombia\nQuibdo - Colombia\nEl Banco - Colombia\nCienaga - Colombia\nSincelejo - Colombia\nTolu - Colombia\nArauca - Colombia\nTame - Colombia\nPamplona - Colombia\nOcana - Colombia\nOrocue - Colombia\nObando - Colombia\nSan Martin - Colombia\nPuerto Carreno - Colombia\nBello - Colombia\nMonteria - Colombia\nBucaramanga - Colombia\nIbague - Colombia\nPopayan - Colombia\nSanta Marta - Colombia\nCucuta - Colombia\nVillavicencio - Colombia\nTumaco - Colombia\nManizales - Colombia\nPasto - Colombia\nBarranquilla - Colombia\nCartagena - Colombia\nMitu - Colombia\nLeticia - Colombia\nMedellin - Colombia\nCali - Colombia\nBogota - Colombia\nMoroni - Comoros\nMadingou - Congo (Brazzaville)\nKinkala - Congo (Brazzaville)\nEwo - Congo (Brazzaville)\nImpfondo - Congo (Brazzaville)\nSembe - Congo (Brazzaville)\nMoloundou - Congo (Brazzaville)\nOwando - Congo (Brazzaville)\nMakoua - Congo (Brazzaville)\nSibiti - Congo (Brazzaville)\nMossendjo - Congo (Brazzaville)\nLoubomo - Congo (Brazzaville)\nGamboma - Congo (Brazzaville)\nDjambala - Congo (Brazzaville)\nOuesso - Congo (Brazzaville)\nKayes - Congo (Brazzaville)\nPointe-Noire - Congo (Brazzaville)\nBrazzaville - Congo (Brazzaville)\nBuluko - Congo (Kinshasa)\nZongo - Congo (Kinshasa)\nLibenge - Congo (Kinshasa)\nBongandanga - Congo (Kinshasa)\nIkela - Congo (Kinshasa)\nBinga - Congo (Kinshasa)\nBasankusu - Congo (Kinshasa)\nBoende - Congo (Kinshasa)\nGbadolite - Congo (Kinshasa)\nBusinga - Congo (Kinshasa)\nBosobolo - Congo (Kinshasa)\nYangambi - Congo (Kinshasa)\nAketi - Congo (Kinshasa)\nMongbwalu - Congo (Kinshasa)\nBafwasende - Congo (Kinshasa)\nBunia - Congo (Kinshasa)\nWamba - Congo (Kinshasa)\nBasoko - Congo (Kinshasa)\nKenge - Congo (Kinshasa)\nBolobo - Congo (Kinshasa)\nKahemba - Congo (Kinshasa)\nBulungu - Congo (Kinshasa)\nLusanga - Congo (Kinshasa)\nMangai - Congo (Kinshasa)\nKasongo-Lunda - Congo (Kinshasa)\nMushie - Congo (Kinshasa)\nDibaya - Congo (Kinshasa)\nMweka - Congo (Kinshasa)\nLuebo - Congo (Kinshasa)\nDemba - Congo (Kinshasa)\nIlebo - Congo (Kinshasa)\nMoanda - Congo (Kinshasa)\nKimpese - Congo (Kinshasa)\nKasangulu - Congo (Kinshasa)\nMbanza-Ngungu - Congo (Kinshasa)\nTshela - Congo (Kinshasa)\nMwenga - Congo (Kinshasa)\nKampene - Congo (Kinshasa)\nKalima - Congo (Kinshasa)\nLubutu - Congo (Kinshasa)\nKabinda - Congo (Kinshasa)\nLubao - Congo (Kinshasa)\nLusambo - Congo (Kinshasa)\nGandajika - Congo (Kinshasa)\nLodja - Congo (Kinshasa)\nDilolo - Congo (Kinshasa)\nNyunzu - Congo (Kinshasa)\nKasaji - Congo (Kinshasa)\nLuanza - Congo (Kinshasa)\nMoba - Congo (Kinshasa)\nBukama - Congo (Kinshasa)\nKaniama - Congo (Kinshasa)\nKipushi - Congo (Kinshasa)\nKambove - Congo (Kinshasa)\nKongolo - Congo (Kinshasa)\nKabalo - Congo (Kinshasa)\nBeni - Congo (Kinshasa)\nLisala - Congo (Kinshasa)\nGemena - Congo (Kinshasa)\nButa - Congo (Kinshasa)\nWatsa - Congo (Kinshasa)\nIsiro - Congo (Kinshasa)\nBondo - Congo (Kinshasa)\nInongo - Congo (Kinshasa)\nTshikapa - Congo (Kinshasa)\nBoma - Congo (Kinshasa)\nBukavu - Congo (Kinshasa)\nUvira - Congo (Kinshasa)\nKindu - Congo (Kinshasa)\nMwene-Ditu - Congo (Kinshasa)\nLikasi - Congo (Kinshasa)\nManono - Congo (Kinshasa)\nKamina - Congo (Kinshasa)\nMbandaka - Congo (Kinshasa)\nKisangani - Congo (Kinshasa)\nBandundu - Congo (Kinshasa)\nKananga - Congo (Kinshasa)\nKasongo - Congo (Kinshasa)\nMbuji-Mayi - Congo (Kinshasa)\nKalemie - Congo (Kinshasa)\nButembo - Congo (Kinshasa)\nGoma - Congo (Kinshasa)\nBumba - Congo (Kinshasa)\nKikwit - Congo (Kinshasa)\nMatadi - Congo (Kinshasa)\nKolwezi - Congo (Kinshasa)\nLubumbashi - Congo (Kinshasa)\nKinshasa - Congo (Kinshasa)\nRarotonga - Cook Islands\nHeredia - Costa Rica\nCartago - Costa Rica\nGolfito - Costa Rica\nAlajuela - Costa Rica\nCanas - Costa Rica\nSixaola - Costa Rica\nPuntarenas - Costa Rica\nCiudad Cortes - Costa Rica\nQuesada - Costa Rica\nLiberia - Costa Rica\nLa Cruz - Costa Rica\nPuerto Limon - Costa Rica\nSan Jose - Costa Rica\nSibenik - Croatia\nKarlovac - Croatia\nRijeka - Croatia\nSlavonski Brod - Croatia\nDubrovnik - Croatia\nSplit - Croatia\nZadar - Croatia\nPula - Croatia\nOsijek - Croatia\nZagreb - Croatia\nCiego de Avila - Cuba\nPalma Soriano - Cuba\nSan Antonio de los Banos - Cuba\nGuines - Cuba\nCaibarien - Cuba\nPlacetas - Cuba\nCienfuegos - Cuba\nNueva Gerona - Cuba\nSancti Spiritus - Cuba\nMoron - Cuba\nNuevitas - Cuba\nManzanillo - Cuba\nBayamo - Cuba\nBanes - Cuba\nLas Tunas - Cuba\nArtemisa - Cuba\nMatanzas - Cuba\nColon - Cuba\nSagua la Grande - Cuba\nPinar del Rio - Cuba\nCamaguey - Cuba\nGuantanamo - Cuba\nHolguin - Cuba\nSanta Clara - Cuba\nSantiago de Cuba - Cuba\nHavana - Cuba\nWillemstad - Curacao\nLarnaka - Cyprus\nPaphos - Cyprus\nLemosos - Cyprus\nNicosia - Cyprus\nUsti Nad Labem - Czech Republic\nHradec Kralove - Czech Republic\nCeske Budejovice - Czech Republic\nLiberec - Czech Republic\nOlomouc - Czech Republic\nPizen - Czech Republic\nJihlava - Czech Republic\nZlin - Czech Republic\nBrno - Czech Republic\nPardubice - Czech Republic\nOstrava - Czech Republic\nPrague - Czech Republic\nCopenhagen - Denmark\nVejle - Denmark\nHillerod - Denmark\nSoro - Denmark\nViborg - Denmark\nRoskilde - Denmark\nSvendborg - Denmark\nOdense - Denmark\nEsbjerg - Denmark\nFrederikshavn - Denmark\nAalborg - Denmark\nAarhus - Denmark\nKobenhavn - Denmark\nDikhil - Djibouti\nTadjoura - Djibouti\nAli Sabih - Djibouti\nObock - Djibouti\nDjibouti - Djibouti\nRoseau - Dominica\nSabaneta - Dominican Republic\nMao - Dominican Republic\nCotui - Dominican Republic\nPuerto Plata - Dominican Republic\nDajabon - Dominican Republic\nMoca - Dominican Republic\nSalcedo - Dominican Republic\nJimani - Dominican Republic\nComendador - Dominican Republic\nPedernales - Dominican Republic\nAzua - Dominican Republic\nBonao - Dominican Republic\nBani - Dominican Republic\nHato Mayor - Dominican Republic\nMonte Plata - Dominican Republic\nNagua - Dominican Republic\nSamana - Dominican Republic\nSan Cristobal - Dominican Republic\nEl Seibo - Dominican Republic\nHiguey - Dominican Republic\nNeiba - Dominican Republic\nLa Vega - Dominican Republic\nSan Francisco de Macoris - Dominican Republic\nSan Pedro de Macoris - Dominican Republic\nMonte Cristi - Dominican Republic\nBarahona - Dominican Republic\nBavaro - Dominican Republic\nLa Romana - Dominican Republic\nSan Juan - Dominican Republic\nSantiago - Dominican Republic\nSanto Domingo - Dominican Republic\nDili - East Timor\nPuyo - Ecuador\nTulcan - Ecuador\nPinas - Ecuador\nPuerto Villamil - Ecuador\nPuerto Baquerizo Moreno - Ecuador\nGuaranda - Ecuador\nAzogues - Ecuador\nSalinas - Ecuador\nAlausi - Ecuador\nSangolqui - Ecuador\nMuisne - Ecuador\nSan Gabriel - Ecuador\nMacara - Ecuador\nZamora - Ecuador\nLatacunga - Ecuador\nMilagro - Ecuador\nBabahoyo - Ecuador\nChone - Ecuador\nJipijapa - Ecuador\nYaupi - Ecuador\nMacas - Ecuador\nCayambe - Ecuador\nAmbato - Ecuador\nTena - Ecuador\nValdez - Ecuador\nSan Lorenzo - Ecuador\nEsmeraldas - Ecuador\nIbarra - Ecuador\nPortoviejo - Ecuador\nMachala - Ecuador\nLoja - Ecuador\nManta - Ecuador\nRiobamba - Ecuador\nCuenca - Ecuador\nSanta Cruz - Ecuador\nQuito - Ecuador\nGuayaquil - Ecuador\nShibin el Kom - Egypt\nBenha - Egypt\nZagazig - Egypt\nKafr el Sheikh - Egypt\nTanta - Egypt\nIsmailia - Egypt\nEl Mansura - Egypt\nDumyat - Egypt\nMatruh - Egypt\nEl Alamein - Egypt\nEl Daba - Egypt\nSalum - Egypt\nDamanhur - Egypt\nSamalut - Egypt\nMallawi - Egypt\nBeni Mazar - Egypt\nBeni Suef - Egypt\nRashid - Egypt\nQasr Farafra - Egypt\nEl Qasr - Egypt\nIsna - Egypt\nQena - Egypt\nGirga - Egypt\nSohag - Egypt\nBerenice - Egypt\nBur Safaga - Egypt\nEl Tur - Egypt\nEl Arish - Egypt\nEl Giza - Egypt\nSiwa - Egypt\nEl Minya - Egypt\nKom Ombo - Egypt\nEl Kharga - Egypt\nHurghada - Egypt\nSuez - Egypt\nBur Said - Egypt\nEl Faiyum - Egypt\nAswan - Egypt\nAsyut - Egypt\nLuxor - Egypt\nAlexandria - Egypt\nCairo - Egypt\nAhuachapan - El Salvador\nCojutepeque - El Salvador\nNueva San Salvador - El Salvador\nZacatecoluca - El Salvador\nLa Union - El Salvador\nSan Francisco Gotera - El Salvador\nSan Vicente - El Salvador\nUsulutan - El Salvador\nChalatenango - El Salvador\nSensuntepeque - El Salvador\nSonsonate - El Salvador\nSan Miguel - El Salvador\nSanta Ana - El Salvador\nSan Salvador - El Salvador\nEvinayong - Equatorial Guinea\nLuba - Equatorial Guinea\nCalatrava - Equatorial Guinea\nMongomo - Equatorial Guinea\nBata - Equatorial Guinea\nMalabo - Equatorial Guinea\nTessenei - Eritrea\nAgordat - Eritrea\nMassawa - Eritrea\nKeren - Eritrea\nMendefera - Eritrea\nAssab - Eritrea\nAsmara - Eritrea\nHaapsalu - Estonia\nViljandi - Estonia\nKohtla-Jarve - Estonia\nNarva - Estonia\nTartu - Estonia\nParnu - Estonia\nTallinn - Estonia\nAwasa - Ethiopia\nGore - Ethiopia\nDebre Birhan - Ethiopia\nBati - Ethiopia\nAdigrat - Ethiopia\nAksum - Ethiopia\nYirga Alem - Ethiopia\nHosaina - Ethiopia\nDila - Ethiopia\nGiyon - Ethiopia\nHagere Hiywet - Ethiopia\nNekemte - Ethiopia\nAsela - Ethiopia\nShashemene - Ethiopia\nDembi Dolo - Ethiopia\nGimbi - Ethiopia\nAsosa - Ethiopia\nJijiga - Ethiopia\nDebre Markos - Ethiopia\nDese - Ethiopia\nSodo - Ethiopia\nArba Minch - Ethiopia\nHarar - Ethiopia\nGoba - Ethiopia\nJima - Ethiopia\nNazret - Ethiopia\nNagele - Ethiopia\nGode - Ethiopia\nDolo Bay - Ethiopia\nBahir Dar - Ethiopia\nMekele - Ethiopia\nDire Dawa - Ethiopia\nGonder - Ethiopia\nAddis Ababa - Ethiopia\nFox Bay - Falkland Islands\nStanley - Falkland Islands\nKlaksvik - Faroe Islands\nTorshavn - Faroe Islands\nPalikir - Federated States of Micronesia\nNandi - Fiji\nLautoka - Fiji\nLabasa - Fiji\nSuva - Fiji\nHameenlinna - Finland\nKouvola - Finland\nMikkeli - Finland\nSavonlinna - Finland\nPori - Finland\nSodankyla - Finland\nJyvaskyla - Finland\nKuopio - Finland\nLappeenranta - Finland\nPorvoo - Finland\nKemijarvi - Finland\nKokkola - Finland\nLahti - Finland\nJoensuu - Finland\nTurku - Finland\nKemi - Finland\nOulu - Finland\nRovaniemi - Finland\nVaasa - Finland\nTampere - Finland\nHelsinki - Finland\nAnnecy - France\nRoanne - France\nRoura - France\nSinnamary - France\nSt.-Brieuc - France\nPoitier - France\nAngers - France\nBiarritz - France\nAix-en-Provence - France\nPerpignan - France\nTarbes - France\nClermont-Ferrand - France\nMelun - France\nArras - France\nBesancon - France\nSaint-Georges - France\nSaint-Etienne - France\nGrenoble - France\nFort-de-France - France\nSaint-Laurent-du-Maroni - France\nIracoubo - France\nCherbourg - France\nCaen - France\nLorient - France\nBrest - France\nLe Mans - France\nNantes - France\nAgen - France\nAjaccio - France\nBastia - France\nToulon - France\nBeziers - France\nMontpellier - France\nNimes - France\nVichy - France\nNevers - France\nAuxerre - France\nDijon - France\nBourges - France\nTours - France\nOrleans - France\nDieppe - France\nRouen - France\nVersailles - France\nBrive - France\nTroyes - France\nReims - France\nCalais - France\nAmiens - France\nMulhouse - France\nNancy - France\nMetz - France\nPointe-a-Pitre - France\nBasse-terre - France\nSt.-Benoit - France\nDzaoudzi - France\nRennes - France\nNice - France\nToulouse - France\nLimoges - France\nLille - France\nStrasbourg - France\nKourou - France\nLa Rochelle - France\nBordeaux - France\nMarseille - France\nLe Havre - France\nSt.-Denis - France\nLyon - France\nCayenne - France\nParis - France\nPapeete - French Polynesia\nEbebiyin - Gabon\nTchibanga - Gabon\nMekambo - Gabon\nMakokou - Gabon\nMitzik - Gabon\nBitam - Gabon\nLambarene - Gabon\nBifoum - Gabon\nNdende - Gabon\nMouila - Gabon\nOmboue - Gabon\nMoanda - Gabon\nOkandja - Gabon\nKoulamoutou - Gabon\nOyem - Gabon\nMayumba - Gabon\nGamba - Gabon\nFranceville - Gabon\nLibreville - Gabon\nPort-Gentil - Gabon\nKutaisi - Georgia\nTskhinvali - Georgia\nPoti - Georgia\nRustavi - Georgia\nBatumi - Georgia\nSukhumi - Georgia\nTbilisi - Georgia\nDusseldorf - Germany\nNuremberg - Germany\nAachen - Germany\nTrier - Germany\nWeimar - Germany\nBamberg - Germany\nDarmstadt - Germany\nBochum - Germany\nErlangen - Germany\nWolfsburg - Germany\nMunster - Germany\nMainz - Germany\nSchwerin - Germany\nBielefeld - Germany\nDortmund - Germany\nDuisburg - Germany\nWuppertal - Germany\nEssen - Germany\nKarlsruhe - Germany\nHeidelberg - Germany\nKassel - Germany\nOldenburg - Germany\nEmden - Germany\nBraunschweig - Germany\nErfurt - Germany\nCoburg - Germany\nAugsburg - Germany\nFurth - Germany\nChemnitz - Germany\nBonn - Germany\nUlm - Germany\nMannheim - Germany\nFreiburg im Breisgau - Germany\nGiessen - Germany\nWiesbaden - Germany\nBremerhaven - Germany\nOsnabruck - Germany\nHannover - Germany\nGottingen - Germany\nGera - Germany\nJena - Germany\nFlensburg - Germany\nLubeck - Germany\nKiel - Germany\nKoblenz - Germany\nSaarbrucken - Germany\nRegensburg - Germany\nRosenheim - Germany\nHof - Germany\nWurzburg - Germany\nIngolstadt - Germany\nCottbus - Germany\nPotsdam - Germany\nMagdeburg - Germany\nLeipzig - Germany\nStralsund - Germany\nRostock - Germany\nStuttgart - Germany\nBremen - Germany\nCologne - Germany\nDresden - Germany\nFrankfurt - Germany\nHamburg - Germany\nMunich - Germany\nBerlin - Germany\nSunyani - Ghana\nTamale - Ghana\nYendi - Ghana\nBolgatanga - Ghana\nBawku - Ghana\nWa - Ghana\nObuasi - Ghana\nBerekum - Ghana\nWinneba - Ghana\nCape Coast - Ghana\nNkawkaw - Ghana\nKoforidua - Ghana\nTema - Ghana\nHo - Ghana\nKumasi - Ghana\nSekondi - Ghana\nAccra - Ghana\nGibraltar - Gibraltar\nLamia - Greece\nPolygyros - Greece\nKomatini - Greece\nPiraeus - Greece\nVolos - Greece\nHania - Greece\nKavala - Greece\nAlexandroupoli - Greece\nKerkira - Greece\nTripoli - Greece\nSparti - Greece\nAgrinio - Greece\nPirgos - Greece\nLarissa - Greece\nIoanina - Greece\nMitilini - Greece\nHios - Greece\nChalkida - Greece\nSitia - Greece\nKaterini - Greece\nSeres - Greece\nXanthi - Greece\nErmoupoli - Greece\nKos - Greece\nRodos - Greece\nPatra - Greece\nKalamata - Greece\nIraklio - Greece\nThessaloniki - Greece\nAthens - Greece\nQasigiannguit - Greenland\nKullorsuaq - Greenland\nTasiusaq - Greenland\nKulusuk - Greenland\nPaamiut - Greenland\nIttoqqortoormiit - Greenland\nTimmiarmiut - Greenland\nQaqortoq - Greenland\nKangerlussuaq - Greenland\nNord - Greenland\nQeqertasuaq - Greenland\nNuussuaq - Greenland\nIlulissat - Greenland\nTasiilaq - Greenland\nSavissivik - Greenland\nKangersuatsiaq - Greenland\nUummannaq - Greenland\nNarsarsuaq - Greenland\nSisimiut - Greenland\nUpernavik - Greenland\nQaanaaq - Greenland\nNuuk - Greenland\nSaint George\'s - Grenada\nAgana - Guam\nSalama - Guatemala\nRetalhuleu - Guatemala\nSan Marcos - Guatemala\nChimaltenango - Guatemala\nAntigua Guatemala - Guatemala\nSolola - Guatemala\nTotonicapan - Guatemala\nEl Progreso - Guatemala\nCuilapa - Guatemala\nChiquimula - Guatemala\nJalapa - Guatemala\nZacapa - Guatemala\nSanta Cruz Del Quiche - Guatemala\nSan Luis - Guatemala\nCoban - Guatemala\nLivingston - Guatemala\nJutiapa - Guatemala\nHuehuetenango - Guatemala\nFlores - Guatemala\nLa Libertad - Guatemala\nSan Jose - Guatemala\nEscuintla - Guatemala\nMazatenango - Guatemala\nPuerto Barrios - Guatemala\nQuetzaltenango - Guatemala\nGuatemala - Guatemala\nMali - Guinea\nTongue - Guinea\nKouroussa - Guinea\nPita - Guinea\nDalaba - Guinea\nBoffa - Guinea\nKoundara - Guinea\nGaoual - Guinea\nTelimele - Guinea\nForecariah - Guinea\nBeyla - Guinea\nGueckedou - Guinea\nDinguiraye - Guinea\nDabola - Guinea\nKerouane - Guinea\nSiguiri - Guinea\nMamou - Guinea\nKamsar - Guinea\nFria - Guinea\nMacenta - Guinea\nYomou - Guinea\nFaranah - Guinea\nKissidougou - Guinea\nLabe - Guinea\nBoke - Guinea\nKindia - Guinea\nKankan - Guinea\nNzerekore - Guinea\nConakry - Guinea\nCacheu - Guinea Bissau\nFarim - Guinea Bissau\nFulacunda - Guinea Bissau\nGabu - Guinea Bissau\nCatio - Guinea Bissau\nBolama - Guinea Bissau\nBafata - Guinea Bissau\nBissau - Guinea Bissau\nCorriverton - Guyana\nItuni - Guyana\nLethem - Guyana\nKumaka - Guyana\nBartica - Guyana\nAnna Regina - Guyana\nLinden - Guyana\nMabaruma - Guyana\nNew Amsterdam - Guyana\nGeorgetown - Guyana\nJeremie - Haiti\nPort-De-Paix - Haiti\nHinche - Haiti\nFort-Liberte - Haiti\nJacmel - Haiti\nLes Cayes - Haiti\nGonaives - Haiti\nCap-Haitien - Haiti\nPort-au-Prince - Haiti\nYoro - Honduras\nLa Esperanza - Honduras\nLa Paz - Honduras\nSanta Barbara - Honduras\nGracias - Honduras\nNueva Ocotepeque - Honduras\nYuscaran - Honduras\nRoatan - Honduras\nNacaome - Honduras\nSanta Rosa de Copan - Honduras\nTrujillo - Honduras\nBrus Laguna - Honduras\nPuerto Lempira - Honduras\nJuticalpa - Honduras\nComayagua - Honduras\nCholuteca - Honduras\nLa Ceiba - Honduras\nSan Pedro Sula - Honduras\nTegucigalpa - Honduras\nHong Kong - Hong Kong S.A.R.\nKowloon - Hong Kong S.A.R.\nTsuen Wan - Hong Kong S.A.R.\nYuen Long Kau Hui - Hong Kong S.A.R.\nVictoria - Hong Kong S.A.R.\nVeszprem - Hungary\nZalaegerszeg - Hungary\nTatabanya - Hungary\nSzekszard - Hungary\nSalgotarjan - Hungary\nBekescsaba - Hungary\nEger - Hungary\nSzombathely - Hungary\nKecskemet - Hungary\nSzekesfehervar - Hungary\nNyiregyhaza - Hungary\nPecs - Hungary\nGyor - Hungary\nKaposvar - Hungary\nVac - Hungary\nMiskolc - Hungary\nSzeged - Hungary\nDebrecen - Hungary\nSzolnok - Hungary\nBudapest - Hungary\nBorgarnes - Iceland\nEgilsstadir - Iceland\nSaudarkrokur - Iceland\nSelfoss - Iceland\nHofn - Iceland\nIsafjardarbaer - Iceland\nAkureyi - Iceland\nKeflavik - Iceland\nReykjavik - Iceland\nPanaji - India\nSimla - India\nGurgaon - India\nSonipat - India\nRohtak - India\nHisar - India\nBhiwani - India\nAmbala - India\nSopore - India\nSilvassa - India\nKalyan - India\nBhusawal - India\nJorhat - India\nHoshiarpur - India\nAjmer - India\nHathras - India\nSitapur - India\nPilibhit - India\nBudaun - India\nFirozabad - India\nMathura - India\nBulandshahr - India\nHapur - India\nMuzaffarnagar - India\nGangtok - India\nDiu - India\nPathankot - India\nSirsa - India\nPanipat - India\nKarnal - India\nBaramula - India\nProddatur - India\nNandyal - India\nHindupur - India\nTirupati - India\nOngole - India\nVizianagaram - India\nRajahmundry - India\nMachilipatnam - India\nKhammam - India\nChirala - India\nKarimnagar - India\nNizamabad - India\nKollam - India\nAlappuzha - India\nPuri - India\nSambalpur - India\nRaurkela - India\nKavaratti - India\nMandya - India\nKolar - India\nShimoga - India\nRaichur - India\nHospet - India\nBidar - India\nSangli - India\nParbhani - India\nMalegaon - India\nPort Blair - India\nTezpur - India\nSilchar - India\nKohima - India\nShillong - India\nAbohar - India\nPatiala - India\nBhilwara - India\nPali - India\nTonk - India\nSikar - India\nBikaner - India\nBharatpur - India\nAlwar - India\nFatehpur - India\nFaizabad - India\nBahraich - India\nMirzapur - India\nJhansi - India\nShahjahanpur - India\nRampur - India\nBareilly - India\nEtawah - India\nDehra Dun - India\nHaora - India\nAlipur Duar - India\nHaldia - India\nBhatpara - India\nMedinipur - India\nSiliguri - India\nPurnia - India\nMuzaffarpur - India\nBilaspur - India\nBurhanpur - India\nUjjain - India\nRatlam - India\nSagar - India\nVellore - India\nTiruvannamalai - India\nRajapalaiyam - India\nCuddalore - India\nKarur - India\nKanchipuram - India\nTirunelveli - India\nNagercoil - India\nThanjavur - India\nKumbakonam - India\nValparai - India\nTiruppur - India\nDaman - India\nNavsari - India\nBhuj - India\nBhavnagar - India\nGandhinagar - India\nItanagar - India\nAizawl - India\nAgartala - India\nKakinada - India\nWarangal - India\nBrahmapur - India\nBijapur - India\nBhiwandi - India\nLatur - India\nAhmednagar - India\nChandrapur - India\nAmravati - India\nDhule - India\nDibrugarh - India\nImphal - India\nUdaipur - India\nGorakhpur - India\nBarddhaman - India\nKrishnanagar - India\nGaya - India\nPorbandar - India\nNellore - India\nKurnool - India\nGuntur - India\nTumkur - India\nDavangere - India\nBellary - India\nBelgaum - India\nTuticorin - India\nDindigul - India\nChandigarh - India\nJammu - India\nSholapur - India\nAurangabad - India\nNasik - India\nDispur - India\nJullundur - India\nAllahabad - India\nMoradabad - India\nGhaziabad - India\nAgra - India\nAligarh - India\nMeerut - India\nDhanbad - India\nGwalior - India\nVadodara - India\nRajkot - India\nFaridabad - India\nSrinagar - India\nVijayawada - India\nThiruvananthapuram - India\nKochi - India\nCuttack - India\nHubli - India\nMangalore - India\nMysore - India\nGulbarga - India\nKolhapur - India\nNanded - India\nAkola - India\nGuwahati - India\nLudhiana - India\nKota - India\nJodhpur - India\nLucknow - India\nSaharanpur - India\nRanchi - India\nBhagalpur - India\nRaipur - India\nJabalpur - India\nIndore - India\nPondicherry - India\nSalem - India\nTiruchirappalli - India\nKozhikode - India\nBhubaneshwar - India\nJamshedpur - India\nVishakhapatnam - India\nAmritsar - India\nVaranasi - India\nAsansol - India\nBhilai - India\nBhopal - India\nMadurai - India\nCoimbatore - India\nDelhi - India\nHyderabad - India\nPune - India\nNagpur - India\nJaipur - India\nKanpur - India\nPatna - India\nChennai - India\nAhmedabad - India\nSurat - India\nNew Delhi - India\nBangalore - India\nMumbai - India\nKolkata - India\nBali - Indonesia\nBinjai - Indonesia\nPadangsidempuan - Indonesia\nTarutung - Indonesia\nTebingtinggi - Indonesia\nTidore - Indonesia\nBukittinggi - Indonesia\nSawahlunto - Indonesia\nPadangpanjang - Indonesia\nAmahai - Indonesia\nMataram - Indonesia\nPraya - Indonesia\nBaubau - Indonesia\nLuwuk - Indonesia\nPoso - Indonesia\nBiak - Indonesia\nTimika - Indonesia\nLangsa - Indonesia\nIndramayu - Indonesia\nSukabumi - Indonesia\nCilacap - Indonesia\nPati - Indonesia\nPakalongan - Indonesia\nTegal - Indonesia\nSalatiga - Indonesia\nMagelang - Indonesia\nSerang - Indonesia\nBekasi - Indonesia\nSingkawang - Indonesia\nBandar Lampung - Indonesia\nPerabumulih - Indonesia\nKuta - Indonesia\nSingaraja - Indonesia\nSumenep - Indonesia\nBanyuwangi - Indonesia\nTuban - Indonesia\nProbolinggo - Indonesia\nPasuruan - Indonesia\nMojokerto - Indonesia\nMadiun - Indonesia\nKediri - Indonesia\nBlitar - Indonesia\nWaingapu - Indonesia\nMaumere - Indonesia\nEnde - Indonesia\nMakale - Indonesia\nPalopo - Indonesia\nWatampone - Indonesia\nPinrang - Indonesia\nMajene - Indonesia\nTanjungpinang - Indonesia\nTelukbutun - Indonesia\nSungaipenuh - Indonesia\nSampit - Indonesia\nKualakapuas - Indonesia\nPalangkaraya - Indonesia\nBontang - Indonesia\nDenpasar - Indonesia\nSorong - Indonesia\nSibolga - Indonesia\nPematangsiantar - Indonesia\nPekanbaru - Indonesia\nManado - Indonesia\nYogyakarta - Indonesia\nKendari - Indonesia\nPalu - Indonesia\nNabire - Indonesia\nMerauke - Indonesia\nLhokseumawe - Indonesia\nSamarinda - Indonesia\nCirebon - Indonesia\nTasikmalaya - Indonesia\nBogor - Indonesia\nBengkulu - Indonesia\nPontianak - Indonesia\nKotabumi - Indonesia\nLahat - Indonesia\nPangkalpinang - Indonesia\nJember - Indonesia\nMartapura - Indonesia\nRuteng - Indonesia\nJambi - Indonesia\nManokwari - Indonesia\nTernate - Indonesia\nAmbon - Indonesia\nRaba - Indonesia\nJayapura - Indonesia\nBanda Aceh - Indonesia\nBalikpapan - Indonesia\nSurakarta - Indonesia\nTanjungpandan - Indonesia\nMalang - Indonesia\nKupang - Indonesia\nParepare - Indonesia\nGorontalo - Indonesia\nPadang - Indonesia\nTarakan - Indonesia\nSemarang - Indonesia\nPalembang - Indonesia\nBandjarmasin - Indonesia\nUjungpandang - Indonesia\nMedan - Indonesia\nBandung - Indonesia\nSurabaya - Indonesia\nJakarta - Indonesia\nYasuj - Iran\nShar e Kord - Iran\nMarv Dasht - Iran\nShahrud - Iran\nVaramin - Iran\nMasjed Soleyman - Iran\nBorujerd - Iran\nMalayer - Iran\nZanjan - Iran\nUrmia - Iran\nAhar - Iran\nSanandaj - Iran\nNeyshabur - Iran\nBojnurd - Iran\nSirjan - Iran\nQomsheh - Iran\nKashan - Iran\nKhomeini Shahr - Iran\nFasa - Iran\nGonbad-e Kavus - Iran\nGorgan - Iran\nAmol - Iran\nSari - Iran\nSemnan - Iran\nKaraj - Iran\nBehbehan - Iran\nDezful - Iran\nKhorramabad - Iran\nIlam - Iran\nSaveh - Iran\nArak - Iran\nMahabad - Iran\nKhvoy - Iran\nMaragheh - Iran\nQasr-e Shirin - Iran\nBijar - Iran\nYazdan - Iran\nTorbat-e Jam - Iran\nQuchan - Iran\nChabahar - Iran\nKashmar - Iran\nBam - Iran\nKerman - Iran\nBandar-e Bushehr - Iran\nAbadan - Iran\nArdabil - Iran\nQom - Iran\nQazvin - Iran\nKermanshah - Iran\nRasht - Iran\nBirjand - Iran\nSabzewar - Iran\nZabol - Iran\nZahedan - Iran\nYazd - Iran\nAhvaz - Iran\nBandar-e-Abbas - Iran\nHamadan - Iran\nTabriz - Iran\nIsfahan - Iran\nShiraz - Iran\nMashhad - Iran\nTehran - Iran\nDahuk - Iraq\nSamarra - Iraq\nAz Aubayr - Iraq\nAd Diwaniyah - Iraq\nAsh Shatrah - Iraq\nMandali - Iraq\nAr Ramadi - Iraq\nAl Musayyib - Iraq\nZakho - Iraq\nTall Afar - Iraq\nTikrit - Iraq\nKarbala - Iraq\nAs Samawah - Iraq\nAn Nasiriyah - Iraq\nAl Amarah - Iraq\nAl Kut - Iraq\nAs Sulaymaniyah - Iraq\nBaqubah - Iraq\nAr Rutbah - Iraq\nAl Fallujah - Iraq\nAl Hillah - Iraq\nIrbil - Iraq\nKirkuk - Iraq\nMosul - Iraq\nAn Najaf - Iraq\nBasra - Iraq\nBaghdad - Iraq\nRos Comain - Ireland\nMuineachan - Ireland\nShannon - Ireland\nWaterford - Ireland\nTralee - Ireland\nDonegal - Ireland\nDrogheda - Ireland\nDundalk - Ireland\nGalway - Ireland\nKilkenny - Ireland\nKillarney - Ireland\nSligo - Ireland\nCork - Ireland\nLimerick - Ireland\nDublin - Ireland\nDouglas - Isle of Man\nRamla - Israel\nBeer Sheva - Israel\nHaifa - Israel\nNazareth - Israel\nJerusalem - Israel\nTel Aviv-Yafo - Israel\nPotenza - Italy\nCampobasso - Italy\nAosta - Italy\nModena - Italy\nCrotone - Italy\nVibo Valentia - Italy\nReggio di Calabria - Italy\nCaserta - Italy\nBarletta - Italy\nRagusa - Italy\nAsti - Italy\nNovara - Italy\nComo - Italy\nUdine - Italy\nTreviso - Italy\nParma - Italy\nRavenna - Italy\nFerrara - Italy\nBologna - Italy\nOlbia - Italy\nCagliari - Italy\nPisa - Italy\nLivorno - Italy\nSiena - Italy\nArezzo - Italy\nCatanzaro - Italy\nSalerno - Italy\nBenevento - Italy\nBari - Italy\nFoggia - Italy\nLecce - Italy\nBrindisi - Italy\nTaranto - Italy\nMessina - Italy\nMarsala - Italy\nSiracusa - Italy\nPescara - Italy\nL\'Aquila - Italy\nCivitavecchia - Italy\nAncona - Italy\nPerugia - Italy\nBergamo - Italy\nTrieste - Italy\nBolzano - Italy\nTrento - Italy\nVerona - Italy\nSassari - Italy\nTurin - Italy\nGenoa - Italy\nFlorence - Italy\nCatania - Italy\nVenice - Italy\nPalermo - Italy\nNaples - Italy\nMilan - Italy\nRome - Italy\nTouba - Ivory Coast\nBouafle - Ivory Coast\nDivo - Ivory Coast\nToumodi - Ivory Coast\nAboisso - Ivory Coast\nFerkessedougou - Ivory Coast\nOdienne - Ivory Coast\nMan - Ivory Coast\nSeguela - Ivory Coast\nGagnoa - Ivory Coast\nSoubre - Ivory Coast\nSan-Pedro - Ivory Coast\nSassandra - Ivory Coast\nBondoukou - Ivory Coast\nAgboville - Ivory Coast\nDimbokro - Ivory Coast\nGrand Bassam - Ivory Coast\nDabou - Ivory Coast\nGuiglo - Ivory Coast\nAbengourou - Ivory Coast\nKorhogo - Ivory Coast\nDaloa - Ivory Coast\nBouake - Ivory Coast\nYamoussoukro - Ivory Coast\nAbidjan - Ivory Coast\nLucea - Jamaica\nMandeville - Jamaica\nBlack River - Jamaica\nFalmouth - Jamaica\nSavanna-la-Mar - Jamaica\nPort Antonio - Jamaica\nSt. Ann\'s Bay - Jamaica\nPort Maria - Jamaica\nHalf Way Tree - Jamaica\nPort Morant - Jamaica\nMay Pen - Jamaica\nSpanish Town - Jamaica\nMontego Bay - Jamaica\nKingston - Jamaica\nOkayama - Japan\nShimonoseki - Japan\nKanoya - Japan\nTakamatsu - Japan\nTokushima - Japan\nToyama - Japan\nTakaoka - Japan\nOtsu - Japan\nMaebashi - Japan\nKawasaki - Japan\nKawagoe - Japan\nUtsunomiya - Japan\nHachioji - Japan\nKoriyama - Japan\nKure - Japan\nMatsue - Japan\nTottori - Japan\nSasebo - Japan\nKitakyushu - Japan\nKumamoto - Japan\nOita - Japan\nGifu - Japan\nTsu - Japan\nMatsumoto - Japan\nShizuoka - Japan\nHamamatsu - Japan\nObihiro - Japan\nTomakomai - Japan\nKitami - Japan\nOtaru - Japan\nFukui - Japan\nMaizuru - Japan\nWakayama - Japan\nMito - Japan\nKofu - Japan\nIwaki - Japan\nNagaoka - Japan\nYamagata - Japan\nTsuruoka - Japan\nKagoshima - Japan\nMatsuyama - Japan\nKanazawa - Japan\nMuroran - Japan\nAsahikawa - Japan\nKobe - Japan\nYokohama - Japan\nAkita - Japan\nAomori - Japan\nHirosaki - Japan\nHachinohe - Japan\nFukushima - Japan\nMorioka - Japan\nNiigata - Japan\nFukuoka - Japan\nMiyazaki - Japan\nNaha - Japan\nKochi - Japan\nNagoya - Japan\nNagano - Japan\nKushiro - Japan\nHakodate - Japan\nKyoto - Japan\nSendai - Japan\nSakata - Japan\nNagasaki - Japan\nHiroshima - Japan\nSapporo - Japan\nOsaka - Japan\nTokyo - Japan\nAl Mafraq - Jordan\nAt Tafilah - Jordan\nMa\'an - Jordan\nIrbid - Jordan\nAs Salt - Jordan\nAz Zarqa - Jordan\nAl Aqabah - Jordan\nAl Karak - Jordan\nAmman - Jordan\nTurgay - Kazakhstan\nMangyshlak - Kazakhstan\nMaqat - Kazakhstan\nBestobe - Kazakhstan\nOsakarovka - Kazakhstan\nAqadyr - Kazakhstan\nSharbaqty - Kazakhstan\nShemonaikha - Kazakhstan\nSerebryansk - Kazakhstan\nBoralday - Kazakhstan\nZharkent - Kazakhstan\nEsik - Kazakhstan\nLenger - Kazakhstan\nKentau - Kazakhstan\nZhosaly - Kazakhstan\nOktyabrsk - Kazakhstan\nAlgha - Kazakhstan\nBayghanin - Kazakhstan\nEmbi - Kazakhstan\nZhetiqara - Kazakhstan\nKomsomolets - Kazakhstan\nTobol - Kazakhstan\nQusmuryn - Kazakhstan\nShieli - Kazakhstan\nMakhambet - Kazakhstan\nChapaev - Kazakhstan\nZhanibek - Kazakhstan\nAqsay - Kazakhstan\nEsil - Kazakhstan\nDerzhavinsk - Kazakhstan\nZhaltyr - Kazakhstan\nMakinsk - Kazakhstan\nAqsu - Kazakhstan\nZholymbet - Kazakhstan\nErymentau - Kazakhstan\nSaryshaghan - Kazakhstan\nQarazhal - Kazakhstan\nAtasu - Kazakhstan\nKishkenekol - Kazakhstan\nTayynsha - Kazakhstan\nBulaevo - Kazakhstan\nErtis - Kazakhstan\nKachiry - Kazakhstan\nZaysan - Kazakhstan\nZyryanovsk - Kazakhstan\nRidder - Kazakhstan\nShar - Kazakhstan\nUrzhar - Kazakhstan\nSarqan - Kazakhstan\nUshtobe - Kazakhstan\nShonzhy - Kazakhstan\nQapshaghay - Kazakhstan\nOtar - Kazakhstan\nFort Shevchenko - Kazakhstan\nZhangaozen - Kazakhstan\nArys - Kazakhstan\nBurylbaytal - Kazakhstan\nShu - Kazakhstan\nQulan - Kazakhstan\nOytal - Kazakhstan\nQaratau - Kazakhstan\nKhromtau - Kazakhstan\nArqalyq - Kazakhstan\nOostanay - Kazakhstan\nBaykonur - Kazakhstan\nBalyqshy - Kazakhstan\nAtbasar - Kazakhstan\nKokshetau - Kazakhstan\nTemirtau - Kazakhstan\nZhezqazghan - Kazakhstan\nQarqaraly - Kazakhstan\nBalqash - Kazakhstan\nPetropavlovsk - Kazakhstan\nAyakoz - Kazakhstan\nTaldyqorghan - Kazakhstan\nTurkistan - Kazakhstan\nShalqar - Kazakhstan\nQazaly - Kazakhstan\nAral - Kazakhstan\nQulsary - Kazakhstan\nOral - Kazakhstan\nBeyneu - Kazakhstan\nAqtau - Kazakhstan\nAqtobe - Kazakhstan\nRudny - Kazakhstan\nQyzylorda - Kazakhstan\nAtyrau - Kazakhstan\nEkibastuz - Kazakhstan\nPavlodar - Kazakhstan\nSemey - Kazakhstan\nOskemen - Kazakhstan\nShymkent - Kazakhstan\nTaraz - Kazakhstan\nAstana - Kazakhstan\nQaraghandy - Kazakhstan\nAlmaty - Kazakhstan\nNyeri - Kenya\nMwingi - Kenya\nEmbu - Kenya\nMachakos - Kenya\nNanyuki - Kenya\nMaralal - Kenya\nKonza - Kenya\nLodwar - Kenya\nEldama Ravine - Kenya\nSotik - Kenya\nNamanga - Kenya\nNaivasha - Kenya\nKericho - Kenya\nKitale - Kenya\nBungoma - Kenya\nKakamega - Kenya\nWajir - Kenya\nGarissa - Kenya\nWitu - Kenya\nTsavo - Kenya\nVoi - Kenya\nKilifi - Kenya\nThika - Kenya\nKendu Bay - Kenya\nKarungu - Kenya\nKisii - Kenya\nMarsabit - Kenya\nMoyale - Kenya\nNakuru - Kenya\nLamu - Kenya\nMalindi - Kenya\nKisumu - Kenya\nMeru - Kenya\nEldoret - Kenya\nMombasa - Kenya\nNairobi - Kenya\nTarawa - Kiribati\nPrizren - Kosovo\nPec - Kosovo\nPristina - Kosovo\nHawalli - Kuwait\nAl Ahmadi - Kuwait\nAl Jahra - Kuwait\nKuwait - Kuwait\nTokmak - Kyrgyzstan\nKara Balta - Kyrgyzstan\nCholpon Ata - Kyrgyzstan\nNaryn - Kyrgyzstan\nKok Yangak - Kyrgyzstan\nBalykchy - Kyrgyzstan\nAt Bashy - Kyrgyzstan\nJalal Abad - Kyrgyzstan\nToktogul - Kyrgyzstan\nTash Komur - Kyrgyzstan\nTalas - Kyrgyzstan\nOsh - Kyrgyzstan\nKarakol - Kyrgyzstan\nBishkek - Kyrgyzstan\nBan Houayxay - Laos\nLouang Namtha - Laos\nChampasak - Laos\nSaravan - Laos\nXam Nua - Laos\nPhongsali - Laos\nAttapu - Laos\nXaignabouri - Laos\nPakxe - Laos\nXiangkhoang - Laos\nLouangphrabang - Laos\nThakhek - Laos\nSavannakhet - Laos\nVientiane - Laos\nRezekne - Latvia\nVentspils - Latvia\nJelgava - Latvia\nLiepaga - Latvia\nDaugavpils - Latvia\nRiga - Latvia\nB\'abda - Lebanon\nNabatiye et Tahta - Lebanon\nSaida - Lebanon\nZahle - Lebanon\nTrablous - Lebanon\nBeirut - Lebanon\nTeyateyaneng - Lesotho\nMohales Hoek - Lesotho\nMoyeni - Lesotho\nHlotse - Lesotho\nButha-Buthe - Lesotho\nMokhotlong - Lesotho\nMafetang - Lesotho\nMaseru - Lesotho\nBarclayville - Liberia\nVoinjama - Liberia\nBensonville - Liberia\nKakata - Liberia\nSanniquellie - Liberia\nRivercess - Liberia\nHarper - Liberia\nGbarnga - Liberia\nZwedru - Liberia\nGreenville - Liberia\nBuchanan - Liberia\nRobertsport - Liberia\nMonrovia - Liberia\nDirj - Libya\nNalut - Libya\nZillah - Libya\nAl Khums - Libya\nTajarhi - Libya\nUmm al Abid - Libya\nAz Zawiyah - Libya\nGharyan - Libya\nMizdah - Libya\nBani Walid - Libya\nAl Marj - Libya\nAl Bayda - Libya\nShahhat - Libya\nEl Agheila - Libya\nMaradah - Libya\nQaminis - Libya\nAs Sidr - Libya\nAl Jaghbub - Libya\nGhadamis - Libya\nHun - Libya\nBirak - Libya\nGhat - Libya\nMarzuq - Libya\nAjdabiya - Libya\nAwjilah - Libya\nSurt - Libya\nDarnah - Libya\nTubruq - Libya\nAl Jawf - Libya\nTmassah - Libya\nMisratah - Libya\nZuwarah - Libya\nSabha - Libya\nBanghazi - Libya\nTripoli - Libya\nVaduz - Liechtenstein\nPanevezys - Lithuania\nSiauliai - Lithuania\nKlaipeda - Lithuania\nKaunas - Lithuania\nVilnius - Lithuania\nLuxembourg City - Luxembourg\nDiekirch - Luxembourg\nGrevenmacher - Luxembourg\nLuxembourg - Luxembourg\nMacau - Macau S.A.R\nTetovo - Macedonia\nBitola - Macedonia\nSkopje - Macedonia\nSambava - Madagascar\nAmbanja - Madagascar\nIhosy - Madagascar\nMandritsara - Madagascar\nBesalampy - Madagascar\nMarovoay - Madagascar\nAntsohihy - Madagascar\nAmbatondrazaka - Madagascar\nBekiy - Madagascar\nManja - Madagascar\nMiandrivazo - Madagascar\nAntsirabe - Madagascar\nAntalaha - Madagascar\nAndoany - Madagascar\nFarafangana - Madagascar\nMananjary - Madagascar\nMaintirano - Madagascar\nToamasina - Madagascar\nMaroantsetra - Madagascar\nTolanaro - Madagascar\nMorombe - Madagascar\nAndroka - Madagascar\nMorondava - Madagascar\nAntsiranana - Madagascar\nFianarantsoa - Madagascar\nMahajanga - Madagascar\nToliara - Madagascar\nAntananarivo - Madagascar\nMzimba - Malawi\nMachinga - Malawi\nDedza - Malawi\nMchinji - Malawi\nNtcheu - Malawi\nChiradzulu - Malawi\nNsanje - Malawi\nMwanza - Malawi\nMulanje - Malawi\nKaronga - Malawi\nChitipa - Malawi\nNkhata Bay - Malawi\nNkhotakota - Malawi\nMangochi - Malawi\nSalima - Malawi\nChiromo - Malawi\nZomba - Malawi\nMzuzu - Malawi\nBlantyre - Malawi\nLilongwe - Malawi\nKangar - Malaysia\nKuala Lipis - Malaysia\nShah Alam - Malaysia\nTeluk Intan - Malaysia\nButterworth - Malaysia\nSungai Petani - Malaysia\nAlor Setar - Malaysia\nMuar - Malaysia\nBatu Pahat - Malaysia\nKeluang - Malaysia\nSeremban - Malaysia\nRaub - Malaysia\nChukai - Malaysia\nKuala Terengganu - Malaysia\nLahad Datu - Malaysia\nBintulu - Malaysia\nMiri - Malaysia\nJohor Bahru - Malaysia\nKelang - Malaysia\nTaiping - Malaysia\nIpoh - Malaysia\nKota Baharu - Malaysia\nMalacca - Malaysia\nKuantan - Malaysia\nTawau - Malaysia\nSandakan - Malaysia\nKota Kinabalu - Malaysia\nSibu - Malaysia\nGeorge Town - Malaysia\nKuching - Malaysia\nPutrajaya - Malaysia\nKuala Lumpur - Malaysia\nMale - Maldives\nGoundam - Mali\nAguelhok - Mali\nBourem - Mali\nKati - Mali\nBanamba - Mali\nKangaba - Mali\nNioro du Sahel - Mali\nBafoulabe - Mali\nSatadougou - Mali\nYelimane - Mali\nKita - Mali\nKoutiala - Mali\nSikasso - Mali\nBougouni - Mali\nMarkala - Mali\nSokolo - Mali\nSan - Mali\nTaoudenni - Mali\nAraouane - Mali\nTessalit - Mali\nMenaka - Mali\nNara - Mali\nKoulikoro - Mali\nMopti - Mali\nGao - Mali\nKayes - Mali\nSegou - Mali\nTimbuktu - Mali\nBamako - Mali\nDjenne - Mali\nValletta - Malta\nMajuro - Marshall Islands\nFderik - Mauritania\nAleg - Mauritania\nAkjoujt - Mauritania\nZouirat - Mauritania\nChegga - Mauritania\nMagta Lajar - Mauritania\nBogue - Mauritania\nBoutilimit - Mauritania\nSelibaby - Mauritania\nTimbedra - Mauritania\nNema - Mauritania\nSaint-Louis - Mauritania\nTidjikdja - Mauritania\nBir Mogrein - Mauritania\nRosso - Mauritania\nKiffa - Mauritania\nNouadhibou - Mauritania\nAyoun el Atrous - Mauritania\nNouakchott - Mauritania\nAtar - Mauritania\nCurepipe - Mauritius\nPort Louis - Mauritius\nVicente Guerrero - Mexico\nLoreto - Mexico\nCiudad Constitucion - Mexico\nAllende - Mexico\nNueva Rosita - Mexico\nHidalgo del Parral - Mexico\nAscension - Mexico\nGomez Palacio - Mexico\nCanatlan - Mexico\nVilla Union - Mexico\nAltata - Mexico\nEsperanza - Mexico\nMagdalena - Mexico\nNacozari Viejo - Mexico\nVillanueva - Mexico\nMontemorelos - Mexico\nSabinas Hidalgo - Mexico\nCardenas - Mexico\nCiudad Valles - Mexico\nRio Verde - Mexico\nCiudad Mante - Mexico\nReynosa - Mexico\nCiudad Madero - Mexico\nAutlan - Mexico\nCiudad Hidalgo - Mexico\nApatzingan - Mexico\nSantiago Ixcuintla - Mexico\nJuchitan - Mexico\nMiahuatlan - Mexico\nAtlixco - Mexico\nAcatlan - Mexico\nParaiso - Mexico\nBalancan - Mexico\nTlaxcala - Mexico\nIrapuato - Mexico\nCelaya - Mexico\nChilpancingo - Mexico\nIguala - Mexico\nTecpan - Mexico\nAtoyac - Mexico\nNezahualcoyotl - Mexico\nSan Juan del Rio - Mexico\nJaltipan - Mexico\nOrizaba - Mexico\nXalapa - Mexico\nNautla - Mexico\nSan Cristobal de Las Casas - Mexico\nEscuintla - Mexico\nMotul - Mexico\nTekax - Mexico\nPeto - Mexico\nHalacho - Mexico\nSan Quintin - Mexico\nPunta Prieta - Mexico\nSan Felipe - Mexico\nSanta Rosalia - Mexico\nGuerrero Negro - Mexico\nPiedras Negras - Mexico\nSan Pedro de las Colonias - Mexico\nSierra Mojada - Mexico\nParras - Mexico\nCuauhtemoc - Mexico\nNuevo Casas Grandes - Mexico\nOjinaga - Mexico\nVilla Ahumada - Mexico\nSanta Barbara - Mexico\nCiudad Camargo - Mexico\nCuencame - Mexico\nPapasquiaro - Mexico\nEscuinapa - Mexico\nGuamuchil - Mexico\nGuasave - Mexico\nEl Fuerte - Mexico\nEldorado - Mexico\nLa Cruz - Mexico\nAgua Prieta - Mexico\nCiudad Obregon - Mexico\nNavajoa - Mexico\nCaborca - Mexico\nCananea - Mexico\nHuatabampo - Mexico\nZacatecas - Mexico\nJuan Aldama - Mexico\nValparaiso - Mexico\nFresnillo - Mexico\nLinares - Mexico\nMatehuala - Mexico\nTamuin - Mexico\nTamazunchale - Mexico\nTula - Mexico\nAldama - Mexico\nSan Fernando - Mexico\nTecoman - Mexico\nPuerto Vallarta - Mexico\nLa Barca - Mexico\nCiudad Guzman - Mexico\nLagos de Moreno - Mexico\nMorelia - Mexico\nLazaro Cardenas - Mexico\nZamora - Mexico\nCoalcoman - Mexico\nUruapan - Mexico\nTuxpan - Mexico\nTepic - Mexico\nCompostela - Mexico\nTecuala - Mexico\nCiudad del Carmen - Mexico\nChampoton - Mexico\nSalina Cruz - Mexico\nPuerto Escondido - Mexico\nPochutla - Mexico\nMitla - Mexico\nTlaxiaco - Mexico\nHuajuapan de Leon - Mexico\nTehuacan - Mexico\nTeziutlan - Mexico\nFrontera - Mexico\nTenosique - Mexico\nSalamanca - Mexico\nGuanajuato - Mexico\nTaxco - Mexico\nAyutla - Mexico\nCiudad Altamirano - Mexico\nPetatlan - Mexico\nPachuca - Mexico\nToluca - Mexico\nZumpango - Mexico\nMinatitlan - Mexico\nCoatzacoalcos - Mexico\nPoza Rica de Hidalgo - Mexico\nCordoba - Mexico\nSantiago Tuxtla - Mexico\nTuxpam - Mexico\nPanuco - Mexico\nPijijiapan - Mexico\nIsla Mujeres - Mexico\nFelipe Carrillo Puerto - Mexico\nTizimin - Mexico\nValladolid - Mexico\nIzamal - Mexico\nTicul - Mexico\nEnsenada - Mexico\nSaltillo - Mexico\nCiudad Juarez - Mexico\nDelicias - Mexico\nDurango - Mexico\nLos Mochis - Mexico\nCiudad Victoria - Mexico\nAguascalientes - Mexico\nManzanillo - Mexico\nTehuantepec - Mexico\nVillahermosa - Mexico\nCuernavaca - Mexico\nQueretaro - Mexico\nTapachula - Mexico\nChetumal - Mexico\nProgreso - Mexico\nCabo San Lucas - Mexico\nMonclova - Mexico\nOmetepec - Mexico\nCozumel - Mexico\nMexicali - Mexico\nLa Paz - Mexico\nTorreon - Mexico\nCuliacan - Mexico\nNogales - Mexico\nHermosillo - Mexico\nGuaymas - Mexico\nSan Luis Potosi - Mexico\nMatamoros - Mexico\nNuevo Laredo - Mexico\nColima - Mexico\nCampeche - Mexico\nOaxaca - Mexico\nLeon - Mexico\nTijuana - Mexico\nChihuahua - Mexico\nMazatlan - Mexico\nTampico - Mexico\nAcapulco - Mexico\nVeracruz - Mexico\nTuxtla Gutierrez - Mexico\nCancun - Mexico\nMerida - Mexico\nGuadalajara - Mexico\nPuebla - Mexico\nMonterrey - Mexico\nMexico City - Mexico\nDubasari - Moldova\nBalti - Moldova\nCahul - Moldova\nTiraspol - Moldova\nChisinau - Moldova\nMonaco - Monaco\nSuchboatar - Mongolia\nDzuunmod - Mongolia\nTsetserleg - Mongolia\nOlgiy - Mongolia\nUlaan-Uul - Mongolia\nHodrogo - Mongolia\nBuyant-Uhaa - Mongolia\nOndorhaan - Mongolia\nBayankhongor - Mongolia\nUliastay - Mongolia\nAltay - Mongolia\nMoron - Mongolia\nUlaangom - Mongolia\nBulgan - Mongolia\nMandalgovi - Mongolia\nDarhan - Mongolia\nDzuunharaa - Mongolia\nArvayheer - Mongolia\nBaruun Urt - Mongolia\nDalandzadgad - Mongolia\nDund-Us - Mongolia\nChoybalsan - Mongolia\nErdenet - Mongolia\nUlaanbaatar - Mongolia\nPodgorica - Montenegro\nKsar El Kebir - Morocco\nLarache - Morocco\nTaza - Morocco\nOuezzane - Morocco\nKenitra - Morocco\nSettat - Morocco\nEr Rachidia - Morocco\nMeknes - Morocco\nTiznit - Morocco\nEl Jadida - Morocco\nDawra - Morocco\nLemsid - Morocco\nTan Tan - Morocco\nBir Anzarane - Morocco\nTangier - Morocco\nAgadir - Morocco\nGoulimine - Morocco\nSmara - Morocco\nAd Dakhla - Morocco\nOujda - Morocco\nSafi - Morocco\nLaayoune - Morocco\nFez - Morocco\nRabat - Morocco\nMarrakesh - Morocco\nCasablanca - Morocco\nMoatize - Mozambique\nLuangwa - Mozambique\nManica - Mozambique\nEspungabera - Mozambique\nMontepuez - Mozambique\nMocimboa - Mozambique\nMarrupa - Mozambique\nCuamba - Mozambique\nLigonha - Mozambique\nMacia - Mozambique\nMassangena - Mozambique\nMapai - Mozambique\nDondo - Mozambique\nChiramba - Mozambique\nMocuba - Mozambique\nNicuadala - Mozambique\nMaxixe - Mozambique\nPanda - Mozambique\nQuissico - Mozambique\nVilanculos - Mozambique\nMatola - Mozambique\nChimoio - Mozambique\nLichinga - Mozambique\nAngoche - Mozambique\nMocambique - Mozambique\nInhambane - Mozambique\nTete - Mozambique\nPemba - Mozambique\nNampula - Mozambique\nXai-Xai - Mozambique\nQuelimane - Mozambique\nNacala - Mozambique\nBeira - Mozambique\nMaputo - Mozambique\nLoikaw - Myanmar\nPa-an - Myanmar\nHakha - Myanmar\nTaunggyi - Myanmar\nSagaing - Myanmar\nMyingyan - Myanmar\nLetpadan - Myanmar\nTaungoo - Myanmar\nThongwa - Myanmar\nMudon - Myanmar\nYe - Myanmar\nMawlamyine - Myanmar\nKyaukphyu - Myanmar\nWakema - Myanmar\nLabutta - Myanmar\nPhyarpon - Myanmar\nYandoon - Myanmar\nHinthada - Myanmar\nPathein - Myanmar\nAllanmyo - Myanmar\nYaynangyoung - Myanmar\nChauk - Myanmar\nPakokku - Myanmar\nNamtu - Myanmar\nDawei - Myanmar\nShwebo - Myanmar\nBago - Myanmar\nPyu - Myanmar\nPyay - Myanmar\nMagway - Myanmar\nMyitkyina - Myanmar\nMonywa - Myanmar\nMyeik - Myanmar\nMandalay - Myanmar\nSittwe - Myanmar\nNaypyidaw - Myanmar\nRangoon - Myanmar\nOmaruru - Namibia\nKaribib - Namibia\nOtavi - Namibia\nGobabis - Namibia\nKarasburg - Namibia\nBethanie - Namibia\nOranjemund - Namibia\nMariental - Namibia\nRehoboth - Namibia\nOutjo - Namibia\nOpuwo - Namibia\nUsakos - Namibia\nOkahandja - Namibia\nOtjiwarongo - Namibia\nOshikango - Namibia\nCuangar - Namibia\nKatima Mulilo - Namibia\nKeetmanshoop - Namibia\nMaltahohe - Namibia\nSwakopmund - Namibia\nOngwediva - Namibia\nRundu - Namibia\nTsumeb - Namibia\nLuderitz - Namibia\nWalvis Bay - Namibia\nWindhoek - Namibia\nGrootfontein - Namibia\nSalyan - Nepal\nBaglung - Nepal\nJumla - Nepal\nBhairawa - Nepal\nDandeldhura - Nepal\nDhangarhi - Nepal\nRamechhap - Nepal\nBhimphedi - Nepal\nRajbiraj - Nepal\nIlam - Nepal\nLalitpur - Nepal\nHetauda - Nepal\nNepalganj - Nepal\nBirganj - Nepal\nBiratnagar - Nepal\nPokhara - Nepal\nKathmandu - Nepal\nAssen - Netherlands\nArnhem - Netherlands\nMaastricht - Netherlands\nZwolle - Netherlands\nMiddelburg - Netherlands\n\'s-Hertogenbosch - Netherlands\nEindhoven - Netherlands\nLeeuwarden - Netherlands\nGroningen - Netherlands\nUtrecht - Netherlands\nHaarlem - Netherlands\nRotterdam - Netherlands\nThe Hague - Netherlands\nAmsterdam - Netherlands\nNoumea - New Caledonia\nGreymouth - New Zealand\nUpper Hutt - New Zealand\nMasterton - New Zealand\nLevin - New Zealand\nWaitakere - New Zealand\nTakapuna - New Zealand\nWhakatane - New Zealand\nAshburton - New Zealand\nKaiapoi - New Zealand\nNew Plymouth - New Zealand\nWestport - New Zealand\nHokitika - New Zealand\nOamaru - New Zealand\nPalmerston North - New Zealand\nWanganui - New Zealand\nHastings - New Zealand\nGisborne - New Zealand\nRotorua - New Zealand\nTaupo - New Zealand\nTauranga - New Zealand\nTimaru - New Zealand\nNelson - New Zealand\nWhangarei - New Zealand\nQueenstown - New Zealand\nInvercargill - New Zealand\nNapier - New Zealand\nManukau - New Zealand\nHamilton - New Zealand\nBlenheim - New Zealand\nDunedin - New Zealand\nWellington - New Zealand\nChristchurch - New Zealand\nAuckland - New Zealand\nSomoto - Nicaragua\nOcotal - Nicaragua\nSan Carlos - Nicaragua\nJinotepe - Nicaragua\nJinotega - Nicaragua\nMasaya - Nicaragua\nSan Juan del Sur - Nicaragua\nEsteli - Nicaragua\nBoaco - Nicaragua\nJuigalpa - Nicaragua\nRivas - Nicaragua\nSan Juan de Nicaragua - Nicaragua\nGranada - Nicaragua\nChinandega - Nicaragua\nMatagalpa - Nicaragua\nPuerto Cabezas - Nicaragua\nLeon - Nicaragua\nBluefields - Nicaragua\nManagua - Nicaragua\nGoure - Niger\nGaya - Niger\nTillaberi - Niger\nAyorou - Niger\nBirni Nkonni - Niger\nMadaoua - Niger\nDiffa - Niger\nNguigmi - Niger\nDosso - Niger\nArlit - Niger\nDjado - Niger\nMaradi - Niger\nTahoua - Niger\nZinder - Niger\nNiamey - Niger\nAgadez - Niger\nUmuahia - Nigeria\nUyo - Nigeria\nOwerri - Nigeria\nDutse - Nigeria\nDamaturu - Nigeria\nIwo - Nigeria\nIseyin - Nigeria\nBiu - Nigeria\nBama - Nigeria\nAba - Nigeria\nOpobo - Nigeria\nOrlu - Nigeria\nOturkpo - Nigeria\nCalabar - Nigeria\nWukari - Nigeria\nJalingo - Nigeria\nKontagora - Nigeria\nBida - Nigeria\nAbeokuta - Nigeria\nIjebu Ode - Nigeria\nAkure - Nigeria\nIkare - Nigeria\nOwo - Nigeria\nOndo - Nigeria\nAdo Ekiti - Nigeria\nIfe - Nigeria\nOshogbo - Nigeria\nOyo - Nigeria\nAwka - Nigeria\nOnitsha - Nigeria\nAzare - Nigeria\nBauchi - Nigeria\nGombe - Nigeria\nKumo - Nigeria\nSapele - Nigeria\nNsukka - Nigeria\nLokoja - Nigeria\nIdah - Nigeria\nLafia - Nigeria\nKeffi - Nigeria\nFuntua - Nigeria\nKatsina - Nigeria\nGusau - Nigeria\nNguru - Nigeria\nGashua - Nigeria\nPotiskum - Nigeria\nBirnin Kebbi - Nigeria\nKoko - Nigeria\nMubi - Nigeria\nNuman - Nigeria\nIlorin - Nigeria\nMinna - Nigeria\nZaria - Nigeria\nJos - Nigeria\nYola - Nigeria\nBenin City - Nigeria\nMaiduguri - Nigeria\nPort Harcourt - Nigeria\nMakurdi - Nigeria\nIbadan - Nigeria\nOgbomosho - Nigeria\nWarri - Nigeria\nKaduna - Nigeria\nEnugu - Nigeria\nSokoto - Nigeria\nAbuja - Nigeria\nKano - Nigeria\nLagos - Nigeria\nSariwon - North Korea\nSin-Ni - North Korea\nChangyon - North Korea\nAnbyon - North Korea\nMunchon - North Korea\nKaesong - North Korea\nChosan - North Korea\nManpo - North Korea\nSunchon - North Korea\nKimhyonggwon - North Korea\nPyongsan - North Korea\nOngjin - North Korea\nHaeju - North Korea\nKilchu - North Korea\nMusan - North Korea\nSonbong - North Korea\nKanggye - North Korea\nHungnam - North Korea\nTaedong - North Korea\nChongju - North Korea\nHyeson - North Korea\nNampo - North Korea\nChongjin - North Korea\nKimchaek - North Korea\nHamhung - North Korea\nWonsan - North Korea\nSinuiju - North Korea\nPyongyang - North Korea\nKyrenia - Northern Cyprus\nAmmochostos - Northern Cyprus\nCapitol Hill - Northern Mariana Islands\nArendal - Norway\nVossavangen - Norway\nLeikanger - Norway\nBaerum - Norway\nHamar - Norway\nTonsberg - Norway\nFinnsnes - Norway\nGjovik - Norway\nRorvik - Norway\nHarstad - Norway\nAlesund - Norway\nSandnes - Norway\nDrammen - Norway\nMoss - Norway\nSteinkjer - Norway\nSvolvaer - Norway\nMo i Rana - Norway\nNarvik - Norway\nBodo - Norway\nHaugesund - Norway\nStavanger - Norway\nSkien - Norway\nNamsos - Norway\nAlta - Norway\nVadso - Norway\nMolde - Norway\nLillehammer - Norway\nKirkenes - Norway\nKristiansand - Norway\nHammerfest - Norway\nTromso - Norway\nTrondheim - Norway\nBergen - Norway\nOslo - Norway\nAlayat Samail - Oman\nDawwah - Oman\nMirbat - Oman\nIbri - Oman\nSalalah - Oman\nSuhar - Oman\nAs Sib - Oman\nNizwa - Oman\nSur - Oman\nMuscat - Oman\nParachinar - Pakistan\nSialkote - Pakistan\nSheikhu Pura - Pakistan\nGujrat - Pakistan\nSahiwal - Pakistan\nChiniot - Pakistan\nRahim Yar Khan - Pakistan\nMansehra - Pakistan\nKohat - Pakistan\nAbbottabad - Pakistan\nMardan - Pakistan\nGwadar - Pakistan\nZhob - Pakistan\nGilgit - Pakistan\nKasur - Pakistan\nKundian - Pakistan\nOkara - Pakistan\nJhang - Pakistan\nSargodha - Pakistan\nDera Ghazi Khan - Pakistan\nSadiqabad - Pakistan\nNawabshah - Pakistan\nBannu - Pakistan\nDera Ismail Khan - Pakistan\nChaman - Pakistan\nTurbat - Pakistan\nFaisalabad - Pakistan\nRawalpindi - Pakistan\nBahawalpur - Pakistan\nMirput Khas - Pakistan\nSukkur - Pakistan\nSaidu - Pakistan\nGujranwala - Pakistan\nQuetta - Pakistan\nLarkana - Pakistan\nIslamabad - Pakistan\nMultan - Pakistan\nHyderabad - Pakistan\nPeshawar - Pakistan\nLahore - Pakistan\nKarachi - Pakistan\nKoror - Palau\nMelekeok - Palau\nRamallah - Palestine\nAl Khalil - Palestine\nNablus - Palestine\nGaza - Palestine\nEl Porvenir - Panama\nPenonome - Panama\nChitre - Panama\nJaque - Panama\nBocas del Toro - Panama\nAlmirante - Panama\nLas Tablas - Panama\nSantiago - Panama\nLa Palma - Panama\nColon - Panama\nBalboa - Panama\nPuerto Armuelles - Panama\nDavid - Panama\nPanama City - Panama\nWabag - Papua New Guinea\nVanimo - Papua New Guinea\nKundiawa - Papua New Guinea\nKerema - Papua New Guinea\nArawa - Papua New Guinea\nLorengau - Papua New Guinea\nKimbe - Papua New Guinea\nDaru - Papua New Guinea\nSohano - Papua New Guinea\nKieta - Papua New Guinea\nMendi - Papua New Guinea\nAbau - Papua New Guinea\nAlotau - Papua New Guinea\nPopondetta - Papua New Guinea\nHoskins - Papua New Guinea\nWewak - Papua New Guinea\nMadang - Papua New Guinea\nKavieng - Papua New Guinea\nGoroka - Papua New Guinea\nMt. Hagen - Papua New Guinea\nRabaul - Papua New Guinea\nLae - Papua New Guinea\nPort Moresby - Papua New Guinea\nMariscal Estigarribia - Paraguay\nCaacupe - Paraguay\nGeneral Eugenio Alejandrino Garay - Paraguay\nArroyos y Esteros - Paraguay\nVilla Hayes - Paraguay\nFortin Falcon - Paraguay\nPuerto Pinasco - Paraguay\nPozo Colorado - Paraguay\nSan Pedro - Paraguay\nSan Lorenzo - Paraguay\nYpacarai - Paraguay\nSan Juan Bautista - Paraguay\nParaguari - Paraguay\nNacunday - Paraguay\nCoronel Oviedo - Paraguay\nCaazapa - Paraguay\nYpe Jhu - Paraguay\nEncarnacion - Paraguay\nCoronel Bogado - Paraguay\nFuerte Olimpo - Paraguay\nCapitan Pablo Lagerenza - Paraguay\nLa Victoria - Paraguay\nHorqueta - Paraguay\nBelen - Paraguay\nRosario - Paraguay\nIta - Paraguay\nPilar - Paraguay\nPedro Juan Caballero - Paraguay\nBella Vista - Paraguay\nAbai - Paraguay\nYgatimi - Paraguay\nHohenau - Paraguay\nConcepcion - Paraguay\nVillarrica - Paraguay\nFiladelfia - Paraguay\nCiudad del Este - Paraguay\nAsuncion - Paraguay\nFerrenafe - Peru\nMotupe - Peru\nMollendo - Peru\nUrubamba - Peru\nSanto Tomas - Peru\nPutina - Peru\nCasma - Peru\nTournavista - Peru\nHuamachuco - Peru\nOtuzco - Peru\nLamas - Peru\nNauta - Peru\nPuquio - Peru\nChosica - Peru\nSatipo - Peru\nTarma - Peru\nLa Oroya - Peru\nHuaura - Peru\nHuacho - Peru\nPimentel - Peru\nOlmos - Peru\nSechura - Peru\nChulucanas - Peru\nSullana - Peru\nAbancay - Peru\nCamana - Peru\nSicuani - Peru\nPuno - Peru\nAyaviri - Peru\nIlave - Peru\nDesaguadero - Peru\nHuarmey - Peru\nCajabamba - Peru\nJaen - Peru\nChota - Peru\nTingo Maria - Peru\nMoyobamba - Peru\nJuanjui - Peru\nTocache - Peru\nChachapoyas - Peru\nCaballococha - Peru\nPuca Urco - Peru\nAndoas - Peru\nSoldado Bartra - Peru\nNuevo Rocafuerte - Peru\nRequena - Peru\nHuanta - Peru\nCoracora - Peru\nChincha Alta - Peru\nSantiago - Peru\nSan Ramon - Peru\nJunin - Peru\nJauja - Peru\nPativilca - Peru\nChancay - Peru\nChilca - Peru\nChiclayo - Peru\nJuliaca - Peru\nCerro de Pasco - Peru\nTarapoto - Peru\nAyacucho - Peru\nCallao - Peru\nPaita - Peru\nTalara - Peru\nTumbes - Peru\nPuerto Maldonado - Peru\nIlo - Peru\nMoquegua - Peru\nHuaraz - Peru\nCajamarca - Peru\nHuanuco - Peru\nPacasmayo - Peru\nSalaverry - Peru\nGueppi - Peru\nContamana - Peru\nHuancavelica - Peru\nPisco - Peru\nNasca - Peru\nPiura - Peru\nArequipa - Peru\nChimbote - Peru\nPucallpa - Peru\nIquitos - Peru\nHuancayo - Peru\nCusco - Peru\nTacna - Peru\nTrujillo - Peru\nIca - Peru\nLima - Peru\nMakati - Philippines\nSan Carlos - Philippines\nCadiz - Philippines\nPagadian - Philippines\nOzamis - Philippines\nTarlac - Philippines\nCabanatuan - Philippines\nOlongapo - Philippines\nDagupan - Philippines\nSan Pablo - Philippines\nQuezon City - Philippines\nPasay City - Philippines\nIligan - Philippines\nOrmac - Philippines\nTacloban - Philippines\nButuan - Philippines\nTagum - Philippines\nSurigao - Philippines\nGingoog - Philippines\nLegazpi - Philippines\nTuguegarao - Philippines\nVigan - Philippines\nBacolod - Philippines\nRoxas - Philippines\nPuerto Princesa - Philippines\nNaga - Philippines\nAngeles - Philippines\nBatangas - Philippines\nCotabato - Philippines\nCalbayog - Philippines\nCagayan de Oro - Philippines\nZamboanga - Philippines\nLaoag - Philippines\nBaguio City - Philippines\nGeneral Santos - Philippines\nCebu - Philippines\nIloilo - Philippines\nDavao - Philippines\nManila - Philippines\nOlsztyn - Poland\nElblag - Poland\nInowroclaw - Poland\nBytom - Poland\nOpole - Poland\nKoszalin - Poland\nElk - Poland\nGdynia - Poland\nWroclaw - Poland\nSzczecin - Poland\nZielona Gora - Poland\nPoznan - Poland\nGrudziadz - Poland\nBydgoszcz - Poland\nKatowice - Poland\nGliwice - Poland\nKielce - Poland\nBialystok - Poland\nLublin - Poland\nRzeszow - Poland\nLodz - Poland\nGdansk - Poland\nKrakow - Poland\nWarsaw - Poland\nAveiro - Portugal\nLeiria - Portugal\nViana Do Castelo - Portugal\nBeja - Portugal\nEvora - Portugal\nPortalegre - Portugal\nSantarem - Portugal\nBraganca - Portugal\nCastelo Branco - Portugal\nGuarda - Portugal\nViseu - Portugal\nVila Real - Portugal\nBraga - Portugal\nCovilha - Portugal\nHorta - Portugal\nAngra do Heroismo - Portugal\nPortimao - Portugal\nFaro - Portugal\nCoimbra - Portugal\nSetubal - Portugal\nPorto - Portugal\nFunchal - Portugal\nPonta Delgada - Portugal\nLisbon - Portugal\nPonce - Puerto Rico\nMayaguez - Puerto Rico\nArecibo - Puerto Rico\nSan Juan - Puerto Rico\nDoha - Qatar\nTargu Jiu - Romania\nSlatina - Romania\nAlexandria - Romania\nTargoviste - Romania\nGiurgiu - Romania\nSlobozia - Romania\nAlba Lulia - Romania\nBistrita - Romania\nDeva - Romania\nZalau - Romania\nSatu Mare - Romania\nRimnicu Vilcea - Romania\nSfintu-Gheorghe - Romania\nMiercurea Cuic - Romania\nPiatra-Neamt - Romania\nBraila - Romania\nVaslui - Romania\nDrobeta-Turnu Severin - Romania\nTulcea - Romania\nArad - Romania\nOradea - Romania\nSibiu - Romania\nSuceava - Romania\nBuzau - Romania\nGalati - Romania\nFocsani - Romania\nCraiova - Romania\nCalarasi - Romania\nResita - Romania\nTimisoara - Romania\nBotosani - Romania\nBaia Mare - Romania\nTirgu Mures - Romania\nPitesti - Romania\nBrasov - Romania\nPloiesti - Romania\nBacau - Romania\nCluj-Napoca - Romania\nConstanta - Romania\nIasi - Romania\nBucharest - Romania\nNazran - Russia\nUst\' Ordynskiy - Russia\nMaykop - Russia\nMozdok - Russia\nGeorgievsk - Russia\nPyatigorsk - Russia\nKislovodsk - Russia\nNevinnomyssk - Russia\nEnurmino - Russia\nLavrentiya - Russia\nZvezdnyy - Russia\nMikhalkino - Russia\nChernyakhovsk - Russia\nSeveromorsk - Russia\nApatity - Russia\nPolyarnyy - Russia\nSlantsy - Russia\nKolpino - Russia\nNovozybkov - Russia\nDyatkovo - Russia\nShuya - Russia\nKineshma - Russia\nBalakhna - Russia\nArzamas - Russia\nRzhev - Russia\nVyshnniy Volochek - Russia\nUglich - Russia\nYelets - Russia\nOrekhovo-Zuevo - Russia\nKlin - Russia\nSergiyev Posad - Russia\nKolomna - Russia\nBataysk - Russia\nTaganrog - Russia\nNovocherkassk - Russia\nKamensk Shakhtinskiy - Russia\nNovoshakhtinsk - Russia\nAleksin - Russia\nNovomoskovsk - Russia\nShchekino - Russia\nNikolayevsk - Russia\nShebekino - Russia\nGubkin - Russia\nApsheronsk - Russia\nKropotkin - Russia\nRuzayevka - Russia\nKirsanov - Russia\nMichurinsk - Russia\nBorisoglebsk - Russia\nPlast - Russia\nBakal - Russia\nVerkhniy Ufaley - Russia\nSevernyy - Russia\nKirovo-Chepetsk - Russia\nKrasnoturinsk - Russia\nAsbest - Russia\nAlapayevsk - Russia\nKrasnouralsk - Russia\nSeverouralsk - Russia\nNovotroitsk - Russia\nBuguruslan - Russia\nChapayevsk - Russia\nSyzran - Russia\nNovokuybishevsk - Russia\nNaberezhnyye Chelny - Russia\nZelenodolsk - Russia\nLeninogorsk - Russia\nBugulma - Russia\nNefteyugansk - Russia\nLeninsk Kuznetsky - Russia\nAnzhero Sudzhensk - Russia\nKiselevsk - Russia\nMundybash - Russia\nChernogorsk - Russia\nAbaza - Russia\nIskitim - Russia\nToguchin - Russia\nKupina - Russia\nZaozernyy - Russia\nBogotol - Russia\nShilka - Russia\nSherlovaya Gora - Russia\nPetrovsk Zabaykalskiy - Russia\nArsenyev - Russia\nPartizansk - Russia\nDalnerechensk - Russia\nZemlya Bunge - Russia\nKhorgo - Russia\nPut Lenina - Russia\nObluchye - Russia\nVanino - Russia\nOmchak - Russia\nUglegorsk - Russia\nKholmsk - Russia\nSolikamsk - Russia\nKizel - Russia\nPakhachi - Russia\nOymyakon - Russia\nTimiryazevskiy - Russia\nAsino - Russia\nStrezhevoy - Russia\nCherkessk - Russia\nVladikavkaz - Russia\nBlagodarnyy - Russia\nZelenokumsk - Russia\nMukhomornoye - Russia\nBeringovskiy - Russia\nBilibino - Russia\nMys Shmidta - Russia\nEgvekinot - Russia\nSovetsk - Russia\nNikel - Russia\nMonchegorsk - Russia\nKirovsk - Russia\nBorovichi - Russia\nStaraya Russa - Russia\nVolkhov - Russia\nTikhvin - Russia\nSvetogorsk - Russia\nGatchina - Russia\nLuga - Russia\nKlintsy - Russia\nRoslavl - Russia\nSafonovo - Russia\nVyazma - Russia\nSegezha - Russia\nVichuga - Russia\nSharya - Russia\nBuy - Russia\nDzerzhinsk - Russia\nVyska - Russia\nKimry - Russia\nBezhetsk - Russia\nNelidovo - Russia\nBologoye - Russia\nTorzhok - Russia\nSokol - Russia\nCherepovets - Russia\nRybinsk - Russia\nRostov - Russia\nKaluga - Russia\nKirov - Russia\nObninsk - Russia\nLgov - Russia\nZheleznogorsk - Russia\nGryazi - Russia\nYegoryevsk - Russia\nPodolsk - Russia\nSolnechnogorsk - Russia\nSerpukhov - Russia\nLivny - Russia\nMtsensk - Russia\nSalsk - Russia\nBelaya Kalitva - Russia\nShakhty - Russia\nMillerovo - Russia\nYefremov - Russia\nBogoroditsk - Russia\nKamyshin - Russia\nPallasovka - Russia\nFrolovo - Russia\nVolzhskiy - Russia\nMikhaylovka - Russia\nUryupinsk - Russia\nStarsy Oskol - Russia\nAlekseyevka - Russia\nValuyki - Russia\nTuapse - Russia\nGelendzhik - Russia\nLabinsk - Russia\nArmavir - Russia\nTimashevsk - Russia\nTikhoretsk - Russia\nYeysk - Russia\nSaransk - Russia\nKamenka - Russia\nKuznetsk - Russia\nSerdobsk - Russia\nKasimov - Russia\nSasovo - Russia\nKotovsk - Russia\nMorshansk - Russia\nKovrov - Russia\nMurom - Russia\nRayevskiy - Russia\nSibay - Russia\nKumertau - Russia\nSalavat - Russia\nBelebey - Russia\nTuymazy - Russia\nNeftekamsk - Russia\nTroitsk - Russia\nYemanzhelinsk - Russia\nKartaly - Russia\nAsha - Russia\nMiass - Russia\nKyshtym - Russia\nKurtamysh - Russia\nShadrinsk - Russia\nVarnek - Russia\nBugrino - Russia\nYamburg - Russia\nSosnogorsk - Russia\nSlobodskoy - Russia\nKirs - Russia\nOmutninsk - Russia\nKotelnich - Russia\nYoshkar Ola - Russia\nKamensk Uralskiy - Russia\nPolevskoy - Russia\nTavda - Russia\nArtemovskiy - Russia\nNevyansk - Russia\nVerkhnyaya Salda - Russia\nNizhnyaya Tura - Russia\nKarpinsk - Russia\nIvdel - Russia\nKrasnoufimsk - Russia\nSarapul - Russia\nMozhga - Russia\nVotkinsk - Russia\nGlazov - Russia\nKanash - Russia\nShumerlya - Russia\nAlatyr - Russia\nSol-lletsk - Russia\nDombarovskiy - Russia\nMednogorsk - Russia\nGay - Russia\nBuzuluk - Russia\nOtradnyy - Russia\nTolyatti - Russia\nEngels - Russia\nPugachev - Russia\nVolsk - Russia\nAtkarsk - Russia\nBalashov - Russia\nAlmetyevsk - Russia\nChistopol - Russia\nNizhnekamsk - Russia\nDimitrovgrad - Russia\nPeregrebnoye - Russia\nSaranpaul - Russia\nUray - Russia\nLaryak - Russia\nKogalym - Russia\nMegion - Russia\nCherlak - Russia\nKalachinsk - Russia\nNazyvayevsk - Russia\nIsikul - Russia\nIshim - Russia\nGolyshmanovo - Russia\nYalutorovsk - Russia\nBiysk - Russia\nZmeinogorsk - Russia\nAleysk - Russia\nNovoaltaysk - Russia\nKamenna Obi - Russia\nGornyak - Russia\nKulunda - Russia\nSlavgorod - Russia\nTashtagol - Russia\nGuryevsk - Russia\nYurga - Russia\nTopki - Russia\nMariinsk - Russia\nShira - Russia\nCherepanovo - Russia\nKargat - Russia\nOb - Russia\nKarasuk - Russia\nBarabinsk - Russia\nTatarsk - Russia\nKaspiysk - Russia\nDerbent - Russia\nBuynaksk - Russia\nYessey - Russia\nUlkan - Russia\nKirensk - Russia\nZheleznogorsk Ilimskiy - Russia\nVikhorevka - Russia\nBiryusinsk - Russia\nKodinskiy - Russia\nArtemovsk - Russia\nUyar - Russia\nUzhur - Russia\nSayanogorsk - Russia\nPodkamennaya - Russia\nIgarka - Russia\nAgapa - Russia\nBoyarka - Russia\nNordvik - Russia\nChelyuskin - Russia\nTaksimo - Russia\nGusinoozyorsk - Russia\nAginskoye - Russia\nProgress - Russia\nBelogorsk - Russia\nNyukzha - Russia\nNerchinsk - Russia\nKavalerovo - Russia\nSpassk Dalniy - Russia\nShalaurova - Russia\nLogashkino - Russia\nUst Kuyga - Russia\nPokrovsk - Russia\nVerkhnevilyuysk - Russia\nVitim - Russia\nOlyokminsk - Russia\nTunguskhaya - Russia\nNatara - Russia\nZhilinda - Russia\nTrofimovsk - Russia\nTukchi - Russia\nAmursk - Russia\nBikin - Russia\nVyazemskiy - Russia\nChegdomyn - Russia\nSiglan - Russia\nKaramken - Russia\nStrelka - Russia\nSevero Kurilsk - Russia\nKrasnogorsk - Russia\nPoronaysk - Russia\nMakarov - Russia\nDolinsk - Russia\nNevelsk - Russia\nKudymkar - Russia\nKungur - Russia\nKrasnokamsk - Russia\nChusovoy - Russia\nGubakha - Russia\nUtkholok - Russia\nBol\'sheretsk - Russia\nIl\'pyrskiy - Russia\nKorf - Russia\nKolpashevo - Russia\nOmolon - Russia\nPevek - Russia\nUmba - Russia\nKovda - Russia\nVelikiy Novgorod - Russia\nVelikiye Luki - Russia\nBelomorsk - Russia\nKem - Russia\nKrasino - Russia\nMatochkin Shar - Russia\nSeverodvinsk - Russia\nKursk - Russia\nTula - Russia\nTambov - Russia\nSterlitamak - Russia\nKurgan - Russia\nIndiga - Russia\nShoyna - Russia\nNovy Port - Russia\nSalekhard - Russia\nGyda - Russia\nTazovskiy - Russia\nNovy Urengoy - Russia\nNadym - Russia\nNoyabrsk - Russia\nSyktyvkar - Russia\nUkhta - Russia\nSerov - Russia\nCheboksary - Russia\nOrsk - Russia\nBalakovo - Russia\nIgrim - Russia\nNyagan - Russia\nKhanty Mansiysk - Russia\nNizhenvartovsk - Russia\nNumto - Russia\nTara - Russia\nTobolsk - Russia\nRubtsovsk - Russia\nGorno Altaysk - Russia\nProkopyevsk - Russia\nMakhachkala - Russia\nTura - Russia\nNoginsk - Russia\nYerema - Russia\nTayshet - Russia\nUsolye Sibirskoye - Russia\nSlyudyanka - Russia\nCheremkhovo - Russia\nZima - Russia\nTulun - Russia\nNizhneudinsk - Russia\nUst Kut - Russia\nBodaybo - Russia\nKomsa - Russia\nKansk - Russia\nAchinsk - Russia\nYeniseysk - Russia\nLesosibirsk - Russia\nTurukhansk - Russia\nVorontsovo - Russia\nStarorybnoye - Russia\nMikhaylova - Russia\nDudinka - Russia\nTeli - Russia\nNovyy Uoyin - Russia\nBagdarin - Russia\nSeverobaykalsk - Russia\nKyakhta - Russia\nSvobodnyy - Russia\nZeya - Russia\nMagdagachi - Russia\nShimanovsk - Russia\nSkovorodino - Russia\nTynda - Russia\nOlovyannaya - Russia\nMogocha - Russia\nKrasnokamensk - Russia\nBorzya - Russia\nKhilok - Russia\nNakhodka - Russia\nUssuriysk - Russia\nLesozavodsk - Russia\nKavache - Russia\nVerkhoyansk - Russia\nCherskiy - Russia\nSrednekolymsk - Russia\nZyryanka - Russia\nEldikan - Russia\nChagda - Russia\nKhandyga - Russia\nUst Maya - Russia\nNeryungri - Russia\nChernyshevskiy - Russia\nTerbyas - Russia\nVilyuysk - Russia\nSangar - Russia\nMenkere - Russia\nSaskylakh - Russia\nGovorovo - Russia\nSagastyr - Russia\nUst Olensk - Russia\nSuntar - Russia\nOlenek - Russia\nUdachnyy - Russia\nBirobidzhan - Russia\nKhakhar - Russia\nDe Kastri - Russia\nChumikan - Russia\nKomsomolsk na Amure - Russia\nAyan - Russia\nNikolayevsk na Amure - Russia\nSavetskaya Gavan - Russia\nEvensk - Russia\nPalatka - Russia\nOmsukchan - Russia\nSusuman - Russia\nNogliki - Russia\nAleksandrovsk Sakhalinskiy - Russia\nKorsakov - Russia\nManily - Russia\nOktyabrskiy - Russia\nKlyuchi - Russia\nUst Kamchatsk - Russia\nProvideniya - Russia\nUelen - Russia\nKandalaksha - Russia\nVyborg - Russia\nKondopoga - Russia\nRusanovo - Russia\nMezen - Russia\nVelsk - Russia\nKotlas - Russia\nOnega - Russia\nIvanovo - Russia\nKostroma - Russia\nVelikiy Ustyug - Russia\nLipetsk - Russia\nOrel - Russia\nVolgodonsk - Russia\nBelgorod - Russia\nNovorossiysk - Russia\nVladimir - Russia\nBirsk - Russia\nZlatoust - Russia\nAmderma - Russia\nNaryan Mar - Russia\nInta - Russia\nUsinsk - Russia\nPechora - Russia\nPervouralsk - Russia\nIzhevsk - Russia\nAkhtubinsk - Russia\nElista - Russia\nKrasnoarmeysk - Russia\nBerezniki - Russia\nNaltchik - Russia\nStavropol - Russia\nUgolnye Kopi - Russia\nKaliningrad - Russia\nPskov - Russia\nBryansk - Russia\nSmolensk - Russia\nPetrozavodsk - Russia\nTver - Russia\nVologda - Russia\nYaroslavl - Russia\nSochi - Russia\nKrasnodar - Russia\nPenza - Russia\nRyazan - Russia\nVoronezh - Russia\nMagnitogorsk - Russia\nChelyabinsk - Russia\nVorkuta - Russia\nNizhny Tagil - Russia\nAstrakhan - Russia\nOrenburg - Russia\nSaratov - Russia\nUlyanovsk - Russia\nOmsk - Russia\nTyumen - Russia\nNovokuznetsk - Russia\nKemerovo - Russia\nGroznyy - Russia\nUst-Ulimsk - Russia\nAngarsk - Russia\nAbakan - Russia\nNorilsk - Russia\nKhatanga - Russia\nKyzyl - Russia\nUlan Ude - Russia\nBlagoveshchensk - Russia\nBukachacha - Russia\nDalnegorsk - Russia\nAmbarchik - Russia\nBatagay - Russia\nChokurdakh - Russia\nUst Nera - Russia\nLensk - Russia\nAldan - Russia\nMirnyy - Russia\nZhigansk - Russia\nOkhotsk - Russia\nKhabarovsk - Russia\nOkha - Russia\nYuzhno Sakhalinsk - Russia\nTomsk - Russia\nAnadyr - Russia\nMurmansk - Russia\nArchangel - Russia\nNizhny Novgorod - Russia\nVolgograd - Russia\nUfa - Russia\nYekaterinburg - Russia\nSamara - Russia\nKazan - Russia\nSurgut - Russia\nBarnaul - Russia\nNovosibirsk - Russia\nBratsk - Russia\nIrkutsk - Russia\nKrasnoyarsk - Russia\nDickson - Russia\nChita - Russia\nVladivostok - Russia\nNizhneyansk - Russia\nYakutsk - Russia\nTiksi - Russia\nMagadan - Russia\nPerm - Russia\nPalana - Russia\nPetropavlovsk Kamchatskiy - Russia\nSt. Petersburg - Russia\nMoscow - Russia\nGikongoro - Rwanda\nKibuye - Rwanda\nKibungo - Rwanda\nNyanza - Rwanda\nGitarama - Rwanda\nButare - Rwanda\nGisenyi - Rwanda\nCyangugu - Rwanda\nByumba - Rwanda\nRuhengeri - Rwanda\nKigali - Rwanda\nBasseterre - Saint Kitts and Nevis\nCastries - Saint Lucia\nKingstown - Saint Vincent and the Grenadines\nApia - Samoa\nSan Marino - San Marino\nSanto Antonio - Sao Tome and Principe\nSao Tome - Sao Tome and Principe\nAn Nabk - Saudi Arabia\nSakakah - Saudi Arabia\nYanbu al Bahr - Saudi Arabia\nDawmat al Jandal - Saudi Arabia\nQal at Bishah - Saudi Arabia\nAt Taif - Saudi Arabia\nNajran - Saudi Arabia\nAl Quwayiyah - Saudi Arabia\nAl Hillah - Saudi Arabia\nAl Mubarraz - Saudi Arabia\nAl-Qatif - Saudi Arabia\nAz Zahran - Saudi Arabia\nBuraydah - Saudi Arabia\nHail - Saudi Arabia\nArar - Saudi Arabia\nRafha - Saudi Arabia\nAl Kharj - Saudi Arabia\nAd Damman - Saudi Arabia\nHafar al Batin - Saudi Arabia\nAl Jubayl - Saudi Arabia\nAl Qunfudhah - Saudi Arabia\nAl Hufuf - Saudi Arabia\nAl Wajh - Saudi Arabia\nAbha - Saudi Arabia\nJizan - Saudi Arabia\nAs Sulayyil - Saudi Arabia\nMedina - Saudi Arabia\nTabuk - Saudi Arabia\nJeddah - Saudi Arabia\nMakkah - Saudi Arabia\nRiyadh - Saudi Arabia\nFatick - Senegal\nDiourbel - Senegal\nLouga - Senegal\nThies - Senegal\nKolda - Senegal\nTambacounda - Senegal\nKedougou - Senegal\nZiguinchor - Senegal\nKaolack - Senegal\nKaedi - Senegal\nDakar - Senegal\nSubotica - Serbia\nKragujevac - Serbia\nZrenjanin - Serbia\nPec - Serbia\nNis - Serbia\nNovi Sad - Serbia\nBelgrade - Serbia\nVictoria - Seychelles\nMakeni - Sierra Leone\nKoidu - Sierra Leone\nKenema - Sierra Leone\nBo - Sierra Leone\nFreetown - Sierra Leone\nBanska Bystrica - Slovakia\nTrnava - Slovakia\nZvolen - Slovakia\nZilina - Slovakia\nKosice - Slovakia\nPresov - Slovakia\nBratislava - Slovakia\nMaribor - Slovenia\nLjubljana - Slovenia\nGizo - Solomon Islands\nLata - Solomon Islands\nHoniara - Solomon Islands\nHudur - Somalia\nGarbahaarey - Somalia\nBu\'aale - Somalia\nDhuusa Mareeb - Somalia\nBuurhakaba - Somalia\nLuuq - Somalia\nMandera - Somalia\nFerfer - Somalia\nJawhar - Somalia\nHurdiyo - Somalia\nQardho - Somalia\nCaluula - Somalia\nBuur Gaabo - Somalia\nBaydhabo - Somalia\nMarka - Somalia\nMereeg - Somalia\nBeledweyne - Somalia\nBoosaaso - Somalia\nBandarbeyla - Somalia\nGaalkacyo - Somalia\nEyl - Somalia\nGaroowe - Somalia\nJamaame - Somalia\nKismaayo - Somalia\nMogadishu - Somalia\nLaascaanood - Somaliland\nCeerigaabo - Somaliland\nBoorama - Somaliland\nBurco - Somaliland\nMaydh - Somaliland\nBerbera - Somaliland\nHargeysa - Somaliland\nQacha\'s Nek - South Africa\nColesberg - South Africa\nPoffader - South Africa\nCarnarvon - South Africa\nPrieska - South Africa\nKuruman - South Africa\nKnysna - South Africa\nSwellendam - South Africa\nHermanus - South Africa\nPaarl - South Africa\nBredasdorp - South Africa\nBeaufort West - South Africa\nBrits - South Africa\nBloemhof - South Africa\nPotchefstroom - South Africa\nBrandfort - South Africa\nBethlehem - South Africa\nSprings - South Africa\nVolksrust - South Africa\nMbombela - South Africa\nKomatipoort - South Africa\nMiddelburg - South Africa\nBethal - South Africa\nStanderton - South Africa\nLebowakgomo - South Africa\nTzaneen - South Africa\nUlundi - South Africa\nLadysmith - South Africa\nPort Shepstone - South Africa\nUbomba - South Africa\nCradock - South Africa\nUitenhage - South Africa\nPort Alfred - South Africa\nGrahamstown - South Africa\nPort St. Johns - South Africa\nAliwal North - South Africa\nQueenstown - South Africa\nBenoni - South Africa\nVereeniging - South Africa\nDe Aar - South Africa\nAlexander Bay - South Africa\nKimberley - South Africa\nOudtshoorn - South Africa\nVanhynsdorp - South Africa\nSaldanha - South Africa\nMossel Bay - South Africa\nVryburg - South Africa\nRustenburg - South Africa\nMmabatho - South Africa\nKlerksdorp - South Africa\nKroonstad - South Africa\nPolokwane - South Africa\nThohoyandou - South Africa\nMusina - South Africa\nVryheid - South Africa\nPietermaritzburg - South Africa\nUmtata - South Africa\nGraaff Reinet - South Africa\nBhisho - South Africa\nSpringbok - South Africa\nUpington - South Africa\nWorcester - South Africa\nGeorge - South Africa\nWelkom - South Africa\nEast London - South Africa\nBloemfontein - South Africa\nPretoria - South Africa\nPort Elizabeth - South Africa\nDurban - South Africa\nJohannesburg - South Africa\nCape Town - South Africa\nGrytviken - South Georgia and the Islands\nEumseong - South Korea\nCheongju - South Korea\nWonju - South Korea\nChuncheon - South Korea\nAnsan - South Korea\nIksan - South Korea\nGyeongju - South Korea\nChangwon - South Korea\nYeosu - South Korea\nAndong - South Korea\nJeju - South Korea\nGangneung - South Korea\nSokcho - South Korea\nJeonju - South Korea\nGunsan - South Korea\nMokpo - South Korea\nPuch\'on - South Korea\nSeongnam - South Korea\nGoyang - South Korea\nSuwon - South Korea\nPohang - South Korea\nUlsan - South Korea\nDaegu - South Korea\nIncheon - South Korea\nDaejeon - South Korea\nGwangju - South Korea\nBusan - South Korea\nSeoul - South Korea\nBentiu - South Sudan\nMaridi - South Sudan\nYei - South Sudan\nMelut - South Sudan\nNasir - South Sudan\nGogrial - South Sudan\nKapoeta - South Sudan\nAweil - South Sudan\nRumbek - South Sudan\nYambio - South Sudan\nBor - South Sudan\nNimule - South Sudan\nJuba - South Sudan\nMalakal - South Sudan\nWau - South Sudan\nMerida - Spain\nMarbella - Spain\nLinares - Spain\nAlgeciras - Spain\nLeon - Spain\nMataro - Spain\nGijon - Spain\nVitoria - Spain\nAlmeria - Spain\nMalaga - Spain\nJaen - Spain\nHuelva - Spain\nAlbacete - Spain\nToledo - Spain\nGuadalajara - Spain\nSantander - Spain\nSalamanca - Spain\nBurgos - Spain\nTarragona - Spain\nLorca - Spain\nCartagena - Spain\nOviedo - Spain\nSantiago de Compostela - Spain\nBadajoz - Spain\nLogrono - Spain\nSan Sebastian - Spain\nAlicante - Spain\nCastello - Spain\nArrecife - Spain\nCadiz - Spain\nGranada - Spain\nMurcia - Spain\nCeuta - Spain\nLa Coruna - Spain\nOurense - Spain\nPamplona - Spain\nValladolid - Spain\nMelilla - Spain\nPalma - Spain\nZaragoza - Spain\nSanta Cruz de Tenerife - Spain\nCordoba - Spain\nVigo - Spain\nBilbao - Spain\nLas Palmas - Spain\nSeville - Spain\nValencia - Spain\nBarcelona - Spain\nMadrid - Spain\nTrincomalee - Sri Lanka\nPuttalan - Sri Lanka\nRatnapura - Sri Lanka\nBatticaloa - Sri Lanka\nKilinochchi - Sri Lanka\nMatara - Sri Lanka\nBadulla - Sri Lanka\nMoratuwa - Sri Lanka\nGalle - Sri Lanka\nAnuradhapura - Sri Lanka\nJaffna - Sri Lanka\nKandy - Sri Lanka\nSri Jawewardenepura Kotte - Sri Lanka\nColombo - Sri Lanka\nAd Damazin - Sudan\nHaiya - Sudan\nEl Manaqil - Sudan\nShendi - Sudan\nBerber - Sudan\nKerma - Sudan\nEd Dueim - Sudan\nUmm Ruwaba - Sudan\nEn Nuhud - Sudan\nMuglad - Sudan\nTokar - Sudan\nMedani - Sudan\nGedaref - Sudan\nEdDamer - Sudan\nAtbara - Sudan\nWadi Halfa - Sudan\nMerowe - Sudan\nKosti - Sudan\nSennar - Sudan\nEl Fasher - Sudan\nKadugli - Sudan\nBabanusa - Sudan\nGeneina - Sudan\nOmdurman - Sudan\nEl Obeid - Sudan\nPort Sudan - Sudan\nNiyala - Sudan\nDongola - Sudan\nKassala - Sudan\nKhartoum - Sudan\nOnverwacht - Suriname\nGroningen - Suriname\nBrownsweg - Suriname\nMoengo - Suriname\nNieuw Amsterdam - Suriname\nNieuw Nickerie - Suriname\nBrokopondo - Suriname\nTotness - Suriname\nCottica - Suriname\nParamaribo - Suriname\nLongyearbyen - Svalbard and Jan Mayen Islands\nPiggs Peak - Swaziland\nSiteki - Swaziland\nManzini - Swaziland\nHlatikulu - Swaziland\nGolela - Swaziland\nLobamba - Swaziland\nMbabane - Swaziland\nGothenburg - Sweden\nFalun - Sweden\nNykoping - Sweden\nHarnosand - Sweden\nKarlskrona - Sweden\nMariestad - Sweden\nVannersborg - Sweden\nBorlange - Sweden\nVasteras - Sweden\nBollnas - Sweden\nGavle - Sweden\nKalmar - Sweden\nVaxjo - Sweden\nOrebro - Sweden\nNorrkoping - Sweden\nHalmstad - Sweden\nKarlstad - Sweden\nSkelleftea - Sweden\nVisby - Sweden\nTrollhattan - Sweden\nBoras - Sweden\nKristianstad - Sweden\nHelsingborg - Sweden\nJonkoping - Sweden\nOrnskoldsvik - Sweden\nLinkoping - Sweden\nOstersund - Sweden\nKiruna - Sweden\nUmea - Sweden\nUppsala - Sweden\nTrelleborg - Sweden\nLulea - Sweden\nSundsvall - Sweden\nMalmo - Sweden\nStockholm - Sweden\nDelemont - Switzerland\nNeuchatel - Switzerland\nAarau - Switzerland\nStans - Switzerland\nSion - Switzerland\nHerisau - Switzerland\nSaint Gallen - Switzerland\nBellinzona - Switzerland\nGlarus - Switzerland\nSchaffhausen - Switzerland\nSchwyz - Switzerland\nFrauenfeld - Switzerland\nAltdorf - Switzerland\nZug - Switzerland\nFribourg - Switzerland\nLiestal - Switzerland\nSolothurn - Switzerland\nSarnen - Switzerland\nAppenzell - Switzerland\nChur - Switzerland\nBiel - Switzerland\nLuzern - Switzerland\nLugano - Switzerland\nLausanne - Switzerland\nBasel - Switzerland\nBern - Switzerland\nZurich - Switzerland\nGeneva - Switzerland\nDar\'a - Syria\nAl Ladhiqiyah - Syria\nMadinat ath Thawrah - Syria\nIzaz - Syria\nManbij - Syria\nIdlib - Syria\nAl Qamishli - Syria\nAl Hasakah - Syria\nDouma - Syria\nTartus - Syria\nAr Raqqah - Syria\nHamah - Syria\nTadmur - Syria\nAbu Kamal - Syria\nDayr az Zawr - Syria\nAs Suwayda - Syria\nAd Nabk - Syria\nAl Qunaytirah - Syria\nHims - Syria\nAleppo - Syria\nDamascus - Syria\nBade - Taiwan\nPingzhen - Taiwan\nTaibao - Taiwan\nTaoyuan - Taiwan\nYangmei - Taiwan\nYilan - Taiwan\nZhubei - Taiwan\nDouliou - Taiwan\nZhongli - Taiwan\nKeelung - Taiwan\nNantou - Taiwan\nPuzi - Taiwan\nChanghua - Taiwan\nChiayi - Taiwan\nHsinchu - Taiwan\nMiaoli - Taiwan\nPingtung - Taiwan\nHualien - Taiwan\nNew Taipei - Taiwan\nTainan - Taiwan\nTaitung - Taiwan\nMagong - Taiwan\nTaichung - Taiwan\nKaohsiung - Taiwan\nTaipei - Taiwan\nLeninobod - Tajikistan\nQurghonteppa - Tajikistan\nKonibodom - Tajikistan\nKuybyshevskiy - Tajikistan\nKulob - Tajikistan\nUroteppa - Tajikistan\nKhorugh - Tajikistan\nKhujand - Tajikistan\nDushanbe - Tajikistan\nWete - Tanzania\nKibaha - Tanzania\nMkokotoni - Tanzania\nTunduma - Tanzania\nTukuyu - Tanzania\nSumbawanga - Tanzania\nMpanda - Tanzania\nKipili - Tanzania\nKarema - Tanzania\nGeita - Tanzania\nNyahanga - Tanzania\nKahama - Tanzania\nShinyanga - Tanzania\nNzega - Tanzania\nSikonge - Tanzania\nBiharamulo - Tanzania\nBukoba - Tanzania\nNgara - Tanzania\nKakonko - Tanzania\nKasulu - Tanzania\nKanyato - Tanzania\nUvinza - Tanzania\nKigoma - Tanzania\nMikumi - Tanzania\nIfakara - Tanzania\nKilosa - Tanzania\nChake Chake - Tanzania\nKibiti - Tanzania\nBagamoyo - Tanzania\nKilindoni - Tanzania\nMpwapwa - Tanzania\nNjombe - Tanzania\nIringa - Tanzania\nMasasi - Tanzania\nMtwara - Tanzania\nTunduru - Tanzania\nMbamba Bay - Tanzania\nManyoni - Tanzania\nItigi - Tanzania\nSingida - Tanzania\nNgorongoro - Tanzania\nOldeani - Tanzania\nMbulu - Tanzania\nBabati - Tanzania\nSame - Tanzania\nMoshi - Tanzania\nMusoma - Tanzania\nKorogwe - Tanzania\nTabora - Tanzania\nLindi - Tanzania\nSongea - Tanzania\nTanga - Tanzania\nMwanza - Tanzania\nMorogoro - Tanzania\nDodoma - Tanzania\nArusha - Tanzania\nMbeya - Tanzania\nZanzibar - Tanzania\nDar es Salaam - Tanzania\nMae Hong Son - Thailand\nPhangnga - Thailand\nRanong - Thailand\nKrabi - Thailand\nPhatthalung - Thailand\nSatun - Thailand\nLamphun - Thailand\nKamphaeng Phet - Thailand\nPhichit - Thailand\nPhetchabun - Thailand\nSupham Buri - Thailand\nAng Thong - Thailand\nChainat - Thailand\nNakhon Nayok - Thailand\nSing Buri - Thailand\nNakhon Pathom - Thailand\nPrachuap Khiri Khan - Thailand\nSamut Sakhon - Thailand\nSamut Songkhram - Thailand\nYasothon - Thailand\nChachoengsao - Thailand\nTrat - Thailand\nKalasin - Thailand\nMaha Sarakham - Thailand\nRoi Et - Thailand\nPattani - Thailand\nChumphon - Thailand\nThung Song - Thailand\nTrang - Thailand\nYala - Thailand\nChiang Rai - Thailand\nLampang - Thailand\nNan - Thailand\nPhayao - Thailand\nPhrae - Thailand\nPhitsanulok - Thailand\nSukhothai - Thailand\nUttaradit - Thailand\nKanchanaburi - Thailand\nMae Sot - Thailand\nTak - Thailand\nUthai Thani - Thailand\nLop Buri - Thailand\nPrachin Buri - Thailand\nAyutthaya - Thailand\nPathum Thani - Thailand\nSaraburi - Thailand\nNonthaburi - Thailand\nPhetchaburi - Thailand\nHua Hin - Thailand\nRatchaburi - Thailand\nSamut Prakan - Thailand\nSisaket - Thailand\nSi Racha - Thailand\nChon Buri - Thailand\nChanthaburi - Thailand\nAranyaprathet - Thailand\nRayong - Thailand\nBuriram - Thailand\nChaiyaphum - Thailand\nBua Yai - Thailand\nSurin - Thailand\nLoei - Thailand\nNong Khai - Thailand\nSakhon Nakhon - Thailand\nUdon Thani - Thailand\nNakhon Phanom - Thailand\nNarathiwat - Thailand\nKhon Kaen - Thailand\nPhuket - Thailand\nNakhon Si Thammarat - Thailand\nSongkhla - Thailand\nHat Yai - Thailand\nNakhon Sawan - Thailand\nUbon Ratchathani - Thailand\nSurat Thani - Thailand\nChiang Mai - Thailand\nNakhon Ratchasima - Thailand\nBangkok - Thailand\nFreeport - The Bahamas\nNassau - The Bahamas\nGeorgetown - The Gambia\nBasse Santa Su - The Gambia\nKerewan - The Gambia\nMansa Konko - The Gambia\nBansang - The Gambia\nBrikama - The Gambia\nBanjul - The Gambia\nBassar - Togo\nSotouboua - Togo\nKpalime - Togo\nSokode - Togo\nMango - Togo\nAtakpame - Togo\nLome - Togo\nNeiafu - Tonga\nNukualofa - Tonga\nSan Fernando - Trinidad and Tobago\nPort-of-Spain - Trinidad and Tobago\nMedenine - Tunisia\nKebili - Tunisia\nTataouine - Tunisia\nL\'Ariana - Tunisia\nJendouba - Tunisia\nKasserine - Tunisia\nSdid Bouzid - Tunisia\nSiliana - Tunisia\nMahdia - Tunisia\nMonastir - Tunisia\nZaghouan - Tunisia\nBen Gardane - Tunisia\nZarzis - Tunisia\nDehibat - Tunisia\nTozeur - Tunisia\nBeja - Tunisia\nBizerte - Tunisia\nNabeul - Tunisia\nEl Kef - Tunisia\nQasserine - Tunisia\nGabes - Tunisia\nGafsa - Tunisia\nQairouan - Tunisia\nSfax - Tunisia\nSousse - Tunisia\nTunis - Tunisia\nKirklareli - Turkey\nBilecik - Turkey\nSakarya - Turkey\nKastamonu - Turkey\nBurdur - Turkey\nKirsehir - Turkey\nNevsehir - Turkey\nAntioch - Turkey\nGiresun - Turkey\nSinop - Turkey\nTokat - Turkey\nArtvin - Turkey\nBingol - Turkey\nBitlis - Turkey\nCankiri - Turkey\nNigde - Turkey\nYozgat - Turkey\nGumushane - Turkey\nSiirt - Turkey\nTunceli - Turkey\nAydin - Turkey\nLuleburgaz - Turkey\nIsparta - Turkey\nKutahya - Turkey\nMugla - Turkey\nElazig - Turkey\nKahramanmaras - Turkey\nIcel - Turkey\nCorum - Turkey\nRize - Turkey\nTatvan - Turkey\nPolatli - Turkey\nKarabuk - Turkey\nNusaybin - Turkey\nHakkari - Turkey\nSoke - Turkey\nBalikesir - Turkey\nCanakkale - Turkey\nEdirne - Turkey\nTekirdag - Turkey\nIzmit - Turkey\nBolu - Turkey\nAfyon - Turkey\nDenizli - Turkey\nManisa - Turkey\nAdiyaman - Turkey\nMalatya - Turkey\nTarsus - Turkey\nSamandagi - Turkey\nHatay - Turkey\nIskenderun - Turkey\nAmasya - Turkey\nOrdu - Turkey\nSivas - Turkey\nBafra - Turkey\nErzurum - Turkey\nErzincan - Turkey\nAgri - Turkey\nDiyarbakir - Turkey\nMus - Turkey\nZonguldak - Turkey\nEregli - Turkey\nKaraman - Turkey\nUsak - Turkey\nKilis - Turkey\nKirikkale - Turkey\nKars - Turkey\nMardin - Turkey\nBatman - Turkey\nVan - Turkey\nAdapazari - Turkey\nTrabzon - Turkey\nSanliurfa - Turkey\nEskisehir - Turkey\nAntalya - Turkey\nKayseri - Turkey\nGaziantep - Turkey\nIzmir - Turkey\nBursa - Turkey\nSamsun - Turkey\nKonya - Turkey\nAdana - Turkey\nAnkara - Turkey\nIstanbul - Turkey\nGyzlarbat - Turkmenistan\nCeleken - Turkmenistan\nTejen - Turkmenistan\nBuzmeyin - Turkmenistan\nKoneurgench - Turkmenistan\nBalkanabat - Turkmenistan\nKaka - Turkmenistan\nAtamyrat - Turkmenistan\nDasoguz - Turkmenistan\nTurkmenbasy - Turkmenistan\nTurkmenabat - Turkmenistan\nMary - Turkmenistan\nAshgabat - Turkmenistan\nGrand Turk - Turks and Caicos Islands\nFunafuti - Tuvalu\nKalangala - Uganda\nKumi - Uganda\nKaberamaido - Uganda\nKayunga - Uganda\nIganga - Uganda\nKamuli - Uganda\nPallisa - Uganda\nMpigi - Uganda\nAdjumani - Uganda\nNebbi - Uganda\nKiboga - Uganda\nNakasongola - Uganda\nBombo - Uganda\nMasindi - Uganda\nFort Portal - Uganda\nKibale - Uganda\nSironko - Uganda\nBusia - Uganda\nKatakwi - Uganda\nNtungamo - Uganda\nKisoro - Uganda\nJinja - Uganda\nSoroti - Uganda\nArua - Uganda\nPakwach - Uganda\nMoyo - Uganda\nEntebbe - Uganda\nMubende - Uganda\nMityana - Uganda\nKitgum - Uganda\nLira - Uganda\nMasindi-Port - Uganda\nMbale - Uganda\nTororo - Uganda\nKaabong - Uganda\nMoroto - Uganda\nMasaka - Uganda\nKatwe - Uganda\nMbarara - Uganda\nKabale - Uganda\nKasese - Uganda\nGulu - Uganda\nKampala - Uganda\nMykolayiv - Ukraine\nChernihiv - Ukraine\nKhmelnytskyy - Ukraine\nKamyanets-Podilskyy - Ukraine\nDrohobych - Ukraine\nUzhgorod - Ukraine\nUman - Ukraine\nBrovary - Ukraine\nBila Tserkva - Ukraine\nIllichivsk - Ukraine\nKonotop - Ukraine\nKryvyy Rih - Ukraine\nMakiyivka - Ukraine\nHorlivka - Ukraine\nKramatorsk - Ukraine\nBerdyansk - Ukraine\nDzhankoy - Ukraine\nYevpatoriya - Ukraine\nKerch - Ukraine\nSimferopol - Ukraine\nKherson - Ukraine\nVoznesensk - Ukraine\nNizhyn - Ukraine\nRivne - Ukraine\nChernivtsi - Ukraine\nIvano-Frankivsk - Ukraine\nTernopil - Ukraine\nLutsk - Ukraine\nKovel - Ukraine\nCherkasy - Ukraine\nKirovohrad - Ukraine\nIzmayil - Ukraine\nVinnytsya - Ukraine\nKorosten - Ukraine\nShostka - Ukraine\nNikopol - Ukraine\nKupyansk - Ukraine\nLysychansk - Ukraine\nLuhansk - Ukraine\nPoltava - Ukraine\nKremenchuk - Ukraine\nMelitopol - Ukraine\nZaporizhzhya - Ukraine\nYalta - Ukraine\nChernobyl - Ukraine\nSumy - Ukraine\nMariupol - Ukraine\nLvov - Ukraine\nOdessa - Ukraine\nZhytomyr - Ukraine\nDnipropetrovsk - Ukraine\nDonetsk - Ukraine\nKharkiv - Ukraine\nSevastapol - Ukraine\nKiev - Ukraine\nUmm al Qaywayn - United Arab Emirates\nSharjah - United Arab Emirates\nJabal Ali - United Arab Emirates\nRas al Khaymah - United Arab Emirates\nAl Fujayrah - United Arab Emirates\nAl Ayn - United Arab Emirates\nAbu Dhabi - United Arab Emirates\nDubai - United Arab Emirates\nBangor - United Kingdom\nCanterbury - United Kingdom\nDerby - United Kingdom\nHove - United Kingdom\nNorthampton - United Kingdom\nWolverhampton - United Kingdom\nChelmsford - United Kingdom\nChichester - United Kingdom\nDurham - United Kingdom\nGloucester - United Kingdom\nHereford - United Kingdom\nLancaster - United Kingdom\nLichfield - United Kingdom\nLincoln - United Kingdom\nNewport - United Kingdom\nNewry - United Kingdom\nPerth - United Kingdom\nPreston - United Kingdom\nRipon - United Kingdom\nSt Albans - United Kingdom\nSt Asaph - United Kingdom\nSt Davids - United Kingdom\nEly - United Kingdom\nArmagh - United Kingdom\nSalford - United Kingdom\nCity of Salford - United Kingdom\nSalisbury - United Kingdom\nStirling - United Kingdom\nTruro - United Kingdom\nWakefield - United Kingdom\nCity of Westminster - United Kingdom\nWinchester - United Kingdom\nWorcester - United Kingdom\nCity of Sunderland - United Kingdom\nCity of Wakefield - United Kingdom\nWells - United Kingdom\nGreenock - United Kingdom\nSunderland - United Kingdom\nSouthampton - United Kingdom\nBristol - United Kingdom\nBournemouth - United Kingdom\nOmagh - United Kingdom\nChester - United Kingdom\nSwansea - United Kingdom\nCarlisle - United Kingdom\nSouthend-on-Sea - United Kingdom\nReading - United Kingdom\nLeicester - United Kingdom\nBradford - United Kingdom\nSheffield - United Kingdom\nFort William - United Kingdom\nAyr - United Kingdom\nAberdeen - United Kingdom\nDundee - United Kingdom\nMiddlesbrough - United Kingdom\nCoventry - United Kingdom\nBath - United Kingdom\nExeter - United Kingdom\nCambridge - United Kingdom\nKingston upon Hull - United Kingdom\nLondonderry - United Kingdom\nLisburn - United Kingdom\nPenzance - United Kingdom\nYork - United Kingdom\nBlackpool - United Kingdom\nDumfries - United Kingdom\nScarborough - United Kingdom\nPlymouth - United Kingdom\nIpswich - United Kingdom\nNorwich - United Kingdom\nBrighton - United Kingdom\nKirkwall - United Kingdom\nInverness - United Kingdom\nOxford - United Kingdom\nLuton - United Kingdom\nPortsmouth - United Kingdom\nPeterborough - United Kingdom\nNottingham - United Kingdom\nStoke-on-Trent - United Kingdom\nDover - United Kingdom\nEdinburgh - United Kingdom\nNewcastle - United Kingdom\nLiverpool - United Kingdom\nCardiff - United Kingdom\nWick - United Kingdom\nLeeds - United Kingdom\nLerwick - United Kingdom\nManchester - United Kingdom\nBirmingham - United Kingdom\nBelfast - United Kingdom\nGlasgow - United Kingdom\nLondon - United Kingdom\nCity of London - United Kingdom\nChristiansted - United States Virgin Islands\nColonia del Sacramento - Uruguay\nTrinidad - Uruguay\nFray Bentos - Uruguay\nCanelones - Uruguay\nFlorida - Uruguay\nArtigas - Uruguay\nBaltasar Brum - Uruguay\nTranqueras - Uruguay\nTacuarembo - Uruguay\nPaso de los Toros - Uruguay\nVergara - Uruguay\nTreinta y Tres - Uruguay\nSanta Lucia - Uruguay\nJose Batlle y Ordonez - Uruguay\nMinas - Uruguay\nMaldonado - Uruguay\nPunta del Este - Uruguay\nAigua - Uruguay\nLa Paloma - Uruguay\nCarmelo - Uruguay\nBella Union - Uruguay\nMercedes - Uruguay\nMelo - Uruguay\nRivera - Uruguay\nLascano - Uruguay\nCastillos - Uruguay\nSan Jose de Mayo - Uruguay\nRocha - Uruguay\nPaysandu - Uruguay\nSalto - Uruguay\nDurazno - Uruguay\nMontevideo - Uruguay\nKhujayli - Uzbekistan\nUrgut - Uzbekistan\nKattaqorgon - Uzbekistan\nDenow - Uzbekistan\nGuliston - Uzbekistan\nIskandar - Uzbekistan\nChirchiq - Uzbekistan\nKogon - Uzbekistan\nKhiwa - Uzbekistan\nChimboy - Uzbekistan\nQunghirot - Uzbekistan\nZarafshon - Uzbekistan\nNavoi - Uzbekistan\nShahrisabz - Uzbekistan\nQarshi - Uzbekistan\nQoqon - Uzbekistan\nJizzax - Uzbekistan\nAngren - Uzbekistan\nOlmaliq - Uzbekistan\nMuynoq - Uzbekistan\nTermiz - Uzbekistan\nFargona - Uzbekistan\nNamangan - Uzbekistan\nUrgentch - Uzbekistan\nBukhara - Uzbekistan\nNukus - Uzbekistan\nAndijon - Uzbekistan\nSamarqand - Uzbekistan\nTashkent - Uzbekistan\nLuganville - Vanuatu\nPort Vila - Vanuatu\nVatican City - Vatican (Holy Sea)\nSan Carlos - Venezuela\nSan Felipe - Venezuela\nSan Juan De Los Morros - Venezuela\nLa Asuncion - Venezuela\nGuasdualito - Venezuela\nBarinas - Venezuela\nValera - Venezuela\nCabimas - Venezuela\nCarora - Venezuela\nGuanare - Venezuela\nPuerto la Cruz - Venezuela\nAnaco - Venezuela\nLos Teques - Venezuela\nValle de la Pascua - Venezuela\nOcumare del Tuy - Venezuela\nCarupano - Venezuela\nTrujillo - Venezuela\nSanta Rita - Venezuela\nMachiques - Venezuela\nSan Carlos del Zulia - Venezuela\nPuerto Cabello - Venezuela\nAcarigua - Venezuela\nUpata - Venezuela\nEl Manteco - Venezuela\nChaguaramas - Venezuela\nBarcelona - Venezuela\nEl Tigre - Venezuela\nMaiquetia - Venezuela\nCalabozo - Venezuela\nZaraza - Venezuela\nAltagracia de Orituco - Venezuela\nTucupita - Venezuela\nPorlamar - Venezuela\nSan Fernando de Apure - Venezuela\nBarquisimeto - Venezuela\nMaturin - Venezuela\nCumana - Venezuela\nCoro - Venezuela\nPunto Fijo - Venezuela\nLa Esmeralda - Venezuela\nCiudad Bolivar - Venezuela\nEl Dorado - Venezuela\nMaracay - Venezuela\nMerida - Venezuela\nPuerto Ayacucho - Venezuela\nSan Cristobal - Venezuela\nValencia - Venezuela\nCiudad Guayana - Venezuela\nMaracaibo - Venezuela\nCaracas - Venezuela\nBir Lehlou - Western Sahara\nAl Bayda - Yemen\n\'Ataq - Yemen\nMarib - Yemen\nDhamar - Yemen\nIbb - Yemen\nAsh Shihr - Yemen\nZabid - Yemen\nHajjah - Yemen\nLahij - Yemen\nAl Ghaydah - Yemen\nRida - Yemen\nHadiboh - Yemen\nSaywun - Yemen\nSadah - Yemen\nAl Hudaydah - Yemen\nSayhut - Yemen\nAl Mukalla - Yemen\nTaizz - Yemen\nAden - Yemen\nSanaa - Yemen\nKawambwa - Zambia\nNchelenge - Zambia\nChinsali - Zambia\nKasama - Zambia\nKapiri Mposhi - Zambia\nMumbwa - Zambia\nChingola - Zambia\nChililabombwe - Zambia\nNyimba - Zambia\nLundazi - Zambia\nChipata - Zambia\nMwinilunga - Zambia\nKasempa - Zambia\nSolwezi - Zambia\nChoma - Zambia\nMongu - Zambia\nKaoma - Zambia\nSesheke - Zambia\nLukulu - Zambia\nKalabo - Zambia\nSenanga - Zambia\nMansa - Zambia\nMpika - Zambia\nMbala - Zambia\nLuanshya - Zambia\nNdola - Zambia\nZambezi - Zambia\nKafue - Zambia\nMazabuka - Zambia\nKabwe - Zambia\nMufulira - Zambia\nKitwe - Zambia\nLivingstone - Zambia\nLusaka - Zambia\nMazowe - Zimbabwe\nShamva - Zimbabwe\nVictoria Falls - Zimbabwe\nZvishavane - Zimbabwe\nKwekwe - Zimbabwe\nPlumtree - Zimbabwe\nBeitbridge - Zimbabwe\nGwanda - Zimbabwe\nChiredzi - Zimbabwe\nMasvingo - Zimbabwe\nKaroi - Zimbabwe\nChinhoyi - Zimbabwe\nKariba - Zimbabwe\nHwange - Zimbabwe\nGweru - Zimbabwe\nMutare - Zimbabwe\nKadoma - Zimbabwe\nChitungwiza - Zimbabwe\nHarare - Zimbabwe\nBulawayo - Zimbabwe\nAberdeen - United States\nAbilene - United States\nAiken - United States\nAkron - United States\nAlamogordo - United States\nAlbany - United States\nAlbert Lea - United States\nAlbuquerque - United States\nAlexandria - United States\nAlhambra - United States\nAlice - United States\nAllakaket - United States\nAllen - United States\nAllentown - United States\nAlliance - United States\nAlpena - United States\nAlpine - United States\nAlton - United States\nAltoona - United States\nAmarillo - United States\nAmbler - United States\nAmes - United States\nAnaheim - United States\nAnchorage - United States\nAnderson - United States\nAniak - United States\nAnn Arbor - United States\nAnnapolis - United States\nAntioch - United States\nApalachicola - United States\nAppleton - United States\nArcadia - United States\nArcata - United States\nArdmore - United States\nArlington - United States\nArvada - United States\nAsheville - United States\nAstoria - United States\nAthens - United States\nAtka - United States\nAtlanta - United States\nAtlantic City - United States\nAtqasuk - United States\nAuburn - United States\nAugusta (GA) - United States\nAugusta (ME) - United States\nAurora (CO) - United States\nAurora (IL) - United States\nAustin - United States\nBakersfield - United States\nBaltimore - United States\nBangor - United States\nBar Harbor - United States\nBarlett - United States\nBarrow - United States\nBarstow - United States\nBartlesville - United States\nBaton Rouge - United States\nBattle Creek - United States\nBay City - United States\nBaytown - United States\nBeaufort - United States\nBeaumont - United States\nBeaver Falls - United States\nBeckley - United States\nBeeville - United States\nBelleville - United States\nBellevue - United States\nBellingham - United States\nBemidji - United States\nBend - United States\nBenton Harbor - United States\nBerkeley - United States\nBethel - United States\nBeverly Hills - United States\nBig Delta - United States\nBig Spring - United States\nBillings - United States\nBiloxi - United States\nBinghamton - United States\nBirmingham - United States\nBishop - United States\nBismarck - United States\nBlacksburg - United States\nBloomington - United States\nBoise - United States\nBoston - United States\nBoulder - United States\nBoulder City - United States\nBowling Green - United States\nBozeman - United States\nBrainerd - United States\nBremerton - United States\nBridgeport - United States\nBristol - United States\nBroken Arrow - United States\nBrookings - United States\nBrownsville - United States\nBrownwood - United States\nBrunswick - United States\nBryan - United States\nBuffalo - United States\nBullhead City - United States\nBurbank - United States\nBurley - United States\nBurlington - United States\nButte - United States\nCadillac - United States\nCalais - United States\nCaldwell - United States\nCambridge - United States\nCamden - United States\nCanton - United States\nCantwell - United States\nCape Coral - United States\nCape Girardeau - United States\nCarbondale - United States\nCarlsbad - United States\nCarrollton - United States\nCarson City - United States\nCary - United States\nCasa Grande - United States\nCasper - United States\nCedar City - United States\nCedar Rapids - United States\nCentennial - United States\nCentralia - United States\nCerritos - United States\nChadron - United States\nChandler - United States\nCharleston - United States\nCharlotte - United States\nCharlottesville - United States\nChattanooga - United States\nChesapeake - United States\nCheyenne - United States\nChicago - United States\nChico - United States\nChignik - United States\nChildress - United States\nChula Vista - United States\nCincinnati - United States\nCircle - United States\nClarksburg - United States\nClarksville - United States\nClearwater - United States\nCleburne - United States\nCleveland - United States\nClinton - United States\nClovis - United States\nCody - United States\nCoeur d\'Alene - United States\nCoffeyville - United States\nCold Bay - United States\nCollege Station - United States\nColorado Springs - United States\nColumbia (MO) - United States\nColumbia (SC) - United States\nColumbia (TN) - United States\nColumbus (GA) - United States\nColumbus (OH) - United States\nConcord - United States\nConroe - United States\nConway - United States\nCoos Bay - United States\nCoral Gables - United States\nCoral Springs - United States\nCordova - United States\nCorona - United States\nCorpus Christi - United States\nCorvallis - United States\nCosta Mesa - United States\nCouncil Bluffs - United States\nCovington - United States\nCraig - United States\nCrescent City - United States\nCrestview - United States\nCrookston - United States\nCumberland - United States\nDalhart - United States\nDallas - United States\nDalton - United States\nDaly City - United States\nDanville - United States\nDavenport - United States\nDavie - United States\nDayton - United States\nDaytona Beach - United States\nDearborn - United States\nDecatur - United States\nDel Rio - United States\nDelano - United States\nDeming - United States\nDenali Park - United States\nDenton - United States\nDenver - United States\nDes Moines - United States\nDetroit - United States\nDevils Lake - United States\nDickinson - United States\nDillingham - United States\nDillon - United States\nDodge City - United States\nDothan - United States\nDouglas - United States\nDover (DE) - United States\nDover (NH) - United States\nDowney - United States\nDublin - United States\nDubuque - United States\nDuluth - United States\nDumas - United States\nDurango - United States\nDurham - United States\nEagle - United States\nEagle Pass - United States\nEau Claire - United States\nEdinburg - United States\nEdison - United States\nEl Cajon - United States\nEl Centro - United States\nEl Dorado - United States\nEl Monte - United States\nEl Paso - United States\nElgin - United States\nElizabeth - United States\nElk Grove - United States\nElkhart - United States\nElko - United States\nElmira - United States\nEly - United States\nEmmonak - United States\nEmporia - United States\nEnid - United States\nEnterprise - United States\nErie - United States\nEscanaba - United States\nEscondido - United States\nEugene - United States\nEureka - United States\nEvanston - United States\nEvansville - United States\nEverett - United States\nFairbanks - United States\nFairfield - United States\nFalfurrias - United States\nFall River - United States\nFalse Pass - United States\nFargo - United States\nFaribault - United States\nFarmington - United States\nFayetteville - United States\nFlagstaff - United States\nFlint - United States\nFlorence - United States\nFond du Lac - United States\nFontana - United States\nFort Collins - United States\nFort Lauderdale - United States\nFort Pierce - United States\nFort Smith - United States\nFort Stockton - United States\nFort Wayne - United States\nFort Worth - United States\nFort Yukon - United States\nFrankfort - United States\nFredericksburg - United States\nFreeport - United States\nFremont - United States\nFresno - United States\nFrisco - United States\nFt. Dodge - United States\nFt. Myers - United States\nFt. Worth - United States\nFullerton - United States\nGadsden - United States\nGainesville - United States\nGalena - United States\nGalesburg - United States\nGallup - United States\nGalveston - United States\nGambell - United States\nGarden City - United States\nGarden Grove - United States\nGarland - United States\nGary - United States\nGila Bend - United States\nGilbert - United States\nGillette - United States\nGlasgow - United States\nGlendale (AZ) - United States\nGlendale (CA) - United States\nGlendive - United States\nGlenwood Springs - United States\nGoldsboro - United States\nGoodland - United States\nGoodnews Bay - United States\nGrand Canyon - United States\nGrand Forks - United States\nGrand Island - United States\nGrand Junction - United States\nGrand Prairie - United States\nGrand Rapids - United States\nGrants Pass - United States\nGreat Falls - United States\nGreeley - United States\nGreen Bay - United States\nGreen River - United States\nGreensboro - United States\nGreenville - United States\nGresham - United States\nGulfport - United States\nGulkana - United States\nGunnison - United States\nGuymon - United States\nHagerstown - United States\nHammond - United States\nHampton - United States\nHancock - United States\nHardin - United States\nHarlingen - United States\nHarrisburg - United States\nHarrisonburg - United States\nHartford - United States\nHattiesburg - United States\nHavre - United States\nHays - United States\nHayward - United States\nHelena - United States\nHenderson - United States\nHereford - United States\nHialeah - United States\nHickory - United States\nHigh Point - United States\nHillsboro - United States\nHilo - United States\nHobbs - United States\nHollywood - United States\nHomer - United States\nHomestead - United States\nHonolulu - United States\nHoonah - United States\nHooper Bay - United States\nHopkinsville - United States\nHot Springs - United States\nHoulton - United States\nHouma - United States\nHouston - United States\nHughes - United States\nHuntington - United States\nHuntington Beach - United States\nHuntsville - United States\nHutchinson - United States\nHydaburg - United States\nIdaho Falls - United States\nIndependence - United States\nIndianapolis - United States\nInglewood - United States\nInternational Falls - United States\nIowa City - United States\nIron Mountain - United States\nIronwood - United States\nIrvine - United States\nIrving - United States\nIthaca - United States\nJackson - United States\nJacksonville - United States\nJamestown - United States\nJanesville - United States\nJefferson City - United States\nJersey City - United States\nJohn Day - United States\nJohnson City - United States\nJohnstown - United States\nJoliet - United States\nJonesboro - United States\nJoplin - United States\nJuneau - United States\nJurupa Valley - United States\nKailua-Kona - United States\nKaktovik - United States\nKalamazoo - United States\nKalispell - United States\nKaltag - United States\nKanab - United States\nKankakee - United States\nKansas City (KS) - United States\nKansas City (MO) - United States\nKarluk - United States\nKearney - United States\nKenai - United States\nKennewick - United States\nKenosha - United States\nKent - United States\nKetchikan - United States\nKey West - United States\nKilleen - United States\nKing Salmon - United States\nKingman - United States\nKingsport - United States\nKingsville - United States\nKirksville - United States\nKissimmee - United States\nKitty Hawk - United States\nKivalina - United States\nKlamath Falls - United States\nKnoxville - United States\nKobuk - United States\nKodiak - United States\nKokomo - United States\nKotlit - United States\nKotzebue - United States\nKoyuk - United States\nKoyukuk - United States\nLa Crosse - United States\nLa Grande (IL) - United States\nLaGrange (GA) - United States\nLafayette (IN) - United States\nLafayette (LA) - United States\nLake Charles - United States\nLake City - United States\nLake Havasu City - United States\nLake Minchumina - United States\nLakeland - United States\nLakeville - United States\nLakewood - United States\nLamar - United States\nLancaster (CA) - United States\nLancaster (NY) - United States\nLancaster (OH) - United States\nLancaster (PA) - United States\nLancaster (TX) - United States\nLander - United States\nLansing - United States\nLaramie - United States\nLaredo - United States\nLas Cruces - United States\nLas Vegas - United States\nLaurel - United States\nLawrence - United States\nLawton - United States\nLead - United States\nLeague City - United States\nLeesburg - United States\nLewiston - United States\nLewisville - United States\nLexington - United States\nLihue - United States\nLima - United States\nLincoln - United States\nLittle Rock - United States\nLivonia - United States\nLogan - United States\nLondon - United States\nLong Beach - United States\nLongview - United States\nLos Alamos - United States\nLos Angeles - United States\nLouisville - United States\nLowell - United States\nLubbock - United States\nLufkin - United States\nLumberton - United States\nLynchburg - United States\nLynn - United States\nMacon - United States\nMadison - United States\nMadisonville - United States\nManchester - United States\nManhattan - United States\nMankato - United States\nMansfield - United States\nMarietta - United States\nMarinette - United States\nMarion - United States\nMarquette - United States\nMason City - United States\nMcAlester - United States\nMcAllen - United States\nMcCook - United States\nMcGrath - United States\nMcKinney - United States\nMedford - United States\nMekoryuk - United States\nMelbourne - United States\nMemphis - United States\nMendocino - United States\nMerced - United States\nMeridian - United States\nMesa - United States\nMesquite - United States\nMetairie - United States\nMiami - United States\nMiami Beach - United States\nMiami Gardens - United States\nMidland - United States\nMiles City - United States\nMilwaukee - United States\nMinneapolis - United States\nMinot - United States\nMiramar - United States\nMissoula - United States\nMitchell - United States\nMoab - United States\nMobile - United States\nMobridge - United States\nModesto - United States\nMonroe - United States\nMontana - United States\nMonterey - United States\nMonterey Park - United States\nMontgomery - United States\nMonticello - United States\nMontpelier - United States\nMontrose - United States\nMoorhead - United States\nMoreno Valley - United States\nMorgantown - United States\nMountain View - United States\nMountain Village - United States\nMt. Shasta - United States\nMuncie - United States\nMurfreesboro - United States\nMurrieta - United States\nMuskegon - United States\nMuskogee - United States\nMyrtle Beach - United States\nNacogdoches - United States\nNaperville - United States\nNaples - United States\nNashua - United States\nNashville - United States\nNatchez - United States\nNational City - United States\nNeedles - United States\nNenana - United States\nNephi - United States\nNew Albany - United States\nNew Bedford - United States\nNew Braunfels - United States\nNew Haven - United States\nNew Iberia - United States\nNew London - United States\nNew Orleans - United States\nNew York City - United States\nNewark - United States\nNewhalen - United States\nNewport - United States\nNewport News - United States\nNiagara Falls - United States\nNikolski - United States\nNome - United States\nNorfolk - United States\nNorman - United States\nNorth Charleston - United States\nNorth Las Vegas - United States\nNorth Platte - United States\nNorwalk - United States\nNyac - United States\nOak Ridge - United States\nOakland - United States\nOcala - United States\nOceanside - United States\nOdessa - United States\nOgden - United States\nOklahoma City - United States\nOlathe - United States\nOlympia - United States\nOmaha - United States\nOntario - United States\nOrange - United States\nOrangeburg - United States\nOrlando - United States\nOshkosh - United States\nOttumwa - United States\nOverland Park - United States\nOwensboro - United States\nOxnard - United States\nPaducah - United States\nPalatka - United States\nPalm Bay - United States\nPalm Coast - United States\nPalm Springs (CA) - United States\nPalm Springs (FL) - United States\nPalmdale - United States\nPalmer - United States\nPalo Alto - United States\nPanama City - United States\nParagould - United States\nParkersburg - United States\nParma - United States\nParowan - United States\nPasadena (CA) - United States\nPasadena (TX) - United States\nPaso Robles - United States\nPaterson - United States\nPearland - United States\nPecos - United States\nPembroke Pines - United States\nPendleton - United States\nPensacola - United States\nPeoria (AZ) - United States\nPeoria (IL) - United States\nPerryville - United States\nPetersburg - United States\nPetoskey - United States\nPhiladelphia - United States\nPhoenix - United States\nPierre - United States\nPilot Point - United States\nPine Bluff - United States\nPittsburgh - United States\nPittsfield - United States\nPlano - United States\nPlattsburg - United States\nPocatello - United States\nPoint Hope - United States\nPolson - United States\nPomona - United States\nPompano Beach - United States\nPonca City - United States\nPontiac - United States\nPoplar Bluff - United States\nPort Arthur - United States\nPort Charlotte - United States\nPort Heiden - United States\nPort Lavaca - United States\nPort St. Lucie - United States\nPortland (ME) - United States\nPortland (OR) - United States\nPortsmouth - United States\nPoughkeepsie - United States\nPowell - United States\nPrescott - United States\nPresque Isle - United States\nPrice - United States\nProvidence - United States\nProvo - United States\nPrudhoe Bay - United States\nPueblo - United States\nQuincy (MA) - United States\nQuincy (IL) - United States\nQuinhagak - United States\nRacine - United States\nRaleigh - United States\nRancho Cucamonga - United States\nRapid City - United States\nRaton - United States\nRawlins - United States\nReading - United States\nRed Devil - United States\nRedding - United States\nReno - United States\nRenton - United States\nRhinelander - United States\nRialto - United States\nRichardson - United States\nRichfield - United States\nRichland - United States\nRichmond (CA) - United States\nRichmond (VA) - United States\nRiverside - United States\nRiverton - United States\nRoanoke - United States\nRochester (MN) - United States\nRochester (NY) - United States\nRock Hill - United States\nRock Island - United States\nRockford - United States\nRocky Mount - United States\nRoseburg - United States\nRosemead - United States\nRoseville - United States\nRoswell - United States\nRound Rock - United States\nRowland Heights - United States\nSacramento - United States\nSafford - United States\nSaginaw - United States\nSaint Paul - United States\nSalem - United States\nSalina - United States\nSalinas - United States\nSalisbury - United States\nSalmon - United States\nSalt Lake City - United States\nSan Angelo - United States\nSan Antonio - United States\nSan Bernardino - United States\nSan Diego - United States\nSan Francisco - United States\nSan Gabriel - United States\nSan Jose - United States\nSan Juan - United States\nSan Luis Obispo - United States\nSan Marcos - United States\nSan Mateo - United States\nSan Marino - United States\nSand Point - United States\nSandy Springs - United States\nSanford - United States\nSanta Ana - United States\nSanta Barbara - United States\nSanta Clara - United States\nSanta Clarita - United States\nSanta Cruz - United States\nSanta Fe - United States\nSanta Maria - United States\nSanta Rosa - United States\nSarasota - United States\nSaratoga Springs - United States\nSault Ste. Marie - United States\nSavannah - United States\nSchenectady - United States\nScottsbluff - United States\nScottsdale - United States\nScranton - United States\nSeattle - United States\nSelawik - United States\nSelma - United States\nSeward - United States\nShawnee (KS) - United States\nShawnee (OK) - United States\nSheboygan - United States\nSherman - United States\nShishmaref - United States\nShreveport - United States\nSidney - United States\nSimi Valley - United States\nSioux City - United States\nSioux Falls - United States\nSitka - United States\nSkagway - United States\nSlidell - United States\nSocorro - United States\nSomerville - United States\nSouth Bend - United States\nSouthaven - United States\nSparks - United States\nSpartanburg - United States\nSpencer - United States\nSpokane - United States\nSpring Hill - United States\nSpringfield (IL) - United States\nSpringfield (MA) - United States\nSpringfield (MO) - United States\nSt. Augustine - United States\nSt. Charles - United States\nSt. Cloud - United States\nSt. George - United States\nSt. Joseph - United States\nSt. Louis - United States\nSt. Paul (MO) - United States\nSt. Petersburg - United States\nStamford - United States\nState College - United States\nSterling Heights - United States\nStillwater (MN) - United States\nStillwater (OK) - United States\nStockton - United States\nSumter - United States\nSunnyvale - United States\nSuperior - United States\nSurprise - United States\nSyracuse - United States\nTacoma - United States\nTalkeetna - United States\nTallahassee - United States\nTampa - United States\nTanacross - United States\nTanana - United States\nTeller - United States\nTemecula - United States\nTempe - United States\nTemple - United States\nTemple City - United States\nTerre Haute - United States\nTexarkana - United States\nTexas City - United States\nThermopolis - United States\nThornton - United States\nThousand Oaks - United States\nTillamook - United States\nTitusville - United States\nTogiak - United States\nToledo - United States\nTomah - United States\nTombstone - United States\nTonopah - United States\nTopeka - United States\nTorrance - United States\nTraverse City - United States\nTrenton - United States\nTrinidad - United States\nTruth or Consequences - United States\nTucson - United States\nTucumcari - United States\nTulare - United States\nTulsa - United States\nTununak - United States\nTupelo - United States\nTuscaloosa - United States\nTwin Falls - United States\nTyler - United States\nUkiah - United States\nUnalakleet - United States\nUnalaska - United States\nUrbana - United States\nUtica - United States\nVacaville - United States\nValdez - United States\nValdosta - United States\nVallejo - United States\nVan Horn - United States\nVancouver - United States\nVentura - United States\nVernal - United States\nVernon - United States\nVero Beach - United States\nVicksburg - United States\nVictoria - United States\nVictorville - United States\nVirginia - United States\nVirginia Beach - United States\nVisalia - United States\nVista - United States\nWaco - United States\nWahiawa - United States\nWailuku - United States\nWainwright - United States\nWales - United States\nWalla Walla - United States\nWallace - United States\nWalnut - United States\nWarren - United States\nWashington DC - United States\nWasilla - United States\nWaterbury - United States\nWaterloo - United States\nWatertown - United States\nWaterville - United States\nWaukegan - United States\nWaukesha - United States\nWausau - United States\nWaycross - United States\nWenatchee - United States\nWest Bend - United States\nWest Covina - United States\nWest Jordan - United States\nWest Palm Beach - United States\nWest Valley City - United States\nWestminster (CA) - United States\nWestminster (CO) - United States\nWheeling (IL) - United States\nWheeling (WV) - United States\nWhite Sulphur Springs - United States\nWhittier - United States\nWichita - United States\nWichita Falls - United States\nWilkes Barre - United States\nWillcox - United States\nWilliamsport - United States\nWilliston - United States\nWillmar - United States\nWilmington (DE) - United States\nWilmington (NC) - United States\nWinchester - United States\nWinnemucca - United States\nWinona - United States\nWinslow - United States\nWinston-Salem - United States\nWinter Haven - United States\nWiseman - United States\nWoodbridge - United States\nWoodward - United States\nWorcester - United States\nWrangell - United States\nYakima - United States\nYakutat - United States\nYankton - United States\nYonkers - United States\nYork - United States\nYoungstown - United States\nYuba City - United States\nYuma - United States\nZanesville - United States\nSingapore - Singapore\n';
var $author$project$Helpers$AutoComplete$Model$noCmd = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Helpers$AutoComplete$Model$initialModel = F3(
	function (inputDomID, data, fieldValue) {
		return $author$project$Helpers$AutoComplete$Model$noCmd(
			{
				kH: data,
				au: $elm$core$Maybe$Nothing,
				lQ: inputDomID,
				R: $elm$core$Maybe$Just(fieldValue),
				V: $elm$core$Maybe$Nothing,
				N: fieldValue
			});
	});
var $author$project$Helpers$City$Model$initialModel = F3(
	function (inputDomID, fieldName, fieldValue) {
		var _v0 = A3($author$project$Helpers$AutoComplete$Model$initialModel, inputDomID, $author$project$Core$Helpers$City$Data$cities, fieldValue);
		var autoCompleteModel = _v0.a;
		var autoCompleteAction = _v0.b;
		return _Utils_Tuple2(
			{dm: autoCompleteModel, ct: fieldName, gA: fieldValue},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, autoCompleteAction));
	});
var $author$project$Model$Search$initialModel = function (userKind) {
	var searchFor = function () {
		if (userKind === 1) {
			return 0;
		} else {
			return 1;
		}
	}();
	var _v0 = A3($author$project$Helpers$City$Model$initialModel, 'locationID', 'location', '');
	var location = _v0.a;
	var action = _v0.b;
	var model = {
		cp: 0,
		ln: $author$project$Form$createForm(
			_List_fromArray(
				[
					A3($author$project$Form$fieldListString, 'relationship', _List_Nil, _List_Nil),
					A3($author$project$Form$fieldString, 'location', '', _List_Nil),
					A3($author$project$Form$fieldString, 'gender', '', _List_Nil),
					A3($author$project$Form$fieldString, 'finding', 'Both', _List_Nil),
					A3($author$project$Form$fieldString, 'sort', 'Active', _List_Nil),
					A3($author$project$Form$fieldBool, 'relationshipDropdownState', false, _List_Nil)
				])),
		hy: location,
		iw: $elm$core$Maybe$Nothing,
		iQ: searchFor,
		A: 10
	};
	return _Utils_Tuple2(
		model,
		A2($elm$core$Platform$Cmd$map, $author$project$Type$Search$InputCityMsg, action));
};
var $author$project$Model$UpdatePassword$initialModel = _Utils_Tuple2(
	{
		dk: $elm$core$Maybe$Nothing,
		ln: $author$project$Form$createForm(
			_List_fromArray(
				[
					A3(
					$author$project$Form$fieldString,
					'oldPassword',
					'',
					_List_fromArray(
						[$author$project$Form$Validators$validatePassword])),
					A3(
					$author$project$Form$fieldString,
					'newPassword',
					'',
					_List_fromArray(
						[$author$project$Form$Validators$validatePassword])),
					A3(
					$author$project$Form$fieldString,
					'passwordConfirmation',
					'',
					_List_fromArray(
						[$author$project$Form$Validators$validatePassword]))
				])),
		hi: false
	},
	$elm$core$Platform$Cmd$none);
var $author$project$Type$FaceVerification$NotVerified = {$: 0};
var $author$project$Model$FaceVerification$initialStatus = $author$project$Type$FaceVerification$NotVerified;
var $author$project$Model$initialAuthState = F2(
	function (user, model) {
		var _v0 = $author$project$Model$UpdatePassword$initialModel;
		var updatePasswordModel = _v0.a;
		var updatePasswordCmd = _v0.b;
		var _v1 = $author$project$Model$Search$initialModel(user.ho);
		var searchModel = _v1.a;
		var searchCmd = _v1.b;
		var _v2 = $author$project$Model$RelatedProfiles$initialModel;
		var relatedProfilesModel = _v2.a;
		var relatedProfilesCmd = _v2.b;
		var _v3 = $author$project$Model$Profile$initialModel(user.eX);
		var profileModel = _v3.a;
		var profileCmd = _v3.b;
		var _v4 = model;
		var multiCardsConfig = _v4.mn;
		var currentTime = _v4.kG;
		var apiUrls = _v4.jX;
		var device = _v4.kQ;
		var _v5 = A2($author$project$Model$EmailVerification$initialModel, apiUrls.np, user.eX);
		var emailVerificationModel = _v5.a;
		var emailVerificationCmd = _v5.b;
		var _v6 = A4(
			$author$project$Model$Membership$initialModel,
			device,
			user,
			multiCardsConfig,
			{
				jU: {kp: apiUrls.jV},
				lI: {ko: apiUrls.lJ},
				mm: {ma: apiUrls.ma, mb: apiUrls.mb, mc: apiUrls.mc}
			});
		var membershipModel = _v6.a;
		var membershipCmd = _v6.b;
		var _v7 = A2($author$project$Model$Detail$initialModel, user.eX, $elm$core$Maybe$Nothing);
		var detailModel = _v7.a;
		var detailCmd = _v7.b;
		var _v8 = $author$project$Model$Deactivate$initialModel;
		var deactivateModel = _v8.a;
		var deactivateCmd = _v8.b;
		var _v9 = A2($author$project$Model$Chat$initialModel, user, currentTime);
		var chatModel = _v9.a;
		var chatCmd = _v9.b;
		var _v10 = $author$project$Model$Block$initialModel;
		var blockModel = _v10.a;
		var blockCmd = _v10.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					j1: $elm$core$Maybe$Just(
						{j2: user, j7: blockModel, km: chatModel, kE: $elm$core$Maybe$Nothing, gc: deactivateModel, gj: detailModel, gm: emailVerificationModel, gx: $author$project$Model$FaceVerification$initialStatus, l9: membershipModel, iu: profileModel, iD: relatedProfilesModel, nm: searchModel, n6: updatePasswordModel})
				}),
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Types$OnAuth,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Types$OnChat, chatCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Types$OnEmailVerification, emailVerificationCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Types$OnSearch, searchCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Types$OnRelatedProfiles, relatedProfilesCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Types$OnDetail, detailCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Types$OnProfile, profileCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Types$OnDeactivate, deactivateCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Types$OnUpdatePassword, updatePasswordCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Types$OnMembership, membershipCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Types$OnBlock, blockCmd)
						]))));
	});
var $author$project$Data$Content$InitPosts = {$: 0};
var $author$project$Data$Content$NotSyncCategories = {$: 0};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$RandomProfiles$generateID = function (attributes) {
	return $elm$core$String$toUpper(
		A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2($elm$core$List$sortBy, $elm$core$Tuple$first, attributes))));
};
var $elm$core$String$append = _String_append;
var $author$project$RandomProfiles$stylesheet = '\n  <style>\n  .rp_loading {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding: 10px;\n    border: 1px solid #CCC;\n    border-radius: 10px;\n  }\n  .rp_container {\n    display: flex;\n    justify-content: space-around;\n    flex-wrap: wrap;\n    padding: 0 10px;\n  }\n  .rp_profile {\n    display: flex;\n    flex-direction: column;\n    margin: 10px;\n    padding-bottom: 10px;\n    width: 300px;\n    text-align: center;\n    border: 1px solid #CCC;\n    border-radius: 10px;\n  }\n  .rp_avatar {\n    width: 100%;\n    max-width: 100%;\n    height: 300px;\n    border-radius: 10px;\n    background-repeat: no-repeat;\n    background-position: center center;\n  }\n  .rp_heading {\n    padding: 10px 10px 5px 10px;\n  }\n  .rp_username {\n    font-size: 22px;\n  }\n  .rp_headline {\n    font-size: 16px;\n  }\n  .rp_stats {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin-top: 5px;\n    font-size: 14px;\n  }\n  .rp_stats div {\n    display: flex;\n    align-items: center;\n    margin-right: 5px;\n  }\n  .rp_stats img {\n    margin-right: 2px;\n  }\n  .rp_wantRelationships {\n    margin-top: 5px;\n  }\n  </style>\n  ';
var $author$project$RandomProfiles$initial = A2($elm$core$String$append, $author$project$RandomProfiles$stylesheet, '\n        <div class=\'rp_loading\'>\n          <p>Loading profiles near you...</p>\n        </div>\n      ');
var $author$project$RandomProfiles$Params = F4(
	function (userType, city, gender, limit) {
		return {fX: city, bt: gender, hs: limit, dg: userType};
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$RandomProfiles$findAttribute = F3(
	function (attributes, name, _default) {
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(name)),
						attributes))));
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$RandomProfiles$paramsEncoder = function (_v0) {
	var userType = _v0.dg;
	var city = _v0.fX;
	var gender = _v0.bt;
	var limit = _v0.hs;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userType',
				$elm$json$Json$Encode$string(userType)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(city)),
				_Utils_Tuple2(
				'gender',
				$elm$json$Json$Encode$string(gender)),
				_Utils_Tuple2(
				'limit',
				$elm$json$Json$Encode$int(limit))
			]));
};
var $author$project$RandomProfiles$responseResolver = function (response) {
	switch (response.$) {
		case 4:
			var body = response.b;
			return $elm$core$Result$Ok(body);
		case 1:
			return $elm$core$Result$Err('Http Timeout');
		case 2:
			return $elm$core$Result$Err('Http Network Error');
		default:
			return $elm$core$Result$Err('Http Error');
	}
};
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{jS: false, cg: r.cg, k6: r.nc, lB: r.lB, mf: r.mf, nU: r.nU, ju: $elm$core$Maybe$Nothing, n8: r.n8});
};
var $author$project$RandomProfiles$process = F2(
	function (url, attributes) {
		var getAttribute = $author$project$RandomProfiles$findAttribute(attributes);
		var params = A4(
			$author$project$RandomProfiles$Params,
			A2(getAttribute, 'userType', 'both'),
			A2(getAttribute, 'city', 'New York - United States'),
			A2(getAttribute, 'gender', 'both'),
			A2(
				$elm$core$Maybe$withDefault,
				3,
				$elm$core$String$toInt(
					A2(getAttribute, 'limit', '3'))));
		return $elm$http$Http$task(
			{
				cg: $elm$http$Http$jsonBody(
					$author$project$RandomProfiles$paramsEncoder(params)),
				lB: _List_Nil,
				mf: 'post',
				nc: $elm$http$Http$stringResolver($author$project$RandomProfiles$responseResolver),
				nU: $elm$core$Maybe$Nothing,
				n8: url
			});
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {lM: index, l7: match, mD: number, eR: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{kk: false, mo: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $author$project$Core$Data$Profile$BodyType$bodyTypeShortString = function (bodyType) {
	switch (bodyType) {
		case 0:
			return 'Slim';
		case 1:
			return 'Athletic';
		case 2:
			return 'Average';
		case 3:
			return 'Curvy';
		case 4:
			return 'Flabby';
		case 5:
			return 'Overweight';
		default:
			return 'Other';
	}
};
var $author$project$RandomProfiles$escapeHtml = function (string) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('<|>'));
	var escape = function (_v0) {
		var match = _v0.l7;
		switch (match) {
			case '<':
				return '&lt;';
			case '>':
				return '&gt;';
			default:
				return match;
		}
	};
	return A3($elm$regex$Regex$replace, regex, escape, string);
};
var $elm$core$Basics$round = _Basics_round;
var $author$project$Core$Data$Profile$Height$cmToInches = function (cm) {
	return $elm$core$Basics$round(cm * 0.393700787);
};
var $author$project$Core$Data$Profile$Height$cmToFeetsAndInches = function (height) {
	if (height.$ === 1) {
		return '--';
	} else {
		var cm = height.a;
		var inInches = $author$project$Core$Data$Profile$Height$cmToInches(cm);
		var _v1 = _Utils_Tuple2((inInches / 12) | 0, inInches % 12);
		var feets = _v1.a;
		var inches = _v1.b;
		return $elm$core$String$fromInt(feets) + ('\' ' + ($elm$core$String$fromInt(inches) + '\"'));
	}
};
var $author$project$Core$Data$Profile$Height$heightInImperial = function (height) {
	return $author$project$Core$Data$Profile$Height$cmToFeetsAndInches(height);
};
var $author$project$Core$Data$Profile$WantRelationship$wantRelationshipFullStringReference = function (wantRelationship) {
	switch (wantRelationship) {
		case 0:
			return 'Open Relationship';
		case 1:
			return 'Casual Dating';
		case 2:
			return 'Make Friends';
		case 3:
			return 'Networking';
		case 4:
			return 'Serious Relationship';
		default:
			return 'Travel Companion';
	}
};
var $author$project$Core$Data$Profile$WantRelationship$wantRelationshipsListFullString = function (wantRelationships) {
	return A2($elm$core$List$map, $author$project$Core$Data$Profile$WantRelationship$wantRelationshipFullStringReference, wantRelationships);
};
var $author$project$RandomProfiles$swapPlaceholder = F2(
	function (data, _v0) {
		var match = _v0.l7;
		switch (match) {
			case '{{avatar}}':
				return data.cc;
			case '{{username}}':
				return $author$project$RandomProfiles$escapeHtml(data.dh);
			case '{{headline}}':
				return $author$project$RandomProfiles$escapeHtml(data.cy);
			case '{{height}}':
				return $author$project$Core$Data$Profile$Height$heightInImperial(data.bu);
			case '{{bodyType}}':
				return $author$project$Core$Data$Profile$BodyType$bodyTypeShortString(data.bi);
			case '{{wantRelationships}}':
				return A2(
					$elm$core$String$join,
					', ',
					$author$project$Core$Data$Profile$WantRelationship$wantRelationshipsListFullString(data.b4));
			case '{{primaryLocation}}':
				return data.bP;
			case '{{userType}}':
				var _v2 = _Utils_Tuple2(data.dg, data.bt);
				if (!_v2.a) {
					if (!_v2.b) {
						var _v3 = _v2.a;
						var _v4 = _v2.b;
						return 'Suitor';
					} else {
						var _v5 = _v2.a;
						var _v6 = _v2.b;
						return 'Suitor';
					}
				} else {
					if (!_v2.b) {
						var _v7 = _v2.a;
						var _v8 = _v2.b;
						return 'Date';
					} else {
						var _v9 = _v2.a;
						var _v10 = _v2.b;
						return 'Date';
					}
				}
			default:
				return '';
		}
	});
var $author$project$RandomProfiles$renderProfile = function (data) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('{{.+[^}]}}'));
	return A3(
		$elm$regex$Regex$replace,
		regex,
		$author$project$RandomProfiles$swapPlaceholder(data),
		'\n          <div class="rp_profile animated pulse">\n              <a href="/register" style="background-image:url({{avatar}})" class="rp_avatar animated fadeIn">\n              </a>\n              <div class="rp_heading">\n                <div class="rp_username">{{username}}</div>\n                <div class="rp_headline">{{headline}}</div>\n              </div>\n              <div class="rp_stats">\n                <div><img src="/assets/images/person.svg">{{userType}}</div>\n                <div><img src="/assets/images/height.svg">{{height}}</div>\n                <div><img src="/assets/images/accessibility.svg">{{bodyType}}</div>\n              </div>\n              <div class="rp_stats">\n                <div><img src="/assets/images/location.svg">{{primaryLocation}}</div>\n                <div class="rp_wantRelationships">{{wantRelationships}}</div>\n              </div>\n          </div>\n        ');
};
var $author$project$Core$Data$Profile$BodyType$OtherBodyType = 6;
var $author$project$Core$Data$Profile$Height$OtherHeight = {$: 1};
var $author$project$RandomProfiles$ProfileData = F9(
	function (avatar, userType, gender, username, headline, height, bodyType, wantRelationships, primaryLocation) {
		return {cc: avatar, bi: bodyType, bt: gender, cy: headline, bu: height, bP: primaryLocation, dg: userType, dh: username, b4: wantRelationships};
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Core$Data$Profile$BodyType$Athletic = 1;
var $author$project$Core$Data$Profile$BodyType$Average = 2;
var $author$project$Core$Data$Profile$BodyType$Curvy = 3;
var $author$project$Core$Data$Profile$BodyType$Flabby = 4;
var $author$project$Core$Data$Profile$BodyType$Overweight = 5;
var $author$project$Core$Data$Profile$BodyType$Slim = 0;
var $author$project$Core$Data$Profile$BodyType$toBodyType = function (bodyType) {
	switch (bodyType) {
		case 'Slim':
			return $elm$core$Result$Ok(0);
		case 'Athletic':
			return $elm$core$Result$Ok(1);
		case 'Average':
			return $elm$core$Result$Ok(2);
		case 'Curvy':
			return $elm$core$Result$Ok(3);
		case 'Flabby':
			return $elm$core$Result$Ok(4);
		case 'Overweight':
			return $elm$core$Result$Ok(5);
		case 'OtherBodyType':
			return $elm$core$Result$Ok(6);
		default:
			return $elm$core$Result$Err('Body type field is invalid.');
	}
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$RandomProfiles$bodyTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$BodyType$toBodyType,
		$elm$core$Result$withDefault(6)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$Gender$Female = 1;
var $author$project$Core$Data$Profile$Gender$Male = 0;
var $author$project$Core$Data$Profile$Gender$toGender = function (gender) {
	switch (gender) {
		case 'Male':
			return $elm$core$Result$Ok(0);
		case 'Female':
			return $elm$core$Result$Ok(1);
		default:
			return $elm$core$Result$Err('Gender field is invalid.');
	}
};
var $author$project$RandomProfiles$genderDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$Gender$toGender,
		$elm$core$Result$withDefault(1)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$Height$CM = function (a) {
	return {$: 0, a: a};
};
var $author$project$Core$Data$Profile$Height$toHeight = function (string) {
	var _v0 = $elm$core$String$toInt(string);
	if (!_v0.$) {
		var height = _v0.a;
		return $elm$core$Result$Ok(
			$author$project$Core$Data$Profile$Height$CM(height));
	} else {
		return $elm$core$Result$Ok($author$project$Core$Data$Profile$Height$OtherHeight);
	}
};
var $author$project$RandomProfiles$heightDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$Height$toHeight,
		$elm$core$Result$withDefault($author$project$Core$Data$Profile$Height$OtherHeight)),
	$elm$json$Json$Decode$string);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$RandomProfiles$Sponsor = 0;
var $author$project$RandomProfiles$Sugar = 1;
var $author$project$RandomProfiles$userTypeDecoder = function () {
	var convert = function (str) {
		switch (str) {
			case 'sponsor':
				return $elm$json$Json$Decode$succeed(0);
			case 'sugar':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid message kind: ' + str);
		}
	};
	return A2($elm$json$Json$Decode$andThen, convert, $elm$json$Json$Decode$string);
}();
var $author$project$Core$Data$Profile$WantRelationship$OpenRelationship = 0;
var $author$project$Core$Data$Profile$WantRelationship$CasualDating = 1;
var $author$project$Core$Data$Profile$WantRelationship$MakeFriends = 2;
var $author$project$Core$Data$Profile$WantRelationship$Networking = 3;
var $author$project$Core$Data$Profile$WantRelationship$SeriousRelationship = 4;
var $author$project$Core$Data$Profile$WantRelationship$TravelCompanion = 5;
var $author$project$Core$Data$Profile$WantRelationship$toWantRelationship = function (idealRelationship) {
	switch (idealRelationship) {
		case 'OpenRelationship':
			return $elm$core$Result$Ok(0);
		case 'CasualDating':
			return $elm$core$Result$Ok(1);
		case 'MakeFriends':
			return $elm$core$Result$Ok(2);
		case 'Networking':
			return $elm$core$Result$Ok(3);
		case 'SeriousRelationship':
			return $elm$core$Result$Ok(4);
		case 'TravelCompanion':
			return $elm$core$Result$Ok(5);
		default:
			return $elm$core$Result$Err('Ideal relationship is invalid.');
	}
};
var $author$project$RandomProfiles$wantRelationshipDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$WantRelationship$toWantRelationship,
		$elm$core$Result$withDefault(0)),
	$elm$json$Json$Decode$string);
var $author$project$RandomProfiles$responseDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'primaryLocation',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'wantRelationships',
		$elm$json$Json$Decode$list($author$project$RandomProfiles$wantRelationshipDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'bodyType',
			$author$project$RandomProfiles$bodyTypeDecoder,
			6,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'height',
				$author$project$RandomProfiles$heightDecoder,
				$author$project$Core$Data$Profile$Height$OtherHeight,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'headline',
					$elm$json$Json$Decode$string,
					'',
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'username',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'gender',
							$author$project$RandomProfiles$genderDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'userType',
								$author$project$RandomProfiles$userTypeDecoder,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'avatar',
									$elm$json$Json$Decode$string,
									'',
									$elm$json$Json$Decode$succeed($author$project$RandomProfiles$ProfileData))))))))));
var $author$project$RandomProfiles$renderResult = function (result) {
	if (!result.$) {
		var data = result.a;
		var _v1 = A2(
			$elm$json$Json$Decode$decodeString,
			$elm$json$Json$Decode$list($author$project$RandomProfiles$responseDecoder),
			data);
		if (!_v1.$) {
			var profiles = _v1.a;
			return $author$project$RandomProfiles$stylesheet + ('<div class=\"rp_container\">' + (A2(
				$elm$core$String$join,
				'',
				A2($elm$core$List$map, $author$project$RandomProfiles$renderProfile, profiles)) + '</div>'));
		} else {
			var error = _v1.a;
			return '<h1>Error occurred in malformed data: ' + ($elm$json$Json$Decode$errorToString(error) + '</h1>');
		}
	} else {
		var error = result.a;
		return '<h1>Error occurred requesting data: ' + (error + '</h1>');
	}
};
var $author$project$RandomProfiles$tag = 'RandomProfiles';
var $author$project$Model$Content$initialModel = function (getRandomProfilesUrl) {
	return {
		I: $author$project$Data$Content$NotSyncCategories,
		aU: $elm$core$Dict$empty,
		ax: $elm$core$Dict$empty,
		er: 10,
		M: $author$project$Data$Content$InitPosts,
		ir: '',
		aB: $elm$core$Dict$empty,
		bV: _List_fromArray(
			[
				{
				aS: $author$project$RandomProfiles$generateID,
				dV: $author$project$RandomProfiles$initial,
				es: $author$project$RandomProfiles$process(getRandomProfilesUrl),
				ey: $author$project$RandomProfiles$renderResult,
				c9: $author$project$RandomProfiles$tag
			}
			])
	};
};
var $elm$regex$Regex$contains = _Regex_contains;
var $author$project$Form$Validators$validateEmail = function (email) {
	return A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('\\S+@\\S+\\.\\S+')),
		email) ? $elm$core$Result$Ok(email) : $elm$core$Result$Err('Please enter a valid email.');
};
var $author$project$Model$ForgetPassword$initialModel = {
	dk: $elm$core$Maybe$Nothing,
	ln: $author$project$Form$createForm(
		_List_fromArray(
			[
				A3(
				$author$project$Form$fieldString,
				'email',
				'',
				_List_fromArray(
					[$author$project$Form$Validators$validateEmail]))
			])),
	hi: false
};
var $author$project$Model$Login$initialModel = {
	dk: $elm$core$Maybe$Nothing,
	ln: $author$project$Form$createForm(
		_List_fromArray(
			[
				A3(
				$author$project$Form$fieldString,
				'email',
				'',
				_List_fromArray(
					[$author$project$Form$Validators$validateEmail])),
				A3(
				$author$project$Form$fieldString,
				'password',
				'',
				_List_fromArray(
					[$author$project$Form$Validators$validatePassword]))
			])),
	W: $elm$core$Maybe$Nothing
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $author$project$Helpers$Validators$invalidSugarRoleWords = _List_fromArray(
	['daddy', 'dadddy', 'dadi', 'daddi', 'papi', 'mom', 'moma', 'mommy', 'mammy', 'mama', 'momma', 'mommma', 'mommas', 'mommi', 'mummy', 'mumma', 'baby']);
var $author$project$Helpers$Validators$invalidSugarWords = _List_fromArray(
	['sugar', 'suga', 'shugar', 'shuga', 'suggar', 'sugga', 'suugar', 'sugarr', 'sugr']);
var $author$project$Helpers$Validators$invalidCombinedWords = function () {
	var combine = function (word) {
		return A2(
			$elm$core$List$map,
			function (role) {
				return _Utils_ap(word, role);
			},
			$author$project$Helpers$Validators$invalidSugarRoleWords);
	};
	return $elm$core$List$concat(
		A2($elm$core$List$map, combine, $author$project$Helpers$Validators$invalidSugarWords));
}();
var $author$project$Helpers$Validators$allInvalidCombinations = $elm$core$List$concat(
	_List_fromArray(
		[$author$project$Helpers$Validators$invalidSugarWords, $author$project$Helpers$Validators$invalidSugarRoleWords, $author$project$Helpers$Validators$invalidCombinedWords]));
var $elm$core$String$toLower = _String_toLower;
var $author$project$Helpers$Validators$containsNoSugarWords = function (unsantiziedString) {
	var string = $elm$core$String$toLower(unsantiziedString);
	var _v0 = A2(
		$elm$core$List$filter,
		function (word) {
			return A2($elm$core$String$contains, word, string);
		},
		$author$project$Helpers$Validators$allInvalidCombinations);
	if (!_v0.b) {
		return $elm$core$Result$Ok(string);
	} else {
		var sugarWords = _v0;
		return $elm$core$Result$Err(
			'Suggestive keywords are not allowed: ' + A2($elm$core$String$join, ', ', sugarWords));
	}
};
var $author$project$Form$Validators$isNotEmpty = function (string) {
	return ($elm$core$String$length(string) > 0) ? $elm$core$Result$Ok(string) : $elm$core$Result$Err('This field cannot be empty');
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $author$project$Form$Validators$validateIsAlphaNumeric = function (value) {
	var regex = function (_char) {
		return A2(
			$elm$regex$Regex$contains,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[a-zA-Z0-9]')),
			$elm$core$String$fromChar(_char));
	};
	return A2($elm$core$String$all, regex, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err('Field can only contains letters and numbers.');
};
var $author$project$Form$Validators$validateUsername = function (username) {
	return A2(
		$elm$core$Result$mapError,
		$elm$core$Basics$always('No spaces. Username must only contain letters and numbers.'),
		A2(
			$elm$core$Result$andThen,
			$author$project$Form$Validators$validateIsAlphaNumeric,
			A2($author$project$Form$Validators$validateMinChars, 3, username)));
};
var $author$project$Model$Register$initialModel = {
	dk: $elm$core$Maybe$Nothing,
	ln: $author$project$Form$createForm(
		_List_fromArray(
			[
				A3(
				$author$project$Form$fieldString,
				'userKind',
				'',
				_List_fromArray(
					[$author$project$Form$Validators$isNotEmpty])),
				A3(
				$author$project$Form$fieldString,
				'wantGender',
				'',
				_List_fromArray(
					[$author$project$Form$Validators$isNotEmpty])),
				A3(
				$author$project$Form$fieldString,
				'email',
				'',
				_List_fromArray(
					[$author$project$Form$Validators$validateEmail])),
				A3(
				$author$project$Form$fieldString,
				'username',
				'',
				_List_fromArray(
					[$author$project$Form$Validators$validateUsername, $author$project$Helpers$Validators$containsNoSugarWords])),
				A3(
				$author$project$Form$fieldString,
				'gender',
				'',
				_List_fromArray(
					[$author$project$Form$Validators$isNotEmpty])),
				A3(
				$author$project$Form$fieldString,
				'password',
				'',
				_List_fromArray(
					[$author$project$Form$Validators$validatePassword])),
				A3(
				$author$project$Form$fieldString,
				'passwordConfirmation',
				'',
				_List_fromArray(
					[$author$project$Form$Validators$validatePassword]))
			])),
	hi: false
};
var $author$project$Data$Alert$Danger = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $truqu$elm_md5$MD5$emptyWords = A2($elm$core$Array$repeat, 16, 0);
var $truqu$elm_md5$MD5$addUnsigned = F2(
	function (x, y) {
		return 4294967295 & (x + y);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $truqu$elm_md5$MD5$rotateLeft = F2(
	function (bits, input) {
		return (input << bits) | (input >>> (32 - bits));
	});
var $truqu$elm_md5$MD5$cmn = F8(
	function (fun, a, b, c, d, x, s, ac) {
		return A2(
			$truqu$elm_md5$MD5$addUnsigned,
			b,
			A2(
				$truqu$elm_md5$MD5$rotateLeft,
				s,
				A2(
					$truqu$elm_md5$MD5$addUnsigned,
					a,
					A2(
						$truqu$elm_md5$MD5$addUnsigned,
						ac,
						A2(
							$truqu$elm_md5$MD5$addUnsigned,
							A3(fun, b, c, d),
							x)))));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $truqu$elm_md5$MD5$f = F3(
	function (x, y, z) {
		return z ^ (x & (y ^ z));
	});
var $truqu$elm_md5$MD5$ff = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$f, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$g = F3(
	function (x, y, z) {
		return y ^ (z & (x ^ y));
	});
var $truqu$elm_md5$MD5$gg = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$g, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$h = F3(
	function (x, y, z) {
		return z ^ (x ^ y);
	});
var $truqu$elm_md5$MD5$hh = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$h, a, b, c, d, x, s, ac);
	});
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $truqu$elm_md5$MD5$i = F3(
	function (x, y, z) {
		return y ^ (x | (~z));
	});
var $truqu$elm_md5$MD5$ii = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$i, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$hex_ = F2(
	function (xs, acc) {
		var a = acc.b5;
		var b = acc.cd;
		var c = acc.cj;
		var d = acc.cn;
		if ((((((((((((((((xs.b && xs.b.b) && xs.b.b.b) && xs.b.b.b.b) && xs.b.b.b.b.b) && xs.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && (!xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b)) {
			var x0 = xs.a;
			var _v1 = xs.b;
			var x1 = _v1.a;
			var _v2 = _v1.b;
			var x2 = _v2.a;
			var _v3 = _v2.b;
			var x3 = _v3.a;
			var _v4 = _v3.b;
			var x4 = _v4.a;
			var _v5 = _v4.b;
			var x5 = _v5.a;
			var _v6 = _v5.b;
			var x6 = _v6.a;
			var _v7 = _v6.b;
			var x7 = _v7.a;
			var _v8 = _v7.b;
			var x8 = _v8.a;
			var _v9 = _v8.b;
			var x9 = _v9.a;
			var _v10 = _v9.b;
			var x10 = _v10.a;
			var _v11 = _v10.b;
			var x11 = _v11.a;
			var _v12 = _v11.b;
			var x12 = _v12.a;
			var _v13 = _v12.b;
			var x13 = _v13.a;
			var _v14 = _v13.b;
			var x14 = _v14.a;
			var _v15 = _v14.b;
			var x15 = _v15.a;
			var s44 = 21;
			var s43 = 15;
			var s42 = 10;
			var s41 = 6;
			var s34 = 23;
			var s33 = 16;
			var s32 = 11;
			var s31 = 4;
			var s24 = 20;
			var s23 = 14;
			var s22 = 9;
			var s21 = 5;
			var s14 = 22;
			var s13 = 17;
			var s12 = 12;
			var s11 = 7;
			var d00 = d;
			var c00 = c;
			var b00 = b;
			var a00 = a;
			var a01 = A7($truqu$elm_md5$MD5$ff, a00, b00, c00, d00, x0, s11, 3614090360);
			var d01 = A7($truqu$elm_md5$MD5$ff, d00, a01, b00, c00, x1, s12, 3905402710);
			var c01 = A7($truqu$elm_md5$MD5$ff, c00, d01, a01, b00, x2, s13, 606105819);
			var b01 = A7($truqu$elm_md5$MD5$ff, b00, c01, d01, a01, x3, s14, 3250441966);
			var a02 = A7($truqu$elm_md5$MD5$ff, a01, b01, c01, d01, x4, s11, 4118548399);
			var d02 = A7($truqu$elm_md5$MD5$ff, d01, a02, b01, c01, x5, s12, 1200080426);
			var c02 = A7($truqu$elm_md5$MD5$ff, c01, d02, a02, b01, x6, s13, 2821735955);
			var b02 = A7($truqu$elm_md5$MD5$ff, b01, c02, d02, a02, x7, s14, 4249261313);
			var a03 = A7($truqu$elm_md5$MD5$ff, a02, b02, c02, d02, x8, s11, 1770035416);
			var d03 = A7($truqu$elm_md5$MD5$ff, d02, a03, b02, c02, x9, s12, 2336552879);
			var c03 = A7($truqu$elm_md5$MD5$ff, c02, d03, a03, b02, x10, s13, 4294925233);
			var b03 = A7($truqu$elm_md5$MD5$ff, b02, c03, d03, a03, x11, s14, 2304563134);
			var a04 = A7($truqu$elm_md5$MD5$ff, a03, b03, c03, d03, x12, s11, 1804603682);
			var d04 = A7($truqu$elm_md5$MD5$ff, d03, a04, b03, c03, x13, s12, 4254626195);
			var c04 = A7($truqu$elm_md5$MD5$ff, c03, d04, a04, b03, x14, s13, 2792965006);
			var b04 = A7($truqu$elm_md5$MD5$ff, b03, c04, d04, a04, x15, s14, 1236535329);
			var a05 = A7($truqu$elm_md5$MD5$gg, a04, b04, c04, d04, x1, s21, 4129170786);
			var d05 = A7($truqu$elm_md5$MD5$gg, d04, a05, b04, c04, x6, s22, 3225465664);
			var c05 = A7($truqu$elm_md5$MD5$gg, c04, d05, a05, b04, x11, s23, 643717713);
			var b05 = A7($truqu$elm_md5$MD5$gg, b04, c05, d05, a05, x0, s24, 3921069994);
			var a06 = A7($truqu$elm_md5$MD5$gg, a05, b05, c05, d05, x5, s21, 3593408605);
			var d06 = A7($truqu$elm_md5$MD5$gg, d05, a06, b05, c05, x10, s22, 38016083);
			var c06 = A7($truqu$elm_md5$MD5$gg, c05, d06, a06, b05, x15, s23, 3634488961);
			var b06 = A7($truqu$elm_md5$MD5$gg, b05, c06, d06, a06, x4, s24, 3889429448);
			var a07 = A7($truqu$elm_md5$MD5$gg, a06, b06, c06, d06, x9, s21, 568446438);
			var d07 = A7($truqu$elm_md5$MD5$gg, d06, a07, b06, c06, x14, s22, 3275163606);
			var c07 = A7($truqu$elm_md5$MD5$gg, c06, d07, a07, b06, x3, s23, 4107603335);
			var b07 = A7($truqu$elm_md5$MD5$gg, b06, c07, d07, a07, x8, s24, 1163531501);
			var a08 = A7($truqu$elm_md5$MD5$gg, a07, b07, c07, d07, x13, s21, 2850285829);
			var d08 = A7($truqu$elm_md5$MD5$gg, d07, a08, b07, c07, x2, s22, 4243563512);
			var c08 = A7($truqu$elm_md5$MD5$gg, c07, d08, a08, b07, x7, s23, 1735328473);
			var b08 = A7($truqu$elm_md5$MD5$gg, b07, c08, d08, a08, x12, s24, 2368359562);
			var a09 = A7($truqu$elm_md5$MD5$hh, a08, b08, c08, d08, x5, s31, 4294588738);
			var d09 = A7($truqu$elm_md5$MD5$hh, d08, a09, b08, c08, x8, s32, 2272392833);
			var c09 = A7($truqu$elm_md5$MD5$hh, c08, d09, a09, b08, x11, s33, 1839030562);
			var b09 = A7($truqu$elm_md5$MD5$hh, b08, c09, d09, a09, x14, s34, 4259657740);
			var a10 = A7($truqu$elm_md5$MD5$hh, a09, b09, c09, d09, x1, s31, 2763975236);
			var d10 = A7($truqu$elm_md5$MD5$hh, d09, a10, b09, c09, x4, s32, 1272893353);
			var c10 = A7($truqu$elm_md5$MD5$hh, c09, d10, a10, b09, x7, s33, 4139469664);
			var b10 = A7($truqu$elm_md5$MD5$hh, b09, c10, d10, a10, x10, s34, 3200236656);
			var a11 = A7($truqu$elm_md5$MD5$hh, a10, b10, c10, d10, x13, s31, 681279174);
			var d11 = A7($truqu$elm_md5$MD5$hh, d10, a11, b10, c10, x0, s32, 3936430074);
			var c11 = A7($truqu$elm_md5$MD5$hh, c10, d11, a11, b10, x3, s33, 3572445317);
			var b11 = A7($truqu$elm_md5$MD5$hh, b10, c11, d11, a11, x6, s34, 76029189);
			var a12 = A7($truqu$elm_md5$MD5$hh, a11, b11, c11, d11, x9, s31, 3654602809);
			var d12 = A7($truqu$elm_md5$MD5$hh, d11, a12, b11, c11, x12, s32, 3873151461);
			var c12 = A7($truqu$elm_md5$MD5$hh, c11, d12, a12, b11, x15, s33, 530742520);
			var b12 = A7($truqu$elm_md5$MD5$hh, b11, c12, d12, a12, x2, s34, 3299628645);
			var a13 = A7($truqu$elm_md5$MD5$ii, a12, b12, c12, d12, x0, s41, 4096336452);
			var d13 = A7($truqu$elm_md5$MD5$ii, d12, a13, b12, c12, x7, s42, 1126891415);
			var c13 = A7($truqu$elm_md5$MD5$ii, c12, d13, a13, b12, x14, s43, 2878612391);
			var b13 = A7($truqu$elm_md5$MD5$ii, b12, c13, d13, a13, x5, s44, 4237533241);
			var a14 = A7($truqu$elm_md5$MD5$ii, a13, b13, c13, d13, x12, s41, 1700485571);
			var d14 = A7($truqu$elm_md5$MD5$ii, d13, a14, b13, c13, x3, s42, 2399980690);
			var c14 = A7($truqu$elm_md5$MD5$ii, c13, d14, a14, b13, x10, s43, 4293915773);
			var b14 = A7($truqu$elm_md5$MD5$ii, b13, c14, d14, a14, x1, s44, 2240044497);
			var a15 = A7($truqu$elm_md5$MD5$ii, a14, b14, c14, d14, x8, s41, 1873313359);
			var d15 = A7($truqu$elm_md5$MD5$ii, d14, a15, b14, c14, x15, s42, 4264355552);
			var c15 = A7($truqu$elm_md5$MD5$ii, c14, d15, a15, b14, x6, s43, 2734768916);
			var b15 = A7($truqu$elm_md5$MD5$ii, b14, c15, d15, a15, x13, s44, 1309151649);
			var a16 = A7($truqu$elm_md5$MD5$ii, a15, b15, c15, d15, x4, s41, 4149444226);
			var d16 = A7($truqu$elm_md5$MD5$ii, d15, a16, b15, c15, x11, s42, 3174756917);
			var c16 = A7($truqu$elm_md5$MD5$ii, c15, d16, a16, b15, x2, s43, 718787259);
			var b16 = A7($truqu$elm_md5$MD5$ii, b15, c16, d16, a16, x9, s44, 3951481745);
			var b17 = A2($truqu$elm_md5$MD5$addUnsigned, b00, b16);
			var c17 = A2($truqu$elm_md5$MD5$addUnsigned, c00, c16);
			var d17 = A2($truqu$elm_md5$MD5$addUnsigned, d00, d16);
			var a17 = A2($truqu$elm_md5$MD5$addUnsigned, a00, a16);
			return {b5: a17, cd: b17, cj: c17, cn: d17};
		} else {
			return acc;
		}
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $truqu$elm_md5$MD5$iget = F2(
	function (index, array) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, index, array));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $truqu$elm_md5$MD5$consume = F2(
	function (_char, _v0) {
		var hashState = _v0.a;
		var _v1 = _v0.b;
		var byteCount = _v1.a;
		var words = _v1.b;
		var totalByteCount = _v0.c;
		var wordCount = (byteCount / 4) | 0;
		var oldWord = A2($truqu$elm_md5$MD5$iget, wordCount, words);
		var bytePosition = 8 * (byteCount % 4);
		var code = _char << bytePosition;
		var newWord = oldWord | code;
		var newWords = A3($elm$core$Array$set, wordCount, newWord, words);
		return (byteCount === 63) ? _Utils_Tuple3(
			A2(
				$truqu$elm_md5$MD5$hex_,
				$elm$core$Array$toList(newWords),
				hashState),
			_Utils_Tuple2(0, $truqu$elm_md5$MD5$emptyWords),
			totalByteCount + 1) : _Utils_Tuple3(
			hashState,
			_Utils_Tuple2(byteCount + 1, newWords),
			totalByteCount + 1);
	});
var $truqu$elm_md5$MD5$finishUp = function (_v0) {
	var hashState = _v0.a;
	var _v1 = _v0.b;
	var byteCount = _v1.a;
	var words = _v1.b;
	var totalByteCount = _v0.c;
	var wordCount = (byteCount / 4) | 0;
	var oldWord = A2($truqu$elm_md5$MD5$iget, wordCount, words);
	var bytePosition = 8 * (byteCount % 4);
	var code = 128 << bytePosition;
	var newWord = oldWord | code;
	var newWords = A3($elm$core$Array$set, wordCount, newWord, words);
	return (wordCount < 14) ? function (x) {
		return A2($truqu$elm_md5$MD5$hex_, x, hashState);
	}(
		$elm$core$Array$toList(
			A3(
				$elm$core$Array$set,
				15,
				totalByteCount >>> 29,
				A3($elm$core$Array$set, 14, totalByteCount << 3, newWords)))) : function (x) {
		return A2(
			$truqu$elm_md5$MD5$hex_,
			x,
			A2(
				$truqu$elm_md5$MD5$hex_,
				$elm$core$Array$toList(newWords),
				hashState));
	}(
		$elm$core$Array$toList(
			A3(
				$elm$core$Array$set,
				15,
				totalByteCount >>> 29,
				A3($elm$core$Array$set, 14, totalByteCount << 3, $truqu$elm_md5$MD5$emptyWords))));
};
var $elm$core$String$foldl = _String_foldl;
var $zwilias$elm_utf_tools$String$UTF8$utf32ToUtf8 = F3(
	function (add, _char, acc) {
		return (_char < 128) ? A2(add, _char, acc) : ((_char < 2048) ? A2(
			add,
			128 | (63 & _char),
			A2(add, 192 | (_char >>> 6), acc)) : ((_char < 65536) ? A2(
			add,
			128 | (63 & _char),
			A2(
				add,
				128 | (63 & (_char >>> 6)),
				A2(add, 224 | (_char >>> 12), acc))) : A2(
			add,
			128 | (63 & _char),
			A2(
				add,
				128 | (63 & (_char >>> 6)),
				A2(
					add,
					128 | (63 & (_char >>> 12)),
					A2(add, 240 | (_char >>> 18), acc))))));
	});
var $zwilias$elm_utf_tools$String$UTF8$foldl = F3(
	function (op, initialAcc, input) {
		return A3(
			$elm$core$String$foldl,
			F2(
				function (_char, acc) {
					return A3(
						$zwilias$elm_utf_tools$String$UTF8$utf32ToUtf8,
						op,
						$elm$core$Char$toCode(_char),
						acc);
				}),
			initialAcc,
			input);
	});
var $truqu$elm_md5$MD5$State = F4(
	function (a, b, c, d) {
		return {b5: a, cd: b, cj: c, cn: d};
	});
var $truqu$elm_md5$MD5$initialHashState = A4($truqu$elm_md5$MD5$State, 1732584193, 4023233417, 2562383102, 271733878);
var $truqu$elm_md5$MD5$hash = function (input) {
	return $truqu$elm_md5$MD5$finishUp(
		A3(
			$zwilias$elm_utf_tools$String$UTF8$foldl,
			$truqu$elm_md5$MD5$consume,
			_Utils_Tuple3(
				$truqu$elm_md5$MD5$initialHashState,
				_Utils_Tuple2(0, $truqu$elm_md5$MD5$emptyWords),
				0),
			input));
};
var $truqu$elm_md5$MD5$bytes = function (string) {
	var _v0 = $truqu$elm_md5$MD5$hash(string);
	var a = _v0.b5;
	var b = _v0.cd;
	var c = _v0.cj;
	var d = _v0.cn;
	return _List_fromArray(
		[a & 255, (a >>> 8) & 255, (a >>> 16) & 255, (a >>> 24) & 255, b & 255, (b >>> 8) & 255, (b >>> 16) & 255, (b >>> 24) & 255, c & 255, (c >>> 8) & 255, (c >>> 16) & 255, (c >>> 24) & 255, d & 255, (d >>> 8) & 255, (d >>> 16) & 255, (d >>> 24) & 255]);
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $truqu$elm_md5$MD5$toHex = function (_byte) {
	switch (_byte) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return 'a';
		case 11:
			return 'b';
		case 12:
			return 'c';
		case 13:
			return 'd';
		case 14:
			return 'e';
		case 15:
			return 'f';
		default:
			return _Utils_ap(
				$truqu$elm_md5$MD5$toHex((_byte / 16) | 0),
				$truqu$elm_md5$MD5$toHex(_byte % 16));
	}
};
var $truqu$elm_md5$MD5$hex = function (s) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (b, acc) {
				return _Utils_ap(
					acc,
					A3(
						$elm$core$String$padLeft,
						2,
						'0',
						$truqu$elm_md5$MD5$toHex(b)));
			}),
		'',
		$truqu$elm_md5$MD5$bytes(s));
};
var $author$project$Data$Alert$generateID = function (alert) {
	switch (alert.$) {
		case 0:
			var text = alert.a;
			return $truqu$elm_md5$MD5$hex('success-' + text);
		case 1:
			var text = alert.a;
			return $truqu$elm_md5$MD5$hex('info-' + text);
		case 2:
			var text = alert.a;
			return $truqu$elm_md5$MD5$hex('failure-' + text);
		case 3:
			var text = alert.a;
			return $truqu$elm_md5$MD5$hex('warning-' + text);
		default:
			var text = alert.a;
			return $truqu$elm_md5$MD5$hex('danger-' + text);
	}
};
var $author$project$Data$Alert$addAlert = F2(
	function (alert, _v0) {
		var alerts = _v0;
		return A3(
			$elm$core$Dict$insert,
			$author$project$Data$Alert$generateID(alert),
			alert,
			alerts);
	});
var $author$project$Data$Alert$addDanger = F2(
	function (text, alerts) {
		return A2(
			$author$project$Data$Alert$addAlert,
			$author$project$Data$Alert$Danger(text),
			alerts);
	});
var $author$project$NativeBridge$RawPushNotification = F2(
	function (kind, data) {
		return {kH: data, ho: kind};
	});
var $author$project$NativeBridge$rawNotificationDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$NativeBridge$RawPushNotification,
	A2($elm$json$Json$Decode$field, 'k', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'd', $elm$json$Json$Decode$value));
var $author$project$NativeBridge$decodeRawPushNotification = function (json) {
	return A2($elm$json$Json$Decode$decodeString, $author$project$NativeBridge$rawNotificationDecoder, json);
};
var $author$project$Data$PushNotification$Chat = $elm$core$Basics$identity;
var $author$project$Data$Chat$Partner$Partner = F6(
	function (uid, username, avatar, status, sponsorLevel, lastRead) {
		return {cc: avatar, aV: lastRead, bY: sponsorLevel, eQ: status, eX: uid, dh: username};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Core$Data$Profile$SponsorLevel$Bronze = 1;
var $author$project$Core$Data$Profile$SponsorLevel$Diamond = 5;
var $author$project$Core$Data$Profile$SponsorLevel$Free = 0;
var $author$project$Core$Data$Profile$SponsorLevel$Gold = 3;
var $author$project$Core$Data$Profile$SponsorLevel$Platinum = 4;
var $author$project$Core$Data$Profile$SponsorLevel$Silver = 2;
var $author$project$Core$Data$Profile$SponsorLevel$Star = 6;
var $author$project$Core$Data$Profile$SponsorLevel$Ultimate = 7;
var $author$project$Core$Data$Profile$SponsorLevel$toSponsorLevel = function (sponsorLevel) {
	switch (sponsorLevel) {
		case 0:
			return $elm$core$Result$Ok(0);
		case 1:
			return $elm$core$Result$Ok(1);
		case 2:
			return $elm$core$Result$Ok(2);
		case 3:
			return $elm$core$Result$Ok(3);
		case 4:
			return $elm$core$Result$Ok(4);
		case 5:
			return $elm$core$Result$Ok(5);
		case 6:
			return $elm$core$Result$Ok(6);
		case 7:
			return $elm$core$Result$Ok(7);
		default:
			return $elm$core$Result$Err('SponsorLevel field is invalid.');
	}
};
var $author$project$Core$Data$Profile$SponsorLevel$sponsorLevelDecoder = function () {
	var convert = function (_int) {
		var _v0 = $author$project$Core$Data$Profile$SponsorLevel$toSponsorLevel(_int);
		if (!_v0.$) {
			var sponsorLevel = _v0.a;
			return $elm$json$Json$Decode$succeed(sponsorLevel);
		} else {
			return $elm$json$Json$Decode$fail(
				'Invalid int for sponsor level ' + $elm$core$String$fromInt(_int));
		}
	};
	return A2($elm$json$Json$Decode$andThen, convert, $elm$json$Json$Decode$int);
}();
var $author$project$Data$Chat$Partner$Status = F2(
	function (user, room) {
		return {a: room, W: user};
	});
var $author$project$Data$Chat$RoomStatus$Blocked = 1;
var $author$project$Data$Chat$RoomStatus$toStatus = function (status) {
	switch (status) {
		case 'Available':
			return $elm$core$Result$Ok(0);
		case 'Blocked':
			return $elm$core$Result$Ok(1);
		default:
			return $elm$core$Result$Err('Status field is invalid.');
	}
};
var $author$project$Data$Chat$RoomStatus$decoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$Chat$RoomStatus$toStatus,
		$elm$core$Result$withDefault(0)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$Status$InCompleted = 1;
var $author$project$Core$Data$Profile$Status$Cloaked = 3;
var $author$project$Core$Data$Profile$Status$Completed = 0;
var $author$project$Core$Data$Profile$Status$Deactivated = 2;
var $author$project$Core$Data$Profile$Status$toStatus = function (status) {
	switch (status) {
		case 'Completed':
			return $elm$core$Result$Ok(0);
		case 'InCompleted':
			return $elm$core$Result$Ok(1);
		case 'Deactivated':
			return $elm$core$Result$Ok(2);
		case 'Cloaked':
			return $elm$core$Result$Ok(3);
		default:
			return $elm$core$Result$Err('Status field is invalid.');
	}
};
var $author$project$Core$Data$Profile$Status$statusDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$Status$toStatus,
		$elm$core$Result$withDefault(1)),
	$elm$json$Json$Decode$string);
var $author$project$Data$Chat$Partner$statusDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'room',
	$author$project$Data$Chat$RoomStatus$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'user',
		$author$project$Core$Data$Profile$Status$statusDecoder,
		$elm$json$Json$Decode$succeed($author$project$Data$Chat$Partner$Status)));
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$Firebase$Firestore$timestampDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$time$Time$millisToPosix),
	$elm$json$Json$Decode$int);
var $author$project$Data$Chat$Partner$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lastRead',
	$author$project$Firebase$Firestore$timestampDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sponsorLevel',
		$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$author$project$Data$Chat$Partner$statusDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'avatar',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'username',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uid',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Data$Chat$Partner$Partner)))))));
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Data$PushNotification$fromRaw = function (_v0) {
	var kind = _v0.ho;
	var data = _v0.kH;
	if (kind === 'chat') {
		var _v2 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$Chat$Partner$decoder, data);
		if (_v2.$ === 1) {
			var jdError = _v2.a;
			return $elm$core$Result$Err(jdError);
		} else {
			var partner = _v2.a;
			return $elm$core$Result$Ok(partner);
		}
	} else {
		return $elm$core$Result$Err(
			A2($elm$json$Json$Decode$Failure, 'Invalid kind: ' + kind, $elm$json$Json$Encode$null));
	}
};
var $author$project$Data$PushNotification$decode = function (json) {
	var _v0 = $author$project$NativeBridge$decodeRawPushNotification(json);
	if (!_v0.$) {
		var rawPushNotification = _v0.a;
		return $author$project$Data$PushNotification$fromRaw(rawPushNotification);
	} else {
		var jdError = _v0.a;
		return $elm$core$Result$Err(jdError);
	}
};
var $author$project$Data$Chat$Room$emptyRoom = function (partner) {
	return {bx: '...', ai: $author$project$Data$Chat$Room$futurePosix, q: partner, df: 0};
};
var $author$project$Data$Chat$Room$get = F2(
	function (partnerID, _v0) {
		var rooms = _v0.ao;
		return A2($elm$core$Dict$get, partnerID, rooms);
	});
var $author$project$Data$Chat$Partner$getNewer = F2(
	function (p1, p2) {
		return (_Utils_cmp(
			$elm$time$Time$posixToMillis(p1.aV),
			$elm$time$Time$posixToMillis(p2.aV)) > 0) ? p1 : p2;
	});
var $author$project$Data$Chat$Room$getRoomID = F3(
	function (partnerID, userID, userKind) {
		if (!userKind) {
			return _Utils_ap(userID, partnerID);
		} else {
			return _Utils_ap(partnerID, userID);
		}
	});
var $author$project$Data$Chat$Room$getRemoteRoom = F3(
	function (channelID, partnerID, user) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getDoc(
				$author$project$Firebase$Firestore$doc(
					'/chat/room/lastMessages/' + A3($author$project$Data$Chat$Room$getRoomID, partnerID, user.eX, user.ho))));
	});
var $author$project$Data$Chat$Room$insert = F2(
	function (room, state) {
		var updatedState = _Utils_update(
			state,
			{
				ao: A3($elm$core$Dict$insert, room.q.eX, room, state.ao)
			});
		var _v0 = state.f8;
		if (_v0.$ === 1) {
			return updatedState;
		} else {
			var partner = _v0.a.q;
			return _Utils_eq(room.q.eX, partner.eX) ? _Utils_update(
				updatedState,
				{
					f8: $elm$core$Maybe$Just(room)
				}) : updatedState;
		}
	});
var $author$project$Data$Chat$Room$create = F2(
	function (partner, state) {
		var _v0 = A2($author$project$Data$Chat$Room$get, partner.eX, state);
		if (_v0.$ === 1) {
			var newRoom = $author$project$Data$Chat$Room$emptyRoom(partner);
			return _Utils_Tuple3(
				newRoom,
				A2($author$project$Data$Chat$Room$insert, newRoom, state),
				A3($author$project$Data$Chat$Room$getRemoteRoom, state.aa.d5, partner.eX, state.W));
		} else {
			var room = _v0.a;
			return _Utils_Tuple3(
				room,
				A2(
					$author$project$Data$Chat$Room$insert,
					_Utils_update(
						room,
						{
							q: A2($author$project$Data$Chat$Partner$getNewer, room.q, partner)
						}),
					state),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Chat$createRoom = F2(
	function (partner, _v0) {
		var state = _v0;
		var _v1 = A2($author$project$Data$Chat$Room$create, partner, state.a);
		var room = _v1.a;
		var roomState = _v1.b;
		var cmd = _v1.c;
		return _Utils_Tuple3(
			room,
			_Utils_update(
				state,
				{a: roomState}),
			cmd);
	});
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Data$Route$routeUrl = {
	jN: '/blog/dating-app-reviews/happymatches',
	j7: '/block',
	kb: '/blog',
	km: '/chat',
	ky: '/contact-us',
	kJ: '/delete-my-profile',
	lb: '/face-verification',
	lc: '/face-verification-processing',
	lh: '/favorite-profile',
	li: '/favorited-me',
	lm: '/forget-password',
	lG: '/',
	l1: '/login',
	l5: '/logout',
	l9: '/membership',
	mi: '/mobile',
	mp: '/my-profile',
	m$: '/privacy-policy',
	m1: '/deleting-my-profile',
	m2: $elm$core$Basics$append('/user-detail/'),
	na: '/register',
	nm: '/search',
	ny: '/register/sponsor/success',
	nH: '/sugar-baby',
	nJ: '/sugar-daddy',
	nM: '/sugar-momma',
	nN: '/register/date/success',
	nS: '/terms-and-conditions',
	n6: '/update-password',
	oe: '/viewed-me'
};
var $author$project$Data$Chat$Room$getCurrent = function (state) {
	return state.f8;
};
var $author$project$Firebase$Internal$Port$elmFirestoreStop = _Platform_outgoingPort('elmFirestoreStop', $elm$json$Json$Encode$string);
var $author$project$Firebase$Firestore$stop = function (queryID) {
	return $author$project$Firebase$Internal$Port$elmFirestoreStop(queryID);
};
var $author$project$Data$Chat$Partner$unsubPartnerOnlineStatus = function (channelID) {
	return $author$project$Firebase$Firestore$stop(channelID);
};
var $author$project$Data$Chat$Room$removeCurrent = function (state) {
	var _v0 = $author$project$Data$Chat$Room$getCurrent(state);
	if (_v0.$ === 1) {
		return _Utils_Tuple2(
			_Utils_update(
				state,
				{f8: $elm$core$Maybe$Nothing}),
			$elm$core$Platform$Cmd$none);
	} else {
		var partner = _v0.a.q;
		return _Utils_Tuple2(
			_Utils_update(
				state,
				{f8: $elm$core$Maybe$Nothing}),
			$author$project$Data$Chat$Partner$unsubPartnerOnlineStatus(
				state.aa.ea(partner.eX)));
	}
};
var $author$project$Data$Chat$setChatPartnerIDForApp = function (partnerID) {
	return $author$project$NativeBridge$sendCustom(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'function',
					$elm$json$Json$Encode$string('setCurrentChatPartnerID')),
					_Utils_Tuple2(
					'partnerID',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, partnerID)))
				])));
};
var $author$project$Firebase$Firestore$serverTimestamp = $elm$json$Json$Encode$string('ELM-FIREBASE::ENCODED-SERVER-TIME-STAMP');
var $author$project$Data$Chat$Partner$partialReadUser = function (userKindString) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				userKindString + '.unreadCount',
				$elm$json$Json$Encode$int(0)),
				_Utils_Tuple2(userKindString + '.lastRead', $author$project$Firebase$Firestore$serverTimestamp)
			]));
};
var $author$project$Data$Chat$Room$encodeUserLastRead = function (userKind) {
	if (userKind === 1) {
		return A2(
			$elm$json$Json$Encode$encode,
			0,
			$author$project$Data$Chat$Partner$partialReadUser('sugar'));
	} else {
		return A2(
			$elm$json$Json$Encode$encode,
			0,
			$author$project$Data$Chat$Partner$partialReadUser('sponsor'));
	}
};
var $author$project$Data$Chat$Room$setRoomAsRead = function (room) {
	return _Utils_update(
		room,
		{df: 0});
};
var $author$project$Firebase$Firestore$UpdateDoc = function (a) {
	return {$: 3, a: a};
};
var $author$project$Firebase$Firestore$updateDoc = F2(
	function (json, document) {
		return A2(
			$author$project$Firebase$Firestore$Query,
			document,
			$author$project$Firebase$Firestore$UpdateDoc(json));
	});
var $author$project$Data$Chat$Room$setRemoteRoomAsRead = F3(
	function (channelID, room, state) {
		return (room.df > 0) ? _Utils_Tuple2(
			A2(
				$author$project$Data$Chat$Room$insert,
				$author$project$Data$Chat$Room$setRoomAsRead(room),
				state),
			A2(
				$author$project$Firebase$Firestore$send,
				channelID,
				A2(
					$author$project$Firebase$Firestore$updateDoc,
					$author$project$Data$Chat$Room$encodeUserLastRead(state.W.ho),
					$author$project$Firebase$Firestore$doc(
						'/chat/room/lastMessages/' + A3($author$project$Data$Chat$Room$getRoomID, room.q.eX, state.W.eX, state.W.ho))))) : _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
	});
var $author$project$Data$Chat$Partner$subPartnerOnlineStatus = F2(
	function (channelID, partnerID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$onSnapshotDoc(
				$author$project$Firebase$Firestore$doc('/backend/search/profiles/' + partnerID)));
	});
var $author$project$Data$Chat$Room$setCurrent = F2(
	function (room, state) {
		var partnerID = room.q.eX;
		var subPartnerOnlineStatus = A2(
			$author$project$Data$Chat$Partner$subPartnerOnlineStatus,
			state.aa.ea(partnerID),
			partnerID);
		var _v0 = A3(
			$author$project$Data$Chat$Room$setRemoteRoomAsRead,
			state.aa.bE,
			room,
			_Utils_update(
				state,
				{
					f8: $elm$core$Maybe$Just(room)
				}));
		var updatedState = _v0.a;
		var roomReadCmd = _v0.b;
		var _v1 = $author$project$Data$Chat$Room$getCurrent(state);
		if (_v1.$ === 1) {
			return _Utils_Tuple2(
				updatedState,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[subPartnerOnlineStatus, roomReadCmd])));
		} else {
			var partner = _v1.a.q;
			return _Utils_Tuple2(
				updatedState,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							subPartnerOnlineStatus,
							roomReadCmd,
							$author$project$Data$Chat$Partner$unsubPartnerOnlineStatus(
							state.aa.ea(partner.eX))
						])));
		}
	});
var $author$project$Firebase$Firestore$Desc = 1;
var $author$project$Data$Chat$Message$Loading = 0;
var $author$project$Firebase$Firestore$Lt = 3;
var $author$project$Data$Chat$Message$dbUserFields = function (_v0) {
	var user = _v0.W;
	var _v1 = user.ho;
	if (!_v1) {
		return _Utils_Tuple2('sponsorID', 'sugarID');
	} else {
		return _Utils_Tuple2('sugarID', 'sponsorID');
	}
};
var $author$project$Data$Chat$Message$futurePosix = $elm$time$Time$millisToPosix(9999999999999);
var $author$project$Firebase$Firestore$Limit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Firebase$Firestore$limit = F2(
	function (num, _v0) {
		var path = _v0.a;
		var clauses = _v0.b;
		return A2(
			$author$project$Firebase$Firestore$Collection,
			path,
			_Utils_ap(
				clauses,
				_List_fromArray(
					[
						$author$project$Firebase$Firestore$Limit(num)
					])));
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Data$Chat$Message$list = F2(
	function (state, partnerID) {
		return $elm$core$Dict$values(
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Dict$empty,
				A2($elm$core$Dict$get, partnerID, state.az)));
	});
var $author$project$Data$Chat$Message$loadLimit = 20;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Firebase$Firestore$OrderBy = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Firebase$Firestore$orderBy = F3(
	function (fieldPath, direction, _v0) {
		var path = _v0.a;
		var clauses = _v0.b;
		return A2(
			$author$project$Firebase$Firestore$Collection,
			path,
			_Utils_ap(
				clauses,
				_List_fromArray(
					[
						A2($author$project$Firebase$Firestore$OrderBy, fieldPath, direction)
					])));
	});
var $author$project$Data$Chat$Message$loadOldMessages = F3(
	function (channelID, partnerID, state) {
		var oldestMessageCreatedAt = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Chat$Message$futurePosix,
			A2(
				$elm$core$Maybe$map,
				$elm$time$Time$millisToPosix,
				$elm$core$List$minimum(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeL,
							$elm$time$Time$posixToMillis,
							function ($) {
								return $.cm;
							}),
						A2($author$project$Data$Chat$Message$list, state, partnerID)))));
		var _v0 = $author$project$Data$Chat$Message$dbUserFields(state);
		var userDbField = _v0.a;
		var partnerDbField = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				state,
				{
					H: A3($elm$core$Dict$insert, partnerID, 0, state.H)
				}),
			A2(
				$author$project$Firebase$Firestore$send,
				channelID,
				$author$project$Firebase$Firestore$getCollection(
					A2(
						$author$project$Firebase$Firestore$limit,
						$author$project$Data$Chat$Message$loadLimit,
						A3(
							$author$project$Firebase$Firestore$orderBy,
							'createdAt',
							1,
							A4(
								$author$project$Firebase$Firestore$whereTime,
								'createdAt',
								3,
								oldestMessageCreatedAt,
								A4(
									$author$project$Firebase$Firestore$where_,
									partnerDbField,
									2,
									partnerID,
									A4(
										$author$project$Firebase$Firestore$where_,
										userDbField,
										2,
										state.W.eX,
										$author$project$Firebase$Firestore$collection('/chat/history/messages')))))))));
	});
var $author$project$Firebase$Firestore$Asc = 0;
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Chat$Message$subNewMessages = F3(
	function (partnerID, currentTime, state) {
		var newestMessageCreatedAt = A2(
			$elm$core$Maybe$withDefault,
			currentTime,
			A2(
				$elm$core$Maybe$map,
				$elm$time$Time$millisToPosix,
				$elm$core$List$maximum(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeL,
							$elm$time$Time$posixToMillis,
							function ($) {
								return $.cm;
							}),
						A2($author$project$Data$Chat$Message$list, state, partnerID)))));
		var _v0 = $author$project$Data$Chat$Message$dbUserFields(state);
		var userDbField = _v0.a;
		var partnerDbField = _v0.b;
		return A2(
			$author$project$Firebase$Firestore$send,
			state.aa.eb(partnerID),
			$author$project$Firebase$Firestore$onSnapshotCollection(
				A3(
					$author$project$Firebase$Firestore$orderBy,
					'createdAt',
					0,
					A4(
						$author$project$Firebase$Firestore$whereTime,
						'createdAt',
						0,
						newestMessageCreatedAt,
						A4(
							$author$project$Firebase$Firestore$where_,
							partnerDbField,
							2,
							partnerID,
							A4(
								$author$project$Firebase$Firestore$where_,
								userDbField,
								2,
								state.W.eX,
								$author$project$Firebase$Firestore$collection('/chat/history/messages')))))));
	});
var $author$project$Data$Chat$Message$subscribe = F3(
	function (partnerID, currentTime, state) {
		var _v0 = A2($elm$core$Dict$get, partnerID, state.H);
		if (_v0.$ === 1) {
			var _v1 = A3(
				$author$project$Data$Chat$Message$loadOldMessages,
				state.aa.d6(partnerID),
				partnerID,
				state);
			var updatedState = _v1.a;
			var loadCmd = _v1.b;
			return _Utils_Tuple2(
				updatedState,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A3($author$project$Data$Chat$Message$subNewMessages, partnerID, currentTime, state),
							loadCmd
						])));
		} else {
			return _Utils_Tuple2(
				state,
				A3($author$project$Data$Chat$Message$subNewMessages, partnerID, currentTime, state));
		}
	});
var $author$project$Data$Chat$Message$unsubscribe = F2(
	function (partnerID, state) {
		return $author$project$Firebase$Firestore$stop(
			state.aa.eb(partnerID));
	});
var $author$project$Data$Chat$setCurrentRoom = F3(
	function (currentRoom, currentTime, _v0) {
		var state = _v0;
		var _v1 = _Utils_Tuple2(state.a.f8, currentRoom);
		if (_v1.a.$ === 1) {
			if (_v1.b.$ === 1) {
				var _v2 = _v1.a;
				var _v3 = _v1.b;
				return _Utils_Tuple2(
					state,
					$author$project$Data$Chat$setChatPartnerIDForApp($elm$core$Maybe$Nothing));
			} else {
				var _v6 = _v1.a;
				var newRoom = _v1.b.a;
				var _v7 = A2($author$project$Data$Chat$Room$setCurrent, newRoom, state.a);
				var roomState = _v7.a;
				var roomCmd = _v7.b;
				var _v8 = A3($author$project$Data$Chat$Message$subscribe, newRoom.q.eX, currentTime, state.h);
				var messageState = _v8.a;
				var messageCmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{h: messageState, a: roomState}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								roomCmd,
								messageCmd,
								$author$project$Data$Chat$setChatPartnerIDForApp(
								$elm$core$Maybe$Just(newRoom.q.eX))
							])));
			}
		} else {
			if (_v1.b.$ === 1) {
				var oldRoom = _v1.a.a;
				var _v4 = _v1.b;
				var _v5 = $author$project$Data$Chat$Room$removeCurrent(state.a);
				var roomState = _v5.a;
				var roomCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{a: roomState}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Data$Chat$Message$unsubscribe, oldRoom.q.eX, state.h),
								roomCmd,
								$author$project$Data$Chat$setChatPartnerIDForApp($elm$core$Maybe$Nothing)
							])));
			} else {
				var oldRoom = _v1.a.a;
				var newRoom = _v1.b.a;
				if (_Utils_eq(oldRoom.q.eX, newRoom.q.eX)) {
					return _Utils_Tuple2(
						state,
						$author$project$Data$Chat$setChatPartnerIDForApp(
							$elm$core$Maybe$Just(newRoom.q.eX)));
				} else {
					var _v9 = A2($author$project$Data$Chat$Room$setCurrent, newRoom, state.a);
					var roomState = _v9.a;
					var roomCmd = _v9.b;
					var _v10 = A3($author$project$Data$Chat$Message$subscribe, newRoom.q.eX, currentTime, state.h);
					var messageState = _v10.a;
					var messageCmd = _v10.b;
					return _Utils_Tuple2(
						_Utils_update(
							state,
							{h: messageState, a: roomState}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									roomCmd,
									messageCmd,
									A2($author$project$Data$Chat$Message$unsubscribe, oldRoom.q.eX, state.h),
									$author$project$Data$Chat$setChatPartnerIDForApp(
									$elm$core$Maybe$Just(newRoom.q.eX))
								])));
				}
			}
		}
	});
var $author$project$Types$Noop = {$: 17};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$NativeBridge$Desktop = {$: 0};
var $author$project$NativeBridge$WebApp = function (a) {
	return {$: 0, a: a};
};
var $author$project$NativeBridge$isDesktop = function (device) {
	return _Utils_eq(
		device,
		$author$project$NativeBridge$WebApp($author$project$NativeBridge$Desktop));
};
var $author$project$Model$Chat$pageChatInputID = 'PageChatInputID';
var $author$project$Model$Chat$setFocusToChatInputOnDesktop = function (device) {
	return $author$project$NativeBridge$isDesktop(device) ? A2(
		$elm$core$Task$attempt,
		$elm$core$Basics$always($author$project$Types$Noop),
		$elm$browser$Browser$Dom$focus($author$project$Model$Chat$pageChatInputID)) : $elm$core$Platform$Cmd$none;
};
var $author$project$Model$Chat$handleCreateRoom = F3(
	function (partner, authState, appModel) {
		var _v0 = authState;
		var chat = _v0.km;
		var _v1 = A2($author$project$Data$Chat$createRoom, partner, chat.i8);
		var room = _v1.a;
		var chatState = _v1.b;
		var createRoomCmd = _v1.c;
		var _v2 = A3(
			$author$project$Data$Chat$setCurrentRoom,
			$elm$core$Maybe$Just(room),
			appModel.kG,
			chatState);
		var updatedChatState = _v2.a;
		var setCurrentRoomCmd = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				appModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								km: _Utils_update(
									chat,
									{i8: updatedChatState})
							}))
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$browser$Browser$Navigation$pushUrl, appModel.bD, $author$project$Data$Route$routeUrl.km),
						createRoomCmd,
						setCurrentRoomCmd,
						$author$project$Model$Chat$setFocusToChatInputOnDesktop(appModel.kQ)
					])));
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Model$PushNotification$handleNotification = F2(
	function (notification, _v0) {
		var appModel = _v0.a;
		var appCmd = _v0.b;
		var _v1 = appModel.j1;
		if (_v1.$ === 1) {
			return _Utils_Tuple2(appModel, appCmd);
		} else {
			var authState = _v1.a;
			var partner = notification;
			return A2(
				$elm$core$Tuple$mapSecond,
				function (chatCmd) {
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[appCmd, chatCmd]));
				},
				A3($author$project$Model$Chat$handleCreateRoom, partner, authState, appModel));
		}
	});
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.iy;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.lo,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.iA,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.il,
					_Utils_ap(http, url.dE)),
				url.mM)));
};
var $author$project$Model$PushNotification$initialWithAuthState = F2(
	function (maybeNotificationJSON, _v0) {
		var appModel = _v0.a;
		var appCmd = _v0.b;
		var initialSubModelSideEffect = A2(
			$elm$browser$Browser$Navigation$replaceUrl,
			appModel.bD,
			$elm$url$Url$toString(appModel.n8));
		if (maybeNotificationJSON.$ === 1) {
			return _Utils_Tuple2(
				appModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[appCmd, initialSubModelSideEffect])));
		} else {
			var json = maybeNotificationJSON.a;
			var _v2 = $author$project$Data$PushNotification$decode(json);
			if (_v2.$ === 1) {
				var decodeError = _v2.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							b8: A2(
								$author$project$Data$Alert$addDanger,
								$elm$json$Json$Decode$errorToString(decodeError),
								appModel.b8)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[appCmd, initialSubModelSideEffect])));
			} else {
				var notification = _v2.a;
				return A2(
					$author$project$Model$PushNotification$handleNotification,
					notification,
					_Utils_Tuple2(appModel, appCmd));
			}
		}
	});
var $author$project$Firebase$Auth$OnAuthStateChanged = {$: 9};
var $author$project$Firebase$Auth$encodeCommand = function (command) {
	switch (command.$) {
		case 0:
			var email = command.a;
			var password = command.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'command',
					$elm$json$Json$Encode$string('CreateUserWithEmailAndPassword')),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(password))
				]);
		case 1:
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'command',
					$elm$json$Json$Encode$string('SendEmailVerification'))
				]);
		case 2:
			var email = command.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'command',
					$elm$json$Json$Encode$string('SendPasswordResetEmail')),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email))
				]);
		case 3:
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'command',
					$elm$json$Json$Encode$string('SignInAnonymously'))
				]);
		case 4:
			var email = command.a;
			var password = command.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'command',
					$elm$json$Json$Encode$string('SignInWithEmailAndPassword')),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(password))
				]);
		case 5:
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'command',
					$elm$json$Json$Encode$string('SignOut'))
				]);
		case 6:
			var password = command.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'command',
					$elm$json$Json$Encode$string('UpdatePassword')),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(password))
				]);
		case 7:
			var displayName = command.a;
			var photoURL = command.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'command',
					$elm$json$Json$Encode$string('UpdateProfile')),
					_Utils_Tuple2(
					'displayName',
					$elm$json$Json$Encode$string(displayName)),
					_Utils_Tuple2(
					'photoURL',
					$elm$json$Json$Encode$string(photoURL))
				]);
		case 8:
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'command',
					$elm$json$Json$Encode$string('Delete'))
				]);
		default:
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'command',
					$elm$json$Json$Encode$string('OnAuthStateChanged'))
				]);
	}
};
var $author$project$Firebase$Auth$commandToJson = function (command) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'requestType',
					$elm$json$Json$Encode$string('auth')),
				$author$project$Firebase$Auth$encodeCommand(command))));
};
var $author$project$Firebase$Auth$send = function (command) {
	return $author$project$Firebase$Internal$Port$elmFirebaseSend(
		$author$project$Firebase$Auth$commandToJson(command));
};
var $author$project$Firebase$Auth$onAuthStateChanged = $author$project$Firebase$Auth$send($author$project$Firebase$Auth$OnAuthStateChanged);
var $author$project$Data$BundleID$sync = F2(
	function (url, channelID) {
		return (A2($elm$core$String$startsWith, '192.168', url.dE) || ((url.dE === 'localhost') || (url.dE === 'happymatches-deployment.firebaseapp.com'))) ? $elm$core$Platform$Cmd$none : A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$onSnapshotDoc(
				$author$project$Firebase$Firestore$doc('/app/bundle')));
	});
var $author$project$NativeBridge$Android = function (a) {
	return {$: 1, a: a};
};
var $author$project$NativeBridge$Ios = function (a) {
	return {$: 0, a: a};
};
var $author$project$NativeBridge$Mobile = function (a) {
	return {$: 1, a: a};
};
var $author$project$NativeBridge$MobileApp = function (a) {
	return {$: 1, a: a};
};
var $author$project$NativeBridge$toDevice = F2(
	function (device, appVersion) {
		switch (device) {
			case 'WebApp Desktop':
				return $author$project$NativeBridge$WebApp($author$project$NativeBridge$Desktop);
			case 'WebApp Mobile Ios':
				return $author$project$NativeBridge$WebApp(
					$author$project$NativeBridge$Mobile(
						$author$project$NativeBridge$Ios(appVersion)));
			case 'WebApp Mobile Android':
				return $author$project$NativeBridge$WebApp(
					$author$project$NativeBridge$Mobile(
						$author$project$NativeBridge$Android(appVersion)));
			case 'MobileApp Ios':
				return $author$project$NativeBridge$MobileApp(
					$author$project$NativeBridge$Ios(appVersion));
			case 'MobileApp Android':
				return $author$project$NativeBridge$MobileApp(
					$author$project$NativeBridge$Android(appVersion));
			default:
				return $author$project$NativeBridge$WebApp($author$project$NativeBridge$Desktop);
		}
	});
var $author$project$Model$initialModel = F3(
	function (flags, url, navKey) {
		var appCmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Data$BundleID$sync, url, 'onBundleIDChange'),
					$author$project$Firebase$Auth$onAuthStateChanged,
					A2($elm$core$Task$perform, $author$project$Types$GetTimezone, $elm$time$Time$here)
				]));
		var _v0 = flags;
		var initialPushNotification = _v0.lO;
		var adminUserIDs = _v0.jQ;
		var preRenderedHtml = _v0.mZ;
		var bundleID = _v0.ki;
		var multiCardsConfig = _v0.mn;
		var apiUrls = _v0.jX;
		var currentTime = _v0.kG;
		var timezoneOffset = _v0.nV;
		var device = _v0.kQ;
		var appVersion = _v0.jY;
		var authUser = _v0.j2;
		var dimension = _v0.kR;
		var maybeUser = A2($elm$core$Maybe$andThen, $author$project$Core$Data$AuthUser$authUserToUser, authUser);
		var device_ = A2($author$project$NativeBridge$toDevice, device, appVersion);
		var publicModel = {
			jQ: adminUserIDs,
			b8: $author$project$Data$Alert$initial,
			jX: apiUrls,
			cb: 1,
			j1: $elm$core$Maybe$Nothing,
			ki: bundleID,
			kw: {
				n9: {j_: 'https://apple.com', mT: 'https://google.com'}
			},
			cl: $author$project$Model$Content$initialModel(apiUrls.ls),
			kG: $elm$time$Time$millisToPosix(currentTime),
			kQ: device_,
			kR: dimension,
			lm: $author$project$Model$ForgetPassword$initialModel,
			l1: $author$project$Model$Login$initialModel,
			d$: 1,
			mn: multiCardsConfig,
			bD: navKey,
			mZ: preRenderedHtml,
			na: $author$project$Model$Register$initialModel,
			ng: A2($author$project$Data$Route$getRoute, device_, url),
			jp: A2($elm$time$Time$customZone, timezoneOffset, _List_Nil),
			n8: url
		};
		if (!maybeUser.$) {
			var user = maybeUser.a;
			return A2(
				$author$project$Model$PushNotification$initialWithAuthState,
				initialPushNotification,
				A2(
					$elm$core$Tuple$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, appCmd]));
					},
					A2($author$project$Model$initialAuthState, user, publicModel)));
		} else {
			return _Utils_Tuple2(
				publicModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							appCmd,
							A2(
							$elm$browser$Browser$Navigation$replaceUrl,
							publicModel.bD,
							$elm$url$Url$toString(publicModel.n8))
						])));
		}
	});
var $author$project$Types$CurrentTime = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$OnAppStatusChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$OnCameraSessionEnd = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$OnCustomMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$OnDataReceived = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$OnFaceVerification = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$OnNativeBridge = function (a) {
	return {$: 6, a: a};
};
var $author$project$Type$Profile$OnPhotoUploadStatus = function (a) {
	return {$: 6, a: a};
};
var $author$project$Types$OnPushNotification = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$Chat$OnRemoteImageUploadStatus = function (a) {
	return {$: 17, a: a};
};
var $author$project$Types$OnResize = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Type$FaceVerification$OnUploadFacePhoto = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {is: processes, jj: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.is;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.jj);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$NativeBridge$isMobileApp = function (device) {
	if (device.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$NativeBridge$onAppStatusChangedPort = _Platform_incomingPort('onAppStatusChangedPort', $elm$json$Json$Decode$string);
var $author$project$NativeBridge$Background = 0;
var $author$project$NativeBridge$Closing = 2;
var $author$project$NativeBridge$toAppStatus = function (string) {
	switch (string) {
		case 'background':
			return 0;
		case 'active':
			return 1;
		case 'closing':
			return 2;
		default:
			return 1;
	}
};
var $author$project$NativeBridge$onAppStatusChanged = function (handler) {
	return $author$project$NativeBridge$onAppStatusChangedPort(
		A2($elm$core$Basics$composeR, $author$project$NativeBridge$toAppStatus, handler));
};
var $author$project$NativeBridge$onCameraSessionEnd = _Platform_incomingPort('onCameraSessionEnd', $elm$json$Json$Decode$string);
var $author$project$NativeBridge$onCustomMsg = _Platform_incomingPort('onCustomMsg', $elm$json$Json$Decode$value);
var $author$project$NativeBridge$onPushNotification = _Platform_incomingPort('onPushNotification', $elm$json$Json$Decode$string);
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {h9: pids, jd: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {gt: event, lX: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.h9,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.lX;
		var event = _v0.gt;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.jd);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Core$Data$Profile$Photo$profilePhotoUploadStatus = _Platform_incomingPort(
	'profilePhotoUploadStatus',
	A2(
		$elm$json$Json$Decode$andThen,
		function (photo) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (kind) {
					return $elm$json$Json$Decode$succeed(
						{ho: kind, mP: photo});
				},
				A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'photo',
			A2(
				$elm$json$Json$Decode$andThen,
				function (url) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (thumbnailUrl) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (id) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (createdAt) {
											return $elm$json$Json$Decode$succeed(
												{cm: createdAt, lK: id, nT: thumbnailUrl, n8: url});
										},
										A2($elm$json$Json$Decode$field, 'createdAt', $elm$json$Json$Decode$int));
								},
								A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'thumbnailUrl', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string)))));
var $author$project$Firebase$Internal$Port$elmFirebaseReceive = _Platform_incomingPort('elmFirebaseReceive', $elm$json$Json$Decode$string);
var $author$project$Firebase$Auth = function (a) {
	return {$: 1, a: a};
};
var $author$project$Firebase$DecodeError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Firebase$Firestore = function (a) {
	return {$: 0, a: a};
};
var $author$project$Firebase$Auth$CreateUserWithEmailAndPasswordResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Firebase$Auth$DeleteResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Firebase$Auth$OnAuthStateChangedResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Firebase$Auth$ResponseError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Firebase$Auth$SendEmailVerificationResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Firebase$Auth$SendPasswordResetEmailResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Firebase$Auth$SignInAnonymouslyResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Firebase$Auth$SignInWithEmailAndPasswordResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Firebase$Auth$SignOutResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Firebase$Auth$UpdatePasswordResponse = function (a) {
	return {$: 7, a: a};
};
var $author$project$Firebase$Auth$UpdateProfileResponse = function (a) {
	return {$: 8, a: a};
};
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Firebase$Auth$DecodeError = function (a) {
	return {$: 14, a: a};
};
var $author$project$Firebase$Auth$Error = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Firebase$Auth$ElmFirebaseAuthInternal = {$: 13};
var $author$project$Firebase$Auth$EmailAlreadyInUse = {$: 11};
var $author$project$Firebase$Auth$InvalidContinueUri = {$: 7};
var $author$project$Firebase$Auth$InvalidEmail = {$: 0};
var $author$project$Firebase$Auth$MissingAndroidPkgName = {$: 4};
var $author$project$Firebase$Auth$MissingContinueUri = {$: 5};
var $author$project$Firebase$Auth$MissingIosBundleID = {$: 6};
var $author$project$Firebase$Auth$OperationNotAllowed = {$: 12};
var $author$project$Firebase$Auth$RequiresRecentLogin = {$: 10};
var $author$project$Firebase$Auth$UnauthorizedContinueUri = {$: 8};
var $author$project$Firebase$Auth$UndocumentedErrorByElmFirebaseAuth = function (a) {
	return {$: 15, a: a};
};
var $author$project$Firebase$Auth$UserDisabled = {$: 1};
var $author$project$Firebase$Auth$UserNotFound = {$: 2};
var $author$project$Firebase$Auth$WeakPassword = {$: 9};
var $author$project$Firebase$Auth$WrongPassword = {$: 3};
var $author$project$Firebase$Auth$errorCodeDecoder = function () {
	var convert = function (str) {
		switch (str) {
			case 'invalid-email':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$InvalidEmail);
			case 'user-disabled':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$UserDisabled);
			case 'user-not-found':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$UserNotFound);
			case 'wrong-password':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$WrongPassword);
			case 'missing-android-pkg-name':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$MissingAndroidPkgName);
			case 'missing-continue-uri':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$MissingContinueUri);
			case 'missing-ios-bundle-id':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$MissingIosBundleID);
			case 'invalid-continue-uri':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$InvalidContinueUri);
			case 'unauthorized-continue-uri':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$UnauthorizedContinueUri);
			case 'weak-password':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$WeakPassword);
			case 'requires-recent-login':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$RequiresRecentLogin);
			case 'email-already-in-use':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$EmailAlreadyInUse);
			case 'operation-not-allowed':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$OperationNotAllowed);
			case 'ElmFirebaseAuthInternal':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Auth$ElmFirebaseAuthInternal);
			default:
				var undocumentedError = str;
				return $elm$json$Json$Decode$succeed(
					$author$project$Firebase$Auth$UndocumentedErrorByElmFirebaseAuth(undocumentedError));
		}
	};
	return A2($elm$json$Json$Decode$andThen, convert, $elm$json$Json$Decode$string);
}();
var $author$project$Firebase$Auth$responseErrorDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Firebase$Auth$Error,
	A2($elm$json$Json$Decode$field, 'code', $author$project$Firebase$Auth$errorCodeDecoder),
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Firebase$Auth$noReturnResponseDecoder = function (json) {
	var errorResult = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'error', $author$project$Firebase$Auth$responseErrorDecoder),
		json);
	var dataResult = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string),
		json);
	var _v0 = _Utils_Tuple2(dataResult, errorResult);
	if (!_v0.a.$) {
		return $elm$core$Result$Ok(0);
	} else {
		if (!_v0.b.$) {
			var error = _v0.b.a;
			return $elm$core$Result$Err(error);
		} else {
			var error = _v0.a.a;
			return $elm$core$Result$Err(
				A2(
					$author$project$Firebase$Auth$Error,
					$author$project$Firebase$Auth$DecodeError(error),
					'Decoder Error'));
		}
	}
};
var $author$project$Firebase$Auth$User = F6(
	function (displayName, uid, email, emailVerified, photoURL, isAnonymous) {
		return {ds: displayName, dt: email, k_: emailVerified, lU: isAnonymous, mQ: photoURL, eX: uid};
	});
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Firebase$Auth$userDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Firebase$Auth$User,
	A2(
		$elm$json$Json$Decode$field,
		'displayName',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'emailVerified', $elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$field,
		'photoURL',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'isAnonymous', $elm$json$Json$Decode$bool));
var $author$project$Firebase$Auth$responseWithUserDecoder = function (json) {
	var errorResult = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'error', $author$project$Firebase$Auth$responseErrorDecoder),
		json);
	var dataResult = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'data', $author$project$Firebase$Auth$userDecoder),
		json);
	var _v0 = _Utils_Tuple2(dataResult, errorResult);
	if (!_v0.a.$) {
		var user = _v0.a.a;
		return $elm$core$Result$Ok(user);
	} else {
		if (!_v0.b.$) {
			var error = _v0.b.a;
			return $elm$core$Result$Err(error);
		} else {
			var error = _v0.a.a;
			return $elm$core$Result$Err(
				A2(
					$author$project$Firebase$Auth$Error,
					$author$project$Firebase$Auth$DecodeError(error),
					'Decoder Error'));
		}
	}
};
var $author$project$Firebase$Auth$decodeResponse = function (json) {
	var commandResult = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'command', $elm$json$Json$Decode$string),
		json);
	if (!commandResult.$) {
		var command = commandResult.a;
		switch (command) {
			case 'CreateUserWithEmailAndPassword':
				return $author$project$Firebase$Auth$CreateUserWithEmailAndPasswordResponse(
					$author$project$Firebase$Auth$responseWithUserDecoder(json));
			case 'SendEmailVerification':
				return $author$project$Firebase$Auth$SendEmailVerificationResponse(
					$author$project$Firebase$Auth$noReturnResponseDecoder(json));
			case 'SendPasswordResetEmail':
				return $author$project$Firebase$Auth$SendPasswordResetEmailResponse(
					$author$project$Firebase$Auth$noReturnResponseDecoder(json));
			case 'SignInAnonymously':
				return $author$project$Firebase$Auth$SignInAnonymouslyResponse(
					$author$project$Firebase$Auth$responseWithUserDecoder(json));
			case 'SignInWithEmailAndPassword':
				return $author$project$Firebase$Auth$SignInWithEmailAndPasswordResponse(
					$author$project$Firebase$Auth$responseWithUserDecoder(json));
			case 'SignOut':
				return $author$project$Firebase$Auth$SignOutResponse(
					$author$project$Firebase$Auth$noReturnResponseDecoder(json));
			case 'UpdatePassword':
				return $author$project$Firebase$Auth$UpdatePasswordResponse(
					$author$project$Firebase$Auth$noReturnResponseDecoder(json));
			case 'UpdateProfile':
				return $author$project$Firebase$Auth$UpdateProfileResponse(
					$author$project$Firebase$Auth$noReturnResponseDecoder(json));
			case 'Delete':
				return $author$project$Firebase$Auth$DeleteResponse(
					$author$project$Firebase$Auth$noReturnResponseDecoder(json));
			case 'OnAuthStateChanged':
				return $author$project$Firebase$Auth$OnAuthStateChangedResponse(
					A2(
						$elm$core$Result$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$json$Json$Decode$decodeString,
							$elm$json$Json$Decode$maybe(
								A2($elm$json$Json$Decode$field, 'data', $author$project$Firebase$Auth$userDecoder)),
							json)));
			default:
				return $author$project$Firebase$Auth$ResponseError(
					A2(
						$elm$json$Json$Decode$Failure,
						'Unknown command' + command,
						$elm$json$Json$Encode$string(command)));
		}
	} else {
		var decoderError = commandResult.a;
		return $author$project$Firebase$Auth$ResponseError(decoderError);
	}
};
var $author$project$Firebase$Firestore$Response = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $author$project$Firebase$Firestore$mapGeneratedID = F3(
	function (_v0, command, generatedID) {
		var queryID = _v0.a;
		var json = _v0.b;
		return (command === 'GenerateID') ? A2($author$project$Firebase$Firestore$Response, queryID, generatedID) : A2($author$project$Firebase$Firestore$Response, queryID, json);
	});
var $author$project$Firebase$Firestore$mapJsonForGeneratedID = function (_v0) {
	var queryID = _v0.a;
	var json = _v0.b;
	var unchangedResponse = A2($author$project$Firebase$Firestore$Response, queryID, json);
	return A2(
		$elm$core$Result$withDefault,
		unchangedResponse,
		A3(
			$elm$core$Result$map2,
			$author$project$Firebase$Firestore$mapGeneratedID(unchangedResponse),
			A2(
				$elm$json$Json$Decode$decodeString,
				A2($elm$json$Json$Decode$field, 'command', $elm$json$Json$Decode$string),
				json),
			A2(
				$elm$json$Json$Decode$decodeString,
				A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string),
				json)));
};
var $author$project$Firebase$Firestore$decodeResponse = function (json) {
	return A2(
		$elm$core$Result$withDefault,
		A2($author$project$Firebase$Firestore$Response, 'Error', '{\'error\':\'Firebase Response decoder error.\'}'),
		A2(
			$elm$core$Result$map,
			$author$project$Firebase$Firestore$mapJsonForGeneratedID,
			A2(
				$elm$core$Result$map,
				function (queryID) {
					return A2($author$project$Firebase$Firestore$Response, queryID, json);
				},
				A2(
					$elm$json$Json$Decode$decodeString,
					A2($elm$json$Json$Decode$field, 'queryID', $elm$json$Json$Decode$string),
					json))));
};
var $author$project$Firebase$responseDecoder = function (json) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'responseType', $elm$json$Json$Decode$string),
		json);
	if (!_v0.$) {
		var responseType = _v0.a;
		switch (responseType) {
			case 'firestore':
				return $author$project$Firebase$Firestore(
					$author$project$Firebase$Firestore$decodeResponse(json));
			case 'auth':
				return $author$project$Firebase$Auth(
					$author$project$Firebase$Auth$decodeResponse(json));
			default:
				return $author$project$Firebase$DecodeError(
					A2(
						$elm$json$Json$Decode$Failure,
						'Unknown responseType: ' + responseType,
						$elm$json$Json$Encode$string(responseType)));
		}
	} else {
		var decoderError = _v0.a;
		return $author$project$Firebase$DecodeError(decoderError);
	}
};
var $author$project$Firebase$receive = function (handler) {
	return $author$project$Firebase$Internal$Port$elmFirebaseReceive(
		A2($elm$core$Basics$composeR, $author$project$Firebase$responseDecoder, handler));
};
var $author$project$Data$Chat$Message$remoteImageUploadStatus = _Platform_incomingPort(
	'remoteImageUploadStatus',
	A2(
		$elm$json$Json$Decode$andThen,
		function (partnerID) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (messageID) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (imageUrl) {
							return $elm$json$Json$Decode$succeed(
								{dI: imageUrl, U: messageID, u: partnerID});
						},
						A2($elm$json$Json$Decode$field, 'imageUrl', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'messageID', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'partnerID', $elm$json$Json$Decode$string)));
var $author$project$Data$Chat$remoteImageUploadStatus = $author$project$Data$Chat$Message$remoteImageUploadStatus;
var $author$project$Ports$FaceVerification$uploadFacePhotoResult = _Platform_incomingPort(
	'uploadFacePhotoResult',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
			])));
var $author$project$Subscriptions$subscriptions = function (_v0) {
	var device = _v0.kQ;
	var mobileSub = $author$project$NativeBridge$isMobileApp(device) ? $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$NativeBridge$onCameraSessionEnd(
				A2($elm$core$Basics$composeL, $author$project$Types$OnNativeBridge, $author$project$Types$OnCameraSessionEnd)),
				$author$project$NativeBridge$onAppStatusChanged(
				A2($elm$core$Basics$composeL, $author$project$Types$OnNativeBridge, $author$project$Types$OnAppStatusChanged)),
				$author$project$NativeBridge$onPushNotification(
				A2($elm$core$Basics$composeL, $author$project$Types$OnNativeBridge, $author$project$Types$OnPushNotification)),
				$author$project$NativeBridge$onCustomMsg(
				A2($elm$core$Basics$composeL, $author$project$Types$OnNativeBridge, $author$project$Types$OnCustomMsg))
			])) : $elm$core$Platform$Sub$none;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 300000, $author$project$Types$CurrentTime),
				$author$project$Firebase$receive($author$project$Types$OnDataReceived),
				$elm$browser$Browser$Events$onResize($author$project$Types$OnResize),
				mobileSub,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Types$OnAuth,
				$elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$author$project$Ports$FaceVerification$uploadFacePhotoResult(
							A2($elm$core$Basics$composeL, $author$project$Types$OnFaceVerification, $author$project$Type$FaceVerification$OnUploadFacePhoto)),
							$author$project$Data$Chat$remoteImageUploadStatus(
							A2($elm$core$Basics$composeL, $author$project$Types$OnChat, $author$project$Type$Chat$OnRemoteImageUploadStatus)),
							$author$project$Core$Data$Profile$Photo$profilePhotoUploadStatus(
							A2($elm$core$Basics$composeL, $author$project$Types$OnProfile, $author$project$Type$Profile$OnPhotoUploadStatus))
						])))
			]));
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$browser$Browser$Navigation$back = F2(
	function (key, n) {
		return A2(_Browser_go, key, -n);
	});
var $author$project$Data$Alert$clear = $author$project$Data$Alert$initial;
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$NativeBridge$fcmSubscribeTopic = _Platform_outgoingPort('fcmSubscribeTopic', $elm$json$Json$Encode$string);
var $author$project$Model$onAuthStateChangedHandler = F2(
	function (maybeAuthUser, model) {
		var maybeUser = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2($elm$core$Maybe$map, $author$project$Core$Data$AuthUser$authUserToUser, maybeAuthUser));
		var _v0 = _Utils_Tuple2(maybeUser, model.j1);
		if (_v0.a.$ === 1) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			} else {
				var _v3 = _v0.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j1: $elm$core$Maybe$Nothing}),
					A2($elm$browser$Browser$Navigation$pushUrl, model.bD, $author$project$Data$Route$routeUrl.lG));
			}
		} else {
			if (!_v0.b.$) {
				var user = _v0.a.a;
				return _Utils_Tuple2(
					model,
					$author$project$NativeBridge$fcmSubscribeTopic(user.eX));
			} else {
				var user = _v0.a.a;
				var _v4 = _v0.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$browser$Browser$Navigation$pushUrl, model.bD, $author$project$Data$Route$routeUrl.nm),
									$author$project$NativeBridge$fcmSubscribeTopic(user.eX)
								]));
					},
					A2($author$project$Model$initialAuthState, user, model));
			}
		}
	});
var $author$project$Model$Route$setChatRoomToNothing = F2(
	function (model, authState) {
		var _v0 = authState;
		var chat = _v0.km;
		var _v1 = A3($author$project$Data$Chat$setCurrentRoom, $elm$core$Maybe$Nothing, model.kG, chat.i8);
		var chatState = _v1.a;
		var chatCmd = _v1.b;
		var updatedChat = _Utils_update(
			chat,
			{i8: chatState});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{km: updatedChat}))
				}),
			chatCmd);
	});
var $author$project$Model$Route$onInternalUrlRequest = F2(
	function (url, model) {
		var pushUrl = A2(
			$elm$browser$Browser$Navigation$pushUrl,
			model.bD,
			$elm$url$Url$toString(url));
		var newRoute = A2($author$project$Data$Route$getRoute, model.kQ, url);
		var currentRoute = model.ng;
		if (_Utils_eq(newRoute, currentRoute)) {
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(pushUrl),
						url.lo)));
		} else {
			var _v0 = model.j1;
			if (_v0.$ === 1) {
				return _Utils_Tuple2(model, pushUrl);
			} else {
				var authState = _v0.a;
				if (currentRoute.$ === 21) {
					var _v2 = A2($author$project$Model$Route$setChatRoomToNothing, model, authState);
					var updatedModel = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple2(
						updatedModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, pushUrl])));
				} else {
					return _Utils_Tuple2(model, pushUrl);
				}
			}
		}
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Data$Chat$Room$onAppStatusChanged = F2(
	function (appStatus, state) {
		var updatedState = _Utils_update(
			state,
			{cb: appStatus});
		if (appStatus === 1) {
			var _v0 = state.f8;
			if (_v0.$ === 1) {
				return _Utils_Tuple2(updatedState, $elm$core$Platform$Cmd$none);
			} else {
				var currentRoom = _v0.a;
				return A3($author$project$Data$Chat$Room$setRemoteRoomAsRead, updatedState.aa.bE, currentRoom, updatedState);
			}
		} else {
			return _Utils_Tuple2(updatedState, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Chat$onAppStatusChanged = F2(
	function (appStatus, _v0) {
		var state = _v0;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (room) {
				return _Utils_update(
					state,
					{a: room});
			},
			A2($author$project$Data$Chat$Room$onAppStatusChanged, appStatus, state.a));
	});
var $author$project$Model$Chat$onAppStatusChanged = F2(
	function (appStatus, appModel) {
		var _v0 = appModel.j1;
		if (_v0.$ === 1) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var authState = _v0.a;
			var _v1 = A2($author$project$Data$Chat$onAppStatusChanged, appStatus, authState.km.i8);
			var chatState = _v1.a;
			var chatCmd = _v1.b;
			var _v2 = authState;
			var chat = _v2.km;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									km: _Utils_update(
										chat,
										{i8: chatState})
								}))
					}),
				chatCmd);
		}
	});
var $author$project$Data$Membership$Awaiting = 1;
var $author$project$Helpers$getCurrentUserProfile = function (_v0) {
	var profile = _v0.iu;
	if (!profile.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var profileModel = profile.a;
		return $elm$core$Maybe$Just(profileModel.iu);
	}
};
var $author$project$Model$Membership$Android$getState = function (appModel) {
	var _v0 = appModel.j1;
	if (!_v0.$) {
		var authState = _v0.a;
		var _v1 = _Utils_Tuple2(
			$author$project$Helpers$getCurrentUserProfile(authState),
			authState.l9);
		if ((!_v1.a.$) && (_v1.b.$ === 3)) {
			var profile = _v1.a.a;
			var model = _v1.b.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple3(authState, model, profile));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Membership$Android$onAppStatusChanged = F2(
	function (appStatus, appModel) {
		var _v0 = $author$project$Model$Membership$Android$getState(appModel);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var model = _v1.b;
			return ((appStatus === 1) && (model.n.eQ !== 1)) ? _Utils_Tuple2(
				appModel,
				$author$project$NativeBridge$sendCustom(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'function',
								$elm$json$Json$Encode$string('checkToken'))
							])))) : _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Membership$Ios$getState = function (appModel) {
	var _v0 = appModel.j1;
	if (!_v0.$) {
		var authState = _v0.a;
		var _v1 = _Utils_Tuple2(
			$author$project$Helpers$getCurrentUserProfile(authState),
			authState.l9);
		if ((!_v1.a.$) && (_v1.b.$ === 2)) {
			var profile = _v1.a.a;
			var model = _v1.b.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple3(authState, model, profile));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Membership$Ios$onAppStatusChanged = F2(
	function (appStatus, appModel) {
		var _v0 = $author$project$Model$Membership$Ios$getState(appModel);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var authState = _v1.a;
			var model = _v1.b;
			return ((appStatus === 1) && (model.n.eQ !== 1)) ? _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									l9: $author$project$Type$Membership$Ios(
										_Utils_update(
											model,
											{
												n: $author$project$Data$Membership$initialApiState(1)
											}))
								}))
					}),
				$author$project$NativeBridge$sendCustom(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'function',
								$elm$json$Json$Encode$string('checkReceipt'))
							])))) : _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$PushNotification$onNewNotification = F2(
	function (json, appModel) {
		var _v0 = $author$project$Data$PushNotification$decode(json);
		if (_v0.$ === 1) {
			var decodeError = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						b8: A2(
							$author$project$Data$Alert$addDanger,
							$elm$json$Json$Decode$errorToString(decodeError),
							appModel.b8)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var notification = _v0.a;
			return A2(
				$author$project$Model$PushNotification$handleNotification,
				notification,
				_Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none));
		}
	});
var $author$project$Type$Membership$Android$CheckTokenResult = function (a) {
	return {$: 5, a: a};
};
var $author$project$Data$Membership$responseResolver = function (response) {
	switch (response.$) {
		case 4:
			var body = response.b;
			return $elm$core$Result$Ok(body);
		case 1:
			return $elm$core$Result$Err('Http Timeout');
		case 2:
			return $elm$core$Result$Err('Http Network Error');
		default:
			return $elm$core$Result$Err('Http Error');
	}
};
var $author$project$Data$Membership$createHttp = F2(
	function (url, params) {
		return $elm$http$Http$task(
			{
				cg: $elm$http$Http$jsonBody(params),
				lB: _List_Nil,
				mf: 'post',
				nc: $elm$http$Http$stringResolver($author$project$Data$Membership$responseResolver),
				nU: $elm$core$Maybe$Nothing,
				n8: url
			});
	});
var $author$project$Data$Membership$Android$checkToken = F3(
	function (url, userID, _v0) {
		var token = _v0.js;
		var productID = _v0.it;
		return A2(
			$author$project$Data$Membership$createHttp,
			url,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'userID',
						$elm$json$Json$Encode$string(userID)),
						_Utils_Tuple2(
						'token',
						$elm$json$Json$Encode$string(token)),
						_Utils_Tuple2(
						'productID',
						$elm$json$Json$Encode$string(productID))
					])));
	});
var $author$project$Model$Membership$Android$checkToken = F2(
	function (_v0, appModel) {
		var errorMessage = _v0.k1;
		var data = _v0.kH;
		var _v1 = appModel.j1;
		if (!_v1.$) {
			var authState = _v1.a;
			var _v2 = authState.l9;
			if (_v2.$ === 3) {
				var model = _v2.a;
				var _v3 = _Utils_Tuple2(errorMessage, data);
				if (!_v3.b.$) {
					var data_ = _v3.b.a;
					return _Utils_Tuple2(
						appModel,
						A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMembership),
								$author$project$Type$Membership$OnAndroid),
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$Membership$Android$CheckTokenResult,
								A3($author$project$Data$Membership$Android$checkToken, model.cr.kp, authState.j2.eX, data_))));
				} else {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Membership$Android$AppResponse = F3(
	function (key, data, errorMessage) {
		return {kH: data, k1: errorMessage, lX: key};
	});
var $author$project$Data$Membership$Android$AppResponseData = F2(
	function (token, productID) {
		return {it: productID, js: token};
	});
var $author$project$Data$Membership$Android$appResponseDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'productID',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'token',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Membership$Android$AppResponseData)));
var $author$project$Data$Membership$Android$appResponseDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'errorMessage',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'data',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Data$Membership$Android$appResponseDataDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'key',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Membership$Android$AppResponse))));
var $author$project$Data$Membership$Android$decodeAppResponse = function (json) {
	return A2($elm$json$Json$Decode$decodeString, $author$project$Data$Membership$Android$appResponseDecoder, json);
};
var $author$project$Data$Membership$Confirming = 1;
var $author$project$Data$Membership$Error = 3;
var $author$project$Type$Membership$Android$PurchaseResult = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Data$Membership$Completed = 2;
var $author$project$Data$Membership$apiStateWithError = function (message) {
	var apiState = $author$project$Data$Membership$initialApiState(2);
	return _Utils_update(
		apiState,
		{
			dk: $elm$core$Maybe$Just(message)
		});
};
var $author$project$Model$Membership$Android$updateSelectedPlan = F3(
	function (newPlan, viewState, model) {
		return _Utils_update(
			model,
			{
				n: $author$project$Data$Membership$initialApiState(0),
				c4: $elm$core$Maybe$Just(
					{mS: newPlan, od: viewState})
			});
	});
var $author$project$Model$Membership$Android$purchase = F2(
	function (_v0, appModel) {
		var errorMessage = _v0.k1;
		var data = _v0.kH;
		var _v1 = $author$project$Model$Membership$Android$getState(appModel);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var authState = _v2.a;
			var model = _v2.b;
			var profile = _v2.c;
			var _v3 = model.c4;
			if (!_v3.$) {
				var selectedPlan = _v3.a;
				var _v4 = _Utils_Tuple2(errorMessage, data);
				if (!_v4.b.$) {
					var data_ = _v4.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							appModel,
							{
								j1: $elm$core$Maybe$Just(
									_Utils_update(
										authState,
										{
											l9: $author$project$Type$Membership$Android(
												_Utils_update(
													model,
													{
														n: $author$project$Data$Membership$initialApiState(1)
													}))
										}))
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMembership),
								$author$project$Type$Membership$OnAndroid),
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$Membership$Android$PurchaseResult(selectedPlan.mS),
								A3($author$project$Data$Membership$Android$checkToken, model.cr.kp, profile.eX, data_))));
				} else {
					if (!_v4.a.$) {
						var message = _v4.a.a;
						var updatedModel = A3($author$project$Model$Membership$Android$updateSelectedPlan, selectedPlan.mS, 3, model);
						return _Utils_Tuple2(
							_Utils_update(
								appModel,
								{
									j1: $elm$core$Maybe$Just(
										_Utils_update(
											authState,
											{
												l9: $author$project$Type$Membership$Android(
													_Utils_update(
														updatedModel,
														{
															n: $author$project$Data$Membership$apiStateWithError(message)
														}))
											}))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var _v5 = _v4.a;
						var _v6 = _v4.b;
						var updatedModel = A3($author$project$Model$Membership$Android$updateSelectedPlan, selectedPlan.mS, 1, model);
						return _Utils_Tuple2(
							_Utils_update(
								appModel,
								{
									j1: $elm$core$Maybe$Just(
										_Utils_update(
											authState,
											{
												l9: $author$project$Type$Membership$Android(
													_Utils_update(
														updatedModel,
														{
															n: $author$project$Data$Membership$initialApiState(0)
														}))
											}))
								}),
							$elm$core$Platform$Cmd$none);
					}
				}
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										l9: $author$project$Type$Membership$Android(
											_Utils_update(
												model,
												{
													n: $author$project$Data$Membership$initialApiState(0)
												}))
									}))
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Alert$Failure = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Alert$addFailure = F2(
	function (text, alerts) {
		return A2(
			$author$project$Data$Alert$addAlert,
			$author$project$Data$Alert$Failure(text),
			alerts);
	});
var $author$project$Model$Membership$Android$restorePurchase = F2(
	function (_v0, appModel) {
		var errorMessage = _v0.k1;
		var data = _v0.kH;
		var errorCase = _Utils_Tuple2(
			_Utils_update(
				appModel,
				{
					b8: A2($author$project$Data$Alert$addFailure, 'Something went wrong, please try again', appModel.b8)
				}),
			$elm$core$Platform$Cmd$none);
		var _v1 = appModel.j1;
		if (!_v1.$) {
			var authState = _v1.a;
			var _v2 = authState.l9;
			if (_v2.$ === 3) {
				var model = _v2.a;
				var _v3 = _Utils_Tuple2(errorMessage, data);
				if (!_v3.b.$) {
					var data_ = _v3.b.a;
					return _Utils_Tuple2(
						appModel,
						A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMembership),
								$author$project$Type$Membership$OnAndroid),
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$Membership$Android$CheckTokenResult,
								A3($author$project$Data$Membership$Android$checkToken, model.cr.kp, authState.j2.eX, data_))));
				} else {
					if (!_v3.a.$) {
						var errorMessage_ = _v3.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								appModel,
								{
									j1: $elm$core$Maybe$Just(
										_Utils_update(
											authState,
											{
												l9: $author$project$Type$Membership$Android(
													_Utils_update(
														model,
														{
															n: $author$project$Data$Membership$apiStateWithError(errorMessage_)
														}))
											}))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return errorCase;
					}
				}
			} else {
				return errorCase;
			}
		} else {
			return errorCase;
		}
	});
var $author$project$Model$MobileCustom$checkAndroidMembership = F2(
	function (string, model) {
		var _v0 = $author$project$Data$Membership$Android$decodeAppResponse(string);
		if (!_v0.$) {
			var appResponse = _v0.a;
			var _v1 = appResponse.lX;
			switch (_v1) {
				case 'AndroidPurchase':
					return $elm$core$Maybe$Just(
						A2($author$project$Model$Membership$Android$purchase, appResponse, model));
				case 'AndroidCheckToken':
					return $elm$core$Maybe$Just(
						A2($author$project$Model$Membership$Android$checkToken, appResponse, model));
				case 'AndroidRestorePurchase':
					return $elm$core$Maybe$Just(
						A2($author$project$Model$Membership$Android$restorePurchase, appResponse, model));
				default:
					return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Type$Membership$Ios$CheckReceiptResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber = function (sponsorLevel) {
	switch (sponsorLevel) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		default:
			return 7;
	}
};
var $author$project$Data$Membership$Ios$checkReceipt = F4(
	function (url, userID, sponsorLevel, receipt) {
		return A2(
			$author$project$Data$Membership$createHttp,
			url,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'userID',
						$elm$json$Json$Encode$string(userID)),
						_Utils_Tuple2(
						'receipt',
						$elm$json$Json$Encode$string(receipt)),
						_Utils_Tuple2(
						'currentSponsorLevel',
						$elm$json$Json$Encode$int(
							$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(sponsorLevel)))
					])));
	});
var $author$project$Model$Membership$Ios$checkReceipt = F2(
	function (_v0, appModel) {
		var errorMessage = _v0.k1;
		var receipt = _v0.m6;
		var _v1 = $author$project$Model$Membership$Ios$getState(appModel);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var authState = _v2.a;
			var model = _v2.b;
			var profile = _v2.c;
			var _v3 = _Utils_Tuple2(errorMessage, receipt);
			if (!_v3.b.$) {
				var receipt_ = _v3.b.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										l9: $author$project$Type$Membership$Ios(
											_Utils_update(
												model,
												{
													n: $author$project$Data$Membership$initialApiState(1)
												}))
									}))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMembership),
							$author$project$Type$Membership$OnIos),
						A2(
							$elm$core$Task$attempt,
							$author$project$Type$Membership$Ios$CheckReceiptResult,
							A4($author$project$Data$Membership$Ios$checkReceipt, model.cr.ko, profile.eX, profile.bY, receipt_))));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										l9: $author$project$Type$Membership$Ios(
											_Utils_update(
												model,
												{
													n: $author$project$Data$Membership$initialApiState(0)
												}))
									}))
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Membership$Ios$AppResponse = F3(
	function (key, receipt, errorMessage) {
		return {k1: errorMessage, lX: key, m6: receipt};
	});
var $author$project$Data$Membership$Ios$appResponseDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'errorMessage',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'receipt',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'key',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Membership$Ios$AppResponse))));
var $author$project$Data$Membership$Ios$decodeAppResponse = function (json) {
	return A2($elm$json$Json$Decode$decodeString, $author$project$Data$Membership$Ios$appResponseDecoder, json);
};
var $author$project$Type$Membership$Ios$FirstPurchaseResult = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Model$Membership$Ios$updateSelectedPlan = F3(
	function (newPlan, viewState, model) {
		return _Utils_update(
			model,
			{
				c4: $elm$core$Maybe$Just(
					{mS: newPlan, od: viewState})
			});
	});
var $author$project$Model$Membership$Ios$proceedPurchase = F6(
	function (msg, _v0, profile, model, authState, appModel) {
		var errorMessage = _v0.k1;
		var receipt = _v0.m6;
		var _v1 = model.c4;
		if (!_v1.$) {
			var selectedPlan = _v1.a;
			var _v2 = _Utils_Tuple2(errorMessage, receipt);
			if (!_v2.b.$) {
				var receipt_ = _v2.b.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										l9: $author$project$Type$Membership$Ios(
											_Utils_update(
												model,
												{
													n: $author$project$Data$Membership$initialApiState(1),
													a$: 0
												}))
									}))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMembership),
							$author$project$Type$Membership$OnIos),
						A2(
							$elm$core$Task$attempt,
							msg(selectedPlan.mS),
							A4($author$project$Data$Membership$Ios$checkReceipt, model.cr.ko, profile.eX, profile.bY, receipt_))));
			} else {
				if (!_v2.a.$) {
					var message = _v2.a.a;
					var updatedModel = A3($author$project$Model$Membership$Ios$updateSelectedPlan, selectedPlan.mS, 3, model);
					return _Utils_Tuple2(
						_Utils_update(
							appModel,
							{
								j1: $elm$core$Maybe$Just(
									_Utils_update(
										authState,
										{
											l9: $author$project$Type$Membership$Ios(
												_Utils_update(
													updatedModel,
													{
														n: $author$project$Data$Membership$apiStateWithError(message)
													}))
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var _v3 = _v2.a;
					var _v4 = _v2.b;
					var updatedModel = A3($author$project$Model$Membership$Ios$updateSelectedPlan, selectedPlan.mS, 1, model);
					return _Utils_Tuple2(
						_Utils_update(
							appModel,
							{
								j1: $elm$core$Maybe$Just(
									_Utils_update(
										authState,
										{
											l9: $author$project$Type$Membership$Ios(
												_Utils_update(
													updatedModel,
													{
														n: $author$project$Data$Membership$initialApiState(0)
													}))
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			}
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									l9: $author$project$Type$Membership$Ios(
										_Utils_update(
											model,
											{
												n: $author$project$Data$Membership$initialApiState(0)
											}))
								}))
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Membership$Ios$firstPurchase = F2(
	function (appResponse, appModel) {
		var _v0 = $author$project$Model$Membership$Ios$getState(appModel);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var authState = _v1.a;
			var model = _v1.b;
			var profile = _v1.c;
			return A6($author$project$Model$Membership$Ios$proceedPurchase, $author$project$Type$Membership$Ios$FirstPurchaseResult, appResponse, profile, model, authState, appModel);
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Membership$Ios$PrePurchaseResult = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Model$Membership$Ios$prePurchase = F2(
	function (appResponse, appModel) {
		var _v0 = $author$project$Model$Membership$Ios$getState(appModel);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var authState = _v1.a;
			var model = _v1.b;
			var profile = _v1.c;
			return A6($author$project$Model$Membership$Ios$proceedPurchase, $author$project$Type$Membership$Ios$PrePurchaseResult, appResponse, profile, model, authState, appModel);
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$MobileCustom$checkIosMembership = F2(
	function (string, model) {
		var _v0 = $author$project$Data$Membership$Ios$decodeAppResponse(string);
		if (!_v0.$) {
			var appResponse = _v0.a;
			var _v1 = appResponse.lX;
			switch (_v1) {
				case 'IosPrePurchase':
					return $elm$core$Maybe$Just(
						A2($author$project$Model$Membership$Ios$prePurchase, appResponse, model));
				case 'IosFirstPurchase':
					return $elm$core$Maybe$Just(
						A2($author$project$Model$Membership$Ios$firstPurchase, appResponse, model));
				case 'IosRefreshReceipt':
					return $elm$core$Maybe$Just(
						A2($author$project$Model$Membership$Ios$checkReceipt, appResponse, model));
				default:
					return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Model$MobileCustom$decodeError = F2(
	function (error, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					b8: A2(
						$author$project$Data$Alert$addDanger,
						$elm$json$Json$Decode$errorToString(error),
						model.b8)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Type$FaceVerification$FacePhoto = function (facePhoto) {
	return {la: facePhoto};
};
var $author$project$Type$FaceVerification$facePhotoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'facePhoto',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Type$FaceVerification$FacePhoto));
var $author$project$Type$FaceVerification$decodeFacePhoto = function (json) {
	return A2($elm$json$Json$Decode$decodeString, $author$project$Type$FaceVerification$facePhotoDecoder, json);
};
var $author$project$Type$FaceVerification$Verifying = {$: 1};
var $author$project$Ports$FaceVerification$uploadFacePhoto = _Platform_outgoingPort(
	'uploadFacePhoto',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'imageData',
					$elm$json$Json$Encode$string($.dG)),
					_Utils_Tuple2(
					'userID',
					$elm$json$Json$Encode$string($.a9))
				]));
	});
var $author$project$Model$FaceVerification$onVerificationEnd = F3(
	function (imageData, appModel, authState) {
		return _Utils_Tuple2(
			_Utils_update(
				appModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{gx: $author$project$Type$FaceVerification$Verifying}))
				}),
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Types$OnAuth,
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Types$OnFaceVerification,
					$author$project$Ports$FaceVerification$uploadFacePhoto(
						{dG: imageData, a9: authState.j2.eX}))));
	});
var $author$project$Model$MobileCustom$onReceiveData = F2(
	function (json, model) {
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, json);
		if (_v0.$ === 1) {
			var error = _v0.a;
			return A2($author$project$Model$MobileCustom$decodeError, error, model);
		} else {
			var string = _v0.a;
			if (string === 'goToFaceVerificationProcessing') {
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.bD, $author$project$Data$Route$routeUrl.lc));
			} else {
				var iosMembership = A2($author$project$Model$MobileCustom$checkIosMembership, string, model);
				var faceVerification = function () {
					var _v2 = $author$project$Type$FaceVerification$decodeFacePhoto(string);
					if (!_v2.$) {
						var facePhoto = _v2.a.la;
						return A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
							A2(
								$elm$core$Maybe$map,
								A2($author$project$Model$FaceVerification$onVerificationEnd, facePhoto, model),
								model.j1));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									b8: A2($author$project$Data$Alert$addDanger, 'Unhandle JSON: ' + string, model.b8)
								}),
							$elm$core$Platform$Cmd$none);
					}
				}();
				var androidMembership = A2($author$project$Model$MobileCustom$checkAndroidMembership, string, model);
				return A2(
					$elm$core$Maybe$withDefault,
					A2($elm$core$Maybe$withDefault, faceVerification, androidMembership),
					iosMembership);
			}
		}
	});
var $author$project$Type$Chat$OnMobileSelectedImage = F4(
	function (a, b, c, d) {
		return {$: 15, a: a, b: b, c: c, d: d};
	});
var $author$project$Core$Data$Profile$Photo$Private = 2;
var $author$project$Core$Data$Profile$Photo$Public = 1;
var $author$project$NativeBridge$CameraResponse = F2(
	function (passThrough, imageData) {
		return {dG: imageData, mL: passThrough};
	});
var $author$project$NativeBridge$cameraResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'imageData',
	$elm$json$Json$Decode$value,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'passThrough',
		$elm$json$Json$Decode$value,
		$elm$json$Json$Decode$succeed($author$project$NativeBridge$CameraResponse)));
var $author$project$NativeBridge$decodeCameraResponse = function (json) {
	return A2($elm$json$Json$Decode$decodeString, $author$project$NativeBridge$cameraResponseDecoder, json);
};
var $author$project$Data$MobileCamera$Avatar = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$MobileCamera$Chat = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Data$MobileCamera$PrivatePhoto = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$MobileCamera$PublicPhoto = function (a) {
	return {$: 1, a: a};
};
var $author$project$NativeBridge$CameraImage = function (original) {
	return {ei: original};
};
var $author$project$NativeBridge$cameraImageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'original',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$NativeBridge$CameraImage));
var $author$project$NativeBridge$decodeCameraImage = function (jsonValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$NativeBridge$cameraImageDecoder, jsonValue);
};
var $author$project$NativeBridge$CameraImageWithThumbnail = F2(
	function (original, thumbnail) {
		return {ei: original, db: thumbnail};
	});
var $author$project$NativeBridge$cameraImageWithThumbnailDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'thumbnail',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'original',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$NativeBridge$CameraImageWithThumbnail)));
var $author$project$NativeBridge$decodeCameraImageWithThumbnail = function (jsonValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$NativeBridge$cameraImageWithThumbnailDecoder, jsonValue);
};
var $author$project$Data$MobileCamera$decodeImageData = F2(
	function (passThrough, imageData) {
		switch (passThrough.$) {
			case 0:
				return A2(
					$elm$core$Result$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ei;
						},
						$author$project$Data$MobileCamera$Avatar),
					$author$project$NativeBridge$decodeCameraImage(imageData));
			case 1:
				return A2(
					$elm$core$Result$map,
					$author$project$Data$MobileCamera$PublicPhoto,
					$author$project$NativeBridge$decodeCameraImageWithThumbnail(imageData));
			case 2:
				return A2(
					$elm$core$Result$map,
					$author$project$Data$MobileCamera$PrivatePhoto,
					$author$project$NativeBridge$decodeCameraImageWithThumbnail(imageData));
			default:
				var partnerID = passThrough.a;
				return A2(
					$elm$core$Result$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ei;
						},
						$author$project$Data$MobileCamera$Chat(partnerID)),
					$author$project$NativeBridge$decodeCameraImage(imageData));
		}
	});
var $author$project$Data$MobileCamera$ForAvatar = {$: 0};
var $author$project$Data$MobileCamera$ForChat = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$MobileCamera$ForPrivatePhoto = {$: 2};
var $author$project$Data$MobileCamera$ForPublicPhoto = {$: 1};
var $author$project$Data$MobileCamera$passThroughDecoder = function () {
	var convert = function (str) {
		var _v0 = A2($elm$core$String$split, '/', str);
		_v0$4:
		while (true) {
			if (_v0.b) {
				switch (_v0.a) {
					case 'ForAvatar':
						return $elm$json$Json$Decode$succeed($author$project$Data$MobileCamera$ForAvatar);
					case 'ForPublicPhoto':
						return $elm$json$Json$Decode$succeed($author$project$Data$MobileCamera$ForPublicPhoto);
					case 'ForPrivatePhoto':
						return $elm$json$Json$Decode$succeed($author$project$Data$MobileCamera$ForPrivatePhoto);
					case 'ForChat':
						if (_v0.b.b) {
							var _v1 = _v0.b;
							var partnerID = _v1.a;
							return $elm$json$Json$Decode$succeed(
								$author$project$Data$MobileCamera$ForChat(partnerID));
						} else {
							break _v0$4;
						}
					default:
						break _v0$4;
				}
			} else {
				break _v0$4;
			}
		}
		return $elm$json$Json$Decode$fail('Unknown passthrough: ' + str);
	};
	return A2($elm$json$Json$Decode$andThen, convert, $elm$json$Json$Decode$string);
}();
var $author$project$Data$MobileCamera$decodePassThrough = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Data$MobileCamera$passThroughDecoder, value);
};
var $author$project$Data$MobileCamera$decodeCameraResponse = function (json) {
	var _v0 = $author$project$NativeBridge$decodeCameraResponse(json);
	if (_v0.$ === 1) {
		var error = _v0.a;
		return $elm$core$Result$Err(error);
	} else {
		var passThrough = _v0.a.mL;
		var imageData = _v0.a.dG;
		var _v1 = $author$project$Data$MobileCamera$decodePassThrough(passThrough);
		if (_v1.$ === 1) {
			var error = _v1.a;
			return $elm$core$Result$Err(error);
		} else {
			var passThrough_ = _v1.a;
			return A2($author$project$Data$MobileCamera$decodeImageData, passThrough_, imageData);
		}
	}
};
var $author$project$Model$MobileCamera$getUserProfile = function (model) {
	var _v0 = model.j1;
	if (_v0.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var profile = _v0.a.iu;
		if (!profile.$) {
			return $elm$core$Maybe$Nothing;
		} else {
			var profileModel = profile.a;
			return $elm$core$Maybe$Just(profileModel.iu);
		}
	}
};
var $author$project$Core$Data$Profile$Photo$kindString = function (kind) {
	switch (kind) {
		case 0:
			return 'Avatar';
		case 1:
			return 'Public';
		default:
			return 'Private';
	}
};
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $author$project$Core$Data$Profile$Photo$uploadMobileImage = _Platform_outgoingPort(
	'uploadMobileImage',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'image',
					$elm$json$Json$Encode$string($.cA)),
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string($.ho)),
					_Utils_Tuple2(
					'thumbnail',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.db))
				]));
	});
var $author$project$Core$Data$Profile$Photo$mobileUpload = F3(
	function (kind, image, thumbnail) {
		return $author$project$Core$Data$Profile$Photo$uploadMobileImage(
			{
				cA: image,
				ho: $author$project$Core$Data$Profile$Photo$kindString(kind),
				db: $elm$core$Maybe$Just(thumbnail)
			});
	});
var $author$project$Core$Data$Profile$Photo$Avatar = 0;
var $author$project$Core$Data$Profile$Photo$mobileUploadAvatar = function (image) {
	return $author$project$Core$Data$Profile$Photo$uploadMobileImage(
		{
			cA: image,
			ho: $author$project$Core$Data$Profile$Photo$kindString(0),
			db: $elm$core$Maybe$Nothing
		});
};
var $author$project$Model$MobileCamera$onReceivePicture = F2(
	function (json, model) {
		var _v0 = $author$project$Data$MobileCamera$decodeCameraResponse(json);
		if (_v0.$ === 1) {
			var error = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						b8: A2(
							$author$project$Data$Alert$addDanger,
							$elm$json$Json$Decode$errorToString(error),
							model.b8)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var image = _v0.a;
			switch (image.$) {
				case 0:
					var imageData = image.a;
					return _Utils_Tuple2(
						model,
						$author$project$Core$Data$Profile$Photo$mobileUploadAvatar(imageData));
				case 1:
					var original = image.a.ei;
					var thumbnail = image.a.db;
					return _Utils_Tuple2(
						model,
						A3($author$project$Core$Data$Profile$Photo$mobileUpload, 1, original, thumbnail));
				case 2:
					var original = image.a.ei;
					var thumbnail = image.a.db;
					return _Utils_Tuple2(
						model,
						A3($author$project$Core$Data$Profile$Photo$mobileUpload, 2, original, thumbnail));
				default:
					var partnerID = image.a;
					var imageData = image.b;
					var _v2 = $author$project$Model$MobileCamera$getUserProfile(model);
					if (_v2.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var userProfile = _v2.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
									A3($author$project$Type$Chat$OnMobileSelectedImage, userProfile, partnerID, imageData)),
								$elm$time$Time$now));
					}
			}
		}
	});
var $author$project$Model$onNativeBridge = F2(
	function (nativeBridgeMsg, model) {
		switch (nativeBridgeMsg.$) {
			case 1:
				var json = nativeBridgeMsg.a;
				return A2($author$project$Model$PushNotification$onNewNotification, json, model);
			case 0:
				var json = nativeBridgeMsg.a;
				return A2($author$project$Model$MobileCamera$onReceivePicture, json, model);
			case 2:
				var appStatus = nativeBridgeMsg.a;
				var _v1 = A2(
					$author$project$Model$Chat$onAppStatusChanged,
					appStatus,
					_Utils_update(
						model,
						{cb: appStatus}));
				var model_ = _v1.a;
				var chatCmd = _v1.b;
				var _v2 = A2($author$project$Model$Membership$Ios$onAppStatusChanged, appStatus, model_);
				var model__ = _v2.a;
				var iOsMembershipCmd = _v2.b;
				var _v3 = A2($author$project$Model$Membership$Android$onAppStatusChanged, appStatus, model__);
				var model___ = _v3.a;
				var androidMembershipCmd = _v3.b;
				return _Utils_Tuple2(
					model___,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[chatCmd, iOsMembershipCmd, androidMembershipCmd])));
			default:
				var json = nativeBridgeMsg.a;
				return A2($author$project$Model$MobileCustom$onReceiveData, json, model);
		}
	});
var $author$project$Data$Alert$Info = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Alert$addInfo = F2(
	function (text, alerts) {
		return A2(
			$author$project$Data$Alert$addAlert,
			$author$project$Data$Alert$Info(text),
			alerts);
	});
var $author$project$Model$Detail$checkProfile = F3(
	function (userID, authState, appModel) {
		var _v0 = A2($elm$core$Dict$get, userID, authState.gj.iw);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(
				appModel,
				A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnDetail),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Core$Data$Profile$getProfile, userID, $author$project$Model$Detail$channelIDs.dB),
								$author$project$Model$Detail$getPublicPhotos(userID),
								$author$project$Model$Detail$checkAndGetUserPrivatePhotos(userID),
								A2($author$project$Model$Detail$getBlockStatus, authState.j2.eX, userID)
							]))));
		} else {
			return _Utils_Tuple2(
				appModel,
				A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnDetail),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Model$Detail$checkAndGetUserPrivatePhotos(userID),
								A2($author$project$Model$Detail$getBlockStatus, authState.j2.eX, userID)
							]))));
		}
	});
var $author$project$NativeBridge$fcmUnSubscribeTopic = _Platform_outgoingPort('fcmUnSubscribeTopic', $elm$json$Json$Encode$string);
var $author$project$Data$Chat$Room$loadLimit = 20;
var $author$project$Data$Chat$Room$loadOldRooms = F2(
	function (channelID, state) {
		var _v0 = state.T;
		switch (_v0.$) {
			case 2:
				return $elm$core$Platform$Cmd$none;
			case 0:
				return $elm$core$Platform$Cmd$none;
			default:
				var lastMessageCreatedAt = _v0.a;
				var availableStatus = $author$project$Data$Chat$RoomStatus$statusString(0);
				var _v1 = state;
				var user = _v1.W;
				var userIDField = $author$project$Data$Chat$Room$dbUserField(user) + '.uid';
				var userRoomStatusField = $author$project$Data$Chat$Room$dbUserField(user) + '.status.room';
				return A2(
					$author$project$Firebase$Firestore$send,
					channelID,
					$author$project$Firebase$Firestore$getCollection(
						A2(
							$author$project$Firebase$Firestore$limit,
							$author$project$Data$Chat$Room$loadLimit,
							A3(
								$author$project$Firebase$Firestore$orderBy,
								'lastMessageCreatedAt',
								1,
								A4(
									$author$project$Firebase$Firestore$whereTime,
									'lastMessageCreatedAt',
									3,
									lastMessageCreatedAt,
									A4(
										$author$project$Firebase$Firestore$where_,
										userRoomStatusField,
										2,
										availableStatus,
										A4(
											$author$project$Firebase$Firestore$where_,
											userIDField,
											2,
											user.eX,
											$author$project$Firebase$Firestore$collection('/chat/room/lastMessages/'))))))));
		}
	});
var $author$project$Data$Chat$Room$initialRemoteRooms = function (state) {
	return state.lV ? _Utils_Tuple2(state, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
		_Utils_update(
			state,
			{lV: true}),
		A2($author$project$Data$Chat$Room$loadOldRooms, state.aa.d7, state));
};
var $author$project$Data$Chat$initialRooms = function (_v0) {
	var state = _v0;
	return A2(
		$elm$core$Tuple$mapFirst,
		function (room) {
			return _Utils_update(
				state,
				{a: room});
		},
		$author$project$Data$Chat$Room$initialRemoteRooms(state.a));
};
var $author$project$Model$Chat$initialRoomsFromRoute = F2(
	function (authState, appModel) {
		var _v0 = $author$project$Data$Chat$initialRooms(authState.km.i8);
		var chatState = _v0.a;
		var chatCmd = _v0.b;
		var _v1 = authState;
		var chat = _v1.km;
		return _Utils_Tuple2(
			_Utils_update(
				appModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								km: _Utils_update(
									chat,
									{i8: chatState})
							}))
				}),
			chatCmd);
	});
var $author$project$Type$Block$Loading = {$: 1};
var $author$project$Model$Block$channelIDs = {
	dz: 'getBlockList',
	lr: function (partnerID) {
		return 'getChatRoomAtBlock/' + partnerID;
	},
	n1: function (partnerID) {
		return 'unBlockChatRoomAtBlock/' + partnerID;
	},
	n3: function (userID) {
		return 'unBlockUserAtBlock/' + userID;
	}
};
var $author$project$Firebase$Firestore$WhereBool = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Firebase$Firestore$whereBool = F4(
	function (fieldPath, op, value, _v0) {
		var path = _v0.a;
		var clauses = _v0.b;
		return A2(
			$author$project$Firebase$Firestore$Collection,
			path,
			_Utils_ap(
				clauses,
				_List_fromArray(
					[
						A3($author$project$Firebase$Firestore$WhereBool, fieldPath, op, value)
					])));
	});
var $author$project$Data$BlockProfile$list = F4(
	function (channelID, limit, userID, createdAt) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getCollection(
				A3(
					$author$project$Firebase$Firestore$orderBy,
					'createdAt',
					1,
					A2(
						$author$project$Firebase$Firestore$limit,
						limit,
						A4(
							$author$project$Firebase$Firestore$whereTime,
							'createdAt',
							3,
							createdAt,
							A4(
								$author$project$Firebase$Firestore$whereBool,
								'blocked',
								2,
								true,
								$author$project$Firebase$Firestore$collection('/profiles/' + (userID + '/blockProfile'))))))));
	});
var $author$project$Model$Block$getProfilesCmd = F2(
	function (_v0, userID) {
		var limit = _v0.hs;
		var profileState = _v0.iv;
		var futurePosix = $elm$time$Time$millisToPosix(99999999999999);
		switch (profileState.$) {
			case 0:
				return A4($author$project$Data$BlockProfile$list, $author$project$Model$Block$channelIDs.dz, limit, userID, futurePosix);
			case 2:
				var profiles = profileState.a;
				return A4(
					$author$project$Data$BlockProfile$list,
					$author$project$Model$Block$channelIDs.dz,
					limit,
					userID,
					A2(
						$elm$core$Maybe$withDefault,
						futurePosix,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.cm;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$sortBy,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.cm;
										},
										$elm$time$Time$posixToMillis),
									profiles)))));
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Model$Block$loadByRoute = F2(
	function (authState, appModel) {
		if (_Utils_eq(authState.j7.iv, $author$project$Type$Block$Init)) {
			var model = authState.j7;
			var updatedAppModel = _Utils_update(
				appModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								j7: _Utils_update(
									model,
									{iv: $author$project$Type$Block$Loading})
							}))
				});
			return _Utils_Tuple2(
				updatedAppModel,
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Types$OnAuth,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnBlock,
						A2($author$project$Model$Block$getProfilesCmd, authState.j7, authState.j2.eX))));
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Content$Page = 0;
var $author$project$Data$Content$Post = 1;
var $author$project$Data$Content$categoryUrlNameToName = F2(
	function (categories, categoryUrlName) {
		var getCategoryName = function (names) {
			getCategoryName:
			while (true) {
				if (names.b) {
					var name = names.a;
					var rest = names.b;
					if (_Utils_eq(
						$elm$core$String$toLower(name),
						$elm$core$String$toLower(categoryUrlName))) {
						return $elm$core$Maybe$Just(name);
					} else {
						var $temp$names = rest;
						names = $temp$names;
						continue getCategoryName;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		};
		var categoryNames = $elm$core$Dict$keys(categories);
		return getCategoryName(categoryNames);
	});
var $author$project$Model$Content$channelIDs = {
	gF: 'getCategoryList',
	gG: function (url) {
		return 'getPageArticle/' + url;
	},
	gH: function (url) {
		return 'getPostArticle/' + url;
	},
	dA: function (url) {
		return 'getPostList/' + url;
	}
};
var $author$project$Data$Content$getArticleUrl = function (article) {
	switch (article.$) {
		case 0:
			var article_ = article.a;
			return article_.n8;
		case 1:
			var url = article.a;
			return url;
		case 2:
			var url = article.a;
			return url;
		default:
			var url = article.a;
			return url;
	}
};
var $author$project$Data$Content$isEqualToUrl = F2(
	function (url, article) {
		return _Utils_eq(
			$author$project$Data$Content$getArticleUrl(article),
			$elm$core$String$toLower(url));
	});
var $author$project$Data$Content$findArticleByUrl = F2(
	function (url, articles) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				$author$project$Data$Content$isEqualToUrl(url),
				articles));
	});
var $author$project$Data$Content$urlToPaths = function (url) {
	return A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
		A2(
			$elm$core$String$split,
			'/',
			$author$project$Data$Route$removeExtension(url)));
};
var $author$project$Data$Content$cleanUrl = function (url) {
	return A2(
		$elm$core$String$join,
		'/',
		$author$project$Data$Content$urlToPaths(url));
};
var $author$project$Data$Content$getArticle = F3(
	function (articleKind, channelID, url) {
		var path = function () {
			if (articleKind === 1) {
				return '/articles/data/posts';
			} else {
				return '/articles/data/pages';
			}
		}();
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getCollection(
				A4(
					$author$project$Firebase$Firestore$where_,
					'url',
					2,
					$author$project$Data$Content$cleanUrl(url),
					$author$project$Firebase$Firestore$collection(path))));
	});
var $author$project$Data$Content$getCategoryList = function (channelID) {
	return A2(
		$author$project$Firebase$Firestore$send,
		channelID,
		$author$project$Firebase$Firestore$getDoc(
			$author$project$Firebase$Firestore$doc('/articles/data')));
};
var $author$project$Data$Content$Loaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Content$getListArticleData = function (postsStatus) {
	switch (postsStatus.$) {
		case 0:
			return _List_Nil;
		case 1:
			var posts = postsStatus.a;
			return $elm$core$Dict$values(posts);
		case 2:
			var posts = postsStatus.a;
			return $elm$core$Dict$values(posts);
		default:
			var posts = postsStatus.a;
			return $elm$core$Dict$values(posts);
	}
};
var $author$project$Data$Content$getLoadedArticle = function (article) {
	if (!article.$) {
		var article_ = article.a;
		return $elm$core$Maybe$Just(article_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Content$getListArticle = function (_v0) {
	var postsStatus = _v0.M;
	var categoriesStatus = _v0.I;
	var individualPosts = _v0.aU;
	var postArticles = $author$project$Data$Content$getListArticleData(postsStatus);
	var individualArticles = A2(
		$elm$core$List$filterMap,
		$author$project$Data$Content$getLoadedArticle,
		$elm$core$Dict$values(individualPosts));
	var categoryArticles = function () {
		if (!categoriesStatus.$) {
			return _List_Nil;
		} else {
			var categories = categoriesStatus.a;
			return $elm$core$List$concat(
				A2(
					$elm$core$List$map,
					$author$project$Data$Content$getListArticleData,
					$elm$core$Dict$values(categories)));
		}
	}();
	return _Utils_ap(
		$elm$core$Dict$values(individualPosts),
		A2(
			$elm$core$List$map,
			function (article) {
				return $author$project$Data$Content$Loaded(article);
			},
			_Utils_ap(
				individualArticles,
				_Utils_ap(postArticles, categoryArticles))));
};
var $author$project$Firebase$Firestore$ArrayContains = 5;
var $author$project$Data$Content$getPostList = F4(
	function (channelID, limit, category, publishedAt) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getCollection(
				A2(
					$author$project$Firebase$Firestore$limit,
					limit,
					A3(
						$author$project$Firebase$Firestore$orderBy,
						'publishedAt',
						1,
						function (path) {
							return A2(
								$elm$core$Maybe$withDefault,
								path,
								A2(
									$elm$core$Maybe$map,
									function (category_) {
										return A4($author$project$Firebase$Firestore$where_, 'categories', 5, category_, path);
									},
									category));
						}(
							A4(
								$author$project$Firebase$Firestore$where_,
								'publishedAt',
								3,
								publishedAt,
								$author$project$Firebase$Firestore$collection('/articles/data/posts')))))));
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {f0: col, kB: contextStack, ip: problem, iN: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.iN, s.f0, x, s.g));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.b),
			s.c) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.b);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.c, offset) < 0,
					0,
					{f0: col, g: s0.g, i: s0.i, c: offset, iN: row, b: s0.b});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.c, s.iN, s.f0, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.c, s1.c, s0.b),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.c, s.b);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{f0: 1, g: s.g, i: s.i, c: s.c + 1, iN: s.iN + 1, b: s.b}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{f0: s.f0 + 1, g: s.g, i: s.i, c: newOffset, iN: s.iN, b: s.b}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.c, s.iN, s.f0, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{f0: newCol, g: s.g, i: s.i, c: newOffset, iN: newRow, b: s.b});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {f0: col, ip: problem, iN: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.iN, p.f0, p.ip);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{f0: 1, g: _List_Nil, i: 1, c: 0, iN: 1, b: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $ryannhg$date_format$DateFormat$DayOfMonthFixed = {$: 7};
var $ryannhg$date_format$DateFormat$dayOfMonthFixed = $ryannhg$date_format$DateFormat$DayOfMonthFixed;
var $ryannhg$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {nW: toAmPm, nX: toMonthAbbreviation, nY: toMonthName, a7: toOrdinalSuffix, nZ: toWeekdayAbbreviation, n_: toWeekdayName};
	});
var $ryannhg$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryannhg$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryannhg$date_format$DateFormat$Language$english = A6(
	$ryannhg$date_format$DateFormat$Language$Language,
	$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishAmPm,
	$ryannhg$date_format$DateFormat$Language$toEnglishSuffix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.eP, posixMinutes) < 0) {
					return posixMinutes + era.c;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryannhg$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.nW(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		ga: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		hM: month,
		jL: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ga;
	});
var $ryannhg$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryannhg$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryannhg$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryannhg$date_format$DateFormat$days)))));
	});
var $ryannhg$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryannhg$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryannhg$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $ryannhg$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).hM;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $ryannhg$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryannhg$date_format$DateFormat$months))));
	});
var $ryannhg$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryannhg$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).jL;
	});
var $ryannhg$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryannhg$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryannhg$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryannhg$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $ryannhg$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $ryannhg$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $ryannhg$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryannhg$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryannhg$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryannhg$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryannhg$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a7(num));
				}(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.nX(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.nY(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a7(num));
				}(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a7(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a7(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a7(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.nZ(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.n_(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a7(num));
				}(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryannhg$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryannhg$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryannhg$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryannhg$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryannhg$date_format$DateFormat$format = $ryannhg$date_format$DateFormat$formatWithLanguage($ryannhg$date_format$DateFormat$Language$english);
var $ryannhg$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryannhg$date_format$DateFormat$hourMilitaryFixed = $ryannhg$date_format$DateFormat$HourMilitaryFixed;
var $ryannhg$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryannhg$date_format$DateFormat$minuteFixed = $ryannhg$date_format$DateFormat$MinuteFixed;
var $ryannhg$date_format$DateFormat$MonthFixed = {$: 2};
var $ryannhg$date_format$DateFormat$monthFixed = $ryannhg$date_format$DateFormat$MonthFixed;
var $ryannhg$date_format$DateFormat$SecondFixed = {$: 33};
var $ryannhg$date_format$DateFormat$secondFixed = $ryannhg$date_format$DateFormat$SecondFixed;
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $ryannhg$date_format$DateFormat$YearNumber = {$: 16};
var $ryannhg$date_format$DateFormat$yearNumber = $ryannhg$date_format$DateFormat$YearNumber;
var $author$project$Data$Content$toWordpressTimeFormat = function (time) {
	return A3(
		$ryannhg$date_format$DateFormat$format,
		_List_fromArray(
			[$ryannhg$date_format$DateFormat$yearNumber, $ryannhg$date_format$DateFormat$monthFixed, $ryannhg$date_format$DateFormat$dayOfMonthFixed, $ryannhg$date_format$DateFormat$hourMilitaryFixed, $ryannhg$date_format$DateFormat$minuteFixed, $ryannhg$date_format$DateFormat$secondFixed]),
		$elm$time$Time$utc,
		time);
};
var $author$project$Data$Content$wordpressTimeFormater = function (string) {
	var year = A3($elm$core$String$slice, 0, 4, string);
	var sec = A3($elm$core$String$slice, 12, 14, string);
	var month = A3($elm$core$String$slice, 4, 6, string);
	var min = A3($elm$core$String$slice, 10, 12, string);
	var hour = A3($elm$core$String$slice, 8, 10, string);
	var day = A3($elm$core$String$slice, 6, 8, string);
	return year + ('-' + (month + ('-' + (day + ('T' + (hour + (':' + (min + (':' + (sec + '.000Z'))))))))));
};
var $author$project$Model$Content$getPostsCmd = F3(
	function (currentTime, category, _v0) {
		var postsStatus = _v0.M;
		var categoriesStatus = _v0.I;
		var postsPerPage = _v0.er;
		var getPublishedAtFromOldestPost = function (articles) {
			return $author$project$Data$Content$toWordpressTimeFormat(
				A2(
					$elm$core$Maybe$withDefault,
					currentTime,
					A2(
						$elm$core$Maybe$map,
						function (_v5) {
							var publishedAt = _v5.iz;
							return A2(
								$elm$core$Maybe$withDefault,
								currentTime,
								$elm$core$Result$toMaybe(
									$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(
										$author$project$Data$Content$wordpressTimeFormater(publishedAt))));
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.iz;
								},
								articles)))));
		};
		var channelID = function () {
			if (!category.$) {
				var categoryName = category.a;
				return $author$project$Model$Content$channelIDs.dA(categoryName);
			} else {
				return $author$project$Model$Content$channelIDs.dA('');
			}
		}();
		return A4(
			$author$project$Data$Content$getPostList,
			channelID,
			postsPerPage,
			category,
			getPublishedAtFromOldestPost(
				function () {
					if (category.$ === 1) {
						return $author$project$Data$Content$getListArticleData(postsStatus);
					} else {
						var category_ = category.a;
						if (!categoriesStatus.$) {
							return _List_Nil;
						} else {
							var categories = categoriesStatus.a;
							var _v3 = A2($elm$core$Dict$get, category_, categories);
							if (_v3.$ === 1) {
								return _List_Nil;
							} else {
								var categoryPostStatus = _v3.a;
								return $author$project$Data$Content$getListArticleData(categoryPostStatus);
							}
						}
					}
				}()));
	});
var $author$project$Type$Content$AddNewShortCodes = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$OnContent = function (a) {
	return {$: 11, a: a};
};
var $author$project$NotFound$generateID = function (_v0) {
	return 'NotFound';
};
var $author$project$NotFound$initial = '';
var $author$project$NotFound$process = function (attributes) {
	return $elm$core$Task$fail(
		A2(
			$elm$core$Maybe$withDefault,
			'Unknown Tag',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq('tag')),
						attributes)))));
};
var $author$project$NotFound$renderResult = function (result) {
	var style = 'style=\'color:red;\'';
	if (!result.$) {
		return '<p ' + (style + '>Unknown short code error?</p>');
	} else {
		var tagError = result.a;
		return '<p ' + (style + ('>Unknown short code: {{' + (tagError + '}}</p>')));
	}
};
var $author$project$NotFound$tag = 'NotFound';
var $author$project$Model$Content$getParser = F2(
	function (parsers, tag) {
		return A2(
			$elm$core$Maybe$withDefault,
			{
				aS: $author$project$NotFound$generateID,
				dV: $author$project$NotFound$initial,
				es: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$append(
						_List_fromArray(
							[
								_Utils_Tuple2('tag', tag)
							])),
					$author$project$NotFound$process),
				ey: $author$project$NotFound$renderResult,
				c9: $author$project$NotFound$tag
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.c9;
						},
						$elm$core$Basics$eq(tag)),
					parsers)));
	});
var $author$project$Model$Content$addNewRenderedShortCode = F2(
	function (_v0, model) {
		var tag = _v0.a;
		var attributes = _v0.b;
		var _v1 = model;
		var shortCodeCaches = _v1.aB;
		var shortCodeParsers = _v1.bV;
		var parser = A2($author$project$Model$Content$getParser, shortCodeParsers, tag);
		var shortCodeID = parser.aS(attributes);
		var _v2 = A2($elm$core$Dict$get, shortCodeID, shortCodeCaches);
		if (!_v2.$) {
			return model;
		} else {
			return _Utils_update(
				model,
				{
					aB: A3($elm$core$Dict$insert, shortCodeID, parser.dV, shortCodeCaches)
				});
		}
	});
var $author$project$Model$Content$addNewRenderedShortCodes = F2(
	function (shortCodes, model) {
		if (!shortCodes.b) {
			return model;
		} else {
			var shortCode = shortCodes.a;
			var rest = shortCodes.b;
			return A2(
				$author$project$Model$Content$addNewRenderedShortCodes,
				rest,
				A2($author$project$Model$Content$addNewRenderedShortCode, shortCode, model));
		}
	});
var $author$project$Type$Content$ShortCodeProcessResult = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Model$Content$attemptShortCodeTask = function (_v0) {
	var tag = _v0.a;
	var renderedShortCodeID = _v0.b;
	var task = _v0.c;
	return A2(
		$elm$core$Task$attempt,
		A2($author$project$Type$Content$ShortCodeProcessResult, renderedShortCodeID, tag),
		task);
};
var $author$project$Model$Content$getNewShortCodeTask = F2(
	function (model, _v0) {
		var tag = _v0.a;
		var attributes = _v0.b;
		var _v1 = model;
		var shortCodeCaches = _v1.aB;
		var shortCodeParsers = _v1.bV;
		var parser = A2($author$project$Model$Content$getParser, shortCodeParsers, tag);
		var shortCodeID = parser.aS(attributes);
		var _v2 = A2($elm$core$Dict$get, shortCodeID, shortCodeCaches);
		if (!_v2.$) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(
				_Utils_Tuple3(
					parser.c9,
					parser.aS(attributes),
					parser.es(attributes)));
		}
	});
var $author$project$Model$Content$getNewShortCodeTasks = F2(
	function (shortCodes, model) {
		return A2(
			$elm$core$List$filterMap,
			$author$project$Model$Content$getNewShortCodeTask(model),
			shortCodes);
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $author$project$Type$Content$ShortCode = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Model$Content$escapeHtmlEntities = function (string) {
	var replaceEntity = function (_v1) {
		var match = _v1.l7;
		switch (match) {
			case '&#8221;':
				return '\"';
			case '&#8243;':
				return '\"';
			case '&#8211;':
				return '-';
			default:
				return match;
		}
	};
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('&#\\d{4};'));
	return A3($elm$regex$Regex$replace, regex, replaceEntity, string);
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Model$Content$extractAttribute = function (regexSubMatch) {
	if (((regexSubMatch.b && regexSubMatch.b.b) && regexSubMatch.b.b.b) && (!regexSubMatch.b.b.b.b)) {
		var _v1 = regexSubMatch.b;
		var attribute = _v1.a;
		var _v2 = _v1.b;
		var value = _v2.a;
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (a, b) {
					return _Utils_Tuple2(a, b);
				}),
			attribute,
			value);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Content$extractAttributes = function (parameters) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('( (\\w+)=\"([^\"]+?)\")'));
	return A2(
		$elm$core$List$filterMap,
		$author$project$Model$Content$extractAttribute,
		A2(
			$elm$core$List$map,
			function ($) {
				return $.eR;
			},
			A2(
				$elm$regex$Regex$find,
				regex,
				$author$project$Model$Content$escapeHtmlEntities(parameters))));
};
var $author$project$Model$Content$regexSubMatchesToShortCode = function (regexSubMatches) {
	if ((regexSubMatches.b && regexSubMatches.b.b) && (!regexSubMatches.b.b.b)) {
		var code = regexSubMatches.a;
		var _v1 = regexSubMatches.b;
		var parameters = _v1.a;
		var attributes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$Model$Content$extractAttributes, parameters));
		return A3(
			$elm$core$Maybe$map2,
			$author$project$Type$Content$ShortCode,
			code,
			$elm$core$Maybe$Just(attributes));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Content$getShortCodes = function (htmlString) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('{{(\\w+)([^}]*)}}'));
	return A2(
		$elm$core$List$filterMap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.eR;
			},
			$author$project$Model$Content$regexSubMatchesToShortCode),
		A2($elm$regex$Regex$find, regex, htmlString));
};
var $author$project$Model$Content$addNewShortCode = F2(
	function (htmlString, appModel) {
		var shortCodes = $author$project$Model$Content$getShortCodes(htmlString);
		var model = appModel.cl;
		var newShortCodeTasks = A2(
			$elm$core$List$map,
			$author$project$Model$Content$attemptShortCodeTask,
			A2($author$project$Model$Content$getNewShortCodeTasks, shortCodes, model));
		var updatedModel = A2($author$project$Model$Content$addNewRenderedShortCodes, shortCodes, model);
		return _Utils_Tuple2(
			_Utils_update(
				appModel,
				{cl: updatedModel}),
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Types$OnContent,
				$elm$core$Platform$Cmd$batch(newShortCodeTasks)));
	});
var $author$project$Data$Content$NotFound = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Content$findPage = F2(
	function (url, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Content$NotFound(url),
			A2(
				$author$project$Data$Content$findArticleByUrl,
				url,
				$elm$core$Dict$values(model.ax)));
	});
var $author$project$Model$Content$findPost = F2(
	function (url, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Content$NotFound(url),
			A2(
				$author$project$Data$Content$findArticleByUrl,
				url,
				$author$project$Model$Content$getListArticle(model)));
	});
var $author$project$Model$Content$renderShortCode = F3(
	function (shortCodeParsers, shortCodeCaches, _v0) {
		var tag = _v0.a;
		var attributes = _v0.b;
		var shortCodeID = A3(
			$elm$core$Basics$apR,
			A2($author$project$Model$Content$getParser, shortCodeParsers, tag),
			function ($) {
				return $.aS;
			},
			attributes);
		var _v1 = A2($elm$core$Dict$get, shortCodeID, shortCodeCaches);
		if (!_v1.$) {
			var htmlString = _v1.a;
			return htmlString;
		} else {
			return '';
		}
	});
var $author$project$Model$Content$replaceShortCodes = F3(
	function (shortCodeParsers, shortCodeCaches, htmlString) {
		var renderShortCodes = function (matches) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Model$Content$renderShortCode, shortCodeParsers, shortCodeCaches),
					$author$project$Model$Content$regexSubMatchesToShortCode(matches.eR)));
		};
		var regex = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('{{(\\w+)([^}]*)}}'));
		return A3($elm$regex$Regex$replace, regex, renderShortCodes, htmlString);
	});
var $author$project$Model$Content$getRenderedHtml = F2(
	function (htmlString, _v0) {
		var shortCodeParsers = _v0.bV;
		var shortCodeCaches = _v0.aB;
		return A3($author$project$Model$Content$replaceShortCodes, shortCodeParsers, shortCodeCaches, htmlString);
	});
var $author$project$Data$Content$LoadingPosts = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Content$SyncedCategories = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Content$getPosts = function (postsStatus) {
	switch (postsStatus.$) {
		case 0:
			return $elm$core$Dict$empty;
		case 1:
			var posts = postsStatus.a;
			return posts;
		case 2:
			var posts = postsStatus.a;
			return posts;
		default:
			var posts = postsStatus.a;
			return posts;
	}
};
var $author$project$Model$Content$loadMore = F2(
	function (category, appModel) {
		var updatedPostsStatus = function (postsStatus) {
			return $author$project$Data$Content$LoadingPosts(
				$author$project$Data$Content$getPosts(postsStatus));
		};
		var model = appModel.cl;
		var cmd = A3($author$project$Model$Content$getPostsCmd, appModel.kG, category, model);
		if (category.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						cl: _Utils_update(
							model,
							{
								M: updatedPostsStatus(model.M)
							})
					}),
				cmd);
		} else {
			var category_ = category.a;
			var _v1 = model.I;
			if (!_v1.$) {
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			} else {
				var categories = _v1.a;
				var _v2 = A2($elm$core$Dict$get, category_, categories);
				if (_v2.$ === 1) {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				} else {
					var updatedCategories = A3(
						$elm$core$Dict$update,
						category_,
						$elm$core$Maybe$map(updatedPostsStatus),
						categories);
					return _Utils_Tuple2(
						_Utils_update(
							appModel,
							{
								cl: _Utils_update(
									model,
									{
										I: $author$project$Data$Content$SyncedCategories(updatedCategories)
									})
							}),
						cmd);
				}
			}
		}
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Model$Content$scrollTo = function (id) {
	return A2(
		$elm$core$Task$attempt,
		$elm$core$Basics$always($author$project$Types$Noop),
		A2(
			$elm$core$Task$andThen,
			function (info) {
				return A2($elm$browser$Browser$Dom$setViewport, 0, info.kZ.jK);
			},
			$elm$browser$Browser$Dom$getElement(id)));
};
var $author$project$Ports$Content$updateMetaData = _Platform_outgoingPort(
	'updateMetaData',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'description',
					$elm$json$Json$Encode$string($.kP)),
					_Utils_Tuple2(
					'keywords',
					$elm$json$Json$Encode$string($.lY))
				]));
	});
var $author$project$Model$Content$processHtml = function (appModel) {
	var model = appModel.cl;
	var _v4 = appModel.ng;
	if (_v4.$ === 23) {
		var contentRoute = _v4.a;
		var _v5 = function () {
			switch (contentRoute.$) {
				case 1:
					var url_ = contentRoute.a;
					return A2(
						$author$project$Model$Content$updateProcessedHtml,
						appModel,
						A2($author$project$Model$Content$findPage, url_, model));
				case 2:
					var url_ = contentRoute.a;
					return A2(
						$author$project$Model$Content$updateProcessedHtml,
						appModel,
						A2($author$project$Model$Content$findPost, url_, model));
				default:
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			}
		}();
		var updatedAppModel = _v5.a;
		var cmd = _v5.b;
		return _Utils_Tuple2(updatedAppModel, cmd);
	} else {
		return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Model$Content$shortCodeProcessResult = F4(
	function (shortCodeID, tag, result, appModel) {
		var model = appModel.cl;
		var _v3 = model;
		var shortCodeCaches = _v3.aB;
		var shortCodeParsers = _v3.bV;
		var parser = A2($author$project$Model$Content$getParser, shortCodeParsers, tag);
		var updatedAppModel = _Utils_update(
			appModel,
			{
				cl: _Utils_update(
					model,
					{
						aB: A3(
							$elm$core$Dict$insert,
							shortCodeID,
							parser.ey(result),
							shortCodeCaches)
					})
			});
		return $author$project$Model$Content$processHtml(updatedAppModel);
	});
var $author$project$Model$Content$update = F2(
	function (msg, appModel) {
		switch (msg.$) {
			case 0:
				var category = msg.a;
				return A2($author$project$Model$Content$loadMore, category, appModel);
			case 1:
				var htmlString = msg.a;
				return A2($author$project$Model$Content$addNewShortCode, htmlString, appModel);
			case 2:
				var shortCodeID = msg.a;
				var tag = msg.b;
				var result = msg.c;
				return A4($author$project$Model$Content$shortCodeProcessResult, shortCodeID, tag, result, appModel);
			default:
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Content$updateProcessedHtml = F2(
	function (appModel, article) {
		if (!article.$) {
			var body = article.a.cg;
			var metaDescription = article.a.cK;
			var metaKeyword = article.a.hG;
			var model = appModel.cl;
			var _v1 = A2(
				$author$project$Model$Content$update,
				$author$project$Type$Content$AddNewShortCodes(body),
				appModel);
			var updatedAppModel = _v1.a;
			var cmd = _v1.b;
			var processedHtml = A2($author$project$Model$Content$getRenderedHtml, body, updatedAppModel.cl);
			return _Utils_Tuple2(
				_Utils_update(
					updatedAppModel,
					{
						cl: _Utils_update(
							model,
							{ir: processedHtml})
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							$author$project$Ports$Content$updateMetaData(
							{kP: metaDescription, lY: metaKeyword}),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2($elm$core$Maybe$map, $author$project$Model$Content$scrollTo, appModel.n8.lo))
						])));
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Content$scrollToTop = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$always($author$project$Types$Noop),
	A2($elm$browser$Browser$Dom$setViewport, 0, 0));
var $author$project$Model$Content$loadByRoute = F2(
	function (contentRoute, appModel) {
		var _v0 = appModel;
		var currentTime = _v0.kG;
		var content = _v0.cl;
		var postsStatusCmd = F2(
			function (postsStatus, category) {
				if (!postsStatus.$) {
					return A3($author$project$Model$Content$getPostsCmd, currentTime, category, content);
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			});
		var categoryStatusCmd = F2(
			function (categories, category) {
				var _v7 = A2($author$project$Data$Content$categoryUrlNameToName, categories, category);
				if (!_v7.$) {
					var categoryName = _v7.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							function (postsStatus) {
								return A2(
									postsStatusCmd,
									postsStatus,
									$elm$core$Maybe$Just(categoryName));
							},
							A2($elm$core$Dict$get, categoryName, categories)));
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			});
		var categoriesStatusCmd = function (category) {
			var _v6 = content.I;
			if (!_v6.$) {
				return $author$project$Data$Content$getCategoryList($author$project$Model$Content$channelIDs.gF);
			} else {
				var categories = _v6.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						categoryStatusCmd(categories),
						category));
			}
		};
		var _v1 = function () {
			switch (contentRoute.$) {
				case 3:
					var category = contentRoute.a;
					return _Utils_Tuple2(
						content,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(postsStatusCmd, content.M, $elm$core$Maybe$Nothing),
									categoriesStatusCmd(
									$elm$core$Maybe$Just(category)),
									$author$project$Model$Content$scrollToTop
								])));
				case 0:
					return _Utils_Tuple2(
						content,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(postsStatusCmd, content.M, $elm$core$Maybe$Nothing),
									categoriesStatusCmd($elm$core$Maybe$Nothing),
									$author$project$Model$Content$scrollToTop
								])));
				case 2:
					var postUrl = contentRoute.a;
					var _v3 = A2(
						$author$project$Data$Content$findArticleByUrl,
						postUrl,
						$author$project$Model$Content$getListArticle(content));
					if (_v3.$ === 1) {
						return _Utils_Tuple2(
							content,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(postsStatusCmd, content.M, $elm$core$Maybe$Nothing),
										A3(
										$author$project$Data$Content$getArticle,
										1,
										$author$project$Model$Content$channelIDs.gH(postUrl),
										postUrl),
										categoriesStatusCmd($elm$core$Maybe$Nothing),
										$author$project$Model$Content$scrollToTop
									])));
					} else {
						return _Utils_Tuple2(content, $author$project$Model$Content$scrollToTop);
					}
				default:
					var pageUrl = contentRoute.a;
					var _v4 = content;
					var pages = _v4.ax;
					var _v5 = A2($elm$core$Dict$get, pageUrl, pages);
					if (_v5.$ === 1) {
						return _Utils_Tuple2(
							content,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3(
										$author$project$Data$Content$getArticle,
										0,
										$author$project$Model$Content$channelIDs.gG(pageUrl),
										pageUrl),
										$author$project$Model$Content$scrollToTop
									])));
					} else {
						return _Utils_Tuple2(content, $author$project$Model$Content$scrollToTop);
					}
			}
		}();
		var updatedModel = _v1.a;
		var cmd = _v1.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (cmd_) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[cmd, cmd_]));
			},
			$author$project$Model$Content$processHtml(
				_Utils_update(
					appModel,
					{cl: updatedModel})));
	});
var $author$project$Core$Data$Profile$Connect$FavoriteProfile = 2;
var $author$project$Core$Data$Profile$Connect$FavoritedMe = 1;
var $author$project$Types$RelatedProfilesKind = function (a) {
	return {$: 1, a: a};
};
var $author$project$Core$Data$Profile$Connect$ViewedMe = 0;
var $author$project$Core$Data$Profile$Connect$connectKindDbString = function (connectKind) {
	switch (connectKind) {
		case 0:
			return 'viewedMe';
		case 1:
			return 'favoritedMe';
		default:
			return 'favoriteProfile';
	}
};
var $author$project$Model$RelatedProfiles$channelIDs = {
	gK: F2(
		function (connectKind, userID) {
			return 'getRelatedProfileResult/' + ($author$project$Core$Data$Profile$Connect$connectKindDbString(connectKind) + ('/' + userID));
		}),
	ji: function (connectKind) {
		return 'syncRelatedProfilesIDsResult/' + $author$project$Core$Data$Profile$Connect$connectKindDbString(connectKind);
	}
};
var $author$project$Core$Data$Profile$Connect$receive = F4(
	function (connectKind, userID, limit, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getCollection(
				A2(
					$author$project$Firebase$Firestore$limit,
					limit,
					A3(
						$author$project$Firebase$Firestore$orderBy,
						'createdAt',
						1,
						$author$project$Firebase$Firestore$collection(
							'/profiles/' + (userID + ('/' + $author$project$Core$Data$Profile$Connect$connectKindDbString(connectKind))))))));
	});
var $author$project$Model$RelatedProfiles$syncRelatedProfilesIDs = F3(
	function (connectKind, userID, limit) {
		return A4(
			$author$project$Core$Data$Profile$Connect$receive,
			connectKind,
			userID,
			limit,
			$author$project$Model$RelatedProfiles$channelIDs.ji(connectKind));
	});
var $author$project$Model$RelatedProfiles$loadByRoute = F3(
	function (relatedProfileRoute, authState, appModel) {
		var _v0 = authState;
		var relatedProfiles = _v0.iD;
		var authUser = _v0.j2;
		var _v1 = authUser;
		var uid = _v1.eX;
		var _v2 = relatedProfiles;
		var viewedMe = _v2.oe;
		var favoritedMe = _v2.li;
		var favoriteProfile = _v2.lh;
		switch (relatedProfileRoute) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										kE: $elm$core$Maybe$Just(
											$author$project$Types$RelatedProfilesKind(0))
									}))
						}),
					A3($author$project$Model$RelatedProfiles$syncRelatedProfilesIDs, 0, uid, viewedMe.A));
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										kE: $elm$core$Maybe$Just(
											$author$project$Types$RelatedProfilesKind(1))
									}))
						}),
					A3($author$project$Model$RelatedProfiles$syncRelatedProfilesIDs, 1, uid, favoritedMe.A));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										kE: $elm$core$Maybe$Just(
											$author$project$Types$RelatedProfilesKind(2))
									}))
						}),
					A3($author$project$Model$RelatedProfiles$syncRelatedProfilesIDs, 2, uid, favoriteProfile.A));
		}
	});
var $author$project$Types$SearchKind = {$: 0};
var $author$project$Model$Search$channelIDs = {dZ: 'loadMoreSearchResult', eH: 'searchResult'};
var $author$project$Data$SearchProfile$filterByGender = F2(
	function (gender, query) {
		return $elm$core$String$isEmpty(gender) ? query : A4($author$project$Firebase$Firestore$where_, 'gender', 2, gender, query);
	});
var $author$project$Data$SearchProfile$filterByLastProfile = F3(
	function (profile, sortBy, query) {
		return A2(
			$elm$core$Maybe$withDefault,
			query,
			A2(
				$elm$core$Maybe$map,
				function (profile_) {
					if (sortBy === 'Newest') {
						return A4($author$project$Firebase$Firestore$whereTime, 'createdAt', 3, profile_.cm, query);
					} else {
						return A4($author$project$Firebase$Firestore$whereTime, 'lastOnline', 3, profile_.lZ, query);
					}
				},
				profile));
	});
var $author$project$Data$SearchProfile$filterByLocation = F2(
	function (location, query) {
		return $elm$core$String$isEmpty(location) ? query : A4($author$project$Firebase$Firestore$where_, 'locations', 5, location, query);
	});
var $author$project$Core$Data$Profile$WantGender$Both = 2;
var $author$project$Core$Data$Profile$WantGender$Man = 0;
var $author$project$Core$Data$Profile$WantGender$Woman = 1;
var $author$project$Core$Data$Profile$WantGender$toWantGender = function (wantGender) {
	switch (wantGender) {
		case 'Man':
			return 0;
		case 'Woman':
			return 1;
		case 'Both':
			return 2;
		default:
			return 2;
	}
};
var $author$project$Data$SearchProfile$filterByWantGender = F2(
	function (wantGender, query) {
		var _v0 = $author$project$Core$Data$Profile$WantGender$toWantGender(wantGender);
		switch (_v0) {
			case 2:
				return query;
			case 0:
				return A4($author$project$Firebase$Firestore$whereBool, 'wantGender.man', 2, true, query);
			default:
				return A4($author$project$Firebase$Firestore$whereBool, 'wantGender.woman', 2, true, query);
		}
	});
var $author$project$Core$Data$Profile$WantRelationship$compressWantRelationship = function (wantRelationship) {
	switch (wantRelationship) {
		case 0:
			return 'A';
		case 1:
			return 'B';
		case 2:
			return 'C';
		case 3:
			return 'D';
		case 4:
			return 'E';
		default:
			return 'F';
	}
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Core$Data$Profile$WantRelationship$getWantRelationshipsSearchString = function (wantRelationships) {
	return A2(
		$elm$core$String$join,
		'',
		$elm$core$List$sort(
			A2($elm$core$List$map, $author$project$Core$Data$Profile$WantRelationship$compressWantRelationship, wantRelationships)));
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Data$SearchProfile$filterByWantRelationships = F2(
	function (wantRelationships, query) {
		if ($elm$core$List$isEmpty(wantRelationships)) {
			return query;
		} else {
			var searchString = $author$project$Core$Data$Profile$WantRelationship$getWantRelationshipsSearchString(
				A2(
					$elm$core$List$filterMap,
					A2($elm$core$Basics$composeR, $author$project$Core$Data$Profile$WantRelationship$toWantRelationship, $elm$core$Result$toMaybe),
					wantRelationships));
			return A4($author$project$Firebase$Firestore$whereBool, '_searchWantRelationships_.' + searchString, 2, true, query);
		}
	});
var $author$project$Data$SearchProfile$sort = F2(
	function (sortBy, query) {
		if (sortBy === 'Newest') {
			return A3($author$project$Firebase$Firestore$orderBy, 'createdAt', 1, query);
		} else {
			return A3($author$project$Firebase$Firestore$orderBy, 'lastOnline', 1, query);
		}
	});
var $author$project$Core$Data$AuthUser$userKindString = function (userKind) {
	if (!userKind) {
		return 'Sponsor';
	} else {
		return 'Sugar';
	}
};
var $author$project$Data$SearchProfile$getProfiles = F3(
	function (_v0, profile, channelID) {
		var wantRelationships = _v0.b4;
		var location = _v0.hy;
		var gender = _v0.bt;
		var wantGender = _v0.di;
		var sortBy = _v0.i6;
		var searchFor = _v0.iQ;
		var limit = _v0.hs;
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getCollection(
				A2(
					$author$project$Data$SearchProfile$sort,
					sortBy,
					A2(
						$author$project$Firebase$Firestore$limit,
						limit,
						A3(
							$author$project$Data$SearchProfile$filterByLastProfile,
							profile,
							sortBy,
							A2(
								$author$project$Data$SearchProfile$filterByWantGender,
								wantGender,
								A2(
									$author$project$Data$SearchProfile$filterByGender,
									gender,
									A2(
										$author$project$Data$SearchProfile$filterByLocation,
										location,
										A2(
											$author$project$Data$SearchProfile$filterByWantRelationships,
											wantRelationships,
											A4(
												$author$project$Firebase$Firestore$where_,
												'userKind',
												2,
												$author$project$Core$Data$AuthUser$userKindString(searchFor),
												$author$project$Firebase$Firestore$collection('/backend/search/profiles')))))))))));
	});
var $author$project$Form$missingFieldWarning = F3(
	function (_v0, _v1, defaultValue) {
		return defaultValue;
	});
var $author$project$Form$getRawString = F2(
	function (form, name) {
		var _v0 = A2($elm$core$Dict$get, name, form.j);
		if ((!_v0.$) && (!_v0.a.$)) {
			var field = _v0.a.a;
			return field.v;
		} else {
			return A3($author$project$Form$missingFieldWarning, name, 'getRawString', '');
		}
	});
var $author$project$Helpers$Ports$Tracker$getDefault = F3(
	function (form, fieldName, defaultValue) {
		var value = A2($author$project$Form$getRawString, form, fieldName);
		return $elm$core$String$isEmpty(value) ? defaultValue : value;
	});
var $author$project$Form$getRawListString = F2(
	function (form, name) {
		var _v0 = A2($elm$core$Dict$get, name, form.j);
		if ((!_v0.$) && (_v0.a.$ === 2)) {
			var field = _v0.a.a;
			return field.v;
		} else {
			return A3($author$project$Form$missingFieldWarning, name, 'getRawListString', _List_Nil);
		}
	});
var $author$project$Core$Data$Profile$WantRelationship$wantRelationshipStringReference = function (wantRelationship) {
	switch (wantRelationship) {
		case 0:
			return _Utils_Tuple2('OR', 'OpenRelationship');
		case 1:
			return _Utils_Tuple2('CD', 'CasualDating');
		case 2:
			return _Utils_Tuple2('MF', 'MakeFriends');
		case 3:
			return _Utils_Tuple2('N', 'Networking');
		case 4:
			return _Utils_Tuple2('SR', 'SeriousRelationship');
		default:
			return _Utils_Tuple2('TC', 'TravelCompanion');
	}
};
var $author$project$Core$Data$Profile$WantRelationship$wantRelationshipsListShortString = function (wantRelationships) {
	return A2(
		$elm$core$List$map,
		A2($elm$core$Basics$composeR, $author$project$Core$Data$Profile$WantRelationship$wantRelationshipStringReference, $elm$core$Tuple$first),
		wantRelationships);
};
var $author$project$Helpers$Ports$Tracker$getRelationshipsString = F2(
	function (form, fieldName) {
		var relationships = A2(
			$elm$core$String$join,
			'/',
			$author$project$Core$Data$Profile$WantRelationship$wantRelationshipsListShortString(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Result$toMaybe,
					A2(
						$elm$core$List$map,
						$author$project$Core$Data$Profile$WantRelationship$toWantRelationship,
						A2($author$project$Form$getRawListString, form, fieldName)))));
		return $elm$core$String$isEmpty(relationships) ? '()' : ('(' + (relationships + ')'));
	});
var $author$project$Helpers$Ports$Tracker$getSearchLabel = F2(
	function (searchFor, form) {
		return A3($author$project$Helpers$Ports$Tracker$getDefault, form, 'gender', 'All') + (' finding ' + (A3($author$project$Helpers$Ports$Tracker$getDefault, form, 'finding', 'All') + (' ' + ($author$project$Core$Data$AuthUser$userKindString(searchFor) + (' in ' + (A3($author$project$Helpers$Ports$Tracker$getDefault, form, 'location', 'Anywhere') + (' ' + A2($author$project$Helpers$Ports$Tracker$getRelationshipsString, form, 'relationship'))))))));
	});
var $author$project$Helpers$Ports$Tracker$registerEvent = _Platform_outgoingPort(
	'registerEvent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'action',
					$elm$json$Json$Encode$string($.b7)),
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$string($.ck)),
					_Utils_Tuple2(
					'label',
					$elm$json$Json$Encode$string($.dX)),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$int($.v))
				]));
	});
var $author$project$Helpers$Ports$Tracker$registerSearchParams = F3(
	function (searchFor, lastForm, currentForm) {
		var lastLabel = A2($author$project$Helpers$Ports$Tracker$getSearchLabel, searchFor, lastForm);
		var currentLabel = A2($author$project$Helpers$Ports$Tracker$getSearchLabel, searchFor, currentForm);
		return _Utils_eq(currentLabel, lastLabel) ? $elm$core$Platform$Cmd$none : $author$project$Helpers$Ports$Tracker$registerEvent(
			{b7: 'Search', ck: 'Profiles', dX: currentLabel, v: 1});
	});
var $author$project$Model$Search$toSearchParams = function (_v0) {
	var form = _v0.ln;
	var searchLimit = _v0.A;
	var searchFor = _v0.iQ;
	return {
		bt: A2($author$project$Form$getRawString, form, 'gender'),
		hs: searchLimit,
		hy: A2($author$project$Form$getRawString, form, 'location'),
		iQ: searchFor,
		i6: A2($author$project$Form$getRawString, form, 'sort'),
		di: A2($author$project$Form$getRawString, form, 'finding'),
		b4: A2($author$project$Form$getRawListString, form, 'relationship')
	};
};
var $author$project$Model$Search$getProfilesCmd = F3(
	function (oldForm, model, channelID) {
		var profile = _Utils_eq(channelID, $author$project$Model$Search$channelIDs.dZ) ? A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeL, $elm$core$List$head, $elm$core$List$reverse),
				model.iw)) : $elm$core$Maybe$Nothing;
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3(
					$author$project$Data$SearchProfile$getProfiles,
					$author$project$Model$Search$toSearchParams(model),
					profile,
					channelID),
					A3($author$project$Helpers$Ports$Tracker$registerSearchParams, model.iQ, oldForm, model.ln)
				]));
	});
var $author$project$Model$Search$loadByRoute = F2(
	function (authState, appModel) {
		var updatedAppModel = _Utils_update(
			appModel,
			{
				j1: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							kE: $elm$core$Maybe$Just($author$project$Types$SearchKind)
						}))
			});
		return _Utils_eq(authState.nm.iw, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(
			updatedAppModel,
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Types$OnAuth,
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Types$OnSearch,
					A3($author$project$Model$Search$getProfilesCmd, authState.nm.ln, authState.nm, $author$project$Model$Search$channelIDs.eH)))) : _Utils_Tuple2(updatedAppModel, $elm$core$Platform$Cmd$none);
	});
var $author$project$Firebase$Auth$SignOut = {$: 5};
var $author$project$Firebase$Auth$signOut = $author$project$Firebase$Auth$send($author$project$Firebase$Auth$SignOut);
var $author$project$Model$Route$onUrlChange = F2(
	function (url, model_) {
		var route = A2($author$project$Data$Route$getRoute, model_.kQ, url);
		var model = _Utils_update(
			model_,
			{ng: route, n8: url});
		var _v0 = model.j1;
		if (_v0.$ === 1) {
			if (route.$ === 23) {
				var contentRoute = route.a;
				return A2($author$project$Model$Content$loadByRoute, contentRoute, model);
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			var authState = _v0.a;
			switch (route.$) {
				case 0:
					var _v3 = model.kQ;
					if (_v3.$ === 1) {
						return A2($author$project$Model$Search$loadByRoute, authState, model);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 18:
					return A2($author$project$Model$Search$loadByRoute, authState, model);
				case 19:
					var relatedProfileRoute = route.a;
					return A3($author$project$Model$RelatedProfiles$loadByRoute, relatedProfileRoute, authState, model);
				case 20:
					var userID = route.a;
					return A3($author$project$Model$Detail$checkProfile, userID, authState, model);
				case 23:
					var contentRoute = route.a;
					return A2($author$project$Model$Content$loadByRoute, contentRoute, model);
				case 21:
					return A2($author$project$Model$Chat$initialRoomsFromRoute, authState, model);
				case 11:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b8: A2($author$project$Data$Alert$addInfo, 'Logging you out', model.b8)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Firebase$Auth$signOut,
									$author$project$NativeBridge$fcmUnSubscribeTopic(authState.j2.eX)
								])));
				case 22:
					return A2($author$project$Model$Block$loadByRoute, authState, model);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Data$Chat$getCurrentRoom = function (_v0) {
	var state = _v0;
	return state.a.f8;
};
var $author$project$Data$Chat$currentRoomBelongsTo = F2(
	function (partnerID, _v0) {
		var state = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(partnerID),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.q;
						},
						function ($) {
							return $.eX;
						}),
					$author$project$Data$Chat$Room$getCurrent(state.a))));
	});
var $author$project$Data$Scroll$isNearBottom = F2(
	function (threshold, _v0) {
		var scrollHeight = _v0.eG;
		var scrollTop = _v0.bT;
		var clientHeight = _v0.dp;
		return _Utils_cmp((scrollHeight - scrollTop) - clientHeight, threshold) < 0;
	});
var $author$project$Model$Chat$pageChatMessageID = 'PageChatMessageID';
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Data$Scroll$toBottom = function (elementID) {
	return A2(
		$elm$core$Task$andThen,
		function (info) {
			return A3($elm$browser$Browser$Dom$setViewportOf, elementID, 0, info.nh.bu);
		},
		$elm$browser$Browser$Dom$getViewportOf(elementID));
};
var $author$project$Model$Chat$scrollToBottom = A2(
	$elm$core$Task$attempt,
	$elm$core$Basics$always($author$project$Types$Noop),
	$author$project$Data$Scroll$toBottom($author$project$Model$Chat$pageChatMessageID));
var $author$project$Model$Chat$scrollToBottomIfUserIsAtBottom = F2(
	function (partnerID, model) {
		if (A2($author$project$Data$Chat$currentRoomBelongsTo, partnerID, model.i8)) {
			var _v0 = A2($elm$core$Dict$get, partnerID, model.bC);
			if (_v0.$ === 1) {
				return $author$project$Model$Chat$scrollToBottom;
			} else {
				var scrollPosition = _v0.a;
				return A2($author$project$Data$Scroll$isNearBottom, 250, scrollPosition) ? $author$project$Model$Chat$scrollToBottom : $elm$core$Platform$Cmd$none;
			}
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Model$Chat$onWindowResize = function (appModel) {
	var _v0 = appModel.j1;
	if (_v0.$ === 1) {
		return $elm$core$Platform$Cmd$none;
	} else {
		var chat = _v0.a.km;
		var _v1 = $author$project$Data$Chat$getCurrentRoom(chat.i8);
		if (_v1.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var partner = _v1.a.q;
			return A2($author$project$Model$Chat$scrollToBottomIfUserIsAtBottom, partner.eX, chat);
		}
	}
};
var $author$project$Data$Alert$remove = F2(
	function (alert, _v0) {
		var alerts = _v0;
		return A2(
			$elm$core$Dict$remove,
			$author$project$Data$Alert$generateID(alert),
			alerts);
	});
var $author$project$Types$OnAuthStateChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Deactivate$authDeleted = function (appModel) {
	return _Utils_Tuple2(
		appModel,
		A2($elm$browser$Browser$Navigation$pushUrl, appModel.bD, $author$project$Data$Route$routeUrl.lG));
};
var $author$project$Model$Deactivate$channelIDs = {kJ: 'deactivateProfile'};
var $author$project$Firebase$Firestore$encodeTimestamp = function (time) {
	return $elm$json$Json$Encode$string(
		'ELM-FIREBASE::ENCODED-TIME|' + $elm$core$String$fromInt(
			$elm$time$Time$posixToMillis(time)));
};
var $author$project$Core$Data$Profile$Benefit$benefitString = function (benefit) {
	switch (benefit) {
		case 0:
			return 'ActiveLifestyle';
		case 1:
			return 'ActivityPartner';
		case 2:
			return 'Adventure';
		case 3:
			return 'Affection';
		case 4:
			return 'AllEthnicities';
		case 5:
			return 'AnimalLover';
		case 6:
			return 'Attention';
		case 7:
			return 'BBW';
		case 8:
			return 'CasualDates';
		case 9:
			return 'CasualEncounters';
		case 10:
			return 'CasualMeetups';
		case 11:
			return 'CoffeeDates';
		case 14:
			return 'Confidant';
		case 12:
			return 'Companion';
		case 13:
			return 'ConcertsMusicalsPlays';
		case 15:
			return 'DaytimeMeetUps';
		case 16:
			return 'DinnerDates';
		case 17:
			return 'Discretion';
		case 18:
			return 'EmotionalConnection';
		case 19:
			return 'EveningMeetUps';
		case 20:
			return 'Excitement';
		case 21:
			return 'Exclusive';
		case 22:
			return 'FinancialSupport';
		case 23:
			return 'FlexibleSchedule';
		case 24:
			return 'FoodLover';
		case 25:
			return 'FriendsWithBenefits';
		case 26:
			return 'Fun';
		case 27:
			return 'GayDating';
		case 28:
			return 'GoodCook';
		case 29:
			return 'HookUp';
		case 30:
			return 'LesbianDating';
		case 31:
			return 'ListeningEar';
		case 32:
			return 'LongTerm';
		case 33:
			return 'LunchDates';
		case 34:
			return 'MarriageMinded';
		case 35:
			return 'MediumTerm';
		case 36:
			return 'MeetForDrinks';
		case 37:
			return 'Mentorship';
		case 38:
			return 'MinimalTattoos';
		case 39:
			return 'Monogamous';
		case 40:
			return 'MonthlyAllowance';
		case 41:
			return 'MovieDates';
		case 42:
			return 'NatureLover';
		case 43:
			return 'NightTimeMeetUps';
		case 44:
			return 'NoAttached';
		case 45:
			return 'NoIntimacy';
		case 46:
			return 'NoMarried';
		case 47:
			return 'NoStayovers';
		case 48:
			return 'NoStringsAttached';
		case 49:
			return 'NoTravel';
		case 50:
			return 'NonExclusive';
		case 51:
			return 'NonMonogamous';
		case 52:
			return 'OccasionalDates';
		case 53:
			return 'OneOffDates';
		case 54:
			return 'OnlineOnly';
		case 55:
			return 'ONS';
		case 56:
			return 'OpenRelationship';
		case 57:
			return 'Pescatarian';
		case 58:
			return 'Platonic';
		case 59:
			return 'ProfessionalNetworking';
		case 60:
			return 'RentAssistance';
		case 61:
			return 'Romance';
		case 62:
			return 'SeniorDating';
		case 63:
			return 'ShortTerm';
		case 64:
			return 'SinglesOnly';
		case 65:
			return 'Soulmate';
		case 66:
			return 'Spontaneity';
		case 67:
			return 'SportsDates';
		case 68:
			return 'StayInPartner';
		case 69:
			return 'Staycations';
		case 70:
			return 'Stayovers';
		case 71:
			return 'SugarNewbie';
		case 72:
			return 'SugarVeteran';
		case 73:
			return 'Surprises';
		case 74:
			return 'TattooFriendly';
		case 75:
			return 'TransFriendly';
		case 76:
			return 'Transgender';
		case 77:
			return 'TravelToYou';
		case 78:
			return 'TravelWithYou';
		case 79:
			return 'Vacations';
		case 80:
			return 'Vegetarian';
		case 81:
			return 'WeekdaysOnly';
		default:
			return 'WeekendsOnly';
	}
};
var $author$project$Core$Data$Profile$Benefit$encoder = function (benefit) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$Benefit$benefitString(benefit));
};
var $author$project$Core$Data$Profile$BodyType$bodyTypeString = function (bodyType) {
	switch (bodyType) {
		case 0:
			return 'Slim';
		case 1:
			return 'Athletic';
		case 2:
			return 'Average';
		case 3:
			return 'Curvy';
		case 4:
			return 'Flabby';
		case 5:
			return 'Overweight';
		default:
			return 'OtherBodyType';
	}
};
var $author$project$Core$Data$Profile$BodyType$encoder = function (bodyType) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$BodyType$bodyTypeString(bodyType));
};
var $author$project$Core$Data$Profile$Drinker$drinkerString = function (drinker) {
	switch (drinker) {
		case 0:
			return 'NonDrinker';
		case 1:
			return 'SocialDrinker';
		default:
			return 'HeavyDrinker';
	}
};
var $author$project$Core$Data$Profile$Drinker$encoder = function (drinker) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$Drinker$drinkerString(drinker));
};
var $author$project$Core$Data$Profile$Education$educationString = function (education) {
	switch (education) {
		case 0:
			return 'HighSchool';
		case 1:
			return 'College';
		case 2:
			return 'AssociatesDegree';
		case 3:
			return 'BachelorsDegree';
		case 4:
			return 'GraduateDegree';
		default:
			return 'PhD';
	}
};
var $author$project$Core$Data$Profile$Education$encoder = function (education) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$Education$educationString(education));
};
var $author$project$Core$Data$Profile$Ethnicity$ethnicityString = function (ethnicity) {
	switch (ethnicity) {
		case 0:
			return 'Asian';
		case 1:
			return 'Black';
		case 2:
			return 'Latin';
		case 3:
			return 'EastIndian';
		case 4:
			return 'MiddleEastern';
		case 5:
			return 'Mixed';
		case 6:
			return 'NativeAmerican';
		case 7:
			return 'PacificIslander';
		case 8:
			return 'White';
		default:
			return 'OtherEthnicity';
	}
};
var $author$project$Core$Data$Profile$Ethnicity$encoder = function (ethnicity) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$Ethnicity$ethnicityString(ethnicity));
};
var $author$project$Core$Data$Profile$Gender$genderString = function (gender) {
	if (!gender) {
		return 'Male';
	} else {
		return 'Female';
	}
};
var $author$project$Core$Data$Profile$Gender$encoder = function (gender) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$Gender$genderString(gender));
};
var $author$project$Core$Data$Profile$Height$heightString = function (height) {
	if (!height.$) {
		var cm = height.a;
		return $elm$core$String$fromInt(cm);
	} else {
		return 'OtherHeight';
	}
};
var $author$project$Core$Data$Profile$Height$encoder = function (height) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$Height$heightString(height));
};
var $author$project$Core$Data$Profile$LifestyleExpectation$lifestyleExpectationString = function (lifestyleExpectation) {
	switch (lifestyleExpectation) {
		case 0:
			return 'Go Dutch';
		case 1:
			return 'Equal Split';
		case 2:
			return 'Open';
		case 3:
			return 'Negotiable';
		case 4:
			return 'Minimal';
		case 5:
			return 'Practical';
		case 6:
			return 'Moderate';
		case 7:
			return 'Substantial';
		case 8:
			return 'High';
		case 9:
			return 'Extravagant';
		default:
			return 'Luxurious';
	}
};
var $author$project$Core$Data$Profile$LifestyleExpectation$encoder = function (lifestyleExpectation) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$LifestyleExpectation$lifestyleExpectationString(lifestyleExpectation));
};
var $author$project$Core$Data$Profile$MaritalStatus$maritalStatusString = function (maritalStatus) {
	switch (maritalStatus) {
		case 0:
			return 'Single';
		case 1:
			return 'OpenRelationship';
		case 2:
			return 'Separated';
		case 3:
			return 'Divorced';
		case 4:
			return 'Widowed';
		case 5:
			return 'AttachedButLooking';
		case 6:
			return 'MarriedButLooking';
		default:
			return 'NotSpecifiedMarital';
	}
};
var $author$project$Core$Data$Profile$MaritalStatus$encoder = function (martialStatus) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$MaritalStatus$maritalStatusString(martialStatus));
};
var $author$project$Core$Data$Profile$NumberOfChildren$numberOfChildrenString = function (children) {
	switch (children) {
		case 0:
			return 'NotSpecified';
		case 1:
			return 'Zero';
		case 2:
			return 'One';
		case 3:
			return 'Two';
		case 4:
			return 'Three';
		case 5:
			return 'Four';
		case 6:
			return 'Five';
		default:
			return 'SixOrMore';
	}
};
var $author$project$Core$Data$Profile$NumberOfChildren$encoder = function (num) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$NumberOfChildren$numberOfChildrenString(num));
};
var $author$project$Core$Data$Profile$Smoker$smokerString = function (smoker) {
	switch (smoker) {
		case 0:
			return 'NonSmoker';
		case 1:
			return 'LightSmoker';
		default:
			return 'HeavySmoker';
	}
};
var $author$project$Core$Data$Profile$Smoker$encoder = function (smoker) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$Smoker$smokerString(smoker));
};
var $author$project$Core$Data$Profile$SponsorLevel$encoder = function (sponsorLevel) {
	return $elm$json$Json$Encode$int(
		$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(sponsorLevel));
};
var $author$project$Core$Data$Profile$Status$statusString = function (profileStatus) {
	switch (profileStatus) {
		case 0:
			return 'Completed';
		case 1:
			return 'InCompleted';
		case 2:
			return 'Deactivated';
		default:
			return 'Cloaked';
	}
};
var $author$project$Core$Data$Profile$Status$encoder = function (status) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$Status$statusString(status));
};
var $author$project$Core$Data$Profile$WantGender$encoder = function (wantGender) {
	switch (wantGender) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'man',
						$elm$json$Json$Encode$bool(true)),
						_Utils_Tuple2(
						'woman',
						$elm$json$Json$Encode$bool(false))
					]));
		case 1:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'man',
						$elm$json$Json$Encode$bool(false)),
						_Utils_Tuple2(
						'woman',
						$elm$json$Json$Encode$bool(true))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'man',
						$elm$json$Json$Encode$bool(true)),
						_Utils_Tuple2(
						'woman',
						$elm$json$Json$Encode$bool(true))
					]));
	}
};
var $author$project$Core$Data$Profile$WantRelationship$wantRelationshipString = function (wantRelationship) {
	return $author$project$Core$Data$Profile$WantRelationship$wantRelationshipStringReference(wantRelationship).b;
};
var $author$project$Core$Data$Profile$WantRelationship$encoder = function (wantRelationship) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Profile$WantRelationship$wantRelationshipString(wantRelationship));
};
var $author$project$Core$Data$AuthUser$userKindEncoder = function (userKind) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$AuthUser$userKindString(userKind));
};
var $author$project$Core$Data$Profile$encode = function (profile) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'username',
					$elm$json$Json$Encode$string(profile.dh)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(profile.dt)),
					_Utils_Tuple2(
					'gender',
					$author$project$Core$Data$Profile$Gender$encoder(profile.bt)),
					_Utils_Tuple2(
					'wantGender',
					$author$project$Core$Data$Profile$WantGender$encoder(profile.di)),
					_Utils_Tuple2(
					'lifestyleExpectation',
					$author$project$Core$Data$Profile$LifestyleExpectation$encoder(profile.bz)),
					_Utils_Tuple2(
					'birthday',
					$author$project$Firebase$Firestore$encodeTimestamp(profile.cf)),
					_Utils_Tuple2(
					'height',
					$author$project$Core$Data$Profile$Height$encoder(profile.bu)),
					_Utils_Tuple2(
					'bodyType',
					$author$project$Core$Data$Profile$BodyType$encoder(profile.bi)),
					_Utils_Tuple2(
					'ethnicity',
					$author$project$Core$Data$Profile$Ethnicity$encoder(profile.bo)),
					_Utils_Tuple2(
					'locations',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, profile.cE)),
					_Utils_Tuple2(
					'headline',
					$elm$json$Json$Encode$string(profile.cy)),
					_Utils_Tuple2(
					'aboutMe',
					$elm$json$Json$Encode$string(profile.b6)),
					_Utils_Tuple2(
					'maritalStatus',
					$author$project$Core$Data$Profile$MaritalStatus$encoder(profile.bB)),
					_Utils_Tuple2(
					'wantRelationships',
					A2($elm$json$Json$Encode$list, $author$project$Core$Data$Profile$WantRelationship$encoder, profile.b4)),
					_Utils_Tuple2(
					'numberOfChildren',
					$author$project$Core$Data$Profile$NumberOfChildren$encoder(profile.bF)),
					_Utils_Tuple2(
					'education',
					$author$project$Core$Data$Profile$Education$encoder(profile.bn)),
					_Utils_Tuple2(
					'occupation',
					$elm$json$Json$Encode$string(profile.cN)),
					_Utils_Tuple2(
					'smoker',
					$author$project$Core$Data$Profile$Smoker$encoder(profile.bW)),
					_Utils_Tuple2(
					'drinker',
					$author$project$Core$Data$Profile$Drinker$encoder(profile.bm)),
					_Utils_Tuple2(
					'benefits',
					A2($elm$json$Json$Encode$list, $author$project$Core$Data$Profile$Benefit$encoder, profile.bg)),
					_Utils_Tuple2(
					'otherBenefit',
					$elm$json$Json$Encode$string(profile.cP)),
					_Utils_Tuple2(
					'createdAt',
					$author$project$Firebase$Firestore$encodeTimestamp(profile.cm)),
					_Utils_Tuple2('updatedAt', $author$project$Firebase$Firestore$serverTimestamp),
					_Utils_Tuple2(
					'privatePhotoNumber',
					$elm$json$Json$Encode$int(profile.cZ)),
					_Utils_Tuple2('lastOnline', $author$project$Firebase$Firestore$serverTimestamp),
					_Utils_Tuple2(
					'avatar',
					$elm$json$Json$Encode$string(profile.cc)),
					_Utils_Tuple2(
					'status',
					$author$project$Core$Data$Profile$Status$encoder(profile.eQ)),
					_Utils_Tuple2(
					'userKind',
					$author$project$Core$Data$AuthUser$userKindEncoder(profile.eY)),
					_Utils_Tuple2(
					'sponsorLevel',
					$author$project$Core$Data$Profile$SponsorLevel$encoder(profile.bY))
				])));
};
var $author$project$Core$Data$Profile$deactivate = F2(
	function (profile, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$updateDoc,
				$author$project$Core$Data$Profile$encode(
					_Utils_update(
						profile,
						{eQ: 2})),
				$author$project$Firebase$Firestore$doc('/profiles/' + profile.eX)));
	});
var $author$project$Model$Deactivate$deactivateProfile = F3(
	function (response, authState, appModel) {
		var _v0 = $author$project$Helpers$getCurrentUserProfile(authState);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var profile = _v0.a;
			if (response.$ === 1) {
				var _v2 = response.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{gc: $author$project$Model$Deactivate$initialModel.a}))
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(
					appModel,
					A2($author$project$Core$Data$Profile$deactivate, profile, $author$project$Model$Deactivate$channelIDs.kJ));
			}
		}
	});
var $author$project$Model$ForgetPassword$forgetPasswordHandler = F2(
	function (response, model) {
		var _v0 = model;
		var forgetPassword = _v0.lm;
		var _v1 = forgetPassword;
		var form = _v1.ln;
		var updatedForm = _Utils_update(
			form,
			{jc: false});
		if (response.$ === 1) {
			var _v3 = response.a;
			var message = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						lm: _Utils_update(
							forgetPassword,
							{
								dk: $elm$core$Maybe$Just(message),
								ln: updatedForm
							})
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						lm: _Utils_update(
							forgetPassword,
							{dk: $elm$core$Maybe$Nothing, ln: updatedForm, hi: true})
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Login$onLogout = F2(
	function (response, model) {
		if (!response.$) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						b8: A2($author$project$Data$Alert$addInfo, 'You are logged out successfully', $author$project$Data$Alert$clear)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var _v1 = response.a;
			var message = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						b8: A2($author$project$Data$Alert$addFailure, message, model.b8)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Channel$onlyHandleWithAuthState = F2(
	function (model, handler) {
		var _v0 = model.j1;
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var authState = _v0.a;
			return A2(handler, authState, model);
		}
	});
var $author$project$Model$Register$channelIDs = {
	h_: function (uid) {
		return 'onCreateDbUser/' + uid;
	}
};
var $author$project$Firebase$Firestore$SetDoc = function (a) {
	return {$: 1, a: a};
};
var $author$project$Firebase$Firestore$setDoc = F2(
	function (json, document) {
		return A2(
			$author$project$Firebase$Firestore$Query,
			document,
			$author$project$Firebase$Firestore$SetDoc(json));
	});
var $author$project$Model$Register$createDbUser = F2(
	function (form, user) {
		var wantGender = $author$project$Core$Data$Profile$WantGender$toWantGender(
			A2($author$project$Form$getRawString, form, 'wantGender'));
		var json = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'wantGender',
						$author$project$Core$Data$Profile$WantGender$encoder(wantGender)),
						_Utils_Tuple2(
						'email',
						$elm$json$Json$Encode$string(
							A2($author$project$Form$getRawString, form, 'email'))),
						_Utils_Tuple2(
						'username',
						$elm$json$Json$Encode$string(
							A2($author$project$Form$getRawString, form, 'username'))),
						_Utils_Tuple2(
						'gender',
						$elm$json$Json$Encode$string(
							A2($author$project$Form$getRawString, form, 'gender'))),
						_Utils_Tuple2('createdAt', $author$project$Firebase$Firestore$serverTimestamp),
						_Utils_Tuple2('updatedAt', $author$project$Firebase$Firestore$serverTimestamp),
						_Utils_Tuple2(
						'userKind',
						$elm$json$Json$Encode$string(
							A2($author$project$Form$getRawString, form, 'userKind'))),
						_Utils_Tuple2(
						'sponsorLevel',
						$author$project$Core$Data$Profile$SponsorLevel$encoder(0)),
						_Utils_Tuple2(
						'status',
						$author$project$Core$Data$Profile$Status$encoder(1)),
						_Utils_Tuple2(
						'verifyStatus',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$bool(false)),
									_Utils_Tuple2(
									'photo',
									$elm$json$Json$Encode$bool(false))
								])))
					])));
		var _v0 = user;
		var uid = _v0.eX;
		return A2(
			$author$project$Firebase$Firestore$send,
			$author$project$Model$Register$channelIDs.h_(uid),
			A2(
				$author$project$Firebase$Firestore$setDoc,
				json,
				$author$project$Firebase$Firestore$doc('/profiles/' + uid)));
	});
var $author$project$Firebase$Auth$UpdateProfile = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Firebase$Auth$updateProfile = F2(
	function (displayName, photoURL) {
		return $author$project$Firebase$Auth$send(
			A2($author$project$Firebase$Auth$UpdateProfile, displayName, photoURL));
	});
var $author$project$Model$Register$userKindtoPhotoURL = function (userKind) {
	return 'https://happymatches.com/assets/images/' + ($elm$core$String$toLower(userKind) + '.jpg');
};
var $author$project$Model$Register$registerResponse = F2(
	function (response, appModel) {
		var model = appModel.na;
		var _v0 = model;
		var form = _v0.ln;
		if (response.$ === 1) {
			var _v2 = response.a;
			var message = _v2.b;
			var updatedModel = _Utils_update(
				model,
				{
					dk: $elm$core$Maybe$Just(message),
					ln: _Utils_update(
						form,
						{jc: false})
				});
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{na: updatedModel}),
				$elm$core$Platform$Cmd$none);
		} else {
			var user = response.a;
			var username = A2($author$project$Form$getRawString, form, 'username');
			var userKind = $author$project$Model$Register$userKindtoPhotoURL(
				A2($author$project$Form$getRawString, form, 'userKind'));
			var updatedUser = _Utils_update(
				user,
				{
					ds: $elm$core$Maybe$Just(username),
					mQ: $elm$core$Maybe$Just(userKind)
				});
			return _Utils_Tuple2(
				appModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Firebase$Auth$updateProfile, username, userKind),
							A2($author$project$Model$Register$createDbUser, form, updatedUser)
						])));
		}
	});
var $author$project$Model$Login$signInHandler = F2(
	function (response, appModel) {
		var _v0 = appModel;
		var login = _v0.l1;
		var _v1 = login;
		var form = _v1.ln;
		if (response.$ === 1) {
			var _v3 = response.a;
			var message = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						l1: _Utils_update(
							login,
							{
								dk: $elm$core$Maybe$Just(message),
								ln: _Utils_update(
									form,
									{jc: false})
							})
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{l1: $author$project$Model$Login$initialModel}),
				A2($elm$browser$Browser$Navigation$pushUrl, appModel.bD, $author$project$Data$Route$routeUrl.nm));
		}
	});
var $author$project$Firebase$Auth$UpdatePassword = function (a) {
	return {$: 6, a: a};
};
var $author$project$Firebase$Auth$updatePassword = function (password) {
	return $author$project$Firebase$Auth$send(
		$author$project$Firebase$Auth$UpdatePassword(password));
};
var $author$project$Model$UpdatePassword$updatePasswordHandler = F3(
	function (response, authState, model) {
		var _v0 = authState;
		var updatePassword = _v0.n6;
		var _v1 = updatePassword;
		var form = _v1.ln;
		var newPassword = A2($author$project$Form$getRawString, form, 'newPassword');
		if (response.$ === 1) {
			var _v3 = response.a;
			var message = _v3.b;
			return function (authState_) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j1: $elm$core$Maybe$Just(authState_)
						}),
					$elm$core$Platform$Cmd$none);
			}(
				function (updatePassword_) {
					return _Utils_update(
						authState,
						{n6: updatePassword_});
				}(
					_Utils_update(
						updatePassword,
						{
							dk: $elm$core$Maybe$Just(message),
							ln: _Utils_update(
								form,
								{jc: false})
						})));
		} else {
			return _Utils_Tuple2(
				model,
				$author$project$Firebase$Auth$updatePassword(newPassword));
		}
	});
var $author$project$Model$UpdatePassword$updatePasswordResult = F3(
	function (response, authState, model) {
		var resetModel = $author$project$Model$UpdatePassword$initialModel.a;
		var _v0 = authState;
		var updatePassword = _v0.n6;
		var _v1 = updatePassword;
		var form = _v1.ln;
		if (response.$ === 1) {
			var _v3 = response.a;
			var message = _v3.b;
			return function (authState_) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j1: $elm$core$Maybe$Just(authState_)
						}),
					$elm$core$Platform$Cmd$none);
			}(
				function (updatePassword_) {
					return _Utils_update(
						authState,
						{n6: updatePassword_});
				}(
					_Utils_update(
						updatePassword,
						{
							dk: $elm$core$Maybe$Just(message),
							ln: _Utils_update(
								form,
								{jc: false})
						})));
		} else {
			return function (authState_) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j1: $elm$core$Maybe$Just(authState_)
						}),
					$elm$core$Platform$Cmd$none);
			}(
				function (updatePassword_) {
					return _Utils_update(
						authState,
						{n6: updatePassword_});
				}(
					_Utils_update(
						resetModel,
						{hi: true})));
		}
	});
var $author$project$Model$Channel$updateFromAuth = F2(
	function (whatResponse, model) {
		switch (whatResponse.$) {
			case 1:
				var response = whatResponse.a;
				return A2($author$project$Model$Register$registerResponse, response, model);
			case 5:
				var response = whatResponse.a;
				var _v1 = model.ng;
				switch (_v1.$) {
					case 14:
						return A2(
							$author$project$Model$Channel$onlyHandleWithAuthState,
							model,
							$author$project$Model$Deactivate$deactivateProfile(response));
					case 16:
						return A2(
							$author$project$Model$Channel$onlyHandleWithAuthState,
							model,
							$author$project$Model$UpdatePassword$updatePasswordHandler(response));
					default:
						return A2($author$project$Model$Login$signInHandler, response, model);
				}
			case 6:
				var response = whatResponse.a;
				return A2($author$project$Model$Login$onLogout, response, model);
			case 3:
				var response = whatResponse.a;
				return A2($author$project$Model$ForgetPassword$forgetPasswordHandler, response, model);
			case 8:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 7:
				var response = whatResponse.a;
				return A2(
					$author$project$Model$Channel$onlyHandleWithAuthState,
					model,
					$author$project$Model$UpdatePassword$updatePasswordResult(response));
			case 9:
				return $author$project$Model$Deactivate$authDeleted(model);
			case 10:
				var user = whatResponse.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Types$OnAuthStateChanged,
						$elm$core$Task$succeed(user)));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b8: A2($author$project$Data$Alert$addDanger, 'Unhandled Firebase Auth Response', model.b8)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Helpers$BlockUser$Types$Failure = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$BlockProfile$block = F3(
	function (channelID, userID, _v0) {
		var uid = _v0.eX;
		var username = _v0.dh;
		var avatar = _v0.cc;
		var json = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'username',
						$elm$json$Json$Encode$string(username)),
						_Utils_Tuple2(
						'avatar',
						$elm$json$Json$Encode$string(avatar)),
						_Utils_Tuple2(
						'blocked',
						$elm$json$Json$Encode$bool(true)),
						_Utils_Tuple2('createdAt', $author$project$Firebase$Firestore$serverTimestamp)
					])));
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$setDoc,
				json,
				$author$project$Firebase$Firestore$doc('/profiles/' + (userID + ('/blockProfile/' + uid)))));
	});
var $author$project$Firebase$Firestore$DecodeError = function (a) {
	return {$: 17, a: a};
};
var $author$project$Firebase$Firestore$Error = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Firebase$Firestore$DocumentSnapshot = F4(
	function (id, exists, data, metadata) {
		return {kH: data, k3: exists, lK: id, me: metadata};
	});
var $author$project$Firebase$Firestore$DocumentMetadata = F2(
	function (fromCache, hasPendingWrites) {
		return {lq: fromCache, gR: hasPendingWrites};
	});
var $author$project$Firebase$Firestore$documentMetadataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Firebase$Firestore$DocumentMetadata,
	A2($elm$json$Json$Decode$field, 'fromCache', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'hasPendingWrites', $elm$json$Json$Decode$bool));
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Firebase$Firestore$documentSnapshotDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Firebase$Firestore$DocumentSnapshot,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'exists', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'metadata', $author$project$Firebase$Firestore$documentMetadataDecoder));
var $author$project$Firebase$Firestore$Aborted = {$: 9};
var $author$project$Firebase$Firestore$AlreadyExists = {$: 5};
var $author$project$Firebase$Firestore$Cancelled = {$: 0};
var $author$project$Firebase$Firestore$DataLoss = {$: 14};
var $author$project$Firebase$Firestore$DeadlineExceeded = {$: 3};
var $author$project$Firebase$Firestore$DocumentNotFound = {$: 16};
var $author$project$Firebase$Firestore$ElmFirebaseInternal = {$: 18};
var $author$project$Firebase$Firestore$FailedPrecondition = {$: 8};
var $author$project$Firebase$Firestore$Internal = {$: 12};
var $author$project$Firebase$Firestore$InvalidArgument = {$: 2};
var $author$project$Firebase$Firestore$NotFound = {$: 4};
var $author$project$Firebase$Firestore$OutOfRange = {$: 10};
var $author$project$Firebase$Firestore$PermissionDenied = {$: 6};
var $author$project$Firebase$Firestore$ResourceExhausted = {$: 7};
var $author$project$Firebase$Firestore$Unauthenticated = {$: 15};
var $author$project$Firebase$Firestore$Unavailable = {$: 13};
var $author$project$Firebase$Firestore$UndocumentedErrorByElmFirebase = function (a) {
	return {$: 19, a: a};
};
var $author$project$Firebase$Firestore$Unimplemented = {$: 11};
var $author$project$Firebase$Firestore$Unknown = {$: 1};
var $author$project$Firebase$Firestore$errorCodeDecoder = function () {
	var convert = function (str) {
		switch (str) {
			case 'cancelled':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$Cancelled);
			case 'unknown':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$Unknown);
			case 'invalid-argument':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$InvalidArgument);
			case 'deadline-exceeded':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$DeadlineExceeded);
			case 'not-found':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$NotFound);
			case 'already-exists':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$AlreadyExists);
			case 'permission-denied':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$PermissionDenied);
			case 'resource-exhausted':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$ResourceExhausted);
			case 'failed-precondition':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$FailedPrecondition);
			case 'aborted':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$Aborted);
			case 'out-of-range':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$OutOfRange);
			case 'unimplemented':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$Unimplemented);
			case 'internal':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$Internal);
			case 'unavailable':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$Unavailable);
			case 'data-loss':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$DataLoss);
			case 'unauthenticated':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$Unauthenticated);
			case 'doc-not-found':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$DocumentNotFound);
			case 'elm-firebase-internal':
				return $elm$json$Json$Decode$succeed($author$project$Firebase$Firestore$ElmFirebaseInternal);
			default:
				var undocumentedError = str;
				return $elm$json$Json$Decode$succeed(
					$author$project$Firebase$Firestore$UndocumentedErrorByElmFirebase(undocumentedError));
		}
	};
	return A2($elm$json$Json$Decode$andThen, convert, $elm$json$Json$Decode$string);
}();
var $author$project$Firebase$Firestore$responseErrorDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Firebase$Firestore$Error,
	A2($elm$json$Json$Decode$field, 'code', $author$project$Firebase$Firestore$errorCodeDecoder),
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Firebase$Firestore$decodeDocumentSnapshot = function (json) {
	var errorResult = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'error', $author$project$Firebase$Firestore$responseErrorDecoder),
		json);
	var dataResult = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'data', $author$project$Firebase$Firestore$documentSnapshotDecoder),
		json);
	var _v0 = _Utils_Tuple2(dataResult, errorResult);
	if (!_v0.a.$) {
		var snapshot = _v0.a.a;
		return $elm$core$Result$Ok(snapshot);
	} else {
		if (!_v0.b.$) {
			var error = _v0.b.a;
			return $elm$core$Result$Err(error);
		} else {
			var snapshotError = _v0.a.a;
			return $elm$core$Result$Err(
				A2(
					$author$project$Firebase$Firestore$Error,
					$author$project$Firebase$Firestore$DecodeError(snapshotError),
					$elm$json$Json$Decode$errorToString(snapshotError)));
		}
	}
};
var $author$project$Helpers$BlockUser$Model$blockRoomResult = F4(
	function (json, userID, model, authState) {
		var _v0 = model;
		var blockProfileParams = _v0.aJ;
		var channelID = _v0.aa;
		if (_Utils_eq(blockProfileParams.eX, userID)) {
			var _v1 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
			if (!_v1.$) {
				return _Utils_Tuple2(
					model,
					A3(
						$author$project$Data$BlockProfile$block,
						channelID.ka(blockProfileParams.eX),
						authState.j2.eX,
						blockProfileParams));
			} else {
				var _v2 = _v1.a;
				var message = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eQ: $author$project$Helpers$BlockUser$Types$Failure(message)
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Chat$blockRoomResult = F4(
	function (partnerID, json, authState, appModel) {
		var _v0 = authState.km.ka;
		if (!_v0.$) {
			var blockUser = _v0.a;
			var model = authState.km;
			var _v1 = A4($author$project$Helpers$BlockUser$Model$blockRoomResult, json, partnerID, blockUser, authState);
			var updatedBlockUser = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									km: _Utils_update(
										model,
										{
											ka: $elm$core$Maybe$Just(updatedBlockUser)
										})
								}))
					}),
				cmd);
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Detail$Available = {$: 1};
var $author$project$Helpers$BlockUser$Types$Success = {$: 2};
var $author$project$Type$Block$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$Block$LoadingMore = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$Block$NoMore = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Block$addProfile = F2(
	function (profile, profileState) {
		switch (profileState.$) {
			case 0:
				return $author$project$Type$Block$Loaded(
					_List_fromArray(
						[profile]));
			case 1:
				return $author$project$Type$Block$Loaded(
					_List_fromArray(
						[profile]));
			case 2:
				var blockList = profileState.a;
				return $author$project$Type$Block$Loaded(
					A2($elm$core$List$cons, profile, blockList));
			case 3:
				var blockList = profileState.a;
				return $author$project$Type$Block$LoadingMore(
					A2($elm$core$List$cons, profile, blockList));
			default:
				var blockList = profileState.a;
				return $author$project$Type$Block$NoMore(
					A2($elm$core$List$cons, profile, blockList));
		}
	});
var $author$project$Data$Chat$Room$remove = F2(
	function (partnerID, state) {
		var updatedState = _Utils_update(
			state,
			{
				ao: A2($elm$core$Dict$remove, partnerID, state.ao)
			});
		var _v0 = state.f8;
		if (_v0.$ === 1) {
			return updatedState;
		} else {
			var partner = _v0.a.q;
			return _Utils_eq(partnerID, partner.eX) ? _Utils_update(
				updatedState,
				{f8: $elm$core$Maybe$Nothing}) : updatedState;
		}
	});
var $author$project$Data$Chat$removeRoom = F2(
	function (partnerID, _v0) {
		var state = _v0;
		return _Utils_update(
			state,
			{
				a: A2($author$project$Data$Chat$Room$remove, partnerID, state.a)
			});
	});
var $author$project$Helpers$BlockUser$Model$blockUserResult = F5(
	function (json, userID, model, authState, appModel) {
		if (_Utils_eq(model.aJ.eX, userID)) {
			var _v0 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
			if (!_v0.$) {
				var updatedFullProfile = $elm$core$Maybe$map(
					function (fullProfile_) {
						return _Utils_update(
							fullProfile_,
							{j9: $author$project$Type$Detail$Available});
					});
				var _v1 = authState;
				var block = _v1.j7;
				var chat = _v1.km;
				var detail = _v1.gj;
				var _v2 = model.aJ;
				var uid = _v2.eX;
				var username = _v2.dh;
				var avatar = _v2.cc;
				var blockProfile = {cc: avatar, cm: appModel.kG, eX: uid, dh: username};
				var updatedAppModel = _Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									j7: _Utils_update(
										block,
										{
											iv: A2($author$project$Model$Block$addProfile, blockProfile, block.iv)
										}),
									km: _Utils_update(
										chat,
										{
											i8: A2($author$project$Data$Chat$removeRoom, userID, chat.i8)
										}),
									gj: _Utils_update(
										detail,
										{
											iw: A3($elm$core$Dict$update, userID, updatedFullProfile, detail.iw)
										})
								}))
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eQ: $author$project$Helpers$BlockUser$Types$Success}),
					updatedAppModel);
			} else {
				var _v3 = _v0.a;
				var message = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eQ: $author$project$Helpers$BlockUser$Types$Failure(message)
						}),
					appModel);
			}
		} else {
			return _Utils_Tuple2(model, appModel);
		}
	});
var $author$project$Model$Chat$blockUserResult = F4(
	function (partnerID, json, authState, appModel) {
		var _v0 = authState.km.ka;
		if (!_v0.$) {
			var blockUser = _v0.a;
			var _v1 = A5($author$project$Helpers$BlockUser$Model$blockUserResult, json, partnerID, blockUser, authState, appModel);
			var updatedBlockUser = _v1.a;
			var updatedAppModel = _v1.b;
			var updatedAuthState = A2($elm$core$Maybe$withDefault, authState, updatedAppModel.j1);
			var model = updatedAuthState.km;
			return _Utils_Tuple2(
				_Utils_update(
					updatedAppModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								updatedAuthState,
								{
									km: _Utils_update(
										model,
										{
											ka: $elm$core$Maybe$Just(updatedBlockUser)
										})
								}))
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Detail$Favorited = 0;
var $author$project$Type$Detail$NotFavorite = 1;
var $author$project$Model$Detail$mapAppModel = F3(
	function (authState, appModel, detailModel) {
		return function (updatedAuthState) {
			return _Utils_update(
				appModel,
				{
					j1: $elm$core$Maybe$Just(updatedAuthState)
				});
		}(
			_Utils_update(
				authState,
				{gj: detailModel}));
	});
var $author$project$Model$Detail$checkFavoriteStatusResult = F4(
	function (userID, json, authState, model) {
		var updatedFullProfile = function (status) {
			return $elm$core$Maybe$map(
				function (fullProfile) {
					return _Utils_update(
						fullProfile,
						{aN: status});
				});
		};
		var _v0 = authState;
		var detail = _v0.gj;
		var updatedProfiles = function (status) {
			return A3(
				$elm$core$Dict$update,
				userID,
				updatedFullProfile(status),
				detail.iw);
		};
		var _v1 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
		if (!_v1.$) {
			var exists = _v1.a.k3;
			return exists ? _Utils_Tuple2(
				A3(
					$author$project$Model$Detail$mapAppModel,
					authState,
					model,
					_Utils_update(
						detail,
						{
							iw: updatedProfiles(0)
						})),
				$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
				A3(
					$author$project$Model$Detail$mapAppModel,
					authState,
					model,
					_Utils_update(
						detail,
						{
							iw: updatedProfiles(1)
						})),
				$elm$core$Platform$Cmd$none);
		} else {
			var _v2 = _v1.a;
			var message = _v2.b;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Detail$mapAppModel,
					authState,
					model,
					_Utils_update(
						detail,
						{
							gs: $elm$core$Maybe$Just(message)
						})),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Helpers$ReportUser$Model$result = F3(
	function (json, userID, model) {
		if (_Utils_eq(userID, model.ez.eX)) {
			var form = model.ln;
			var _v0 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
			if (!_v0.$) {
				return _Utils_update(
					model,
					{
						ln: _Utils_update(
							form,
							{gs: $elm$core$Maybe$Nothing, jc: false}),
						hi: true
					});
			} else {
				var _v1 = _v0.a;
				var message = _v1.b;
				return _Utils_update(
					model,
					{
						ln: _Utils_update(
							form,
							{
								gs: $elm$core$Maybe$Just(message),
								jc: false
							})
					});
			}
		} else {
			return model;
		}
	});
var $author$project$Model$Chat$createReportResult = F4(
	function (partnerID, json, authState, appModel) {
		var _v0 = authState.km.aA;
		if (_v0.$ === 1) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var reportUser = _v0.a;
			var model = authState.km;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									km: _Utils_update(
										model,
										{
											aA: $elm$core$Maybe$Just(
												A3($author$project$Helpers$ReportUser$Model$result, json, partnerID, reportUser))
										})
								}))
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Detail$createReportResult = F4(
	function (userID, json, authState, appModel) {
		var _v0 = A2($elm$core$Dict$get, userID, authState.gj.iw);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var reportUser = _v0.a.aA;
			if (reportUser.$ === 1) {
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			} else {
				var reportUser_ = reportUser.a;
				var updatedFullProfile = $elm$core$Maybe$map(
					function (fullProfile) {
						return _Utils_update(
							fullProfile,
							{
								aA: $elm$core$Maybe$Just(
									A3($author$project$Helpers$ReportUser$Model$result, json, userID, reportUser_))
							});
					});
				var model = authState.gj;
				var _v2 = model;
				var profiles = _v2.iw;
				var updatedProfiles = A3($elm$core$Dict$update, userID, updatedFullProfile, profiles);
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Detail$mapAppModel,
						authState,
						appModel,
						_Utils_update(
							model,
							{iw: updatedProfiles})),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Model$Detail$updateFavoriteStatus = F3(
	function (userID, status, profiles) {
		var updatedFullProfile = function (status_) {
			return $elm$core$Maybe$map(
				function (fullProfile) {
					return _Utils_update(
						fullProfile,
						{aN: status_});
				});
		};
		return A3(
			$elm$core$Dict$update,
			userID,
			updatedFullProfile(status),
			profiles);
	});
var $author$project$Model$Detail$deleteFavoriteProfileResult = F3(
	function (userID, authState, model) {
		var _v0 = authState;
		var detail = _v0.gj;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$Detail$mapAppModel,
				authState,
				model,
				_Utils_update(
					detail,
					{
						iw: A3($author$project$Model$Detail$updateFavoriteStatus, userID, 1, detail.iw)
					})),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Firebase$Firestore$QuerySnapshot = F4(
	function (size, empty, docChanges, docs) {
		return {kU: docChanges, kV: docs, k$: empty, ns: size};
	});
var $author$project$Firebase$Firestore$DocumentChange = F2(
	function (doc, type_) {
		return {kT: doc, n0: type_};
	});
var $author$project$Firebase$Firestore$Added = 0;
var $author$project$Firebase$Firestore$Modified = 1;
var $author$project$Firebase$Firestore$Removed = 2;
var $author$project$Firebase$Firestore$documentChangeTypeDecoder = function () {
	var convert = function (str) {
		switch (str) {
			case 'added':
				return $elm$json$Json$Decode$succeed(0);
			case 'modified':
				return $elm$json$Json$Decode$succeed(1);
			case 'removed':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid documentChangeType: ' + str);
		}
	};
	return A2($elm$json$Json$Decode$andThen, convert, $elm$json$Json$Decode$string);
}();
var $author$project$Firebase$Firestore$documentChangeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Firebase$Firestore$DocumentChange,
	A2($elm$json$Json$Decode$field, 'doc', $author$project$Firebase$Firestore$documentSnapshotDecoder),
	A2($elm$json$Json$Decode$field, 'type_', $author$project$Firebase$Firestore$documentChangeTypeDecoder));
var $author$project$Firebase$Firestore$querySnapshotDataDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Firebase$Firestore$QuerySnapshot,
	A2($elm$json$Json$Decode$field, 'size', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'empty', $elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$field,
		'docChanges',
		$elm$json$Json$Decode$list($author$project$Firebase$Firestore$documentChangeDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'docs',
		$elm$json$Json$Decode$list($author$project$Firebase$Firestore$documentSnapshotDecoder)));
var $author$project$Firebase$Firestore$decodeQuerySnapshot = function (json) {
	var errorResult = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'error', $author$project$Firebase$Firestore$responseErrorDecoder),
		json);
	var dataResult = A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'data', $author$project$Firebase$Firestore$querySnapshotDataDecoder),
		json);
	var _v0 = _Utils_Tuple2(dataResult, errorResult);
	if (!_v0.a.$) {
		var snapshot = _v0.a.a;
		return $elm$core$Result$Ok(snapshot);
	} else {
		if (!_v0.b.$) {
			var error = _v0.b.a;
			return $elm$core$Result$Err(error);
		} else {
			var snapshotError = _v0.a.a;
			return $elm$core$Result$Err(
				A2(
					$author$project$Firebase$Firestore$Error,
					$author$project$Firebase$Firestore$DecodeError(snapshotError),
					$elm$json$Json$Decode$errorToString(snapshotError)));
		}
	}
};
var $author$project$Data$Content$ArticleData = function (id) {
	return function (body) {
		return function (createdAt) {
			return function (metaDescription) {
				return function (metaKeyword) {
					return function (metaTitle) {
						return function (status) {
							return function (title) {
								return function (updatedAt) {
									return function (url) {
										return function (image) {
											return function (contentType) {
												return function (publishedAt) {
													return function (categories) {
														return function (tags) {
															return {cg: body, fP: categories, f3: contentType, cm: createdAt, lK: id, cA: image, cK: metaDescription, hG: metaKeyword, cL: metaTitle, iz: publishedAt, eQ: status, jk: tags, dd: title, n7: updatedAt, n8: url};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Data$Content$articleDecoder = function (id) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tags',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'categories',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'publishedAt',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contentType',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'image',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'url',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'updatedAt',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'title',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'status',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'metaTitle',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'metaKeyword',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'metaDescription',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'createdAt',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'body',
															$elm$json$Json$Decode$string,
															A2(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																id,
																$elm$json$Json$Decode$succeed($author$project$Data$Content$ArticleData))))))))))))))));
};
var $author$project$Data$Content$decodeArticle = function (id) {
	return $elm$json$Json$Decode$decodeString(
		$author$project$Data$Content$articleDecoder(id));
};
var $author$project$Data$Content$snapshotToArticle = function (_v0) {
	var id = _v0.lK;
	var data = _v0.kH;
	var _v1 = A2($author$project$Data$Content$decodeArticle, id, data);
	if (!_v1.$) {
		var article = _v1.a;
		var format = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split('\\\"'),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$join('\"'),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$split('\\\''),
					$elm$core$String$join('\''))));
		var metaDescription = format(article.cK);
		var metaTitle = format(article.cL);
		var title = format(article.dd);
		var cleanedUrl = $author$project$Data$Content$cleanUrl(article.n8);
		var body = format(article.cg);
		return $elm$core$Maybe$Just(
			_Utils_update(
				article,
				{cg: body, cK: metaDescription, cL: metaTitle, dd: title, n8: cleanedUrl}));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Content$snapshotToArticles = function (docs) {
	return A2($elm$core$List$filterMap, $author$project$Data$Content$snapshotToArticle, docs);
};
var $author$project$Data$Content$decodeArticleDataList = function (json) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Data$Content$snapshotToArticles,
				function ($) {
					return $.kV;
				}),
			$elm$core$Result$toMaybe(
				$author$project$Firebase$Firestore$decodeQuerySnapshot(json))));
};
var $author$project$Model$Content$getArticle = F4(
	function (articleKind, articleUrl, json, appModel) {
		var model = appModel.cl;
		var articles = $author$project$Data$Content$decodeArticleDataList(json);
		var _v0 = $elm$core$List$head(articles);
		if (_v0.$ === 1) {
			var updatedModel = function () {
				if (!articleKind) {
					return _Utils_update(
						model,
						{
							ax: A3(
								$elm$core$Dict$insert,
								articleUrl,
								$author$project$Data$Content$NotFound(articleUrl),
								model.ax)
						});
				} else {
					return _Utils_update(
						model,
						{
							aU: A3(
								$elm$core$Dict$insert,
								articleUrl,
								$author$project$Data$Content$NotFound(articleUrl),
								model.aU)
						});
				}
			}();
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{cl: updatedModel}),
				$elm$core$Platform$Cmd$none);
		} else {
			var article = _v0.a;
			var updatedModel = function () {
				if (!articleKind) {
					return _Utils_update(
						model,
						{
							ax: A3(
								$elm$core$Dict$insert,
								article.n8,
								$author$project$Data$Content$Loaded(article),
								model.ax)
						});
				} else {
					return _Utils_update(
						model,
						{
							aU: A3(
								$elm$core$Dict$insert,
								article.n8,
								$author$project$Data$Content$Loaded(article),
								model.aU)
						});
				}
			}();
			var updatedAppModel = _Utils_update(
				appModel,
				{cl: updatedModel});
			return $author$project$Model$Content$processHtml(updatedAppModel);
		}
	});
var $author$project$Model$Block$getProfiles = function (profileState) {
	switch (profileState.$) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_Nil;
		case 2:
			var downloadedProfiles = profileState.a;
			return downloadedProfiles;
		case 3:
			var downloadedProfiles = profileState.a;
			return downloadedProfiles;
		default:
			var downloadedProfiles = profileState.a;
			return downloadedProfiles;
	}
};
var $author$project$Model$Block$concatProfiles = F2(
	function (profiles, profileState) {
		return _Utils_ap(
			$author$project$Model$Block$getProfiles(profileState),
			profiles);
	});
var $author$project$Data$BlockProfile$Profile = F4(
	function (uid, username, avatar, createdAt) {
		return {cc: avatar, cm: createdAt, eX: uid, dh: username};
	});
var $author$project$Data$BlockProfile$decoder = F2(
	function (currentTime, uid) {
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'createdAt',
			$author$project$Firebase$Firestore$timestampDecoder,
			currentTime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'avatar',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'username',
					$elm$json$Json$Decode$string,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						uid,
						$elm$json$Json$Decode$succeed($author$project$Data$BlockProfile$Profile)))));
	});
var $author$project$Data$BlockProfile$decode = F2(
	function (currentTime, _v0) {
		var id = _v0.lK;
		var data = _v0.kH;
		return A2(
			$elm$json$Json$Decode$decodeString,
			A2($author$project$Data$BlockProfile$decoder, currentTime, id),
			data);
	});
var $author$project$Data$BlockProfile$decodeList = F2(
	function (_v0, currentTime) {
		var docs = _v0.kV;
		return A2(
			$elm$core$List$filterMap,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Result$toMaybe,
				$author$project$Data$BlockProfile$decode(currentTime)),
			docs);
	});
var $author$project$Model$Block$getBlockListResult = F3(
	function (json, authState, appModel) {
		var _v0 = $author$project$Firebase$Firestore$decodeQuerySnapshot(json);
		if (_v0.$ === 1) {
			var _v1 = _v0.a;
			var message = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						b8: A2($author$project$Data$Alert$addFailure, message, appModel.b8)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var snapshots = _v0.a;
			var _v2 = appModel;
			var currentTime = _v2.kG;
			var profiles = A2($author$project$Data$BlockProfile$decodeList, snapshots, currentTime);
			var _v3 = authState;
			var block = _v3.j7;
			var profileState = $elm$core$List$isEmpty(profiles) ? $author$project$Type$Block$NoMore(
				$author$project$Model$Block$getProfiles(block.iv)) : $author$project$Type$Block$Loaded(
				A2($author$project$Model$Block$concatProfiles, profiles, block.iv));
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									j7: _Utils_update(
										block,
										{iv: profileState})
								}))
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Detail$Blocked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$Detail$Checking = 3;
var $author$project$Type$Detail$OnUnBlockUser = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Type$Detail$Pending = {$: 2};
var $author$project$Helpers$UnBlockUser$Types$Init = {$: 0};
var $author$project$Helpers$UnBlockUser$Types$Popup = function (a) {
	return {$: 1, a: a};
};
var $author$project$CustomPopup$Init = 2;
var $author$project$CustomPopup$initialModel = function (config) {
	return {bl: config, eQ: 2};
};
var $author$project$Helpers$UnBlockUser$Model$initialModel = F2(
	function (channelID, userID) {
		return _Utils_Tuple2(
			{
				aa: channelID,
				$7: $elm$core$Maybe$Nothing,
				bN: $author$project$CustomPopup$initialModel(
					{fe: '000000', f_: $author$project$View$Theme$images.mV, eq: 'PopupForUnBlockUser', jr: $author$project$Helpers$UnBlockUser$Types$Popup}),
				eQ: $author$project$Helpers$UnBlockUser$Types$Init,
				a9: userID
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$Detail$getBlockStatusResult = F4(
	function (userID, json, authState, appModel) {
		var channelID = {lr: $author$project$Model$Detail$channelIDs.lr, n1: $author$project$Model$Detail$channelIDs.n1, n3: $author$project$Model$Detail$channelIDs.n3};
		var _v0 = authState;
		var detail = _v0.gj;
		var updateBlockStatus = F2(
			function (status, cmd_) {
				var updatedFullProfile = $elm$core$Maybe$map(
					function (fullProfile) {
						return _Utils_update(
							fullProfile,
							{j9: status});
					});
				var _v7 = detail;
				var profiles = _v7.iw;
				var updatedProfiles = function () {
					var _v8 = A2($elm$core$Dict$get, userID, profiles);
					if (_v8.$ === 1) {
						return A3(
							$elm$core$Dict$insert,
							userID,
							{j9: status, aN: 3, bQ: $author$project$Type$Detail$Pending, iu: $elm$core$Maybe$Nothing, m5: _List_Nil, aA: $elm$core$Maybe$Nothing},
							profiles);
					} else {
						return A3($elm$core$Dict$update, userID, updatedFullProfile, profiles);
					}
				}();
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Detail$mapAppModel,
						authState,
						appModel,
						_Utils_update(
							detail,
							{iw: updatedProfiles})),
					cmd_);
			});
		var _v1 = A2($author$project$Helpers$UnBlockUser$Model$initialModel, channelID, userID);
		var unBlockUser = _v1.a;
		var cmd = _v1.b;
		var _v2 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
		if (!_v2.$) {
			var snapshot = _v2.a;
			var _v3 = A2($author$project$Data$BlockProfile$decode, appModel.kG, snapshot);
			if (!_v3.$) {
				return A2(
					updateBlockStatus,
					$author$project$Type$Detail$Blocked(unBlockUser),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Types$OnDetail,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Type$Detail$OnUnBlockUser(userID),
								cmd))));
			} else {
				var error = _v3.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							b8: A2(
								$author$project$Data$Alert$addFailure,
								$elm$json$Json$Decode$errorToString(error),
								appModel.b8)
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			if (_v2.a.a.$ === 6) {
				var _v4 = _v2.a;
				var _v5 = _v4.a;
				return A2(updateBlockStatus, $author$project$Type$Detail$Available, $elm$core$Platform$Cmd$none);
			} else {
				var _v6 = _v2.a;
				var message = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							b8: A2($author$project$Data$Alert$addFailure, message, appModel.b8)
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Data$Content$CategoriesData = function (postCategories) {
	return {im: postCategories};
};
var $author$project$Data$Content$categoriesDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'postCategories',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Data$Content$CategoriesData));
var $author$project$Data$Content$decodeCategoryList = function (json) {
	var decodeData = function (_v0) {
		var data = _v0.kH;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.im;
				},
				$elm$core$Result$toMaybe(
					A2($elm$json$Json$Decode$decodeString, $author$project$Data$Content$categoriesDataDecoder, data))));
	};
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			decodeData,
			$elm$core$Result$toMaybe(
				$author$project$Firebase$Firestore$decodeDocumentSnapshot(json))));
};
var $author$project$Model$Content$getCategoryList = F2(
	function (json, appModel) {
		var model = appModel.cl;
		var categoryList = $author$project$Data$Content$decodeCategoryList(json);
		var _v0 = model.I;
		if (!_v0.$) {
			var updatedCategories = $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (category) {
						return _Utils_Tuple2(category, $author$project$Data$Content$InitPosts);
					},
					categoryList));
			var updatedModel = _Utils_update(
				model,
				{
					I: $author$project$Data$Content$SyncedCategories(updatedCategories)
				});
			var updatedAppModel = _Utils_update(
				appModel,
				{cl: updatedModel});
			var _v1 = appModel.ng;
			if ((_v1.$ === 23) && (_v1.a.$ === 3)) {
				var category = _v1.a.a;
				var _v2 = A2($author$project$Data$Content$categoryUrlNameToName, updatedCategories, category);
				if (!_v2.$) {
					var categoryName = _v2.a;
					return _Utils_Tuple2(
						updatedAppModel,
						A3(
							$author$project$Model$Content$getPostsCmd,
							appModel.kG,
							$elm$core$Maybe$Just(categoryName),
							updatedModel));
				} else {
					return _Utils_Tuple2(updatedAppModel, $elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(updatedAppModel, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Helpers$UnBlockUser$Types$Failure = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Chat$RoomStatus$encoder = function (status) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$Chat$RoomStatus$statusString(status));
};
var $author$project$Data$Chat$Partner$statusEncoder = function (_v0) {
	var room = _v0.a;
	var user = _v0.W;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user',
				$author$project$Core$Data$Profile$Status$encoder(user)),
				_Utils_Tuple2(
				'room',
				$author$project$Data$Chat$RoomStatus$encoder(room))
			]));
};
var $author$project$Data$Chat$Partner$setUnBlockedRoomEncode = F2(
	function (profile, userKindString) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					userKindString + '.uid',
					$elm$json$Json$Encode$string(profile.eX)),
					_Utils_Tuple2(
					userKindString + '.username',
					$elm$json$Json$Encode$string(profile.dh)),
					_Utils_Tuple2(
					userKindString + '.avatar',
					$elm$json$Json$Encode$string(profile.cc)),
					_Utils_Tuple2(
					userKindString + '.status',
					$author$project$Data$Chat$Partner$statusEncoder(
						{a: 0, W: profile.eQ})),
					_Utils_Tuple2(
					userKindString + '.sponsorLevel',
					$author$project$Core$Data$Profile$SponsorLevel$encoder(profile.bY))
				]));
	});
var $author$project$Data$Chat$Room$encodeUnBlockedRoom = function (userProfile) {
	var _v0 = userProfile.eY;
	if (_v0 === 1) {
		return A2(
			$elm$json$Json$Encode$encode,
			0,
			A2($author$project$Data$Chat$Partner$setUnBlockedRoomEncode, userProfile, 'sugar'));
	} else {
		return A2(
			$elm$json$Json$Encode$encode,
			0,
			A2($author$project$Data$Chat$Partner$setUnBlockedRoomEncode, userProfile, 'sponsor'));
	}
};
var $author$project$Data$Chat$Room$unBlockRoom = F3(
	function (channelID, userProfile, partnerID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$updateDoc,
				$author$project$Data$Chat$Room$encodeUnBlockedRoom(userProfile),
				$author$project$Firebase$Firestore$doc(
					'/chat/room/lastMessages/' + A3($author$project$Data$Chat$Room$getRoomID, partnerID, userProfile.eX, userProfile.eY))));
	});
var $author$project$Data$Chat$Room$unBlock = F3(
	function (channelID, userProfile, partnerID) {
		return A3($author$project$Data$Chat$Room$unBlockRoom, channelID, userProfile, partnerID);
	});
var $author$project$Data$Chat$unBlockRoom = F3(
	function (channelID, userProfile, partnerID) {
		return A3($author$project$Data$Chat$Room$unBlock, channelID, userProfile, partnerID);
	});
var $author$project$Helpers$UnBlockUser$Model$getChatRoomResult = F4(
	function (json, unBlockUserID, model, authState) {
		var _v0 = model;
		var channelID = _v0.aa;
		var userID = _v0.a9;
		if (_Utils_eq(userID, unBlockUserID)) {
			var _v1 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
			if (!_v1.$) {
				var _v2 = authState.iu;
				if (_v2.$ === 1) {
					var profileModel = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								$7: $elm$core$Maybe$Just(json)
							}),
						A3(
							$author$project$Data$Chat$unBlockRoom,
							channelID.n1(userID),
							profileModel.iu,
							userID));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eQ: $author$project$Helpers$UnBlockUser$Types$Failure('Cannot find your profile')
							}),
						$elm$core$Platform$Cmd$none);
				}
			} else {
				var _v3 = _v1.a;
				var message = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eQ: $author$project$Helpers$UnBlockUser$Types$Failure(message)
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Block$getChatRoomResult = F4(
	function (json, userID, authState, appModel) {
		var _v0 = authState.j7.n3;
		if (!_v0.$) {
			var unBlockUser = _v0.a;
			var model = authState.j7;
			var _v1 = A4($author$project$Helpers$UnBlockUser$Model$getChatRoomResult, json, userID, unBlockUser, authState);
			var updatedUnBlockUser = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									j7: _Utils_update(
										model,
										{
											n3: $elm$core$Maybe$Just(updatedUnBlockUser)
										})
								}))
					}),
				cmd);
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Detail$getChatRoomResult = F4(
	function (json, userID, authState, appModel) {
		var _v0 = A2($elm$core$Dict$get, userID, authState.gj.iw);
		if (!_v0.$) {
			var fullProfile = _v0.a;
			var _v1 = fullProfile.j9;
			if (_v1.$ === 2) {
				var unBlockUser = _v1.a;
				var model = authState.gj;
				var _v2 = model;
				var profiles = _v2.iw;
				var _v3 = A4($author$project$Helpers$UnBlockUser$Model$getChatRoomResult, json, userID, unBlockUser, authState);
				var updatedUnBlockUser = _v3.a;
				var cmd = _v3.b;
				var updatedFullProfile = $elm$core$Maybe$map(
					function (fullProfile_) {
						return _Utils_update(
							fullProfile_,
							{
								j9: $author$project$Type$Detail$Blocked(updatedUnBlockUser)
							});
					});
				var updatedProfiles = A3($elm$core$Dict$update, userID, updatedFullProfile, profiles);
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Detail$mapAppModel,
						authState,
						appModel,
						_Utils_update(
							model,
							{iw: updatedProfiles})),
					cmd);
			} else {
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Content$LoadedPosts = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Content$NoMorePosts = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Content$getPostList = F3(
	function (category, json, appModel) {
		var model = appModel.cl;
		var articles = $author$project$Data$Content$decodeArticleDataList(json);
		var updatedStatus = (_Utils_cmp(
			$elm$core$List$length(articles),
			model.er) < 0) ? $author$project$Data$Content$NoMorePosts : $author$project$Data$Content$LoadedPosts;
		var updatedPostsStatus = function (postsStatus) {
			return updatedStatus(
				$elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (article) {
							return _Utils_Tuple2(article.n8, article);
						},
						_Utils_ap(
							articles,
							$author$project$Data$Content$getListArticleData(postsStatus)))));
		};
		if (category.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						cl: _Utils_update(
							model,
							{
								M: updatedPostsStatus(model.M)
							})
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var category_ = category.a;
			var _v1 = model.I;
			if (!_v1.$) {
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			} else {
				var categories = _v1.a;
				var _v2 = A2($elm$core$Dict$get, category_, categories);
				if (_v2.$ === 1) {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				} else {
					var updatedCategories = A3(
						$elm$core$Dict$update,
						category_,
						$elm$core$Maybe$map(updatedPostsStatus),
						categories);
					return _Utils_Tuple2(
						_Utils_update(
							appModel,
							{
								cl: _Utils_update(
									model,
									{
										I: $author$project$Data$Content$SyncedCategories(updatedCategories)
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			}
		}
	});
var $author$project$Type$Detail$Getting = {$: 0};
var $author$project$Type$Detail$Granted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$Detail$Refused = {$: 1};
var $author$project$Core$Data$Profile$Photo$Photo = F4(
	function (id, url, thumbnailUrl, createdAt) {
		return {cm: createdAt, lK: id, nT: thumbnailUrl, n8: url};
	});
var $author$project$Core$Data$Profile$Photo$photoDecoder = function (photoID) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'createdAt',
		$author$project$Firebase$Firestore$timestampDecoder,
		$elm$time$Time$millisToPosix(9999999999999),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'thumbnailUrl',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'url',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'id',
					$elm$json$Json$Decode$string,
					photoID,
					$elm$json$Json$Decode$succeed($author$project$Core$Data$Profile$Photo$Photo)))));
};
var $author$project$Core$Data$Profile$Photo$decodePhoto = F2(
	function (photoID, json) {
		return A2(
			$elm$json$Json$Decode$decodeString,
			$author$project$Core$Data$Profile$Photo$photoDecoder(photoID),
			json);
	});
var $author$project$Core$Data$Profile$Photo$toPhoto = function (_v0) {
	var id = _v0.lK;
	var data = _v0.kH;
	return A2($author$project$Core$Data$Profile$Photo$decodePhoto, id, data);
};
var $author$project$Core$Data$Profile$Photo$toPhotos = function (_v0) {
	var docs = _v0.kV;
	return A2(
		$elm$core$List$filterMap,
		A2($elm$core$Basics$composeL, $elm$core$Result$toMaybe, $author$project$Core$Data$Profile$Photo$toPhoto),
		docs);
};
var $author$project$Model$Detail$getProfilePrivatePhotosResult = F4(
	function (userID, json, authState, model) {
		var updatedFullProfile = F2(
			function (privatePhotoAccess, fullProfile) {
				return A2(
					$elm$core$Maybe$map,
					function (fullProfile_) {
						return _Utils_update(
							fullProfile_,
							{bQ: privatePhotoAccess});
					},
					fullProfile);
			});
		var _v0 = authState;
		var detail = _v0.gj;
		var _v1 = detail;
		var profiles = _v1.iw;
		var updatedProfiles = function (privatePhotoAccess) {
			var _v5 = A2($elm$core$Dict$get, userID, profiles);
			if (_v5.$ === 1) {
				return A3(
					$elm$core$Dict$insert,
					userID,
					{j9: $author$project$Type$Detail$Getting, aN: 3, bQ: privatePhotoAccess, iu: $elm$core$Maybe$Nothing, m5: _List_Nil, aA: $elm$core$Maybe$Nothing},
					profiles);
			} else {
				return A3(
					$elm$core$Dict$update,
					userID,
					updatedFullProfile(privatePhotoAccess),
					profiles);
			}
		};
		var _v2 = $author$project$Firebase$Firestore$decodeQuerySnapshot(json);
		if (!_v2.$) {
			var snapshots = _v2.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Detail$mapAppModel,
					authState,
					model,
					_Utils_update(
						detail,
						{
							iw: updatedProfiles(
								$author$project$Type$Detail$Granted(
									$author$project$Core$Data$Profile$Photo$toPhotos(snapshots)))
						})),
				$elm$core$Platform$Cmd$none);
		} else {
			if (_v2.a.a.$ === 6) {
				var _v3 = _v2.a;
				var _v4 = _v3.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Detail$mapAppModel,
						authState,
						model,
						_Utils_update(
							detail,
							{
								iw: updatedProfiles($author$project$Type$Detail$Refused)
							})),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Detail$mapAppModel,
						authState,
						model,
						_Utils_update(
							detail,
							{
								iw: updatedProfiles(
									$author$project$Type$Detail$Granted(_List_Nil))
							})),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Model$Detail$getProfilePublicPhotosResult = F4(
	function (userID, json, authState, model) {
		var _v0 = authState;
		var detail = _v0.gj;
		var _v1 = $author$project$Firebase$Firestore$decodeQuerySnapshot(json);
		if (!_v1.$) {
			var snapshots = _v1.a;
			var publicPhotos = $author$project$Core$Data$Profile$Photo$toPhotos(snapshots);
			var updatedFullProfile = $elm$core$Maybe$map(
				function (fullProfile) {
					return _Utils_update(
						fullProfile,
						{m5: publicPhotos});
				});
			var _v2 = detail;
			var profiles = _v2.iw;
			var updatedProfiles = function () {
				var _v3 = A2($elm$core$Dict$get, userID, profiles);
				if (_v3.$ === 1) {
					return A3(
						$elm$core$Dict$insert,
						userID,
						{j9: $author$project$Type$Detail$Getting, aN: 3, bQ: $author$project$Type$Detail$Pending, iu: $elm$core$Maybe$Nothing, m5: publicPhotos, aA: $elm$core$Maybe$Nothing},
						profiles);
				} else {
					return A3($elm$core$Dict$update, userID, updatedFullProfile, profiles);
				}
			}();
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Detail$mapAppModel,
					authState,
					model,
					_Utils_update(
						detail,
						{iw: updatedProfiles})),
				$elm$core$Platform$Cmd$none);
		} else {
			var _v4 = _v1.a;
			var message = _v4.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						b8: A2($author$project$Data$Alert$addFailure, message, model.b8)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Detail$Report = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Core$Data$Profile$favoriteProfilePath = F2(
	function (userID, favoritedUserID) {
		return '/profiles/' + (userID + ('/favoriteProfile/' + favoritedUserID));
	});
var $author$project$Core$Data$Profile$getFavoriteProfile = F3(
	function (userID, favoritedUserID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getDoc(
				$author$project$Firebase$Firestore$doc(
					A2($author$project$Core$Data$Profile$favoriteProfilePath, userID, favoritedUserID))));
	});
var $author$project$Model$Detail$checkFavoriteStatus = F2(
	function (favoritedUserID, authUserID) {
		return A3(
			$author$project$Core$Data$Profile$getFavoriteProfile,
			authUserID,
			favoritedUserID,
			$author$project$Model$Detail$channelIDs.fT(favoritedUserID));
	});
var $author$project$Core$Data$Profile$Education$College = 1;
var $author$project$Core$Data$Profile$LifestyleExpectation$Moderate = 6;
var $author$project$Core$Data$Profile$Drinker$NonDrinker = 0;
var $author$project$Core$Data$Profile$Smoker$NonSmoker = 0;
var $author$project$Core$Data$Profile$NumberOfChildren$NotSpecified = 0;
var $author$project$Core$Data$Profile$MaritalStatus$Open = 1;
var $author$project$Core$Data$Profile$Ethnicity$OtherEthnicity = 9;
var $author$project$Core$Data$Profile$Profile = function (uid) {
	return function (username) {
		return function (email) {
			return function (avatar) {
				return function (gender) {
					return function (wantGender) {
						return function (lifestyleExpectation) {
							return function (birthday) {
								return function (height) {
									return function (bodyType) {
										return function (ethnicity) {
											return function (locations) {
												return function (headline) {
													return function (aboutMe) {
														return function (maritalStatus) {
															return function (wantRelationships) {
																return function (numberOfChildren) {
																	return function (education) {
																		return function (occupation) {
																			return function (smoker) {
																				return function (drinker) {
																					return function (benefits) {
																						return function (otherBenefit) {
																							return function (createdAt) {
																								return function (updatedAt) {
																									return function (privatePhotoNumber) {
																										return function (lastOnline) {
																											return function (userKind) {
																												return function (status) {
																													return function (verifyStatus) {
																														return function (sponsorLevel) {
																															return {b6: aboutMe, cc: avatar, bg: benefits, cf: birthday, bi: bodyType, cm: createdAt, bm: drinker, bn: education, dt: email, bo: ethnicity, bt: gender, cy: headline, bu: height, lZ: lastOnline, bz: lifestyleExpectation, cE: locations, bB: maritalStatus, bF: numberOfChildren, cN: occupation, cP: otherBenefit, cZ: privatePhotoNumber, bW: smoker, bY: sponsorLevel, eQ: status, eX: uid, n7: updatedAt, eY: userKind, dh: username, ob: verifyStatus, di: wantGender, b4: wantRelationships};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Core$Data$Profile$Benefit$ActiveLifestyle = 0;
var $author$project$Core$Data$Profile$Benefit$ActivityPartner = 1;
var $author$project$Core$Data$Profile$Benefit$Adventure = 2;
var $author$project$Core$Data$Profile$Benefit$Affection = 3;
var $author$project$Core$Data$Profile$Benefit$AllEthnicities = 4;
var $author$project$Core$Data$Profile$Benefit$AnimalLover = 5;
var $author$project$Core$Data$Profile$Benefit$Attention = 6;
var $author$project$Core$Data$Profile$Benefit$BBW = 7;
var $author$project$Core$Data$Profile$Benefit$CasualDates = 8;
var $author$project$Core$Data$Profile$Benefit$CasualEncounters = 9;
var $author$project$Core$Data$Profile$Benefit$CasualMeetups = 10;
var $author$project$Core$Data$Profile$Benefit$CoffeeDates = 11;
var $author$project$Core$Data$Profile$Benefit$Companion = 12;
var $author$project$Core$Data$Profile$Benefit$ConcertsMusicalsPlays = 13;
var $author$project$Core$Data$Profile$Benefit$Confidant = 14;
var $author$project$Core$Data$Profile$Benefit$DaytimeMeetUps = 15;
var $author$project$Core$Data$Profile$Benefit$DinnerDates = 16;
var $author$project$Core$Data$Profile$Benefit$Discretion = 17;
var $author$project$Core$Data$Profile$Benefit$EmotionalConnection = 18;
var $author$project$Core$Data$Profile$Benefit$EveningMeetUps = 19;
var $author$project$Core$Data$Profile$Benefit$Excitement = 20;
var $author$project$Core$Data$Profile$Benefit$Exclusive = 21;
var $author$project$Core$Data$Profile$Benefit$FinancialSupport = 22;
var $author$project$Core$Data$Profile$Benefit$FlexibleSchedule = 23;
var $author$project$Core$Data$Profile$Benefit$FoodLover = 24;
var $author$project$Core$Data$Profile$Benefit$FriendsWithBenefits = 25;
var $author$project$Core$Data$Profile$Benefit$Fun = 26;
var $author$project$Core$Data$Profile$Benefit$GayDating = 27;
var $author$project$Core$Data$Profile$Benefit$GoodCook = 28;
var $author$project$Core$Data$Profile$Benefit$HookUp = 29;
var $author$project$Core$Data$Profile$Benefit$LesbianDating = 30;
var $author$project$Core$Data$Profile$Benefit$ListeningEar = 31;
var $author$project$Core$Data$Profile$Benefit$LongTerm = 32;
var $author$project$Core$Data$Profile$Benefit$LunchDates = 33;
var $author$project$Core$Data$Profile$Benefit$MarriageMinded = 34;
var $author$project$Core$Data$Profile$Benefit$MediumTerm = 35;
var $author$project$Core$Data$Profile$Benefit$MeetForDrinks = 36;
var $author$project$Core$Data$Profile$Benefit$Mentorship = 37;
var $author$project$Core$Data$Profile$Benefit$MinimalTattoos = 38;
var $author$project$Core$Data$Profile$Benefit$Monogamous = 39;
var $author$project$Core$Data$Profile$Benefit$MonthlyAllowance = 40;
var $author$project$Core$Data$Profile$Benefit$MovieDates = 41;
var $author$project$Core$Data$Profile$Benefit$NatureLover = 42;
var $author$project$Core$Data$Profile$Benefit$NightTimeMeetUps = 43;
var $author$project$Core$Data$Profile$Benefit$NoAttached = 44;
var $author$project$Core$Data$Profile$Benefit$NoIntimacy = 45;
var $author$project$Core$Data$Profile$Benefit$NoMarried = 46;
var $author$project$Core$Data$Profile$Benefit$NoStayovers = 47;
var $author$project$Core$Data$Profile$Benefit$NoStringsAttached = 48;
var $author$project$Core$Data$Profile$Benefit$NoTravel = 49;
var $author$project$Core$Data$Profile$Benefit$NonExclusive = 50;
var $author$project$Core$Data$Profile$Benefit$NonMonogamous = 51;
var $author$project$Core$Data$Profile$Benefit$ONS = 55;
var $author$project$Core$Data$Profile$Benefit$OccasionalDates = 52;
var $author$project$Core$Data$Profile$Benefit$OneOffDates = 53;
var $author$project$Core$Data$Profile$Benefit$OnlineOnly = 54;
var $author$project$Core$Data$Profile$Benefit$OpenRelationship = 56;
var $author$project$Core$Data$Profile$Benefit$Pescatarian = 57;
var $author$project$Core$Data$Profile$Benefit$Platonic = 58;
var $author$project$Core$Data$Profile$Benefit$ProfessionalNetworking = 59;
var $author$project$Core$Data$Profile$Benefit$RentAssistance = 60;
var $author$project$Core$Data$Profile$Benefit$Romance = 61;
var $author$project$Core$Data$Profile$Benefit$SeniorDating = 62;
var $author$project$Core$Data$Profile$Benefit$ShortTerm = 63;
var $author$project$Core$Data$Profile$Benefit$SinglesOnly = 64;
var $author$project$Core$Data$Profile$Benefit$Soulmate = 65;
var $author$project$Core$Data$Profile$Benefit$Spontaneity = 66;
var $author$project$Core$Data$Profile$Benefit$SportsDates = 67;
var $author$project$Core$Data$Profile$Benefit$StayInPartner = 68;
var $author$project$Core$Data$Profile$Benefit$Staycations = 69;
var $author$project$Core$Data$Profile$Benefit$Stayovers = 70;
var $author$project$Core$Data$Profile$Benefit$SugarNewbie = 71;
var $author$project$Core$Data$Profile$Benefit$SugarVeteran = 72;
var $author$project$Core$Data$Profile$Benefit$Surprises = 73;
var $author$project$Core$Data$Profile$Benefit$TattooFriendly = 74;
var $author$project$Core$Data$Profile$Benefit$TransFriendly = 75;
var $author$project$Core$Data$Profile$Benefit$Transgender = 76;
var $author$project$Core$Data$Profile$Benefit$TravelToYou = 77;
var $author$project$Core$Data$Profile$Benefit$TravelWithYou = 78;
var $author$project$Core$Data$Profile$Benefit$Vacations = 79;
var $author$project$Core$Data$Profile$Benefit$Vegetarian = 80;
var $author$project$Core$Data$Profile$Benefit$WeekdaysOnly = 81;
var $author$project$Core$Data$Profile$Benefit$WeekendsOnly = 82;
var $author$project$Core$Data$Profile$Benefit$toBenefit = function (benefit) {
	switch (benefit) {
		case 'ActiveLifestyle':
			return $elm$core$Result$Ok(0);
		case 'ActivityPartner':
			return $elm$core$Result$Ok(1);
		case 'Adventure':
			return $elm$core$Result$Ok(2);
		case 'Affection':
			return $elm$core$Result$Ok(3);
		case 'AllEthnicities':
			return $elm$core$Result$Ok(4);
		case 'AnimalLover':
			return $elm$core$Result$Ok(5);
		case 'Attention':
			return $elm$core$Result$Ok(6);
		case 'BBW':
			return $elm$core$Result$Ok(7);
		case 'CasualDates':
			return $elm$core$Result$Ok(8);
		case 'CasualEncounters':
			return $elm$core$Result$Ok(9);
		case 'CasualMeetups':
			return $elm$core$Result$Ok(10);
		case 'CoffeeDates':
			return $elm$core$Result$Ok(11);
		case 'Confidant':
			return $elm$core$Result$Ok(14);
		case 'Companion':
			return $elm$core$Result$Ok(12);
		case 'ConcertsMusicalsPlays':
			return $elm$core$Result$Ok(13);
		case 'DaytimeMeetUps':
			return $elm$core$Result$Ok(15);
		case 'DinnerDates':
			return $elm$core$Result$Ok(16);
		case 'Discretion':
			return $elm$core$Result$Ok(17);
		case 'EmotionalConnection':
			return $elm$core$Result$Ok(18);
		case 'EveningMeetUps':
			return $elm$core$Result$Ok(19);
		case 'Excitement':
			return $elm$core$Result$Ok(20);
		case 'Exclusive':
			return $elm$core$Result$Ok(21);
		case 'FinancialSupport-Remove':
			return $elm$core$Result$Ok(22);
		case 'FlexibleSchedule':
			return $elm$core$Result$Ok(23);
		case 'FoodLover':
			return $elm$core$Result$Ok(24);
		case 'FriendsWithBenefits':
			return $elm$core$Result$Ok(25);
		case 'Fun':
			return $elm$core$Result$Ok(26);
		case 'Gay Dating':
			return $elm$core$Result$Ok(27);
		case 'GoodCook':
			return $elm$core$Result$Ok(28);
		case 'HookUp':
			return $elm$core$Result$Ok(29);
		case 'LesbianDating':
			return $elm$core$Result$Ok(30);
		case 'ListeningEar':
			return $elm$core$Result$Ok(31);
		case 'LongTerm':
			return $elm$core$Result$Ok(32);
		case 'LunchDates':
			return $elm$core$Result$Ok(33);
		case 'MarriageMinded':
			return $elm$core$Result$Ok(34);
		case 'MediumTerm':
			return $elm$core$Result$Ok(35);
		case 'MeetForDrinks':
			return $elm$core$Result$Ok(36);
		case 'Mentorship':
			return $elm$core$Result$Ok(37);
		case 'MinimalTattoos':
			return $elm$core$Result$Ok(38);
		case 'Monogamous':
			return $elm$core$Result$Ok(39);
		case 'MonthlyAllowance-Remove':
			return $elm$core$Result$Ok(40);
		case 'MovieDates':
			return $elm$core$Result$Ok(41);
		case 'NatureLover':
			return $elm$core$Result$Ok(42);
		case 'NightTimeMeetUps':
			return $elm$core$Result$Ok(43);
		case 'NoAttached':
			return $elm$core$Result$Ok(44);
		case 'NoIntimacy':
			return $elm$core$Result$Ok(45);
		case 'NoMarried':
			return $elm$core$Result$Ok(46);
		case 'NoStayovers':
			return $elm$core$Result$Ok(47);
		case 'NoStringsAttached':
			return $elm$core$Result$Ok(48);
		case 'NoTravel':
			return $elm$core$Result$Ok(49);
		case 'NonExclusive':
			return $elm$core$Result$Ok(50);
		case 'NonMonogamous':
			return $elm$core$Result$Ok(51);
		case 'OccasionalDates':
			return $elm$core$Result$Ok(52);
		case 'OneOffDates':
			return $elm$core$Result$Ok(53);
		case 'OnlineOnly':
			return $elm$core$Result$Ok(54);
		case 'ONS':
			return $elm$core$Result$Ok(55);
		case 'OpenRelationship':
			return $elm$core$Result$Ok(56);
		case 'Pescatarian':
			return $elm$core$Result$Ok(57);
		case 'Platonic':
			return $elm$core$Result$Ok(58);
		case 'ProfessionalNetworking':
			return $elm$core$Result$Ok(59);
		case 'RentAssistance-Remove':
			return $elm$core$Result$Ok(60);
		case 'Romance':
			return $elm$core$Result$Ok(61);
		case 'SeniorDating':
			return $elm$core$Result$Ok(62);
		case 'ShortTerm':
			return $elm$core$Result$Ok(63);
		case 'SinglesOnly':
			return $elm$core$Result$Ok(64);
		case 'Soulmate':
			return $elm$core$Result$Ok(65);
		case 'Spontaneity':
			return $elm$core$Result$Ok(66);
		case 'SportsDates':
			return $elm$core$Result$Ok(67);
		case 'StayInPartner':
			return $elm$core$Result$Ok(68);
		case 'Staycations':
			return $elm$core$Result$Ok(69);
		case 'Stayovers':
			return $elm$core$Result$Ok(70);
		case 'SugarNewbie-Remove':
			return $elm$core$Result$Ok(71);
		case 'SugarVeteran-Remove':
			return $elm$core$Result$Ok(72);
		case 'Surprises':
			return $elm$core$Result$Ok(73);
		case 'TattooFriendly':
			return $elm$core$Result$Ok(74);
		case 'TransFriendly':
			return $elm$core$Result$Ok(75);
		case 'Transgender':
			return $elm$core$Result$Ok(76);
		case 'TravelToYou':
			return $elm$core$Result$Ok(77);
		case 'TravelWithYou':
			return $elm$core$Result$Ok(78);
		case 'Vacations':
			return $elm$core$Result$Ok(79);
		case 'Vegetarian':
			return $elm$core$Result$Ok(80);
		case 'WeekdaysOnly':
			return $elm$core$Result$Ok(81);
		case 'WeekendsOnly':
			return $elm$core$Result$Ok(82);
		default:
			return $elm$core$Result$Err('Benefit is invalid.');
	}
};
var $author$project$Core$Data$Profile$Benefit$benefitsDecoder = function () {
	var listBenefits = function (benefits) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Result$toMaybe,
			A2($elm$core$List$map, $author$project$Core$Data$Profile$Benefit$toBenefit, benefits));
	};
	var convert = function (benefits) {
		return $elm$json$Json$Decode$succeed(
			listBenefits(benefits));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		convert,
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
}();
var $author$project$Core$Data$Profile$BodyType$bodyTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$BodyType$toBodyType,
		$elm$core$Result$withDefault(6)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$defaultBirthday = F2(
	function (userKind, currentTime) {
		var setAgeAs = function (years) {
			return $elm$time$Time$millisToPosix(
				$elm$time$Time$posixToMillis(currentTime) - (((((years * 365) * 24) * 60) * 60) * 1000));
		};
		if (!userKind) {
			return setAgeAs(23);
		} else {
			return setAgeAs(22);
		}
	});
var $author$project$Core$Data$Profile$SponsorLevel$defaultSponsorLevel = function (userKind) {
	if (!userKind) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Core$Data$Profile$Drinker$HeavyDrinker = 2;
var $author$project$Core$Data$Profile$Drinker$SocialDrinker = 1;
var $author$project$Core$Data$Profile$Drinker$toDrinker = function (drinker) {
	switch (drinker) {
		case 'NonDrinker':
			return $elm$core$Result$Ok(0);
		case 'SocialDrinker':
			return $elm$core$Result$Ok(1);
		case 'HeavyDrinker':
			return $elm$core$Result$Ok(2);
		default:
			return $elm$core$Result$Err('Drinker field is invalid.');
	}
};
var $author$project$Core$Data$Profile$Drinker$drinkerDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$Drinker$toDrinker,
		$elm$core$Result$withDefault(0)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$Education$AssociatesDegree = 2;
var $author$project$Core$Data$Profile$Education$BachelorsDegree = 3;
var $author$project$Core$Data$Profile$Education$GraduateDegree = 4;
var $author$project$Core$Data$Profile$Education$HighSchool = 0;
var $author$project$Core$Data$Profile$Education$PhD = 5;
var $author$project$Core$Data$Profile$Education$toEducation = function (education) {
	switch (education) {
		case 'HighSchool':
			return $elm$core$Result$Ok(0);
		case 'College':
			return $elm$core$Result$Ok(1);
		case 'AssociatesDegree':
			return $elm$core$Result$Ok(2);
		case 'BachelorsDegree':
			return $elm$core$Result$Ok(3);
		case 'GraduateDegree':
			return $elm$core$Result$Ok(4);
		case 'PhD':
			return $elm$core$Result$Ok(5);
		default:
			return $elm$core$Result$Err('Education field is invalid.');
	}
};
var $author$project$Core$Data$Profile$Education$educationDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$Education$toEducation,
		$elm$core$Result$withDefault(1)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$Ethnicity$Asian = 0;
var $author$project$Core$Data$Profile$Ethnicity$Black = 1;
var $author$project$Core$Data$Profile$Ethnicity$EastIndian = 3;
var $author$project$Core$Data$Profile$Ethnicity$Latin = 2;
var $author$project$Core$Data$Profile$Ethnicity$MiddleEastern = 4;
var $author$project$Core$Data$Profile$Ethnicity$Mixed = 5;
var $author$project$Core$Data$Profile$Ethnicity$NativeAmerican = 6;
var $author$project$Core$Data$Profile$Ethnicity$PacificIslander = 7;
var $author$project$Core$Data$Profile$Ethnicity$White = 8;
var $author$project$Core$Data$Profile$Ethnicity$toEthnicity = function (string) {
	switch (string) {
		case 'Asian':
			return $elm$core$Result$Ok(0);
		case 'Black':
			return $elm$core$Result$Ok(1);
		case 'Latin':
			return $elm$core$Result$Ok(2);
		case 'EastIndian':
			return $elm$core$Result$Ok(3);
		case 'MiddleEastern':
			return $elm$core$Result$Ok(4);
		case 'Mixed':
			return $elm$core$Result$Ok(5);
		case 'NativeAmerican':
			return $elm$core$Result$Ok(6);
		case 'PacificIslander':
			return $elm$core$Result$Ok(7);
		case 'White':
			return $elm$core$Result$Ok(8);
		case 'OtherEthnicity':
			return $elm$core$Result$Ok(9);
		default:
			return $elm$core$Result$Err('Ethniciy field is invalid.');
	}
};
var $author$project$Core$Data$Profile$Ethnicity$ethnicityDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$Ethnicity$toEthnicity,
		$elm$core$Result$withDefault(9)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$Gender$genderDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$Gender$toGender,
		$elm$core$Result$withDefault(1)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$Height$heightDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$Height$toHeight,
		$elm$core$Result$withDefault($author$project$Core$Data$Profile$Height$OtherHeight)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$LifestyleExpectation$Negotiable = 3;
var $author$project$Core$Data$Profile$LifestyleExpectation$EqualSplit = 1;
var $author$project$Core$Data$Profile$LifestyleExpectation$Extravagant = 9;
var $author$project$Core$Data$Profile$LifestyleExpectation$GoDutch = 0;
var $author$project$Core$Data$Profile$LifestyleExpectation$High = 8;
var $author$project$Core$Data$Profile$LifestyleExpectation$Luxurious = 10;
var $author$project$Core$Data$Profile$LifestyleExpectation$Minimal = 4;
var $author$project$Core$Data$Profile$LifestyleExpectation$OpenExpectation = 2;
var $author$project$Core$Data$Profile$LifestyleExpectation$Practical = 5;
var $author$project$Core$Data$Profile$LifestyleExpectation$Substantial = 7;
var $author$project$Core$Data$Profile$LifestyleExpectation$toLifestyleExpectation = function (lifestyleExpectation) {
	switch (lifestyleExpectation) {
		case 'Go Dutch':
			return $elm$core$Result$Ok(0);
		case 'Equal Split':
			return $elm$core$Result$Ok(1);
		case 'Open':
			return $elm$core$Result$Ok(2);
		case 'Negotiable':
			return $elm$core$Result$Ok(3);
		case 'Minimal':
			return $elm$core$Result$Ok(4);
		case 'Practical':
			return $elm$core$Result$Ok(5);
		case 'Moderate':
			return $elm$core$Result$Ok(6);
		case 'Substantial':
			return $elm$core$Result$Ok(7);
		case 'High':
			return $elm$core$Result$Ok(8);
		case 'Extravagant':
			return $elm$core$Result$Ok(9);
		case 'Luxurious':
			return $elm$core$Result$Ok(10);
		default:
			return $elm$core$Result$Err('Lifestyle Expectation field is invalid.');
	}
};
var $author$project$Core$Data$Profile$LifestyleExpectation$lifestyleExpectationDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$LifestyleExpectation$toLifestyleExpectation,
		$elm$core$Result$withDefault(3)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$MaritalStatus$Single = 0;
var $author$project$Core$Data$Profile$MaritalStatus$Attached = 5;
var $author$project$Core$Data$Profile$MaritalStatus$Divorced = 3;
var $author$project$Core$Data$Profile$MaritalStatus$Married = 6;
var $author$project$Core$Data$Profile$MaritalStatus$NotSpecifiedMarital = 7;
var $author$project$Core$Data$Profile$MaritalStatus$Separated = 2;
var $author$project$Core$Data$Profile$MaritalStatus$Widowed = 4;
var $author$project$Core$Data$Profile$MaritalStatus$toMaritalStatus = function (maritalStatus) {
	switch (maritalStatus) {
		case 'Single':
			return $elm$core$Result$Ok(0);
		case 'OpenRelationship':
			return $elm$core$Result$Ok(1);
		case 'Separated':
			return $elm$core$Result$Ok(2);
		case 'Divorced':
			return $elm$core$Result$Ok(3);
		case 'Widowed':
			return $elm$core$Result$Ok(4);
		case 'AttachedButLooking':
			return $elm$core$Result$Ok(5);
		case 'MarriedButLooking':
			return $elm$core$Result$Ok(6);
		case 'NotSpecifiedMarital':
			return $elm$core$Result$Ok(7);
		default:
			return $elm$core$Result$Err('Relationship is invalid.');
	}
};
var $author$project$Core$Data$Profile$MaritalStatus$maritalStatusDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$MaritalStatus$toMaritalStatus,
		$elm$core$Result$withDefault(0)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$NumberOfChildren$Five = 6;
var $author$project$Core$Data$Profile$NumberOfChildren$Four = 5;
var $author$project$Core$Data$Profile$NumberOfChildren$One = 2;
var $author$project$Core$Data$Profile$NumberOfChildren$SixOrMore = 7;
var $author$project$Core$Data$Profile$NumberOfChildren$Three = 4;
var $author$project$Core$Data$Profile$NumberOfChildren$Two = 3;
var $author$project$Core$Data$Profile$NumberOfChildren$Zero = 1;
var $author$project$Core$Data$Profile$NumberOfChildren$toNumberOfChildren = function (children) {
	switch (children) {
		case 'NotSpecified':
			return $elm$core$Result$Ok(0);
		case 'Zero':
			return $elm$core$Result$Ok(1);
		case 'One':
			return $elm$core$Result$Ok(2);
		case 'Two':
			return $elm$core$Result$Ok(3);
		case 'Three':
			return $elm$core$Result$Ok(4);
		case 'Four':
			return $elm$core$Result$Ok(5);
		case 'Five':
			return $elm$core$Result$Ok(6);
		case 'SixOrMore':
			return $elm$core$Result$Ok(7);
		default:
			return $elm$core$Result$Err('Children field is invalid.');
	}
};
var $author$project$Core$Data$Profile$NumberOfChildren$numberOfChildrenDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$NumberOfChildren$toNumberOfChildren,
		$elm$core$Result$withDefault(0)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$Smoker$HeavySmoker = 2;
var $author$project$Core$Data$Profile$Smoker$LightSmoker = 1;
var $author$project$Core$Data$Profile$Smoker$toSmoker = function (smoker) {
	switch (smoker) {
		case 'NonSmoker':
			return $elm$core$Result$Ok(0);
		case 'LightSmoker':
			return $elm$core$Result$Ok(1);
		case 'HeavySmoker':
			return $elm$core$Result$Ok(2);
		default:
			return $elm$core$Result$Err('Smoker field is invalid.');
	}
};
var $author$project$Core$Data$Profile$Smoker$smokerDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$Profile$Smoker$toSmoker,
		$elm$core$Result$withDefault(0)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$AuthUser$toUserKind = function (userKind) {
	switch (userKind) {
		case 'Sugar':
			return $elm$core$Result$Ok(1);
		case 'Sponsor':
			return $elm$core$Result$Ok(0);
		default:
			return $elm$core$Result$Err('UserKind field is invalid.');
	}
};
var $author$project$Core$Data$AuthUser$userKindDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Core$Data$AuthUser$toUserKind,
		$elm$core$Result$withDefault(1)),
	$elm$json$Json$Decode$string);
var $author$project$Core$Data$Profile$VerifyStatus$VerifyStatus = F2(
	function (email, photo) {
		return {dt: email, mP: photo};
	});
var $author$project$Core$Data$Profile$VerifyStatus$verifyStatusDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'photo',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'email',
		$elm$json$Json$Decode$bool,
		false,
		$elm$json$Json$Decode$succeed($author$project$Core$Data$Profile$VerifyStatus$VerifyStatus)));
var $author$project$Core$Data$Profile$WantGender$snapshotToWantGender = function (_v0) {
	var man = _v0.hC;
	var woman = _v0.jI;
	var _v1 = _Utils_Tuple2(man, woman);
	_v1$2:
	while (true) {
		if (_v1.a) {
			if (!_v1.b) {
				return 0;
			} else {
				break _v1$2;
			}
		} else {
			if (_v1.b) {
				return 1;
			} else {
				break _v1$2;
			}
		}
	}
	return 2;
};
var $author$project$Core$Data$Profile$WantGender$WantGenderSnapshot = F2(
	function (man, woman) {
		return {hC: man, jI: woman};
	});
var $author$project$Core$Data$Profile$WantGender$wantGenderSnapshotDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'woman',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'man',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Core$Data$Profile$WantGender$WantGenderSnapshot)));
var $author$project$Core$Data$Profile$WantGender$wantGenderDecoder = A2($elm$json$Json$Decode$map, $author$project$Core$Data$Profile$WantGender$snapshotToWantGender, $author$project$Core$Data$Profile$WantGender$wantGenderSnapshotDecoder);
var $author$project$Core$Data$Profile$WantRelationship$wantRelationshipsDecoder = function () {
	var listWantRelationship = function (wantRelationships) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Result$toMaybe,
			A2($elm$core$List$map, $author$project$Core$Data$Profile$WantRelationship$toWantRelationship, wantRelationships));
	};
	var convert = function (wantRelationships) {
		return $elm$json$Json$Decode$succeed(
			listWantRelationship(wantRelationships));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		convert,
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
}();
var $author$project$Core$Data$Profile$profileDecoder = F3(
	function (currentTime, userKind, userID) {
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'sponsorLevel',
			$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelDecoder,
			$author$project$Core$Data$Profile$SponsorLevel$defaultSponsorLevel(userKind),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'verifyStatus',
				$author$project$Core$Data$Profile$VerifyStatus$verifyStatusDecoder,
				{dt: false, mP: false},
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'status',
					$author$project$Core$Data$Profile$Status$statusDecoder,
					1,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'userKind',
						$author$project$Core$Data$AuthUser$userKindDecoder,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'lastOnline',
							$author$project$Firebase$Firestore$timestampDecoder,
							currentTime,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'privatePhotoNumber',
								$elm$json$Json$Decode$int,
								0,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'updatedAt',
									$author$project$Firebase$Firestore$timestampDecoder,
									currentTime,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'createdAt',
										$author$project$Firebase$Firestore$timestampDecoder,
										currentTime,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'otherBenefit',
											$elm$json$Json$Decode$string,
											'',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'benefits',
												$author$project$Core$Data$Profile$Benefit$benefitsDecoder,
												_List_Nil,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'drinker',
													$author$project$Core$Data$Profile$Drinker$drinkerDecoder,
													0,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'smoker',
														$author$project$Core$Data$Profile$Smoker$smokerDecoder,
														0,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'occupation',
															$elm$json$Json$Decode$string,
															'',
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'education',
																$author$project$Core$Data$Profile$Education$educationDecoder,
																1,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'numberOfChildren',
																	$author$project$Core$Data$Profile$NumberOfChildren$numberOfChildrenDecoder,
																	0,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'wantRelationships',
																		$author$project$Core$Data$Profile$WantRelationship$wantRelationshipsDecoder,
																		_List_Nil,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'maritalStatus',
																			$author$project$Core$Data$Profile$MaritalStatus$maritalStatusDecoder,
																			1,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'aboutMe',
																				$elm$json$Json$Decode$string,
																				'',
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'headline',
																					$elm$json$Json$Decode$string,
																					'',
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'locations',
																						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																						_List_Nil,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'ethnicity',
																							$author$project$Core$Data$Profile$Ethnicity$ethnicityDecoder,
																							9,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'bodyType',
																								$author$project$Core$Data$Profile$BodyType$bodyTypeDecoder,
																								0,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'height',
																									$author$project$Core$Data$Profile$Height$heightDecoder,
																									$author$project$Core$Data$Profile$Height$OtherHeight,
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'birthday',
																										$author$project$Firebase$Firestore$timestampDecoder,
																										A2($author$project$Core$Data$Profile$defaultBirthday, userKind, currentTime),
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'lifestyleExpectation',
																											$author$project$Core$Data$Profile$LifestyleExpectation$lifestyleExpectationDecoder,
																											6,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'wantGender',
																												$author$project$Core$Data$Profile$WantGender$wantGenderDecoder,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'gender',
																													$author$project$Core$Data$Profile$Gender$genderDecoder,
																													A4(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																														'avatar',
																														$elm$json$Json$Decode$string,
																														'',
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'email',
																															$elm$json$Json$Decode$string,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'username',
																																$elm$json$Json$Decode$string,
																																A4(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																	'uid',
																																	$elm$json$Json$Decode$string,
																																	userID,
																																	$elm$json$Json$Decode$succeed($author$project$Core$Data$Profile$Profile))))))))))))))))))))))))))))))));
	});
var $author$project$Core$Data$Profile$decodeProfile = F4(
	function (currentTime, userKind, id, json) {
		return A2(
			$elm$json$Json$Decode$decodeString,
			A3($author$project$Core$Data$Profile$profileDecoder, currentTime, userKind, id),
			json);
	});
var $author$project$Helpers$ReportUser$Types$Popup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Helpers$ReportUser$Model$initialModel = F3(
	function (channelID, reporter, reported) {
		return _Utils_Tuple2(
			{
				aa: channelID,
				ln: $author$project$Form$createForm(
					_List_fromArray(
						[
							A3(
							$author$project$Form$fieldString,
							'reason',
							'',
							_List_fromArray(
								[$author$project$Form$Validators$isNotEmpty])),
							A3($author$project$Form$fieldString, 'otherReason', '', _List_Nil)
						])),
				hi: false,
				bN: $author$project$CustomPopup$initialModel(
					{fe: '000000', f_: $author$project$View$Theme$images.mV, eq: 'PopupForReportUser', jr: $author$project$Helpers$ReportUser$Types$Popup}),
				ez: reported,
				eA: reporter
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$Detail$initialReportUser = F2(
	function (user, profile) {
		var reporter = {eX: user.eX, dh: user.ds};
		var reported = {eX: profile.eX, dh: profile.dh};
		var _v0 = A3($author$project$Helpers$ReportUser$Model$initialModel, $author$project$Model$Detail$channelIDs.f6, reporter, reported);
		var reportUser = _v0.a;
		var reportUserCmd = _v0.b;
		return _Utils_Tuple2(reportUser, reportUserCmd);
	});
var $author$project$Core$Data$Profile$createdAtJson = A2(
	$elm$json$Json$Encode$encode,
	0,
	$elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('createdAt', $author$project$Firebase$Firestore$serverTimestamp)
			])));
var $author$project$Core$Data$Profile$viewedMeProfilePath = F2(
	function (userID, viewerID) {
		return '/profiles/' + (userID + ('/viewedMe/' + viewerID));
	});
var $author$project$Core$Data$Profile$setViewedProfile = F3(
	function (userID, viewerID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$setDoc,
				$author$project$Core$Data$Profile$createdAtJson,
				$author$project$Firebase$Firestore$doc(
					A2($author$project$Core$Data$Profile$viewedMeProfilePath, userID, viewerID))));
	});
var $author$project$Model$Detail$setViewedProfile = F2(
	function (userID, authUserID) {
		return A3($author$project$Core$Data$Profile$setViewedProfile, userID, authUserID, $author$project$Model$Detail$channelIDs.bE);
	});
var $author$project$Model$Detail$getProfileResult = F3(
	function (json, authState, model) {
		var _v0 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
		if (_v0.$ === 1) {
			var _v1 = _v0.a;
			var message = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						b8: A2($author$project$Data$Alert$addFailure, message, model.b8)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var id = _v0.a.lK;
			var data = _v0.a.kH;
			var _v2 = authState;
			var detail = _v2.gj;
			var authUser = _v2.j2;
			var searchFor = (!authUser.ho) ? 1 : 0;
			var hasProfile = $elm$core$Result$toMaybe(
				A4($author$project$Core$Data$Profile$decodeProfile, model.kG, searchFor, id, data));
			var _v3 = detail;
			var profiles = _v3.iw;
			if (hasProfile.$ === 1) {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			} else {
				var profile = hasProfile.a;
				var _v5 = profile;
				var uid = _v5.eX;
				var _v6 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnDetail),
							$author$project$Type$Detail$Report(uid))),
					A2($author$project$Model$Detail$initialReportUser, authUser, profile));
				var reportUser = _v6.a;
				var reportUserCmd = _v6.b;
				var updatedFullProfile = $elm$core$Maybe$map(
					function (fullProfile) {
						return _Utils_update(
							fullProfile,
							{
								iu: $elm$core$Maybe$Just(profile),
								aA: $elm$core$Maybe$Just(reportUser)
							});
					});
				var updatedProfiles = function () {
					var _v7 = A2($elm$core$Dict$get, uid, profiles);
					if (_v7.$ === 1) {
						return A3(
							$elm$core$Dict$insert,
							uid,
							{
								j9: $author$project$Type$Detail$Getting,
								aN: 3,
								bQ: $author$project$Type$Detail$Pending,
								iu: $elm$core$Maybe$Just(profile),
								m5: _List_Nil,
								aA: $elm$core$Maybe$Just(reportUser)
							},
							profiles);
					} else {
						return A3($elm$core$Dict$update, uid, updatedFullProfile, profiles);
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										gj: _Utils_update(
											detail,
											{iw: updatedProfiles})
									}))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Model$Detail$setViewedProfile, uid, authUser.eX),
								A2($author$project$Model$Detail$checkFavoriteStatus, uid, authUser.eX),
								reportUserCmd
							])));
			}
		}
	});
var $author$project$Data$ProfileStatus$Error = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Data$ProfileStatus$Synced = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$SearchProfile$getProfile = F2(
	function (userID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$getDoc(
				$author$project$Firebase$Firestore$doc('/backend/search/profiles/' + userID)));
	});
var $author$project$Model$RelatedProfiles$getRelatedProfileState = F2(
	function (connectKind, model) {
		switch (connectKind) {
			case 0:
				return model.oe;
			case 1:
				return model.li;
			default:
				return model.lh;
		}
	});
var $author$project$Data$ProfileStatus$getUnSyncUserID = function (statuses) {
	getUnSyncUserID:
	while (true) {
		if (statuses.b) {
			var status = statuses.a;
			var rest = statuses.b;
			if (!status.$) {
				var userID = status.a;
				return $elm$core$Maybe$Just(userID);
			} else {
				var $temp$statuses = rest;
				statuses = $temp$statuses;
				continue getUnSyncUserID;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Model$RelatedProfiles$getProfileCmd = F2(
	function (connectKind, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (userID) {
					return A2(
						$author$project$Data$SearchProfile$getProfile,
						userID,
						A2($author$project$Model$RelatedProfiles$channelIDs.gK, connectKind, userID));
				},
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Data$ProfileStatus$getUnSyncUserID,
					A2($author$project$Model$RelatedProfiles$getRelatedProfileState, connectKind, model).an)));
	});
var $author$project$Core$Data$Profile$Connect$toConnectKindFromDb = function (connectKindString) {
	switch (connectKindString) {
		case 'viewedMe':
			return $elm$core$Result$Ok(0);
		case 'favoritedMe':
			return $elm$core$Result$Ok(1);
		case 'favoriteProfile':
			return $elm$core$Result$Ok(2);
		default:
			return $elm$core$Result$Err('Invalid connectKindString: ' + connectKindString);
	}
};
var $author$project$Core$Data$Profile$OnlineStatus$Offline = 1;
var $author$project$Data$SearchProfile$Profile = function (uid) {
	return function (username) {
		return function (avatar) {
			return function (birthday) {
				return function (height) {
					return function (bodyType) {
						return function (locations) {
							return function (headline) {
								return function (wantRelationships) {
									return function (lifestyleExpectation) {
										return function (publicPhotos) {
											return function (sponsorLevel) {
												return function (lastOnline) {
													return function (onlineStatus) {
														return function (createdAt) {
															return {cc: avatar, cf: birthday, bi: bodyType, cm: createdAt, cy: headline, bu: height, lZ: lastOnline, bz: lifestyleExpectation, cE: locations, mH: onlineStatus, m5: publicPhotos, bY: sponsorLevel, eX: uid, dh: username, b4: wantRelationships};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Core$Data$Profile$OnlineStatus$Online = 0;
var $author$project$Core$Data$Profile$OnlineStatus$decoder = function () {
	var convert = function (str) {
		switch (str) {
			case 'Online':
				return $elm$json$Json$Decode$succeed(0);
			case 'Offline':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid OnlineStatus: ' + str);
		}
	};
	return A2($elm$json$Json$Decode$andThen, convert, $elm$json$Json$Decode$string);
}();
var $author$project$Data$SearchProfile$profileDecoder = F4(
	function (currentTime, userKind, userID, _v0) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdAt',
			$author$project$Firebase$Firestore$timestampDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'onlineStatus',
				$author$project$Core$Data$Profile$OnlineStatus$decoder,
				1,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'lastOnline',
					$author$project$Firebase$Firestore$timestampDecoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'sponsorLevel',
						$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelDecoder,
						$author$project$Core$Data$Profile$SponsorLevel$defaultSponsorLevel(userKind),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'publicPhotos',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'lifestyleExpectation',
								$author$project$Core$Data$Profile$LifestyleExpectation$lifestyleExpectationDecoder,
								6,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'wantRelationships',
									$author$project$Core$Data$Profile$WantRelationship$wantRelationshipsDecoder,
									_List_Nil,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'headline',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'locations',
											$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
											_List_Nil,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'bodyType',
												$author$project$Core$Data$Profile$BodyType$bodyTypeDecoder,
												0,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'height',
													$author$project$Core$Data$Profile$Height$heightDecoder,
													$author$project$Core$Data$Profile$Height$OtherHeight,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'birthday',
														$author$project$Firebase$Firestore$timestampDecoder,
														A2($author$project$Core$Data$Profile$defaultBirthday, userKind, currentTime),
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'avatar',
															$elm$json$Json$Decode$string,
															'',
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'username',
																$elm$json$Json$Decode$string,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'uid',
																	$elm$json$Json$Decode$string,
																	userID,
																	$elm$json$Json$Decode$succeed($author$project$Data$SearchProfile$Profile))))))))))))))));
	});
var $author$project$Data$SearchProfile$decodeProfile = F5(
	function (currentTime, userKind, id, json, fromCache) {
		return A2(
			$elm$json$Json$Decode$decodeString,
			A4($author$project$Data$SearchProfile$profileDecoder, currentTime, userKind, id, fromCache),
			json);
	});
var $author$project$Data$SearchProfile$toProfile = F3(
	function (currentTime, userKind, _v0) {
		var id = _v0.lK;
		var data = _v0.kH;
		var metadata = _v0.me;
		return A5($author$project$Data$SearchProfile$decodeProfile, currentTime, userKind, id, data, metadata.lq);
	});
var $author$project$Data$ProfileStatus$getUserID = function (status) {
	switch (status.$) {
		case 0:
			var userID = status.a;
			return userID;
		case 1:
			var uid = status.a.eX;
			return uid;
		default:
			var userID = status.a;
			return userID;
	}
};
var $author$project$Data$ProfileStatus$update = F3(
	function (userID, newStatus, statuses) {
		return A2(
			$elm$core$List$map,
			function (status) {
				return _Utils_eq(
					userID,
					$author$project$Data$ProfileStatus$getUserID(status)) ? newStatus : status;
			},
			statuses);
	});
var $author$project$Model$RelatedProfiles$getRelatedProfileResult = F5(
	function (contentKindString, userID, json, authState, appModel) {
		var _v0 = $author$project$Core$Data$Profile$Connect$toConnectKindFromDb(contentKindString);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var connectKind = _v0.a;
			var _v1 = authState;
			var relatedProfiles = _v1.iD;
			var search = _v1.nm;
			var relatedProfileState = A2($author$project$Model$RelatedProfiles$getRelatedProfileState, connectKind, relatedProfiles);
			var _v2 = relatedProfileState.an;
			if (_v2.$ === 1) {
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			} else {
				var profileStatuses = _v2.a;
				var _v3 = appModel;
				var currentTime = _v3.kG;
				var updateRelatedProfileState = function (state) {
					var _v5 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
					if (_v5.$ === 1) {
						var _v6 = _v5.a;
						var message = _v6.b;
						return _Utils_update(
							state,
							{
								an: $elm$core$Maybe$Just(
									A3(
										$author$project$Data$ProfileStatus$update,
										userID,
										A2($author$project$Data$ProfileStatus$Error, userID, message),
										profileStatuses))
							});
					} else {
						var snapshot = _v5.a;
						var _v7 = A3($author$project$Data$SearchProfile$toProfile, currentTime, search.iQ, snapshot);
						if (_v7.$ === 1) {
							var decoderError = _v7.a;
							return _Utils_update(
								state,
								{
									an: $elm$core$Maybe$Just(
										A3(
											$author$project$Data$ProfileStatus$update,
											userID,
											A2(
												$author$project$Data$ProfileStatus$Error,
												userID,
												$elm$json$Json$Decode$errorToString(decoderError)),
											profileStatuses))
								});
						} else {
							var profile = _v7.a;
							return _Utils_update(
								state,
								{
									an: $elm$core$Maybe$Just(
										A3(
											$author$project$Data$ProfileStatus$update,
											userID,
											$author$project$Data$ProfileStatus$Synced(profile),
											profileStatuses))
								});
						}
					}
				};
				var updatedModel = function () {
					switch (connectKind) {
						case 0:
							return _Utils_update(
								relatedProfiles,
								{
									oe: updateRelatedProfileState(relatedProfiles.oe)
								});
						case 1:
							return _Utils_update(
								relatedProfiles,
								{
									li: updateRelatedProfileState(relatedProfiles.li)
								});
						default:
							return _Utils_update(
								relatedProfiles,
								{
									lh: updateRelatedProfileState(relatedProfiles.lh)
								});
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{iD: updatedModel}))
						}),
					A2($author$project$Model$RelatedProfiles$getProfileCmd, connectKind, updatedModel));
			}
		}
	});
var $author$project$Data$BundleID$getBundleIDFromSnapshot = function (json) {
	var _v0 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
	if (_v0.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var data = _v0.a.kH;
		var metadata = _v0.a.me;
		return metadata.lq ? $elm$core$Maybe$Nothing : $elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeString,
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
				data));
	}
};
var $author$project$NativeBridge$mobileOsString = function (device) {
	if (device.$ === 1) {
		if (device.a.$ === 1) {
			return $elm$core$Maybe$Just('android');
		} else {
			return $elm$core$Maybe$Just('ios');
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$NativeBridge$mobileOsVersion = function (device) {
	if (device.$ === 1) {
		if (device.a.$ === 1) {
			var version = device.a.a;
			return $elm$core$Maybe$Just(version);
		} else {
			var version = device.a.a;
			return $elm$core$Maybe$Just(version);
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$BundleID$handle = F4(
	function (url, hasLocalBundleID, device, json) {
		if (hasLocalBundleID.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var localBundleID = hasLocalBundleID.a;
			var _v1 = $author$project$Data$BundleID$getBundleIDFromSnapshot(json);
			if (_v1.$ === 1) {
				return $elm$core$Platform$Cmd$none;
			} else {
				var newBundleID = _v1.a;
				return _Utils_eq(newBundleID, localBundleID) ? $elm$core$Platform$Cmd$none : $elm$browser$Browser$Navigation$load(
					url.mM + ('/?os=' + (A2(
						$elm$core$Maybe$withDefault,
						'null',
						$author$project$NativeBridge$mobileOsString(device)) + ('&bustCache=' + (newBundleID + ('&version=' + A2(
						$elm$core$Maybe$withDefault,
						'0.0.0',
						$author$project$NativeBridge$mobileOsVersion(device))))))));
			}
		}
	});
var $author$project$Data$SearchProfile$toProfiles = F3(
	function (currentTime, userKind, _v0) {
		var docs = _v0.kV;
		return A2(
			$elm$core$List$filterMap,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Result$toMaybe,
				A2($author$project$Data$SearchProfile$toProfile, currentTime, userKind)),
			docs);
	});
var $author$project$Model$Search$handleResult = F4(
	function (isReset, json, authState, appModel) {
		var _v0 = $author$project$Firebase$Firestore$decodeQuerySnapshot(json);
		if (_v0.$ === 1) {
			var _v1 = _v0.a;
			var message = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						b8: A2($author$project$Data$Alert$addFailure, message, appModel.b8)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var snapshots = _v0.a;
			var _v2 = appModel;
			var adminUserIDs = _v2.jQ;
			var currentTime = _v2.kG;
			var _v3 = authState;
			var search = _v3.nm;
			var authUser = _v3.j2;
			var profiles = A3($author$project$Data$SearchProfile$toProfiles, currentTime, authUser.ho, snapshots);
			var filterAdminProfiles = A2(
				$elm$core$List$filter,
				function (profile) {
					return (!_Utils_eq(profile.eX, adminUserIDs.l6)) && (!_Utils_eq(profile.eX, adminUserIDs.lj));
				},
				profiles);
			var updatedModel = isReset ? _Utils_update(
				search,
				{
					iw: $elm$core$Maybe$Just(filterAdminProfiles)
				}) : function (updatedProfiles) {
				return _Utils_update(
					search,
					{
						iw: $elm$core$Maybe$Just(updatedProfiles)
					});
			}(
				A2(
					$elm$core$Maybe$withDefault,
					filterAdminProfiles,
					A2(
						$elm$core$Maybe$map,
						function (profiles_) {
							return _Utils_ap(profiles_, filterAdminProfiles);
						},
						search.iw)));
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{nm: updatedModel}))
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$OnRegister = function (a) {
	return {$: 10, a: a};
};
var $author$project$Type$Register$ResetModel = function (a) {
	return {$: 2, a: a};
};
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.nA));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {iF: reqs, jd: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.ju;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.iF));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.jd)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					jS: r.jS,
					cg: r.cg,
					k6: A2(_Http_mapExpect, func, r.k6),
					lB: r.lB,
					mf: r.mf,
					nU: r.nU,
					ju: r.ju,
					n8: r.n8
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{jS: false, cg: r.cg, k6: r.k6, lB: r.lB, mf: r.mf, nU: r.nU, ju: r.ju, n8: r.n8}));
};
var $elm$http$Http$post = function (r) {
	return $elm$http$Http$request(
		{cg: r.cg, k6: r.k6, lB: _List_Nil, mf: 'POST', nU: $elm$core$Maybe$Nothing, ju: $elm$core$Maybe$Nothing, n8: r.n8});
};
var $elm$http$Http$stringBody = _Http_pair;
var $author$project$Model$Register$sendEmailCmd = F2(
	function (url, userID) {
		var params = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'userID',
						$elm$json$Json$Encode$string(userID)),
						_Utils_Tuple2(
						'token',
						$elm$json$Json$Encode$string(
							$truqu$elm_md5$MD5$hex(userID)))
					])));
		return $elm$http$Http$post(
			{
				cg: A2($elm$http$Http$stringBody, 'application/json', params),
				k6: $elm$http$Http$expectString(
					A2($elm$core$Basics$composeL, $author$project$Types$OnRegister, $author$project$Type$Register$ResetModel)),
				n8: url
			});
	});
var $author$project$Model$Register$onCreateDbUser = F2(
	function (uid, appModel) {
		var verifyEmailUrl = appModel.jX.np;
		var _v0 = appModel.na;
		var form = _v0.ln;
		var user = {
			ds: $elm$core$Maybe$Just(
				A2($author$project$Form$getRawString, form, 'username')),
			dt: A2($author$project$Form$getRawString, form, 'email'),
			k_: false,
			lU: false,
			mQ: $elm$core$Maybe$Just(
				$author$project$Model$Register$userKindtoPhotoURL(
					A2($author$project$Form$getRawString, form, 'userKind'))),
			eX: uid
		};
		return _Utils_Tuple2(
			appModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Model$Register$sendEmailCmd, verifyEmailUrl, uid),
						A2(
						$elm$core$Task$perform,
						$author$project$Types$OnAuthStateChanged,
						$elm$core$Task$succeed(
							$elm$core$Maybe$Just(user))),
						A2($elm$browser$Browser$Navigation$pushUrl, appModel.bD, $author$project$Data$Route$routeUrl.nm)
					])));
	});
var $author$project$Firebase$Firestore$getErrorMessage = function (_v0) {
	var message = _v0.b;
	return message;
};
var $author$project$Data$Chat$Room$Room = F4(
	function (lastMessage, lastMessageCreatedAt, unreadCount, partner) {
		return {bx: lastMessage, ai: lastMessageCreatedAt, q: partner, df: unreadCount};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$Data$Chat$Room$decoder = function (user) {
	return A5(
		$elm$json$Json$Decode$map4,
		$author$project$Data$Chat$Room$Room,
		A2($elm$json$Json$Decode$field, 'lastMessage', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'lastMessageCreatedAt', $author$project$Firebase$Firestore$timestampDecoder),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				[
					$author$project$Data$Chat$Room$dbUserField(user),
					'unreadCount'
				]),
			$elm$json$Json$Decode$int),
		A2(
			$elm$json$Json$Decode$field,
			$author$project$Data$Chat$Room$dbPartnerField(user),
			$author$project$Data$Chat$Partner$decoder));
};
var $author$project$Data$Chat$Room$decode = F2(
	function (state, json) {
		return A2(
			$elm$json$Json$Decode$decodeString,
			$author$project$Data$Chat$Room$decoder(state.W),
			json);
	});
var $author$project$Data$Chat$Room$onGetRemoteRoom = F2(
	function (json, state) {
		var _v0 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
		if (_v0.$ === 1) {
			var error = _v0.a;
			return $elm$core$Result$Err(error);
		} else {
			var doc = _v0.a;
			if ((!doc.k3) || doc.me.gR) {
				return $elm$core$Result$Ok(state);
			} else {
				var _v1 = A2($author$project$Data$Chat$Room$decode, state, doc.kH);
				if (_v1.$ === 1) {
					var decodeError = _v1.a;
					return $elm$core$Result$Err(
						A2(
							$author$project$Firebase$Firestore$Error,
							$author$project$Firebase$Firestore$DecodeError(decodeError),
							$elm$json$Json$Decode$errorToString(decodeError)));
				} else {
					var room = _v1.a;
					return $elm$core$Result$Ok(
						A2($author$project$Data$Chat$Room$insert, room, state));
				}
			}
		}
	});
var $author$project$Data$Chat$onGetRemoteRoom = F2(
	function (json, _v0) {
		var state = _v0;
		return A2(
			$elm$core$Result$map,
			function (room) {
				return _Utils_update(
					state,
					{a: room});
			},
			A2($author$project$Data$Chat$Room$onGetRemoteRoom, json, state.a));
	});
var $author$project$Model$Chat$onGetRemoteRoom = F3(
	function (json, authState, appModel) {
		var _v0 = authState;
		var chat = _v0.km;
		var _v1 = A2($author$project$Data$Chat$onGetRemoteRoom, json, chat.i8);
		if (_v1.$ === 1) {
			var error = _v1.a;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						b8: A2(
							$author$project$Data$Alert$addFailure,
							$author$project$Firebase$Firestore$getErrorMessage(error),
							appModel.b8)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var chatState = _v1.a;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									km: _Utils_update(
										chat,
										{i8: chatState})
								}))
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Chat$mapDbErrors = F2(
	function (errors, appModel) {
		return function (alerts) {
			return _Utils_update(
				appModel,
				{b8: alerts});
		}(
			A3(
				$elm$core$List$foldl,
				$author$project$Data$Alert$addFailure,
				appModel.b8,
				A2($elm$core$List$map, $author$project$Firebase$Firestore$getErrorMessage, errors)));
	});
var $author$project$Data$Chat$Message$insert = F2(
	function (message, state) {
		var partnerMessages = A3(
			$elm$core$Dict$insert,
			message.lK,
			message,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Dict$empty,
				A2($elm$core$Dict$get, message.u, state.az)));
		return _Utils_update(
			state,
			{
				az: A3($elm$core$Dict$insert, message.u, partnerMessages, state.az)
			});
	});
var $author$project$Data$Chat$Message$addRemoteMessage = F2(
	function (decodedMessage, _v0) {
		var errors = _v0.a;
		var state = _v0.b;
		if (!decodedMessage.$) {
			var message = decodedMessage.a;
			return _Utils_Tuple2(
				errors,
				A2($author$project$Data$Chat$Message$insert, message, state));
		} else {
			var decodeError = decodedMessage.a;
			return _Utils_Tuple2(
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Firebase$Firestore$Error,
						$author$project$Firebase$Firestore$DecodeError(decodeError),
						$elm$json$Json$Decode$errorToString(decodeError)),
					errors),
				state);
		}
	});
var $author$project$Data$Chat$Message$Message = F6(
	function (id, sender, partnerID, content, kind, createdAt) {
		return {cl: content, cm: createdAt, lK: id, ho: kind, u: partnerID, iY: sender};
	});
var $author$project$Data$Chat$Message$AskForPrivatePhoto = 2;
var $author$project$Data$Chat$Message$Image = 1;
var $author$project$Data$Chat$Message$Text = 0;
var $author$project$Data$Chat$Message$messageKindDecoder = function () {
	var convert = function (str) {
		switch (str) {
			case 'Text':
				return $elm$json$Json$Decode$succeed(0);
			case 'Image':
				return $elm$json$Json$Decode$succeed(1);
			case 'AskForPrivatePhoto':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid message kind: ' + str);
		}
	};
	return A2($elm$json$Json$Decode$andThen, convert, $elm$json$Json$Decode$string);
}();
var $author$project$Data$Chat$Message$FromPartner = 0;
var $author$project$Data$Chat$Message$FromUser = 1;
var $author$project$Data$Chat$Message$senderDecoder = function (_v0) {
	var uid = _v0.eX;
	var convert = function (receiverID) {
		return _Utils_eq(receiverID, uid) ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$succeed(1);
	};
	return A2($elm$json$Json$Decode$andThen, convert, $elm$json$Json$Decode$string);
};
var $author$project$Data$Chat$Message$messageDecoder = F2(
	function (user, id) {
		var partnerField = function () {
			var _v0 = user.ho;
			if (_v0 === 1) {
				return 'sponsorID';
			} else {
				return 'sugarID';
			}
		}();
		return A7(
			$elm$json$Json$Decode$map6,
			$author$project$Data$Chat$Message$Message,
			$elm$json$Json$Decode$succeed(id),
			A2(
				$elm$json$Json$Decode$field,
				'receiverID',
				$author$project$Data$Chat$Message$senderDecoder(user)),
			A2($elm$json$Json$Decode$field, partnerField, $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'content', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'kind', $author$project$Data$Chat$Message$messageKindDecoder),
			A2($elm$json$Json$Decode$field, 'createdAt', $author$project$Firebase$Firestore$timestampDecoder));
	});
var $author$project$Data$Chat$Message$decode = F2(
	function (_v0, _v1) {
		var user = _v0.W;
		var id = _v1.lK;
		var data = _v1.kH;
		return A2(
			$elm$json$Json$Decode$decodeString,
			A2($author$project$Data$Chat$Message$messageDecoder, user, id),
			data);
	});
var $author$project$Data$Chat$Message$CanLoadMore = 1;
var $author$project$Data$Chat$Message$LoadedAll = 2;
var $author$project$Data$Chat$Message$updateLoadStatus = F3(
	function (partnerID, loadedDocsCount, state) {
		return (_Utils_cmp(loadedDocsCount, $author$project$Data$Chat$Message$loadLimit) < 0) ? _Utils_update(
			state,
			{
				H: A3($elm$core$Dict$insert, partnerID, 2, state.H)
			}) : _Utils_update(
			state,
			{
				H: A3($elm$core$Dict$insert, partnerID, 1, state.H)
			});
	});
var $author$project$Data$Chat$Message$addLoadedMessages = F3(
	function (partnerID, json, state) {
		var _v0 = $author$project$Firebase$Firestore$decodeQuerySnapshot(json);
		if (_v0.$ === 1) {
			var error = _v0.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[error]),
				state);
		} else {
			var size = _v0.a.ns;
			var docs = _v0.a.kV;
			return A2(
				$elm$core$Tuple$mapSecond,
				A2($author$project$Data$Chat$Message$updateLoadStatus, partnerID, size),
				A3(
					$elm$core$List$foldl,
					$author$project$Data$Chat$Message$addRemoteMessage,
					_Utils_Tuple2(_List_Nil, state),
					A2(
						$elm$core$List$map,
						$author$project$Data$Chat$Message$decode(state),
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Basics$not,
									function ($) {
										return $.gR;
									}),
								function ($) {
									return $.me;
								}),
							docs))));
		}
	});
var $author$project$Data$Chat$Message$onLoadInitialMessages = $author$project$Data$Chat$Message$addLoadedMessages;
var $author$project$Data$Chat$onLoadInitialMessages = F3(
	function (partnerID, json, _v0) {
		var state = _v0;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (message) {
				return _Utils_update(
					state,
					{h: message});
			},
			A3($author$project$Data$Chat$Message$onLoadInitialMessages, partnerID, json, state.h));
	});
var $author$project$Model$Chat$onLoadInitialMessages = F4(
	function (partnerID, json, authState, appModel) {
		var _v0 = A3($author$project$Data$Chat$onLoadInitialMessages, partnerID, json, authState.km.i8);
		var errors = _v0.a;
		var chatState = _v0.b;
		var appModelWithErrors = A2($author$project$Model$Chat$mapDbErrors, errors, appModel);
		var _v1 = authState;
		var chat = _v1.km;
		return _Utils_Tuple2(
			_Utils_update(
				appModelWithErrors,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								km: _Utils_update(
									chat,
									{i8: chatState})
							}))
				}),
			$author$project$Model$Chat$scrollToBottom);
	});
var $author$project$Type$Chat$Block = function (a) {
	return {$: 23, a: a};
};
var $author$project$Type$Chat$Report = function (a) {
	return {$: 22, a: a};
};
var $author$project$Model$Chat$customChannel = {
	fv: function (partnerID) {
		return 'blockRoom/' + partnerID;
	},
	ka: function (partnerID) {
		return 'blockUser/' + partnerID;
	},
	f5: function (userID) {
		return 'createReportUserChat/' + userID;
	},
	n2: function (partnerID) {
		return 'unBlockRoom/' + partnerID;
	}
};
var $author$project$Helpers$BlockUser$Types$Init = {$: 0};
var $author$project$Helpers$BlockUser$Types$Popup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Helpers$BlockUser$Model$initialModel = F2(
	function (channelID, blockProfileParams) {
		return _Utils_Tuple2(
			{
				aJ: blockProfileParams,
				aa: channelID,
				bN: $author$project$CustomPopup$initialModel(
					{fe: '000000', f_: $author$project$View$Theme$images.mV, eq: 'PopupForBlockUser', jr: $author$project$Helpers$BlockUser$Types$Popup}),
				eQ: $author$project$Helpers$BlockUser$Types$Init
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$Chat$initialBlockUser = function (chatState) {
	var _v0 = $author$project$Data$Chat$getCurrentRoom(chatState);
	if (!_v0.$) {
		var partner = _v0.a.q;
		var params = {cc: partner.cc, eX: partner.eX, dh: partner.dh};
		var blockUserChannelID = {j8: $author$project$Model$Chat$customChannel.fv, ka: $author$project$Model$Chat$customChannel.ka};
		var _v1 = A2($author$project$Helpers$BlockUser$Model$initialModel, blockUserChannelID, params);
		var blockUser = _v1.a;
		var blockUserCmd = _v1.b;
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(blockUser),
			blockUserCmd);
	} else {
		return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Model$Chat$initialReportUser = F2(
	function (user, chatState) {
		var _v0 = $author$project$Data$Chat$getCurrentRoom(chatState);
		if (!_v0.$) {
			var partner = _v0.a.q;
			var reporter = {eX: user.eX, dh: user.ds};
			var reported = {eX: partner.eX, dh: partner.dh};
			var _v1 = A3($author$project$Helpers$ReportUser$Model$initialModel, $author$project$Model$Chat$customChannel.f5, reporter, reported);
			var reportUser = _v1.a;
			var reportUserCmd = _v1.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(reportUser),
				reportUserCmd);
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Chat$LoadRoomsOnTallViewport = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Chat$Room$list = function (_v0) {
	var rooms = _v0.ao;
	return $elm$core$Dict$values(rooms);
};
var $author$project$Data$Chat$Room$getOldest = function (state) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ai;
				},
				$elm$time$Time$posixToMillis),
			$author$project$Data$Chat$Room$list(state)));
};
var $author$project$Data$Chat$getLastRoomPartnerID = function (_v0) {
	var state = _v0;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.q;
			},
			function ($) {
				return $.eX;
			}),
		$author$project$Data$Chat$Room$getOldest(state.a));
};
var $author$project$Model$Chat$loadRoomsOnTallViewport = function (chatState) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Cmd$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Task$attempt(
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
					$author$project$Type$Chat$LoadRoomsOnTallViewport)),
			A2(
				$elm$core$Maybe$map,
				$elm$browser$Browser$Dom$getElement,
				$author$project$Data$Chat$getLastRoomPartnerID(chatState))));
};
var $author$project$Data$Chat$Room$addRemoteRoom = F2(
	function (decodedRoom, _v0) {
		var addedRooms = _v0.a;
		var errors = _v0.b;
		var roomState = _v0.c;
		if (!decodedRoom.$) {
			var room = decodedRoom.a;
			return _Utils_Tuple3(
				A2($elm$core$List$cons, room, addedRooms),
				errors,
				A2($author$project$Data$Chat$Room$insert, room, roomState));
		} else {
			var decodeError = decodedRoom.a;
			return _Utils_Tuple3(
				addedRooms,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Firebase$Firestore$Error,
						$author$project$Firebase$Firestore$DecodeError(decodeError),
						$elm$json$Json$Decode$errorToString(decodeError)),
					errors),
				roomState);
		}
	});
var $author$project$Data$Chat$Room$addRemoteRoomsToState = F2(
	function (docs, state) {
		return A3(
			$elm$core$List$foldl,
			$author$project$Data$Chat$Room$addRemoteRoom,
			_Utils_Tuple3(_List_Nil, _List_Nil, state),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Data$Chat$Room$decode(state),
					function ($) {
						return $.kH;
					}),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$not,
							function ($) {
								return $.gR;
							}),
						function ($) {
							return $.me;
						}),
					docs)));
	});
var $author$project$Data$Chat$Room$LoadedAll = {$: 2};
var $author$project$Data$Chat$Room$updateLoadStatus = F3(
	function (loadedDocsCount, addedRooms, state) {
		if (_Utils_cmp(loadedDocsCount, $author$project$Data$Chat$Room$loadLimit) < 0) {
			return _Utils_update(
				state,
				{T: $author$project$Data$Chat$Room$LoadedAll});
		} else {
			var lastMessageCreatedAtFromFirestore = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ai;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.ai;
							},
							$elm$time$Time$posixToMillis),
						addedRooms)));
			if (!lastMessageCreatedAtFromFirestore.$) {
				var createdAt = lastMessageCreatedAtFromFirestore.a;
				return _Utils_update(
					state,
					{
						T: $author$project$Data$Chat$Room$CanLoadMore(createdAt)
					});
			} else {
				return _Utils_update(
					state,
					{T: $author$project$Data$Chat$Room$LoadedAll});
			}
		}
	});
var $author$project$Data$Chat$Room$addRemoteRoomsWithLoadStatus = F2(
	function (json, state) {
		var _v0 = $author$project$Firebase$Firestore$decodeQuerySnapshot(json);
		if (_v0.$ === 1) {
			var error = _v0.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[error]),
				state);
		} else {
			var size = _v0.a.ns;
			var docs = _v0.a.kV;
			var _v1 = A2($author$project$Data$Chat$Room$addRemoteRoomsToState, docs, state);
			var addedRooms = _v1.a;
			var errors = _v1.b;
			var updatedState = _v1.c;
			return _Utils_Tuple2(
				errors,
				A3($author$project$Data$Chat$Room$updateLoadStatus, size, addedRooms, updatedState));
		}
	});
var $author$project$Data$Chat$Room$onLoadInitialRooms = $author$project$Data$Chat$Room$addRemoteRoomsWithLoadStatus;
var $author$project$Data$Chat$onLoadInitialRooms = F2(
	function (json, _v0) {
		var state = _v0;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (room) {
				return _Utils_update(
					state,
					{a: room});
			},
			A2($author$project$Data$Chat$Room$onLoadInitialRooms, json, state.a));
	});
var $author$project$Data$Chat$Room$getNewest = function (state) {
	return $elm$core$List$head(
		$elm$core$List$reverse(
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ai;
					},
					$elm$time$Time$posixToMillis),
				$author$project$Data$Chat$Room$list(state))));
};
var $author$project$Data$Chat$setCurrentRoomToNewest = F2(
	function (currentTime, _v0) {
		var state = _v0;
		return function (room) {
			return A3($author$project$Data$Chat$setCurrentRoom, room, currentTime, state);
		}(
			$author$project$Data$Chat$Room$getNewest(state.a));
	});
var $author$project$Model$Chat$onLoadInitialRooms = F3(
	function (json, authState, appModel) {
		var _v0 = authState;
		var chat = _v0.km;
		var _v1 = A2($author$project$Data$Chat$onLoadInitialRooms, json, chat.i8);
		var errors = _v1.a;
		var chatState = _v1.b;
		var _v2 = ($author$project$NativeBridge$isDesktop(appModel.kQ) && _Utils_eq(
			$author$project$Data$Chat$getCurrentRoom(chatState),
			$elm$core$Maybe$Nothing)) ? A2($author$project$Data$Chat$setCurrentRoomToNewest, appModel.kG, chatState) : _Utils_Tuple2(chatState, $elm$core$Platform$Cmd$none);
		var updatedChatState = _v2.a;
		var setCurrentRoomCmd = _v2.b;
		var _v3 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
					$author$project$Type$Chat$Report)),
			A2($author$project$Model$Chat$initialReportUser, authState.j2, updatedChatState));
		var reportUser = _v3.a;
		var reportUserCmd = _v3.b;
		var updatedAppModel = A2($author$project$Model$Chat$mapDbErrors, errors, appModel);
		var _v4 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
					$author$project$Type$Chat$Block)),
			$author$project$Model$Chat$initialBlockUser(updatedChatState));
		var blockUser = _v4.a;
		var blockUserCmd = _v4.b;
		return _Utils_Tuple2(
			_Utils_update(
				updatedAppModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								km: _Utils_update(
									chat,
									{ka: blockUser, aA: reportUser, i8: updatedChatState})
							}))
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Model$Chat$loadRoomsOnTallViewport(updatedChatState),
						setCurrentRoomCmd,
						reportUserCmd,
						blockUserCmd
					])));
	});
var $author$project$Type$Chat$LoadMessagesAndScroll = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Model$Chat$onLoadMessages = F4(
	function (partnerID, json, _v0, appModel) {
		return _Utils_Tuple2(
			appModel,
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
					A2($author$project$Type$Chat$LoadMessagesAndScroll, json, partnerID)),
				$elm$browser$Browser$Dom$getViewportOf($author$project$Model$Chat$pageChatMessageID)));
	});
var $author$project$Data$Chat$Room$onLoadRooms = $author$project$Data$Chat$Room$addRemoteRoomsWithLoadStatus;
var $author$project$Data$Chat$onLoadRooms = F2(
	function (json, _v0) {
		var state = _v0;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (room) {
				return _Utils_update(
					state,
					{a: room});
			},
			A2($author$project$Data$Chat$Room$onLoadRooms, json, state.a));
	});
var $author$project$Model$Chat$onLoadRooms = F3(
	function (json, authState, appModel) {
		var _v0 = A2($author$project$Data$Chat$onLoadRooms, json, authState.km.i8);
		var errors = _v0.a;
		var chatState = _v0.b;
		var updatedAppModel = A2($author$project$Model$Chat$mapDbErrors, errors, appModel);
		var _v1 = authState;
		var chat = _v1.km;
		return _Utils_Tuple2(
			_Utils_update(
				updatedAppModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								km: _Utils_update(
									chat,
									{i8: chatState})
							}))
				}),
			$author$project$Model$Chat$loadRoomsOnTallViewport(chatState));
	});
var $author$project$Data$Chat$Partner$decodeOnlineStatus = function (json) {
	var decodeOnlineStatusField = A2($elm$json$Json$Decode$field, 'onlineStatus', $author$project$Core$Data$Profile$OnlineStatus$decoder);
	return A2(
		$elm$core$Result$withDefault,
		1,
		A2($elm$json$Json$Decode$decodeString, decodeOnlineStatusField, json));
};
var $author$project$Data$Chat$Room$onPartnerOnlineStatus = F3(
	function (partnerID, json, state) {
		var _v0 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
		if (_v0.$ === 1) {
			var error = _v0.a;
			return $elm$core$Result$Err(error);
		} else {
			var data = _v0.a.kH;
			return $elm$core$Result$Ok(
				_Utils_update(
					state,
					{
						bK: A3(
							$elm$core$Dict$insert,
							partnerID,
							$author$project$Data$Chat$Partner$decodeOnlineStatus(data),
							state.bK)
					}));
		}
	});
var $author$project$Data$Chat$onPartnerOnlineStatus = F3(
	function (partnerID, json, _v0) {
		var state = _v0;
		return A2(
			$elm$core$Result$map,
			function (room) {
				return _Utils_update(
					state,
					{a: room});
			},
			A3($author$project$Data$Chat$Room$onPartnerOnlineStatus, partnerID, json, state.a));
	});
var $author$project$Model$Chat$onPartnerOnlineStatus = F4(
	function (partnerID, json, authState, appModel) {
		var _v0 = authState;
		var chat = _v0.km;
		var _v1 = A3($author$project$Data$Chat$onPartnerOnlineStatus, partnerID, json, chat.i8);
		if (_v1.$ === 1) {
			var error = _v1.a;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						b8: A2(
							$author$project$Data$Alert$addFailure,
							$author$project$Firebase$Firestore$getErrorMessage(error),
							appModel.b8)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var chatState = _v1.a;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									km: _Utils_update(
										chat,
										{i8: chatState})
								}))
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Chat$Message$onSubNewMessages = F3(
	function (_v0, json, state) {
		var _v1 = $author$project$Firebase$Firestore$decodeQuerySnapshot(json);
		if (_v1.$ === 1) {
			var error = _v1.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[error]),
				state);
		} else {
			var docs = _v1.a.kV;
			return A3(
				$elm$core$List$foldl,
				$author$project$Data$Chat$Message$addRemoteMessage,
				_Utils_Tuple2(_List_Nil, state),
				A2(
					$elm$core$List$map,
					$author$project$Data$Chat$Message$decode(state),
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								function ($) {
									return $.gR;
								}),
							function ($) {
								return $.me;
							}),
						docs)));
		}
	});
var $author$project$Data$Chat$onSubNewMessages = F3(
	function (partnerID, json, _v0) {
		var state = _v0;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (message) {
				return _Utils_update(
					state,
					{h: message});
			},
			A3($author$project$Data$Chat$Message$onSubNewMessages, partnerID, json, state.h));
	});
var $author$project$Model$Chat$onSubNewMessages = F4(
	function (partnerID, json, authState, appModel) {
		var _v0 = authState;
		var chat = _v0.km;
		var _v1 = A3($author$project$Data$Chat$onSubNewMessages, partnerID, json, chat.i8);
		var errors = _v1.a;
		var chatState = _v1.b;
		var appModelWithErrors = A2($author$project$Model$Chat$mapDbErrors, errors, appModel);
		var updatedChat = _Utils_update(
			chat,
			{i8: chatState});
		return _Utils_Tuple2(
			_Utils_update(
				appModelWithErrors,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{km: updatedChat}))
				}),
			A2($author$project$Model$Chat$scrollToBottomIfUserIsAtBottom, partnerID, updatedChat));
	});
var $author$project$Data$Chat$Partner$updateLastRead = F2(
	function (lastRead, partner) {
		return _Utils_update(
			partner,
			{aV: lastRead});
	});
var $author$project$Data$Chat$Room$updatePartnerLastRead = F3(
	function (lastRead, partnerID, state) {
		var _v0 = A2($author$project$Data$Chat$Room$get, partnerID, state);
		if (_v0.$ === 1) {
			return state;
		} else {
			var room = _v0.a;
			return A2(
				$author$project$Data$Chat$Room$insert,
				_Utils_update(
					room,
					{
						q: A2($author$project$Data$Chat$Partner$updateLastRead, lastRead, room.q)
					}),
				state);
		}
	});
var $author$project$Data$Chat$Room$updateRemotePartnerLastRead = F2(
	function (decodedRoom, _v0) {
		var errors = _v0.a;
		var roomState = _v0.b;
		if (decodedRoom.$ === 1) {
			var decodeError = decodedRoom.a;
			return _Utils_Tuple2(
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Firebase$Firestore$Error,
						$author$project$Firebase$Firestore$DecodeError(decodeError),
						$elm$json$Json$Decode$errorToString(decodeError)),
					errors),
				roomState);
		} else {
			var partner = decodedRoom.a.q;
			return _Utils_Tuple2(
				errors,
				A3($author$project$Data$Chat$Room$updatePartnerLastRead, partner.aV, partner.eX, roomState));
		}
	});
var $author$project$Data$Chat$Room$onSubPartnerLastRead = F2(
	function (json, state) {
		var _v0 = $author$project$Firebase$Firestore$decodeQuerySnapshot(json);
		if (_v0.$ === 1) {
			var error = _v0.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[error]),
				state);
		} else {
			var docs = _v0.a.kV;
			return A3(
				$elm$core$List$foldl,
				$author$project$Data$Chat$Room$updateRemotePartnerLastRead,
				_Utils_Tuple2(_List_Nil, state),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Data$Chat$Room$decode(state),
						function ($) {
							return $.kH;
						}),
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								function ($) {
									return $.gR;
								}),
							function ($) {
								return $.me;
							}),
						docs)));
		}
	});
var $author$project$Data$Chat$onSubPartnerLastRead = F2(
	function (json, _v0) {
		var state = _v0;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (room) {
				return _Utils_update(
					state,
					{a: room});
			},
			A2($author$project$Data$Chat$Room$onSubPartnerLastRead, json, state.a));
	});
var $author$project$Model$Chat$onSubPartnerLastRead = F3(
	function (json, authState, appModel) {
		var _v0 = A2($author$project$Data$Chat$onSubPartnerLastRead, json, authState.km.i8);
		var errors = _v0.a;
		var chatState = _v0.b;
		var updatedAppModel = A2($author$project$Model$Chat$mapDbErrors, errors, appModel);
		var _v1 = authState;
		var chat = _v1.km;
		return _Utils_Tuple2(
			_Utils_update(
				updatedAppModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								km: _Utils_update(
									chat,
									{i8: chatState})
							}))
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$Chat$Room$addRemoteRooms = F2(
	function (json, state) {
		var _v0 = $author$project$Firebase$Firestore$decodeQuerySnapshot(json);
		if (_v0.$ === 1) {
			var error = _v0.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[error]),
				state);
		} else {
			var docs = _v0.a.kV;
			var _v1 = A2($author$project$Data$Chat$Room$addRemoteRoomsToState, docs, state);
			var errors = _v1.b;
			var updatedState = _v1.c;
			return _Utils_Tuple2(errors, updatedState);
		}
	});
var $author$project$Data$Chat$Room$onSubUpdatedRooms = F2(
	function (json, state) {
		var _v0 = A2($author$project$Data$Chat$Room$addRemoteRooms, json, state);
		var errors = _v0.a;
		var updatedState = _v0.b;
		var _v1 = updatedState.f8;
		if (_v1.$ === 1) {
			return _Utils_Tuple3(errors, updatedState, $elm$core$Platform$Cmd$none);
		} else {
			var currentRoom = _v1.a;
			return (updatedState.cb === 1) ? function (_v2) {
				var roomState = _v2.a;
				var roomCmd = _v2.b;
				return _Utils_Tuple3(errors, roomState, roomCmd);
			}(
				A3($author$project$Data$Chat$Room$setRemoteRoomAsRead, updatedState.aa.bE, currentRoom, updatedState)) : _Utils_Tuple3(errors, updatedState, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Chat$onSubUpdatedRooms = F2(
	function (json, _v0) {
		var state = _v0;
		return function (_v1) {
			var errors = _v1.a;
			var room = _v1.b;
			var cmd = _v1.c;
			return _Utils_Tuple3(
				errors,
				_Utils_update(
					state,
					{a: room}),
				cmd);
		}(
			A2($author$project$Data$Chat$Room$onSubUpdatedRooms, json, state.a));
	});
var $author$project$Model$Chat$onSubUpdatedRooms = F3(
	function (json, authState, appModel) {
		var _v0 = A2($author$project$Data$Chat$onSubUpdatedRooms, json, authState.km.i8);
		var errors = _v0.a;
		var chatState = _v0.b;
		var chatCmd = _v0.c;
		var updatedAppModel = A2($author$project$Model$Chat$mapDbErrors, errors, appModel);
		var _v1 = authState;
		var chat = _v1.km;
		return _Utils_Tuple2(
			_Utils_update(
				updatedAppModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								km: _Utils_update(
									chat,
									{i8: chatState})
							}))
				}),
			chatCmd);
	});
var $author$project$Firebase$Auth$Delete = {$: 8};
var $author$project$Firebase$Auth$delete = $author$project$Firebase$Auth$send($author$project$Firebase$Auth$Delete);
var $author$project$Model$Deactivate$profileDeactivated = F3(
	function (json, authState, appModel) {
		var model = authState.gc;
		var form = model.ln;
		var _v0 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
		if (!_v0.$) {
			return _Utils_Tuple2(
				appModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Firebase$Auth$delete,
							A2($elm$browser$Browser$Navigation$pushUrl, appModel.bD, $author$project$Data$Route$routeUrl.m1)
						])));
		} else {
			var _v1 = _v0.a;
			var message = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									gc: _Utils_update(
										model,
										{
											dk: $elm$core$Maybe$Just(message),
											ln: _Utils_update(
												form,
												{jc: false})
										})
								}))
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Detail$setFavoriteProfileResult = F3(
	function (userID, authState, model) {
		var _v0 = authState;
		var detail = _v0.gj;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$Detail$mapAppModel,
				authState,
				model,
				_Utils_update(
					detail,
					{
						iw: A3($author$project$Model$Detail$updateFavoriteStatus, userID, 0, detail.iw)
					})),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$Membership$Android$Purchased = 1;
var $author$project$Data$Membership$Android$SubscriptionInformation = F6(
	function (subscriptionCreatedAt, currentSponsorLevel, nextRebillingDate, renewable, downgradeSponsorLevel, status) {
		return {kF: currentSponsorLevel, kX: downgradeSponsorLevel, mt: nextRebillingDate, nb: renewable, eQ: status, nE: subscriptionCreatedAt};
	});
var $author$project$Data$Membership$Mobile$Expired = 1;
var $author$project$Data$Membership$Mobile$Active = 0;
var $author$project$Data$Membership$Mobile$toStatus = function (status) {
	switch (status) {
		case 'Active':
			return $elm$core$Result$Ok(0);
		case 'Expired':
			return $elm$core$Result$Ok(1);
		default:
			return $elm$core$Result$Err('Status field is invalid.');
	}
};
var $author$project$Data$Membership$Mobile$statusDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$Membership$Mobile$toStatus,
		$elm$core$Result$withDefault(1)),
	$elm$json$Json$Decode$string);
var $author$project$Data$Membership$Android$subscriptionInformationDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Data$Membership$Android$SubscriptionInformation,
	A2($elm$json$Json$Decode$field, 'subscriptionCreatedAt', $author$project$Firebase$Firestore$timestampDecoder),
	A2($elm$json$Json$Decode$field, 'currentSponsorLevel', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'nextRebillingDate', $author$project$Firebase$Firestore$timestampDecoder),
	A2($elm$json$Json$Decode$field, 'renewable', $elm$json$Json$Decode$bool),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'downgradeSponsorLevel', $elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'status', $author$project$Data$Membership$Mobile$statusDecoder));
var $author$project$Data$Membership$Android$decodeSubscriptionInformation = function (json) {
	return A2(
		$elm$core$Result$mapError,
		function (decodeError) {
			return A2(
				$author$project$Firebase$Firestore$Error,
				$author$project$Firebase$Firestore$DecodeError(decodeError),
				$elm$json$Json$Decode$errorToString(decodeError));
		},
		A2($elm$json$Json$Decode$decodeString, $author$project$Data$Membership$Android$subscriptionInformationDecoder, json));
};
var $author$project$Data$Membership$Android$decode = function (json) {
	var _v0 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
	if (_v0.$ === 1) {
		var error = _v0.a;
		return $elm$core$Result$Err(error);
	} else {
		var snapshot = _v0.a;
		return snapshot.k3 ? A2(
			$elm$core$Result$map,
			$elm$core$Maybe$Just,
			$author$project$Data$Membership$Android$decodeSubscriptionInformation(snapshot.kH)) : $elm$core$Result$Ok($elm$core$Maybe$Nothing);
	}
};
var $author$project$Model$Membership$Android$syncMembershipResult = F3(
	function (json, authState, appModel) {
		var _v0 = authState.l9;
		if (_v0.$ === 3) {
			var model = _v0.a;
			var _v1 = $author$project$Data$Membership$Android$decode(json);
			if (_v1.$ === 1) {
				var _v2 = _v1.a;
				var message = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							b8: A2($author$project$Data$Alert$addFailure, message, appModel.b8)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var subscriptionInformation = _v1.a;
				var purchaseStatus = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function (_v3) {
							return 1;
						},
						subscriptionInformation));
				var updatedModel = _Utils_update(
					model,
					{
						n: $author$project$Data$Membership$initialApiState(0),
						a$: purchaseStatus,
						je: subscriptionInformation
					});
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										l9: $author$project$Type$Membership$Android(updatedModel)
									}))
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Membership$Ios$Purchased = 1;
var $author$project$Data$Membership$Ios$SubscriptionInformation = F6(
	function (subscriptionCreatedAt, currentSponsorLevel, nextRebillingDate, renewable, downgradeSponsorLevel, status) {
		return {kF: currentSponsorLevel, kX: downgradeSponsorLevel, mt: nextRebillingDate, nb: renewable, eQ: status, nE: subscriptionCreatedAt};
	});
var $author$project$Data$Membership$Ios$subscriptionInformationDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Data$Membership$Ios$SubscriptionInformation,
	A2($elm$json$Json$Decode$field, 'subscriptionCreatedAt', $author$project$Firebase$Firestore$timestampDecoder),
	A2($elm$json$Json$Decode$field, 'currentSponsorLevel', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'nextRebillingDate', $author$project$Firebase$Firestore$timestampDecoder),
	A2($elm$json$Json$Decode$field, 'renewable', $elm$json$Json$Decode$bool),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'downgradeSponsorLevel', $elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'status', $author$project$Data$Membership$Mobile$statusDecoder));
var $author$project$Data$Membership$Ios$decodeSubscriptionInformation = function (json) {
	return A2(
		$elm$core$Result$mapError,
		function (decodeError) {
			return A2(
				$author$project$Firebase$Firestore$Error,
				$author$project$Firebase$Firestore$DecodeError(decodeError),
				$elm$json$Json$Decode$errorToString(decodeError));
		},
		A2($elm$json$Json$Decode$decodeString, $author$project$Data$Membership$Ios$subscriptionInformationDecoder, json));
};
var $author$project$Data$Membership$Ios$decode = function (json) {
	var _v0 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
	if (_v0.$ === 1) {
		var error = _v0.a;
		return $elm$core$Result$Err(error);
	} else {
		var snapshot = _v0.a;
		return snapshot.k3 ? A2(
			$elm$core$Result$map,
			$elm$core$Maybe$Just,
			$author$project$Data$Membership$Ios$decodeSubscriptionInformation(snapshot.kH)) : $elm$core$Result$Ok($elm$core$Maybe$Nothing);
	}
};
var $author$project$Model$Membership$Ios$syncMembershipResult = F3(
	function (json, authState, appModel) {
		var _v0 = authState.l9;
		if (_v0.$ === 2) {
			var model = _v0.a;
			var _v1 = $author$project$Data$Membership$Ios$decode(json);
			if (_v1.$ === 1) {
				var _v2 = _v1.a;
				var message = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							b8: A2($author$project$Data$Alert$addFailure, message, appModel.b8)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var subscriptionInformation = _v1.a;
				var purchaseStatus = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function (_v3) {
							return 1;
						},
						subscriptionInformation));
				var updatedModel = _Utils_update(
					model,
					{
						n: $author$project$Data$Membership$initialApiState(0),
						a$: purchaseStatus,
						je: subscriptionInformation
					});
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										l9: $author$project$Type$Membership$Ios(updatedModel)
									}))
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Membership$Web$SubscriptionInformation = F3(
	function (subscriptionCreatedAt, nextRebillingDate, downgradeSponsorLevel) {
		return {kX: downgradeSponsorLevel, mt: nextRebillingDate, nE: subscriptionCreatedAt};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Data$Membership$Web$subscriptionInformationDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$Membership$Web$SubscriptionInformation,
	A2($elm$json$Json$Decode$field, 'subscriptionCreatedAt', $author$project$Firebase$Firestore$timestampDecoder),
	A2($elm$json$Json$Decode$field, 'nextRebillingDate', $author$project$Firebase$Firestore$timestampDecoder),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'downgradeSponsorLevel', $elm$json$Json$Decode$int)));
var $author$project$Data$Membership$Web$decodeSubscriptionInformation = function (json) {
	return A2(
		$elm$core$Result$mapError,
		function (decodeError) {
			return A2(
				$author$project$Firebase$Firestore$Error,
				$author$project$Firebase$Firestore$DecodeError(decodeError),
				$elm$json$Json$Decode$errorToString(decodeError));
		},
		A2($elm$json$Json$Decode$decodeString, $author$project$Data$Membership$Web$subscriptionInformationDecoder, json));
};
var $author$project$Data$Membership$Web$decode = function (json) {
	var _v0 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
	if (_v0.$ === 1) {
		var error = _v0.a;
		return $elm$core$Result$Err(error);
	} else {
		var snapshot = _v0.a;
		return snapshot.k3 ? A2(
			$elm$core$Result$map,
			$elm$core$Maybe$Just,
			$author$project$Data$Membership$Web$decodeSubscriptionInformation(snapshot.kH)) : $elm$core$Result$Ok($elm$core$Maybe$Nothing);
	}
};
var $author$project$Model$Membership$Web$syncMembershipResult = F3(
	function (json, authState, appModel) {
		var _v0 = authState.l9;
		if (_v0.$ === 1) {
			var model = _v0.a;
			var _v1 = $author$project$Data$Membership$Web$decode(json);
			if (_v1.$ === 1) {
				var _v2 = _v1.a;
				var message = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							b8: A2($author$project$Data$Alert$addFailure, message, appModel.b8)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				if (_v1.a.$ === 1) {
					var _v3 = _v1.a;
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				} else {
					var subscriptionInformation = _v1.a.a;
					var _v4 = subscriptionInformation;
					var nextRebillingDate = _v4.mt;
					var subscriptionCreatedAt = _v4.nE;
					var downgradeSponsorLevel = _v4.kX;
					var sponsorLevel = A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Core$Data$Profile$SponsorLevel$toSponsorLevel, $elm$core$Result$toMaybe),
							downgradeSponsorLevel));
					var updatedModel = _Utils_update(
						model,
						{
							kX: sponsorLevel,
							mt: $elm$core$Maybe$Just(nextRebillingDate),
							nE: $elm$core$Maybe$Just(subscriptionCreatedAt)
						});
					return _Utils_Tuple2(
						_Utils_update(
							appModel,
							{
								j1: $elm$core$Maybe$Just(
									_Utils_update(
										authState,
										{
											l9: $author$project$Type$Membership$Web(updatedModel)
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			}
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Profile$IsSynced = function (a) {
	return {$: 1, a: a};
};
var $author$project$Core$Data$Profile$updateProfile = F2(
	function (channelID, profile) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$updateDoc,
				$author$project$Core$Data$Profile$encode(profile),
				$author$project$Firebase$Firestore$doc('/profiles/' + profile.eX)));
	});
var $author$project$Model$Profile$updatePrivatePhotoNumber = F2(
	function (photoNumber, profile) {
		return A2(
			$author$project$Core$Data$Profile$updateProfile,
			$author$project$Model$Profile$channelIDs.bE,
			_Utils_update(
				profile,
				{cZ: photoNumber}));
	});
var $author$project$Model$Profile$syncMyPrivatePhotos = F3(
	function (json, authState, appModel) {
		var _v0 = authState.iu;
		if (!_v0.$) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var profileModel = _v0.a;
			var _v1 = $author$project$Firebase$Firestore$decodeQuerySnapshot(json);
			if (_v1.$ === 1) {
				var error = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							b8: A2(
								$author$project$Data$Alert$addFailure,
								$author$project$Firebase$Firestore$getErrorMessage(error),
								appModel.b8)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var snapshot = _v1.a;
				var photos = $author$project$Core$Data$Profile$Photo$toPhotos(snapshot);
				var photoNumber = $elm$core$List$length(photos);
				var _v2 = profileModel;
				var profile = _v2.iu;
				var cmd = (!_Utils_eq(profile.cZ, photoNumber)) ? A2($author$project$Model$Profile$updatePrivatePhotoNumber, photoNumber, profile) : $elm$core$Platform$Cmd$none;
				var updatedProfile = (profile.eQ === 2) ? profile : _Utils_update(
					profile,
					{cZ: photoNumber});
				return function (updatedAuthState) {
					return _Utils_Tuple2(
						_Utils_update(
							appModel,
							{
								j1: $elm$core$Maybe$Just(updatedAuthState)
							}),
						cmd);
				}(
					function (updatedProfileModel) {
						return _Utils_update(
							authState,
							{iu: updatedProfileModel});
					}(
						$author$project$Type$Profile$IsSynced(
							_Utils_update(
								profileModel,
								{bR: photos, iu: updatedProfile}))));
			}
		}
	});
var $author$project$Core$Data$Profile$Height$Imperial = 0;
var $author$project$Type$Profile$ComponentMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$Profile$InputCityMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Core$Data$Profile$getPrimaryAndSecondaryLocations = function (locations) {
	_v0$2:
	while (true) {
		if (locations.b) {
			if (locations.b.b) {
				if (!locations.b.b.b) {
					var primaryLocation = locations.a;
					var _v1 = locations.b;
					var secondaryLocation = _v1.a;
					return _Utils_Tuple2(primaryLocation, secondaryLocation);
				} else {
					break _v0$2;
				}
			} else {
				var primaryLocation = locations.a;
				return _Utils_Tuple2(primaryLocation, '');
			}
		} else {
			break _v0$2;
		}
	}
	return _Utils_Tuple2('', '');
};
var $author$project$Model$Profile$initialComponents = function (profile) {
	var _v0 = $author$project$Core$Data$Profile$getPrimaryAndSecondaryLocations(profile.cE);
	var primaryLocationData = _v0.a;
	var secondaryLocationData = _v0.b;
	var _v1 = A3($author$project$Helpers$City$Model$initialModel, 'secondaryLocationID', 'secondaryLocation', secondaryLocationData);
	var secondaryLocation = _v1.a;
	var secondaryLocationAction = _v1.b;
	var _v2 = A3($author$project$Helpers$City$Model$initialModel, 'primaryLocationID', 'primaryLocation', primaryLocationData);
	var primaryLocation = _v2.a;
	var primaryLocationAction = _v2.b;
	return _Utils_Tuple2(
		{bP: primaryLocation, bU: secondaryLocation},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Type$Profile$ComponentMsg,
						$author$project$Type$Profile$InputCityMsg('primaryLocation')),
					primaryLocationAction),
					A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Type$Profile$ComponentMsg,
						$author$project$Type$Profile$InputCityMsg('secondaryLocation')),
					secondaryLocationAction)
				])));
};
var $author$project$Core$Data$Profile$Benefit$benefitsListString = function (benefits) {
	return A2($elm$core$List$map, $author$project$Core$Data$Profile$Benefit$benefitString, benefits);
};
var $author$project$Form$fieldTime = F4(
	function (name, value, validators, form) {
		var field = $author$project$Form$IsTime(
			{
				x: $elm$core$Result$Err(''),
				ba: validators,
				v: value
			});
		return _Utils_update(
			form,
			{
				j: A3($elm$core$Dict$insert, name, field, form.j)
			});
	});
var $author$project$Model$Profile$isLegalAge = F2(
	function (currentTime, time) {
		var now = $elm$time$Time$posixToMillis(currentTime);
		var birthday = $elm$time$Time$posixToMillis(time);
		var isMoreThan18Years = _Utils_cmp(now - birthday, ((((18 * 365) * 24) * 60) * 60) * 1000) > 0;
		return isMoreThan18Years ? $elm$core$Result$Ok(time) : $elm$core$Result$Err('You must be at least 18 years old.');
	});
var $author$project$Form$Validators$isNotEmptyList = function (list) {
	return ($elm$core$List$length(list) > 0) ? $elm$core$Result$Ok(list) : $elm$core$Result$Err('This field cannot be empty');
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$core$String$words = _String_words;
var $author$project$Helpers$Validators$getSugarWords = function (unsantiziedText) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[^a-zA-Z ]'));
	var text = A3(
		$elm$regex$Regex$replace,
		regex,
		function (_v0) {
			return ' ';
		},
		$elm$core$String$toLower(unsantiziedText));
	return A2(
		$elm$core$List$filter,
		function (word) {
			return A2($elm$core$List$member, word, $author$project$Helpers$Validators$allInvalidCombinations);
		},
		$elm$core$String$words(text));
};
var $author$project$Helpers$Validators$noSugarWords = function (string) {
	var _v0 = $author$project$Helpers$Validators$getSugarWords(string);
	if (!_v0.b) {
		return $elm$core$Result$Ok(string);
	} else {
		var sugarWords = _v0;
		return $elm$core$Result$Err(
			'Suggestive keywords are not allowed: ' + A2($elm$core$String$join, ', ', sugarWords));
	}
};
var $author$project$Core$Data$Profile$SponsorLevel$sponsorLevelString = function (sponsorLevel) {
	switch (sponsorLevel) {
		case 0:
			return 'Anyone';
		case 1:
			return 'Bronze';
		case 2:
			return 'Silver';
		case 3:
			return 'Gold';
		case 4:
			return 'Platinum';
		case 5:
			return 'Diamond';
		case 6:
			return 'Star';
		default:
			return 'Ultimate';
	}
};
var $author$project$Core$Data$Profile$WantGender$wantGenderString = function (wantGender) {
	switch (wantGender) {
		case 0:
			return 'Man';
		case 1:
			return 'Woman';
		default:
			return 'Both';
	}
};
var $author$project$Core$Data$Profile$WantRelationship$wantRelationshipsListString = function (wantRelationships) {
	return A2(
		$elm$core$List$map,
		A2($elm$core$Basics$composeR, $author$project$Core$Data$Profile$WantRelationship$wantRelationshipStringReference, $elm$core$Tuple$second),
		wantRelationships);
};
var $author$project$Model$Profile$initialForm = F2(
	function (currentTime, profile) {
		var _v0 = $author$project$Core$Data$Profile$getPrimaryAndSecondaryLocations(profile.cE);
		var primaryLocation = _v0.a;
		var secondaryLocation = _v0.b;
		var fields = _List_fromArray(
			[
				A3(
				$author$project$Form$fieldString,
				'username',
				profile.dh,
				_List_fromArray(
					[$author$project$Form$Validators$validateUsername, $author$project$Helpers$Validators$containsNoSugarWords])),
				A3(
				$author$project$Form$fieldString,
				'email',
				profile.dt,
				_List_fromArray(
					[$author$project$Form$Validators$validateEmail])),
				A3(
				$author$project$Form$fieldString,
				'gender',
				$author$project$Core$Data$Profile$Gender$genderString(profile.bt),
				_List_fromArray(
					[$author$project$Form$Validators$isNotEmpty])),
				A3(
				$author$project$Form$fieldString,
				'wantGender',
				$author$project$Core$Data$Profile$WantGender$wantGenderString(profile.di),
				_List_Nil),
				A3(
				$author$project$Form$fieldString,
				'lifestyleExpectation',
				$author$project$Core$Data$Profile$LifestyleExpectation$lifestyleExpectationString(profile.bz),
				_List_Nil),
				A3(
				$author$project$Form$fieldTime,
				'birthday',
				profile.cf,
				_List_fromArray(
					[
						$author$project$Model$Profile$isLegalAge(currentTime)
					])),
				A3(
				$author$project$Form$fieldString,
				'height',
				$author$project$Core$Data$Profile$Height$heightString(profile.bu),
				_List_fromArray(
					[$author$project$Form$Validators$isNotEmpty])),
				A3(
				$author$project$Form$fieldString,
				'bodyType',
				$author$project$Core$Data$Profile$BodyType$bodyTypeString(profile.bi),
				_List_Nil),
				A3(
				$author$project$Form$fieldString,
				'ethnicity',
				$author$project$Core$Data$Profile$Ethnicity$ethnicityString(profile.bo),
				_List_Nil),
				A3(
				$author$project$Form$fieldString,
				'primaryLocation',
				primaryLocation,
				_List_fromArray(
					[$author$project$Form$Validators$isNotEmpty])),
				A3($author$project$Form$fieldString, 'secondaryLocation', secondaryLocation, _List_Nil),
				A3(
				$author$project$Form$fieldString,
				'headline',
				profile.cy,
				_List_fromArray(
					[$author$project$Form$Validators$isNotEmpty, $author$project$Helpers$Validators$noSugarWords])),
				A3(
				$author$project$Form$fieldString,
				'aboutMe',
				profile.b6,
				_List_fromArray(
					[$author$project$Helpers$Validators$noSugarWords])),
				A3(
				$author$project$Form$fieldString,
				'maritalStatus',
				$author$project$Core$Data$Profile$MaritalStatus$maritalStatusString(profile.bB),
				_List_Nil),
				A3(
				$author$project$Form$fieldListString,
				'wantRelationships',
				$author$project$Core$Data$Profile$WantRelationship$wantRelationshipsListString(profile.b4),
				_List_fromArray(
					[$author$project$Form$Validators$isNotEmptyList])),
				A3(
				$author$project$Form$fieldString,
				'numberOfChildren',
				$author$project$Core$Data$Profile$NumberOfChildren$numberOfChildrenString(profile.bF),
				_List_Nil),
				A3(
				$author$project$Form$fieldString,
				'education',
				$author$project$Core$Data$Profile$Education$educationString(profile.bn),
				_List_Nil),
				A3($author$project$Form$fieldString, 'occupation', profile.cN, _List_Nil),
				A3(
				$author$project$Form$fieldString,
				'smoker',
				$author$project$Core$Data$Profile$Smoker$smokerString(profile.bW),
				_List_Nil),
				A3(
				$author$project$Form$fieldString,
				'drinker',
				$author$project$Core$Data$Profile$Drinker$drinkerString(profile.bm),
				_List_Nil),
				A3(
				$author$project$Form$fieldListString,
				'benefits',
				$author$project$Core$Data$Profile$Benefit$benefitsListString(profile.bg),
				_List_Nil),
				A3(
				$author$project$Form$fieldString,
				'otherBenefit',
				profile.cP,
				_List_fromArray(
					[$author$project$Helpers$Validators$noSugarWords])),
				A3(
				$author$project$Form$fieldString,
				'sponsorLevel',
				$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelString(profile.bY),
				_List_fromArray(
					[$author$project$Form$Validators$isNotEmpty]))
			]);
		return $author$project$Form$validate(
			$author$project$Form$createForm(fields));
	});
var $author$project$Core$Data$Profile$Photo$syncPrivatePhotos = F2(
	function (userID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$onSnapshotCollection(
				$author$project$Firebase$Firestore$collection(
					$author$project$Core$Data$Profile$Photo$privatePhotosPath(userID))));
	});
var $author$project$Core$Data$Profile$Photo$syncPublicPhotos = F2(
	function (userID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$onSnapshotCollection(
				$author$project$Firebase$Firestore$collection(
					$author$project$Core$Data$Profile$Photo$publicPhotosPath(userID))));
	});
var $author$project$Model$Profile$initialSyncedModel = F2(
	function (currentTime, profile) {
		var photoCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$author$project$Core$Data$Profile$Photo$syncPrivatePhotos,
					profile.eX,
					$author$project$Model$Profile$channelIDs.eS('privatePhotos')),
					A2(
					$author$project$Core$Data$Profile$Photo$syncPublicPhotos,
					profile.eX,
					$author$project$Model$Profile$channelIDs.eS('publicPhotos'))
				]));
		var _v0 = $author$project$Model$Profile$initialComponents(profile);
		var components = _v0.a;
		var componentCmds = _v0.b;
		var cmds = $elm$core$Platform$Cmd$batch(
			function () {
				var _v1 = profile.eQ;
				switch (_v1) {
					case 3:
						return _List_fromArray(
							[componentCmds, photoCmds]);
					case 0:
						return _List_fromArray(
							[componentCmds, photoCmds]);
					case 1:
						return _List_fromArray(
							[componentCmds, photoCmds]);
					default:
						return _List_Nil;
				}
			}());
		return _Utils_Tuple2(
			$author$project$Type$Profile$IsSynced(
				{
					ab: components,
					ln: A2($author$project$Model$Profile$initialForm, currentTime, profile),
					cz: 0,
					bR: _List_Nil,
					iu: profile,
					m5: _List_Nil
				}),
			cmds);
	});
var $author$project$Model$Profile$syncMyProfileResult = F3(
	function (json, authState, appModel) {
		var _v0 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
		if (_v0.$ === 1) {
			var error = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						b8: A2(
							$author$project$Data$Alert$addFailure,
							$author$project$Firebase$Firestore$getErrorMessage(error),
							appModel.b8)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var id = _v0.a.lK;
			var data = _v0.a.kH;
			var profile = A4($author$project$Core$Data$Profile$decodeProfile, appModel.kG, authState.j2.ho, id, data);
			if (profile.$ === 1) {
				var error = profile.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							b8: A2(
								$author$project$Data$Alert$addFailure,
								$elm$json$Json$Decode$errorToString(error),
								appModel.b8)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var profile_ = profile.a;
				var _v2 = authState.iu;
				if (!_v2.$) {
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map(
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnProfile)),
						A2(
							$elm$core$Tuple$mapFirst,
							function (updatedAuthState) {
								return _Utils_update(
									appModel,
									{
										j1: $elm$core$Maybe$Just(updatedAuthState)
									});
							},
							A2(
								$elm$core$Tuple$mapFirst,
								function (updatedProfile) {
									return _Utils_update(
										authState,
										{iu: updatedProfile});
								},
								A2($author$project$Model$Profile$initialSyncedModel, appModel.kG, profile_))));
				} else {
					var profileModel = _v2.a;
					return function (updatedAuthState) {
						return _Utils_Tuple2(
							_Utils_update(
								appModel,
								{
									j1: $elm$core$Maybe$Just(updatedAuthState)
								}),
							$elm$core$Platform$Cmd$none);
					}(
						function (updatedProfileModel) {
							return _Utils_update(
								authState,
								{iu: updatedProfileModel});
						}(
							$author$project$Type$Profile$IsSynced(
								_Utils_update(
									profileModel,
									{iu: profile_}))));
				}
			}
		}
	});
var $author$project$Model$Profile$syncMyPublicPhotos = F3(
	function (json, authState, appModel) {
		var _v0 = authState.iu;
		if (!_v0.$) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var profileModel = _v0.a;
			var _v1 = $author$project$Firebase$Firestore$decodeQuerySnapshot(json);
			if (_v1.$ === 1) {
				var error = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							b8: A2(
								$author$project$Data$Alert$addFailure,
								$author$project$Firebase$Firestore$getErrorMessage(error),
								appModel.b8)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var snapshot = _v1.a;
				return function (updatedAuthState) {
					return _Utils_Tuple2(
						_Utils_update(
							appModel,
							{
								j1: $elm$core$Maybe$Just(updatedAuthState)
							}),
						$elm$core$Platform$Cmd$none);
				}(
					function (updatedProfileModel) {
						return _Utils_update(
							authState,
							{iu: updatedProfileModel});
					}(
						$author$project$Type$Profile$IsSynced(
							_Utils_update(
								profileModel,
								{
									m5: $author$project$Core$Data$Profile$Photo$toPhotos(snapshot)
								}))));
			}
		}
	});
var $author$project$Data$ProfileStatus$NotSynced = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$ProfileStatus$get = F2(
	function (userID, statuses) {
		get:
		while (true) {
			if (statuses.b) {
				var status = statuses.a;
				var rest = statuses.b;
				if (_Utils_eq(
					userID,
					$author$project$Data$ProfileStatus$getUserID(status))) {
					return $elm$core$Maybe$Just(status);
				} else {
					var $temp$userID = userID,
						$temp$statuses = rest;
					userID = $temp$userID;
					statuses = $temp$statuses;
					continue get;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Data$ProfileStatus$create = F2(
	function (userIDs, previouseStatuses) {
		return A2(
			$elm$core$List$map,
			function (userID) {
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Data$ProfileStatus$NotSynced(userID),
					A2($author$project$Data$ProfileStatus$get, userID, previouseStatuses));
			},
			userIDs);
	});
var $author$project$Core$Data$Profile$Connect$decodeProfileIDs = function (json) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$core$Result$map,
			$elm$core$List$map(
				function ($) {
					return $.lK;
				}),
			A2(
				$elm$core$Result$map,
				function ($) {
					return $.kV;
				},
				$author$project$Firebase$Firestore$decodeQuerySnapshot(json))));
};
var $author$project$Model$RelatedProfiles$syncRelatedProfilesIDsResult = F4(
	function (connectKindString, json, authState, appModel) {
		var _v0 = $author$project$Core$Data$Profile$Connect$toConnectKindFromDb(connectKindString);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var connectKind = _v0.a;
			var profileIDs = $author$project$Core$Data$Profile$Connect$decodeProfileIDs(json);
			var _v1 = authState;
			var relatedProfiles = _v1.iD;
			var relatedProfileState = A2($author$project$Model$RelatedProfiles$getRelatedProfileState, connectKind, relatedProfiles);
			var profileStatuses = A2(
				$author$project$Data$ProfileStatus$create,
				profileIDs,
				A2($elm$core$Maybe$withDefault, _List_Nil, relatedProfileState.an));
			var updatedRelatedProfileState = _Utils_update(
				relatedProfileState,
				{
					an: $elm$core$Maybe$Just(profileStatuses)
				});
			var updatedModel = function () {
				switch (connectKind) {
					case 0:
						return _Utils_update(
							relatedProfiles,
							{oe: updatedRelatedProfileState});
					case 1:
						return _Utils_update(
							relatedProfiles,
							{li: updatedRelatedProfileState});
					default:
						return _Utils_update(
							relatedProfiles,
							{lh: updatedRelatedProfileState});
				}
			}();
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{iD: updatedModel}))
					}),
				A2($author$project$Model$RelatedProfiles$getProfileCmd, connectKind, updatedModel));
		}
	});
var $author$project$Data$BlockProfile$unblock = F3(
	function (channelID, userID, blockedProfileID) {
		var json = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'blocked',
						$elm$json$Json$Encode$bool(false))
					])));
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$updateDoc,
				json,
				$author$project$Firebase$Firestore$doc('/profiles/' + (userID + ('/blockProfile/' + blockedProfileID)))));
	});
var $author$project$Helpers$UnBlockUser$Model$unBlockChatRoomResult = F4(
	function (json, unBlockUserID, model, authState) {
		var _v0 = model;
		var channelID = _v0.aa;
		var userID = _v0.a9;
		if (_Utils_eq(userID, unBlockUserID)) {
			var _v1 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
			if (!_v1.$) {
				return _Utils_Tuple2(
					model,
					A3(
						$author$project$Data$BlockProfile$unblock,
						channelID.n3(userID),
						authState.j2.eX,
						userID));
			} else {
				var _v2 = _v1.a;
				var message = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eQ: $author$project$Helpers$UnBlockUser$Types$Failure(message)
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Block$unBlockChatRoomResult = F4(
	function (json, userID, authState, appModel) {
		var _v0 = authState.j7.n3;
		if (!_v0.$) {
			var unBlockUser = _v0.a;
			var model = authState.j7;
			var _v1 = A4($author$project$Helpers$UnBlockUser$Model$unBlockChatRoomResult, json, userID, unBlockUser, authState);
			var updatedUnBlockUser = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									j7: _Utils_update(
										model,
										{
											n3: $elm$core$Maybe$Just(updatedUnBlockUser)
										})
								}))
					}),
				cmd);
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Detail$unBlockChatRoomResult = F4(
	function (json, userID, authState, appModel) {
		var _v0 = A2($elm$core$Dict$get, userID, authState.gj.iw);
		if (!_v0.$) {
			var fullProfile = _v0.a;
			var _v1 = fullProfile.j9;
			if (_v1.$ === 2) {
				var unBlockUser = _v1.a;
				var model = authState.gj;
				var _v2 = model;
				var profiles = _v2.iw;
				var _v3 = A4($author$project$Helpers$UnBlockUser$Model$unBlockChatRoomResult, json, userID, unBlockUser, authState);
				var updatedUnBlockUser = _v3.a;
				var cmd = _v3.b;
				var updatedFullProfile = $elm$core$Maybe$map(
					function (fullProfile_) {
						return _Utils_update(
							fullProfile_,
							{
								j9: $author$project$Type$Detail$Blocked(updatedUnBlockUser)
							});
					});
				var updatedProfiles = A3($elm$core$Dict$update, userID, updatedFullProfile, profiles);
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Detail$mapAppModel,
						authState,
						appModel,
						_Utils_update(
							model,
							{iw: updatedProfiles})),
					cmd);
			} else {
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Helpers$UnBlockUser$Types$Success = {$: 2};
var $author$project$Helpers$UnBlockUser$Model$removeBlockProfile = F2(
	function (userID, profileState) {
		switch (profileState.$) {
			case 0:
				return $author$project$Type$Block$Init;
			case 1:
				return $author$project$Type$Block$Loading;
			case 2:
				var profiles = profileState.a;
				return $author$project$Type$Block$Loaded(
					A2(
						$elm$core$List$filter,
						function (_v1) {
							var uid = _v1.eX;
							return !_Utils_eq(uid, userID);
						},
						profiles));
			case 3:
				var profiles = profileState.a;
				return $author$project$Type$Block$LoadingMore(
					A2(
						$elm$core$List$filter,
						function (_v2) {
							var uid = _v2.eX;
							return !_Utils_eq(uid, userID);
						},
						profiles));
			default:
				var profiles = profileState.a;
				return $author$project$Type$Block$NoMore(
					A2(
						$elm$core$List$filter,
						function (_v3) {
							var uid = _v3.eX;
							return !_Utils_eq(uid, userID);
						},
						profiles));
		}
	});
var $author$project$Helpers$UnBlockUser$Model$updateProfileBlockStatus = F2(
	function (userID, profiles) {
		var updatedFullProfile = $elm$core$Maybe$map(
			function (fullProfile_) {
				return _Utils_update(
					fullProfile_,
					{j9: $author$project$Type$Detail$Available});
			});
		return A3($elm$core$Dict$update, userID, updatedFullProfile, profiles);
	});
var $author$project$Data$Chat$isInitRooms = function (_v0) {
	var state = _v0;
	return state.a.lV;
};
var $author$project$Helpers$UnBlockUser$Model$updatedChatState = F2(
	function (json, chatState) {
		var _v0 = _Utils_Tuple2(
			$author$project$Data$Chat$isInitRooms(chatState),
			json);
		if (_v0.a && (!_v0.b.$)) {
			var chatRoomJson = _v0.b.a;
			return A2(
				$elm$core$Maybe$withDefault,
				chatState,
				$elm$core$Result$toMaybe(
					A2($author$project$Data$Chat$onGetRemoteRoom, chatRoomJson, chatState)));
		} else {
			return chatState;
		}
	});
var $author$project$Helpers$UnBlockUser$Model$unBlockUserResult = F5(
	function (json, unBlockUserID, model, authState, appModel) {
		var _v0 = model;
		var userID = _v0.a9;
		var chatRoomJson = _v0.$7;
		if (_Utils_eq(userID, unBlockUserID)) {
			var _v1 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
			if (!_v1.$) {
				var _v2 = authState;
				var detail = _v2.gj;
				var block = _v2.j7;
				var chat = _v2.km;
				var updatedAppModel = _Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									j7: _Utils_update(
										block,
										{
											iv: A2($author$project$Helpers$UnBlockUser$Model$removeBlockProfile, userID, block.iv)
										}),
									km: _Utils_update(
										chat,
										{
											i8: A2($author$project$Helpers$UnBlockUser$Model$updatedChatState, chatRoomJson, chat.i8)
										}),
									gj: _Utils_update(
										detail,
										{
											iw: A2($author$project$Helpers$UnBlockUser$Model$updateProfileBlockStatus, userID, detail.iw)
										})
								}))
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eQ: $author$project$Helpers$UnBlockUser$Types$Success}),
					updatedAppModel);
			} else {
				var _v3 = _v1.a;
				var message = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eQ: $author$project$Helpers$UnBlockUser$Types$Failure(message)
						}),
					appModel);
			}
		} else {
			return _Utils_Tuple2(model, appModel);
		}
	});
var $author$project$Model$Block$unBlockUserResult = F4(
	function (json, userID, authState, appModel) {
		var _v0 = authState.j7.n3;
		if (!_v0.$) {
			var unBlockUser = _v0.a;
			var _v1 = A5($author$project$Helpers$UnBlockUser$Model$unBlockUserResult, json, userID, unBlockUser, authState, appModel);
			var updatedUnBlockUser = _v1.a;
			var updatedAppModel = _v1.b;
			var updatedAuthState = A2($elm$core$Maybe$withDefault, authState, updatedAppModel.j1);
			var model = updatedAuthState.j7;
			return _Utils_Tuple2(
				_Utils_update(
					updatedAppModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								updatedAuthState,
								{
									j7: _Utils_update(
										model,
										{
											n3: $elm$core$Maybe$Just(updatedUnBlockUser)
										})
								}))
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Detail$UnBlockSucessfully = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Detail$unBlockUserResult = F4(
	function (json, userID, authState, appModel) {
		var _v0 = A2($elm$core$Dict$get, userID, authState.gj.iw);
		if (!_v0.$) {
			var fullProfile = _v0.a;
			var _v1 = fullProfile.j9;
			if (_v1.$ === 2) {
				var unBlockUser = _v1.a;
				var _v2 = A5($author$project$Helpers$UnBlockUser$Model$unBlockUserResult, json, userID, unBlockUser, authState, appModel);
				var updatedUnBlockUser = _v2.a;
				var updatedAppModel = _v2.b;
				var updatedAuthState = A2($elm$core$Maybe$withDefault, authState, updatedAppModel.j1);
				var model = updatedAuthState.gj;
				var updatedFullProfile = _Utils_eq(updatedUnBlockUser.eQ, $author$project$Helpers$UnBlockUser$Types$Success) ? $elm$core$Maybe$map(
					function (fullProfile_) {
						return _Utils_update(
							fullProfile_,
							{
								j9: $author$project$Type$Detail$UnBlockSucessfully(updatedUnBlockUser)
							});
					}) : $elm$core$Maybe$map(
					function (fullProfile_) {
						return _Utils_update(
							fullProfile_,
							{
								j9: $author$project$Type$Detail$Blocked(updatedUnBlockUser)
							});
					});
				var _v3 = model;
				var profiles = _v3.iw;
				var updatedProfiles = A3($elm$core$Dict$update, userID, updatedFullProfile, profiles);
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Detail$mapAppModel,
						updatedAuthState,
						updatedAppModel,
						_Utils_update(
							model,
							{iw: updatedProfiles})),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Alert$Success = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Alert$addSuccess = F2(
	function (text, alerts) {
		return A2(
			$author$project$Data$Alert$addAlert,
			$author$project$Data$Alert$Success(text),
			alerts);
	});
var $author$project$Model$Profile$updateProfileResponse = F3(
	function (json, authState, appModel) {
		var _v0 = authState.iu;
		if (!_v0.$) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var profileModel = _v0.a;
			var _v1 = profileModel;
			var form = _v1.ln;
			var updatedAppModel = _Utils_update(
				appModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								iu: $author$project$Type$Profile$IsSynced(
									_Utils_update(
										profileModel,
										{
											ln: _Utils_update(
												form,
												{jc: false})
										}))
							}))
				});
			var _v2 = $author$project$Firebase$Firestore$decodeDocumentSnapshot(json);
			if (_v2.$ === 1) {
				var error = _v2.a;
				return _Utils_Tuple2(
					_Utils_update(
						updatedAppModel,
						{
							b8: A2(
								$author$project$Data$Alert$addFailure,
								$author$project$Firebase$Firestore$getErrorMessage(error),
								appModel.b8)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						updatedAppModel,
						{
							b8: A2($author$project$Data$Alert$addSuccess, 'Profile updated successfully!', appModel.b8)
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Model$Channel$updateFromFirestore = F2(
	function (_v0, model) {
		var queryID = _v0.a;
		var json = _v0.b;
		var channelID = A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			A2($elm$core$String$split, '/', queryID));
		_v1$47:
		while (true) {
			if (channelID.b) {
				switch (channelID.a) {
					case 'onBundleIDChange':
						if (!channelID.b.b) {
							return _Utils_Tuple2(
								model,
								A4($author$project$Data$BundleID$handle, model.n8, model.ki, model.kQ, json));
						} else {
							break _v1$47;
						}
					case 'onCreateDbUser':
						if (channelID.b.b) {
							var _v2 = channelID.b;
							var uid = _v2.a;
							return A2($author$project$Model$Register$onCreateDbUser, uid, model);
						} else {
							break _v1$47;
						}
					case 'deactivateProfile':
						if (!channelID.b.b) {
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								$author$project$Model$Deactivate$profileDeactivated(json));
						} else {
							break _v1$47;
						}
					case 'checkFavoriteStatusResult':
						if (channelID.b.b) {
							var _v3 = channelID.b;
							var userID = _v3.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Detail$checkFavoriteStatusResult, userID, json));
						} else {
							break _v1$47;
						}
					case 'setFavoriteProfile':
						if (channelID.b.b) {
							var _v4 = channelID.b;
							var userID = _v4.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								$author$project$Model$Detail$setFavoriteProfileResult(userID));
						} else {
							break _v1$47;
						}
					case 'deleteFavoriteProfile':
						if (channelID.b.b) {
							var _v5 = channelID.b;
							var userID = _v5.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								$author$project$Model$Detail$deleteFavoriteProfileResult(userID));
						} else {
							break _v1$47;
						}
					case 'getProfileResult':
						if (!channelID.b.b) {
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								$author$project$Model$Detail$getProfileResult(json));
						} else {
							break _v1$47;
						}
					case 'getProfilePublicPhotosResult':
						if (channelID.b.b) {
							var _v6 = channelID.b;
							var userID = _v6.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Detail$getProfilePublicPhotosResult, userID, json));
						} else {
							break _v1$47;
						}
					case 'getProfilePrivatePhotosResult':
						if (channelID.b.b) {
							var _v7 = channelID.b;
							var userID = _v7.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Detail$getProfilePrivatePhotosResult, userID, json));
						} else {
							break _v1$47;
						}
					case 'createReportUserDetail':
						if (channelID.b.b) {
							var _v8 = channelID.b;
							var userID = _v8.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Detail$createReportResult, userID, json));
						} else {
							break _v1$47;
						}
					case 'getBlockStatus':
						if (channelID.b.b) {
							var _v9 = channelID.b;
							var userID = _v9.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Detail$getBlockStatusResult, userID, json));
						} else {
							break _v1$47;
						}
					case 'getChatRoomAtDetail':
						if (channelID.b.b) {
							var _v10 = channelID.b;
							var userID = _v10.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Detail$getChatRoomResult, json, userID));
						} else {
							break _v1$47;
						}
					case 'unBlockChatRoomAtDetail':
						if (channelID.b.b) {
							var _v11 = channelID.b;
							var userID = _v11.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Detail$unBlockChatRoomResult, json, userID));
						} else {
							break _v1$47;
						}
					case 'unBlockUserAtDetail':
						if (channelID.b.b) {
							var _v12 = channelID.b;
							var userID = _v12.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Detail$unBlockUserResult, json, userID));
						} else {
							break _v1$47;
						}
					case 'syncMyProfileResult':
						if (!channelID.b.b) {
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								$author$project$Model$Profile$syncMyProfileResult(json));
						} else {
							break _v1$47;
						}
					case 'syncMyPhotos':
						if (channelID.b.b && (!channelID.b.b.b)) {
							switch (channelID.b.a) {
								case 'publicPhotos':
									var _v13 = channelID.b;
									return A2(
										$author$project$Model$Channel$onlyHandleWithAuthState,
										model,
										$author$project$Model$Profile$syncMyPublicPhotos(json));
								case 'privatePhotos':
									var _v14 = channelID.b;
									return A2(
										$author$project$Model$Channel$onlyHandleWithAuthState,
										model,
										$author$project$Model$Profile$syncMyPrivatePhotos(json));
								default:
									break _v1$47;
							}
						} else {
							break _v1$47;
						}
					case 'updateProfileResponse':
						if (!channelID.b.b) {
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								$author$project$Model$Profile$updateProfileResponse(json));
						} else {
							break _v1$47;
						}
					case 'searchResult':
						if (!channelID.b.b) {
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Search$handleResult, true, json));
						} else {
							break _v1$47;
						}
					case 'loadMoreSearchResult':
						if (!channelID.b.b) {
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Search$handleResult, false, json));
						} else {
							break _v1$47;
						}
					case 'getRelatedProfileResult':
						if (channelID.b.b && channelID.b.b.b) {
							var _v15 = channelID.b;
							var connectKind = _v15.a;
							var _v16 = _v15.b;
							var userID = _v16.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A3($author$project$Model$RelatedProfiles$getRelatedProfileResult, connectKind, userID, json));
						} else {
							break _v1$47;
						}
					case 'syncRelatedProfilesIDsResult':
						if (channelID.b.b) {
							var _v17 = channelID.b;
							var connectKind = _v17.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$RelatedProfiles$syncRelatedProfilesIDsResult, connectKind, json));
						} else {
							break _v1$47;
						}
					case 'syncWebMembershipResult':
						if (!channelID.b.b) {
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								$author$project$Model$Membership$Web$syncMembershipResult(json));
						} else {
							break _v1$47;
						}
					case 'syncIosMembershipResult':
						if (!channelID.b.b) {
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								$author$project$Model$Membership$Ios$syncMembershipResult(json));
						} else {
							break _v1$47;
						}
					case 'syncAndroidMembershipResult':
						if (!channelID.b.b) {
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								$author$project$Model$Membership$Android$syncMembershipResult(json));
						} else {
							break _v1$47;
						}
					case 'getCategoryList':
						if (!channelID.b.b) {
							return A2($author$project$Model$Content$getCategoryList, json, model);
						} else {
							break _v1$47;
						}
					case 'getPostList':
						if (channelID.b.b) {
							var _v18 = channelID.b;
							var categoryName = _v18.a;
							return A3(
								$author$project$Model$Content$getPostList,
								$elm$core$Maybe$Just(categoryName),
								json,
								model);
						} else {
							return A3($author$project$Model$Content$getPostList, $elm$core$Maybe$Nothing, json, model);
						}
					case 'getPostArticle':
						var rest = channelID.b;
						var articleUrl = A2($elm$core$String$join, '/', rest);
						return A4($author$project$Model$Content$getArticle, 1, articleUrl, json, model);
					case 'getPageArticle':
						var rest = channelID.b;
						var articleUrl = A2($elm$core$String$join, '/', rest);
						return A4($author$project$Model$Content$getArticle, 0, articleUrl, json, model);
					case 'onSubUpdatedRooms':
						return A2(
							$author$project$Model$Channel$onlyHandleWithAuthState,
							model,
							$author$project$Model$Chat$onSubUpdatedRooms(json));
					case 'onSubPartnerLastRead':
						return A2(
							$author$project$Model$Channel$onlyHandleWithAuthState,
							model,
							$author$project$Model$Chat$onSubPartnerLastRead(json));
					case 'onGetRemoteRoom':
						return A2(
							$author$project$Model$Channel$onlyHandleWithAuthState,
							model,
							$author$project$Model$Chat$onGetRemoteRoom(json));
					case 'onLoadInitialRooms':
						return A2(
							$author$project$Model$Channel$onlyHandleWithAuthState,
							model,
							$author$project$Model$Chat$onLoadInitialRooms(json));
					case 'onLoadRooms':
						return A2(
							$author$project$Model$Channel$onlyHandleWithAuthState,
							model,
							$author$project$Model$Chat$onLoadRooms(json));
					case 'onLoadInitialMessages':
						if (channelID.b.b) {
							var _v19 = channelID.b;
							var partnerID = _v19.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Chat$onLoadInitialMessages, partnerID, json));
						} else {
							break _v1$47;
						}
					case 'onSubNewMessages':
						if (channelID.b.b) {
							var _v20 = channelID.b;
							var partnerID = _v20.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Chat$onSubNewMessages, partnerID, json));
						} else {
							break _v1$47;
						}
					case 'onLoadMessages':
						if (channelID.b.b) {
							var _v21 = channelID.b;
							var partnerID = _v21.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Chat$onLoadMessages, partnerID, json));
						} else {
							break _v1$47;
						}
					case 'onPartnerOnlineStatus':
						if (channelID.b.b) {
							var _v22 = channelID.b;
							var partnerID = _v22.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Chat$onPartnerOnlineStatus, partnerID, json));
						} else {
							break _v1$47;
						}
					case 'createReportUserChat':
						if (channelID.b.b) {
							var _v23 = channelID.b;
							var partnerID = _v23.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Chat$createReportResult, partnerID, json));
						} else {
							break _v1$47;
						}
					case 'blockUser':
						if (channelID.b.b) {
							var _v24 = channelID.b;
							var partnerID = _v24.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Chat$blockUserResult, partnerID, json));
						} else {
							break _v1$47;
						}
					case 'blockRoom':
						if (channelID.b.b) {
							var _v25 = channelID.b;
							var partnerID = _v25.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Chat$blockRoomResult, partnerID, json));
						} else {
							break _v1$47;
						}
					case 'getBlockList':
						return A2(
							$author$project$Model$Channel$onlyHandleWithAuthState,
							model,
							$author$project$Model$Block$getBlockListResult(json));
					case 'getChatRoomAtBlock':
						if (channelID.b.b) {
							var _v26 = channelID.b;
							var userID = _v26.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Block$getChatRoomResult, json, userID));
						} else {
							break _v1$47;
						}
					case 'unBlockChatRoomAtBlock':
						if (channelID.b.b) {
							var _v27 = channelID.b;
							var userID = _v27.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Block$unBlockChatRoomResult, json, userID));
						} else {
							break _v1$47;
						}
					case 'unBlockUserAtBlock':
						if (channelID.b.b) {
							var _v28 = channelID.b;
							var userID = _v28.a;
							return A2(
								$author$project$Model$Channel$onlyHandleWithAuthState,
								model,
								A2($author$project$Model$Block$unBlockUserResult, json, userID));
						} else {
							break _v1$47;
						}
					case 'noop':
						if (!channelID.b.b) {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						} else {
							break _v1$47;
						}
					default:
						break _v1$47;
				}
			} else {
				break _v1$47;
			}
		}
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					b8: A2($author$project$Data$Alert$addDanger, 'Invalid channelID: ' + queryID, model.b8)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$Channel$update = F2(
	function (response, model) {
		switch (response.$) {
			case 0:
				var firestoreResponse = response.a;
				return A2($author$project$Model$Channel$updateFromFirestore, firestoreResponse, model);
			case 1:
				var authResponse = response.a;
				return A2($author$project$Model$Channel$updateFromAuth, authResponse, model);
			default:
				var decoderError = response.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b8: A2(
								$author$project$Data$Alert$addDanger,
								'Firebase Error: ' + $elm$json$Json$Decode$errorToString(decoderError),
								model.b8)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$OnForgetPassword = function (a) {
	return {$: 8, a: a};
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Form$isResultOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Form$isFieldValid = function (field) {
	switch (field.$) {
		case 0:
			var field_ = field.a;
			return $author$project$Form$isResultOk(field_.x);
		case 1:
			var field_ = field.a;
			return $author$project$Form$isResultOk(field_.x);
		case 2:
			var field_ = field.a;
			return $author$project$Form$isResultOk(field_.x);
		default:
			var field_ = field.a;
			return $author$project$Form$isResultOk(field_.x);
	}
};
var $author$project$Form$isFormValid = function (form) {
	return A2(
		$elm$core$List$all,
		$author$project$Form$isFieldValid,
		$elm$core$Dict$values(
			$author$project$Form$validate(form).j));
};
var $author$project$Firebase$Auth$SendPasswordResetEmail = function (a) {
	return {$: 2, a: a};
};
var $author$project$Firebase$Auth$sendPasswordResetEmail = function (email) {
	return $author$project$Firebase$Auth$send(
		$author$project$Firebase$Auth$SendPasswordResetEmail(email));
};
var $author$project$Model$ForgetPassword$submitForm = function (model) {
	if ($author$project$Form$isFormValid(model.ln)) {
		var form = model.ln;
		var email = A2($author$project$Form$getRawString, form, 'email');
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dk: $elm$core$Maybe$Nothing,
					ln: _Utils_update(
						form,
						{jc: true}),
					hi: false
				}),
			$author$project$Firebase$Auth$sendPasswordResetEmail(email));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dk: $elm$core$Maybe$Just('Check your form'),
					hi: false
				}),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Form$addOrRemoveListStringItem = F2(
	function (list, item) {
		return A2($elm$core$List$member, item, list) ? A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(item),
			list) : A2(
			$elm$core$List$append,
			list,
			_List_fromArray(
				[item]));
	});
var $author$project$Form$updateOnFieldMsg = F2(
	function (fieldMsg, field) {
		var _v0 = _Utils_Tuple2(field, fieldMsg);
		_v0$4:
		while (true) {
			if (!_v0.a.$) {
				switch (_v0.a.a.$) {
					case 0:
						if (!_v0.b.$) {
							var field_ = _v0.a.a.a;
							var _v1 = _v0.b;
							var value = _v1.b;
							return $elm$core$Maybe$Just(
								$author$project$Form$IsString(
									A2($author$project$Form$updateField, field_, value)));
						} else {
							break _v0$4;
						}
					case 1:
						if (_v0.b.$ === 1) {
							var field_ = _v0.a.a.a;
							return $elm$core$Maybe$Just(
								$author$project$Form$IsBool(
									A2($author$project$Form$updateField, field_, !field_.v)));
						} else {
							break _v0$4;
						}
					case 2:
						if (_v0.b.$ === 2) {
							var field_ = _v0.a.a.a;
							var _v2 = _v0.b;
							var value = _v2.b;
							return $elm$core$Maybe$Just(
								$author$project$Form$IsListString(
									A2(
										$author$project$Form$updateField,
										field_,
										A2($author$project$Form$addOrRemoveListStringItem, field_.v, value))));
						} else {
							break _v0$4;
						}
					default:
						if (_v0.b.$ === 3) {
							var field_ = _v0.a.a.a;
							var _v3 = _v0.b;
							var value = _v3.b;
							return $elm$core$Maybe$Just(
								$author$project$Form$IsTime(
									A2(
										$author$project$Form$updateField,
										field_,
										A2(
											$elm$core$Result$withDefault,
											$elm$time$Time$millisToPosix(0),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(value + 'T01:01:01.000Z')))));
						} else {
							break _v0$4;
						}
				}
			} else {
				break _v0$4;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Form$updateForm = F2(
	function (form, fieldMsg) {
		var update = $author$project$Form$updateOnFieldMsg(fieldMsg);
		switch (fieldMsg.$) {
			case 0:
				var name = fieldMsg.a;
				return _Utils_update(
					form,
					{
						j: A3($elm$core$Dict$update, name, update, form.j)
					});
			case 1:
				var name = fieldMsg.a;
				return _Utils_update(
					form,
					{
						j: A3($elm$core$Dict$update, name, update, form.j)
					});
			case 2:
				var name = fieldMsg.a;
				return _Utils_update(
					form,
					{
						j: A3($elm$core$Dict$update, name, update, form.j)
					});
			default:
				var name = fieldMsg.a;
				return _Utils_update(
					form,
					{
						j: A3($elm$core$Dict$update, name, update, form.j)
					});
		}
	});
var $author$project$Model$ForgetPassword$update = F2(
	function (msg, appModel) {
		var model = appModel.lm;
		var form = model.ln;
		var updatedState = function () {
			if (msg.$ === 1) {
				var fieldMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ln: A2($author$project$Form$updateForm, form, fieldMsg)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return $author$project$Model$ForgetPassword$submitForm(model);
			}
		}();
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Types$OnForgetPassword),
			A2(
				$elm$core$Tuple$mapFirst,
				function (model_) {
					return _Utils_update(
						appModel,
						{lm: model_});
				},
				updatedState));
	});
var $author$project$Types$OnLogin = function (a) {
	return {$: 9, a: a};
};
var $author$project$Firebase$Auth$SignInWithEmailAndPassword = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Firebase$Auth$signInWithEmailAndPassword = F2(
	function (email, password) {
		return $author$project$Firebase$Auth$send(
			A2($author$project$Firebase$Auth$SignInWithEmailAndPassword, email, password));
	});
var $author$project$Model$Login$submitForm = function (model) {
	if ($author$project$Form$isFormValid(model.ln)) {
		var form = model.ln;
		var password = A2($author$project$Form$getRawString, form, 'password');
		var email = A2($author$project$Form$getRawString, form, 'email');
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dk: $elm$core$Maybe$Nothing,
					ln: _Utils_update(
						form,
						{jc: true})
				}),
			A2($author$project$Firebase$Auth$signInWithEmailAndPassword, email, password));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dk: $elm$core$Maybe$Just('Check your form')
				}),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Model$Login$update = F2(
	function (msg, appModel) {
		var model = appModel.l1;
		var updatedState = function () {
			if (!msg.$) {
				var fieldMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ln: A2($author$project$Form$updateForm, model.ln, fieldMsg)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return $author$project$Model$Login$submitForm(model);
			}
		}();
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Types$OnLogin),
			A2(
				$elm$core$Tuple$mapFirst,
				function (model_) {
					return _Utils_update(
						appModel,
						{l1: model_});
				},
				updatedState));
	});
var $author$project$Firebase$Auth$CreateUserWithEmailAndPassword = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Firebase$Auth$createUserWithEmailAndPassword = F2(
	function (email, password) {
		return $author$project$Firebase$Auth$send(
			A2($author$project$Firebase$Auth$CreateUserWithEmailAndPassword, email, password));
	});
var $author$project$Model$Register$submitForm = function (model) {
	var form = model.ln;
	var password = A2($author$project$Form$getRawString, form, 'password');
	var email = A2($author$project$Form$getRawString, form, 'email');
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				dk: $elm$core$Maybe$Nothing,
				ln: _Utils_update(
					form,
					{jc: true})
			}),
		A2($author$project$Firebase$Auth$createUserWithEmailAndPassword, email, password));
};
var $author$project$Model$Register$validateForm = function (model) {
	if ($author$project$Form$isFormValid(model.ln)) {
		var form = model.ln;
		var isWrongPassword = !_Utils_eq(
			A2($author$project$Form$getRawString, form, 'password'),
			A2($author$project$Form$getRawString, form, 'passwordConfirmation'));
		return isWrongPassword ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dk: $elm$core$Maybe$Just('Password and Confirmation Password are not the same')
				}),
			$elm$core$Platform$Cmd$none) : $author$project$Model$Register$submitForm(model);
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dk: $elm$core$Maybe$Just('Your form is incompleted. Please fill up all fields.')
				}),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Model$Register$update = F2(
	function (msg, appModel) {
		var toAppTuple = function (_v1) {
			var model_ = _v1.a;
			var cmd_ = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{na: model_}),
				A2($elm$core$Platform$Cmd$map, $author$project$Types$OnRegister, cmd_));
		};
		var model = appModel.na;
		var form = model.ln;
		switch (msg.$) {
			case 1:
				var fieldMsg = msg.a;
				return toAppTuple(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								dk: $elm$core$Maybe$Nothing,
								ln: A2($author$project$Form$updateForm, form, fieldMsg)
							}),
						$elm$core$Platform$Cmd$none));
			case 0:
				return toAppTuple(
					$author$project$Model$Register$validateForm(model));
			default:
				return toAppTuple(
					_Utils_Tuple2($author$project$Model$Register$initialModel, $elm$core$Platform$Cmd$none));
		}
	});
var $author$project$Model$Block$loadMore = F2(
	function (authState, appModel) {
		var _v0 = authState.j7.iv;
		if (_v0.$ === 2) {
			var profiles = _v0.a;
			var model = authState.j7;
			var updatedAppModel = _Utils_update(
				appModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								j7: _Utils_update(
									model,
									{
										iv: $author$project$Type$Block$LoadingMore(profiles)
									})
							}))
				});
			return _Utils_Tuple2(
				updatedAppModel,
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Types$OnAuth,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnBlock,
						A2($author$project$Model$Block$getProfilesCmd, authState.j7, authState.j2.eX))));
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Block$OnUnBlockUser = function (a) {
	return {$: 2, a: a};
};
var $author$project$CustomPopup$Close = 1;
var $author$project$CustomPopup$closeMsg = 1;
var $author$project$CustomPopup$Open = 0;
var $author$project$CustomPopup$openMsg = 0;
var $author$project$Helpers$UnBlockUser$Types$Submitting = {$: 1};
var $author$project$Data$Chat$getRemoteRoom = F3(
	function (channelID, partnerID, user) {
		return A3($author$project$Data$Chat$Room$getRemoteRoom, channelID, partnerID, user);
	});
var $author$project$Helpers$UnBlockUser$Model$submit = F2(
	function (authState, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{eQ: $author$project$Helpers$UnBlockUser$Types$Submitting}),
			A3(
				$author$project$Data$Chat$getRemoteRoom,
				model.aa.lr(model.a9),
				model.a9,
				authState.j2));
	});
var $author$project$CustomPopup$Closed = 1;
var $author$project$CustomPopup$Noop = 2;
var $author$project$CustomPopup$Opened = 0;
var $author$project$CustomPopup$update = F2(
	function (msg, model) {
		switch (msg) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eQ: 0}),
					A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always(2),
						$elm$browser$Browser$Dom$focus(model.bl.eq)));
			case 1:
				return function (model_) {
					return _Utils_Tuple2(
						_Utils_update(
							model_,
							{eQ: 1}),
						$elm$core$Platform$Cmd$none);
				}(
					$author$project$CustomPopup$initialModel(model.bl));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Helpers$UnBlockUser$Model$update = F3(
	function (msg, authState, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A2($author$project$CustomPopup$update, $author$project$CustomPopup$openMsg, model.bN);
				var popup = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: popup}),
					A2($elm$core$Platform$Cmd$map, $author$project$Helpers$UnBlockUser$Types$Popup, cmd));
			case 1:
				var popupMsg = msg.a;
				var _v2 = A2($author$project$CustomPopup$update, popupMsg, model.bN);
				var popup = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: popup}),
					A2($elm$core$Platform$Cmd$map, $author$project$Helpers$UnBlockUser$Types$Popup, cmd));
			default:
				return A2($author$project$Helpers$UnBlockUser$Model$submit, authState, model);
		}
	});
var $author$project$Model$Block$onUnBlockUser = F3(
	function (unBlockMsg, authState, appModel) {
		if (_Utils_eq(
			unBlockMsg,
			$author$project$Helpers$UnBlockUser$Types$Popup($author$project$CustomPopup$closeMsg))) {
			var model = authState.j7;
			var updatedAppModel = _Utils_update(
				appModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								j7: _Utils_update(
									model,
									{n3: $elm$core$Maybe$Nothing})
							}))
				});
			return _Utils_Tuple2(updatedAppModel, $elm$core$Platform$Cmd$none);
		} else {
			var _v0 = authState.j7.n3;
			if (!_v0.$) {
				var unBlockUser = _v0.a;
				var model = authState.j7;
				var _v1 = A3($author$project$Helpers$UnBlockUser$Model$update, unBlockMsg, authState, unBlockUser);
				var updatedUnBlockUser = _v1.a;
				var cmd = _v1.b;
				var updatedAppModel = _Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									j7: _Utils_update(
										model,
										{
											n3: $elm$core$Maybe$Just(updatedUnBlockUser)
										})
								}))
					});
				return _Utils_Tuple2(
					updatedAppModel,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Types$OnBlock,
							A2($elm$core$Platform$Cmd$map, $author$project$Type$Block$OnUnBlockUser, cmd))));
			} else {
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Helpers$UnBlockUser$Types$OpenPopup = {$: 0};
var $author$project$Model$Block$unblock = F3(
	function (userID, authState, appModel) {
		var model = authState.j7;
		var channelID = {lr: $author$project$Model$Block$channelIDs.lr, n1: $author$project$Model$Block$channelIDs.n1, n3: $author$project$Model$Block$channelIDs.n3};
		var _v0 = function (_v1) {
			var unBlockUser_ = _v1.a;
			var cmd_ = _v1.b;
			return A2(
				$elm$core$Tuple$mapSecond,
				function (cmd__) {
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd_, cmd__]));
				},
				A3($author$project$Helpers$UnBlockUser$Model$update, $author$project$Helpers$UnBlockUser$Types$OpenPopup, authState, unBlockUser_));
		}(
			A2($author$project$Helpers$UnBlockUser$Model$initialModel, channelID, userID));
		var unBlockUser = _v0.a;
		var cmd = _v0.b;
		var updatedAppModel = _Utils_update(
			appModel,
			{
				j1: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							j7: _Utils_update(
								model,
								{
									n3: $elm$core$Maybe$Just(unBlockUser)
								})
						}))
			});
		return _Utils_Tuple2(
			updatedAppModel,
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Types$OnAuth,
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Types$OnBlock,
					A2($elm$core$Platform$Cmd$map, $author$project$Type$Block$OnUnBlockUser, cmd))));
	});
var $author$project$Model$Block$update = F3(
	function (msg, authState, appModel) {
		switch (msg.$) {
			case 0:
				return A2($author$project$Model$Block$loadMore, authState, appModel);
			case 1:
				var userID = msg.a;
				return A3($author$project$Model$Block$unblock, userID, authState, appModel);
			default:
				var unBlockMsg = msg.a;
				return A3($author$project$Model$Block$onUnBlockUser, unBlockMsg, authState, appModel);
		}
	});
var $author$project$Type$Chat$Open = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Emoji$People = 0;
var $author$project$Type$Chat$Popup = function (a) {
	return {$: 9, a: a};
};
var $author$project$Core$Data$Profile$privatePhotoAccessPath = F2(
	function (userID, requesterID) {
		return 'profiles/' + (userID + ('/privatePhotoAccess/' + requesterID));
	});
var $author$project$Core$Data$Profile$grantUserToAccessPrivatePhoto = F3(
	function (channelID, userID, requesterID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$setDoc,
				$author$project$Core$Data$Profile$createdAtJson,
				$author$project$Firebase$Firestore$doc(
					A2($author$project$Core$Data$Profile$privatePhotoAccessPath, userID, requesterID))));
	});
var $author$project$Data$Scroll$isNearTop = F2(
	function (threshold, _v0) {
		var scrollTop = _v0.bT;
		return _Utils_cmp(scrollTop, threshold) < 0;
	});
var $author$project$Data$Chat$Message$loadMessages = F2(
	function (partnerID, state) {
		var loadStatus = A2(
			$elm$core$Maybe$withDefault,
			1,
			A2($elm$core$Dict$get, partnerID, state.H));
		switch (loadStatus) {
			case 2:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 0:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			default:
				return A3(
					$author$project$Data$Chat$Message$loadOldMessages,
					state.aa.d8(partnerID),
					partnerID,
					state);
		}
	});
var $author$project$Data$Chat$loadMoreMessagesInCurrentRoom = function (_v0) {
	var state = _v0;
	var _v1 = $author$project$Data$Chat$Room$getCurrent(state.a);
	if (_v1.$ === 1) {
		return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
	} else {
		var partner = _v1.a.q;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (messageState) {
				return _Utils_update(
					state,
					{h: messageState});
			},
			A2($author$project$Data$Chat$Message$loadMessages, partner.eX, state.h));
	}
};
var $author$project$Model$Chat$loadMoreMessagesInCurrentRoom = F3(
	function (appModel, authState, model) {
		var _v0 = $author$project$Data$Chat$loadMoreMessagesInCurrentRoom(model.i8);
		var chatState = _v0.a;
		var chatCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				appModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								km: _Utils_update(
									model,
									{i8: chatState})
							}))
				}),
			chatCmd);
	});
var $author$project$Data$Chat$Room$Loading = {$: 0};
var $author$project$Data$Chat$Room$loadRooms = function (state) {
	var _v0 = state.T;
	switch (_v0.$) {
		case 2:
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		case 0:
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		default:
			return _Utils_Tuple2(
				_Utils_update(
					state,
					{T: $author$project$Data$Chat$Room$Loading}),
				A2($author$project$Data$Chat$Room$loadOldRooms, state.aa.d9, state));
	}
};
var $author$project$Data$Chat$loadRooms = function (_v0) {
	var state = _v0;
	return A2(
		$elm$core$Tuple$mapFirst,
		function (room) {
			return _Utils_update(
				state,
				{a: room});
		},
		$author$project$Data$Chat$Room$loadRooms(state.a));
};
var $author$project$Model$Chat$loadRooms = F2(
	function (appModel, authState) {
		var _v0 = authState;
		var chat = _v0.km;
		var _v1 = $author$project$Data$Chat$loadRooms(chat.i8);
		var chatState = _v1.a;
		var chatCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				appModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{
								km: _Utils_update(
									chat,
									{i8: chatState})
							}))
				}),
			chatCmd);
	});
var $author$project$Data$Chat$Message$onLoadMessages = $author$project$Data$Chat$Message$addLoadedMessages;
var $author$project$Data$Chat$onLoadMessages = F3(
	function (partnerID, json, _v0) {
		var state = _v0;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (message) {
				return _Utils_update(
					state,
					{h: message});
			},
			A3($author$project$Data$Chat$Message$onLoadMessages, partnerID, json, state.h));
	});
var $author$project$Data$Chat$Message$get = F3(
	function (partnerID, messageID, state) {
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Dict$get(messageID),
			A2($elm$core$Dict$get, partnerID, state.az));
	});
var $author$project$Data$Chat$Message$onRemoteImageUploadStatus = F2(
	function (_v0, state) {
		var partnerID = _v0.u;
		var messageID = _v0.U;
		var imageUrl = _v0.dI;
		var _v1 = A3($author$project$Data$Chat$Message$get, partnerID, messageID, state);
		if (_v1.$ === 1) {
			return state;
		} else {
			var message = _v1.a;
			return A2(
				$author$project$Data$Chat$Message$insert,
				_Utils_update(
					message,
					{cl: imageUrl}),
				state);
		}
	});
var $author$project$Data$Chat$onRemoteImageUploadStatus = F2(
	function (imageUploadStatus, _v0) {
		var state = _v0;
		return _Utils_update(
			state,
			{
				h: A2($author$project$Data$Chat$Message$onRemoteImageUploadStatus, imageUploadStatus, state.h)
			});
	});
var $author$project$Firebase$Firestore$DeleteDoc = {$: 4};
var $author$project$Firebase$Firestore$deleteDoc = function (document) {
	return A2($author$project$Firebase$Firestore$Query, document, $author$project$Firebase$Firestore$DeleteDoc);
};
var $author$project$Core$Data$Profile$removeUserFromAccessPrivatePhoto = F3(
	function (channelID, userID, requesterID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$deleteDoc(
				$author$project$Firebase$Firestore$doc(
					A2($author$project$Core$Data$Profile$privatePhotoAccessPath, userID, requesterID))));
	});
var $author$project$Model$Chat$scrollToMessage = function (currentViewport) {
	return A2(
		$elm$core$Task$attempt,
		$elm$core$Basics$always($author$project$Types$Noop),
		A2(
			$elm$core$Task$andThen,
			function (newViewport) {
				var contentHeightDiff = newViewport.nh.bu - currentViewport.nh.bu;
				return A3($elm$browser$Browser$Dom$setViewportOf, $author$project$Model$Chat$pageChatMessageID, 0, newViewport.jH.jK + contentHeightDiff);
			},
			$elm$browser$Browser$Dom$getViewportOf($author$project$Model$Chat$pageChatMessageID)));
};
var $author$project$Data$Chat$Message$generateID = F3(
	function (state, currentTime, partnerID) {
		return $truqu$elm_md5$MD5$hex(
			_Utils_ap(
				state.W.eX,
				_Utils_ap(
					partnerID,
					$elm$core$String$fromInt(
						$elm$time$Time$posixToMillis(currentTime)))));
	});
var $author$project$Data$Chat$Message$createMessage = F5(
	function (state, partnerID, messageKind, content, currentTime) {
		var message = {
			cl: content,
			cm: currentTime,
			lK: A3($author$project$Data$Chat$Message$generateID, state, currentTime, partnerID),
			ho: messageKind,
			u: partnerID,
			iY: 1
		};
		return _Utils_Tuple2(
			A2($author$project$Data$Chat$Message$insert, message, state),
			message);
	});
var $author$project$Data$Chat$Message$sendRemoteImageMessage = _Platform_outgoingPort(
	'sendRemoteImageMessage',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'createdAt',
					$elm$json$Json$Encode$int($.cm)),
					_Utils_Tuple2(
					'fileInputID',
					$elm$json$Json$Encode$string($.dw)),
					_Utils_Tuple2(
					'messageID',
					$elm$json$Json$Encode$string($.U)),
					_Utils_Tuple2(
					'partnerID',
					$elm$json$Json$Encode$string($.u)),
					_Utils_Tuple2(
					'roomID',
					$elm$json$Json$Encode$string($.a1))
				]));
	});
var $author$project$Data$Chat$Message$sendImageMessage = F5(
	function (state, roomID, partnerID, fileInputID, currentTime) {
		var _v0 = A5($author$project$Data$Chat$Message$createMessage, state, partnerID, 1, '', currentTime);
		var updatedState = _v0.a;
		var message = _v0.b;
		return _Utils_Tuple3(
			message,
			updatedState,
			$author$project$Data$Chat$Message$sendRemoteImageMessage(
				{
					cm: $elm$time$Time$posixToMillis(currentTime),
					dw: fileInputID,
					U: message.lK,
					u: partnerID,
					a1: roomID
				}));
	});
var $author$project$Data$Chat$Room$formatLastMessage = function (_v0) {
	var kind = _v0.ho;
	var content = _v0.cl;
	switch (kind) {
		case 1:
			return 'Image';
		case 2:
			return 'Private Photo Request';
		default:
			return A2($elm$core$String$left, 50, content);
	}
};
var $author$project$Data$Chat$Room$setRoomLastMessage = F2(
	function (message, room) {
		return _Utils_update(
			room,
			{
				bx: $author$project$Data$Chat$Room$formatLastMessage(message),
				ai: message.cm
			});
	});
var $author$project$Data$Chat$Partner$setReadUserEncode = function (profile) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'uid',
				$elm$json$Json$Encode$string(profile.eX)),
				_Utils_Tuple2(
				'username',
				$elm$json$Json$Encode$string(profile.dh)),
				_Utils_Tuple2(
				'avatar',
				$elm$json$Json$Encode$string(profile.cc)),
				_Utils_Tuple2(
				'status',
				$author$project$Data$Chat$Partner$statusEncoder(
					{a: 0, W: profile.eQ})),
				_Utils_Tuple2(
				'sponsorLevel',
				$author$project$Core$Data$Profile$SponsorLevel$encoder(profile.bY)),
				_Utils_Tuple2(
				'unreadCount',
				$elm$json$Json$Encode$int(0)),
				_Utils_Tuple2('lastRead', $author$project$Firebase$Firestore$serverTimestamp)
			]));
};
var $author$project$Firebase$Firestore$increment = function (number) {
	return $elm$json$Json$Encode$string(
		'ELM-FIREBASE::ENCODED-INCREMENT|' + $elm$core$String$fromInt(number));
};
var $author$project$Data$Chat$Partner$setUnreadEncode = function (partner) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'uid',
				$elm$json$Json$Encode$string(partner.eX)),
				_Utils_Tuple2(
				'username',
				$elm$json$Json$Encode$string(partner.dh)),
				_Utils_Tuple2(
				'avatar',
				$elm$json$Json$Encode$string(partner.cc)),
				_Utils_Tuple2(
				'status',
				$author$project$Data$Chat$Partner$statusEncoder(partner.eQ)),
				_Utils_Tuple2(
				'sponsorLevel',
				$author$project$Core$Data$Profile$SponsorLevel$encoder(partner.bY)),
				_Utils_Tuple2(
				'unreadCount',
				$author$project$Firebase$Firestore$increment(1)),
				_Utils_Tuple2(
				'lastRead',
				$author$project$Firebase$Firestore$encodeTimestamp(partner.aV))
			]));
};
var $author$project$Data$Chat$Room$encodeWithSentMessage = F2(
	function (userProfile, room) {
		var _v0 = userProfile.eY;
		if (_v0 === 1) {
			return A2(
				$elm$json$Json$Encode$encode,
				0,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'lastMessage',
							$elm$json$Json$Encode$string(room.bx)),
							_Utils_Tuple2('lastMessageCreatedAt', $author$project$Firebase$Firestore$serverTimestamp),
							_Utils_Tuple2(
							'receiverID',
							$elm$json$Json$Encode$string(room.q.eX)),
							_Utils_Tuple2(
							'sugar',
							$author$project$Data$Chat$Partner$setReadUserEncode(userProfile)),
							_Utils_Tuple2(
							'sponsor',
							$author$project$Data$Chat$Partner$setUnreadEncode(room.q))
						])));
		} else {
			return A2(
				$elm$json$Json$Encode$encode,
				0,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'lastMessage',
							$elm$json$Json$Encode$string(room.bx)),
							_Utils_Tuple2('lastMessageCreatedAt', $author$project$Firebase$Firestore$serverTimestamp),
							_Utils_Tuple2(
							'receiverID',
							$elm$json$Json$Encode$string(room.q.eX)),
							_Utils_Tuple2(
							'sponsor',
							$author$project$Data$Chat$Partner$setReadUserEncode(userProfile)),
							_Utils_Tuple2(
							'sugar',
							$author$project$Data$Chat$Partner$setUnreadEncode(room.q))
						])));
		}
	});
var $author$project$Firebase$Firestore$SetDocWithMerge = function (a) {
	return {$: 2, a: a};
};
var $author$project$Firebase$Firestore$setDocWithMerge = F2(
	function (json, document) {
		return A2(
			$author$project$Firebase$Firestore$Query,
			document,
			$author$project$Firebase$Firestore$SetDocWithMerge(json));
	});
var $author$project$Data$Chat$Room$updateRemoteRoom = F4(
	function (channelID, partnerID, userProfile, room) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$setDocWithMerge,
				A2($author$project$Data$Chat$Room$encodeWithSentMessage, userProfile, room),
				$author$project$Firebase$Firestore$doc(
					'/chat/room/lastMessages/' + A3($author$project$Data$Chat$Room$getRoomID, partnerID, userProfile.eX, userProfile.eY))));
	});
var $author$project$Data$Chat$Room$sendLastMessage = F4(
	function (userProfile, message, room, state) {
		var updatedRoom = $author$project$Data$Chat$Room$setRoomAsRead(
			A2($author$project$Data$Chat$Room$setRoomLastMessage, message, room));
		return _Utils_Tuple2(
			A2($author$project$Data$Chat$Room$insert, updatedRoom, state),
			A4($author$project$Data$Chat$Room$updateRemoteRoom, state.aa.bE, room.q.eX, userProfile, updatedRoom));
	});
var $author$project$Data$Chat$sendImageMessage = F5(
	function (userProfile, room, fileInputID, currentTime, _v0) {
		var state = _v0;
		var roomID = A3($author$project$Data$Chat$Room$getRoomID, room.q.eX, userProfile.eX, userProfile.eY);
		var _v1 = A5($author$project$Data$Chat$Message$sendImageMessage, state.h, roomID, room.q.eX, fileInputID, currentTime);
		var message = _v1.a;
		var messageState = _v1.b;
		var messageCmd = _v1.c;
		var _v2 = A4($author$project$Data$Chat$Room$sendLastMessage, userProfile, message, room, state.a);
		var roomState = _v2.a;
		var roomCmd = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				state,
				{h: messageState, a: roomState}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[messageCmd, roomCmd])));
	});
var $author$project$Data$Chat$Message$sendRemoteImageMessageWithBase64 = _Platform_outgoingPort(
	'sendRemoteImageMessageWithBase64',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'createdAt',
					$elm$json$Json$Encode$int($.cm)),
					_Utils_Tuple2(
					'imageData',
					$elm$json$Json$Encode$string($.dG)),
					_Utils_Tuple2(
					'messageID',
					$elm$json$Json$Encode$string($.U)),
					_Utils_Tuple2(
					'partnerID',
					$elm$json$Json$Encode$string($.u)),
					_Utils_Tuple2(
					'roomID',
					$elm$json$Json$Encode$string($.a1))
				]));
	});
var $author$project$Data$Chat$Message$sendImageMessageWithBase64 = F5(
	function (state, roomID, partnerID, imageData, currentTime) {
		var _v0 = A5($author$project$Data$Chat$Message$createMessage, state, partnerID, 1, imageData, currentTime);
		var updatedState = _v0.a;
		var message = _v0.b;
		return _Utils_Tuple3(
			message,
			updatedState,
			$author$project$Data$Chat$Message$sendRemoteImageMessageWithBase64(
				{
					cm: $elm$time$Time$posixToMillis(currentTime),
					dG: imageData,
					U: message.lK,
					u: partnerID,
					a1: roomID
				}));
	});
var $author$project$Data$Chat$sendImageMessageWithBase64 = F5(
	function (userProfile, partnerID, currentTime, imageData, _v0) {
		var state = _v0;
		var _v1 = A2($author$project$Data$Chat$Room$get, partnerID, state.a);
		if (_v1.$ === 1) {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		} else {
			var room = _v1.a;
			var roomID = A3($author$project$Data$Chat$Room$getRoomID, room.q.eX, userProfile.eX, userProfile.eY);
			var _v2 = A5($author$project$Data$Chat$Message$sendImageMessageWithBase64, state.h, roomID, room.q.eX, imageData, currentTime);
			var message = _v2.a;
			var messageState = _v2.b;
			var messageCmd = _v2.c;
			var _v3 = A4($author$project$Data$Chat$Room$sendLastMessage, userProfile, message, room, state.a);
			var roomState = _v3.a;
			var roomCmd = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					state,
					{h: messageState, a: roomState}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[messageCmd, roomCmd])));
		}
	});
var $author$project$Data$Chat$Message$messageKindEncoder = function (kind) {
	switch (kind) {
		case 0:
			return $elm$json$Json$Encode$string('Text');
		case 1:
			return $elm$json$Json$Encode$string('Image');
		default:
			return $elm$json$Json$Encode$string('AskForPrivatePhoto');
	}
};
var $author$project$Data$Chat$Message$encodeSentMessage = F2(
	function (user, message) {
		var _v0 = function () {
			var _v1 = user.ho;
			if (_v1 === 1) {
				return _Utils_Tuple2(message.u, user.eX);
			} else {
				return _Utils_Tuple2(user.eX, message.u);
			}
		}();
		var sponsorID = _v0.a;
		var sugarID = _v0.b;
		return A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'receiverID',
						$elm$json$Json$Encode$string(message.u)),
						_Utils_Tuple2(
						'sponsorID',
						$elm$json$Json$Encode$string(sponsorID)),
						_Utils_Tuple2(
						'sugarID',
						$elm$json$Json$Encode$string(sugarID)),
						_Utils_Tuple2(
						'kind',
						$author$project$Data$Chat$Message$messageKindEncoder(message.ho)),
						_Utils_Tuple2('createdAt', $author$project$Firebase$Firestore$serverTimestamp),
						_Utils_Tuple2(
						'content',
						$elm$json$Json$Encode$string(message.cl))
					])));
	});
var $author$project$Data$Chat$Message$setRemoteTextMessage = F3(
	function (channelID, user, message) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$setDoc,
				A2($author$project$Data$Chat$Message$encodeSentMessage, user, message),
				$author$project$Firebase$Firestore$doc('/chat/history/messages/' + message.lK)));
	});
var $author$project$Data$Chat$Message$sendPrivatePhotoRequest = F3(
	function (state, partnerID, currentTime) {
		var _v0 = A5($author$project$Data$Chat$Message$createMessage, state, partnerID, 2, '', currentTime);
		var updatedState = _v0.a;
		var message = _v0.b;
		return _Utils_Tuple3(
			message,
			updatedState,
			A3($author$project$Data$Chat$Message$setRemoteTextMessage, state.aa.bE, state.W, message));
	});
var $author$project$Data$Chat$sendPrivatePhotoRequest = F4(
	function (userProfile, room, currentTime, _v0) {
		var state = _v0;
		var _v1 = A3($author$project$Data$Chat$Message$sendPrivatePhotoRequest, state.h, room.q.eX, currentTime);
		var message = _v1.a;
		var messageState = _v1.b;
		var messageCmd = _v1.c;
		var _v2 = A4($author$project$Data$Chat$Room$sendLastMessage, userProfile, message, room, state.a);
		var roomState = _v2.a;
		var roomCmd = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				state,
				{h: messageState, a: roomState}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[messageCmd, roomCmd])));
	});
var $elm$core$String$trim = _String_trim;
var $author$project$Data$Chat$Message$isEmptyText = function (string) {
	return function (strLen) {
		return strLen <= 0;
	}(
		$elm$core$String$length(
			$elm$core$String$trim(string)));
};
var $author$project$Data$Chat$Message$sendTextMessage = F4(
	function (state, partnerID, content, currentTime) {
		var sanitisedContent = $elm$core$String$trim(content);
		var _v0 = A5($author$project$Data$Chat$Message$createMessage, state, partnerID, 0, sanitisedContent, currentTime);
		var updatedState = _v0.a;
		var message = _v0.b;
		return _Utils_Tuple3(
			message,
			updatedState,
			A3($author$project$Data$Chat$Message$setRemoteTextMessage, state.aa.bE, state.W, message));
	});
var $author$project$Data$Chat$sendTextMessage = F5(
	function (userProfile, room, text, currentTime, _v0) {
		var state = _v0;
		if ($author$project$Data$Chat$Message$isEmptyText(text)) {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		} else {
			var _v1 = A4($author$project$Data$Chat$Message$sendTextMessage, state.h, room.q.eX, text, currentTime);
			var message = _v1.a;
			var messageState = _v1.b;
			var messageCmd = _v1.c;
			var _v2 = A4($author$project$Data$Chat$Room$sendLastMessage, userProfile, message, room, state.a);
			var roomState = _v2.a;
			var roomCmd = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					state,
					{h: messageState, a: roomState}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[messageCmd, roomCmd])));
		}
	});
var $author$project$NativeBridge$startCameraSession = _Platform_outgoingPort(
	'startCameraSession',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'maxImageWidth',
					$elm$json$Json$Encode$int($.cH)),
					_Utils_Tuple2(
					'maxThumbnailWidth',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, $);
					}($.cI)),
					_Utils_Tuple2(
					'passThrough',
					$elm$core$Basics$identity($.mL))
				]));
	});
var $author$project$NativeBridge$cameraStart = F2(
	function (passThrough, maxImageWidth) {
		return $author$project$NativeBridge$startCameraSession(
			{cH: maxImageWidth, cI: $elm$core$Maybe$Nothing, mL: passThrough});
	});
var $author$project$Data$MobileCamera$encodeChatPassThrough = function (partnerID) {
	return $elm$json$Json$Encode$string('ForChat/' + partnerID);
};
var $author$project$Data$MobileCamera$startCameraForChat = function (partnerID) {
	return A2(
		$author$project$NativeBridge$cameraStart,
		$author$project$Data$MobileCamera$encodeChatPassThrough(partnerID),
		1280);
};
var $author$project$Data$Scroll$toPosition = F2(
	function (elementID, _v0) {
		var scrollTop = _v0.bT;
		return A3($elm$browser$Browser$Dom$setViewportOf, elementID, 0, scrollTop);
	});
var $author$project$PopupPhoto$Closed = 1;
var $author$project$PopupPhoto$Noop = {$: 4};
var $author$project$PopupPhoto$Opened = 0;
var $author$project$PopupPhoto$showNextPhoto = function (model) {
	var _v0 = model;
	var photos = _v0.bL;
	var photoIndex = _v0.K;
	var lastIndex = $elm$core$List$length(photos) - 1;
	return (_Utils_cmp(photoIndex, lastIndex) > -1) ? _Utils_update(
		model,
		{K: lastIndex}) : _Utils_update(
		model,
		{K: photoIndex + 1});
};
var $author$project$PopupPhoto$showPreviousPhoto = function (model) {
	var _v0 = model;
	var photoIndex = _v0.K;
	return (photoIndex <= 0) ? _Utils_update(
		model,
		{K: 0}) : _Utils_update(
		model,
		{K: photoIndex - 1});
};
var $author$project$PopupPhoto$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var photos = msg.a;
				var photoIndex = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{K: photoIndex, bL: photos, eQ: 0}),
					A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$PopupPhoto$Noop),
						$elm$browser$Browser$Dom$focus(model.bl.eq)));
			case 1:
				return function (model_) {
					return _Utils_Tuple2(
						_Utils_update(
							model_,
							{eQ: 1}),
						$elm$core$Platform$Cmd$none);
				}(
					$author$project$PopupPhoto$initialModel(model.bl));
			case 2:
				return _Utils_Tuple2(
					$author$project$PopupPhoto$showNextPhoto(model),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					$author$project$PopupPhoto$showPreviousPhoto(model),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Helpers$BlockUser$Types$Submitting = {$: 1};
var $author$project$Data$Chat$Partner$setBlockedRoomEncode = function (profile) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'uid',
				$elm$json$Json$Encode$string(profile.eX)),
				_Utils_Tuple2(
				'username',
				$elm$json$Json$Encode$string(profile.dh)),
				_Utils_Tuple2(
				'avatar',
				$elm$json$Json$Encode$string(profile.cc)),
				_Utils_Tuple2(
				'status',
				$author$project$Data$Chat$Partner$statusEncoder(
					{a: 1, W: profile.eQ})),
				_Utils_Tuple2(
				'sponsorLevel',
				$author$project$Core$Data$Profile$SponsorLevel$encoder(profile.bY)),
				_Utils_Tuple2(
				'unreadCount',
				$elm$json$Json$Encode$int(0)),
				_Utils_Tuple2('lastRead', $author$project$Firebase$Firestore$serverTimestamp)
			]));
};
var $author$project$Data$Chat$Room$encodeBlockedRoom = function (userProfile) {
	var _v0 = userProfile.eY;
	if (_v0 === 1) {
		return A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'sugar',
						$author$project$Data$Chat$Partner$setBlockedRoomEncode(userProfile))
					])));
	} else {
		return A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'sponsor',
						$author$project$Data$Chat$Partner$setBlockedRoomEncode(userProfile))
					])));
	}
};
var $author$project$Data$Chat$Room$blockRoom = F3(
	function (channelID, userProfile, partnerID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$updateDoc,
				$author$project$Data$Chat$Room$encodeBlockedRoom(userProfile),
				$author$project$Firebase$Firestore$doc(
					'/chat/room/lastMessages/' + A3($author$project$Data$Chat$Room$getRoomID, partnerID, userProfile.eX, userProfile.eY))));
	});
var $author$project$Data$Chat$Room$block = F3(
	function (channelID, userProfile, partnerID) {
		return A3($author$project$Data$Chat$Room$blockRoom, channelID, userProfile, partnerID);
	});
var $author$project$Data$Chat$blockRoom = F3(
	function (channelID, userProfile, partnerID) {
		return A3($author$project$Data$Chat$Room$block, channelID, userProfile, partnerID);
	});
var $author$project$Helpers$BlockUser$Model$submit = F2(
	function (authState, model) {
		var _v0 = authState.iu;
		if (_v0.$ === 1) {
			var profileModel = _v0.a;
			var _v1 = model;
			var channelID = _v1.aa;
			var blockProfileParams = _v1.aJ;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{eQ: $author$project$Helpers$BlockUser$Types$Submitting}),
				A3(
					$author$project$Data$Chat$blockRoom,
					channelID.j8(blockProfileParams.eX),
					profileModel.iu,
					model.aJ.eX));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						eQ: $author$project$Helpers$BlockUser$Types$Failure('Cannot find your profile')
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Helpers$BlockUser$Model$update = F3(
	function (msg, authState, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A2($author$project$CustomPopup$update, $author$project$CustomPopup$openMsg, model.bN);
				var popup = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: popup}),
					A2($elm$core$Platform$Cmd$map, $author$project$Helpers$BlockUser$Types$Popup, cmd));
			case 1:
				var popupMsg = msg.a;
				var _v2 = A2($author$project$CustomPopup$update, popupMsg, model.bN);
				var popup = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: popup}),
					A2($elm$core$Platform$Cmd$map, $author$project$Helpers$BlockUser$Types$Popup, cmd));
			default:
				return A2($author$project$Helpers$BlockUser$Model$submit, authState, model);
		}
	});
var $author$project$Model$Chat$updateBlockUser = F3(
	function (blockMsg, authState, appModel) {
		var _v0 = authState.km.ka;
		if (!_v0.$) {
			var blockUser = _v0.a;
			var model = authState.km;
			var _v1 = A3($author$project$Helpers$BlockUser$Model$update, blockMsg, authState, blockUser);
			var updatedBlockUser = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									km: _Utils_update(
										model,
										{
											ka: $elm$core$Maybe$Just(updatedBlockUser)
										})
								}))
					}),
				A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
						$author$project$Type$Chat$Block),
					cmd));
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Form$addFieldError = F2(
	function (errorMsg, field) {
		if (!field.$) {
			switch (field.a.$) {
				case 0:
					var field_ = field.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Form$IsString(
							_Utils_update(
								field_,
								{
									x: $elm$core$Result$Err(errorMsg)
								})));
				case 1:
					var field_ = field.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Form$IsBool(
							_Utils_update(
								field_,
								{
									x: $elm$core$Result$Err(errorMsg)
								})));
				case 2:
					var field_ = field.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Form$IsListString(
							_Utils_update(
								field_,
								{
									x: $elm$core$Result$Err(errorMsg)
								})));
				default:
					var field_ = field.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Form$IsTime(
							_Utils_update(
								field_,
								{
									x: $elm$core$Result$Err(errorMsg)
								})));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Core$Data$Report$Other = function (a) {
	return {$: 4, a: a};
};
var $author$project$Core$Data$Report$Pending = 0;
var $author$project$Core$Data$Report$otherReasonEncoder = function (reason) {
	return $elm$json$Json$Encode$string(
		function () {
			if (reason.$ === 4) {
				var otherReason = reason.a;
				return otherReason;
			} else {
				return '';
			}
		}());
};
var $author$project$Core$Data$Report$reasonString = function (reason) {
	switch (reason.$) {
		case 0:
			return 'InappropriatePhotos';
		case 1:
			return 'Spammer';
		case 2:
			return 'Scammer';
		case 3:
			return 'UnderageUser';
		default:
			return 'Other';
	}
};
var $author$project$Core$Data$Report$reasonEncoder = function (reason) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Report$reasonString(reason));
};
var $author$project$Core$Data$Report$statusString = function (status) {
	if (!status) {
		return 'Pending';
	} else {
		return 'Resolved';
	}
};
var $author$project$Core$Data$Report$statusEncoder = function (status) {
	return $elm$json$Json$Encode$string(
		$author$project$Core$Data$Report$statusString(status));
};
var $author$project$Core$Data$Report$userEncoder = function (_v0) {
	var username = _v0.dh;
	var uid = _v0.eX;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'username',
				$elm$json$Json$Encode$string(username)),
				_Utils_Tuple2(
				'uid',
				$elm$json$Json$Encode$string(uid))
			]));
};
var $author$project$Core$Data$Report$create = F3(
	function (channelID, currentTime, _v0) {
		var reason = _v0.et;
		var reporter = _v0.eA;
		var reported = _v0.ez;
		var reportID = $truqu$elm_md5$MD5$hex(
			_Utils_ap(
				reporter.eX,
				_Utils_ap(
					reported.eX,
					$elm$core$String$fromInt(
						$elm$time$Time$posixToMillis(currentTime)))));
		var json = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2('createdAt', $author$project$Firebase$Firestore$serverTimestamp),
						_Utils_Tuple2(
						'reason',
						$author$project$Core$Data$Report$reasonEncoder(reason)),
						_Utils_Tuple2(
						'otherReason',
						$author$project$Core$Data$Report$otherReasonEncoder(reason)),
						_Utils_Tuple2(
						'reporter',
						$author$project$Core$Data$Report$userEncoder(reporter)),
						_Utils_Tuple2(
						'reported',
						$author$project$Core$Data$Report$userEncoder(reported)),
						_Utils_Tuple2(
						'status',
						$author$project$Core$Data$Report$statusEncoder(0))
					])));
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$setDoc,
				json,
				$author$project$Firebase$Firestore$doc('/backend/report/cases/' + reportID)));
	});
var $author$project$Core$Data$Report$InappropriatePhotos = {$: 0};
var $author$project$Core$Data$Report$Scammer = {$: 2};
var $author$project$Core$Data$Report$Spammer = {$: 1};
var $author$project$Core$Data$Report$UnderageUser = {$: 3};
var $author$project$Core$Data$Report$toReason = F2(
	function (otherReason, reason) {
		switch (reason) {
			case 'InappropriatePhotos':
				return $elm$core$Result$Ok($author$project$Core$Data$Report$InappropriatePhotos);
			case 'Spammer':
				return $elm$core$Result$Ok($author$project$Core$Data$Report$Spammer);
			case 'Scammer':
				return $elm$core$Result$Ok($author$project$Core$Data$Report$Scammer);
			case 'UnderageUser':
				return $elm$core$Result$Ok($author$project$Core$Data$Report$UnderageUser);
			case 'Other':
				return $elm$core$Result$Ok(
					$author$project$Core$Data$Report$Other(otherReason));
			default:
				return $elm$core$Result$Err('Report reason field is invalid.');
		}
	});
var $author$project$Helpers$ReportUser$Model$sendReport = F2(
	function (currentTime, model) {
		var _v0 = model;
		var form = _v0.ln;
		var reporter = _v0.eA;
		var reported = _v0.ez;
		var channelID = _v0.aa;
		var otherReason = A2($author$project$Form$getRawString, form, 'otherReason');
		var reasonString = A2($author$project$Form$getRawString, form, 'reason');
		var reason = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Core$Data$Report$Other(otherReason),
			$elm$core$Result$toMaybe(
				A2($author$project$Core$Data$Report$toReason, otherReason, reasonString)));
		var params = {et: reason, ez: reported, eA: reporter};
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					ln: _Utils_update(
						form,
						{gs: $elm$core$Maybe$Nothing, jc: true})
				}),
			A3(
				$author$project$Core$Data$Report$create,
				channelID(reported.eX),
				currentTime,
				params));
	});
var $author$project$Helpers$ReportUser$Model$submitForm = F2(
	function (currentTime, model) {
		var addOtherReasonFieldError = $author$project$Form$addFieldError('This field cannot be empty');
		var _v0 = model;
		var form = _v0.ln;
		var otherReason = A2($author$project$Form$getRawString, form, 'otherReason');
		var reasonString = A2($author$project$Form$getRawString, form, 'reason');
		var validOtherReason = function () {
			var _v1 = A2($author$project$Core$Data$Report$toReason, otherReason, reasonString);
			if ((!_v1.$) && (_v1.a.$ === 4)) {
				var otherReason_ = _v1.a.a;
				return otherReason_ !== '';
			} else {
				return true;
			}
		}();
		var updateFields = function (fields) {
			return validOtherReason ? fields : A3($elm$core$Dict$update, 'otherReason', addOtherReasonFieldError, fields);
		};
		var updatedForm = function (form_) {
			return _Utils_update(
				form_,
				{
					j: updateFields(form_.j)
				});
		}(
			$author$project$Form$validate(form));
		return ($author$project$Form$isFormValid(updatedForm) && validOtherReason) ? A2(
			$author$project$Helpers$ReportUser$Model$sendReport,
			currentTime,
			_Utils_update(
				model,
				{ln: updatedForm})) : _Utils_Tuple2(
			_Utils_update(
				model,
				{ln: updatedForm}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Helpers$ReportUser$Model$update = F3(
	function (msg, currentTime, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A2($author$project$CustomPopup$update, $author$project$CustomPopup$openMsg, model.bN);
				var popup = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: popup}),
					A2($elm$core$Platform$Cmd$map, $author$project$Helpers$ReportUser$Types$Popup, cmd));
			case 1:
				var popupMsg = msg.a;
				var _v2 = A2($author$project$CustomPopup$update, popupMsg, model.bN);
				var popup = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: popup}),
					A2($elm$core$Platform$Cmd$map, $author$project$Helpers$ReportUser$Types$Popup, cmd));
			case 2:
				var fieldMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ln: A2($author$project$Form$updateForm, model.ln, fieldMsg)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return A2($author$project$Helpers$ReportUser$Model$submitForm, currentTime, model);
		}
	});
var $author$project$Model$Chat$updateReportUser = F3(
	function (reportMsg, authState, appModel) {
		var _v0 = authState.km.aA;
		if (_v0.$ === 1) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var reportUser = _v0.a;
			var model = authState.km;
			var _v1 = A3($author$project$Helpers$ReportUser$Model$update, reportMsg, appModel.kG, reportUser);
			var updatedReportUser = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									km: _Utils_update(
										model,
										{
											aA: $elm$core$Maybe$Just(updatedReportUser)
										})
								}))
					}),
				A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
						$author$project$Type$Chat$Report),
					cmd));
		}
	});
var $author$project$Model$Chat$update = F3(
	function (msg, authState, appModel) {
		var _v0 = authState;
		var chat = _v0.km;
		switch (msg.$) {
			case 0:
				var partner = msg.a;
				return A3($author$project$Model$Chat$handleCreateRoom, partner, authState, appModel);
			case 1:
				var room = msg.a;
				var scrollToLastPosition = A2(
					$elm$core$Task$attempt,
					$elm$core$Basics$always($author$project$Types$Noop),
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Data$Scroll$toBottom($author$project$Model$Chat$pageChatMessageID),
						A2(
							$elm$core$Maybe$map,
							$author$project$Data$Scroll$toPosition($author$project$Model$Chat$pageChatMessageID),
							A2(
								$elm$core$Maybe$andThen,
								function (partnerID) {
									return A2($elm$core$Dict$get, partnerID, chat.bC);
								},
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.q;
										},
										function ($) {
											return $.eX;
										}),
									room)))));
				var _v2 = A3($author$project$Data$Chat$setCurrentRoom, room, appModel.kG, chat.i8);
				var chatState = _v2.a;
				var chatCmd = _v2.b;
				var _v3 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
							$author$project$Type$Chat$Report)),
					A2($author$project$Model$Chat$initialReportUser, authState.j2, chatState));
				var reportUser = _v3.a;
				var reportUserCmd = _v3.b;
				var _v4 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
							$author$project$Type$Chat$Block)),
					$author$project$Model$Chat$initialBlockUser(chatState));
				var blockUser = _v4.a;
				var blockUserCmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{ka: blockUser, Q: $author$project$Type$Chat$Close, ee: false, aA: reportUser, i8: chatState})
									}))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								scrollToLastPosition,
								$author$project$Model$Chat$setFocusToChatInputOnDesktop(appModel.kQ),
								chatCmd,
								reportUserCmd,
								blockUserCmd
							])));
			case 2:
				var scrollPosition = msg.a;
				if (A2($author$project$Data$Scroll$isNearBottom, 400, scrollPosition)) {
					var _v5 = $author$project$Data$Chat$loadRooms(chat.i8);
					var chatState = _v5.a;
					var chatCmd = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							appModel,
							{
								j1: $elm$core$Maybe$Just(
									_Utils_update(
										authState,
										{
											km: _Utils_update(
												chat,
												{i8: chatState})
										}))
							}),
						chatCmd);
				} else {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 3:
				var hasViewport = msg.a;
				if (hasViewport.$ === 1) {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				} else {
					var element = hasViewport.a.kZ;
					var viewport = hasViewport.a.jH;
					return (_Utils_cmp(element.jK, viewport.bu) < 0) ? A2($author$project$Model$Chat$loadRooms, appModel, authState) : _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{Q: $author$project$Type$Chat$Close})
									}))
						}),
					$author$project$Model$Chat$setFocusToChatInputOnDesktop(appModel.kQ));
			case 5:
				var partnerID = msg.a;
				var scrollPosition = msg.b;
				var updatedChat = _Utils_update(
					chat,
					{
						bC: A3($elm$core$Dict$insert, partnerID, scrollPosition, chat.bC)
					});
				return A2($author$project$Data$Scroll$isNearTop, 400, scrollPosition) ? A3($author$project$Model$Chat$loadMoreMessagesInCurrentRoom, appModel, authState, updatedChat) : _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{km: updatedChat}))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var json = msg.a;
				var partnerID = msg.b;
				var hasCurrentViewport = msg.c;
				var _v7 = A3($author$project$Data$Chat$onLoadMessages, partnerID, json, authState.km.i8);
				var errors = _v7.a;
				var chatState = _v7.b;
				var updatedAppModel = A2(
					$author$project$Model$Chat$mapDbErrors,
					errors,
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{i8: chatState})
									}))
						}));
				if (hasCurrentViewport.$ === 1) {
					return _Utils_Tuple2(updatedAppModel, $elm$core$Platform$Cmd$none);
				} else {
					var viewport = hasCurrentViewport.a;
					return _Utils_Tuple2(
						updatedAppModel,
						$author$project$Model$Chat$scrollToMessage(viewport));
				}
			case 7:
				var partnerID = msg.a;
				var inputText = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{
												ah: A3($elm$core$Dict$insert, partnerID, inputText, chat.ah)
											})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var userProfile = msg.a;
				var room = msg.b;
				var text = msg.c;
				var currentTime = msg.d;
				var _v9 = A5($author$project$Data$Chat$sendTextMessage, userProfile, room, text, currentTime, chat.i8);
				var chatState = _v9.a;
				var chatCmd = _v9.b;
				var updatedChat = _Utils_update(
					chat,
					{
						Q: $author$project$Type$Chat$Close,
						ah: A2($elm$core$Dict$remove, room.q.eX, chat.ah),
						i8: chatState
					});
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{km: updatedChat}))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								chatCmd,
								A2(
								$elm$core$Task$attempt,
								$elm$core$Basics$always($author$project$Types$Noop),
								$elm$browser$Browser$Dom$focus($author$project$Model$Chat$pageChatInputID))
							])));
			case 9:
				var popupMsg = msg.a;
				var _v10 = A2($author$project$PopupPhoto$update, popupMsg, chat.bN);
				var popup = _v10.a;
				var cmd = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{bN: popup})
									}))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
							$author$project$Type$Chat$Popup),
						cmd));
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{
												Q: $author$project$Type$Chat$Open(0)
											})
									}))
						}),
					$author$project$Model$Chat$setFocusToChatInputOnDesktop(appModel.kQ));
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{Q: $author$project$Type$Chat$Close})
									}))
						}),
					$author$project$Model$Chat$setFocusToChatInputOnDesktop(appModel.kQ));
			case 12:
				var category = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{
												Q: $author$project$Type$Chat$Open(category)
											})
									}))
						}),
					$author$project$Model$Chat$setFocusToChatInputOnDesktop(appModel.kQ));
			case 13:
				var partnerID = msg.a;
				var emoji = msg.b;
				var inputText = function (text) {
					return _Utils_ap(text, emoji);
				}(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Dict$get, partnerID, chat.ah)));
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{
												ah: A3($elm$core$Dict$insert, partnerID, inputText, chat.ah)
											})
									}))
						}),
					$author$project$Model$Chat$setFocusToChatInputOnDesktop(appModel.kQ));
			case 14:
				var userProfile = msg.a;
				var room = msg.b;
				var fieldName = msg.c;
				var currentTime = msg.d;
				var _v11 = A5($author$project$Data$Chat$sendImageMessage, userProfile, room, fieldName, currentTime, chat.i8);
				var chatState = _v11.a;
				var chatCmd = _v11.b;
				var updatedChat = _Utils_update(
					chat,
					{Q: $author$project$Type$Chat$Close, i8: chatState});
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{km: updatedChat}))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								chatCmd,
								$author$project$Model$Chat$setFocusToChatInputOnDesktop(appModel.kQ),
								$author$project$Model$Chat$scrollToBottom
							])));
			case 15:
				var userProfile = msg.a;
				var partnerID = msg.b;
				var imageData = msg.c;
				var currentTime = msg.d;
				var _v12 = A5($author$project$Data$Chat$sendImageMessageWithBase64, userProfile, partnerID, currentTime, imageData, chat.i8);
				var chatState = _v12.a;
				var chatCmd = _v12.b;
				var updatedChat = _Utils_update(
					chat,
					{Q: $author$project$Type$Chat$Close, i8: chatState});
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{km: updatedChat}))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[chatCmd, $author$project$Model$Chat$scrollToBottom])));
			case 16:
				var partnerID = msg.a;
				return $author$project$NativeBridge$isMobileApp(appModel.kQ) ? _Utils_Tuple2(
					appModel,
					$author$project$Data$MobileCamera$startCameraForChat(partnerID)) : _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 17:
				var imageUploadStatus = msg.a;
				var updatedChat = _Utils_update(
					chat,
					{
						i8: A2($author$project$Data$Chat$onRemoteImageUploadStatus, imageUploadStatus, chat.i8)
					});
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{km: updatedChat}))
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var userProfile = msg.a;
				var partner = msg.b;
				var currentTime = msg.c;
				var _v13 = A2($author$project$Data$Chat$createRoom, partner, chat.i8);
				var room = _v13.a;
				var createdRoomState = _v13.b;
				var createRoomCmd = _v13.c;
				var _v14 = A3(
					$author$project$Data$Chat$setCurrentRoom,
					$elm$core$Maybe$Just(room),
					currentTime,
					createdRoomState);
				var setCurrentRoomState = _v14.a;
				var setCurrentRoomCmd = _v14.b;
				var _v15 = A4($author$project$Data$Chat$sendPrivatePhotoRequest, userProfile, room, currentTime, setCurrentRoomState);
				var updatedChatState = _v15.a;
				var privatePhotoCmd = _v15.b;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{i8: updatedChatState})
									}))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$browser$Browser$Navigation$pushUrl, appModel.bD, $author$project$Data$Route$routeUrl.km),
								createRoomCmd,
								setCurrentRoomCmd,
								privatePhotoCmd,
								$author$project$Model$Chat$setFocusToChatInputOnDesktop(appModel.kQ)
							])));
			case 19:
				var userProfile = msg.a;
				var room = msg.b;
				var currentTime = msg.c;
				var _v16 = A5($author$project$Data$Chat$sendTextMessage, userProfile, room, 'Yes, I have given you access to view my Private Photos.', currentTime, chat.i8);
				var chatState = _v16.a;
				var chatCmd = _v16.b;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{i8: chatState})
									}))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Core$Data$Profile$grantUserToAccessPrivatePhoto, $author$project$Model$Chat$channelID.bE, userProfile.eX, room.q.eX),
								$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										chatCmd,
										$author$project$Model$Chat$setFocusToChatInputOnDesktop(appModel.kQ)
									]))
							])));
			case 20:
				var userProfile = msg.a;
				var room = msg.b;
				var currentTime = msg.c;
				var _v17 = A5($author$project$Data$Chat$sendTextMessage, userProfile, room, 'I have cancelled your request to view my Private Photos.', currentTime, chat.i8);
				var chatState = _v17.a;
				var chatCmd = _v17.b;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{i8: chatState})
									}))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Core$Data$Profile$removeUserFromAccessPrivatePhoto, $author$project$Model$Chat$channelID.bE, userProfile.eX, room.q.eX),
								$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										chatCmd,
										$author$project$Model$Chat$setFocusToChatInputOnDesktop(appModel.kQ)
									]))
							])));
			case 21:
				var openMenu = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{
										km: _Utils_update(
											chat,
											{ee: openMenu})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 22:
				var reportMsg = msg.a;
				return A3($author$project$Model$Chat$updateReportUser, reportMsg, authState, appModel);
			default:
				var blockMsg = msg.a;
				return A3($author$project$Model$Chat$updateBlockUser, blockMsg, authState, appModel);
		}
	});
var $author$project$Model$Deactivate$submitForm = F2(
	function (profile, model) {
		if ($author$project$Form$isFormValid(model.ln)) {
			var _v0 = model;
			var form = _v0.ln;
			var password = A2($author$project$Form$getRawString, form, 'password');
			var updatedForm = _Utils_update(
				form,
				{jc: true});
			return _Utils_Tuple2(
				{dk: $elm$core$Maybe$Nothing, ln: updatedForm, iC: true},
				A2($author$project$Firebase$Auth$signInWithEmailAndPassword, profile.dt, password));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dk: $elm$core$Maybe$Just('Check your form')
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Deactivate$update = F2(
	function (msg, authState) {
		var model = authState.gc;
		var _v0 = $author$project$Helpers$getCurrentUserProfile(authState);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dk: $elm$core$Maybe$Just('Missing profile')
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var profile = _v0.a;
			if (!msg.$) {
				var fieldMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ln: A2($author$project$Form$updateForm, model.ln, fieldMsg)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return A2($author$project$Model$Deactivate$submitForm, profile, model);
			}
		}
	});
var $author$project$Type$Detail$PopupMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$Detail$Updating = 2;
var $author$project$Core$Data$Profile$setFavoriteProfile = F3(
	function (userID, favoritedUserID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$setDoc,
				$author$project$Core$Data$Profile$createdAtJson,
				$author$project$Firebase$Firestore$doc(
					A2($author$project$Core$Data$Profile$favoriteProfilePath, userID, favoritedUserID))));
	});
var $author$project$Core$Data$Profile$favoritedProfilePath = F2(
	function (userID, favoriterUserID) {
		return '/profiles/' + (userID + ('/favoritedMe/' + favoriterUserID));
	});
var $author$project$Core$Data$Profile$setFavoritedProfile = F3(
	function (userID, favoriterUserID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			A2(
				$author$project$Firebase$Firestore$setDoc,
				$author$project$Core$Data$Profile$createdAtJson,
				$author$project$Firebase$Firestore$doc(
					A2($author$project$Core$Data$Profile$favoritedProfilePath, userID, favoriterUserID))));
	});
var $author$project$Model$Detail$favoriteProfile = F3(
	function (favoritedUserID, authUserID, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					iw: A3($author$project$Model$Detail$updateFavoriteStatus, favoritedUserID, 2, model.iw)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Core$Data$Profile$setFavoriteProfile, authUserID, favoritedUserID, $author$project$Model$Detail$channelIDs.bE),
						A3(
						$author$project$Core$Data$Profile$setFavoritedProfile,
						favoritedUserID,
						authUserID,
						$author$project$Model$Detail$channelIDs.i_(favoritedUserID))
					])));
	});
var $author$project$Model$Detail$onUnBlockUser = F4(
	function (userID, unBlockMsg, authState, appModel) {
		var _v0 = A2($elm$core$Dict$get, userID, authState.gj.iw);
		if (!_v0.$) {
			var fullProfile = _v0.a;
			var handleUnBlockUser = F2(
				function (unBlockUser, toBlockStatus) {
					var model = authState.gj;
					var _v2 = model;
					var profiles = _v2.iw;
					var _v3 = A3($author$project$Helpers$UnBlockUser$Model$update, unBlockMsg, authState, unBlockUser);
					var updatedUnBlockUser = _v3.a;
					var cmd = _v3.b;
					var updatedFullProfile = $elm$core$Maybe$map(
						function (fullProfile_) {
							return _Utils_update(
								fullProfile_,
								{
									j9: toBlockStatus(updatedUnBlockUser)
								});
						});
					var updatedProfiles = A3($elm$core$Dict$update, userID, updatedFullProfile, profiles);
					return _Utils_Tuple2(
						A3(
							$author$project$Model$Detail$mapAppModel,
							authState,
							appModel,
							_Utils_update(
								model,
								{iw: updatedProfiles})),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Types$OnAuth,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Types$OnDetail,
								A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Type$Detail$OnUnBlockUser(userID),
									cmd))));
				});
			var _v1 = fullProfile.j9;
			switch (_v1.$) {
				case 2:
					var unBlockUser = _v1.a;
					return A2(
						handleUnBlockUser,
						unBlockUser,
						function (blockStatus) {
							return $author$project$Type$Detail$Blocked(blockStatus);
						});
				case 3:
					var unBlockUser = _v1.a;
					return A2(
						handleUnBlockUser,
						unBlockUser,
						function (blockStatus) {
							return $author$project$Type$Detail$UnBlockSucessfully(blockStatus);
						});
				default:
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Core$Data$Profile$deleteFavoriteProfile = F3(
	function (userID, favoritedUserID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$deleteDoc(
				$author$project$Firebase$Firestore$doc(
					A2($author$project$Core$Data$Profile$favoriteProfilePath, userID, favoritedUserID))));
	});
var $author$project$Core$Data$Profile$deleteFavoritedProfile = F3(
	function (userID, favoriterUserID, channelID) {
		return A2(
			$author$project$Firebase$Firestore$send,
			channelID,
			$author$project$Firebase$Firestore$deleteDoc(
				$author$project$Firebase$Firestore$doc(
					A2($author$project$Core$Data$Profile$favoritedProfilePath, userID, favoriterUserID))));
	});
var $author$project$Model$Detail$unFavoriteProfile = F3(
	function (favoritedUserID, authUserID, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					iw: A3($author$project$Model$Detail$updateFavoriteStatus, favoritedUserID, 2, model.iw)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Core$Data$Profile$deleteFavoriteProfile, authUserID, favoritedUserID, $author$project$Model$Detail$channelIDs.bE),
						A3(
						$author$project$Core$Data$Profile$deleteFavoritedProfile,
						favoritedUserID,
						authUserID,
						$author$project$Model$Detail$channelIDs.gh(favoritedUserID))
					])));
	});
var $author$project$Model$Detail$updateReportUser = F4(
	function (userID, reportMsg, authState, appModel) {
		var _v0 = A2($elm$core$Dict$get, userID, authState.gj.iw);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var reportUser = _v0.a.aA;
			if (reportUser.$ === 1) {
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			} else {
				var reportUser_ = reportUser.a;
				var model = authState.gj;
				var _v2 = model;
				var profiles = _v2.iw;
				var _v3 = A3($author$project$Helpers$ReportUser$Model$update, reportMsg, appModel.kG, reportUser_);
				var updatedReportUser = _v3.a;
				var cmd = _v3.b;
				var updatedFullProfile = $elm$core$Maybe$map(
					function (fullProfile) {
						return _Utils_update(
							fullProfile,
							{
								aA: $elm$core$Maybe$Just(updatedReportUser)
							});
					});
				var updatedProfiles = A3($elm$core$Dict$update, userID, updatedFullProfile, profiles);
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Detail$mapAppModel,
						authState,
						appModel,
						_Utils_update(
							model,
							{iw: updatedProfiles})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnDetail),
							$author$project$Type$Detail$Report(userID)),
						cmd));
			}
		}
	});
var $author$project$Model$Detail$update = F3(
	function (msg, authState, appModel) {
		var toAppTuple = function (_v3) {
			var model_ = _v3.a;
			var cmd_ = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{gj: model_}))
					}),
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Types$OnAuth,
					A2($elm$core$Platform$Cmd$map, $author$project$Types$OnDetail, cmd_)));
		};
		var model = authState.gj;
		var _v0 = authState;
		var authUser = _v0.j2;
		switch (msg.$) {
			case 0:
				var popupMsg = msg.a;
				var _v2 = A2($author$project$PopupPhoto$update, popupMsg, model.ep);
				var popupPhoto = _v2.a;
				var cmd = _v2.b;
				return toAppTuple(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{ep: popupPhoto}),
						A2($elm$core$Platform$Cmd$map, $author$project$Type$Detail$PopupMsg, cmd)));
			case 1:
				var favoritedUserID = msg.a;
				return toAppTuple(
					A3($author$project$Model$Detail$favoriteProfile, favoritedUserID, authUser.eX, model));
			case 2:
				var favoritedUserID = msg.a;
				return toAppTuple(
					A3($author$project$Model$Detail$unFavoriteProfile, favoritedUserID, authUser.eX, model));
			case 3:
				var userID = msg.a;
				var reportMsg = msg.b;
				return A4($author$project$Model$Detail$updateReportUser, userID, reportMsg, authState, appModel);
			default:
				var userID = msg.a;
				var unBlockMsg = msg.b;
				return A4($author$project$Model$Detail$onUnBlockUser, userID, unBlockMsg, authState, appModel);
		}
	});
var $author$project$Type$EmailVerification$Sending = {$: 1};
var $author$project$Type$EmailVerification$SendEmailResult = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$EmailVerification$sendEmailCmd = F2(
	function (url, userID) {
		var params = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'userID',
						$elm$json$Json$Encode$string(userID)),
						_Utils_Tuple2(
						'token',
						$elm$json$Json$Encode$string(
							$truqu$elm_md5$MD5$hex(userID)))
					])));
		return $elm$http$Http$post(
			{
				cg: A2($elm$http$Http$stringBody, 'application/json', params),
				k6: $elm$http$Http$expectString($author$project$Type$EmailVerification$SendEmailResult),
				n8: url
			});
	});
var $author$project$Type$EmailVerification$Failure = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$EmailVerification$Success = {$: 3};
var $author$project$Model$EmailVerification$maxRetryNumber = 3;
var $author$project$Model$EmailVerification$checkRetryCmd = F2(
	function (retryNumber, cmd) {
		return (_Utils_cmp(retryNumber, $author$project$Model$EmailVerification$maxRetryNumber) < 0) ? {ar: cmd, h: $elm$core$Maybe$Nothing} : {
			ar: cmd,
			h: $elm$core$Maybe$Just('An error occurred. Please try again.')
		};
	});
var $author$project$Model$EmailVerification$checkHttpError = F3(
	function (error, retryNumber, retryCmd) {
		switch (error.$) {
			case 1:
				return A2($author$project$Model$EmailVerification$checkRetryCmd, retryNumber, retryCmd);
			case 2:
				return A2($author$project$Model$EmailVerification$checkRetryCmd, retryNumber, retryCmd);
			case 0:
				var message = error.a;
				return {
					ar: $elm$core$Platform$Cmd$none,
					h: $elm$core$Maybe$Just(message)
				};
			case 3:
				var errorCode = error.a;
				return {
					ar: $elm$core$Platform$Cmd$none,
					h: $elm$core$Maybe$Just(
						'Http bad status: ' + $elm$core$String$fromInt(errorCode))
				};
			default:
				var message = error.a;
				return {
					ar: $elm$core$Platform$Cmd$none,
					h: $elm$core$Maybe$Just(message)
				};
		}
	});
var $author$project$Helpers$Decoders$Error = function (a) {
	return {$: 1, a: a};
};
var $author$project$Helpers$Decoders$Success = function (a) {
	return {$: 0, a: a};
};
var $author$project$Helpers$Decoders$decodeApiResponse = F2(
	function (successDecoder, json) {
		var statusResult = A2(
			$elm$json$Json$Decode$decodeString,
			A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool),
			json);
		var messageResult = A2(
			$elm$json$Json$Decode$decodeString,
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)),
			json);
		var errorCodeResult = A2(
			$elm$json$Json$Decode$decodeString,
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'errorCode', $elm$json$Json$Decode$string)),
			json);
		var dataResult = A2(
			$elm$json$Json$Decode$decodeString,
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'data', successDecoder)),
			json);
		var _v0 = _Utils_Tuple2(statusResult, dataResult);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (_v0.a.a) {
					if (!_v0.b.$) {
						var data = _v0.b.a;
						return $author$project$Helpers$Decoders$Success(data);
					} else {
						break _v0$2;
					}
				} else {
					var _v1 = _Utils_Tuple2(errorCodeResult, messageResult);
					if ((!_v1.a.$) && (!_v1.b.$)) {
						var errorCode = _v1.a.a;
						var message = _v1.b.a;
						return $author$project$Helpers$Decoders$Error(
							{
								cs: A2($elm$core$Maybe$withDefault, '', errorCode),
								h: A2($elm$core$Maybe$withDefault, '', message)
							});
					} else {
						return $author$project$Helpers$Decoders$Error(
							{cs: 'Json Parse Failed', h: 'Error in parsing JSON string.'});
					}
				}
			} else {
				break _v0$2;
			}
		}
		return $author$project$Helpers$Decoders$Error(
			{cs: 'Json Parse Failed', h: 'Error in parsing JSON string.'});
	});
var $author$project$Model$EmailVerification$sendEmailVerificationResult = F2(
	function (response, model) {
		var _v0 = model;
		var apiRetryNumber = _v0.ca;
		var userID = _v0.a9;
		var apiUrl = _v0.dl;
		if (response.$ === 1) {
			var error = response.a;
			var _v2 = A3(
				$author$project$Model$EmailVerification$checkHttpError,
				error,
				apiRetryNumber,
				A2($author$project$Model$EmailVerification$sendEmailCmd, apiUrl, userID));
			var cmd = _v2.ar;
			var message = _v2.h;
			if (!message.$) {
				var errorMessage = message.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ca: 0,
							eQ: $author$project$Type$EmailVerification$Failure(errorMessage)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ca: apiRetryNumber + 1, eQ: $author$project$Type$EmailVerification$Sending}),
					cmd);
			}
		} else {
			var response_ = response.a;
			var _v4 = A2(
				$author$project$Helpers$Decoders$decodeApiResponse,
				$elm$json$Json$Decode$succeed(0),
				response_);
			if (!_v4.$) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eQ: $author$project$Type$EmailVerification$Success}),
					$elm$core$Platform$Cmd$none);
			} else {
				var message = _v4.a.h;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eQ: $author$project$Type$EmailVerification$Failure(message)
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Model$EmailVerification$update = F2(
	function (msg, _v0) {
		var emailVerification = _v0.gm;
		if (!msg.$) {
			return _Utils_Tuple2(
				_Utils_update(
					emailVerification,
					{eQ: $author$project$Type$EmailVerification$Sending}),
				A2($author$project$Model$EmailVerification$sendEmailCmd, emailVerification.dl, emailVerification.a9));
		} else {
			var response = msg.a;
			return A2($author$project$Model$EmailVerification$sendEmailVerificationResult, response, emailVerification);
		}
	});
var $author$project$Type$FaceVerification$Error = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$FaceVerification$Verified = {$: 2};
var $author$project$Model$FaceVerification$update = function (msg) {
	if (!msg.$) {
		return _Utils_Tuple2(
			$author$project$Type$FaceVerification$NotVerified,
			$author$project$NativeBridge$sendCustom(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'function',
							$elm$json$Json$Encode$string('startFaceVerification'))
						]))));
	} else {
		var errorMessage = msg.a;
		if (errorMessage.$ === 1) {
			return _Utils_Tuple2($author$project$Type$FaceVerification$Verified, $elm$core$Platform$Cmd$none);
		} else {
			var message = errorMessage.a;
			return _Utils_Tuple2(
				$author$project$Type$FaceVerification$Error(message),
				$elm$core$Platform$Cmd$none);
		}
	}
};
var $author$project$Data$Membership$Opened = 0;
var $author$project$Data$Membership$Android$BelongedToAnotherUser = 2;
var $author$project$Model$Membership$Android$checkTokenResult = F2(
	function (response, model) {
		if (response.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						n: $author$project$Data$Membership$apiStateWithError('Network error.')
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var apiResponse = response.a;
			var _v1 = A2(
				$author$project$Helpers$Decoders$decodeApiResponse,
				$elm$json$Json$Decode$succeed(0),
				apiResponse);
			if (_v1.$ === 1) {
				var errorCode = _v1.a.cs;
				var message = _v1.a.h;
				switch (errorCode) {
					case 'API/INVALID_TOKEN':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									n: $author$project$Data$Membership$initialApiState(0),
									a$: 0
								}),
							$elm$core$Platform$Cmd$none);
					case 'API/TOKEN_BELONGED_TO_ANOTHER_USER':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									n: $author$project$Data$Membership$initialApiState(0),
									a$: 2
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									n: $author$project$Data$Membership$apiStateWithError(message)
								}),
							$elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							n: $author$project$Data$Membership$initialApiState(0),
							a$: 1
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Data$Membership$Confirmed = 2;
var $author$project$Model$Membership$Android$confirmSelectedPlan = F2(
	function (newPlan, model) {
		var updatedModel = A3($author$project$Model$Membership$Android$updateSelectedPlan, newPlan, 2, model);
		return _Utils_Tuple2(
			_Utils_update(
				updatedModel,
				{
					n: $author$project$Data$Membership$initialApiState(1)
				}),
			$author$project$NativeBridge$sendCustom(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'function',
							$elm$json$Json$Encode$string('subscribe')),
							_Utils_Tuple2(
							'sponsorLevel',
							$elm$json$Json$Encode$int(
								$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(newPlan.bY)))
						]))));
	});
var $author$project$Model$Membership$Android$purchaseResult = F3(
	function (plan, response, model) {
		if (response.$ === 1) {
			var updatedModel = A3($author$project$Model$Membership$Android$updateSelectedPlan, plan, 3, model);
			return _Utils_Tuple2(
				_Utils_update(
					updatedModel,
					{
						n: $author$project$Data$Membership$apiStateWithError('Network error.')
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var apiResponse = response.a;
			var _v1 = A2(
				$author$project$Helpers$Decoders$decodeApiResponse,
				$elm$json$Json$Decode$succeed(0),
				apiResponse);
			if (_v1.$ === 1) {
				var message = _v1.a.h;
				var updatedModel = A3($author$project$Model$Membership$Android$updateSelectedPlan, plan, 3, model);
				return _Utils_Tuple2(
					_Utils_update(
						updatedModel,
						{
							n: $author$project$Data$Membership$apiStateWithError(message)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							n: $author$project$Data$Membership$initialApiState(0),
							a$: 1,
							c4: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Model$Membership$Android$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var newPlan = msg.a;
				return _Utils_Tuple2(
					A3($author$project$Model$Membership$Android$updateSelectedPlan, newPlan, 0, model),
					$elm$core$Platform$Cmd$none);
			case 1:
				var newPlan = msg.a;
				return _Utils_Tuple2(
					A3($author$project$Model$Membership$Android$updateSelectedPlan, newPlan, 1, model),
					$elm$core$Platform$Cmd$none);
			case 2:
				var newPlan = msg.a;
				return A2($author$project$Model$Membership$Android$confirmSelectedPlan, newPlan, model);
			case 3:
				var plan = msg.a;
				var result = msg.b;
				return A3($author$project$Model$Membership$Android$purchaseResult, plan, result, model);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							n: $author$project$Data$Membership$initialApiState(1)
						}),
					$author$project$NativeBridge$sendCustom(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'function',
									$elm$json$Json$Encode$string('restorePurchase'))
								]))));
			case 5:
				var result = msg.a;
				return A2($author$project$Model$Membership$Android$checkTokenResult, result, model);
			default:
				var sponsorLevel = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$NativeBridge$sendCustom(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'function',
									$elm$json$Json$Encode$string('manageSubscriptions')),
									_Utils_Tuple2(
									'sponsorLevel',
									$elm$json$Json$Encode$int(
										$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(sponsorLevel)))
								]))));
		}
	});
var $author$project$Data$Membership$Ios$BelongedToAnotherAppleAccount = 3;
var $author$project$Data$Membership$Ios$BelongedToAnotherUser = 2;
var $author$project$Model$Membership$Ios$checkReceiptResult = F2(
	function (response, model) {
		if (response.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						n: $author$project$Data$Membership$apiStateWithError('Network error.')
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var apiResponse = response.a;
			var _v1 = A2(
				$author$project$Helpers$Decoders$decodeApiResponse,
				$elm$json$Json$Decode$succeed(0),
				apiResponse);
			if (_v1.$ === 1) {
				var errorCode = _v1.a.cs;
				var message = _v1.a.h;
				switch (errorCode) {
					case 'API/NO_RECEIPT':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									n: $author$project$Data$Membership$initialApiState(0),
									a$: 0
								}),
							$elm$core$Platform$Cmd$none);
					case 'API/APPLE_ACCOUNT_BELONGED_TO_ANOTHER_USER':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									n: $author$project$Data$Membership$initialApiState(0),
									a$: 2
								}),
							$elm$core$Platform$Cmd$none);
					case 'API/USER_BELONGED_TO_ANOTHER_APPLE_ACCOUNT':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									n: $author$project$Data$Membership$initialApiState(0),
									a$: 3
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									n: $author$project$Data$Membership$apiStateWithError(message)
								}),
							$elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							n: $author$project$Data$Membership$initialApiState(0),
							a$: 1
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Model$Membership$Ios$confirmSelectedPlan = F2(
	function (newPlan, model) {
		var updatedModel = A3($author$project$Model$Membership$Ios$updateSelectedPlan, newPlan, 2, model);
		return _Utils_Tuple2(
			_Utils_update(
				updatedModel,
				{
					n: $author$project$Data$Membership$initialApiState(1)
				}),
			$author$project$NativeBridge$sendCustom(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'function',
							$elm$json$Json$Encode$string('preSubscribe'))
						]))));
	});
var $author$project$Model$Membership$Ios$firstPurchaseResult = F3(
	function (plan, response, model) {
		if (response.$ === 1) {
			var updatedModel = A3($author$project$Model$Membership$Ios$updateSelectedPlan, plan, 3, model);
			return _Utils_Tuple2(
				_Utils_update(
					updatedModel,
					{
						n: $author$project$Data$Membership$apiStateWithError('Network error.')
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var apiResponse = response.a;
			var _v1 = A2(
				$author$project$Helpers$Decoders$decodeApiResponse,
				$elm$json$Json$Decode$succeed(0),
				apiResponse);
			if (_v1.$ === 1) {
				var message = _v1.a.h;
				var updatedModel = A3($author$project$Model$Membership$Ios$updateSelectedPlan, plan, 3, model);
				return _Utils_Tuple2(
					_Utils_update(
						updatedModel,
						{
							n: $author$project$Data$Membership$apiStateWithError(message)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							n: $author$project$Data$Membership$initialApiState(0),
							a$: 1,
							c4: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Model$Membership$Ios$prePurchaseResult = F3(
	function (plan, response, model) {
		if (response.$ === 1) {
			var updatedModel = A3($author$project$Model$Membership$Ios$updateSelectedPlan, plan, 3, model);
			return _Utils_Tuple2(
				_Utils_update(
					updatedModel,
					{
						n: $author$project$Data$Membership$apiStateWithError('Network error.')
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var apiResponse = response.a;
			var updatedModel = _Utils_update(
				model,
				{
					n: $author$project$Data$Membership$initialApiState(0)
				});
			var _v1 = A2(
				$author$project$Helpers$Decoders$decodeApiResponse,
				$elm$json$Json$Decode$succeed(0),
				apiResponse);
			if (_v1.$ === 1) {
				var errorCode = _v1.a.cs;
				var message = _v1.a.h;
				switch (errorCode) {
					case 'API/NO_RECEIPT':
						return _Utils_Tuple2(
							model,
							$author$project$NativeBridge$sendCustom(
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'function',
											$elm$json$Json$Encode$string('subscribe')),
											_Utils_Tuple2(
											'sponsorLevel',
											$elm$json$Json$Encode$int(
												$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(plan.bY)))
										]))));
					case 'API/APPLE_ACCOUNT_BELONGED_TO_ANOTHER_USER':
						return _Utils_Tuple2(
							_Utils_update(
								updatedModel,
								{a$: 2}),
							$elm$core$Platform$Cmd$none);
					case 'API/USER_BELONGED_TO_ANOTHER_APPLE_ACCOUNT':
						return _Utils_Tuple2(
							_Utils_update(
								updatedModel,
								{a$: 3}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									n: $author$project$Data$Membership$apiStateWithError(message)
								}),
							$elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						updatedModel,
						{a$: 1}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Model$Membership$Ios$update = F3(
	function (msg, model, _v0) {
		switch (msg.$) {
			case 0:
				var newPlan = msg.a;
				return _Utils_Tuple2(
					A3($author$project$Model$Membership$Ios$updateSelectedPlan, newPlan, 0, model),
					$elm$core$Platform$Cmd$none);
			case 1:
				var newPlan = msg.a;
				return _Utils_Tuple2(
					A3($author$project$Model$Membership$Ios$updateSelectedPlan, newPlan, 1, model),
					$elm$core$Platform$Cmd$none);
			case 2:
				var newPlan = msg.a;
				return A2($author$project$Model$Membership$Ios$confirmSelectedPlan, newPlan, model);
			case 3:
				var plan = msg.a;
				var result = msg.b;
				return A3($author$project$Model$Membership$Ios$prePurchaseResult, plan, result, model);
			case 4:
				var plan = msg.a;
				var result = msg.b;
				return A3($author$project$Model$Membership$Ios$firstPurchaseResult, plan, result, model);
			case 5:
				return _Utils_Tuple2(
					model,
					$author$project$NativeBridge$sendCustom(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'function',
									$elm$json$Json$Encode$string('managePlans'))
								]))));
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							n: $author$project$Data$Membership$initialApiState(1)
						}),
					$author$project$NativeBridge$sendCustom(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'function',
									$elm$json$Json$Encode$string('refreshReceipt'))
								]))));
			default:
				var result = msg.a;
				return A2($author$project$Model$Membership$Ios$checkReceiptResult, result, model);
		}
	});
var $author$project$Type$Membership$Web$ApiResponse = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Data$Membership$Web$createTokenJsonString = F2(
	function (userID, email) {
		return $elm$json$Json$Encode$string(
			$truqu$elm_md5$MD5$hex(
				_Utils_ap(userID, email)));
	});
var $author$project$Data$Membership$Web$cancel = F3(
	function (url, userID, email) {
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'userID',
					$elm$json$Json$Encode$string(userID)),
					_Utils_Tuple2(
					'token',
					A2($author$project$Data$Membership$Web$createTokenJsonString, userID, email))
				]));
		return A2($author$project$Data$Membership$createHttp, url, params);
	});
var $author$project$Ports$Membership$checkoutToMultiCards = _Platform_outgoingPort('checkoutToMultiCards', $elm$core$Basics$identity);
var $author$project$Data$Membership$Web$freePlan = {jT: 0, mq: 'FREE', bY: 0, nR: ''};
var $author$project$Data$Membership$Web$paidPlans = _List_fromArray(
	[
		{jT: 500, mq: 'BRONZE', bY: 1, nR: 'Your Adventure Begins'},
		{jT: 1000, mq: 'SILVER', bY: 2, nR: 'You\'re Going Places'},
		{jT: 1500, mq: 'GOLD', bY: 3, nR: 'Stand Out & Be Noticed'},
		{jT: 2000, mq: 'PLATINUM', bY: 4, nR: 'Success Awaits You'},
		{jT: 2500, mq: 'DIAMOND', bY: 5, nR: 'Your Dating Wonderland'},
		{jT: 3000, mq: 'STAR', bY: 6, nR: 'You’re the Star'},
		{jT: 3500, mq: 'ULTIMATE', bY: 7, nR: 'You’re Unbeatable'}
	]);
var $author$project$Data$Membership$Web$config = {
	e9: A2($elm$core$List$cons, $author$project$Data$Membership$Web$freePlan, $author$project$Data$Membership$Web$paidPlans),
	lp: $author$project$Data$Membership$Web$freePlan,
	mK: $author$project$Data$Membership$Web$paidPlans
};
var $author$project$Data$Membership$Web$downgrade = F4(
	function (url, userID, email, sponsorLevel) {
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'userID',
					$elm$json$Json$Encode$string(userID)),
					_Utils_Tuple2(
					'token',
					A2($author$project$Data$Membership$Web$createTokenJsonString, userID, email)),
					_Utils_Tuple2(
					'sponsorLevel',
					$elm$json$Json$Encode$int(
						$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(sponsorLevel)))
				]));
		return A2($author$project$Data$Membership$createHttp, url, params);
	});
var $author$project$Data$Membership$Web$AlreadyDowngradedFor = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Data$Membership$Web$AlreadyOn = function (a) {
	return {$: 6, a: a};
};
var $author$project$Data$Membership$Web$CreateNew = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Membership$Web$CreateNewWithTrial = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Membership$Web$DowngradeTo = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Data$Membership$Web$ResubscribeTo = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Data$Membership$Web$UpgradeTo = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Data$Membership$Web$getPlan = function (sponsorLevel) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Data$Membership$Web$freePlan,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bY;
					},
					$elm$core$Basics$eq(sponsorLevel)),
				$author$project$Data$Membership$Web$config.e9)));
};
var $author$project$Data$Membership$Web$getTopupAmountInCents = F4(
	function (currentTime, nextRebillingDate, currentPlan, newPlan) {
		var timeRemainingInMonth = $elm$time$Time$posixToMillis(nextRebillingDate) - $elm$time$Time$posixToMillis(currentTime);
		var priceDiffInPlans = newPlan.jT - currentPlan.jT;
		var millisecondsInAMonth = (((30 * 24) * 60) * 60) * 1000;
		return 100 * $elm$core$Basics$floor(((timeRemainingInMonth / millisecondsInAMonth) * priceDiffInPlans) / 100);
	});
var $author$project$Data$Membership$Web$getSwitchPlanAction = F5(
	function (currentTime, sponsorLevel, newPlan, maybeNextRebillingDate, downgradeSponsorLevel) {
		if (maybeNextRebillingDate.$ === 1) {
			return (newPlan.bY === 1) ? $author$project$Data$Membership$Web$CreateNewWithTrial(newPlan) : $author$project$Data$Membership$Web$CreateNew(newPlan);
		} else {
			var nextRebillingDate = maybeNextRebillingDate.a;
			var currentPlan = $author$project$Data$Membership$Web$getPlan(sponsorLevel);
			var topupAmountInCents = A4($author$project$Data$Membership$Web$getTopupAmountInCents, currentTime, nextRebillingDate, currentPlan, newPlan);
			if (!currentPlan.bY) {
				return $author$project$Data$Membership$Web$CreateNew(newPlan);
			} else {
				if (_Utils_cmp(
					$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(newPlan.bY),
					$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(currentPlan.bY)) > 0) {
					return A3($author$project$Data$Membership$Web$UpgradeTo, newPlan, nextRebillingDate, topupAmountInCents);
				} else {
					if (downgradeSponsorLevel.$ === 1) {
						return _Utils_eq(newPlan.bY, currentPlan.bY) ? $author$project$Data$Membership$Web$AlreadyOn(newPlan) : A2($author$project$Data$Membership$Web$DowngradeTo, newPlan, nextRebillingDate);
					} else {
						var downgradeSponsorLevel_ = downgradeSponsorLevel.a;
						return ((!newPlan.bY) && (!downgradeSponsorLevel_)) ? A2($author$project$Data$Membership$Web$AlreadyDowngradedFor, newPlan, nextRebillingDate) : (_Utils_eq(newPlan.bY, currentPlan.bY) ? A2($author$project$Data$Membership$Web$ResubscribeTo, newPlan, nextRebillingDate) : (_Utils_eq(newPlan.bY, downgradeSponsorLevel_) ? A2($author$project$Data$Membership$Web$AlreadyDowngradedFor, newPlan, nextRebillingDate) : A2($author$project$Data$Membership$Web$DowngradeTo, newPlan, nextRebillingDate)));
					}
				}
			}
		}
	});
var $author$project$Data$Membership$Web$reactivate = F3(
	function (url, userID, email) {
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'userID',
					$elm$json$Json$Encode$string(userID)),
					_Utils_Tuple2(
					'token',
					A2($author$project$Data$Membership$Web$createTokenJsonString, userID, email))
				]));
		return A2($author$project$Data$Membership$createHttp, url, params);
	});
var $author$project$Model$Membership$Web$updateSelectedPlan = F3(
	function (newPlan, viewState, model) {
		return _Utils_update(
			model,
			{
				c4: $elm$core$Maybe$Just(
					{mS: newPlan, od: viewState})
			});
	});
var $author$project$Model$Membership$Web$confirmSelectedPlan = F4(
	function (_v0, currentTime, newPlan, model) {
		var sponsorLevel = _v0.bY;
		var uid = _v0.eX;
		var email = _v0.dt;
		var updatedModel = function (m) {
			return _Utils_update(
				m,
				{
					n: $author$project$Data$Membership$initialApiState(1)
				});
		}(
			A3($author$project$Model$Membership$Web$updateSelectedPlan, newPlan, 2, model));
		var _v1 = model;
		var multiCardsConfig = _v1.mn;
		var nextRebillingDate = _v1.mt;
		var downgradeSponsorLevel = _v1.kX;
		var endPoints = _v1.cr;
		var _v2 = endPoints;
		var membershipCancelUrl = _v2.ma;
		var membershipDowngradeUrl = _v2.mb;
		var membershipReactivateUrl = _v2.mc;
		var _v3 = A5($author$project$Data$Membership$Web$getSwitchPlanAction, currentTime, sponsorLevel, newPlan, nextRebillingDate, downgradeSponsorLevel);
		switch (_v3.$) {
			case 0:
				var plan = _v3.a;
				var jsonValue = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'merchantID',
							$elm$json$Json$Encode$string(multiCardsConfig.md)),
							_Utils_Tuple2(
							'pageOrderID',
							$elm$json$Json$Encode$string(multiCardsConfig.mJ)),
							_Utils_Tuple2(
							'checkoutUrl',
							$elm$json$Json$Encode$string(multiCardsConfig.kq)),
							_Utils_Tuple2(
							'userID',
							$elm$json$Json$Encode$string(uid)),
							_Utils_Tuple2(
							'plan',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string(plan.mq)),
										_Utils_Tuple2(
										'amountInCents',
										$elm$json$Json$Encode$int(plan.jT)),
										_Utils_Tuple2(
										'action',
										$elm$json$Json$Encode$string('CreateNew'))
									])))
						]));
				return _Utils_Tuple2(
					updatedModel,
					$author$project$Ports$Membership$checkoutToMultiCards(jsonValue));
			case 1:
				var plan = _v3.a;
				var jsonValue = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'merchantID',
							$elm$json$Json$Encode$string(multiCardsConfig.md)),
							_Utils_Tuple2(
							'pageOrderID',
							$elm$json$Json$Encode$string(multiCardsConfig.mJ)),
							_Utils_Tuple2(
							'checkoutUrl',
							$elm$json$Json$Encode$string(multiCardsConfig.kq)),
							_Utils_Tuple2(
							'userID',
							$elm$json$Json$Encode$string(uid)),
							_Utils_Tuple2(
							'plan',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string(plan.mq)),
										_Utils_Tuple2(
										'amountInCents',
										$elm$json$Json$Encode$int(plan.jT)),
										_Utils_Tuple2(
										'action',
										$elm$json$Json$Encode$string('CreateNewWithTrial'))
									])))
						]));
				return _Utils_Tuple2(
					updatedModel,
					$author$project$Ports$Membership$checkoutToMultiCards(jsonValue));
			case 2:
				var plan = _v3.a;
				var topupAmountInCents = _v3.c;
				var jsonValue = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'merchantID',
							$elm$json$Json$Encode$string(multiCardsConfig.md)),
							_Utils_Tuple2(
							'pageOrderID',
							$elm$json$Json$Encode$string(multiCardsConfig.mJ)),
							_Utils_Tuple2(
							'checkoutUrl',
							$elm$json$Json$Encode$string(multiCardsConfig.kq)),
							_Utils_Tuple2(
							'userID',
							$elm$json$Json$Encode$string(uid)),
							_Utils_Tuple2(
							'plan',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string(plan.mq)),
										_Utils_Tuple2(
										'amountInCents',
										$elm$json$Json$Encode$int(topupAmountInCents)),
										_Utils_Tuple2(
										'action',
										$elm$json$Json$Encode$string('UpgradeTo'))
									])))
						]));
				return _Utils_Tuple2(
					updatedModel,
					$author$project$Ports$Membership$checkoutToMultiCards(jsonValue));
			case 3:
				var plan = _v3.a;
				return _Utils_eq(plan.bY, $author$project$Data$Membership$Web$config.lp.bY) ? _Utils_Tuple2(
					updatedModel,
					A2(
						$elm$core$Task$attempt,
						$author$project$Type$Membership$Web$ApiResponse(plan),
						A3($author$project$Data$Membership$Web$cancel, membershipCancelUrl, uid, email))) : _Utils_Tuple2(
					updatedModel,
					A2(
						$elm$core$Task$attempt,
						$author$project$Type$Membership$Web$ApiResponse(plan),
						A4($author$project$Data$Membership$Web$downgrade, membershipDowngradeUrl, uid, email, plan.bY)));
			case 4:
				var plan = _v3.a;
				return _Utils_Tuple2(
					updatedModel,
					A2(
						$elm$core$Task$attempt,
						$author$project$Type$Membership$Web$ApiResponse(plan),
						A3($author$project$Data$Membership$Web$reactivate, membershipReactivateUrl, uid, email)));
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c4: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c4: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Membership$Web$updateMembershipResult = F3(
	function (plan, response, model) {
		if (response.$ === 1) {
			var updatedModel = A3($author$project$Model$Membership$Web$updateSelectedPlan, plan, 3, model);
			return _Utils_Tuple2(
				_Utils_update(
					updatedModel,
					{
						n: $author$project$Data$Membership$apiStateWithError('Network error.')
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var apiResponse = response.a;
			var _v1 = model;
			var apiState = _v1.n;
			var _v2 = A2(
				$author$project$Helpers$Decoders$decodeApiResponse,
				$elm$json$Json$Decode$succeed(0),
				apiResponse);
			if (_v2.$ === 1) {
				var message = _v2.a.h;
				var updatedModel = A3($author$project$Model$Membership$Web$updateSelectedPlan, plan, 3, model);
				return _Utils_Tuple2(
					_Utils_update(
						updatedModel,
						{
							n: $author$project$Data$Membership$apiStateWithError(message)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							n: _Utils_update(
								apiState,
								{eQ: 2}),
							c4: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Model$Membership$Web$update = F4(
	function (currentTime, msg, model, authState) {
		var _v0 = model;
		var apiState = _v0.n;
		var _v1 = $author$project$Helpers$getCurrentUserProfile(authState);
		if (_v1.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						n: _Utils_update(
							apiState,
							{
								dk: $elm$core$Maybe$Just('Missing profile')
							})
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var profile = _v1.a;
			switch (msg.$) {
				case 0:
					var newPlan = msg.a;
					return _Utils_Tuple2(
						A3($author$project$Model$Membership$Web$updateSelectedPlan, newPlan, 0, model),
						$elm$core$Platform$Cmd$none);
				case 1:
					var newPlan = msg.a;
					return _Utils_Tuple2(
						A3($author$project$Model$Membership$Web$updateSelectedPlan, newPlan, 1, model),
						$elm$core$Platform$Cmd$none);
				case 2:
					var newPlan = msg.a;
					return A4($author$project$Model$Membership$Web$confirmSelectedPlan, profile, currentTime, newPlan, model);
				default:
					var plan = msg.a;
					var result = msg.b;
					return A3($author$project$Model$Membership$Web$updateMembershipResult, plan, result, model);
			}
		}
	});
var $author$project$Model$Membership$update = F3(
	function (currentTime, msg, authState) {
		var _v0 = _Utils_Tuple2(authState.l9, msg);
		_v0$3:
		while (true) {
			switch (_v0.b.$) {
				case 0:
					if (_v0.a.$ === 1) {
						var webState = _v0.a.a;
						var webMsg = _v0.b.a;
						var _v1 = A4($author$project$Model$Membership$Web$update, currentTime, webMsg, webState, authState);
						var web = _v1.a;
						var webCmd = _v1.b;
						return _Utils_Tuple2(
							$author$project$Type$Membership$Web(web),
							A2($elm$core$Platform$Cmd$map, $author$project$Type$Membership$OnWeb, webCmd));
					} else {
						break _v0$3;
					}
				case 1:
					if (_v0.a.$ === 2) {
						var iOsState = _v0.a.a;
						var iOsMsg = _v0.b.a;
						var _v2 = A3($author$project$Model$Membership$Ios$update, iOsMsg, iOsState, authState);
						var iOs = _v2.a;
						var iOsCmd = _v2.b;
						return _Utils_Tuple2(
							$author$project$Type$Membership$Ios(iOs),
							A2($elm$core$Platform$Cmd$map, $author$project$Type$Membership$OnIos, iOsCmd));
					} else {
						break _v0$3;
					}
				default:
					if (_v0.a.$ === 3) {
						var androidState = _v0.a.a;
						var androidMsg = _v0.b.a;
						var _v3 = A2($author$project$Model$Membership$Android$update, androidMsg, androidState);
						var android = _v3.a;
						var androidCmd = _v3.b;
						return _Utils_Tuple2(
							$author$project$Type$Membership$Android(android),
							A2($elm$core$Platform$Cmd$map, $author$project$Type$Membership$OnAndroid, androidCmd));
					} else {
						break _v0$3;
					}
			}
		}
		return _Utils_Tuple2(authState.l9, $elm$core$Platform$Cmd$none);
	});
var $author$project$Form$AsString = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Core$Data$Profile$Height$Metric = 1;
var $author$project$Core$Data$Profile$Photo$deleteImage = _Platform_outgoingPort(
	'deleteImage',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string($.ho)),
					_Utils_Tuple2(
					'photoID',
					$elm$json$Json$Encode$string($.ek)),
					_Utils_Tuple2(
					'thumbnailUrl',
					$elm$json$Json$Encode$string($.nT)),
					_Utils_Tuple2(
					'url',
					$elm$json$Json$Encode$string($.n8))
				]));
	});
var $author$project$Core$Data$Profile$Photo$delete = F2(
	function (kind, _v0) {
		var id = _v0.lK;
		var url = _v0.n8;
		var thumbnailUrl = _v0.nT;
		return $author$project$Core$Data$Profile$Photo$deleteImage(
			{
				ho: $author$project$Core$Data$Profile$Photo$kindString(kind),
				ek: id,
				nT: thumbnailUrl,
				n8: url
			});
	});
var $author$project$Core$Data$Profile$Height$inchesToCm = function (inches) {
	return $elm$core$Basics$round(inches * 2.54);
};
var $author$project$NativeBridge$cameraStartWithThumbnail = F3(
	function (passThrough, maxImageWidth, maxThumbnailWidth) {
		return $author$project$NativeBridge$startCameraSession(
			{
				cH: maxImageWidth,
				cI: $elm$core$Maybe$Just(maxThumbnailWidth),
				mL: passThrough
			});
	});
var $author$project$Data$MobileCamera$encodePhotoPassThrough = function (photoKind) {
	switch (photoKind) {
		case 0:
			return $elm$json$Json$Encode$string('ForAvatar');
		case 1:
			return $elm$json$Json$Encode$string('ForPublicPhoto');
		default:
			return $elm$json$Json$Encode$string('ForPrivatePhoto');
	}
};
var $author$project$Data$MobileCamera$startCameraForProfile = function (photoKind) {
	return (!photoKind) ? A2(
		$author$project$NativeBridge$cameraStart,
		$author$project$Data$MobileCamera$encodePhotoPassThrough(photoKind),
		600) : A3(
		$author$project$NativeBridge$cameraStartWithThumbnail,
		$author$project$Data$MobileCamera$encodePhotoPassThrough(photoKind),
		1280,
		100);
};
var $author$project$Model$Profile$isSameLocations = function (model) {
	var _v0 = model;
	var components = _v0.ab;
	var form = _v0.ln;
	var _v1 = components;
	var primaryLocation = _v1.bP;
	var secondaryLocation = _v1.bU;
	return _Utils_eq(
		A2($author$project$Form$getRawString, form, primaryLocation.ct),
		A2($author$project$Form$getRawString, form, secondaryLocation.ct));
};
var $author$project$Form$getRawTime = F2(
	function (form, name) {
		var _v0 = A2($elm$core$Dict$get, name, form.j);
		if ((!_v0.$) && (_v0.a.$ === 3)) {
			var field = _v0.a.a;
			return field.v;
		} else {
			return A3(
				$author$project$Form$missingFieldWarning,
				name,
				'getRawTime',
				$elm$time$Time$millisToPosix(0));
		}
	});
var $author$project$Core$Data$Profile$Benefit$toBenefits = function (benefits) {
	return $elm$core$Result$Ok(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Result$toMaybe,
			A2($elm$core$List$map, $author$project$Core$Data$Profile$Benefit$toBenefit, benefits)));
};
var $author$project$Core$Data$Profile$SponsorLevel$toSponsorLevelFromString = function (sponsorLevel) {
	switch (sponsorLevel) {
		case 'Free':
			return $elm$core$Result$Ok(0);
		case 'Anyone':
			return $elm$core$Result$Ok(0);
		case 'Bronze':
			return $elm$core$Result$Ok(1);
		case 'Silver':
			return $elm$core$Result$Ok(2);
		case 'Gold':
			return $elm$core$Result$Ok(3);
		case 'Platinum':
			return $elm$core$Result$Ok(4);
		case 'Diamond':
			return $elm$core$Result$Ok(5);
		case 'Star':
			return $elm$core$Result$Ok(6);
		case 'Ultimate':
			return $elm$core$Result$Ok(7);
		default:
			return $elm$core$Result$Err('SponsorLevel field is invalid.');
	}
};
var $author$project$Core$Data$Profile$WantRelationship$toWantRelationships = function (wantRelationships) {
	return $elm$core$Result$Ok(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Result$toMaybe,
			A2($elm$core$List$map, $author$project$Core$Data$Profile$WantRelationship$toWantRelationship, wantRelationships)));
};
var $author$project$Core$Data$Profile$updateProfileWithFields = F2(
	function (profile, fields) {
		var updatedSponsorLevel = (!profile.eY) ? profile.bY : A2(
			$elm$core$Result$withDefault,
			1,
			$author$project$Core$Data$Profile$SponsorLevel$toSponsorLevelFromString(fields.bY));
		return _Utils_update(
			profile,
			{
				b6: fields.b6,
				cc: fields.cc,
				bg: A2(
					$elm$core$Maybe$withDefault,
					profile.bg,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$Benefit$toBenefits(fields.bg))),
				cf: fields.cf,
				bi: A2(
					$elm$core$Maybe$withDefault,
					profile.bi,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$BodyType$toBodyType(fields.bi))),
				bm: A2(
					$elm$core$Maybe$withDefault,
					profile.bm,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$Drinker$toDrinker(fields.bm))),
				bn: A2(
					$elm$core$Maybe$withDefault,
					profile.bn,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$Education$toEducation(fields.bn))),
				bo: A2(
					$elm$core$Maybe$withDefault,
					profile.bo,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$Ethnicity$toEthnicity(fields.bo))),
				bt: A2(
					$elm$core$Maybe$withDefault,
					profile.bt,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$Gender$toGender(fields.bt))),
				cy: fields.cy,
				bu: A2(
					$elm$core$Maybe$withDefault,
					profile.bu,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$Height$toHeight(fields.bu))),
				bz: A2(
					$elm$core$Maybe$withDefault,
					profile.bz,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$LifestyleExpectation$toLifestyleExpectation(fields.bz))),
				cE: fields.cE,
				bB: A2(
					$elm$core$Maybe$withDefault,
					profile.bB,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$MaritalStatus$toMaritalStatus(fields.bB))),
				bF: A2(
					$elm$core$Maybe$withDefault,
					profile.bF,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$NumberOfChildren$toNumberOfChildren(fields.bF))),
				cN: fields.cN,
				cP: fields.cP,
				cZ: fields.cZ,
				bW: A2(
					$elm$core$Maybe$withDefault,
					profile.bW,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$Smoker$toSmoker(fields.bW))),
				bY: updatedSponsorLevel,
				dh: fields.dh,
				di: $author$project$Core$Data$Profile$WantGender$toWantGender(fields.di),
				b4: A2(
					$elm$core$Maybe$withDefault,
					profile.b4,
					$elm$core$Result$toMaybe(
						$author$project$Core$Data$Profile$WantRelationship$toWantRelationships(fields.b4)))
			});
	});
var $author$project$Model$Profile$updateProfileWithForm = F3(
	function (profile, privatePhotos, form) {
		var secondaryLocation = A2($author$project$Form$getRawString, form, 'secondaryLocation');
		var primaryLocation = A2($author$project$Form$getRawString, form, 'primaryLocation');
		var fields = {
			b6: A2($author$project$Form$getRawString, form, 'aboutMe'),
			cc: profile.cc,
			bg: A2($author$project$Form$getRawListString, form, 'benefits'),
			cf: A2($author$project$Form$getRawTime, form, 'birthday'),
			bi: A2($author$project$Form$getRawString, form, 'bodyType'),
			bm: A2($author$project$Form$getRawString, form, 'drinker'),
			bn: A2($author$project$Form$getRawString, form, 'education'),
			bo: A2($author$project$Form$getRawString, form, 'ethnicity'),
			bt: A2($author$project$Form$getRawString, form, 'gender'),
			cy: A2($author$project$Form$getRawString, form, 'headline'),
			bu: A2($author$project$Form$getRawString, form, 'height'),
			bz: A2($author$project$Form$getRawString, form, 'lifestyleExpectation'),
			cE: _List_fromArray(
				[primaryLocation, secondaryLocation]),
			bB: A2($author$project$Form$getRawString, form, 'maritalStatus'),
			bF: A2($author$project$Form$getRawString, form, 'numberOfChildren'),
			cN: A2($author$project$Form$getRawString, form, 'occupation'),
			cP: A2($author$project$Form$getRawString, form, 'otherBenefit'),
			cZ: $elm$core$List$length(privatePhotos),
			bW: A2($author$project$Form$getRawString, form, 'smoker'),
			bY: A2($author$project$Form$getRawString, form, 'sponsorLevel'),
			dh: A2($author$project$Form$getRawString, form, 'username'),
			di: A2($author$project$Form$getRawString, form, 'wantGender'),
			b4: A2($author$project$Form$getRawListString, form, 'wantRelationships')
		};
		return A2($author$project$Core$Data$Profile$updateProfileWithFields, profile, fields);
	});
var $author$project$Model$Profile$submitForm = F3(
	function (authState, appModel, model) {
		var validateResults = _List_fromArray(
			[
				$author$project$Form$isFormValid(model.ln),
				!$author$project$Model$Profile$isSameLocations(model)
			]);
		if (A2(
			$elm$core$List$all,
			$elm$core$Basics$eq(true),
			validateResults)) {
			var _v0 = model;
			var form = _v0.ln;
			var profile = _v0.iu;
			var privatePhotos = _v0.bR;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						b8: $author$project$Data$Alert$clear,
						j1: $elm$core$Maybe$Just(
							_Utils_update(
								authState,
								{
									iu: $author$project$Type$Profile$IsSynced(
										_Utils_update(
											model,
											{
												ln: _Utils_update(
													form,
													{jc: true})
											}))
								}))
					}),
				A2(
					$author$project$Core$Data$Profile$updateProfile,
					$author$project$Model$Profile$channelIDs.jy,
					A3($author$project$Model$Profile$updateProfileWithForm, profile, privatePhotos, form)));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						b8: A2($author$project$Data$Alert$addFailure, 'Your profile is incompleted. Please check it again.', appModel.b8)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Core$Data$Profile$Photo$toKind = function (string) {
	switch (string) {
		case 'Avatar':
			return $elm$core$Result$Ok(0);
		case 'Public':
			return $elm$core$Result$Ok(1);
		case 'Private':
			return $elm$core$Result$Ok(2);
		default:
			return $elm$core$Result$Err('Invalid string value for kind: ' + string);
	}
};
var $author$project$Helpers$AutoComplete$Model$blurInput = function (_v0) {
	var model = _v0.a;
	var action = _v0.b;
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[action])));
};
var $author$project$Helpers$AutoComplete$Model$getNextValue = F3(
	function (firstValue, currentValue, values) {
		getNextValue:
		while (true) {
			if (currentValue.$ === 1) {
				return firstValue;
			} else {
				var value = currentValue.a;
				if (values.b) {
					if (values.b.b) {
						var first = values.a;
						var _v2 = values.b;
						var next = _v2.a;
						var rest = _v2.b;
						if (_Utils_eq(first, value)) {
							return $elm$core$Maybe$Just(next);
						} else {
							var $temp$firstValue = firstValue,
								$temp$currentValue = currentValue,
								$temp$values = A2($elm$core$List$cons, next, rest);
							firstValue = $temp$firstValue;
							currentValue = $temp$currentValue;
							values = $temp$values;
							continue getNextValue;
						}
					} else {
						return firstValue;
					}
				} else {
					return firstValue;
				}
			}
		}
	});
var $author$project$Helpers$AutoComplete$Model$highlightNextValue = F2(
	function (currentValue, values) {
		var firstValue = $elm$core$List$head(values);
		return A3($author$project$Helpers$AutoComplete$Model$getNextValue, firstValue, currentValue, values);
	});
var $author$project$Helpers$AutoComplete$Model$highlightPreviousValue = F2(
	function (currentValue, values) {
		highlightPreviousValue:
		while (true) {
			if (currentValue.$ === 1) {
				return $elm$core$List$head(
					$elm$core$List$reverse(values));
			} else {
				var value = currentValue.a;
				if (values.b) {
					if (values.b.b) {
						var first = values.a;
						var _v2 = values.b;
						var next = _v2.a;
						var rest = _v2.b;
						if (_Utils_eq(next, value)) {
							return $elm$core$Maybe$Just(first);
						} else {
							var $temp$currentValue = currentValue,
								$temp$values = A2($elm$core$List$cons, next, rest);
							currentValue = $temp$currentValue;
							values = $temp$values;
							continue highlightPreviousValue;
						}
					} else {
						var last = values.a;
						return $elm$core$Maybe$Just(last);
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $author$project$Helpers$AutoComplete$Model$newHighlightedValueModel = F2(
	function (highlightedValue, model) {
		if (!highlightedValue.$) {
			var value = highlightedValue.a;
			return $author$project$Helpers$AutoComplete$Model$noCmd(
				_Utils_update(
					model,
					{
						au: $elm$core$Maybe$Just(value),
						R: $elm$core$Maybe$Just(value),
						V: model.V,
						N: model.N
					}));
		} else {
			return $author$project$Helpers$AutoComplete$Model$noCmd(
				_Utils_update(
					model,
					{au: $elm$core$Maybe$Nothing, R: model.R, V: model.V, N: model.N}));
		}
	});
var $author$project$Helpers$AutoComplete$Model$newKeywordModel = F3(
	function (keyword, result, model) {
		return $author$project$Helpers$AutoComplete$Model$noCmd(
			_Utils_update(
				model,
				{au: $elm$core$Maybe$Nothing, R: keyword, V: result, N: model.N}));
	});
var $author$project$Helpers$AutoComplete$Model$newSelectedValueModel = F2(
	function (selectedValue, model) {
		var sanitizedValue = $elm$core$String$trim(selectedValue);
		var keyword = $elm$core$String$isEmpty(sanitizedValue) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(selectedValue);
		return $author$project$Helpers$AutoComplete$Model$noCmd(
			_Utils_update(
				model,
				{au: $elm$core$Maybe$Nothing, R: keyword, V: $elm$core$Maybe$Nothing, N: sanitizedValue}));
	});
var $author$project$Helpers$AutoComplete$Model$resetModel = function (model) {
	return $author$project$Helpers$AutoComplete$Model$noCmd(
		_Utils_update(
			model,
			{au: $elm$core$Maybe$Nothing, R: $elm$core$Maybe$Nothing, V: $elm$core$Maybe$Nothing, N: ''}));
};
var $author$project$Helpers$AutoComplete$Model$search = F2(
	function (data, keyword) {
		var pattern = '(.*' + (keyword + '.*-.*\n)');
		var regex = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			A2(
				$elm$regex$Regex$fromStringWith,
				{kk: true, mo: true},
				pattern));
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.l7;
			},
			A2($elm$regex$Regex$find, regex, data));
	});
var $author$project$Helpers$AutoComplete$Model$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 5:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var fieldValue = msg.a;
				return A2($author$project$Helpers$AutoComplete$Model$newSelectedValueModel, fieldValue, model);
			case 1:
				var keyword = msg.a;
				return ($elm$core$String$length(keyword) >= 3) ? A3(
					$author$project$Helpers$AutoComplete$Model$newKeywordModel,
					$elm$core$Maybe$Just(keyword),
					$elm$core$Maybe$Just(
						A2($author$project$Helpers$AutoComplete$Model$search, model.kH, keyword)),
					model) : A3(
					$author$project$Helpers$AutoComplete$Model$newKeywordModel,
					$elm$core$Maybe$Just(keyword),
					$elm$core$Maybe$Nothing,
					model);
			case 2:
				var _v1 = model;
				var keyword = _v1.R;
				var selectedValue = _v1.N;
				if (!keyword.$) {
					if (keyword.a === '') {
						return A2($author$project$Helpers$AutoComplete$Model$newSelectedValueModel, '', model);
					} else {
						return A2($author$project$Helpers$AutoComplete$Model$newSelectedValueModel, selectedValue, model);
					}
				} else {
					return A2($author$project$Helpers$AutoComplete$Model$newSelectedValueModel, selectedValue, model);
				}
			case 3:
				var keyPressed = msg.a;
				var _v3 = model;
				var highlightedValue = _v3.au;
				var result = _v3.V;
				if (result.$ === 1) {
					switch (keyPressed) {
						case 0:
							return $author$project$Helpers$AutoComplete$Model$noCmd(model);
						case 1:
							return $author$project$Helpers$AutoComplete$Model$noCmd(model);
						default:
							return $author$project$Helpers$AutoComplete$Model$blurInput(
								$author$project$Helpers$AutoComplete$Model$resetModel(model));
					}
				} else {
					var result_ = result.a;
					switch (keyPressed) {
						case 0:
							return A2(
								$author$project$Helpers$AutoComplete$Model$newHighlightedValueModel,
								A2($author$project$Helpers$AutoComplete$Model$highlightPreviousValue, highlightedValue, result_),
								model);
						case 1:
							return A2(
								$author$project$Helpers$AutoComplete$Model$newHighlightedValueModel,
								A2($author$project$Helpers$AutoComplete$Model$highlightNextValue, highlightedValue, result_),
								model);
						default:
							if (highlightedValue.$ === 1) {
								return $author$project$Helpers$AutoComplete$Model$blurInput(
									$author$project$Helpers$AutoComplete$Model$resetModel(model));
							} else {
								var value = highlightedValue.a;
								return $author$project$Helpers$AutoComplete$Model$blurInput(
									A2($author$project$Helpers$AutoComplete$Model$newSelectedValueModel, value, model));
							}
					}
				}
			default:
				var _v8 = model.R;
				if ((!_v8.$) && (_v8.a === '')) {
					return A2($author$project$Helpers$AutoComplete$Model$newSelectedValueModel, '', model);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Helpers$City$Model$update = F2(
	function (msg, model) {
		var autoCompleteMsg = msg;
		var _v1 = A2($author$project$Helpers$AutoComplete$Model$update, autoCompleteMsg, model.dm);
		var autoCompleteModel = _v1.a;
		var autoCompleteAction = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dm: autoCompleteModel, gA: autoCompleteModel.N}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, autoCompleteAction));
	});
var $author$project$Model$Profile$updateComponent = F2(
	function (componentMsg, model) {
		switch (componentMsg.a) {
			case 'primaryLocation':
				var cityMsg = componentMsg.b;
				var _v1 = model;
				var components = _v1.ab;
				var form = _v1.ln;
				var _v2 = A2($author$project$Helpers$City$Model$update, cityMsg, components.bP);
				var primaryLocation = _v2.a;
				var action = _v2.b;
				var updatedForm = A2(
					$author$project$Form$updateForm,
					form,
					A2($author$project$Form$AsString, primaryLocation.ct, primaryLocation.gA));
				if ($author$project$Model$Profile$isSameLocations(
					_Utils_update(
						model,
						{ln: updatedForm}))) {
					var updatedField = $author$project$Form$addFieldError('Primary Location cannot be the same as Secondary Location');
					var updatedFields = A3($elm$core$Dict$update, primaryLocation.ct, updatedField, updatedForm.j);
					var newErrorForm = _Utils_update(
						updatedForm,
						{j: updatedFields});
					return _Utils_Tuple2(
						$author$project$Type$Profile$IsSynced(
							_Utils_update(
								model,
								{
									ab: _Utils_update(
										components,
										{bP: primaryLocation}),
									ln: newErrorForm
								})),
						A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Type$Profile$ComponentMsg,
								$author$project$Type$Profile$InputCityMsg('primaryLocation')),
							action));
				} else {
					return _Utils_Tuple2(
						$author$project$Type$Profile$IsSynced(
							_Utils_update(
								model,
								{
									ab: _Utils_update(
										components,
										{bP: primaryLocation}),
									ln: updatedForm
								})),
						A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Type$Profile$ComponentMsg,
								$author$project$Type$Profile$InputCityMsg('primaryLocation')),
							action));
				}
			case 'secondaryLocation':
				var cityMsg = componentMsg.b;
				var _v3 = model;
				var components = _v3.ab;
				var form = _v3.ln;
				var _v4 = A2($author$project$Helpers$City$Model$update, cityMsg, components.bU);
				var secondaryLocation = _v4.a;
				var action = _v4.b;
				var updatedForm = A2(
					$author$project$Form$updateForm,
					form,
					A2($author$project$Form$AsString, secondaryLocation.ct, secondaryLocation.gA));
				if ($author$project$Model$Profile$isSameLocations(
					_Utils_update(
						model,
						{ln: updatedForm}))) {
					var updatedField = $author$project$Form$addFieldError('Secondary Location cannot be the same as Primary Location');
					var updatedFields = A3($elm$core$Dict$update, secondaryLocation.ct, updatedField, updatedForm.j);
					var newErrorForm = _Utils_update(
						updatedForm,
						{j: updatedFields});
					return _Utils_Tuple2(
						$author$project$Type$Profile$IsSynced(
							_Utils_update(
								model,
								{
									ab: _Utils_update(
										components,
										{bU: secondaryLocation}),
									ln: newErrorForm
								})),
						A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Type$Profile$ComponentMsg,
								$author$project$Type$Profile$InputCityMsg('secondaryLocation')),
							action));
				} else {
					return _Utils_Tuple2(
						$author$project$Type$Profile$IsSynced(
							_Utils_update(
								model,
								{
									ab: _Utils_update(
										components,
										{bU: secondaryLocation}),
									ln: updatedForm
								})),
						A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Type$Profile$ComponentMsg,
								$author$project$Type$Profile$InputCityMsg('secondaryLocation')),
							action));
				}
			default:
				return _Utils_Tuple2(
					$author$project$Type$Profile$IsSynced(model),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Core$Data$Profile$Photo$updateUploadStatus = F2(
	function (uploadStatus, photos) {
		if (photos.b) {
			var photo = photos.a;
			var rest = photos.b;
			return _Utils_eq(photo.lK, uploadStatus.mP.lK) ? A2(
				$elm$core$List$cons,
				_Utils_update(
					photo,
					{n8: uploadStatus.mP.n8}),
				rest) : A2(
				$elm$core$List$cons,
				photo,
				A2($author$project$Core$Data$Profile$Photo$updateUploadStatus, uploadStatus, rest));
		} else {
			return _List_fromArray(
				[
					{
					cm: $elm$time$Time$millisToPosix(uploadStatus.mP.cm),
					lK: uploadStatus.mP.lK,
					nT: uploadStatus.mP.nT,
					n8: uploadStatus.mP.n8
				}
				]);
		}
	});
var $author$project$Core$Data$Profile$Photo$uploadImage = _Platform_outgoingPort(
	'uploadImage',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fileInputID',
					$elm$json$Json$Encode$string($.dw)),
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string($.ho))
				]));
	});
var $author$project$Core$Data$Profile$Photo$upload = F2(
	function (fieldName, kind) {
		return $author$project$Core$Data$Profile$Photo$uploadImage(
			{
				dw: fieldName,
				ho: $author$project$Core$Data$Profile$Photo$kindString(kind)
			});
	});
var $author$project$Model$Profile$update = F3(
	function (msg, appModel, authState) {
		var model = authState.iu;
		var mapAppModel = function (profileModel) {
			return _Utils_update(
				appModel,
				{
					j1: $elm$core$Maybe$Just(
						_Utils_update(
							authState,
							{iu: profileModel}))
				});
		};
		var _v0 = appModel;
		var device = _v0.kQ;
		if (!model.$) {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		} else {
			var syncedModel = model.a;
			switch (msg.$) {
				case 0:
					var fieldMsg = msg.a;
					return _Utils_Tuple2(
						mapAppModel(
							$author$project$Type$Profile$IsSynced(
								_Utils_update(
									syncedModel,
									{
										ln: A2($author$project$Form$updateForm, syncedModel.ln, fieldMsg)
									}))),
						$elm$core$Platform$Cmd$none);
				case 4:
					var fieldName = msg.a;
					var photoKind = msg.b;
					return $author$project$NativeBridge$isMobileApp(device) ? _Utils_Tuple2(
						mapAppModel(
							$author$project$Type$Profile$IsSynced(syncedModel)),
						$author$project$Data$MobileCamera$startCameraForProfile(photoKind)) : _Utils_Tuple2(
						mapAppModel(
							$author$project$Type$Profile$IsSynced(syncedModel)),
						A2($author$project$Core$Data$Profile$Photo$upload, fieldName, photoKind));
				case 5:
					var photo = msg.a;
					var photoKind = msg.b;
					return _Utils_Tuple2(
						mapAppModel(
							$author$project$Type$Profile$IsSynced(syncedModel)),
						A2($author$project$Core$Data$Profile$Photo$delete, photoKind, photo));
				case 6:
					var uploadStatus = msg.a;
					var profile = syncedModel.iu;
					var photoKind = $author$project$Core$Data$Profile$Photo$toKind(uploadStatus.ho);
					if (!photoKind.$) {
						switch (photoKind.a) {
							case 1:
								var _v4 = photoKind.a;
								return _Utils_Tuple2(
									mapAppModel(
										$author$project$Type$Profile$IsSynced(
											_Utils_update(
												syncedModel,
												{
													m5: A2($author$project$Core$Data$Profile$Photo$updateUploadStatus, uploadStatus, syncedModel.m5)
												}))),
									$elm$core$Platform$Cmd$none);
							case 2:
								var _v5 = photoKind.a;
								return _Utils_Tuple2(
									mapAppModel(
										$author$project$Type$Profile$IsSynced(
											_Utils_update(
												syncedModel,
												{
													bR: A2($author$project$Core$Data$Profile$Photo$updateUploadStatus, uploadStatus, syncedModel.bR)
												}))),
									$elm$core$Platform$Cmd$none);
							default:
								var _v6 = photoKind.a;
								return _Utils_Tuple2(
									mapAppModel(
										$author$project$Type$Profile$IsSynced(
											_Utils_update(
												syncedModel,
												{
													iu: _Utils_update(
														profile,
														{cc: uploadStatus.mP.n8})
												}))),
									$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
					}
				case 1:
					var componentMsg = msg.a;
					var _v7 = A2($author$project$Model$Profile$updateComponent, componentMsg, syncedModel);
					var profileModel = _v7.a;
					var componentCmd = _v7.b;
					return _Utils_Tuple2(
						mapAppModel(profileModel),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Types$OnAuth,
							A2($elm$core$Platform$Cmd$map, $author$project$Types$OnProfile, componentCmd)));
				case 2:
					var _v8 = syncedModel;
					var heightUnit = _v8.cz;
					var form = _v8.ln;
					if (!heightUnit) {
						return _Utils_Tuple2(
							mapAppModel(
								$author$project$Type$Profile$IsSynced(
									_Utils_update(
										syncedModel,
										{cz: 1}))),
							$elm$core$Platform$Cmd$none);
					} else {
						var updatedForm = A2(
							$author$project$Form$updateForm,
							form,
							A2(
								$author$project$Form$AsString,
								'height',
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$elm$core$String$fromInt,
										A2(
											$elm$core$Maybe$map,
											$author$project$Core$Data$Profile$Height$inchesToCm,
											A2(
												$elm$core$Maybe$map,
												$author$project$Core$Data$Profile$Height$cmToInches,
												$elm$core$String$toInt(
													A2($author$project$Form$getRawString, form, 'height'))))))));
						return _Utils_Tuple2(
							mapAppModel(
								$author$project$Type$Profile$IsSynced(
									_Utils_update(
										syncedModel,
										{ln: updatedForm, cz: 0}))),
							$elm$core$Platform$Cmd$none);
					}
				case 3:
					return A3($author$project$Model$Profile$submitForm, authState, appModel, syncedModel);
				default:
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Model$RelatedProfiles$loadMore = F3(
	function (connectKind, authState, model) {
		var _v0 = authState.j2;
		var uid = _v0.eX;
		var _v1 = model;
		var viewedMe = _v1.oe;
		var favoritedMe = _v1.li;
		var favoriteProfile = _v1.lh;
		var profilesPerPage = _v1.ix;
		switch (connectKind) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							oe: _Utils_update(
								viewedMe,
								{A: viewedMe.A + profilesPerPage})
						}),
					A3($author$project$Model$RelatedProfiles$syncRelatedProfilesIDs, 0, uid, viewedMe.A + profilesPerPage));
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							li: _Utils_update(
								favoritedMe,
								{A: favoritedMe.A + profilesPerPage})
						}),
					A3($author$project$Model$RelatedProfiles$syncRelatedProfilesIDs, 1, uid, favoritedMe.A + profilesPerPage));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							lh: _Utils_update(
								favoriteProfile,
								{A: viewedMe.A + profilesPerPage})
						}),
					A3($author$project$Model$RelatedProfiles$syncRelatedProfilesIDs, 2, uid, favoriteProfile.A + profilesPerPage));
		}
	});
var $author$project$Model$RelatedProfiles$update = F2(
	function (msg, authState) {
		var model = authState.iD;
		var connectKind = msg;
		return A3($author$project$Model$RelatedProfiles$loadMore, connectKind, authState, model);
	});
var $author$project$Type$Search$ExecuteDelayCmd = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Type$Search$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Model$Search$update = F3(
	function (msg, adminUserIDs, authState) {
		var model = authState.nm;
		switch (msg.$) {
			case 2:
				var delayCmdID = msg.a;
				var cmd = msg.b;
				return _Utils_eq(delayCmdID, model.cp) ? _Utils_Tuple2(model, cmd) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var fieldMsg = msg.a;
				var delayCmdID = model.cp + 1;
				var _v1 = model;
				var form = _v1.ln;
				var updatedForm = A2($author$project$Form$updateForm, form, fieldMsg);
				var updatedModel = _Utils_update(
					model,
					{ln: updatedForm});
				if (fieldMsg.$ === 1) {
					return _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							updatedModel,
							{cp: delayCmdID, iw: $elm$core$Maybe$Nothing}),
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always(
								A2(
									$author$project$Type$Search$ExecuteDelayCmd,
									delayCmdID,
									A3($author$project$Model$Search$getProfilesCmd, form, updatedModel, $author$project$Model$Search$channelIDs.eH))),
							$elm$core$Process$sleep(500)));
				}
			case 1:
				var cityMsg = msg.a;
				var _v3 = model;
				var location = _v3.hy;
				var form = _v3.ln;
				var _v4 = A2($author$project$Helpers$City$Model$update, cityMsg, location);
				var updatedLocation = _v4.a;
				var action = _v4.b;
				var updatedModel = _Utils_update(
					model,
					{hy: updatedLocation});
				return (!_Utils_eq(
					updatedLocation.gA,
					A2($author$project$Form$getRawString, form, 'location'))) ? A2(
					$elm$core$Tuple$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Type$Search$InputCityMsg, action),
									cmd
								]));
					},
					A3(
						$author$project$Model$Search$update,
						$author$project$Type$Search$FormMsg(
							A2($author$project$Form$AsString, updatedLocation.ct, updatedLocation.gA)),
						adminUserIDs,
						_Utils_update(
							authState,
							{nm: updatedModel}))) : _Utils_Tuple2(
					updatedModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Type$Search$InputCityMsg, action));
			default:
				return _Utils_Tuple2(
					model,
					A3($author$project$Model$Search$getProfilesCmd, model.ln, model, $author$project$Model$Search$channelIDs.dZ));
		}
	});
var $author$project$Model$UpdatePassword$submitForm = F2(
	function (email, model) {
		if ($author$project$Form$isFormValid(model.ln)) {
			var _v0 = model;
			var form = _v0.ln;
			var newPassword = A2($author$project$Form$getRawString, form, 'newPassword');
			var oldPassword = A2($author$project$Form$getRawString, form, 'oldPassword');
			var passwordConfirmation = A2($author$project$Form$getRawString, form, 'passwordConfirmation');
			var updatedForm = _Utils_update(
				form,
				{jc: true});
			return (!_Utils_eq(newPassword, passwordConfirmation)) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dk: $elm$core$Maybe$Just('New Password and Confirmation Password are not the same')
					}),
				$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
				_Utils_update(
					model,
					{dk: $elm$core$Maybe$Nothing, ln: updatedForm, hi: false}),
				A2($author$project$Firebase$Auth$signInWithEmailAndPassword, email, oldPassword));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dk: $elm$core$Maybe$Just('Check your form')
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$UpdatePassword$update = F2(
	function (msg, authState) {
		var model = authState.n6;
		var form = model.ln;
		if (msg.$ === 1) {
			var fieldMsg = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						ln: A2($author$project$Form$updateForm, form, fieldMsg)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return A2($author$project$Model$UpdatePassword$submitForm, authState.j2.dt, model);
		}
	});
var $author$project$Model$updateAuthState = F3(
	function (authorizedMsg, model, authState) {
		var _v0 = model;
		var currentTime = _v0.kG;
		var adminUserIDs = _v0.jQ;
		switch (authorizedMsg.$) {
			case 0:
				var chatMsg = authorizedMsg.a;
				return A3($author$project$Model$Chat$update, chatMsg, authState, model);
			case 1:
				var emailVerificationMsg = authorizedMsg.a;
				var _v2 = A2($author$project$Model$EmailVerification$update, emailVerificationMsg, authState);
				var emailVerificationModel = _v2.a;
				var emailVerificationCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{gm: emailVerificationModel}))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2($elm$core$Platform$Cmd$map, $author$project$Types$OnEmailVerification, emailVerificationCmd)));
			case 2:
				var faceVerificationMsg = authorizedMsg.a;
				var _v3 = $author$project$Model$FaceVerification$update(faceVerificationMsg);
				var faceVerificationStatus = _v3.a;
				var faceVerificationCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{gx: faceVerificationStatus}))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2($elm$core$Platform$Cmd$map, $author$project$Types$OnFaceVerification, faceVerificationCmd)));
			case 4:
				var relatedProfilesMsg = authorizedMsg.a;
				var _v4 = A2($author$project$Model$RelatedProfiles$update, relatedProfilesMsg, authState);
				var relatedProfilesModel = _v4.a;
				var relatedProfilesCmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{iD: relatedProfilesModel}))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2($elm$core$Platform$Cmd$map, $author$project$Types$OnRelatedProfiles, relatedProfilesCmd)));
			case 3:
				var searchMsg = authorizedMsg.a;
				var _v5 = A3($author$project$Model$Search$update, searchMsg, adminUserIDs, authState);
				var searchModel = _v5.a;
				var searchCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{nm: searchModel}))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2($elm$core$Platform$Cmd$map, $author$project$Types$OnSearch, searchCmd)));
			case 5:
				var detailMsg = authorizedMsg.a;
				return A3($author$project$Model$Detail$update, detailMsg, authState, model);
			case 6:
				var profileMsg = authorizedMsg.a;
				return A3($author$project$Model$Profile$update, profileMsg, model, authState);
			case 7:
				var deactivateMsg = authorizedMsg.a;
				var _v6 = A2($author$project$Model$Deactivate$update, deactivateMsg, authState);
				var deactivateModel = _v6.a;
				var deactivateCmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{gc: deactivateModel}))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2($elm$core$Platform$Cmd$map, $author$project$Types$OnDeactivate, deactivateCmd)));
			case 8:
				var updatePasswordMsg = authorizedMsg.a;
				var _v7 = A2($author$project$Model$UpdatePassword$update, updatePasswordMsg, authState);
				var updatePasswordModel = _v7.a;
				var updatePasswordCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{n6: updatePasswordModel}))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2($elm$core$Platform$Cmd$map, $author$project$Types$OnUpdatePassword, updatePasswordCmd)));
			case 9:
				var membershipMsg = authorizedMsg.a;
				var _v8 = A3($author$project$Model$Membership$update, currentTime, membershipMsg, authState);
				var membershipModel = _v8.a;
				var membershipCmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j1: $elm$core$Maybe$Just(
								_Utils_update(
									authState,
									{l9: membershipModel}))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2($elm$core$Platform$Cmd$map, $author$project$Types$OnMembership, membershipCmd)));
			default:
				var blockMsg = authorizedMsg.a;
				return A3($author$project$Model$Block$update, blockMsg, authState, model);
		}
	});
var $author$project$Model$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return A2($author$project$Model$Channel$update, response, model);
			case 1:
				var url = msg.a;
				return A2($author$project$Model$Route$onUrlChange, url, model);
			case 2:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return function (_v2) {
						var updatedModel = _v2.a;
						var cmd = _v2.b;
						return _Utils_Tuple2(
							_Utils_update(
								updatedModel,
								{b8: $author$project$Data$Alert$clear, d$: 1}),
							cmd);
					}(
						A2($author$project$Model$Route$onInternalUrlRequest, url, model));
				} else {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(url));
				}
			case 3:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kG: time}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var zone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jp: zone}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var user = msg.a;
				return A2($author$project$Model$onAuthStateChangedHandler, user, model);
			case 6:
				var nativeBridgeMsg = msg.a;
				return A2($author$project$Model$onNativeBridge, nativeBridgeMsg, model);
			case 7:
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$back, model.bD, 1));
			case 9:
				var loginMsg = msg.a;
				return A2($author$project$Model$Login$update, loginMsg, model);
			case 10:
				var registerMsg = msg.a;
				return A2($author$project$Model$Register$update, registerMsg, model);
			case 8:
				var forgetPasswordMsg = msg.a;
				return A2($author$project$Model$ForgetPassword$update, forgetPasswordMsg, model);
			case 11:
				var contentMsg = msg.a;
				return A2($author$project$Model$Content$update, contentMsg, model);
			case 12:
				var width = msg.a;
				var height = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kR: {ni: height, nj: width}
						}),
					$author$project$Model$Chat$onWindowResize(model));
			case 13:
				var authorizedMsg = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Model$updateAuthState, authorizedMsg, model),
						model.j1));
			case 14:
				var status = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d$: status}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var tagger = msg.a;
				return _Utils_Tuple2(
					model,
					A2($elm$core$Task$perform, tagger, $elm$time$Time$now));
			case 16:
				var alert = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b8: A2($author$project$Data$Alert$remove, alert, model.b8)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$View$Layout$NoHeaderLayout = 0;
var $author$project$View$Layout$OrangeLayout = 2;
var $author$project$View$Layout$TransparentLayout = 1;
var $author$project$Type$EmailVerification$SendEmail = {$: 0};
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$a = $rtfeldman$elm_css$Html$Styled$node('a');
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$attribute = $rtfeldman$elm_css$VirtualDom$Styled$attribute;
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.b;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.kK) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.mq, record.kK, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{kK: decl, mq: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
	var _v0 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v0.a;
	var compactedDeclarations = _v0.b;
	return A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
};
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.fS;
	var imports = _v0.g5;
	var namespaces = _v0.hP;
	var declarations = _v0.kL;
	return {
		fS: charset,
		kL: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
		g5: imports,
		hP: namespaces
	};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$String$mapJoinHelp = F4(
	function (map, sep, strs, result) {
		mapJoinHelp:
		while (true) {
			if (!strs.b) {
				return result;
			} else {
				if (!strs.b.b) {
					var first = strs.a;
					return result + (map(first) + '');
				} else {
					var first = strs.a;
					var rest = strs.b;
					var $temp$map = map,
						$temp$sep = sep,
						$temp$strs = rest,
						$temp$result = result + (map(first) + (sep + ''));
					map = $temp$map;
					sep = $temp$sep;
					strs = $temp$strs;
					result = $temp$result;
					continue mapJoinHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$Css$String$mapJoin = F3(
	function (map, sep, strs) {
		return A4($rtfeldman$elm_css$Css$String$mapJoinHelp, map, sep, strs, '');
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.gz + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.v)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, ' and ', expressions);
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
		'\n',
		mediaQueries);
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (prop) {
			return prop + ';';
		},
		'',
		properties);
};
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors);
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (' ' + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
	return A2(
		$elm$core$String$append,
		A2($elm$core$String$join, ' ', segments),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
	var firstSelector = _v0.a;
	var otherSelectors = _v0.b;
	var properties = _v0.c;
	var selectorStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
		',',
		A2($elm$core$List$cons, firstSelector, otherSelectors));
	return selectorStr + ('{' + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + '}'));
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ', ', mediaQueries);
			var blocks = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, '\n', styleBlocks);
			return '@media ' + (query + ('{' + (blocks + '}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.mq;
			var declaration = decl.a.kK;
			return '@keyframes ' + (name + ('{' + (declaration + '}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.fS;
	var imports = _v0.g5;
	var namespaces = _v0.hP;
	var declarations = _v0.kL;
	return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$importToString, '\n', imports) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, '\n', namespaces) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, '\n', declarations) + '')));
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							var _v9 = declarations.a;
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {aK: charsProcessed, aT: hash, E: seed, a2: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.aT)) ? (data.E ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.aT)))) : data.E;
	var h0 = acc ^ data.aK;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.aT | ((255 & $elm$core$Char$toCode(c)) << data.a2);
		var _v0 = data.a2;
		if (_v0 === 24) {
			return {
				aK: data.aK + 1,
				aT: 0,
				E: A2($robinheghan$murmur3$Murmur3$mix, data.E, res),
				a2: 0
			};
		} else {
			return {aK: data.aK + 1, aT: res, E: data.E, a2: data.a2 + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$initialSeed = 15739;
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($robinheghan$murmur3$Murmur3$hashString, $rtfeldman$elm_css$Hash$initialSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var str = declaration.a;
								var properties = declaration.b;
								return _List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{kK: str, mq: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var str = snippetDeclaration.a;
			var properties = snippetDeclaration.b;
			return _List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.fS;
	var imports = _v0.g5;
	var namespaces = _v0.hP;
	var snippets = _v0.i4;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {fS: charset, kL: declarations, g5: imports, hP: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {fS: $elm$core$Maybe$Nothing, g5: _List_Nil, hP: _List_Nil, i4: snippets};
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = '\u0007';
var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
	if (!styles.b) {
		return '';
	} else {
		var otherwise = styles;
		return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet, styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
					])));
	}
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classProperty = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, true, cssTemplate);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.v);
};
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$block = {o: 0, v: 'block'};
var $rtfeldman$elm_css$Css$bold = {ae: 0, v: 'bold'};
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.v + (' ' + (argB.v + (' ' + argC.v))));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-color', c.v);
};
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.v);
	});
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.v);
};
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		be: 1,
		bh: 0,
		P: 0,
		lv: 0,
		m8: 0,
		v: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				be: alpha / 255,
				bh: blue,
				P: 0,
				lv: green,
				m8: red,
				v: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $author$project$View$Theme$colors = {
	fs: $rtfeldman$elm_css$Css$hex('000000'),
	lv: $rtfeldman$elm_css$Css$hex('A5C63D'),
	lw: $rtfeldman$elm_css$Css$hex('F9F9F9'),
	gN: $rtfeldman$elm_css$Css$hex('F2F2F2'),
	lx: $rtfeldman$elm_css$Css$hex('E6E6E6'),
	gO: $rtfeldman$elm_css$Css$hex('BDBDBD'),
	ly: $rtfeldman$elm_css$Css$hex('828282'),
	lz: $rtfeldman$elm_css$Css$hex('4F4F4F'),
	lA: $rtfeldman$elm_css$Css$hex('333333'),
	l$: $rtfeldman$elm_css$Css$hex('FFF4F0'),
	eh: $rtfeldman$elm_css$Css$hex('F36023'),
	m8: $rtfeldman$elm_css$Css$hex('ED2626'),
	og: $rtfeldman$elm_css$Css$hex('FFFFFF')
};
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$stringsToValue = function (list) {
	return $elm$core$List$isEmpty(list) ? {v: 'none'} : {
		v: A2($elm$core$String$join, ', ', list)
	};
};
var $rtfeldman$elm_css$Css$fontFamilies = A2(
	$elm$core$Basics$composeL,
	$rtfeldman$elm_css$Css$prop1('font-family'),
	$rtfeldman$elm_css$Css$stringsToValue);
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.v;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $elm$core$String$fromFloat = _String_fromNumber;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			e0: 0,
			fI: 0,
			aP: 0,
			y: 0,
			by: 0,
			aW: 0,
			aj: 0,
			aX: 0,
			aY: 0,
			av: 0,
			aw: 0,
			S: 0,
			al: numericValue,
			a5: 0,
			a8: unitLabel,
			b1: units,
			v: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $author$project$View$Theme$fonts = {
	lf: {
		cg: _List_fromArray(
			['Open Sans', 'sans-serif']),
		gT: _List_fromArray(
			['Prata', 'serif'])
	},
	ns: {
		j4: $rtfeldman$elm_css$Css$px(22),
		j5: $rtfeldman$elm_css$Css$px(28),
		j6: $rtfeldman$elm_css$Css$px(36),
		mB: $rtfeldman$elm_css$Css$px(14),
		nt: $rtfeldman$elm_css$Css$px(12),
		i2: $rtfeldman$elm_css$Css$px(10)
	}
};
var $rtfeldman$elm_css$Css$Media$feature = F2(
	function (key, _v0) {
		var value = _v0.v;
		return {
			gz: key,
			v: $elm$core$Maybe$Just(value)
		};
	});
var $rtfeldman$elm_css$Css$Media$maxWidth = function (value) {
	return A2($rtfeldman$elm_css$Css$Media$feature, 'max-width', value);
};
var $rtfeldman$elm_css$Css$Structure$OnlyQuery = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Media$only = $rtfeldman$elm_css$Css$Structure$OnlyQuery;
var $rtfeldman$elm_css$Css$Structure$Screen = 1;
var $rtfeldman$elm_css$Css$Media$screen = 1;
var $rtfeldman$elm_css$Css$Preprocess$WithMedia = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Media$withMedia = $rtfeldman$elm_css$Css$Preprocess$WithMedia;
var $author$project$View$Theme$forDinosaurMobileScreen = $rtfeldman$elm_css$Css$Media$withMedia(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$only,
			$rtfeldman$elm_css$Css$Media$screen,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Media$maxWidth(
					$rtfeldman$elm_css$Css$px(576))
				]))
		]));
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $rtfeldman$elm_css$Css$minHeight = $rtfeldman$elm_css$Css$prop1('min-height');
var $rtfeldman$elm_css$Css$noWrap = {br: 0, cx: 0, v: 'nowrap', aq: 0};
var $rtfeldman$elm_css$Css$none = {aH: 0, fu: 0, C: 0, d: 0, o: 0, lH: 0, hb: 0, dW: 0, aY: 0, av: 0, S: 0, f: 0, e: 0, d3: 0, cT: 0, mU: 0, L: 0, c_: 0, nk: 0, a4: 0, aD: 0, F: 0, l: 0, n5: 0, v: 'none'};
var $rtfeldman$elm_css$Css$normal = {dv: 0, aQ: 0, ae: 0, ej: 0, v: 'normal', aq: 0};
var $rtfeldman$elm_css$Css$outline = $rtfeldman$elm_css$Css$prop1('outline');
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.v + (' ' + argB.v));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $rtfeldman$elm_css$Css$pointer = {d: 0, v: 'pointer'};
var $rtfeldman$elm_css$Css$solid = {C: 0, aC: 0, v: 'solid'};
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$textDecoration = $rtfeldman$elm_css$Css$prop1('text-decoration');
var $rtfeldman$elm_css$Css$transparent = {P: 0, v: 'transparent'};
var $rtfeldman$elm_css$Css$underline = {a4: 0, v: 'underline'};
var $rtfeldman$elm_css$Css$whiteSpace = $rtfeldman$elm_css$Css$prop1('white-space');
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$zero = {by: 0, aW: 0, aj: 0, aX: 0, aY: 0, av: 0, aw: 0, mD: 0, al: 0, cT: 0, a8: '', b1: 0, v: '0'};
var $author$project$View$Theme$defaultStyles = {
	e$: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
				]))
		]),
	kd: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz)
		]),
	ci: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(20)),
			A3($rtfeldman$elm_css$Css$border3, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$solid, $author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.m8),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	kj: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$borderColor($author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.m8)
				]))
		]),
	kz: F2(
		function (screenHeight, hasAlert) {
			return hasAlert ? _List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(screenHeight - 113)),
					$author$project$View$Theme$forDinosaurMobileScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$px(screenHeight - 131))
						]))
				]) : _List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(screenHeight - 65))
				]);
		}),
	kA: F2(
		function (screenHeight, hasAlert) {
			return hasAlert ? _List_fromArray(
				[
					$rtfeldman$elm_css$Css$minHeight(
					$rtfeldman$elm_css$Css$px(screenHeight - 113)),
					$author$project$View$Theme$forDinosaurMobileScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$minHeight(
							$rtfeldman$elm_css$Css$px(screenHeight - 131))
						]))
				]) : _List_fromArray(
				[
					$rtfeldman$elm_css$Css$minHeight(
					$rtfeldman$elm_css$Css$px(screenHeight - 65))
				]);
		}),
	lt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8),
					$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
					$rtfeldman$elm_css$Css$borderColor($author$project$View$Theme$colors.m8)
				]))
		]),
	lC: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j5),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal)
		]),
	ht: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
				]))
		])
};
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $rtfeldman$elm_css$Html$Styled$hr = $rtfeldman$elm_css$Html$Styled$node('hr');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Html$Styled$p = $rtfeldman$elm_css$Html$Styled$node('p');
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $author$project$Page$EmailNotVerified$view = function (authState) {
	var styles = {
		f1: _List_Nil,
		cl: $author$project$View$Theme$defaultStyles.kd,
		gS: $author$project$View$Theme$defaultStyles.lC,
		ht: _Utils_ap(
			$author$project$View$Theme$defaultStyles.ht,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
				]))
	};
	var model = authState.gm;
	var header = A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.gS)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Verify Your Email'),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil)
			]));
	var _v0 = model;
	var status = _v0.eQ;
	switch (status.$) {
		case 0:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
					]),
				_List_fromArray(
					[
						header,
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.cl)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Please Check Your Email (and the Spam Folder) to Verify Your Email to Start Viewing the Exciting Profiles of Other Users.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.cl)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('If You Did Not Receive the Verification Email, Please Click '),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.ht),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'verifyUrl'),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Types$OnAuth(
											$author$project$Types$OnEmailVerification($author$project$Type$EmailVerification$SendEmail)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Here')
									]))
							]))
					]));
		case 1:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
					]),
				_List_fromArray(
					[
						header,
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.cl)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Sending Verification Email to Your Inbox...')
							]))
					]));
		case 2:
			var message = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
					]),
				_List_fromArray(
					[
						header,
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.cl)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Error: ' + message)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.cl)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Please Try Again '),
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.ht),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Types$OnAuth(
											$author$project$Types$OnEmailVerification($author$project$Type$EmailVerification$SendEmail)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Here')
									]))
							]))
					]));
		default:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
					]),
				_List_fromArray(
					[
						header,
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.cl)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Verification Email is Sent Out Successfully.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.cl)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Please Check Your Email (and the Spam Folder) to Verify Your Email to Start Viewing the Exciting Profiles of Other Users.')
							]))
					]));
	}
};
var $author$project$View$checkEmailIsVerified = F2(
	function (authState, profileModel) {
		return (!profileModel.iu.ob.dt) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				0,
				$author$project$Page$EmailNotVerified$view(authState))) : $elm$core$Maybe$Nothing;
	});
var $rtfeldman$elm_css$Css$calcExpressionToString = function (expression) {
	if (!expression) {
		return '+';
	} else {
		return '-';
	}
};
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ',', args) + ')'));
	});
var $rtfeldman$elm_css$Css$calc = F3(
	function (firstExpr, expression, secondExpr) {
		var withoutCalcStr = function (l) {
			return A2($elm$core$String$startsWith, 'calc(', l.v) ? A2($elm$core$String$dropLeft, 4, l.v) : l.v;
		};
		var calcs = withoutCalcStr(firstExpr) + (' ' + ($rtfeldman$elm_css$Css$calcExpressionToString(expression) + (' ' + withoutCalcStr(secondExpr))));
		var value = A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'calc',
			_List_fromArray(
				[calcs]));
		return {fI: 0, aP: 0, y: 0, by: 0, aW: 0, aj: 0, aX: 0, aY: 0, av: 0, aw: 0, S: 0, a5: 0, v: value};
	});
var $rtfeldman$elm_css$Css$row = {dx: 0, br: 0, v: 'row'};
var $rtfeldman$elm_css$Css$column = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{v: 'column'});
var $rtfeldman$elm_css$Css$displayFlex = A2($rtfeldman$elm_css$Css$property, 'display', 'flex');
var $rtfeldman$elm_css$Css$flexDirection = $rtfeldman$elm_css$Css$prop1('flex-direction');
var $author$project$View$Theme$forMobileScreen = $rtfeldman$elm_css$Css$Media$withMedia(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$only,
			$rtfeldman$elm_css$Css$Media$screen,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Media$maxWidth(
					$rtfeldman$elm_css$Css$px(767))
				]))
		]));
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $rtfeldman$elm_css$Css$Subtraction = 1;
var $rtfeldman$elm_css$Css$minus = 1;
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $author$project$Page$Profile$profileNotCompleted = function () {
	var styles = {
		kg: _List_fromArray(
			[
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
					]))
			]),
		f1: _Utils_ap(
			$author$project$View$Theme$defaultStyles.kd,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(11),
					$rtfeldman$elm_css$Css$px(20)),
					$rtfeldman$elm_css$Css$width(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$pct(100),
						$rtfeldman$elm_css$Css$minus,
						$rtfeldman$elm_css$Css$px(40))),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.l$),
					$rtfeldman$elm_css$Css$fontSize(
					$rtfeldman$elm_css$Css$px(14)),
					$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$lineHeight(
					$rtfeldman$elm_css$Css$px(22)),
					$author$project$View$Theme$forMobileScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]))
	};
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Complete Your Profile to Start Viewing the Exciting Profiles of Other Users.')
					]))
			]));
}();
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Html$Styled$img = $rtfeldman$elm_css$Html$Styled$node('img');
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$src = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'src', url);
};
var $author$project$View$Display$simpleLoadingView = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$padding(
					$rtfeldman$elm_css$Css$px(40))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv)
				]),
			_List_Nil)
		]));
var $author$project$Type$Profile$SubmitForm = {$: 3};
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $author$project$View$Form$biggerSubmitButton = function (isSubmitting) {
	return isSubmitting ? A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap(
					$author$project$View$Theme$defaultStyles.ci,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Css$padding2,
							$rtfeldman$elm_css$Css$px(10),
							$rtfeldman$elm_css$Css$px(120))
						]))),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Submit')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Submitting...')
			])) : A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap(
					$author$project$View$Theme$defaultStyles.ci,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Css$padding2,
							$rtfeldman$elm_css$Css$px(10),
							$rtfeldman$elm_css$Css$px(120))
						]))),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(false),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Submit')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Submit')
			]));
};
var $rtfeldman$elm_css$Html$Styled$form = $rtfeldman$elm_css$Html$Styled$node('form');
var $rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
};
var $rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onSubmit = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $rtfeldman$elm_css$Css$fontStyle = $rtfeldman$elm_css$Css$prop1('font-style');
var $rtfeldman$elm_css$Css$italic = {aQ: 0, v: 'italic'};
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $author$project$Page$Profile$View$styles = {
	fE: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic)
			])),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN)
		]),
	gd: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
					]))
			])),
	cQ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15))
		]),
	jJ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og)
		])
};
var $author$project$Type$Profile$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$Profile$ToggleHeightUnit = {$: 2};
var $rtfeldman$elm_css$Css$backgroundImage = $rtfeldman$elm_css$Css$prop1('background-image');
var $author$project$Type$Profile$UploadImage = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$absolute = {bO: 0, v: 'absolute'};
var $rtfeldman$elm_css$Html$Styled$Attributes$for = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('htmlFor');
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $author$project$Page$Profile$BasicInfo$hiddenInputFile = function (device) {
	return $author$project$NativeBridge$isMobileApp(device) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
		$rtfeldman$elm_css$Html$Styled$input,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('file'),
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
					])),
				$rtfeldman$elm_css$Html$Styled$Attributes$id('AvatarFileID'),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$on,
				'change',
				$elm$json$Json$Decode$succeed(
					$author$project$Types$OnAuth(
						$author$project$Types$OnProfile(
							A2($author$project$Type$Profile$UploadImage, 'AvatarFileID', 0)))))
			]),
		_List_Nil);
};
var $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node('label');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$right = $rtfeldman$elm_css$Css$prop1('right');
var $rtfeldman$elm_css$Css$backgroundPosition = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'backgroundPosition',
		'background-position',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$backgroundRepeat = $rtfeldman$elm_css$Css$prop1('background-repeat');
var $rtfeldman$elm_css$Css$backgroundSize = $rtfeldman$elm_css$Css$prop1('background-size');
var $rtfeldman$elm_css$Css$borderBottom3 = $rtfeldman$elm_css$Css$prop3('border-bottom');
var $rtfeldman$elm_css$Css$cover = {aj: 0, v: 'cover'};
var $rtfeldman$elm_css$Css$flexGrow = $rtfeldman$elm_css$Css$prop1('flex-grow');
var $rtfeldman$elm_css$Css$flexWrap = $rtfeldman$elm_css$Css$prop1('flex-wrap');
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Css$margin2 = $rtfeldman$elm_css$Css$prop2('margin');
var $rtfeldman$elm_css$Css$marginBottom = $rtfeldman$elm_css$Css$prop1('margin-bottom');
var $rtfeldman$elm_css$Css$marginRight = $rtfeldman$elm_css$Css$prop1('margin-right');
var $rtfeldman$elm_css$Css$middle = $rtfeldman$elm_css$Css$prop1('middle');
var $rtfeldman$elm_css$Css$noRepeat = {aI: 0, Y: 0, v: 'no-repeat'};
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		aw: 0,
		S: 0,
		mD: 0,
		cM: 0,
		al: val,
		a8: '',
		b1: 0,
		v: $elm$core$String$fromFloat(val)
	};
};
var $rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.v + (' ' + (argB.v + (' ' + (argC.v + (' ' + argD.v))))));
	});
var $rtfeldman$elm_css$Css$padding4 = $rtfeldman$elm_css$Css$prop4('padding');
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $rtfeldman$elm_css$Css$paddingLeft = $rtfeldman$elm_css$Css$prop1('padding-left');
var $rtfeldman$elm_css$Css$paddingRight = $rtfeldman$elm_css$Css$prop1('padding-right');
var $rtfeldman$elm_css$Css$paddingTop = $rtfeldman$elm_css$Css$prop1('padding-top');
var $rtfeldman$elm_css$Css$relative = {bO: 0, v: 'relative'};
var $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1('space-between');
var $rtfeldman$elm_css$Css$table = {o: 0, v: 'table'};
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $rtfeldman$elm_css$Css$verticalAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'verticalAlign',
		'vertical-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$wrap = {br: 0, cx: 0, v: 'wrap'};
var $author$project$Page$Profile$BasicInfo$styles = {
	fc: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(2))),
			$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
			$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(6)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gN),
			A2($rtfeldman$elm_css$Css$property, 'padding-top', 'calc(100% - 2px)'),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$table)
		]),
	ce: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(50),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(8))),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	cu: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(25),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(15))),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$paddingRight($rtfeldman$elm_css$Css$zero)
				]))
		]),
	cv: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	bs: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(5)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$paddingTop($rtfeldman$elm_css$Css$zero)
				]))
		]),
	gP: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(15))
		]),
	gQ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(6),
			$rtfeldman$elm_css$Css$px(6),
			$rtfeldman$elm_css$Css$px(3),
			$rtfeldman$elm_css$Css$px(6)),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$right(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	gU: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(50),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(8))),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	gV: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	gW: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$flexGrow(
			$rtfeldman$elm_css$Css$num(2)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$pct(50),
						$rtfeldman$elm_css$Css$minus,
						$rtfeldman$elm_css$Css$px(8)))
				]))
		]),
	dD: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$px(-10)),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(12)),
				$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic)
			])),
	bv: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-2)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(14))
		]),
	hq: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(25),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(15))),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	hT: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(140))
		]),
	hU: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-2)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(15))
		]),
	hV: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(6)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly),
					$rtfeldman$elm_css$Css$borderColor($author$project$View$Theme$colors.ly),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	hW: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(22))
		]),
	hX: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
				$rtfeldman$elm_css$Css$top(
				$rtfeldman$elm_css$Css$pct(30)),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$width(
				A3(
					$rtfeldman$elm_css$Css$calc,
					$rtfeldman$elm_css$Css$pct(100),
					$rtfeldman$elm_css$Css$minus,
					$rtfeldman$elm_css$Css$px(40))),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	cV: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gN)
		]),
	iK: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(75)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$paddingLeft($rtfeldman$elm_css$Css$zero)
				]))
		]),
	dd: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(13)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
				$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle)
			])),
	de: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero)
		])
};
var $author$project$Page$Profile$BasicInfo$hasAvatarUploader = F2(
	function (device, avatarUrl) {
		return (A2($elm$core$String$startsWith, 'blob:', avatarUrl) || A2($elm$core$String$startsWith, 'data:', avatarUrl)) ? A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
							$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$px(50))
						]))
				]),
			_List_Nil) : A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.gQ),
					$rtfeldman$elm_css$Html$Styled$Attributes$for('AvatarFileID'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnProfile(
							A2($author$project$Type$Profile$UploadImage, 'AvatarFileID', 0))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.gP),
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.mN)
						]),
					_List_Nil),
					$author$project$Page$Profile$BasicInfo$hiddenInputFile(device)
				]));
	});
var $author$project$Page$Profile$BasicInfo$noneAvatarUploader = function (device) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.hX)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.hW)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Upload your Profile Photo to increase your profile views significantly.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.hT)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap($author$project$View$Theme$defaultStyles.lt, $author$project$Page$Profile$BasicInfo$styles.hV)),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnProfile(
										A2($author$project$Type$Profile$UploadImage, 'AvatarFileID', 0))))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.hU),
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.io)
									]),
								_List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('Upload Photo'),
								$author$project$Page$Profile$BasicInfo$hiddenInputFile(device)
							]))
					]))
			]));
};
var $rtfeldman$elm_css$Css$url = function (urlValue) {
	return {aH: 0, v: 'url(' + (urlValue + ')')};
};
var $author$project$Page$Profile$BasicInfo$avatarField = F2(
	function (device, avatar) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$backgroundImage(
								$rtfeldman$elm_css$Css$url(avatar))
							]),
						$author$project$Page$Profile$BasicInfo$styles.fc))
				]),
			(avatar === '') ? _List_fromArray(
				[
					$author$project$Page$Profile$BasicInfo$noneAvatarUploader(device)
				]) : _List_fromArray(
				[
					A2($author$project$Page$Profile$BasicInfo$hasAvatarUploader, device, avatar)
				]));
	});
var $author$project$Form$Helpers$getFieldErrorMessage = function (field) {
	var _v0 = field.x;
	if (!_v0.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var message = _v0.a;
		return $elm$core$Maybe$Just(message);
	}
};
var $author$project$Form$Helpers$getErrorMessage = F2(
	function (form, fieldName) {
		var field = A2($elm$core$Dict$get, fieldName, form.j);
		if (field.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var taggedField = field.a;
			switch (taggedField.$) {
				case 0:
					var field_ = taggedField.a;
					return $author$project$Form$Helpers$getFieldErrorMessage(field_);
				case 1:
					var field_ = taggedField.a;
					return $author$project$Form$Helpers$getFieldErrorMessage(field_);
				case 2:
					var field_ = taggedField.a;
					return $author$project$Form$Helpers$getFieldErrorMessage(field_);
				default:
					var field_ = taggedField.a;
					return $author$project$Form$Helpers$getFieldErrorMessage(field_);
			}
		}
	});
var $author$project$View$Form$displayValidationError = F2(
	function (form, fieldName) {
		var _v0 = A2($author$project$Form$Helpers$getErrorMessage, form, fieldName);
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var msg = _v0.a;
			return ($elm$core$String$length(msg) > 0) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							$author$project$View$Theme$defaultStyles.kd,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
								]))),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', fieldName + 'Error')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(msg)
					])) : $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $rtfeldman$elm_css$VirtualDom$Styled$mapAttribute = F2(
	function (transform, _v0) {
		var prop = _v0.a;
		var isCssStyle = _v0.b;
		var cssTemplate = _v0.c;
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$mapAttribute, transform, prop),
			isCssStyle,
			cssTemplate);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$map = F2(
	function (transform, vdomNode) {
		switch (vdomNode.$) {
			case 0:
				var elemType = vdomNode.a;
				var properties = vdomNode.b;
				var children = vdomNode.c;
				return A3(
					$rtfeldman$elm_css$VirtualDom$Styled$Node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$map(transform),
						children));
			case 1:
				var ns = vdomNode.a;
				var elemType = vdomNode.b;
				var properties = vdomNode.c;
				var children = vdomNode.d;
				return A4(
					$rtfeldman$elm_css$VirtualDom$Styled$NodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$map(transform),
						children));
			case 2:
				var elemType = vdomNode.a;
				var properties = vdomNode.b;
				var children = vdomNode.c;
				return A3(
					$rtfeldman$elm_css$VirtualDom$Styled$KeyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var key = _v1.a;
							var child = _v1.b;
							return _Utils_Tuple2(
								key,
								A2($rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
						},
						children));
			case 3:
				var ns = vdomNode.a;
				var elemType = vdomNode.b;
				var properties = vdomNode.c;
				var children = vdomNode.d;
				return A4(
					$rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						function (_v2) {
							var key = _v2.a;
							var child = _v2.b;
							return _Utils_Tuple2(
								key,
								A2($rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
						},
						children));
			default:
				var vdom = vdomNode.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
					A2($elm$virtual_dom$VirtualDom$map, transform, vdom));
		}
	});
var $rtfeldman$elm_css$Html$Styled$map = $rtfeldman$elm_css$VirtualDom$Styled$map;
var $author$project$Helpers$AutoComplete$Types$ExitWithoutSelection = {$: 2};
var $rtfeldman$elm_css$Css$fixed = {bf: 0, bO: 0, c8: 0, v: 'fixed'};
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		ae: 0,
		cB: 0,
		aw: 0,
		S: 0,
		mD: 0,
		cM: 0,
		al: val,
		a8: '',
		b1: 0,
		v: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$VhUnits = 0;
var $rtfeldman$elm_css$Css$vh = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vh');
var $rtfeldman$elm_css$Css$VwUnits = 0;
var $rtfeldman$elm_css$Css$vw = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vw');
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $author$project$View$Display$clickBlanket = F3(
	function (zIndex, msg, isVisible) {
		return isVisible ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
							$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$vw(100)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$vh(100)),
							$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
							$rtfeldman$elm_css$Css$zIndex(
							$rtfeldman$elm_css$Css$int(zIndex))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'clickBlanket')
				]),
			_List_Nil) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Helpers$AutoComplete$Types$ArrowDown = 1;
var $author$project$Helpers$AutoComplete$Types$ArrowUp = 0;
var $author$project$Helpers$AutoComplete$Types$Enter = 2;
var $author$project$Helpers$AutoComplete$Types$Input = function (a) {
	return {$: 1, a: a};
};
var $author$project$Helpers$AutoComplete$Types$OnBlur = {$: 4};
var $author$project$Helpers$AutoComplete$Types$OnKeyUp = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete = function (bool) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $rtfeldman$elm_css$Html$Styled$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$placeholder = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('placeholder');
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$Helpers$AutoComplete$View$inputView = F2(
	function (styles, model) {
		var onKeyUp = A2(
			$rtfeldman$elm_css$Html$Styled$Events$on,
			'keyup',
			A2(
				$elm$json$Json$Decode$andThen,
				function (keyCode) {
					switch (keyCode) {
						case 38:
							return $elm$json$Json$Decode$succeed(
								$author$project$Helpers$AutoComplete$Types$OnKeyUp(0));
						case 40:
							return $elm$json$Json$Decode$succeed(
								$author$project$Helpers$AutoComplete$Types$OnKeyUp(1));
						case 13:
							return $elm$json$Json$Decode$succeed(
								$author$project$Helpers$AutoComplete$Types$OnKeyUp(2));
						default:
							return $elm$json$Json$Decode$fail(
								$elm$core$String$fromInt(keyCode));
					}
				},
				$rtfeldman$elm_css$Html$Styled$Events$keyCode));
		var _v0 = model;
		var keyword = _v0.R;
		var inputDomID = _v0.lQ;
		var inputValue = A2($elm$core$Maybe$withDefault, '', keyword);
		return A2(
			$rtfeldman$elm_css$Html$Styled$input,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Helpers$AutoComplete$Types$Input),
					$rtfeldman$elm_css$Html$Styled$Attributes$value(inputValue),
					onKeyUp,
					$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(styles.mR),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$on,
					'blur',
					$elm$json$Json$Decode$succeed($author$project$Helpers$AutoComplete$Types$OnBlur)),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(inputDomID),
					$rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.lP),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', inputDomID)
				]),
			_List_Nil);
	});
var $rtfeldman$elm_css$Html$Styled$li = $rtfeldman$elm_css$Html$Styled$node('li');
var $author$project$Helpers$AutoComplete$Types$Select = function (a) {
	return {$: 0, a: a};
};
var $author$project$Helpers$AutoComplete$View$resultItem = F3(
	function (styles, highlightedValue, fieldValue) {
		var highlightedStyle = function () {
			if (!highlightedValue.$) {
				var value = highlightedValue.a;
				return _Utils_eq(value, fieldValue) ? styles.lF : _List_Nil;
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Helpers$AutoComplete$Types$Select(fieldValue)),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(styles.V, highlightedStyle))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(fieldValue)
				]));
	});
var $rtfeldman$elm_css$Html$Styled$ul = $rtfeldman$elm_css$Html$Styled$node('ul');
var $author$project$Helpers$AutoComplete$View$resultsView = F4(
	function (styles, inputDomID, highlightedValue, result) {
		var attributeDataTest = A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', inputDomID + 'Result');
		return $elm$core$List$isEmpty(result) ? A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.nd),
					attributeDataTest
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.V)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('No city found.')
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.nd),
					attributeDataTest
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Helpers$AutoComplete$View$resultItem, styles, highlightedValue),
				result));
	});
var $author$project$Helpers$AutoComplete$View$view = F2(
	function (styles, model) {
		var _v0 = model;
		var highlightedValue = _v0.au;
		var result = _v0.V;
		var inputDomID = _v0.lQ;
		if (result.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
					]),
				_List_fromArray(
					[
						A2($author$project$Helpers$AutoComplete$View$inputView, styles, model)
					]));
		} else {
			var result_ = result.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
					]),
				_List_fromArray(
					[
						A2($author$project$Helpers$AutoComplete$View$inputView, styles, model),
						A4($author$project$Helpers$AutoComplete$View$resultsView, styles, inputDomID, highlightedValue, result_),
						A3($author$project$View$Display$clickBlanket, 9, $author$project$Helpers$AutoComplete$Types$ExitWithoutSelection, true)
					]));
		}
	});
var $author$project$Helpers$City$View$cityFieldWithStyles = F3(
	function (styles, _v0, _v1) {
		var form = _v0.ln;
		var model = _v0.mk;
		var fieldName = _v1.ct;
		var label = _v1.dX;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.dX)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$elm$core$Basics$identity,
					A2($author$project$Helpers$AutoComplete$View$view, styles.lP, model.dm)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.gs)
						]),
					_List_fromArray(
						[
							A2($author$project$View$Form$displayValidationError, form, fieldName)
						]))
				]));
	});
var $rtfeldman$elm_css$Css$focus = $rtfeldman$elm_css$Css$pseudoClass('focus');
var $rtfeldman$elm_css$Css$listStyleType = $rtfeldman$elm_css$Css$prop1('list-style-type');
var $rtfeldman$elm_css$Css$maxHeight = $rtfeldman$elm_css$Css$prop1('max-height');
var $rtfeldman$elm_css$Css$minWidth = $rtfeldman$elm_css$Css$prop1('min-width');
var $rtfeldman$elm_css$Css$overflowY = $rtfeldman$elm_css$Css$prop1('overflow-y');
var $rtfeldman$elm_css$Css$scroll = {bf: 0, fu: 0, hb: 0, aZ: 0, nl: 0, v: 'scroll'};
var $author$project$Helpers$AutoComplete$View$defaultStyles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	lF: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gN)
		]),
	lP: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(7)),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(16))),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.l$),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$View$Theme$colors.eh),
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				]))
		]),
	mR: '',
	V: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(7)),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh),
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gN),
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
					]))
			])),
	nd: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(10)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(400)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$vh(40)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll)
		])
};
var $author$project$Helpers$City$View$defaultStyles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero)
		]),
	gs: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	lP: $author$project$Helpers$AutoComplete$View$defaultStyles,
	dX: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(5))
		])
};
var $author$project$View$Form$getInputBorderColor = F2(
	function (form, fieldName) {
		var _v0 = A2($author$project$Form$Helpers$getErrorMessage, form, fieldName);
		if (_v0.$ === 1) {
			return $author$project$View$Theme$colors.gO;
		} else {
			var msg = _v0.a;
			return ($elm$core$String$length(msg) > 0) ? $author$project$View$Theme$colors.eh : $author$project$View$Theme$colors.gO;
		}
	});
var $author$project$Helpers$City$View$cityField = F2(
	function (info, params) {
		var updatedInput = _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(5),
				$rtfeldman$elm_css$Css$px(7)),
				$rtfeldman$elm_css$Css$width(
				A3(
					$rtfeldman$elm_css$Css$calc,
					$rtfeldman$elm_css$Css$pct(100),
					$rtfeldman$elm_css$Css$minus,
					$rtfeldman$elm_css$Css$px(16))),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				A2($author$project$View$Form$getInputBorderColor, info.ln, params.ct)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(4)),
				$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$focus(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.l$),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$View$Theme$colors.eh),
						$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
					]))
			]);
		var autoCompleteStyle = $author$project$Helpers$AutoComplete$View$defaultStyles;
		var updatedAutoCompleteStyle = _Utils_update(
			autoCompleteStyle,
			{lP: updatedInput});
		var styles = _Utils_update(
			$author$project$Helpers$City$View$defaultStyles,
			{lP: updatedAutoCompleteStyle});
		return A3($author$project$Helpers$City$View$cityFieldWithStyles, styles, info, params);
	});
var $rtfeldman$elm_css$Css$border = $rtfeldman$elm_css$Css$prop1('border');
var $rtfeldman$elm_css$Css$borderBox = {dn: 0, ch: 0, v: 'border-box'};
var $rtfeldman$elm_css$Css$borderLeft3 = $rtfeldman$elm_css$Css$prop3('border-left');
var $rtfeldman$elm_css$Css$boxSizing = $rtfeldman$elm_css$Css$prop1('box-sizing');
var $rtfeldman$elm_css$Html$Styled$option = $rtfeldman$elm_css$Html$Styled$node('option');
var $rtfeldman$elm_css$Html$Styled$Attributes$selected = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
var $author$project$View$Form$dropdownOption = F2(
	function (selectedValue, _v0) {
		var optionValue = _v0.a;
		var label = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$option,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$value(optionValue),
					$rtfeldman$elm_css$Html$Styled$Attributes$selected(
					_Utils_eq(
						$elm$core$String$toLower(selectedValue),
						$elm$core$String$toLower(optionValue)))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				]));
	});
var $rtfeldman$elm_css$Css$hidden = {C: 0, aZ: 0, v: 'hidden', b3: 0};
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $rtfeldman$elm_css$Css$Addition = 0;
var $rtfeldman$elm_css$Css$plus = 0;
var $rtfeldman$elm_css$Html$Styled$select = $rtfeldman$elm_css$Html$Styled$node('select');
var $rtfeldman$elm_css$Css$spaceAround = $rtfeldman$elm_css$Css$prop1('space-around');
var $author$project$View$Form$dropdownField = F2(
	function (form, _v0) {
		var fieldName = _v0.ct;
		var label = _v0.dX;
		var options = _v0.eg;
		var styles = {
			f1: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(10),
					$rtfeldman$elm_css$Css$zero)
				]),
			g3: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(2)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(9)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(20))
				]),
			g4: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(1)),
					$rtfeldman$elm_css$Css$top(
					$rtfeldman$elm_css$Css$pct(10)),
					$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(30)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$pct(80)),
					A3(
					$rtfeldman$elm_css$Css$borderLeft3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$View$Theme$colors.gO)
				]),
			lP: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$pct(100),
						$rtfeldman$elm_css$Css$plus,
						$rtfeldman$elm_css$Css$px(20))),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
					$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(2)),
					$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
					A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
					A2($rtfeldman$elm_css$Css$property, '-moz-appearance', 'none')
				]),
			hf: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(28)),
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(4)),
					$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					A2($author$project$View$Form$getInputBorderColor, form, fieldName)),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(4)),
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
					$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
					$rtfeldman$elm_css$Css$focus(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.l$),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$View$Theme$colors.eh),
							$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
						]))
				]),
			dX: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(5))
				])
		};
		var selectedValue = A2($author$project$Form$getRawString, form, fieldName);
		var createOptions = $author$project$View$Form$dropdownOption(selectedValue);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.dX)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.hf)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									$author$project$Form$AsString(fieldName)),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.lP),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', fieldName)
								]),
							A2($elm$core$List$map, createOptions, options)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.g4)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.kY),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.g3)
										]),
									_List_Nil)
								]))
						])),
					A2($author$project$View$Form$displayValidationError, form, fieldName)
				]));
	});
var $author$project$View$ProfileOption$sponsorLevelOption = function (sponsorLevel) {
	var value = $author$project$Core$Data$Profile$SponsorLevel$sponsorLevelString(sponsorLevel);
	switch (sponsorLevel) {
		case 0:
			return _Utils_Tuple2(value, 'Anyone');
		case 1:
			return _Utils_Tuple2(value, 'Bronze');
		case 2:
			return _Utils_Tuple2(value, 'Silver');
		case 3:
			return _Utils_Tuple2(value, 'Gold');
		case 4:
			return _Utils_Tuple2(value, 'Platinum');
		case 5:
			return _Utils_Tuple2(value, 'Diamond');
		case 6:
			return _Utils_Tuple2(value, 'Star');
		default:
			return _Utils_Tuple2(value, 'Ultimate');
	}
};
var $author$project$Page$Profile$BasicInfo$sponsorLevelOptions = A2(
	$elm$core$List$map,
	$author$project$View$ProfileOption$sponsorLevelOption,
	_List_fromArray(
		[0, 1, 2, 3, 4, 5, 6, 7]));
var $author$project$Page$Profile$BasicInfo$displaySponsorLevelForSugar = F2(
	function (form, profile) {
		var _v0 = profile.eY;
		if (!_v0) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.cV)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.de)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.dd)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Minimum Suitor Level*')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.cv)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.cu)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$map,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnProfile),
											$author$project$Type$Profile$FormMsg),
										A2(
											$author$project$View$Form$dropdownField,
											form,
											{ct: 'sponsorLevel', dX: '', eg: $author$project$Page$Profile$BasicInfo$sponsorLevelOptions}))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.dD)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$img,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.bv),
												$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.bv)
											]),
										_List_Nil),
										$rtfeldman$elm_css$Html$Styled$text('You can choose the minimum Suitor level you want to chat with. A lower level allows more Suitors to message you, and a higher level increases the quality but reduces the number of Suitors who can message you.')
									]))
							]))
					]));
		}
	});
var $author$project$View$ProfileOption$genderOption = function (gender) {
	var value = $author$project$Core$Data$Profile$Gender$genderString(gender);
	if (!gender) {
		return _Utils_Tuple2(value, 'Man');
	} else {
		return _Utils_Tuple2(value, 'Lady');
	}
};
var $author$project$View$ProfileOption$genderOptions = A2(
	$elm$core$List$map,
	$author$project$View$ProfileOption$genderOption,
	_List_fromArray(
		[0, 1]));
var $author$project$View$ProfileOption$listCmOptions = F2(
	function (minHeight, maxHeight) {
		var option = _Utils_Tuple2(
			$elm$core$String$fromInt(minHeight),
			$author$project$Core$Data$Profile$Height$heightString(
				$author$project$Core$Data$Profile$Height$CM(minHeight)) + ' CM');
		return (_Utils_cmp(minHeight, maxHeight) < 1) ? A2(
			$elm$core$List$cons,
			option,
			A2($author$project$View$ProfileOption$listCmOptions, minHeight + 1, maxHeight)) : _List_fromArray(
			[option]);
	});
var $author$project$View$ProfileOption$heightCmOptions = A2(
	$elm$core$List$cons,
	_Utils_Tuple2('', 'Select'),
	_Utils_ap(
		A2($author$project$View$ProfileOption$listCmOptions, 137, 213),
		_List_fromArray(
			[
				_Utils_Tuple2('otherHeight', 'Other')
			])));
var $author$project$View$ProfileOption$listFtOptions = F2(
	function (minInches, maxInches) {
		var heightInCM = $author$project$Core$Data$Profile$Height$inchesToCm(minInches);
		var option = _Utils_Tuple2(
			$elm$core$String$fromInt(heightInCM),
			$author$project$Core$Data$Profile$Height$cmToFeetsAndInches(
				$author$project$Core$Data$Profile$Height$CM(heightInCM)));
		return (_Utils_cmp(minInches, maxInches) < 1) ? A2(
			$elm$core$List$cons,
			option,
			A2($author$project$View$ProfileOption$listFtOptions, minInches + 1, maxInches)) : _List_fromArray(
			[option]);
	});
var $author$project$View$ProfileOption$heightFtOptions = A2(
	$elm$core$List$cons,
	_Utils_Tuple2('', 'Select'),
	_Utils_ap(
		A2($author$project$View$ProfileOption$listFtOptions, 54, 84),
		_List_fromArray(
			[
				_Utils_Tuple2('otherHeight', 'Other')
			])));
var $author$project$Form$AsListString = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $author$project$View$Theme$applyStyleIf = F2(
	function (condition, styles) {
		return condition ? $rtfeldman$elm_css$Css$batch(styles) : $rtfeldman$elm_css$Css$batch(_List_Nil);
	});
var $rtfeldman$elm_css$Css$auto = {jR: 0, d: 0, aP: 0, cB: 0, lW: 0, aW: 0, aj: 0, S: 0, aZ: 0, L: 0, c8: 0, a6: 0, F: 0, v: 'auto'};
var $rtfeldman$elm_css$Css$flexStart = $rtfeldman$elm_css$Css$prop1('flex-start');
var $author$project$View$Form$isSelectedTag = F2(
	function (selectedValues, _v0) {
		var optionValue = _v0.a;
		return A2($elm$core$List$member, optionValue, selectedValues);
	});
var $rtfeldman$elm_css$Css$scale = function (x) {
	return {
		l: 0,
		v: A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'scale',
			_List_fromArray(
				[
					$elm$core$String$fromFloat(x)
				]))
	};
};
var $rtfeldman$elm_css$Css$valuesOrNone = function (list) {
	return $elm$core$List$isEmpty(list) ? {v: 'none'} : {
		v: A3(
			$rtfeldman$elm_css$Css$String$mapJoin,
			function ($) {
				return $.v;
			},
			' ',
			list)
	};
};
var $rtfeldman$elm_css$Css$transforms = A2(
	$elm$core$Basics$composeL,
	$rtfeldman$elm_css$Css$prop1('transform'),
	$rtfeldman$elm_css$Css$valuesOrNone);
var $rtfeldman$elm_css$Css$transform = function (only) {
	return $rtfeldman$elm_css$Css$transforms(
		_List_fromArray(
			[only]));
};
var $author$project$View$Form$selectedTagField = F3(
	function (selectedValues, fieldName, _v0) {
		var optionValue = _v0.a;
		var label = _v0.b;
		var isSelected = A2(
			$author$project$View$Form$isSelectedTag,
			selectedValues,
			_Utils_Tuple2(optionValue, label));
		var styles = {
			f1: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
					$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$borderRadius($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.ly),
					$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$scale(0)),
					$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
					A2($rtfeldman$elm_css$Css$property, 'transition', 'all 0.3s ease'),
					A2(
					$author$project$View$Theme$applyStyleIf,
					isSelected,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$transform(
							$rtfeldman$elm_css$Css$scale(1)),
							$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$auto),
							$rtfeldman$elm_css$Css$marginRight(
							$rtfeldman$elm_css$Css$px(5)),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$px(5)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$px(20))
						]))
				]),
			ex: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$padding(
					$rtfeldman$elm_css$Css$px(5)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(15)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(15)),
					$rtfeldman$elm_css$Css$hover(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						]))
				]),
			c9: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(10)),
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$px(6)),
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
					$rtfeldman$elm_css$Css$fontSize(
					$rtfeldman$elm_css$Css$px(12)),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og)
				])
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.c9)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2($author$project$Form$AsListString, fieldName, optionValue)),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.ex),
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.ex)
						]),
					_List_Nil)
				]));
	});
var $author$project$View$Form$tagField = F3(
	function (selectedValues, fieldName, _v0) {
		var optionValue = _v0.a;
		var label = _v0.b;
		var isSelected = A2(
			$author$project$View$Form$isSelectedTag,
			selectedValues,
			_Utils_Tuple2(optionValue, label));
		var styles = {
			f1: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(5)),
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(5)),
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(6),
					$rtfeldman$elm_css$Css$px(10)),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(20)),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN),
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$scale(1)),
					$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$auto),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(14)),
					A2($rtfeldman$elm_css$Css$property, 'transition', 'all 0.3s ease'),
					A2(
					$author$project$View$Theme$applyStyleIf,
					isSelected,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$transform(
							$rtfeldman$elm_css$Css$scale(0)),
							$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
							A2($rtfeldman$elm_css$Css$padding2, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$borderRadius($rtfeldman$elm_css$Css$zero)
						]))
				]),
			c9: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
					$rtfeldman$elm_css$Css$fontSize(
					$rtfeldman$elm_css$Css$px(12)),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly),
					$rtfeldman$elm_css$Css$hover(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						]))
				])
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2($author$project$Form$AsListString, fieldName, optionValue)),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.c9)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						]))
				]));
	});
var $author$project$View$Form$tagsFields = F2(
	function (form, _v0) {
		var fieldName = _v0.ct;
		var options = _v0.eg;
		var styles = {
			fV: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$px(5)),
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(5)),
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
					$rtfeldman$elm_css$Css$minHeight(
					$rtfeldman$elm_css$Css$px(20)),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					A2($author$project$View$Form$getInputBorderColor, form, fieldName)),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(4))
				]),
			f1: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(10),
					$rtfeldman$elm_css$Css$zero)
				]),
			gs: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$px(5))
				]),
			jl: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$px(10)),
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
				])
		};
		var selectedValues = A2($author$project$Form$getRawListString, form, fieldName);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.fV),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', fieldName)
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$View$Form$selectedTagField, selectedValues, fieldName),
						options)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.gs)
						]),
					_List_fromArray(
						[
							A2($author$project$View$Form$displayValidationError, form, fieldName)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.jl),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', fieldName + 'Tags')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$View$Form$tagField, selectedValues, fieldName),
						options))
				]));
	});
var $author$project$View$Form$textFieldFactory = F3(
	function (inputType, form, _v0) {
		var fieldName = _v0.ct;
		var label = _v0.dX;
		var styles = {
			f1: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(10),
					$rtfeldman$elm_css$Css$zero)
				]),
			gs: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$px(5))
				]),
			lP: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(28)),
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(4)),
					$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					A2($author$project$View$Form$getInputBorderColor, form, fieldName)),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(4)),
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
					A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
					A2($rtfeldman$elm_css$Css$property, '-moz-appearance', 'none'),
					$rtfeldman$elm_css$Css$focus(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.l$),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$View$Theme$colors.eh),
							$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
						]))
				]),
			dX: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(5))
				])
		};
		var fieldValue = A2($author$project$Form$getRawString, form, fieldName);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.dX)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_(inputType),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							$author$project$Form$AsString(fieldName)),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(fieldValue),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.lP),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', fieldName)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.gs)
						]),
					_List_fromArray(
						[
							A2($author$project$View$Form$displayValidationError, form, fieldName)
						]))
				]));
	});
var $author$project$View$Form$textField = $author$project$View$Form$textFieldFactory('text');
var $author$project$Form$AsTime = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $author$project$View$Form$timeField = F2(
	function (form, _v0) {
		var fieldName = _v0.ct;
		var label = _v0.dX;
		var styles = {
			f1: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(10),
					$rtfeldman$elm_css$Css$zero)
				]),
			gs: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$px(5))
				]),
			lP: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(28)),
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(4)),
					$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					A2($author$project$View$Form$getInputBorderColor, form, fieldName)),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(4)),
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
					A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
					A2($rtfeldman$elm_css$Css$property, '-moz-appearance', 'none'),
					$rtfeldman$elm_css$Css$focus(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.l$),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$View$Theme$colors.eh),
							$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
						]))
				]),
			dX: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(5))
				])
		};
		var fieldValue = A3(
			$elm$core$String$slice,
			0,
			10,
			$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
				A2($author$project$Form$getRawTime, form, fieldName)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.dX)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('date'),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							$author$project$Form$AsTime(fieldName)),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(fieldValue),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.lP),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', fieldName)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.gs)
						]),
					_List_fromArray(
						[
							A2($author$project$View$Form$displayValidationError, form, fieldName)
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$title = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('title');
var $author$project$Page$Profile$BasicInfo$wantRelationshipOption = function (wantRelationship) {
	var value = $author$project$Core$Data$Profile$WantRelationship$wantRelationshipString(wantRelationship);
	switch (wantRelationship) {
		case 0:
			return _Utils_Tuple2(value, 'Open Relationship');
		case 1:
			return _Utils_Tuple2(value, 'Casual Dating');
		case 2:
			return _Utils_Tuple2(value, 'Make Friends');
		case 3:
			return _Utils_Tuple2(value, 'Networking');
		case 4:
			return _Utils_Tuple2(value, 'Serious Relationship');
		default:
			return _Utils_Tuple2(value, 'Travel Companion');
	}
};
var $author$project$Page$Profile$BasicInfo$wantRelationshipsOptions = A2(
	$elm$core$List$map,
	$author$project$Page$Profile$BasicInfo$wantRelationshipOption,
	_List_fromArray(
		[1, 2, 3, 0, 4, 5]));
var $author$project$Page$Profile$BasicInfo$view = F2(
	function (device, model) {
		var toAppMsg = A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnProfile);
		var _v0 = model;
		var profile = _v0.iu;
		var form = _v0.ln;
		var components = _v0.ab;
		var heightUnit = _v0.cz;
		var _v1 = components;
		var primaryLocation = _v1.bP;
		var secondaryLocation = _v1.bU;
		var primaryLocationFieldInfo = {ln: form, mk: primaryLocation};
		var secondaryLocationFieldInfo = {ln: form, mk: secondaryLocation};
		var heightField = function () {
			if (!heightUnit) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
					A2(
						$author$project$View$Form$dropdownField,
						form,
						{ct: 'height', dX: 'Height (Ft)', eg: $author$project$View$ProfileOption$heightFtOptions}));
			} else {
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
					A2(
						$author$project$View$Form$dropdownField,
						form,
						{ct: 'height', dX: 'Height (Cm)', eg: $author$project$View$ProfileOption$heightCmOptions}));
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.de)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.dd)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('BASIC INFORMATION')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.cv)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.hq)
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Profile$BasicInfo$avatarField, device, profile.cc)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.iK)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.ce)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$map,
											A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
											A2(
												$author$project$View$Form$textField,
												form,
												{ct: 'username', dX: 'Username *'}))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.ce)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$map,
											A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
											A2(
												$author$project$View$Form$timeField,
												form,
												{ct: 'birthday', dX: 'Birthday *'}))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.ce)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$map,
											A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
											A2(
												$author$project$View$Form$dropdownField,
												form,
												{ct: 'gender', dX: 'Gender *', eg: $author$project$View$ProfileOption$genderOptions}))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.gU)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.gW)
												]),
											_List_fromArray(
												[heightField])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.gV)
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Events$onClick(
															toAppMsg($author$project$Type$Profile$ToggleHeightUnit))
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$img,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.nO),
																	$rtfeldman$elm_css$Html$Styled$Attributes$title('Switch to imperial/metric')
																]),
															_List_Nil)
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.bs)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$map,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$ComponentMsg),
												$author$project$Type$Profile$InputCityMsg('primaryLocation')),
											A2(
												$author$project$Helpers$City$View$cityField,
												primaryLocationFieldInfo,
												{ct: 'primaryLocation', dX: 'Primary Location *'}))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.bs)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$map,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$ComponentMsg),
												$author$project$Type$Profile$InputCityMsg('secondaryLocation')),
											A2(
												$author$project$Helpers$City$View$cityField,
												secondaryLocationFieldInfo,
												{ct: 'secondaryLocation', dX: 'Secondary Location'}))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.bs)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$map,
									A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
									A2(
										$author$project$View$Form$textField,
										form,
										{ct: 'headline', dX: 'Headline *'}))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.dD)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.bv),
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.bv)
										]),
									_List_Nil),
									$rtfeldman$elm_css$Html$Styled$text('Add a short summary about yourself that will grab a member\'s attention.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.cV)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.de)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.dd)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('WHAT I\'M LOOKING FOR *')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.cv)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$BasicInfo$styles.bs)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$map,
									A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
									A2(
										$author$project$View$Form$tagsFields,
										form,
										{ct: 'wantRelationships', eg: $author$project$Page$Profile$BasicInfo$wantRelationshipsOptions}))
								]))
						])),
					A2($author$project$Page$Profile$BasicInfo$displaySponsorLevelForSugar, form, profile)
				]));
	});
var $author$project$View$ProfileOption$benefitOption = function (benefit) {
	var value = $author$project$Core$Data$Profile$Benefit$benefitString(benefit);
	switch (benefit) {
		case 0:
			return _Utils_Tuple2(value, 'Active Lifestyle');
		case 1:
			return _Utils_Tuple2(value, 'Activity Partner');
		case 2:
			return _Utils_Tuple2(value, 'Adventure');
		case 3:
			return _Utils_Tuple2(value, 'Affection');
		case 4:
			return _Utils_Tuple2(value, 'All Ethnicities');
		case 5:
			return _Utils_Tuple2(value, 'Pets Lover');
		case 6:
			return _Utils_Tuple2(value, 'Attention');
		case 7:
			return _Utils_Tuple2(value, 'BBW');
		case 8:
			return _Utils_Tuple2(value, 'Casual Dates');
		case 9:
			return _Utils_Tuple2(value, 'Casual Encounters');
		case 10:
			return _Utils_Tuple2(value, 'Casual Meetups');
		case 11:
			return _Utils_Tuple2(value, 'Coffee Dates');
		case 12:
			return _Utils_Tuple2(value, 'Companion');
		case 13:
			return _Utils_Tuple2(value, 'Concerts/Musicals/Plays');
		case 14:
			return _Utils_Tuple2(value, 'Confidant');
		case 15:
			return _Utils_Tuple2(value, 'Daytime Meetups');
		case 16:
			return _Utils_Tuple2(value, 'Dinner Dates');
		case 17:
			return _Utils_Tuple2(value, 'Discretion');
		case 18:
			return _Utils_Tuple2(value, 'Emotional Connection');
		case 19:
			return _Utils_Tuple2(value, 'Evening Meetups');
		case 20:
			return _Utils_Tuple2(value, 'Excitement');
		case 21:
			return _Utils_Tuple2(value, 'Exclusive');
		case 22:
			return _Utils_Tuple2(value, 'Financial Support');
		case 23:
			return _Utils_Tuple2(value, 'Flexible Schedule');
		case 24:
			return _Utils_Tuple2(value, 'Food Lover');
		case 25:
			return _Utils_Tuple2(value, 'Friends with Benefits');
		case 26:
			return _Utils_Tuple2(value, 'Fun');
		case 27:
			return _Utils_Tuple2(value, 'Gay Dating');
		case 28:
			return _Utils_Tuple2(value, 'Good Cook');
		case 29:
			return _Utils_Tuple2(value, 'Hook Up');
		case 30:
			return _Utils_Tuple2(value, 'Lesbian Dating');
		case 31:
			return _Utils_Tuple2(value, 'Listening Ear');
		case 32:
			return _Utils_Tuple2(value, 'Long Term');
		case 33:
			return _Utils_Tuple2(value, 'Lunch Dates');
		case 34:
			return _Utils_Tuple2(value, 'Marriage Minded');
		case 35:
			return _Utils_Tuple2(value, 'Medium Term');
		case 36:
			return _Utils_Tuple2(value, 'Meet For Drinks');
		case 37:
			return _Utils_Tuple2(value, 'Mentor/Mentee');
		case 38:
			return _Utils_Tuple2(value, 'Minimal Tattoos');
		case 39:
			return _Utils_Tuple2(value, 'Monogamous');
		case 40:
			return _Utils_Tuple2(value, 'Monthly Allowance');
		case 41:
			return _Utils_Tuple2(value, 'Movie Lover');
		case 42:
			return _Utils_Tuple2(value, 'Nature Lover');
		case 43:
			return _Utils_Tuple2(value, 'Nighttime Meetups');
		case 44:
			return _Utils_Tuple2(value, 'No Attached Dates');
		case 45:
			return _Utils_Tuple2(value, 'No Intimacy');
		case 46:
			return _Utils_Tuple2(value, 'No Married Dates');
		case 47:
			return _Utils_Tuple2(value, 'No Stayovers');
		case 48:
			return _Utils_Tuple2(value, 'NSA');
		case 49:
			return _Utils_Tuple2(value, 'No Travel');
		case 50:
			return _Utils_Tuple2(value, 'Non-Exclusive');
		case 51:
			return _Utils_Tuple2(value, 'Non-Monogamous');
		case 52:
			return _Utils_Tuple2(value, 'Occasional Dates');
		case 53:
			return _Utils_Tuple2(value, 'One-Off Dates');
		case 54:
			return _Utils_Tuple2(value, 'Online Only');
		case 55:
			return _Utils_Tuple2(value, 'ONS');
		case 56:
			return _Utils_Tuple2(value, 'Open Relationship');
		case 57:
			return _Utils_Tuple2(value, 'Pescatarian');
		case 58:
			return _Utils_Tuple2(value, 'Platonic');
		case 59:
			return _Utils_Tuple2(value, 'Professional Networking');
		case 60:
			return _Utils_Tuple2(value, 'Rent Assistance');
		case 61:
			return _Utils_Tuple2(value, 'Romance');
		case 63:
			return _Utils_Tuple2(value, 'Short Term');
		case 64:
			return _Utils_Tuple2(value, 'Singles Only');
		case 62:
			return _Utils_Tuple2(value, 'Senior Dating');
		case 65:
			return _Utils_Tuple2(value, 'Soulmate');
		case 66:
			return _Utils_Tuple2(value, 'Spontaneity');
		case 67:
			return _Utils_Tuple2(value, 'Sports Lover');
		case 68:
			return _Utils_Tuple2(value, 'Stay-In Partner');
		case 69:
			return _Utils_Tuple2(value, 'Staycations');
		case 70:
			return _Utils_Tuple2(value, 'Stayovers');
		case 71:
			return _Utils_Tuple2(value, 'Sugar Newbie');
		case 72:
			return _Utils_Tuple2(value, 'Sugar Veteran');
		case 73:
			return _Utils_Tuple2(value, 'Surprises');
		case 74:
			return _Utils_Tuple2(value, 'Tattoo Friendly');
		case 75:
			return _Utils_Tuple2(value, 'Trans-Friendly');
		case 76:
			return _Utils_Tuple2(value, 'Transgender');
		case 77:
			return _Utils_Tuple2(value, 'Travel To You');
		case 78:
			return _Utils_Tuple2(value, 'Travel With You');
		case 79:
			return _Utils_Tuple2(value, 'Trips/Vacations');
		case 80:
			return _Utils_Tuple2(value, 'Vegetarian');
		case 81:
			return _Utils_Tuple2(value, 'Weekdays Only');
		default:
			return _Utils_Tuple2(value, 'Weekends Only');
	}
};
var $author$project$View$ProfileOption$benefitsOption = A2(
	$elm$core$List$map,
	$author$project$View$ProfileOption$benefitOption,
	_List_fromArray(
		[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 12, 13, 15, 16, 17, 18, 19, 20, 21, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82]));
var $author$project$View$ProfileOption$bodyTypeOption = function (bodyType) {
	var value = $author$project$Core$Data$Profile$BodyType$bodyTypeString(bodyType);
	switch (bodyType) {
		case 0:
			return _Utils_Tuple2(value, 'Slim');
		case 1:
			return _Utils_Tuple2(value, 'Athletic');
		case 2:
			return _Utils_Tuple2(value, 'Average');
		case 3:
			return _Utils_Tuple2(value, 'Curvy');
		case 4:
			return _Utils_Tuple2(value, 'A Few Extra Pounds');
		case 5:
			return _Utils_Tuple2(value, 'Overweight');
		default:
			return _Utils_Tuple2(value, 'Other');
	}
};
var $author$project$View$ProfileOption$bodyTypeOptions = A2(
	$elm$core$List$cons,
	_Utils_Tuple2('', 'Select'),
	A2(
		$elm$core$List$map,
		$author$project$View$ProfileOption$bodyTypeOption,
		_List_fromArray(
			[0, 1, 2, 3, 4, 5, 6])));
var $author$project$View$ProfileOption$drinkerOption = function (drinker) {
	var value = $author$project$Core$Data$Profile$Drinker$drinkerString(drinker);
	switch (drinker) {
		case 0:
			return _Utils_Tuple2(value, 'Non Drinker');
		case 1:
			return _Utils_Tuple2(value, 'Social Drinker');
		default:
			return _Utils_Tuple2(value, 'Heavy Drinker');
	}
};
var $author$project$View$ProfileOption$drinkerOptions = A2(
	$elm$core$List$cons,
	_Utils_Tuple2('', 'Select'),
	A2(
		$elm$core$List$map,
		$author$project$View$ProfileOption$drinkerOption,
		_List_fromArray(
			[0, 1, 2])));
var $author$project$View$ProfileOption$educationOption = function (education) {
	var value = $author$project$Core$Data$Profile$Education$educationString(education);
	switch (education) {
		case 0:
			return _Utils_Tuple2(value, 'High School');
		case 1:
			return _Utils_Tuple2(value, 'Some College');
		case 2:
			return _Utils_Tuple2(value, 'Associates Degree');
		case 3:
			return _Utils_Tuple2(value, 'Bachelors Degree');
		case 4:
			return _Utils_Tuple2(value, 'Graduate Degree');
		default:
			return _Utils_Tuple2(value, 'PhD / Post Doctoral');
	}
};
var $author$project$View$ProfileOption$educationOptions = A2(
	$elm$core$List$cons,
	_Utils_Tuple2('', 'Select'),
	A2(
		$elm$core$List$map,
		$author$project$View$ProfileOption$educationOption,
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])));
var $author$project$View$ProfileOption$ethnicityOption = function (ethnicity) {
	var value = $author$project$Core$Data$Profile$Ethnicity$ethnicityString(ethnicity);
	switch (ethnicity) {
		case 0:
			return _Utils_Tuple2(value, 'Asian');
		case 1:
			return _Utils_Tuple2(value, 'Black / African Descent');
		case 2:
			return _Utils_Tuple2(value, 'Latin / Hispanic');
		case 3:
			return _Utils_Tuple2(value, 'East Indian');
		case 4:
			return _Utils_Tuple2(value, 'Middle Eastern');
		case 5:
			return _Utils_Tuple2(value, 'Mixed');
		case 6:
			return _Utils_Tuple2(value, 'Native American');
		case 7:
			return _Utils_Tuple2(value, 'Pacific Islander');
		case 8:
			return _Utils_Tuple2(value, 'White / Caucasian');
		default:
			return _Utils_Tuple2(value, 'Other');
	}
};
var $author$project$View$ProfileOption$ethnicityOptions = A2(
	$elm$core$List$cons,
	_Utils_Tuple2('', 'Select'),
	A2(
		$elm$core$List$map,
		$author$project$View$ProfileOption$ethnicityOption,
		_List_fromArray(
			[0, 1, 2, 3, 4, 5, 6, 7, 8, 9])));
var $author$project$View$ProfileOption$lifestyleExpectationOption = function (lifestyleExpectation) {
	var value = $author$project$Core$Data$Profile$LifestyleExpectation$lifestyleExpectationString(lifestyleExpectation);
	switch (lifestyleExpectation) {
		case 0:
			return _Utils_Tuple2(value, 'Go Dutch');
		case 1:
			return _Utils_Tuple2(value, 'Equal Split');
		case 2:
			return _Utils_Tuple2(value, 'Open');
		case 3:
			return _Utils_Tuple2(value, 'Negotiable');
		case 4:
			return _Utils_Tuple2(value, 'Minimal');
		case 5:
			return _Utils_Tuple2(value, 'Practical');
		case 6:
			return _Utils_Tuple2(value, 'Moderate');
		case 7:
			return _Utils_Tuple2(value, 'Substantial');
		case 8:
			return _Utils_Tuple2(value, 'High');
		case 9:
			return _Utils_Tuple2(value, 'Extravagant');
		default:
			return _Utils_Tuple2(value, 'Luxurious');
	}
};
var $author$project$View$ProfileOption$lifestyleExpectationOptions = A2(
	$elm$core$List$cons,
	_Utils_Tuple2('', 'Select'),
	A2(
		$elm$core$List$map,
		$author$project$View$ProfileOption$lifestyleExpectationOption,
		_List_fromArray(
			[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10])));
var $author$project$View$ProfileOption$maritalStatusOption = function (maritalStatus) {
	var value = $author$project$Core$Data$Profile$MaritalStatus$maritalStatusString(maritalStatus);
	switch (maritalStatus) {
		case 0:
			return _Utils_Tuple2(value, 'Single');
		case 1:
			return _Utils_Tuple2(value, 'Open Relationship');
		case 2:
			return _Utils_Tuple2(value, 'Separated');
		case 3:
			return _Utils_Tuple2(value, 'Divorced');
		case 4:
			return _Utils_Tuple2(value, 'Widowed');
		case 5:
			return _Utils_Tuple2(value, 'Attached But Looking');
		case 6:
			return _Utils_Tuple2(value, 'Married But Looking');
		default:
			return _Utils_Tuple2(value, 'Prefer Not To Say');
	}
};
var $author$project$View$ProfileOption$maritalStatusOptions = A2(
	$elm$core$List$cons,
	_Utils_Tuple2('', 'Select'),
	A2(
		$elm$core$List$map,
		$author$project$View$ProfileOption$maritalStatusOption,
		_List_fromArray(
			[0, 1, 2, 3, 4, 5, 6, 7])));
var $author$project$View$ProfileOption$numberOfChildrenOption = function (numberOfChildren) {
	var value = $author$project$Core$Data$Profile$NumberOfChildren$numberOfChildrenString(numberOfChildren);
	switch (numberOfChildren) {
		case 0:
			return _Utils_Tuple2(value, 'Prefer Not To Say');
		case 1:
			return _Utils_Tuple2(value, '0');
		case 2:
			return _Utils_Tuple2(value, '1');
		case 3:
			return _Utils_Tuple2(value, '2');
		case 4:
			return _Utils_Tuple2(value, '3');
		case 5:
			return _Utils_Tuple2(value, '4');
		case 6:
			return _Utils_Tuple2(value, '5');
		default:
			return _Utils_Tuple2(value, '6+');
	}
};
var $author$project$View$ProfileOption$numberOfChildrenOptions = A2(
	$elm$core$List$cons,
	_Utils_Tuple2('', 'Select'),
	A2(
		$elm$core$List$map,
		$author$project$View$ProfileOption$numberOfChildrenOption,
		_List_fromArray(
			[0, 1, 2, 3, 4, 5, 6, 7])));
var $author$project$View$ProfileOption$smokerOption = function (smoker) {
	var value = $author$project$Core$Data$Profile$Smoker$smokerString(smoker);
	switch (smoker) {
		case 0:
			return _Utils_Tuple2(value, 'Non Smoker');
		case 1:
			return _Utils_Tuple2(value, 'Light Smoker');
		default:
			return _Utils_Tuple2(value, 'Heavy Smoker');
	}
};
var $author$project$View$ProfileOption$smokerOptions = A2(
	$elm$core$List$cons,
	_Utils_Tuple2('', 'Select'),
	A2(
		$elm$core$List$map,
		$author$project$View$ProfileOption$smokerOption,
		_List_fromArray(
			[0, 1, 2])));
var $author$project$Page$Profile$PersonalInfo$styles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	cu: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(25),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(15))),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$paddingRight($rtfeldman$elm_css$Css$zero)
				]))
		]),
	cv: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	bs: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	dD: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$px(-5)),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(12)),
				$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic)
			])),
	bv: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-2)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(14))
		]),
	cV: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(17),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gN)
		]),
	c6: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero)
		]),
	dd: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(13)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
				$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle)
			])),
	de: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero)
		])
};
var $rtfeldman$elm_css$Html$Styled$textarea = $rtfeldman$elm_css$Html$Styled$node('textarea');
var $author$project$View$Form$textareaField = F2(
	function (form, _v0) {
		var fieldName = _v0.ct;
		var label = _v0.dX;
		var noLabel = label === '';
		var styles = {
			f1: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(10),
					$rtfeldman$elm_css$Css$zero)
				]),
			gs: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$px(5))
				]),
			lP: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(5),
					$rtfeldman$elm_css$Css$px(7)),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$View$Theme$colors.gO),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(4)),
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
					$rtfeldman$elm_css$Css$focus(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.l$),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$View$Theme$colors.eh),
							$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
						]))
				]),
			dX: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(5)),
					A2(
					$author$project$View$Theme$applyStyleIf,
					noLabel,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
						]))
				])
		};
		var fieldValue = A2($author$project$Form$getRawString, form, fieldName);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.dX)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$textarea,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.lP),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							$author$project$Form$AsString(fieldName)),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(fieldValue),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', fieldName)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.gs)
						]),
					_List_fromArray(
						[
							A2($author$project$View$Form$displayValidationError, form, fieldName)
						]))
				]));
	});
var $author$project$View$ProfileOption$wantGenderOption = function (wantGender) {
	var value = $author$project$Core$Data$Profile$WantGender$wantGenderString(wantGender);
	switch (wantGender) {
		case 0:
			return _Utils_Tuple2(value, 'Men');
		case 1:
			return _Utils_Tuple2(value, 'Ladies');
		default:
			return _Utils_Tuple2(value, 'Both');
	}
};
var $author$project$View$ProfileOption$wantGenderOptions = A2(
	$elm$core$List$map,
	$author$project$View$ProfileOption$wantGenderOption,
	_List_fromArray(
		[0, 1, 2]));
var $author$project$Page$Profile$PersonalInfo$view = function (model) {
	var toAppMsg = A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnProfile);
	var _v0 = model;
	var form = _v0.ln;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.de)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.dd)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('PERSONAL INFORMATION')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cv)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cu)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$dropdownField,
									form,
									{ct: 'wantGender', dX: 'Looking For', eg: $author$project$View$ProfileOption$wantGenderOptions}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cu)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$dropdownField,
									form,
									{ct: 'ethnicity', dX: 'Ethnicity', eg: $author$project$View$ProfileOption$ethnicityOptions}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cu)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$dropdownField,
									form,
									{ct: 'numberOfChildren', dX: 'Children', eg: $author$project$View$ProfileOption$numberOfChildrenOptions}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cu)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$dropdownField,
									form,
									{ct: 'education', dX: 'Education', eg: $author$project$View$ProfileOption$educationOptions}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cu)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$dropdownField,
									form,
									{ct: 'smoker', dX: 'Smokes', eg: $author$project$View$ProfileOption$smokerOptions}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cu)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$dropdownField,
									form,
									{ct: 'bodyType', dX: 'Body type', eg: $author$project$View$ProfileOption$bodyTypeOptions}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cu)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$dropdownField,
									form,
									{ct: 'maritalStatus', dX: 'Relationship', eg: $author$project$View$ProfileOption$maritalStatusOptions}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cu)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$dropdownField,
									form,
									{ct: 'drinker', dX: 'Drinks', eg: $author$project$View$ProfileOption$drinkerOptions}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cu)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$dropdownField,
									form,
									{ct: 'lifestyleExpectation', dX: 'Lifestyle Expectation', eg: $author$project$View$ProfileOption$lifestyleExpectationOptions}))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cu)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$textField,
									form,
									{ct: 'occupation', dX: 'Occupation'}))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cV)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.c6)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.dd)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ABOUT ME')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cv)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.bs)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$textareaField,
									form,
									{ct: 'aboutMe', dX: ''}))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cV)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.c6)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.dd)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('WHAT I\'M LOOKING FOR')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cv)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.bs)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$tagsFields,
									form,
									{ct: 'benefits', eg: $author$project$View$ProfileOption$benefitsOption}))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cV)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.c6)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.dd)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('OTHERS')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.cv)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$PersonalInfo$styles.bs)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$FormMsg),
								A2(
									$author$project$View$Form$textareaField,
									form,
									{ct: 'otherBenefit', dX: ''}))
							]))
					]))
			]));
};
var $rtfeldman$elm_css$Css$dashed = {C: 0, aC: 0, v: 'dashed'};
var $author$project$Page$Profile$PhotoInfo$fileInputID = F2(
	function (photoKind, photos) {
		switch (photoKind) {
			case 1:
				return 'PublicPhotoFileID-' + $elm$core$String$fromInt(
					$elm$core$List$length(photos));
			case 2:
				return 'PrivatePhotoFileID-' + $elm$core$String$fromInt(
					$elm$core$List$length(photos));
			default:
				return '';
		}
	});
var $author$project$Page$Profile$PhotoInfo$photoNote = 'Enhance the attractiveness of your profile with classy, fun and personable photos of yourself. Use photos (including animated GIFs) larger than 400px by 400px. No nude photos, please.';
var $author$project$Page$Profile$PhotoInfo$hiddenInputFile = F3(
	function (device, photoKind, fieldName) {
		return $author$project$NativeBridge$isMobileApp(device) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$input,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('file'),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(fieldName),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$on,
					'change',
					$elm$json$Json$Decode$succeed(
						$author$project$Types$OnAuth(
							$author$project$Types$OnProfile(
								A2($author$project$Type$Profile$UploadImage, fieldName, photoKind)))))
				]),
			_List_Nil);
	});
var $author$project$Page$Profile$PhotoInfo$uploadPhotoButton = F3(
	function (device, photoKind, fieldName) {
		var styles = {
			jz: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(10)),
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(-2)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(15))
				]),
			jD: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$View$Theme$colors.gO),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(6)),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
					$rtfeldman$elm_css$Css$hover(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly),
							$rtfeldman$elm_css$Css$borderColor($author$project$View$Theme$colors.ly),
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						]))
				])
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$View$Theme$defaultStyles.lt, styles.jD)),
					$rtfeldman$elm_css$Html$Styled$Attributes$for(fieldName),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnProfile(
							A2($author$project$Type$Profile$UploadImage, fieldName, photoKind))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.jz),
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.io)
						]),
					_List_Nil),
					$rtfeldman$elm_css$Html$Styled$text('Upload Photo'),
					A3($author$project$Page$Profile$PhotoInfo$hiddenInputFile, device, photoKind, fieldName)
				]));
	});
var $author$project$Page$Profile$PhotoInfo$emptyView = F3(
	function (device, photoKind, intro) {
		var textStyle = _Utils_ap(
			$author$project$View$Theme$defaultStyles.kd,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly),
					$rtfeldman$elm_css$Css$fontSize(
					$rtfeldman$elm_css$Css$px(14)),
					$rtfeldman$elm_css$Css$lineHeight(
					$rtfeldman$elm_css$Css$px(21)),
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
				]));
		var containerStyle = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
			]);
		var styles = {
			gp: _Utils_ap(
				containerStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$px(33)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$px(10)),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$dashed,
						$author$project$View$Theme$colors.gO),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(60))
					])),
			gq: containerStyle,
			he: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$left(
					$rtfeldman$elm_css$Css$px(-10000)),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute)
				]),
			hh: _Utils_ap(
				textStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$paddingBottom(
						$rtfeldman$elm_css$Css$px(20))
					])),
			hY: _Utils_ap(
				textStyle,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$px(20),
						$rtfeldman$elm_css$Css$pct(25)),
						$author$project$View$Theme$forMobileScreen(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$padding2,
								$rtfeldman$elm_css$Css$px(10),
								$rtfeldman$elm_css$Css$pct(5))
							]))
					]))
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.gq)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.gp)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.hh)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(intro)
								])),
							A3(
							$author$project$Page$Profile$PhotoInfo$uploadPhotoButton,
							device,
							photoKind,
							A2($author$project$Page$Profile$PhotoInfo$fileInputID, photoKind, _List_Nil))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.hY)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text($author$project$Page$Profile$PhotoInfo$photoNote)
						]))
				]));
	});
var $author$project$Type$Profile$DeleteImage = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Profile$PhotoInfo$showLoadingIfImageIsLocalFile = F3(
	function (imageLength, imageMobileLength, url) {
		return (A2($elm$core$String$startsWith, 'blob:', url) || A2($elm$core$String$startsWith, 'data:', url)) ? A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$px(imageLength - 5)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$px(imageLength - 5)),
							$author$project$View$Theme$forMobileScreen(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$px(imageMobileLength - 5)),
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$px(imageMobileLength - 5))
								]))
						]))
				]),
			_List_Nil) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Page$Profile$PhotoInfo$imageField = F3(
	function (dimension, photoKind, photo) {
		var imageMobileLength = (dimension.nj / 2) - 43;
		var imageLength = (dimension.nj / 5) - 25;
		var styles = {
			g3: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(15))
				]),
			g4: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					A4(
					$rtfeldman$elm_css$Css$padding4,
					$rtfeldman$elm_css$Css$px(6),
					$rtfeldman$elm_css$Css$px(6),
					$rtfeldman$elm_css$Css$px(3),
					$rtfeldman$elm_css$Css$px(6)),
					$rtfeldman$elm_css$Css$top(
					$rtfeldman$elm_css$Css$px(10)),
					$rtfeldman$elm_css$Css$right(
					$rtfeldman$elm_css$Css$px(10)),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(4)),
					$rtfeldman$elm_css$Css$hover(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						]))
				]),
			h7: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(10)),
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(10)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(imageLength)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(imageLength)),
					$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
					$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(6)),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$View$Theme$colors.gN),
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$table),
					$author$project$View$Theme$forMobileScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$px(imageMobileLength)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$px(imageMobileLength))
						]))
				])
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$backgroundImage(
								$rtfeldman$elm_css$Css$url(photo.n8))
							]),
						styles.h7))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.g4),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnProfile(
									A2($author$project$Type$Profile$DeleteImage, photo, photoKind))))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.g3),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.kO)
								]),
							_List_Nil)
						])),
					A3($author$project$Page$Profile$PhotoInfo$showLoadingIfImageIsLocalFile, imageLength, imageMobileLength, photo.n8)
				]));
	});
var $elm$core$List$sortWith = _List_sortWith;
var $rtfeldman$elm_css$Html$Styled$br = $rtfeldman$elm_css$Html$Styled$node('br');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $rtfeldman$elm_css$VirtualDom$Styled$style = F2(
	function (key, val) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$style, key, val),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$style;
var $author$project$Page$Profile$PhotoInfo$uploadPhotoArea = F3(
	function (device, photoKind, fieldName) {
		var styles = {
			he: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$left(
					$rtfeldman$elm_css$Css$px(-10000)),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute)
				]),
			jA: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
					$rtfeldman$elm_css$Css$width(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$pct(20),
						$rtfeldman$elm_css$Css$minus,
						$rtfeldman$elm_css$Css$px(14))),
					A2($rtfeldman$elm_css$Css$property, 'padding-top', 'calc(20% - 12px)'),
					$author$project$View$Theme$forMobileScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							A3(
								$rtfeldman$elm_css$Css$calc,
								$rtfeldman$elm_css$Css$pct(50),
								$rtfeldman$elm_css$Css$minus,
								$rtfeldman$elm_css$Css$px(12))),
							A2($rtfeldman$elm_css$Css$property, 'padding-top', '43%')
						]))
				]),
			jB: _Utils_ap(
				$author$project$View$Theme$defaultStyles.kd,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
						$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$height(
						A3(
							$rtfeldman$elm_css$Css$calc,
							$rtfeldman$elm_css$Css$pct(100),
							$rtfeldman$elm_css$Css$minus,
							$rtfeldman$elm_css$Css$px(12))),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$px(6)),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$View$Theme$colors.gO),
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly),
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$px(70)),
						$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
						$rtfeldman$elm_css$Css$lineHeight(
						$rtfeldman$elm_css$Css$px(38)),
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$hover(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
							])),
						$author$project$View$Theme$forMobileScreen(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$px(50))
							]))
					])),
			jC: _Utils_ap(
				$author$project$View$Theme$defaultStyles.kd,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$px(15))
					]))
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.jA)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(fieldName),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.jB),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'alignContent', 'center'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnProfile(
									A2($author$project$Type$Profile$UploadImage, fieldName, photoKind))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('+'),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.jC)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Upload Photo')
								])),
							A3($author$project$Page$Profile$PhotoInfo$hiddenInputFile, device, photoKind, fieldName)
						]))
				]));
	});
var $author$project$Page$Profile$PhotoInfo$photosView = F4(
	function (device, dimension, photoKind, photos) {
		var photosContainerStyle = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
				$rtfeldman$elm_css$Css$width(
				A3(
					$rtfeldman$elm_css$Css$calc,
					$rtfeldman$elm_css$Css$pct(100),
					$rtfeldman$elm_css$Css$plus,
					$rtfeldman$elm_css$Css$px(10)))
			]);
		var imageAsc = F2(
			function (m1, m2) {
				var b = $elm$time$Time$posixToMillis(m2.cm);
				var a = $elm$time$Time$posixToMillis(m1.cm);
				return A2($elm$core$Basics$compare, a, b);
			});
		var imageFields = A2(
			$elm$core$List$map,
			A2($author$project$Page$Profile$PhotoInfo$imageField, dimension, photoKind),
			A2($elm$core$List$sortWith, imageAsc, photos));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(photosContainerStyle)
				]),
			_Utils_ap(
				imageFields,
				_List_fromArray(
					[
						A3(
						$author$project$Page$Profile$PhotoInfo$uploadPhotoArea,
						device,
						photoKind,
						A2($author$project$Page$Profile$PhotoInfo$fileInputID, photoKind, photos))
					])));
	});
var $author$project$Page$Profile$PhotoInfo$privatePhotoNote = 'Your Private Photos cannot be seen by other members unless you give your permission. You can retract your permission anytime.';
var $author$project$Page$Profile$PhotoInfo$privatePhotosField = F3(
	function (device, dimension, photos) {
		return $elm$core$List$isEmpty(photos) ? A3($author$project$Page$Profile$PhotoInfo$emptyView, device, 2, $author$project$Page$Profile$PhotoInfo$privatePhotoNote) : A4($author$project$Page$Profile$PhotoInfo$photosView, device, dimension, 2, photos);
	});
var $author$project$Page$Profile$PhotoInfo$publicPhotoNote = 'Your Public Photos can be seen by all members who visit your profile.';
var $author$project$Page$Profile$PhotoInfo$publicPhotosField = F3(
	function (device, dimension, photos) {
		return $elm$core$List$isEmpty(photos) ? A3($author$project$Page$Profile$PhotoInfo$emptyView, device, 1, $author$project$Page$Profile$PhotoInfo$publicPhotoNote) : A4($author$project$Page$Profile$PhotoInfo$photosView, device, dimension, 1, photos);
	});
var $author$project$Page$Profile$PhotoInfo$view = F3(
	function (device, dimension, model) {
		var styles = {
			f1: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
				]),
			cv: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]),
			cV: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$margin2,
					$rtfeldman$elm_css$Css$px(17),
					$rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					A3(
					$rtfeldman$elm_css$Css$borderBottom3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$View$Theme$colors.gN)
				]),
			dd: _Utils_ap(
				$author$project$View$Theme$defaultStyles.kd,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$px(13)),
						$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
						$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
						$rtfeldman$elm_css$Css$lineHeight(
						$rtfeldman$elm_css$Css$px(40))
					])),
			de: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(10))
				])
		};
		var _v0 = model;
		var publicPhotos = _v0.m5;
		var privatePhotos = _v0.bR;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.de)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.dd)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('PUBLIC PHOTOS')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.cv)
						]),
					_List_fromArray(
						[
							A3($author$project$Page$Profile$PhotoInfo$publicPhotosField, device, dimension, publicPhotos)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.cV)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.de)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.dd)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('PRIVATE PHOTOS')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.cv)
						]),
					_List_fromArray(
						[
							A3($author$project$Page$Profile$PhotoInfo$privatePhotosField, device, dimension, privatePhotos)
						]))
				]));
	});
var $author$project$Page$Profile$View$view = F3(
	function (device, dimension, model) {
		var _v0 = model;
		var form = _v0.ln;
		var _v1 = form;
		var submitting = _v1.jc;
		return A2(
			$rtfeldman$elm_css$Html$Styled$form,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
					$author$project$Types$OnAuth(
						$author$project$Types$OnProfile($author$project$Type$Profile$SubmitForm)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$View$styles.f1)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$View$styles.jJ)
								]),
							_List_fromArray(
								[
									A3($author$project$Page$Profile$PhotoInfo$view, device, dimension, model)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$View$styles.cQ)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$View$styles.jJ)
										]),
									_List_fromArray(
										[
											A2($author$project$Page$Profile$BasicInfo$view, device, model)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$View$styles.cQ)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$View$styles.jJ)
										]),
									_List_fromArray(
										[
											$author$project$Page$Profile$PersonalInfo$view(model)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$View$styles.fE)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$biggerSubmitButton(submitting),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$View$styles.gd),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.kJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Delete Your Account')
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Profile$view = F2(
	function (_v0, _v1) {
		var device = _v0.kQ;
		var dimension = _v0.kR;
		var profile = _v1.iu;
		if (!profile.$) {
			return $author$project$View$Display$simpleLoadingView;
		} else {
			var model = profile.a;
			var _v3 = model.iu.eQ;
			if (_v3 === 1) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Page$Profile$profileNotCompleted,
							A3($author$project$Page$Profile$View$view, device, dimension, model)
						]));
			} else {
				return A3($author$project$Page$Profile$View$view, device, dimension, model);
			}
		}
	});
var $author$project$View$checkProfileIsCompleted = F3(
	function (model, authState, profileModel) {
		var _v0 = profileModel.iu.eQ;
		if (_v0 === 1) {
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					2,
					A2($author$project$Page$Profile$view, model, authState)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $rtfeldman$elm_css$Html$Styled$h1 = $rtfeldman$elm_css$Html$Styled$node('h1');
var $author$project$View$Display$unauthorizedView = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap(
				$author$project$View$Theme$defaultStyles.kd,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$px(20)),
						$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					])))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$View$Theme$defaultStyles.lC,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$px(30))
							])))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Unauthorized Access')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Please sign in first.')
				]))
		]));
var $author$project$View$authPage = F2(
	function (model, pageView) {
		var _v0 = model.j1;
		if (_v0.$ === 1) {
			return _Utils_Tuple2(0, $author$project$View$Display$unauthorizedView);
		} else {
			var authState = _v0.a;
			var _v1 = authState.iu;
			if (!_v1.$) {
				return _Utils_Tuple2(
					2,
					A2(pageView, model, authState));
			} else {
				var profileModel = _v1.a;
				var mapNothing = F2(
					function (f2, f1) {
						if (f1.$ === 1) {
							return f2;
						} else {
							var f = f1.a;
							return $elm$core$Maybe$Just(f);
						}
					});
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(
						2,
						A2(pageView, model, authState)),
					A2(
						mapNothing,
						A3($author$project$View$checkProfileIsCompleted, model, authState, profileModel),
						A2($author$project$View$checkEmailIsVerified, authState, profileModel)));
			}
		}
	});
var $author$project$View$Helpers$UserInfo$isMissingAvatar = function (authState) {
	var _v0 = authState.iu;
	if (!_v0.$) {
		return false;
	} else {
		var profile = _v0.a.iu;
		return (!profile.eQ) && (profile.cc === '');
	}
};
var $author$project$Types$NavigateBack = {$: 7};
var $rtfeldman$elm_css$Css$Media$minWidth = function (value) {
	return A2($rtfeldman$elm_css$Css$Media$feature, 'min-width', value);
};
var $author$project$View$Theme$forDesktopScreen = $rtfeldman$elm_css$Css$Media$withMedia(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$only,
			$rtfeldman$elm_css$Css$Media$screen,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Media$minWidth(
					$rtfeldman$elm_css$Css$px(768))
				]))
		]));
var $author$project$Page$Detail$backButton = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
					$author$project$View$Theme$forDesktopScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
						]))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$View$Theme$defaultStyles.ci,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$margin2,
								$rtfeldman$elm_css$Css$px(20),
								$rtfeldman$elm_css$Css$zero)
							]))),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Types$NavigateBack)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('< Back To Search')
				]))
		]));
var $author$project$Page$Detail$styles = {
	f1: F2(
		function (_v0, hasAlert) {
			var screenHeight = _v0.ni;
			return _Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$px(15)),
						$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll),
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
						$rtfeldman$elm_css$Css$zIndex(
						$rtfeldman$elm_css$Css$int(3)),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.lx)
					]),
				A2($author$project$View$Theme$defaultStyles.kz, screenHeight, hasAlert));
		}),
	gs: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	ha: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
				]))
		]),
	h3: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(15))
		]),
	h4: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingLeft($rtfeldman$elm_css$Css$zero)
				]))
		])
};
var $author$project$Helpers$toAppHtml = F2(
	function (msg, html) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$author$project$Types$OnAuth,
			A2($rtfeldman$elm_css$Html$Styled$map, msg, html));
	});
var $author$project$Helpers$UnBlockUser$Types$Submit = {$: 2};
var $author$project$Helpers$UnBlockUser$View$styles = {
	ci: _Utils_ap(
		$author$project$View$Theme$defaultStyles.ci,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(100))
			])),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left)
		]),
	k1: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
			])),
	lS: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(15))
			])),
	c7: $author$project$View$Theme$defaultStyles.kd,
	dd: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(15))
			]))
};
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $author$project$CustomPopup$styles = {
	ff: function (backgroundColor_) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$backgroundColor(
				$rtfeldman$elm_css$Css$hex(backgroundColor_)),
				$rtfeldman$elm_css$Css$opacity(
				$rtfeldman$elm_css$Css$num(0.9))
			]);
	},
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(10000)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	ie: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.8)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				])),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(60))
		]),
	$8: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(20))
		]),
	ig: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	mW: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100))
		])
};
var $rtfeldman$elm_css$Html$Styled$Attributes$tabindex = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$CustomPopup$view = F2(
	function (html, model) {
		var _v0 = model;
		var status = _v0.eQ;
		var config = _v0.bl;
		var toggleStyle = function () {
			switch (status) {
				case 0:
					return _List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'transition', 'transform 0.3s ease, opacity 0.3s ease'),
							$rtfeldman$elm_css$Css$transform(
							$rtfeldman$elm_css$Css$scale(1)),
							$rtfeldman$elm_css$Css$opacity(
							$rtfeldman$elm_css$Css$num(1))
						]);
				case 1:
					return _List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'transition', 'transform 0.3s ease, opacity 0.3s ease'),
							$rtfeldman$elm_css$Css$transform(
							$rtfeldman$elm_css$Css$scale(0)),
							$rtfeldman$elm_css$Css$opacity(
							$rtfeldman$elm_css$Css$num(0))
						]);
				default:
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Css$transform(
							$rtfeldman$elm_css$Css$scale(0)),
							$rtfeldman$elm_css$Css$opacity(
							$rtfeldman$elm_css$Css$num(0))
						]);
			}
		}();
		var _v1 = config;
		var closeIcon = _v1.f_;
		var toMsg = _v1.jr;
		var popupID = _v1.eq;
		var backgroundColor = _v1.fe;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$CustomPopup$styles.f1, toggleStyle)),
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(popupID)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$CustomPopup$styles.ff(backgroundColor))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$CustomPopup$styles.ig),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							toMsg(1))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
									'click',
									$elm$json$Json$Decode$succeed(
										_Utils_Tuple2(
											toMsg(2),
											true)))
								]),
							_List_fromArray(
								[html])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$CustomPopup$styles.ie),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									toMsg(1)),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'closeCustomPopup')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$CustomPopup$styles.$8),
											$rtfeldman$elm_css$Html$Styled$Attributes$src(closeIcon)
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Helpers$UnBlockUser$View$view = function (model) {
	var _v0 = model;
	var status = _v0.eQ;
	var popup = _v0.bN;
	var body = function () {
		switch (status.$) {
			case 0:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$UnBlockUser$View$styles.c7)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Do you want to unblock this user?'),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('You will receive message from this user!'),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Helpers$UnBlockUser$Types$Submit),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$UnBlockUser$View$styles.ci),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Submit')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('UnBlock User')
							]))
					]);
			case 1:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$UnBlockUser$View$styles.c7)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Unblocking this user...'),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
							]))
					]);
			case 2:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$UnBlockUser$View$styles.c7)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('User unblocked successfully.'),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
							]))
					]);
			default:
				var errorMessage = status.a;
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$UnBlockUser$View$styles.k1)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(errorMessage),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Helpers$UnBlockUser$Types$Submit),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$UnBlockUser$View$styles.ci),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Submit')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Retry')
							]))
					]);
		}
	}();
	var html = A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$UnBlockUser$View$styles.f1),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'unBlockPopup')
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$UnBlockUser$View$styles.dd)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('UNBLOCK USER')
					])),
			body));
	return A2($author$project$CustomPopup$view, html, popup);
};
var $author$project$Page$Detail$unBlockView = F2(
	function (userID, blockStatus) {
		var popup = function (unBlockUser) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$map,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnDetail),
					$author$project$Type$Detail$OnUnBlockUser(userID)),
				$author$project$Helpers$UnBlockUser$View$view(unBlockUser));
		};
		switch (blockStatus.$) {
			case 2:
				var unBlockUser = blockStatus.a;
				return popup(unBlockUser);
			case 3:
				var unBlockUser = blockStatus.a;
				return popup(unBlockUser);
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Helpers$ReportUser$Types$FormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Helpers$ReportUser$Types$SubmitForm = {$: 3};
var $author$project$Core$Data$Report$reasonFullString = function (reason) {
	switch (reason.$) {
		case 0:
			return 'Inappropriate Photos';
		case 1:
			return 'Spammer';
		case 2:
			return 'Scammer';
		case 3:
			return 'Underage User';
		default:
			return 'Other';
	}
};
var $author$project$Helpers$ReportUser$View$styles = {
	fE: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	k1: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
			])),
	cu: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	c7: $author$project$View$Theme$defaultStyles.kd,
	dd: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(15))
			]))
};
var $author$project$Helpers$ReportUser$View$renderFormError = function (error) {
	if (error.$ === 1) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = error.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$ReportUser$View$styles.k1)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Helpers$ReportUser$View$view = function (model) {
	var reasonOption = function (reason_) {
		return _Utils_Tuple2(
			$author$project$Core$Data$Report$reasonString(reason_),
			$author$project$Core$Data$Report$reasonFullString(reason_));
	};
	var reasonOptions = A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Select'),
		A2(
			$elm$core$List$map,
			reasonOption,
			_List_fromArray(
				[
					$author$project$Core$Data$Report$InappropriatePhotos,
					$author$project$Core$Data$Report$Spammer,
					$author$project$Core$Data$Report$Scammer,
					$author$project$Core$Data$Report$UnderageUser,
					$author$project$Core$Data$Report$Other('')
				])));
	var _v0 = model;
	var isSuccess = _v0.hi;
	var form = _v0.ln;
	var popup = _v0.bN;
	var otherReason = A2($author$project$Form$getRawString, form, 'otherReason');
	var reason = A2($author$project$Form$getRawString, form, 'reason');
	var otherReasonHtml = function () {
		var _v2 = A2($author$project$Core$Data$Report$toReason, otherReason, reason);
		if ((!_v2.$) && (_v2.a.$ === 4)) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$ReportUser$View$styles.cu)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$Helpers$ReportUser$Types$FormMsg,
						A2(
							$author$project$View$Form$textareaField,
							form,
							{ct: 'otherReason', dX: 'Tell us more *'}))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							$author$project$Helpers$ReportUser$View$styles.cu,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
								])))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$Helpers$ReportUser$Types$FormMsg,
						A2(
							$author$project$View$Form$textareaField,
							form,
							{ct: 'otherReason', dX: 'Tell us more *'}))
					]));
		}
	}();
	var _v1 = form;
	var submitting = _v1.jc;
	var error = _v1.gs;
	var html = isSuccess ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$ReportUser$View$styles.f1),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'reportPopup')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$ReportUser$View$styles.dd)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('REPORT USER')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$ReportUser$View$styles.c7)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('User reported successfully.'),
						A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
						A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
						$rtfeldman$elm_css$Html$Styled$text('Thanks for your feedback!')
					]))
			])) : A2(
		$rtfeldman$elm_css$Html$Styled$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Events$onSubmit($author$project$Helpers$ReportUser$Types$SubmitForm)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$ReportUser$View$styles.f1),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'reportPopup')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$ReportUser$View$styles.dd)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('REPORT USER')
							])),
						$author$project$Helpers$ReportUser$View$renderFormError(error),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$ReportUser$View$styles.cu)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Helpers$ReportUser$Types$FormMsg,
								A2(
									$author$project$View$Form$dropdownField,
									form,
									{ct: 'reason', dX: 'Reason *', eg: reasonOptions}))
							])),
						otherReasonHtml,
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$ReportUser$View$styles.fE)
							]),
						_List_fromArray(
							[
								$author$project$View$Form$biggerSubmitButton(submitting)
							]))
					]))
			]));
	return A2($author$project$CustomPopup$view, html, popup);
};
var $author$project$Core$Data$Profile$birthdayToAge = F2(
	function (birthday, currentTime) {
		return A2($elm$time$Time$toYear, $elm$time$Time$utc, currentTime) - A2($elm$time$Time$toYear, $elm$time$Time$utc, birthday);
	});
var $author$project$Type$Chat$CreateRoom = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Chat$Partner$fromProfile = F2(
	function (profile, roomStatus) {
		return {
			cc: profile.cc,
			aV: $elm$time$Time$millisToPosix(0),
			bY: profile.bY,
			eQ: {a: roomStatus, W: profile.eQ},
			eX: profile.eX,
			dh: profile.dh
		};
	});
var $author$project$Page$Detail$BasicInfo$chatButton = F2(
	function (profile, blockStatus) {
		switch (blockStatus.$) {
			case 0:
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap(
								$author$project$View$Theme$defaultStyles.ci,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$padding2,
										$rtfeldman$elm_css$Css$px(10),
										$rtfeldman$elm_css$Css$px(20))
									]))),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'gettingBlockStatus')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$marginRight(
											$rtfeldman$elm_css$Css$px(6)),
											$rtfeldman$elm_css$Css$marginBottom(
											$rtfeldman$elm_css$Css$px(-2))
										])),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.km)
								]),
							_List_Nil),
							$rtfeldman$elm_css$Html$Styled$text('Checking...')
						]));
			case 2:
				return A2(
					$author$project$Helpers$toAppHtml,
					$author$project$Types$OnDetail,
					A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								A2($author$project$Type$Detail$OnUnBlockUser, profile.eX, $author$project$Helpers$UnBlockUser$Types$OpenPopup)),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap(
									$author$project$View$Theme$defaultStyles.ci,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$padding2,
											$rtfeldman$elm_css$Css$px(10),
											$rtfeldman$elm_css$Css$px(20))
										]))),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'unblock')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('UnBlock')
							])));
			default:
				return A2(
					$author$project$Helpers$toAppHtml,
					$author$project$Types$OnChat,
					A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Type$Chat$CreateRoom(
									A2($author$project$Data$Chat$Partner$fromProfile, profile, 0))),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap(
									$author$project$View$Theme$defaultStyles.ci,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$padding2,
											$rtfeldman$elm_css$Css$px(10),
											$rtfeldman$elm_css$Css$px(20))
										]))),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'message')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$marginRight(
												$rtfeldman$elm_css$Css$px(6)),
												$rtfeldman$elm_css$Css$marginBottom(
												$rtfeldman$elm_css$Css$px(-2))
											])),
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.km)
									]),
								_List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('Message')
							])));
		}
	});
var $author$project$Page$Detail$BasicInfo$upgradeButton = A2(
	$rtfeldman$elm_css$Html$Styled$a,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap(
				$author$project$View$Theme$defaultStyles.ci,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$px(10),
						$rtfeldman$elm_css$Css$px(20))
					]))),
			$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l9)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginRight(
							$rtfeldman$elm_css$Css$px(6)),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$px(-2))
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.km)
				]),
			_List_Nil),
			$rtfeldman$elm_css$Html$Styled$text('Upgrade to Chat')
		]));
var $author$project$Page$Detail$BasicInfo$chatOrUpgradeButton = F3(
	function (partner, currentUserProfile, blockStatus) {
		var _v0 = currentUserProfile.eY;
		if (_v0 === 1) {
			return A2($author$project$Page$Detail$BasicInfo$chatButton, partner, blockStatus);
		} else {
			return (_Utils_cmp(
				$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(partner.bY),
				$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(currentUserProfile.bY)) > 0) ? $author$project$Page$Detail$BasicInfo$upgradeButton : A2($author$project$Page$Detail$BasicInfo$chatButton, partner, blockStatus);
		}
	});
var $author$project$Core$Data$Profile$Photo$isLoadingPhoto = function (photo) {
	return _Utils_eq(photo.n8, $author$project$View$Theme$images.hv);
};
var $author$project$Core$Data$Profile$Photo$getAvatarUrlFromPhotos = F2(
	function (url, photos) {
		return ($elm$core$String$isEmpty(url) || _Utils_eq(url, $author$project$View$Theme$images.hv)) ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.n8;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Core$Data$Profile$Photo$isLoadingPhoto),
					photos))) : $elm$core$Maybe$Just(url);
	});
var $author$project$Data$Membership$getMembershipColor = function (sponsorLevel) {
	switch (sponsorLevel) {
		case 0:
			return $rtfeldman$elm_css$Css$hex('E6E6E6');
		case 1:
			return $rtfeldman$elm_css$Css$hex('B5651E');
		case 2:
			return $rtfeldman$elm_css$Css$hex('A9A9A9');
		case 3:
			return $rtfeldman$elm_css$Css$hex('D4AF37');
		case 4:
			return $rtfeldman$elm_css$Css$hex('E5E4E2');
		case 5:
			return $rtfeldman$elm_css$Css$hex('DDA0DD');
		case 6:
			return $rtfeldman$elm_css$Css$hex('FFDF00');
		default:
			return $rtfeldman$elm_css$Css$hex('333333');
	}
};
var $author$project$PopupPhoto$Open = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$PopupPhoto$openGalleryMsg = F2(
	function (photos, index) {
		return A2($author$project$PopupPhoto$Open, photos, index);
	});
var $author$project$Page$Detail$BasicInfo$displayAvatar = F2(
	function (profile, publicPhotos) {
		var _v0 = profile;
		var avatar = _v0.cc;
		var sponsorLevel = _v0.bY;
		var updatedAvatar = A2(
			$elm$core$Maybe$withDefault,
			$author$project$View$Theme$images.kN,
			A2($author$project$Core$Data$Profile$Photo$getAvatarUrlFromPhotos, avatar, publicPhotos));
		var membershipColor = $author$project$Data$Membership$getMembershipColor(sponsorLevel);
		var styles_ = {
			cc: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(8)),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(3),
					$rtfeldman$elm_css$Css$solid,
					membershipColor),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]),
			fc: _List_fromArray(
				[
					A4(
					$rtfeldman$elm_css$Css$padding4,
					$rtfeldman$elm_css$Css$px(40),
					$rtfeldman$elm_css$Css$px(40),
					$rtfeldman$elm_css$Css$px(10),
					$rtfeldman$elm_css$Css$px(40))
				])
		};
		return A2(
			$author$project$Helpers$toAppHtml,
			$author$project$Types$OnDetail,
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles_.fc)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles_.cc),
								$rtfeldman$elm_css$Html$Styled$Attributes$src(updatedAvatar),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Type$Detail$PopupMsg(
									A2(
										$author$project$PopupPhoto$openGalleryMsg,
										_List_fromArray(
											[updatedAvatar]),
										0)))
							]),
						_List_Nil)
					])));
	});
var $author$project$Page$Detail$BasicInfo$displaySponsorLevel = function (profile) {
	var _v0 = profile;
	var sponsorLevel = _v0.bY;
	var membershipColor = $author$project$Data$Membership$getMembershipColor(sponsorLevel);
	var styles_ = {
		f1: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$backgroundColor(membershipColor),
				A2(
				$rtfeldman$elm_css$Css$margin2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(40)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(20)),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(3),
				$rtfeldman$elm_css$Css$solid,
				membershipColor)
			]),
		eT: _Utils_ap(
			$author$project$View$Theme$defaultStyles.kd,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
					$rtfeldman$elm_css$Css$padding(
					$rtfeldman$elm_css$Css$px(5))
				]))
	};
	var _v1 = profile.eY;
	if (_v1 === 1) {
		var label = (!sponsorLevel) ? $author$project$Core$Data$Profile$SponsorLevel$sponsorLevelString(sponsorLevel) : ($author$project$Core$Data$Profile$SponsorLevel$sponsorLevelString(sponsorLevel) + ' & Above Only');
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles_.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles_.eT)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						]))
				]));
	} else {
		return (!sponsorLevel) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles_.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles_.eT)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelString(sponsorLevel))
						]))
				]));
	}
};
var $author$project$Type$Detail$FavoriteProfile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$Detail$UnFavoriteProfile = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$borderTop3 = $rtfeldman$elm_css$Css$prop3('border-top');
var $author$project$Page$Detail$BasicInfo$container = _List_fromArray(
	[
		$rtfeldman$elm_css$Css$borderRadius(
		$rtfeldman$elm_css$Css$px(10)),
		A3(
		$rtfeldman$elm_css$Css$border3,
		$rtfeldman$elm_css$Css$px(1),
		$rtfeldman$elm_css$Css$solid,
		$author$project$View$Theme$colors.gO),
		$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
		$author$project$View$Theme$forMobileScreen(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$auto)
			]))
	]);
var $rtfeldman$elm_css$Css$inline = {o: 0, v: 'inline'};
var $author$project$Page$Detail$BasicInfo$styles = {
	e7: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(5)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(13))
			])),
	fn: _Utils_ap(
		$author$project$Page$Detail$BasicInfo$container,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(20))
			])),
	fy: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(15),
			$rtfeldman$elm_css$Css$zero)
		]),
	fG: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero)
		]),
	bp: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lt,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(8),
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$px(15))
			])),
	cy: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(5)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(13))
			])),
	cQ: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	cR: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingRight(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(14))
			])),
	cS: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$flexGrow(
				$rtfeldman$elm_css$Css$num(1)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(14)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
			])),
	cV: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(17),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gN)
		]),
	dd: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(13)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
			])),
	jt: _Utils_ap(
		$author$project$Page$Detail$BasicInfo$container,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(324)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	dh: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(18)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
			])),
	jE: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(12))
			])),
	jF: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-4)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(17))
		]),
	jG: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(14),
			$rtfeldman$elm_css$Css$zero),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO)
		])
};
var $author$project$Page$Detail$BasicInfo$favoriteButton = F2(
	function (_v0, favoriteStatus) {
		var uid = _v0.eX;
		switch (favoriteStatus) {
			case 0:
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Type$Detail$UnFavoriteProfile(uid)),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.bp)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$px(18)),
											$rtfeldman$elm_css$Css$marginRight(
											$rtfeldman$elm_css$Css$px(6)),
											$rtfeldman$elm_css$Css$marginBottom(
											$rtfeldman$elm_css$Css$px(-2))
										])),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.kD)
								]),
							_List_Nil),
							$rtfeldman$elm_css$Html$Styled$text('UnFavorite')
						]));
			case 1:
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Type$Detail$FavoriteProfile(uid)),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.bp)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$px(18)),
											$rtfeldman$elm_css$Css$marginRight(
											$rtfeldman$elm_css$Css$px(6)),
											$rtfeldman$elm_css$Css$marginBottom(
											$rtfeldman$elm_css$Css$px(-2))
										])),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.lD)
								]),
							_List_Nil),
							$rtfeldman$elm_css$Html$Styled$text('Favorite')
						]));
			case 2:
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.bp)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Updating...')
						]));
			default:
				return A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.bp)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Checking...')
						]));
		}
	});
var $author$project$Core$Data$Profile$MaritalStatus$maritalStatusFullString = function (maritalStatus) {
	switch (maritalStatus) {
		case 0:
			return 'Single';
		case 1:
			return 'Open Relationship';
		case 2:
			return 'Separated';
		case 4:
			return 'Widowed';
		case 3:
			return 'Divorced';
		case 5:
			return 'Attached But Looking';
		case 6:
			return 'Married But Looking';
		default:
			return 'Prefer Not To Say';
	}
};
var $author$project$Page$Detail$BasicInfo$verifyButton = function (isVerified) {
	return isVerified ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.jG)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.jE)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.jF),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.nr)
							]),
						_List_Nil),
						$rtfeldman$elm_css$Html$Styled$text('USER VERIFIED')
					]))
			])) : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Page$Detail$BasicInfo$view = F6(
	function (currentTime, currentUserProfile, profile, publicPhotos, favoriteStatus, blockStatus) {
		var _v0 = profile;
		var username = _v0.dh;
		var headline = _v0.cy;
		var gender = _v0.bt;
		var locations = _v0.cE;
		var birthday = _v0.cf;
		var maritalStatus = _v0.bB;
		var _v1 = $author$project$Core$Data$Profile$getPrimaryAndSecondaryLocations(locations);
		var primaryLocation = _v1.a;
		var secondaryLocation = _v1.b;
		var ageAndLocation = $elm$core$String$fromInt(
			A2($author$project$Core$Data$Profile$birthdayToAge, birthday, currentTime)) + (', ' + primaryLocation);
		var locationsString = (secondaryLocation === '') ? _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(primaryLocation)
			]) : _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(primaryLocation),
				A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
				A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
				$rtfeldman$elm_css$Html$Styled$text(secondaryLocation)
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.jt)
						]),
					_List_fromArray(
						[
							A2($author$project$Page$Detail$BasicInfo$displayAvatar, profile, publicPhotos),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.dh)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(username)
								])),
							$author$project$Page$Detail$BasicInfo$displaySponsorLevel(profile),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.e7)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(ageAndLocation)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cy)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('\"' + (headline + '\"'))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.fG),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'chatAndFavoriteButton')
								]),
							_List_fromArray(
								[
									A3($author$project$Page$Detail$BasicInfo$chatOrUpgradeButton, profile, currentUserProfile, blockStatus),
									A2(
									$author$project$Helpers$toAppHtml,
									$author$project$Types$OnDetail,
									A2($author$project$Page$Detail$BasicInfo$favoriteButton, profile, favoriteStatus))
								])),
							$author$project$Page$Detail$BasicInfo$verifyButton(false)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.fy)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.fn)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.dd)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('BASIC INFORMATION')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cV)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cQ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cR)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Gender')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cS)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Core$Data$Profile$Gender$genderString(gender))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cV)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cQ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cR)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Relationship')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cS)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Core$Data$Profile$MaritalStatus$maritalStatusFullString(maritalStatus))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cV)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cQ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cR)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Location')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$BasicInfo$styles.cS)
												]),
											locationsString)
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Detail$PersonalInfo$contentWithDefault = function (content) {
	return $elm$core$String$isEmpty(content) ? '--' : content;
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $elm$core$String$lines = _String_lines;
var $author$project$Page$Detail$PersonalInfo$breakLines = function (content) {
	var _v0 = $elm$core$String$lines(content);
	if ((_v0.b && (_v0.a === '')) && (!_v0.b.b)) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Page$Detail$PersonalInfo$contentWithDefault(''))
			]);
	} else {
		var lines = _v0;
		return A2(
			$elm$core$List$intersperse,
			A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
			A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$text, lines));
	}
};
var $rtfeldman$elm_css$Css$inlineBlock = {o: 0, v: 'inline-block'};
var $author$project$Page$Detail$PersonalInfo$titleStyle = _Utils_ap(
	$author$project$View$Theme$defaultStyles.kd,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle)
		]));
var $author$project$Page$Detail$PersonalInfo$styles = {
	ft: _Utils_ap(
		$author$project$Page$Detail$PersonalInfo$titleStyle,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA)
			])),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(42))),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$auto)
				]))
		]),
	g6: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	dQ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingTop(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$flexGrow(
				$rtfeldman$elm_css$Css$num(1)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(14))
			])),
	dR: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(33))
		]),
	dS: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(14))
			])),
	g8: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(14)),
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
				$rtfeldman$elm_css$Css$marginRight(
				$rtfeldman$elm_css$Css$px(5)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$px(5)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(14)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(20))
			])),
	g9: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	dU: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(14))
			])),
	cV: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(17),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gN)
		]),
	dd: _Utils_ap(
		$author$project$Page$Detail$PersonalInfo$titleStyle,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO)
			])),
	de: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		])
};
var $author$project$Page$Detail$PersonalInfo$aboutMeInformation = function (_v0) {
	var aboutMe = _v0.b6;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.g6)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.de)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.dd)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ABOUT ME')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.dU)
					]),
				$author$project$Page$Detail$PersonalInfo$breakLines(aboutMe))
			]));
};
var $author$project$Core$Data$Profile$BodyType$bodyTypeFullString = function (bodyType) {
	switch (bodyType) {
		case 0:
			return 'Slim';
		case 1:
			return 'Athletic';
		case 2:
			return 'Average';
		case 3:
			return 'Curvy';
		case 4:
			return 'Flabby';
		case 5:
			return 'Overweight';
		default:
			return '--';
	}
};
var $author$project$Page$Detail$PersonalInfo$listStringToContent = F2(
	function (content, contents) {
		listStringToContent:
		while (true) {
			if (contents.b) {
				var string = contents.a;
				var rest = contents.b;
				if ($elm$core$List$isEmpty(rest)) {
					var $temp$content = _Utils_ap(content, string),
						$temp$contents = rest;
					content = $temp$content;
					contents = $temp$contents;
					continue listStringToContent;
				} else {
					var $temp$content = content + (string + ', '),
						$temp$contents = rest;
					content = $temp$content;
					contents = $temp$contents;
					continue listStringToContent;
				}
			} else {
				return content;
			}
		}
	});
var $author$project$Page$Detail$PersonalInfo$displayListStringData = F2(
	function (label, contents) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.dR)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.dS)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.dQ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Page$Detail$PersonalInfo$listStringToContent, '', contents))
						]))
				]));
	});
var $author$project$Page$Detail$PersonalInfo$displayStringData = F2(
	function (label, content) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.dR)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.dS)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.dQ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Page$Detail$PersonalInfo$contentWithDefault(content))
						]))
				]));
	});
var $author$project$Core$Data$Profile$Drinker$drinkerFullString = function (drinker) {
	switch (drinker) {
		case 0:
			return 'Non Drinker';
		case 1:
			return 'Social Drinker';
		default:
			return 'Heavy Drinker';
	}
};
var $author$project$Core$Data$Profile$Education$educationFullString = function (education) {
	switch (education) {
		case 0:
			return 'High School';
		case 1:
			return 'Some College';
		case 2:
			return 'Associates Degree';
		case 3:
			return 'Bachelors Degree';
		case 4:
			return 'Graduate Degree';
		default:
			return 'PhD / Post Doctoral';
	}
};
var $author$project$Core$Data$Profile$Ethnicity$ethnicityFullString = function (ethnicity) {
	switch (ethnicity) {
		case 0:
			return 'Asian';
		case 1:
			return 'Black / African Descent';
		case 2:
			return 'Latin / Hispanic';
		case 3:
			return 'East Indian';
		case 4:
			return 'Middle Eastern';
		case 5:
			return 'Mixed';
		case 6:
			return 'Native American';
		case 7:
			return 'Pacific Islander';
		case 8:
			return 'White / Causasian';
		default:
			return 'Other Ethnicity';
	}
};
var $author$project$Page$Detail$PersonalInfo$getHeightText = function (height) {
	if (!height.$) {
		return $author$project$Core$Data$Profile$Height$heightInImperial(height) + (' (' + ($author$project$Core$Data$Profile$Height$heightString(height) + 'cm)'));
	} else {
		return '';
	}
};
var $author$project$Core$Data$Profile$NumberOfChildren$numberOfChildrenFullString = function (children) {
	switch (children) {
		case 0:
			return 'Not Specified';
		case 1:
			return '0';
		case 2:
			return '1';
		case 3:
			return '2';
		case 4:
			return '3';
		case 5:
			return '4';
		case 6:
			return '5';
		default:
			return '6 or More';
	}
};
var $author$project$Core$Data$Profile$Smoker$smokerFullString = function (smoker) {
	switch (smoker) {
		case 0:
			return 'Non Smoker';
		case 1:
			return 'Light Smoker';
		default:
			return 'Heavy Smoker';
	}
};
var $author$project$Core$Data$Profile$WantGender$wantGenderFullString = function (wantGender) {
	switch (wantGender) {
		case 0:
			return 'Men';
		case 1:
			return 'Ladies';
		default:
			return 'Both';
	}
};
var $author$project$Page$Detail$PersonalInfo$additionalInformation = function (profile) {
	var _v0 = profile;
	var wantGender = _v0.di;
	var lifestyleExpectation = _v0.bz;
	var height = _v0.bu;
	var bodyType = _v0.bi;
	var ethnicity = _v0.bo;
	var numberOfChildren = _v0.bF;
	var education = _v0.bn;
	var occupation = _v0.cN;
	var smoker = _v0.bW;
	var drinker = _v0.bm;
	var wantRelationships = _v0.b4;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.g6)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.de)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.ft)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('INFORMATION')
							]))
					])),
				A2(
				$author$project$Page$Detail$PersonalInfo$displayStringData,
				'Looking For',
				$author$project$Core$Data$Profile$WantGender$wantGenderFullString(wantGender)),
				A2(
				$author$project$Page$Detail$PersonalInfo$displayStringData,
				'Ethnicity',
				$author$project$Core$Data$Profile$Ethnicity$ethnicityFullString(ethnicity)),
				A2(
				$author$project$Page$Detail$PersonalInfo$displayStringData,
				'Children',
				$author$project$Core$Data$Profile$NumberOfChildren$numberOfChildrenFullString(numberOfChildren)),
				A2(
				$author$project$Page$Detail$PersonalInfo$displayStringData,
				'Lifestyle Expectation',
				$author$project$Core$Data$Profile$LifestyleExpectation$lifestyleExpectationString(lifestyleExpectation)),
				A2(
				$author$project$Page$Detail$PersonalInfo$displayStringData,
				'Education',
				$author$project$Core$Data$Profile$Education$educationFullString(education)),
				A2(
				$author$project$Page$Detail$PersonalInfo$displayStringData,
				'Smokes',
				$author$project$Core$Data$Profile$Smoker$smokerFullString(smoker)),
				A2(
				$author$project$Page$Detail$PersonalInfo$displayStringData,
				'Body Type',
				$author$project$Core$Data$Profile$BodyType$bodyTypeFullString(bodyType)),
				A2($author$project$Page$Detail$PersonalInfo$displayStringData, 'Occupation', occupation),
				A2(
				$author$project$Page$Detail$PersonalInfo$displayStringData,
				'Drinks',
				$author$project$Core$Data$Profile$Drinker$drinkerFullString(drinker)),
				A2(
				$author$project$Page$Detail$PersonalInfo$displayStringData,
				'Height',
				$author$project$Page$Detail$PersonalInfo$getHeightText(height)),
				A2(
				$author$project$Page$Detail$PersonalInfo$displayListStringData,
				'Ideal Relationship',
				$author$project$Core$Data$Profile$WantRelationship$wantRelationshipsListFullString(wantRelationships))
			]));
};
var $author$project$Core$Data$Profile$Benefit$benefitFullString = function (benefit) {
	switch (benefit) {
		case 0:
			return 'Active Lifestyle';
		case 1:
			return 'Activity Partner';
		case 2:
			return 'Adventure';
		case 3:
			return 'Affection';
		case 4:
			return 'All Ethnicities';
		case 5:
			return 'Animal Lover';
		case 6:
			return 'Attention';
		case 7:
			return 'BBW';
		case 8:
			return 'Casual Dates';
		case 9:
			return 'Casual Encounters';
		case 10:
			return 'Casual Meetups';
		case 11:
			return 'Coffee Dates';
		case 14:
			return 'Confidant';
		case 12:
			return 'Companion';
		case 13:
			return 'Concerts/Musicals/Plays';
		case 15:
			return 'Daytime Meetups';
		case 16:
			return 'Dinner Dates';
		case 17:
			return 'Discretion';
		case 18:
			return 'Emotional Connection';
		case 19:
			return 'Evening Meetups';
		case 20:
			return 'Excitement';
		case 21:
			return 'Exclusive';
		case 22:
			return 'Financial Support';
		case 23:
			return 'Flexible Schedule';
		case 24:
			return 'Food Lover';
		case 25:
			return 'Friends With Benefits';
		case 26:
			return 'Fun';
		case 27:
			return 'Gay Dating';
		case 28:
			return 'Good Cook';
		case 29:
			return 'Hook Up';
		case 30:
			return 'Lesbian Dating';
		case 31:
			return 'Listening Ear';
		case 32:
			return 'Long Term';
		case 33:
			return 'Lunch Dates';
		case 42:
			return 'Nature Lover';
		case 34:
			return 'Marriage Minded';
		case 35:
			return 'Medium Term';
		case 36:
			return 'Meet For Drinks';
		case 37:
			return 'Mentorship';
		case 38:
			return 'Minimal Tattoos';
		case 39:
			return 'Monogamous';
		case 40:
			return 'Monthly Allowance';
		case 41:
			return 'Movie Dates';
		case 43:
			return 'Night Time Meetups';
		case 44:
			return 'No Attached Dates';
		case 45:
			return 'No Intimacy';
		case 46:
			return 'No Married Dates';
		case 47:
			return 'No Stayovers';
		case 48:
			return 'No Strings Attached';
		case 49:
			return 'No Travel';
		case 50:
			return 'Non Exclusive';
		case 51:
			return 'Non Monogamous';
		case 52:
			return 'Occasional Dates';
		case 53:
			return 'One Off Dates';
		case 54:
			return 'Online Only';
		case 55:
			return 'ONS';
		case 56:
			return 'Open Relationship';
		case 57:
			return 'Pescatarian';
		case 58:
			return 'Platonic';
		case 59:
			return 'Professional Networking';
		case 60:
			return 'Rent Assistance';
		case 61:
			return 'Romance';
		case 62:
			return 'Senior Dating';
		case 63:
			return 'Short Term';
		case 64:
			return 'Singles Only';
		case 65:
			return 'Soulmate';
		case 66:
			return 'Spontaneity';
		case 67:
			return 'Sports Dates';
		case 68:
			return 'Stay In Partner';
		case 69:
			return 'Staycations';
		case 70:
			return 'Stayovers';
		case 71:
			return 'Sugar Newbie';
		case 72:
			return 'Sugar Veteran';
		case 73:
			return 'Surprises';
		case 74:
			return 'Tattoo Friendly';
		case 75:
			return 'Trans Friendly';
		case 76:
			return 'Transgender';
		case 77:
			return 'Travel To You';
		case 78:
			return 'Travel With You';
		case 79:
			return 'Vacations';
		case 80:
			return 'Vegetarian';
		case 81:
			return 'Weekdays Only';
		default:
			return 'Weekends Only';
	}
};
var $author$project$Core$Data$Profile$Benefit$benefitsListFullString = function (benefits) {
	return A2($elm$core$List$map, $author$project$Core$Data$Profile$Benefit$benefitFullString, benefits);
};
var $author$project$Page$Detail$PersonalInfo$listStringToTags = F2(
	function (html, contents) {
		listStringToTags:
		while (true) {
			if (contents.b) {
				var string = contents.a;
				var rest = contents.b;
				var tag = A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.g8)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(string)
						]));
				var $temp$html = A2(
					$elm$core$List$append,
					_List_fromArray(
						[tag]),
					html),
					$temp$contents = rest;
				html = $temp$html;
				contents = $temp$contents;
				continue listStringToTags;
			} else {
				return html;
			}
		}
	});
var $author$project$Page$Detail$PersonalInfo$displayListTagData = function (contents) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.g9)
			]),
		A2($author$project$Page$Detail$PersonalInfo$listStringToTags, _List_Nil, contents));
};
var $author$project$Page$Detail$PersonalInfo$lookingForInformation = function (_v0) {
	var benefits = _v0.bg;
	var otherBenefit = _v0.cP;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.g6)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.de)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.dd)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('WHAT I\'M LOOKING FOR')
							]))
					])),
				$author$project$Page$Detail$PersonalInfo$displayListTagData(
				$author$project$Core$Data$Profile$Benefit$benefitsListFullString(benefits)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.dU)
					]),
				$author$project$Page$Detail$PersonalInfo$breakLines(otherBenefit))
			]));
};
var $author$project$Page$Detail$PersonalInfo$view = function (profile) {
	return A2(
		$author$project$Helpers$toAppHtml,
		$author$project$Types$OnDetail,
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.f1)
				]),
			_List_fromArray(
				[
					$author$project$Page$Detail$PersonalInfo$additionalInformation(profile),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.cV)
						]),
					_List_Nil),
					$author$project$Page$Detail$PersonalInfo$aboutMeInformation(profile),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PersonalInfo$styles.cV)
						]),
					_List_Nil),
					$author$project$Page$Detail$PersonalInfo$lookingForInformation(profile)
				])));
};
var $author$project$Helpers$ReportUser$Types$OpenPopup = {$: 0};
var $author$project$Page$Detail$PhotoInfo$styles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$auto)
				]))
		]),
	mP: function (url) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$table),
				$rtfeldman$elm_css$Css$marginRight(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$width(
				A3(
					$rtfeldman$elm_css$Css$calc,
					$rtfeldman$elm_css$Css$pct(25),
					$rtfeldman$elm_css$Css$minus,
					$rtfeldman$elm_css$Css$px(15))),
				$rtfeldman$elm_css$Css$backgroundImage(
				$rtfeldman$elm_css$Css$url(url)),
				$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
				$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(6)),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				$author$project$View$Theme$colors.gN),
				A2($rtfeldman$elm_css$Css$property, 'padding-top', 'calc(25% - 10px)'),
				A2($rtfeldman$elm_css$Css$property, '-webkit-mask-image', '-webkit-radial-gradient(white, black)'),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
			]);
	},
	h5: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(6)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.fs),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.5))
		]),
	h6: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
				$rtfeldman$elm_css$Css$paddingTop(
				$rtfeldman$elm_css$Css$pct(39)),
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(32)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	h8: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(20))
		]),
	aA: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginLeft(
				A3(
					$rtfeldman$elm_css$Css$calc,
					$rtfeldman$elm_css$Css$pct(100),
					$rtfeldman$elm_css$Css$minus,
					$rtfeldman$elm_css$Css$px(140))),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$px(10)),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(5),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(140)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
			])),
	eB: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.ly),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(6)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
					$rtfeldman$elm_css$Css$borderColor($author$project$View$Theme$colors.lz),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	eC: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(7)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-3)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(18))
		]),
	dd: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(40)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(40)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(13)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
				$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle)
			])),
	de: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(15),
			$rtfeldman$elm_css$Css$px(20))
		])
};
var $author$project$Page$Detail$PhotoInfo$renderPhotoWithCounter = F3(
	function (photos, photoIndex, counter) {
		var photo = $elm$core$List$head(
			A2($elm$core$List$drop, photoIndex, photos));
		if (!photo.$) {
			var thumbnailUrl = photo.a.nT;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$author$project$Page$Detail$PhotoInfo$styles.mP(thumbnailUrl)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Type$Detail$PopupMsg(
							A2(
								$author$project$PopupPhoto$openGalleryMsg,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.n8;
									},
									photos),
								photoIndex)))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PhotoInfo$styles.h5)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PhotoInfo$styles.h6)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								'+' + $elm$core$String$fromInt(counter))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$Detail$PhotoInfo$viewPhoto = F2(
	function (photos, index) {
		var photo = $elm$core$List$head(
			A2($elm$core$List$drop, index, photos));
		if (!photo.$) {
			var url = photo.a.n8;
			return A2(
				$rtfeldman$elm_css$Html$Styled$map,
				$author$project$Type$Detail$PopupMsg,
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$Page$Detail$PhotoInfo$styles.mP(url)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A2(
								$author$project$PopupPhoto$openGalleryMsg,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.n8;
									},
									photos),
								index))
						]),
					_List_Nil));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$Detail$PhotoInfo$displayLastPhoto = F2(
	function (allPhotos, remainingPhotos) {
		var photoIndex = $elm$core$List$length(allPhotos) - $elm$core$List$length(remainingPhotos);
		if (!remainingPhotos.b) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			if (!remainingPhotos.b.b) {
				return A2($author$project$Page$Detail$PhotoInfo$viewPhoto, allPhotos, photoIndex);
			} else {
				var rest = remainingPhotos.b;
				var restPhotosCount = $elm$core$List$length(rest);
				return A3($author$project$Page$Detail$PhotoInfo$renderPhotoWithCounter, allPhotos, photoIndex, restPhotosCount);
			}
		}
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{s: nodeList, p: nodeListSize, r: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Array$toIndexedList = function (array) {
	var len = array.a;
	var helper = F2(
		function (entry, _v0) {
			var index = _v0.a;
			var list = _v0.b;
			return _Utils_Tuple2(
				index - 1,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(index, entry),
					list));
		});
	return A3(
		$elm$core$Array$foldr,
		helper,
		_Utils_Tuple2(len - 1, _List_Nil),
		array).b;
};
var $author$project$Page$Detail$PhotoInfo$displayPhotos = F3(
	function (title, button, photos) {
		var restPhotos = A2($elm$core$List$drop, 3, photos);
		var firstThreePhotos = $elm$core$Array$toIndexedList(
			$elm$core$Array$fromList(
				A2(
					$elm$core$List$take,
					3,
					A2(
						$elm$core$List$filter,
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Core$Data$Profile$Photo$isLoadingPhoto),
						photos))));
		var displayPhoto = function (_v0) {
			var index = _v0.a;
			return A2(
				$author$project$Helpers$toAppHtml,
				$author$project$Types$OnDetail,
				A2($author$project$Page$Detail$PhotoInfo$viewPhoto, photos, index));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PhotoInfo$styles.de)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PhotoInfo$styles.dd)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(title)
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$rtfeldman$elm_css$Html$Styled$text(''),
							button)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PhotoInfo$styles.h8)
						]),
					_Utils_ap(
						A2($elm$core$List$map, displayPhoto, firstThreePhotos),
						_List_fromArray(
							[
								A2(
								$author$project$Helpers$toAppHtml,
								$author$project$Types$OnDetail,
								A2($author$project$Page$Detail$PhotoInfo$displayLastPhoto, photos, restPhotos))
							])))
				]));
	});
var $author$project$Type$Chat$SendPrivatePhotoRequest = F3(
	function (a, b, c) {
		return {$: 18, a: a, b: b, c: c};
	});
var $author$project$Types$WithCurrentTime = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$Detail$PhotoInfo$requestPrivatePhotoButton = F2(
	function (user, partnerProfile) {
		var onClickMsg = $author$project$Types$WithCurrentTime(
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
				A2(
					$author$project$Type$Chat$SendPrivatePhotoRequest,
					user,
					A2($author$project$Data$Chat$Partner$fromProfile, partnerProfile, 0))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(onClickMsg),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$View$Theme$defaultStyles.lt, $author$project$Page$Detail$PhotoInfo$styles.eB))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PhotoInfo$styles.eC),
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.io)
						]),
					_List_Nil),
					$rtfeldman$elm_css$Html$Styled$text('View Private Photos')
				]));
	});
var $author$project$Page$Detail$PhotoInfo$upgradeButton = function (_v0) {
	var sponsorLevel = _v0.bY;
	return A2(
		$rtfeldman$elm_css$Html$Styled$a,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap($author$project$View$Theme$defaultStyles.lt, $author$project$Page$Detail$PhotoInfo$styles.eB)),
				$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l9)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PhotoInfo$styles.eC),
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.io)
					]),
				_List_Nil),
				$rtfeldman$elm_css$Html$Styled$text(
				'Upgrade to ' + $author$project$Core$Data$Profile$SponsorLevel$sponsorLevelString(sponsorLevel))
			]));
};
var $author$project$Page$Detail$PhotoInfo$requestPrivatePhoto = F3(
	function (user, partner, blockStatus) {
		var buttonView = function () {
			var _v1 = user.eY;
			if (_v1 === 1) {
				return A2($author$project$Page$Detail$PhotoInfo$requestPrivatePhotoButton, user, partner);
			} else {
				return (_Utils_cmp(
					$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(partner.bY),
					$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(user.bY)) > 0) ? $author$project$Page$Detail$PhotoInfo$upgradeButton(partner) : A2($author$project$Page$Detail$PhotoInfo$requestPrivatePhotoButton, user, partner);
			}
		}();
		switch (blockStatus.$) {
			case 1:
				return buttonView;
			case 3:
				return buttonView;
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$Detail$PhotoInfo$view = F5(
	function (currentUserProfile, profile, publicPhotos, privatePhotoAccess, blockStatus) {
		var updatedPrivatePhotoAccess = function () {
			var _v1 = currentUserProfile.eY;
			if (_v1 === 1) {
				return privatePhotoAccess;
			} else {
				return (_Utils_cmp(
					$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(profile.bY),
					$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(currentUserProfile.bY)) > 0) ? $author$project$Type$Detail$Refused : privatePhotoAccess;
			}
		}();
		var photosView = function () {
			switch (updatedPrivatePhotoAccess.$) {
				case 0:
					var photos = updatedPrivatePhotoAccess.a;
					return $elm$core$List$isEmpty(photos) ? _List_fromArray(
						[
							A3($author$project$Page$Detail$PhotoInfo$displayPhotos, 'PHOTOS', $elm$core$Maybe$Nothing, publicPhotos)
						]) : _List_fromArray(
						[
							A3($author$project$Page$Detail$PhotoInfo$displayPhotos, 'PHOTOS', $elm$core$Maybe$Nothing, publicPhotos),
							A3($author$project$Page$Detail$PhotoInfo$displayPhotos, 'PRIVATE PHOTOS', $elm$core$Maybe$Nothing, photos)
						]);
				case 1:
					var privatePhotoNumber = $elm$core$String$fromInt(profile.cZ);
					var title = 'PHOTOS (' + (privatePhotoNumber + ' private photos)');
					var button = $elm$core$Maybe$Just(
						A3($author$project$Page$Detail$PhotoInfo$requestPrivatePhoto, currentUserProfile, profile, blockStatus));
					return _List_fromArray(
						[
							A3($author$project$Page$Detail$PhotoInfo$displayPhotos, title, button, publicPhotos)
						]);
				default:
					return _List_fromArray(
						[
							A3($author$project$Page$Detail$PhotoInfo$displayPhotos, 'PHOTOS', $elm$core$Maybe$Nothing, publicPhotos)
						]);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PhotoInfo$styles.f1),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'photoWrapper')
				]),
			_Utils_ap(
				photosView,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$PhotoInfo$styles.aA),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnDetail(
										A2($author$project$Type$Detail$Report, profile.eX, $author$project$Helpers$ReportUser$Types$OpenPopup)))),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'reportLink')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Report user')
							]))
					])));
	});
var $author$project$PopupPhoto$Close = {$: 1};
var $author$project$PopupPhoto$ShowNext = {$: 2};
var $author$project$PopupPhoto$ShowPrevious = {$: 3};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $rtfeldman$elm_css$Css$bottom = $rtfeldman$elm_css$Css$prop1('bottom');
var $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1('max-width');
var $author$project$PopupPhoto$popupButton = _List_fromArray(
	[
		$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
		$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
		$rtfeldman$elm_css$Css$opacity(
		$rtfeldman$elm_css$Css$num(0.8)),
		$rtfeldman$elm_css$Css$hover(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
			]))
	]);
var $author$project$PopupPhoto$styles = {
	ff: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('000000')),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.9))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(10000)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	f4: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(14),
			$rtfeldman$elm_css$Css$px(7)),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$pct(15)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(7)),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.8)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('FFFFFF')),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				['Open Sans', 'sans-serif']))
		]),
	mP: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$pct(90)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$pct(80)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(6)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$hex('BDBDBD'))
		]),
	ie: _Utils_ap(
		$author$project$PopupPhoto$popupButton,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(60)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(60))
			])),
	$8: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(20))
		]),
	ig: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	mW: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	ih: _Utils_ap(
		$author$project$PopupPhoto$popupButton,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$top(
				A3(
					$rtfeldman$elm_css$Css$calc,
					$rtfeldman$elm_css$Css$pct(50),
					$rtfeldman$elm_css$Css$minus,
					$rtfeldman$elm_css$Css$px(40))),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(60)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(80)),
				A2(
				$rtfeldman$elm_css$Css$Media$withMedia,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Css$Media$only,
						$rtfeldman$elm_css$Css$Media$screen,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Media$maxWidth(
								$rtfeldman$elm_css$Css$px(767))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$top(
						$rtfeldman$elm_css$Css$pct(75))
					]))
			])),
	ii: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(23)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(17)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(32))
		]),
	ij: _Utils_ap(
		$author$project$PopupPhoto$popupButton,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$top(
				A3(
					$rtfeldman$elm_css$Css$calc,
					$rtfeldman$elm_css$Css$pct(50),
					$rtfeldman$elm_css$Css$minus,
					$rtfeldman$elm_css$Css$px(40))),
				$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(60)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(80)),
				A2(
				$rtfeldman$elm_css$Css$Media$withMedia,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Css$Media$only,
						$rtfeldman$elm_css$Css$Media$screen,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Media$maxWidth(
								$rtfeldman$elm_css$Css$px(767))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$top(
						$rtfeldman$elm_css$Css$pct(75))
					]))
			])),
	ik: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(23)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(23)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(17)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(32))
		])
};
var $author$project$PopupPhoto$popupCloseButton = F2(
	function (icon, _v0) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.ie),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$PopupPhoto$Close),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'popupCloseButton')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.$8),
							$rtfeldman$elm_css$Html$Styled$Attributes$src(icon)
						]),
					_List_Nil)
				]));
	});
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$PopupPhoto$showIndex = F2(
	function (photoIndex, photoCount) {
		var indexLabel = $elm$core$String$fromInt(photoIndex + 1) + ('/' + $elm$core$String$fromInt(photoCount));
		return (photoCount === 1) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.f4)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(indexLabel)
				]));
	});
var $author$project$PopupPhoto$popupContent = F2(
	function (currentIndex, photos) {
		var _v0 = A2($elm$core$Array$get, currentIndex, photos);
		if (!_v0.$) {
			var url = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.mW),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$PopupPhoto$Close),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'popupContentContainer')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.mP),
								$rtfeldman$elm_css$Html$Styled$Attributes$src(url),
								A2(
								$rtfeldman$elm_css$Html$Styled$Events$custom,
								'click',
								$elm$json$Json$Decode$succeed(
									{h: $author$project$PopupPhoto$Noop, m_: true, nC: true}))
							]),
						_List_Nil),
						A2(
						$author$project$PopupPhoto$showIndex,
						currentIndex,
						$elm$core$Array$length(photos))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.mW)
					]),
				_List_Nil);
		}
	});
var $author$project$PopupPhoto$popupLeftButton = function (icon) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.ih),
				$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$PopupPhoto$ShowPrevious),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'popupLeftButton')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.ii),
						$rtfeldman$elm_css$Html$Styled$Attributes$src(icon)
					]),
				_List_Nil)
			]));
};
var $author$project$PopupPhoto$popupRightButton = function (icon) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.ij),
				$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$PopupPhoto$ShowNext),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'popupRightButton')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.ik),
						$rtfeldman$elm_css$Html$Styled$Attributes$src(icon)
					]),
				_List_Nil)
			]));
};
var $author$project$PopupPhoto$showNavigation = F2(
	function (_v0, photoCount) {
		var config = _v0.bl;
		return (photoCount === 1) ? _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('')
			]) : _List_fromArray(
			[
				$author$project$PopupPhoto$popupLeftButton(config.l_),
				$author$project$PopupPhoto$popupRightButton(config.nf)
			]);
	});
var $author$project$PopupPhoto$view = function (model) {
	var onKeyUp = A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keyup',
		A2(
			$elm$json$Json$Decode$andThen,
			function (keyCodeInt) {
				switch (keyCodeInt) {
					case 27:
						return $elm$json$Json$Decode$succeed($author$project$PopupPhoto$Close);
					case 37:
						return $elm$json$Json$Decode$succeed($author$project$PopupPhoto$ShowPrevious);
					case 39:
						return $elm$json$Json$Decode$succeed($author$project$PopupPhoto$ShowNext);
					default:
						return $elm$json$Json$Decode$fail(
							$elm$core$String$fromInt(keyCodeInt));
				}
			},
			$rtfeldman$elm_css$Html$Styled$Events$keyCode));
	var _v0 = model;
	var photos = _v0.bL;
	var photoIndex = _v0.K;
	var status = _v0.eQ;
	var photoArray = $elm$core$Array$fromList(photos);
	var photoCount = $elm$core$Array$length(photoArray);
	var toggleStyle = function () {
		switch (status) {
			case 0:
				return _List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, 'transition', 'transform 0.3s ease, opacity 0.3s ease'),
						$rtfeldman$elm_css$Css$transform(
						$rtfeldman$elm_css$Css$scale(1)),
						$rtfeldman$elm_css$Css$opacity(
						$rtfeldman$elm_css$Css$num(1))
					]);
			case 1:
				return _List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, 'transition', 'transform 0.3s ease, opacity 0.3s ease'),
						$rtfeldman$elm_css$Css$transform(
						$rtfeldman$elm_css$Css$scale(0)),
						$rtfeldman$elm_css$Css$opacity(
						$rtfeldman$elm_css$Css$num(0))
					]);
			default:
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$transform(
						$rtfeldman$elm_css$Css$scale(0)),
						$rtfeldman$elm_css$Css$opacity(
						$rtfeldman$elm_css$Css$num(0))
					]);
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap($author$project$PopupPhoto$styles.f1, toggleStyle)),
				onKeyUp,
				$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0),
				$rtfeldman$elm_css$Html$Styled$Attributes$id(model.bl.eq)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.ff)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$PopupPhoto$styles.ig)
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2($author$project$PopupPhoto$popupContent, photoIndex, photoArray),
							A2($author$project$PopupPhoto$popupCloseButton, model.bl.f_, photoIndex)
						]),
					A2($author$project$PopupPhoto$showNavigation, model, photoCount)))
			]));
};
var $author$project$Page$Detail$renderFullDetail = F5(
	function (containerStyle, currentTime, model, fullProfile, currentUserProfile) {
		var _v0 = model;
		var popupGallery = _v0.ep;
		var error = _v0.gs;
		var _v1 = fullProfile;
		var profile = _v1.iu;
		var publicPhotos = _v1.m5;
		var privatePhotoAccess = _v1.bQ;
		var favoriteStatus = _v1.aN;
		var reportUser = _v1.aA;
		var blockStatus = _v1.j9;
		var reportUserHtml = A2(
			$elm$core$Maybe$withDefault,
			$rtfeldman$elm_css$Html$Styled$text(''),
			A2($elm$core$Maybe$map, $author$project$Helpers$ReportUser$View$view, reportUser));
		if (profile.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
					]),
				_List_fromArray(
					[$author$project$View$Display$simpleLoadingView]));
		} else {
			var profile_ = profile.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$styles.gs)
							]),
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$rtfeldman$elm_css$Html$Styled$text(''),
								A2(
									$elm$core$Maybe$map,
									function (message) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
														]))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(message)
												]));
									},
									error))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$styles.ha)
							]),
						_List_fromArray(
							[
								A6($author$project$Page$Detail$BasicInfo$view, currentTime, currentUserProfile, profile_, publicPhotos, favoriteStatus, blockStatus),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$styles.h4)
									]),
								_List_fromArray(
									[
										A2(
										$elm$core$Maybe$withDefault,
										$rtfeldman$elm_css$Html$Styled$text(''),
										A2(
											$elm$core$Maybe$map,
											function (message) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css(
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
																]))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(message)
														]));
											},
											error)),
										A5($author$project$Page$Detail$PhotoInfo$view, currentUserProfile, profile_, publicPhotos, privatePhotoAccess, blockStatus),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Detail$styles.h3)
											]),
										_List_fromArray(
											[
												$author$project$Page$Detail$PersonalInfo$view(profile_)
											]))
									])),
								$author$project$Page$Detail$backButton,
								A2(
								$author$project$Helpers$toAppHtml,
								$author$project$Types$OnDetail,
								A2(
									$rtfeldman$elm_css$Html$Styled$map,
									$author$project$Type$Detail$PopupMsg,
									$author$project$PopupPhoto$view(popupGallery))),
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnDetail),
									$author$project$Type$Detail$Report(profile_.eX)),
								reportUserHtml),
								A2($author$project$Page$Detail$unBlockView, profile_.eX, blockStatus)
							]))
					]));
		}
	});
var $author$project$Page$Detail$renderDetail = F4(
	function (dimension, userID, currentTime, authState) {
		var model = authState.gj;
		var currentUserProfile = $author$project$Helpers$getCurrentUserProfile(authState);
		var containerStyle = A2(
			$author$project$Page$Detail$styles.f1,
			dimension,
			$author$project$View$Helpers$UserInfo$isMissingAvatar(authState));
		var _v0 = model;
		var profiles = _v0.iw;
		var fullProfile = A2($elm$core$Dict$get, userID, profiles);
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
					]),
				_List_fromArray(
					[$author$project$View$Display$simpleLoadingView])),
			A3(
				$elm$core$Maybe$map2,
				A3($author$project$Page$Detail$renderFullDetail, containerStyle, currentTime, model),
				fullProfile,
				currentUserProfile));
	});
var $author$project$Page$Detail$view = F2(
	function (appModel, authState) {
		var _v0 = appModel.ng;
		if (_v0.$ === 20) {
			var userID = _v0.a;
			return A4($author$project$Page$Detail$renderDetail, appModel.kR, userID, appModel.kG, authState);
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Type$RelatedProfiles$LoadMore = $elm$core$Basics$identity;
var $author$project$Page$RelatedProfiles$styles = {
	fz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$zero)
		]),
	f1: F2(
		function (_v0, hasAlert) {
			var screenHeight = _v0.ni;
			return _Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.lx)
					]),
				A2($author$project$View$Theme$defaultStyles.kz, screenHeight, hasAlert));
		}),
	c0: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(20))
		])
};
var $author$project$Page$RelatedProfiles$buttonLoadMore = F3(
	function (connectKind, searchLimit, numberOfIDs) {
		return (_Utils_cmp(searchLimit, numberOfIDs) > 0) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RelatedProfiles$styles.fz)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kj),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnRelatedProfiles(connectKind)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Load More')
						]))
				]));
	});
var $author$project$Animate$Pulse = 2;
var $author$project$Animate$animationToString = function (animation) {
	switch (animation) {
		case 0:
			return 'bounce';
		case 1:
			return 'flash';
		case 2:
			return 'pulse';
		case 3:
			return 'rubberBand';
		case 4:
			return 'shake';
		case 5:
			return 'headShake';
		case 6:
			return 'swing';
		case 7:
			return 'tada';
		case 8:
			return 'wobble';
		case 9:
			return 'jello';
		case 10:
			return 'bounceIn';
		case 11:
			return 'bounceInDown';
		case 12:
			return 'bounceInLeft';
		case 13:
			return 'bounceInRight';
		case 14:
			return 'bounceInUp';
		case 15:
			return 'bounceOut';
		case 16:
			return 'bounceOutDown';
		case 17:
			return 'bounceOutLeft';
		case 18:
			return 'bounceOutRight';
		case 19:
			return 'bounceOutUp';
		case 20:
			return 'fadeIn';
		case 21:
			return 'fadeInDown';
		case 22:
			return 'fadeInDownBig';
		case 23:
			return 'fadeInLeft';
		case 24:
			return 'fadeInLeftBig';
		case 25:
			return 'fadeInRight';
		case 26:
			return 'fadeInRightBig';
		case 27:
			return 'fadeInUp';
		case 28:
			return 'fadeInUpBig';
		case 29:
			return 'fadeOut';
		case 30:
			return 'fadeOutDown';
		case 31:
			return 'fadeOutDownBig';
		case 32:
			return 'fadeOutLeft';
		case 33:
			return 'fadeOutLeftBig';
		case 34:
			return 'fadeOutRight';
		case 35:
			return 'fadeOutRightBig';
		case 36:
			return 'fadeOutUp';
		case 37:
			return 'fadeOutUpBig';
		case 38:
			return 'flipInX';
		case 39:
			return 'flipInY';
		case 40:
			return 'flipOutX';
		case 41:
			return 'flipOutY';
		case 42:
			return 'lightSpeedIn';
		case 43:
			return 'lightSpeedOut';
		case 44:
			return 'rotateIn';
		case 45:
			return 'rotateInDownLeft';
		case 46:
			return 'rotateInDownRight';
		case 47:
			return 'rotateInUpLeft';
		case 48:
			return 'rotateInUpRight';
		case 49:
			return 'rotateOut';
		case 50:
			return 'rotateOutDownLeft';
		case 51:
			return 'rotateOutDownRight';
		case 52:
			return 'rotateOutUpLeft';
		case 53:
			return 'rotateOutUpRight';
		case 54:
			return 'hinge';
		case 55:
			return 'jackInTheBox';
		case 56:
			return 'rollIn';
		case 57:
			return 'rollOut';
		case 58:
			return 'zoomIn';
		case 59:
			return 'zoomInDown';
		case 60:
			return 'zoomInLeft';
		case 61:
			return 'zoomInRight';
		case 62:
			return 'zoomInUp';
		case 63:
			return 'zoomOut';
		case 64:
			return 'zoomOutDown';
		case 65:
			return 'zoomOutLeft';
		case 66:
			return 'zoomOutRight';
		case 67:
			return 'zoomOutUp';
		case 68:
			return 'slideInDown';
		case 69:
			return 'slideInLeft';
		case 70:
			return 'slideInRight';
		case 71:
			return 'slideInUp';
		case 72:
			return 'slideOutDown';
		case 73:
			return 'slideOutLeft';
		case 74:
			return 'slideOutRight';
		default:
			return 'slideOutUp';
	}
};
var $author$project$Animate$animateClass = function (animation) {
	return ' animated ' + ($author$project$Animate$animationToString(animation) + ' ');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $author$project$Animate$animate = function (animation) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		$author$project$Animate$animateClass(animation));
};
var $rtfeldman$elm_css$Css$backgroundPosition2 = $rtfeldman$elm_css$Css$prop2('background-position');
var $author$project$Page$Search$Profile$styles = {
	fq: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(280)),
			A2($rtfeldman$elm_css$Css$property, 'word-wrap', 'break-word'),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$vw(100),
						$rtfeldman$elm_css$Css$minus,
						$rtfeldman$elm_css$Css$px(40))),
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(10))
				]))
		]),
	f1: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(540)),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$vw(3)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$vw(1)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(10)),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$px(10)),
						$rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$px(10)),
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$px(20)),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$px(10))
					]))
			])),
	gn: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(540)),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$vw(3)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$vw(1)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(10)),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$px(10)),
						$rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$px(10)),
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$px(20)),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$px(10))
					]))
			])),
	gT: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(10))
				]))
		]),
	g2: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	cA: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(200)),
			A2(
			$rtfeldman$elm_css$Css$backgroundPosition2,
			$rtfeldman$elm_css$Css$pct(50),
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
			$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	ag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	g6: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexGrow(
			$rtfeldman$elm_css$Css$num(2)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(200)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$auto),
					$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$zero)
				]))
		]),
	bv: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(3))
		]),
	dT: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	g7: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(10)),
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(10))
				]))
		]),
	bI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10))
		]),
	mP: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(5))
		]),
	h8: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(10))
				]))
		])
};
var $author$project$Page$Search$Profile$loadingProfileView = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.gn),
			$author$project$Animate$animate(2)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv)
				]),
			_List_Nil)
		]));
var $author$project$Page$Search$Profile$icon = function (url) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$img,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$src(url),
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.bv)
			]),
		_List_Nil);
};
var $author$project$Page$Search$Profile$displayLifestyleExpectationIfSugar = function (profile) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap($author$project$Page$Search$Profile$styles.bI, $author$project$Page$Search$Profile$styles.ag))
			]),
		_List_fromArray(
			[
				$author$project$Page$Search$Profile$icon($author$project$View$Theme$images.lg),
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Core$Data$Profile$LifestyleExpectation$lifestyleExpectationString(profile.bz))
			]));
};
var $author$project$Page$Search$Profile$displayInformation = F2(
	function (currentTime, profile) {
		var _v0 = profile;
		var height = _v0.bu;
		var birthday = _v0.cf;
		var locations = _v0.cE;
		var bodyType = _v0.bi;
		var wantRelationships = _v0.b4;
		var primaryLocation = function () {
			var _v1 = $elm$core$List$head(locations);
			if (_v1.$ === 1) {
				return '';
			} else {
				var location = _v1.a;
				return location;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.g7)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.dT)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Search$Profile$styles.bI, $author$project$Page$Search$Profile$styles.ag))
								]),
							_List_fromArray(
								[
									$author$project$Page$Search$Profile$icon($author$project$View$Theme$images.mO),
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(
										A2($author$project$Core$Data$Profile$birthdayToAge, birthday, currentTime)))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Search$Profile$styles.bI, $author$project$Page$Search$Profile$styles.ag))
								]),
							_List_fromArray(
								[
									$author$project$Page$Search$Profile$icon($author$project$View$Theme$images.bu),
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Core$Data$Profile$Height$heightInImperial(height))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Search$Profile$styles.bI, $author$project$Page$Search$Profile$styles.ag))
								]),
							_List_fromArray(
								[
									$author$project$Page$Search$Profile$icon($author$project$View$Theme$images.jO),
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Core$Data$Profile$BodyType$bodyTypeShortString(bodyType))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.ag)
								]),
							_List_fromArray(
								[
									$author$project$Page$Search$Profile$icon($author$project$View$Theme$images.of),
									$rtfeldman$elm_css$Html$Styled$text(
									A2(
										$elm$core$String$join,
										'/',
										$author$project$Core$Data$Profile$WantRelationship$wantRelationshipsListShortString(wantRelationships)))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$Search$Profile$styles.dT, $author$project$Page$Search$Profile$styles.ag))
						]),
					_List_fromArray(
						[
							$author$project$Page$Search$Profile$displayLifestyleExpectationIfSugar(profile),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.ag)
								]),
							_List_fromArray(
								[
									$author$project$Page$Search$Profile$icon($author$project$View$Theme$images.hy),
									$rtfeldman$elm_css$Html$Styled$text(primaryLocation)
								]))
						]))
				]));
	});
var $author$project$Animate$FadeIn = 20;
var $author$project$Page$Search$Profile$displayPhoto = function (url) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$img,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.mP),
				$rtfeldman$elm_css$Html$Styled$Attributes$src(url),
				$author$project$Animate$animate(20)
			]),
		_List_Nil);
};
var $author$project$Page$Search$Profile$getAvatarUrlFromListUrl = F2(
	function (url, photos) {
		return ($elm$core$String$isEmpty(url) || _Utils_eq(url, $author$project$View$Theme$images.hv)) ? $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq($author$project$View$Theme$images.hv),
				photos)) : $elm$core$Maybe$Just(url);
	});
var $author$project$Page$Search$Profile$displayProfileAvatar = function (_v0) {
	var uid = _v0.eX;
	var avatar = _v0.cc;
	var publicPhotos = _v0.m5;
	var _v1 = A2($author$project$Page$Search$Profile$getAvatarUrlFromListUrl, avatar, publicPhotos);
	if (_v1.$ === 1) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var avatar_ = _v1.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href(
					$author$project$Data$Route$routeUrl.m2(uid))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_css$Css$backgroundImage(
									$rtfeldman$elm_css$Css$url(avatar_)),
								$author$project$Page$Search$Profile$styles.cA))
						]),
					_List_Nil)
				]));
	}
};
var $author$project$Page$Search$Profile$displayUsername = function (_v0) {
	var uid = _v0.eX;
	var username = _v0.dh;
	var sponsorLevel = _v0.bY;
	var membershipColor = $author$project$Data$Membership$getMembershipColor(sponsorLevel);
	var styles_ = {
		fh: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(4),
				$rtfeldman$elm_css$Css$px(7)),
				$rtfeldman$elm_css$Css$marginRight(
				$rtfeldman$elm_css$Css$px(5)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$backgroundColor(membershipColor),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og)
			]),
		f1: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$px(10))
					]))
			]),
		dh: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j4),
				$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
			])
	};
	return (!sponsorLevel) ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(styles_.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(
						$author$project$Data$Route$routeUrl.m2(uid)),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles_.dh)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(username)
					]))
			])) : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(styles_.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles_.fh)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelString(sponsorLevel))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(
						$author$project$Data$Route$routeUrl.m2(uid)),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles_.dh)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(username)
					]))
			]));
};
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $author$project$Page$Search$Profile$truncate = F2(
	function (length, string) {
		return (_Utils_cmp(
			$elm$core$String$length(string),
			length) < 1) ? string : A3(
			$elm$core$String$padRight,
			length,
			'.',
			A2($elm$core$String$left, length - 3, string));
	});
var $author$project$Page$Search$Profile$view = F2(
	function (currentTime, profile) {
		var _v0 = profile;
		var uid = _v0.eX;
		var headline = _v0.cy;
		var publicPhotos = _v0.m5;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.f1),
					$author$project$Animate$animate(2),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(uid)
				]),
			_List_fromArray(
				[
					$author$project$Page$Search$Profile$displayProfileAvatar(profile),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.g6)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.gT)
								]),
							_List_fromArray(
								[
									$author$project$Page$Search$Profile$displayUsername(profile),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.fq)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Page$Search$Profile$truncate, 140, headline))
										]))
								])),
							A2($author$project$Page$Search$Profile$displayInformation, currentTime, profile),
							A2(
							$rtfeldman$elm_css$Html$Styled$hr,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.g2)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Profile$styles.h8)
								]),
							A2(
								$elm$core$List$map,
								$author$project$Page$Search$Profile$displayPhoto,
								A2(
									$elm$core$List$take,
									5,
									A2(
										$elm$core$List$filter,
										$elm$core$Basics$neq($author$project$View$Theme$images.hv),
										publicPhotos))))
						]))
				]));
	});
var $author$project$Page$RelatedProfiles$displayProfiles = F5(
	function (containerStyle, connectKind, menuView, currentTime, _v0) {
		var profileStatuses = _v0.an;
		var searchLimit = _v0.A;
		if (profileStatuses.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
					]),
				_List_fromArray(
					[
						menuView,
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RelatedProfiles$styles.c0)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv)
									]),
								_List_Nil)
							]))
					]));
		} else {
			var profileStatuses_ = profileStatuses.a;
			var profiles = A2(
				$elm$core$List$map,
				function (profileStatus) {
					switch (profileStatus.$) {
						case 0:
							return $author$project$Page$Search$Profile$loadingProfileView;
						case 1:
							var profile = profileStatus.a;
							return A2($author$project$Page$Search$Profile$view, currentTime, profile);
						default:
							return $rtfeldman$elm_css$Html$Styled$text('');
					}
				},
				profileStatuses_);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
					]),
				_List_fromArray(
					[
						menuView,
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RelatedProfiles$styles.c0)
							]),
						profiles),
						A3(
						$author$project$Page$RelatedProfiles$buttonLoadMore,
						connectKind,
						searchLimit,
						$elm$core$List$length(profileStatuses_))
					]));
		}
	});
var $rtfeldman$elm_css$Css$Structure$PseudoElement = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$pseudoElement = function (element) {
	return $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(element);
};
var $rtfeldman$elm_css$Css$before = $rtfeldman$elm_css$Css$pseudoElement('before');
var $author$project$Page$Search$Menu$styles = {
	e4: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
		]),
	bk: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block)
				])),
			$author$project$View$Theme$forDesktopScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$before(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'content', '\"\\00a0\"')
						]))
				]))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.lx),
			$author$project$View$Theme$forDesktopScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$left),
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(115))
				]))
		]),
	ge: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	gf: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(40))
			])),
	hE: function (_v0) {
		var screenWidth = _v0.nj;
		return _Utils_ap(
			$author$project$View$Theme$defaultStyles.kd,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(20),
					$rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px((screenWidth / 4) - 1)),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
					$author$project$View$Theme$forDesktopScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$px(20)),
							$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$auto),
							$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB)
						]))
				]));
	}
};
var $author$project$Page$Search$Menu$view = function (appModel) {
	var menuStyle = $author$project$Page$Search$Menu$styles.hE(appModel.kR);
	var activeMenuStyles = function (route) {
		return _Utils_eq(route, appModel.ng) ? $author$project$Page$Search$Menu$styles.e4 : _List_Nil;
	};
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Menu$styles.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.nm),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							menuStyle,
							activeMenuStyles($author$project$Data$Route$SearchRoute)))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('SEARCH'),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Menu$styles.bk)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('PROFILES')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.lh),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							menuStyle,
							activeMenuStyles(
								$author$project$Data$Route$RelatedProfileRoute(2))))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('FAVORITE'),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Menu$styles.bk)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('PROFILES')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.li),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							menuStyle,
							activeMenuStyles(
								$author$project$Data$Route$RelatedProfileRoute(1))))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('FAVORITED'),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Menu$styles.bk)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ME')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.oe),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							menuStyle,
							activeMenuStyles(
								$author$project$Data$Route$RelatedProfileRoute(0))))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('VIEWED'),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Menu$styles.bk)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ME')
							]))
					]))
			]));
};
var $author$project$Page$RelatedProfiles$view = F2(
	function (appModel, authState) {
		var menuView = $author$project$Page$Search$Menu$view(appModel);
		var _v0 = authState.iD;
		var viewedMe = _v0.oe;
		var favoritedMe = _v0.li;
		var favoriteProfile = _v0.lh;
		var _v1 = appModel;
		var currentTime = _v1.kG;
		var dimension = _v1.kR;
		var containerStyle = A2(
			$author$project$Page$RelatedProfiles$styles.f1,
			dimension,
			$author$project$View$Helpers$UserInfo$isMissingAvatar(authState));
		var _v2 = authState.kE;
		if ((!_v2.$) && (_v2.a.$ === 1)) {
			var connectKind = _v2.a.a;
			switch (connectKind) {
				case 0:
					return A5($author$project$Page$RelatedProfiles$displayProfiles, containerStyle, connectKind, menuView, currentTime, viewedMe);
				case 1:
					return A5($author$project$Page$RelatedProfiles$displayProfiles, containerStyle, connectKind, menuView, currentTime, favoritedMe);
				default:
					return A5($author$project$Page$RelatedProfiles$displayProfiles, containerStyle, connectKind, menuView, currentTime, favoriteProfile);
			}
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RelatedProfiles$styles.c0)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv)
									]),
								_List_Nil)
							]))
					]));
		}
	});
var $author$project$Type$Search$LoadMore = {$: 3};
var $author$project$Page$Search$styles = {
	fz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$zero)
		]),
	f1: F2(
		function (_v0, hasAlert) {
			var screenHeight = _v0.ni;
			return _Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.lx)
					]),
				A2($author$project$View$Theme$defaultStyles.kz, screenHeight, hasAlert));
		}),
	cw: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	hR: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20))
		]),
	c0: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		])
};
var $author$project$Page$Search$buttonLoadMore = F2(
	function (_v0, totalProfile) {
		var searchLimit = _v0.A;
		return (_Utils_cmp(totalProfile, searchLimit) < 0) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$styles.fz)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kj),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnSearch($author$project$Type$Search$LoadMore)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Load More')
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$h4 = $rtfeldman$elm_css$Html$Styled$node('h4');
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				return styles;
			} else {
				return A3(
					$elm$core$Dict$insert,
					cssTemplate,
					$rtfeldman$elm_css$Hash$fromString(cssTemplate),
					styles);
			}
		} else {
			return styles;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(classname));
			} else {
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string('_unstyled'));
			}
		} else {
			return val;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
			} else {
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', '_unstyled');
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
	function (candidate, properties) {
		stylesFromPropertiesHelp:
		while (true) {
			if (!properties.b) {
				return candidate;
			} else {
				if (!properties.a.b) {
					var _v1 = properties.a;
					var classname = _v1.c;
					var rest = properties.b;
					var $temp$candidate = candidate,
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				} else {
					var _v2 = properties.a;
					var cssTemplate = _v2.c;
					var rest = properties.b;
					var $temp$candidate = $elm$core$Maybe$Just(cssTemplate),
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
	var _v0 = A2($rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, $elm$core$Maybe$Nothing, properties);
	if (_v0.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var cssTemplate = _v0.a;
		return A2(
			$elm$core$Dict$singleton,
			cssTemplate,
			$rtfeldman$elm_css$Hash$fromString(cssTemplate));
	}
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3(
	function (template, classname, declaration) {
		return declaration + ('\n' + A3($elm$core$String$replace, $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return A3($elm$core$Dict$foldl, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, '', dict);
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
	return A3(
		$elm$virtual_dom$VirtualDom$node,
		'span',
		_List_fromArray(
			[
				A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
				A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
			]),
		_List_fromArray(
			[
				A3(
				$elm$virtual_dom$VirtualDom$node,
				'style',
				_List_Nil,
				$elm$core$List$singleton(
					$elm$virtual_dom$VirtualDom$text(
						$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))))
			]));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
	function (elemType, properties, children) {
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
	function (allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
	function (elemType, properties, keyedChildren) {
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
	function (ns, elemType, properties, keyedChildren) {
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
	function (ns, elemType, properties, children) {
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2 = F3(
	function (fn, arg1, arg2) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A2(fn, arg1, arg2));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy2 = F3(
	function (fn, arg1, arg2) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A4($elm$virtual_dom$VirtualDom$lazy3, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2, fn, arg1, arg2));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy2 = $rtfeldman$elm_css$VirtualDom$Styled$lazy2;
var $rtfeldman$elm_css$VirtualDom$Styled$keyedNode = $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode;
var $rtfeldman$elm_css$Html$Styled$Keyed$node = $rtfeldman$elm_css$VirtualDom$Styled$keyedNode;
var $author$project$View$ProfileOption$genderSearchOptions = A2(
	$elm$core$List$cons,
	_Utils_Tuple2('', 'All'),
	A2(
		$elm$core$List$map,
		$author$project$View$ProfileOption$genderOption,
		_List_fromArray(
			[0, 1])));
var $author$project$Page$Search$Filter$sortOptions = _List_fromArray(
	[
		_Utils_Tuple2('Active', 'Active'),
		_Utils_Tuple2('Newest', 'Newest')
	]);
var $rtfeldman$elm_css$Css$contentBox = {dn: 0, ch: 0, v: 'content-box'};
var $rtfeldman$elm_css$Css$ellipsis = {jo: 0, v: 'ellipsis'};
var $rtfeldman$elm_css$Css$stretch = $rtfeldman$elm_css$Css$prop1('stretch');
var $rtfeldman$elm_css$Css$textOverflow = $rtfeldman$elm_css$Css$prop1('text-overflow');
var $author$project$Page$Search$Filter$styles = function () {
	var autoCompleteStyles = $author$project$Helpers$AutoComplete$View$defaultStyles;
	return {
		bj: _List_fromArray(
			[
				$author$project$View$Theme$forDesktopScreen(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$borderLeft3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$View$Theme$colors.gN)
					]))
			]),
		fY: {
			f1: _Utils_ap(
				$author$project$View$Theme$defaultStyles.kd,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
					])),
			gs: _List_Nil,
			lP: _Utils_update(
				autoCompleteStyles,
				{
					lP: _List_fromArray(
						[
							$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j4),
							$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs),
							$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
							$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
							$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
						]),
					mR: 'All',
					V: _Utils_ap(
						$author$project$View$Theme$defaultStyles.kd,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$padding2,
								$rtfeldman$elm_css$Css$px(10),
								$rtfeldman$elm_css$Css$px(20)),
								$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j4),
								$rtfeldman$elm_css$Css$hover(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh),
										$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gN),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									]))
							])),
					nd: _List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
							$rtfeldman$elm_css$Css$left(
							$rtfeldman$elm_css$Css$px(-18)),
							$rtfeldman$elm_css$Css$zIndex(
							$rtfeldman$elm_css$Css$int(10)),
							$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$minWidth(
							$rtfeldman$elm_css$Css$px(400)),
							$rtfeldman$elm_css$Css$maxHeight(
							$rtfeldman$elm_css$Css$vh(40)),
							$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
							$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
							$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll),
							$author$project$View$Theme$forMobileScreen(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$left(
									$rtfeldman$elm_css$Css$px(-32)),
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$vw(100))
								]))
						])
				}),
			dX: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(5))
				])
		},
		f1: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(20)),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$stretch),
						$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$px(10))
					]))
			]),
		aO: _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(180)),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$px(10)),
						$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$auto),
						$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$contentBox),
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$px(5),
						$rtfeldman$elm_css$Css$px(20)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$px(5))
					]))
			]),
		hO: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(230))
			]),
		nv: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs)
			])
	};
}();
var $author$project$Page$Search$Inputs$Dropdown$view = F2(
	function (form, _v0) {
		var fieldName = _v0.ct;
		var label = _v0.dX;
		var options = _v0.eg;
		var styles = {
			f1: $author$project$View$Theme$defaultStyles.kd,
			g3: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(1)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$pct(100))
				]),
			lP: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
					$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(2)),
					$rtfeldman$elm_css$Css$width(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$pct(100),
						$rtfeldman$elm_css$Css$plus,
						$rtfeldman$elm_css$Css$px(20))),
					$rtfeldman$elm_css$Css$border(
					$rtfeldman$elm_css$Css$px(0)),
					$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j4),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(25)),
					$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
					A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
					A2($rtfeldman$elm_css$Css$property, '-moz-appearance', 'none')
				]),
			hd: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
					$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
				]),
			dX: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(5))
				])
		};
		var selectedValue = A2($author$project$Form$getRawString, form, fieldName);
		var createOptions = $author$project$View$Form$dropdownOption(selectedValue);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(fieldName),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.dX)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.hd)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									$author$project$Form$AsString(fieldName)),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.lP),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', fieldName)
								]),
							A2($elm$core$List$map, createOptions, options)),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.no),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.g3)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Form$AsBool = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$getRawBool = F2(
	function (form, name) {
		var _v0 = A2($elm$core$Dict$get, name, form.j);
		if ((!_v0.$) && (_v0.a.$ === 1)) {
			var field = _v0.a.a;
			return field.v;
		} else {
			return A2(
				$elm$core$Basics$always,
				false,
				A3($author$project$Form$missingFieldWarning, name, 'getRawBool', ''));
		}
	});
var $rtfeldman$elm_css$Css$scaleY = function (y) {
	return {
		l: 0,
		v: A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'scaleY',
			_List_fromArray(
				[
					$elm$core$String$fromFloat(y)
				]))
	};
};
var $author$project$Page$Search$Inputs$MultiSelect$styles = {
	f$: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$transform(
			$rtfeldman$elm_css$Css$scaleY(0)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0))
		]),
	f1: $author$project$View$Theme$defaultStyles.kd,
	g3: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	lP: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j4),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	hd: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	dX: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(5))
		]),
	h$: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$transform(
			$rtfeldman$elm_css$Css$scaleY(1)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(1))
		]),
	ef: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j4),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A2($rtfeldman$elm_css$Css$property, 'transition', 'color 0.3s ease')
		]),
	eg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A2($rtfeldman$elm_css$Css$property, 'transition', 'transform 0.3s cubic-bezier(0.17, 0.04, 0.03, 0.94), opacity 0.3s ease'),
			A2($rtfeldman$elm_css$Css$property, 'transform-origin', '0 0'),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$left(
					$rtfeldman$elm_css$Css$px(-30)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$vw(100)),
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(10))
				]))
		]),
	iS: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
		]),
	iT: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10))
		])
};
var $author$project$Page$Search$Inputs$MultiSelect$renderOption = F3(
	function (fieldName, selectedValues, _v0) {
		var value = _v0.a;
		var label = _v0.b;
		var isSelected = A2($elm$core$List$member, value, selectedValues);
		return isSelected ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$Page$Search$Inputs$MultiSelect$styles.ef, $author$project$Page$Search$Inputs$MultiSelect$styles.iS)),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A2($author$project$Form$AsListString, fieldName, value))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.kW),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Inputs$MultiSelect$styles.iT)
						]),
					_List_Nil),
					$rtfeldman$elm_css$Html$Styled$text(label)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Inputs$MultiSelect$styles.ef),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A2($author$project$Form$AsListString, fieldName, value))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				]));
	});
var $author$project$Page$Search$Inputs$MultiSelect$renderDropdown = F4(
	function (visible, fieldName, selectedValues, options) {
		var style = visible ? $author$project$Page$Search$Inputs$MultiSelect$styles.h$ : $author$project$Page$Search$Inputs$MultiSelect$styles.f$;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$Page$Search$Inputs$MultiSelect$styles.eg, style)),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', fieldName + 'Options')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Page$Search$Inputs$MultiSelect$renderOption, fieldName, selectedValues),
				options));
	});
var $author$project$Page$Search$Inputs$MultiSelect$selectedValuesText = function (selectedValues) {
	var selectedRelationships = $author$project$Core$Data$Profile$WantRelationship$toWantRelationships(selectedValues);
	if (selectedRelationships.$ === 1) {
		return 'All';
	} else {
		var relationships = selectedRelationships.a;
		return $elm$core$List$isEmpty(relationships) ? 'All' : A2(
			$elm$core$String$join,
			' / ',
			$author$project$Core$Data$Profile$WantRelationship$wantRelationshipsListShortString(relationships));
	}
};
var $author$project$Page$Search$Inputs$MultiSelect$view = F2(
	function (form, _v0) {
		var fieldName = _v0.ct;
		var label = _v0.dX;
		var options = _v0.eg;
		var sortedOptions = A2($elm$core$List$sortBy, $elm$core$Tuple$second, options);
		var selectedValues = $elm$core$List$sort(
			A2($author$project$Form$getRawListString, form, fieldName));
		var dropdownFieldName = 'relationshipDropdownState';
		var dropdownState = A2($author$project$Form$getRawBool, form, dropdownFieldName);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Inputs$MultiSelect$styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(fieldName),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Inputs$MultiSelect$styles.dX)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Inputs$MultiSelect$styles.hd)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Inputs$MultiSelect$styles.lP),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Form$AsBool(dropdownFieldName)),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', fieldName)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Page$Search$Inputs$MultiSelect$selectedValuesText(selectedValues))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.no),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Form$AsBool(dropdownFieldName)),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Inputs$MultiSelect$styles.g3)
								]),
							_List_Nil),
							A3(
							$author$project$View$Display$clickBlanket,
							9,
							$author$project$Form$AsBool(dropdownFieldName),
							dropdownState),
							A4($author$project$Page$Search$Inputs$MultiSelect$renderDropdown, dropdownState, fieldName, selectedValues, sortedOptions)
						]))
				]));
	});
var $author$project$View$ProfileOption$wantGenderPluralOption = function (wantGender) {
	var value = $author$project$Core$Data$Profile$WantGender$wantGenderString(wantGender);
	switch (wantGender) {
		case 0:
			return _Utils_Tuple2(value, 'Man');
		case 1:
			return _Utils_Tuple2(value, 'Lady');
		default:
			return _Utils_Tuple2(value, 'Both');
	}
};
var $author$project$View$ProfileOption$wantGenderPluralOptions = A2(
	$elm$core$List$map,
	$author$project$View$ProfileOption$wantGenderPluralOption,
	_List_fromArray(
		[2, 0, 1]));
var $author$project$View$ProfileOption$wantRelationshipOption = function (wantRelationship) {
	var value = $author$project$Core$Data$Profile$WantRelationship$wantRelationshipString(wantRelationship);
	switch (wantRelationship) {
		case 0:
			return _Utils_Tuple2(value, 'Open Relationship');
		case 1:
			return _Utils_Tuple2(value, 'Casual Dating');
		case 2:
			return _Utils_Tuple2(value, 'Make Friends');
		case 3:
			return _Utils_Tuple2(value, 'Networking');
		case 4:
			return _Utils_Tuple2(value, 'Serious Relationship');
		default:
			return _Utils_Tuple2(value, 'Travel Companion');
	}
};
var $author$project$View$ProfileOption$wantRelationshipOptions = A2(
	$elm$core$List$map,
	$author$project$View$ProfileOption$wantRelationshipOption,
	_List_fromArray(
		[1, 2, 3, 0, 4, 5]));
var $author$project$Page$Search$Filter$view = function (model) {
	var _v0 = model;
	var location = _v0.hy;
	var form = _v0.ln;
	var primaryLocationFieldInfo = {ln: form, mk: location};
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$Filter$styles.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap($author$project$Page$Search$Filter$styles.aO, $author$project$Page$Search$Filter$styles.hO))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$Type$Search$FormMsg,
						A2(
							$author$project$Page$Search$Inputs$MultiSelect$view,
							form,
							{ct: 'relationship', dX: 'TYPE OF RELATIONSHIP', eg: $author$project$View$ProfileOption$wantRelationshipOptions}))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap($author$project$Page$Search$Filter$styles.aO, $author$project$Page$Search$Filter$styles.bj))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$Type$Search$InputCityMsg,
						A3(
							$author$project$Helpers$City$View$cityFieldWithStyles,
							$author$project$Page$Search$Filter$styles.fY,
							primaryLocationFieldInfo,
							{ct: 'primaryLocation', dX: 'LOCATION'}))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap($author$project$Page$Search$Filter$styles.aO, $author$project$Page$Search$Filter$styles.bj))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$Type$Search$FormMsg,
						A2(
							$author$project$Page$Search$Inputs$Dropdown$view,
							form,
							{ct: 'gender', dX: 'GENDER', eg: $author$project$View$ProfileOption$genderSearchOptions}))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap($author$project$Page$Search$Filter$styles.aO, $author$project$Page$Search$Filter$styles.bj))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$Type$Search$FormMsg,
						A2(
							$author$project$Page$Search$Inputs$Dropdown$view,
							form,
							{ct: 'finding', dX: 'FINDING', eg: $author$project$View$ProfileOption$wantGenderPluralOptions}))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap($author$project$Page$Search$Filter$styles.aO, $author$project$Page$Search$Filter$styles.bj))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$Type$Search$FormMsg,
						A2(
							$author$project$Page$Search$Inputs$Dropdown$view,
							form,
							{ct: 'sort', dX: 'SORT', eg: $author$project$Page$Search$Filter$sortOptions}))
					]))
			]));
};
var $author$project$Page$Search$view = F2(
	function (appModel, authState) {
		var toAppHtml = A2(
			$elm$core$Basics$composeR,
			$rtfeldman$elm_css$Html$Styled$map($author$project$Types$OnSearch),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Types$OnAuth));
		var model = authState.nm;
		var containerStyle = A2(
			$author$project$Page$Search$styles.f1,
			appModel.kR,
			$author$project$View$Helpers$UserInfo$isMissingAvatar(authState));
		var _v0 = model.iw;
		if (_v0.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
					]),
				_List_fromArray(
					[
						$author$project$Page$Search$Menu$view(appModel),
						toAppHtml(
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$styles.cw)
								]),
							_List_fromArray(
								[
									$author$project$Page$Search$Filter$view(model)
								]))),
						toAppHtml(
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$styles.c0)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv)
										]),
									_List_Nil)
								])))
					]));
		} else {
			if (!_v0.a.b) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
						]),
					_List_fromArray(
						[
							$author$project$Page$Search$Menu$view(appModel),
							toAppHtml(
							A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$styles.cw)
									]),
								_List_fromArray(
									[
										$author$project$Page$Search$Filter$view(model)
									]))),
							toAppHtml(
							A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$styles.c0)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h4,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$styles.hR)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('There is no profiles')
											]))
									])))
						]));
			} else {
				var profiles = _v0.a;
				var displayProfile = function (profile) {
					return _Utils_Tuple2(
						profile.eX,
						A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Page$Search$Profile$view, appModel.kG, profile));
				};
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
						]),
					_List_fromArray(
						[
							$author$project$Page$Search$Menu$view(appModel),
							toAppHtml(
							A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$styles.cw)
									]),
								_List_fromArray(
									[
										$author$project$Page$Search$Filter$view(model)
									]))),
							A3(
							$rtfeldman$elm_css$Html$Styled$Keyed$node,
							'div',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Search$styles.c0),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'searchContainer')
								]),
							A2($elm$core$List$map, displayProfile, profiles)),
							A2(
							$author$project$Page$Search$buttonLoadMore,
							model,
							$elm$core$List$length(profiles))
						]));
			}
		}
	});
var $author$project$View$profilesView = F2(
	function (model, authState) {
		var profilesViewForDetail = function () {
			var _v0 = authState.kE;
			if ((!_v0.$) && (_v0.a.$ === 1)) {
				return A2($author$project$Page$RelatedProfiles$view, model, authState);
			} else {
				return A2($author$project$Page$Search$view, model, authState);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Page$Detail$view, model, authState),
					profilesViewForDetail
				]));
	});
var $author$project$Animate$FadeInLeft = 23;
var $author$project$Animate$FadeInRight = 25;
var $rtfeldman$elm_css$Css$margin = $rtfeldman$elm_css$Css$prop1('margin');
var $rtfeldman$elm_css$Css$default = {d: 0, v: 'default'};
var $rtfeldman$elm_css$Html$Styled$Attributes$target = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('target');
var $author$project$View$Display$unobviousLink = F3(
	function (text_, url, customStyle) {
		var styles = _Utils_ap(
			$author$project$View$Theme$defaultStyles.kd,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default)
					]),
				customStyle));
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles),
					$rtfeldman$elm_css$Html$Styled$Attributes$href(url),
					$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(text_)
				]));
	});
var $author$project$Page$Home$headingAndSub = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(40)),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
				]))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(45)),
							$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$px(60)),
							$author$project$View$Theme$forDinosaurMobileScreen(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$px(25)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$px(35))
								]))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Matching Aspirations & Expectations')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(14))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('(World’s 1st Facial Recognition Verification '),
					A3(
					$author$project$View$Display$unobviousLink,
					'Dating Site',
					'https://www.happymatches.com/blog/online-dating/online-dating-websites',
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(14)),
							$rtfeldman$elm_css$Css$fontFamilies(
							_List_fromArray(
								['none']))
						])),
					$rtfeldman$elm_css$Html$Styled$text(')')
				]))
		]));
var $elm$virtual_dom$VirtualDom$lazy5 = _VirtualDom_lazy5;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp4 = F5(
	function (fn, arg1, arg2, arg3, arg4) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A4(fn, arg1, arg2, arg3, arg4));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy4 = F5(
	function (fn, arg1, arg2, arg3, arg4) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A6($elm$virtual_dom$VirtualDom$lazy5, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp4, fn, arg1, arg2, arg3, arg4));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy4 = $rtfeldman$elm_css$VirtualDom$Styled$lazy4;
var $author$project$View$Hero$paragraph = function (children) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$px(16)),
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					]))
			]),
		children);
};
var $author$project$Page$Home$styles = {
	fz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	fH: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	gX: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		])
};
var $rtfeldman$elm_css$Html$Styled$h3 = $rtfeldman$elm_css$Html$Styled$node('h3');
var $author$project$Page$Home$HowItWorks$styles = {
	fz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(40)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero)
				]))
		]),
	fD: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(30)),
					$rtfeldman$elm_css$Css$paddingRight(
					$rtfeldman$elm_css$Css$px(30)),
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$pct(70)),
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$normal)
				]))
		]),
	fK: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(390)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	fL: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(80))
				]))
		]),
	fM: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(30)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	fN: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j4),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero)
		]),
	fO: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	gT: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j6),
				$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
			])),
	bZ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingLeft(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$paddingRight(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			]))
};
var $author$project$Page$Home$HowItWorks$card = F3(
	function (imageUrl, title, content) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$HowItWorks$styles.fK)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$HowItWorks$styles.fL),
							$rtfeldman$elm_css$Html$Styled$Attributes$src(imageUrl)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$HowItWorks$styles.fN)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(title)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$HowItWorks$styles.fM)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(content)
						]))
				]));
	});
var $author$project$Page$Home$HowItWorks$view = function (registerUrl) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$HowItWorks$styles.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$HowItWorks$styles.gT)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('How it works')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$HowItWorks$styles.bZ)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Finding your Perfect Match and Ideal Type of Relationship (based on your Aspirations and Expectations) is Easy and Hassle-Free.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$HowItWorks$styles.bZ)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Simply state upfront what you want in a Suitor/Date'),
						$rtfeldman$elm_css$Html$Styled$text(', and whether you want '),
						A3($author$project$View$Display$unobviousLink, 'Casual Dating', 'https://www.happymatches.com/casual-dating', _List_Nil),
						$rtfeldman$elm_css$Html$Styled$text(', '),
						A3($author$project$View$Display$unobviousLink, 'Serious Relationship', 'https://www.happymatches.com/serious-relationship', _List_Nil),
						$rtfeldman$elm_css$Html$Styled$text(', '),
						A3($author$project$View$Display$unobviousLink, 'Open Relationship', 'https://www.happymatches.com/open-relationship', _List_Nil),
						$rtfeldman$elm_css$Html$Styled$text(', Make Friends, Network or Travel Companion.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$HowItWorks$styles.fO)
					]),
				_List_fromArray(
					[
						A3($author$project$Page$Home$HowItWorks$card, $author$project$View$Theme$images.lG.kS, 'Discover', 'Browse through quality Suitors/Dates in your location. Shortlist the profiles you like.'),
						A3($author$project$Page$Home$HowItWorks$card, $author$project$View$Theme$images.lG.kx, 'Connect', 'Chat with them through the portal’s real-time chat. Get to know each other better.'),
						A3($author$project$Page$Home$HowItWorks$card, $author$project$View$Theme$images.lG.l8, 'Meetup', 'Arrange your first and subsequent meet ups through the portal. Enjoy your dates.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$HowItWorks$styles.fz)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kj),
								$rtfeldman$elm_css$Html$Styled$Attributes$href(registerUrl),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$HowItWorks$styles.fD)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Find Your Ideal Relationship Partner Now')
									]))
							]))
					]))
			]));
};
var $author$project$Page$Home$Media$styles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero)
		]),
	dq: _List_fromArray(
		[
			$author$project$View$Theme$forDesktopScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(34))
				]))
		]),
	cA: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(30))
		]),
	hB: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	bZ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic)
			]))
};
var $author$project$Page$Home$Media$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Media$styles.f1)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Media$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('What the media thinks about HappyMatches ...')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Media$styles.hB)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.datingnews.com/apps-and-sites/happy-matches-dating-site-reboots-online-dating/'),
							$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hD.kI),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Media$styles.cA)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.datingadvice.com/online-dating/happymatches-a-simple-and-effective-dating-site'),
							$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hD.dq),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Home$Media$styles.cA, $author$project$Page$Home$Media$styles.dq))
								]),
							_List_Nil)
						]))
				]))
		]));
var $rtfeldman$elm_css$Css$columnReverse = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{v: 'column-reverse'});
var $author$project$Page$Home$Special$styles = {
	ci: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(30)),
					$rtfeldman$elm_css$Css$paddingRight(
					$rtfeldman$elm_css$Css$px(30)),
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$pct(70)),
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$normal)
				]))
		]),
	fz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(40)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero)
				]))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(20)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$columnReverse)
				]))
		]),
	f2: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	gT: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$maxWidth(
				$rtfeldman$elm_css$Css$px(700)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j6)
			])),
	cA: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$auto)
		]),
	bJ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$maxWidth(
				$rtfeldman$elm_css$Css$px(700)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$px(15))
					]))
			]))
};
var $author$project$Page$Home$Special$view = function (registerUrl) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.lG.nw),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.cA)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.f2)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.gT)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('What makes')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('HappyMatches so special?')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.bJ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Whilst Conventional Dating remains, Modern Dating is multi-faceted and continuously evolving.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.bJ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Many People seek a '),
								A3($author$project$View$Display$unobviousLink, 'Committed Relationship', 'https://www.happymatches.com/committed-relationship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Romantic Relationship', 'https://www.happymatches.com/romantic-relationship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Monogamous Relationship', 'https://www.happymatches.com/monogamous-relationship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Exclusive Relationship', 'https://www.happymatches.com/exclusive-relationship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Long Term Relationship', 'https://www.happymatches.com/long-term-relationship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(' or '),
								A3($author$project$View$Display$unobviousLink, 'Senior Dating', 'https://www.happymatches.com/senior-dating', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.bJ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Others want a '),
								A3($author$project$View$Display$unobviousLink, 'Friends With Benefits', 'https://www.happymatches.com/friends-with-benefits', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'NSA Relationship', 'https://www.happymatches.com/nsa-relationship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Non Monogamous Relationship', 'https://www.happymatches.com/non-monogamous-relationship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Platonic Friendship', 'https://www.happymatches.com/platonic-friendship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(' or '),
								A3($author$project$View$Display$unobviousLink, 'Platonic Relationship', 'https://www.happymatches.com/platonic-relationship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('. '),
								A3($author$project$View$Display$unobviousLink, 'Casual Encounters', 'https://www.happymatches.com/casual-encounters', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Casual Relationship', 'https://www.happymatches.com/casual-relationship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Fling', 'https://www.happymatches.com/fling', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Hook Up', 'https://www.happymatches.com/hook-up', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'One Night Stand', 'https://www.happymatches.com/one-night-stand', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(' and '),
								A3($author$project$View$Display$unobviousLink, 'Short Term Relationship', 'https://www.happymatches.com/short-term-relationship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(' are increasingly popular too.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.bJ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Happy Matches offers '),
								A3($author$project$View$Display$unobviousLink, 'Heterosexual Dating', 'https://www.happymatches.com/heterosexual-dating', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Gay Dating', 'https://www.happymatches.com/gay-dating', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Lesbian Dating', 'https://www.happymatches.com/lesbian-dating', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Bisexual Dating', 'https://www.happymatches.com/bisexual-dating', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(' and '),
								A3($author$project$View$Display$unobviousLink, 'Bi Curious Dating', 'https://www.happymatches.com/bi-curious-dating', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('. Or find a '),
								A3($author$project$View$Display$unobviousLink, 'Sapiosexual', 'https://www.happymatches.com/sapiosexual', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(' or '),
								A3($author$project$View$Display$unobviousLink, 'Demisexual', 'https://www.happymatches.com/demisexual', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(' here.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.bJ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Whatever the Type of Relationship You are seeking, You can definitely Count on Us to find Quality Dating Partners. After all, we understand the Key Issues and Frustrations that everyone faces with '),
								A3($author$project$View$Display$unobviousLink, 'Online Dating Sites', 'https://www.happymatches.com/online-dating/dating-sites', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(' and '),
								A3($author$project$View$Display$unobviousLink, 'Online Dating Apps', 'https://www.happymatches.com/online-dating/dating-apps', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.bJ)
							]),
						_List_fromArray(
							[
								A3($author$project$View$Display$unobviousLink, 'Friend Zone', 'https://www.happymatches.com/online-dating/friend-zone', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('? '),
								A3($author$project$View$Display$unobviousLink, 'First Date Ideas', 'https://www.happymatches.com/online-dating/first-date-ideas', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('? '),
								A3($author$project$View$Display$unobviousLink, 'How to Get a Girlfriend', 'https://www.happymatches.com/online-dating/how-to-get-a-girlfriend', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('? '),
								A3($author$project$View$Display$unobviousLink, 'How to Get a Boyfriend', 'https://www.happymatches.com/online-dating/how-to-get-a-boyfriend', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('? '),
								A3($author$project$View$Display$unobviousLink, 'Toxic Relationship', 'https://www.happymatches.com/toxic-relationship', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('? Check Out our Valuable Insights on '),
								A3($author$project$View$Display$unobviousLink, 'Dating Advice', 'https://www.happymatches.com/online-dating/dating-advice', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Dating Tips', 'https://www.happymatches.com/online-dating/dating-tips', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'Date Ideas', 'https://www.happymatches.com/online-dating/date-ideas', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text(' and '),
								A3($author$project$View$Display$unobviousLink, 'Dating Rules', 'https://www.happymatches.com/online-dating/dating-rules', _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.bJ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('We Care about You, We Respect that You are Unique, We Want You to Succeed!')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.bJ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('We are always Continuously Improving and have implemented Cutting-Edge Innovative Solutions to address Your Dating Issues. Embark with us together on this Exciting Journey to help Amazing People like You find your Happy Matches.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.fz)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kj),
										$rtfeldman$elm_css$Html$Styled$Attributes$href(registerUrl),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Special$styles.ci)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Partner with Us to Your Dating Success Today!')
											]))
									]))
							]))
					]))
			]));
};
var $rtfeldman$elm_css$Css$Structure$Descendant = 3;
var $rtfeldman$elm_css$Css$Preprocess$NestSnippet = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Global$descendants = $rtfeldman$elm_css$Css$Preprocess$NestSnippet(3);
var $rtfeldman$elm_css$Css$Structure$TypeSelector = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Global$typeSelector = F2(
	function (selectorStr, styles) {
		var sequence = A2($rtfeldman$elm_css$Css$Structure$TypeSelectorSequence, selectorStr, _List_Nil);
		var sel = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, sel, _List_Nil, styles))
			]);
	});
var $author$project$Page$Home$Sponsors$styles = {
	Z: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
					$rtfeldman$elm_css$Css$Global$descendants(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Css$Global$typeSelector,
							'a',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
									$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
								]))
						]))
				]))
		]),
	fo: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$margin2,
					$rtfeldman$elm_css$Css$zero,
					$rtfeldman$elm_css$Css$px(15))
				]))
		]),
	fz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(40)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero)
				]))
		]),
	fD: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(30)),
					$rtfeldman$elm_css$Css$paddingRight(
					$rtfeldman$elm_css$Css$px(30)),
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$pct(70)),
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$normal)
				]))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$author$project$View$Theme$forDesktopScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundImage(
					$rtfeldman$elm_css$Css$url($author$project$View$Theme$images.ll)),
					$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
					$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$right)
				]))
		]),
	f2: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$zero,
					$rtfeldman$elm_css$Css$px(10))
				]))
		]),
	gT: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j6),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					]))
			])),
	cA: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$auto),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	$9: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
		]),
	bZ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$zero,
					$rtfeldman$elm_css$Css$px(15)),
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
				]))
		])
};
var $author$project$Page$Home$Sponsors$view = function (registerUrl) {
	var linkStyles = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
				]))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.lG.nz),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.cA)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.f2)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.gT)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.$9)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('BENEFITS FOR')
									])),
								$rtfeldman$elm_css$Html$Styled$text('Suitors')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.bZ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Focus on being Authentic and on Impressing your Dates – Leave the rest to us.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.fo)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Verify Your Profile, Differentiate Yourself and Be Noticed')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Meet Attractive Ladies and Men at a Low Affordable Cost')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Dating Partners and Type of Relationships of Your Choice')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Verified Profiles for Safe Environment with Seamless Chat Interaction')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_Utils_ap(
											$author$project$Page$Home$Sponsors$styles.Z,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
												])))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Avoid Wasting Time on Unsuitable Dates, Scammers and Fake Profiles')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Hassle-free, Peak Performance and Highly Effective Dating Experience')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Intuitive State-of-the-Art '),
										A3($author$project$View$Display$unobviousLink, 'Dating Apps', 'https://www.happymatches.com/online-dating/dating-apps', linkStyles),
										$rtfeldman$elm_css$Html$Styled$text(' and '),
										A3($author$project$View$Display$unobviousLink, 'Dating Site', 'https://www.happymatches.com/online-dating/dating-sites', linkStyles),
										$rtfeldman$elm_css$Html$Styled$text('/'),
										A3($author$project$View$Display$unobviousLink, 'Dating Website', 'https://www.happymatches.com/online-dating/dating-websites', linkStyles)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sponsors$styles.fz)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href(registerUrl),
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_Utils_ap($author$project$View$Theme$defaultStyles.kj, $author$project$Page$Home$Sponsors$styles.fD))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Connect with Your Gorgeous Dream Dates Now')
											]))
									]))
							]))
					]))
			]));
};
var $rtfeldman$elm_css$Css$flexEnd = $rtfeldman$elm_css$Css$prop1('flex-end');
var $author$project$Page$Home$Sugars$styles = {
	Z: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$paddingLeft(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
						$rtfeldman$elm_css$Css$Global$descendants(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Global$typeSelector,
								'a',
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
										$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
									]))
							]))
					]))
			])),
	fo: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$margin2,
					$rtfeldman$elm_css$Css$zero,
					$rtfeldman$elm_css$Css$px(15))
				]))
		]),
	fz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(40)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero)
				]))
		]),
	fD: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(30)),
					$rtfeldman$elm_css$Css$paddingRight(
					$rtfeldman$elm_css$Css$px(30)),
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$pct(70)),
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$normal)
				]))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$author$project$View$Theme$forDesktopScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundImage(
					$rtfeldman$elm_css$Css$url($author$project$View$Theme$images.lk)),
					$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
					$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$left),
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(200))
				]))
		]),
	f2: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(15)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	gT: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j6),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					]))
			])),
	cA: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMedia,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Media$only,
					$rtfeldman$elm_css$Css$Media$screen,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Media$maxWidth(
							$rtfeldman$elm_css$Css$px(1300))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	$9: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
		]),
	bZ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$px(15)),
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					]))
			]))
};
var $author$project$Page$Home$Sugars$view = function (registerUrl) {
	var linkStyles = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
				]))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.f2)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.gT)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.$9)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('BENEFITS FOR')
									])),
								$rtfeldman$elm_css$Html$Styled$text('Dates')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.bZ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Know what you want, Go for it! Attract your Suitors and enjoy Magnificent times together.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.fo)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Verify Your Profile, Differentiate Yourself and Be Noticed')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Meet Charming Men and Ladies at No Cost (i.e. It’s Free!)')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Dating Partners and Type of Relationships of Your Choice')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Verified Profiles for Safe Environment with Seamless Chat Interaction')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_Utils_ap(
											$author$project$Page$Home$Sugars$styles.Z,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
												])))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Avoid Wasting Time on Unsuitable Dates, Scammers and Fake Profiles')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Hassle-free, Peak Performance and Highly Effective Dating Experience')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.Z)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Intuitive State-of-the-Art '),
										A3($author$project$View$Display$unobviousLink, 'Dating Apps', 'https://www.happymatches.com/online-dating/dating-apps', linkStyles),
										$rtfeldman$elm_css$Html$Styled$text(' and '),
										A3($author$project$View$Display$unobviousLink, 'Dating Site', 'https://www.happymatches.com/online-dating/dating-sites', linkStyles),
										$rtfeldman$elm_css$Html$Styled$text('/'),
										A3($author$project$View$Display$unobviousLink, 'Dating Website', 'https://www.happymatches.com/online-dating/dating-websites', linkStyles)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.fz)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kj),
										$rtfeldman$elm_css$Html$Styled$Attributes$href(registerUrl),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.fD)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Connect with Your Charming Dream Suitors Now')
											]))
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.lG.nK),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.cA)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.lG.nI),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.cA)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.lG.nL),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$Sugars$styles.cA)
					]),
				_List_Nil)
			]));
};
var $author$project$View$Hero$view = F4(
	function (mobileImageUrl, imageUrl, containerStyle, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$backgroundImage(
							$rtfeldman$elm_css$Css$url(imageUrl)),
							$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
							$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
							$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$px(160)),
							$author$project$View$Theme$forMobileScreen(
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$padding2,
									$rtfeldman$elm_css$Css$px(20),
									$rtfeldman$elm_css$Css$px(15)),
									$rtfeldman$elm_css$Css$minHeight(
									$rtfeldman$elm_css$Css$vh(100)),
									$rtfeldman$elm_css$Css$backgroundImage(
									$rtfeldman$elm_css$Css$url(mobileImageUrl))
								]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
						]),
					children)
				]));
	});
var $author$project$Page$Home$view = function () {
	var registerUrl = $author$project$Data$Route$routeUrl.na;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A5(
				$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
				$author$project$View$Hero$view,
				$author$project$View$Theme$images.lG.mj,
				$author$project$View$Theme$images.lG.j3,
				$author$project$Page$Home$styles.gX,
				_List_fromArray(
					[
						$author$project$Page$Home$headingAndSub,
						$author$project$View$Hero$paragraph(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Where Attractive People and Charming People Meet for Dates and Romance.'),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('Modern '),
								A3(
								$author$project$View$Display$unobviousLink,
								'Online Dating',
								'https://www.happymatches.com/online-dating',
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
										$rtfeldman$elm_css$Css$fontSize(
										$rtfeldman$elm_css$Css$px(16)),
										$rtfeldman$elm_css$Css$fontFamilies(
										_List_fromArray(
											['Open Sans, sans-serif']))
									])),
								$rtfeldman$elm_css$Html$Styled$text(' made Simple and Straightforward.')
							])),
						$author$project$View$Hero$paragraph(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Signing up for your '),
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.e$),
										$rtfeldman$elm_css$Html$Styled$Attributes$href(registerUrl)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Suitor')
									])),
								$rtfeldman$elm_css$Html$Styled$text(' or '),
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.e$),
										$rtfeldman$elm_css$Html$Styled$Attributes$href(registerUrl)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Date')
									])),
								$rtfeldman$elm_css$Html$Styled$text(' account is fast and free.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$styles.fH)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$styles.fz),
										$author$project$Animate$animate(23)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kj),
												$rtfeldman$elm_css$Html$Styled$Attributes$href(registerUrl)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('I\'M A MAN')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Home$styles.fz),
										$author$project$Animate$animate(25)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kj),
												$rtfeldman$elm_css$Html$Styled$Attributes$href(registerUrl)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('I\'M A LADY')
											]))
									]))
							]))
					])),
				$author$project$Page$Home$HowItWorks$view(registerUrl),
				$author$project$Page$Home$Media$view,
				$author$project$Page$Home$Sponsors$view(registerUrl),
				$author$project$Page$Home$Sugars$view(registerUrl),
				$author$project$Page$Home$Special$view(registerUrl)
			]));
}();
var $author$project$Type$Register$FormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$Register$SubmitForm = {$: 0};
var $author$project$Page$Register$disclaimer = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap(
				$author$project$View$Theme$defaultStyles.kd,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
						A2(
						$rtfeldman$elm_css$Css$margin2,
						$rtfeldman$elm_css$Css$px(15),
						$rtfeldman$elm_css$Css$zero)
					])))
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text('By registering, you agree to HappyMatches.com’s '),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.e$),
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.nS)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Terms of Use')
				])),
			$rtfeldman$elm_css$Html$Styled$text(' and '),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.e$),
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.m$)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Privacy Policy')
				])),
			$rtfeldman$elm_css$Html$Styled$text('. '),
			$rtfeldman$elm_css$Html$Styled$text('Promoting illegal commercial activities (such as prostitution, social escorting and payment-for-sex) is prohibited. '),
			$rtfeldman$elm_css$Html$Styled$text('Users must be at least 18 years old and shall not put any contact information on their profile.')
		]));
var $author$project$View$Form$emailField = $author$project$View$Form$textFieldFactory('email');
var $author$project$Page$Register$header = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
					$author$project$View$Theme$forMobileScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.lC)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Sign up')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$author$project$View$Theme$forMobileScreen(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
								]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kd)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Already have an account?')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap(
								$author$project$View$Theme$defaultStyles.lt,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginLeft(
										$rtfeldman$elm_css$Css$px(15))
									]))),
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l1)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('SIGN IN')
						]))
				]))
		]));
var $author$project$View$Form$passwordField = $author$project$View$Form$textFieldFactory('password');
var $author$project$Page$Register$renderFormError = function (apiError) {
	if (apiError.$ === 1) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = apiError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'formError')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Page$Register$styles = {
	g2: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	i1: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$margin2,
				$rtfeldman$elm_css$Css$px(30),
				$rtfeldman$elm_css$Css$zero)
			])),
	jb: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		])
};
var $author$project$View$Form$submitButton = function (isSubmitting) {
	return isSubmitting ? A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.ci),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Submit')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Submitting...')
			])) : A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.ci),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(false),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Submit')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Submit')
			]));
};
var $rtfeldman$elm_css$Css$borderRight3 = $rtfeldman$elm_css$Css$prop3('border-right');
var $rtfeldman$elm_css$Css$lastChild = $rtfeldman$elm_css$Css$pseudoClass('last-child');
var $author$project$View$Form$tabSelectOption = F3(
	function (fieldName, selectedValue, _v0) {
		var optionValue = _v0.a;
		var label = _v0.b;
		var style = _Utils_ap(
			$author$project$View$Theme$defaultStyles.kd,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(10),
					$rtfeldman$elm_css$Css$px(20)),
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN),
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly),
					A3(
					$rtfeldman$elm_css$Css$borderRight3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$View$Theme$colors.gO),
					$rtfeldman$elm_css$Css$lastChild(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero)
						])),
					$rtfeldman$elm_css$Css$hover(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						]))
				]));
		var selectedStyle = _Utils_eq(selectedValue, optionValue) ? _List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh)
			]) : _List_Nil;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(style, selectedStyle)),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A2($author$project$Form$AsString, fieldName, optionValue)),
					$rtfeldman$elm_css$Html$Styled$Attributes$value(optionValue),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', optionValue)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				]));
	});
var $author$project$View$Form$tabSelectField = F2(
	function (form, _v0) {
		var fieldName = _v0.ct;
		var label = _v0.dX;
		var options = _v0.eg;
		var styles = {
			f1: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					A2(
					$rtfeldman$elm_css$Css$margin2,
					$rtfeldman$elm_css$Css$px(15),
					$rtfeldman$elm_css$Css$zero)
				]),
			gs: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$px(5)),
					$author$project$View$Theme$forDesktopScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginLeft(
							$rtfeldman$elm_css$Css$px(140))
						]))
				]),
			hd: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$author$project$View$Theme$forMobileScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart)
						]))
				]),
			dX: _Utils_ap(
				$author$project$View$Theme$defaultStyles.kd,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(140)),
						$author$project$View$Theme$forMobileScreen(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$paddingBottom(
								$rtfeldman$elm_css$Css$px(5))
							]))
					])),
			h0: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$View$Theme$colors.gO),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(20)),
					$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
					$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none)
				])
		};
		var selectedValue = A2($author$project$Form$getRawString, form, fieldName);
		var createOptions = A2($author$project$View$Form$tabSelectOption, fieldName, selectedValue);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.hd)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.dX)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.h0)
								]),
							A2($elm$core$List$map, createOptions, options))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.gs)
						]),
					_List_fromArray(
						[
							A2($author$project$View$Form$displayValidationError, form, fieldName)
						]))
				]));
	});
var $author$project$View$ProfileOption$userKindOption = function (userKind) {
	var value = $author$project$Core$Data$AuthUser$userKindString(userKind);
	if (!userKind) {
		return _Utils_Tuple2(value, 'Charming Suitor');
	} else {
		return _Utils_Tuple2(value, 'Attractive Date');
	}
};
var $author$project$View$ProfileOption$userKindOptions = A2(
	$elm$core$List$map,
	$author$project$View$ProfileOption$userKindOption,
	_List_fromArray(
		[0, 1]));
var $author$project$Page$Register$renderRegistrationForm = function (_v0) {
	var register = _v0.na;
	var _v1 = register;
	var form = _v1.ln;
	var apiError = _v1.dk;
	var _v2 = form;
	var submitting = _v2.jc;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Page$Register$header,
				A2(
				$rtfeldman$elm_css$Html$Styled$hr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$styles.g2)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$styles.i1)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Signing up for your account is fast and free!')
					])),
				$author$project$Page$Register$renderFormError(apiError),
				A2(
				$rtfeldman$elm_css$Html$Styled$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
						$author$project$Types$OnRegister($author$project$Type$Register$SubmitForm))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnRegister, $author$project$Type$Register$FormMsg),
						A2(
							$author$project$View$Form$tabSelectField,
							form,
							{ct: 'userKind', dX: 'I am a', eg: $author$project$View$ProfileOption$userKindOptions})),
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnRegister, $author$project$Type$Register$FormMsg),
						A2(
							$author$project$View$Form$tabSelectField,
							form,
							{ct: 'gender', dX: 'Who is a', eg: $author$project$View$ProfileOption$genderOptions})),
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnRegister, $author$project$Type$Register$FormMsg),
						A2(
							$author$project$View$Form$tabSelectField,
							form,
							{ct: 'wantGender', dX: 'Looking for', eg: $author$project$View$ProfileOption$wantGenderOptions})),
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnRegister, $author$project$Type$Register$FormMsg),
						A2(
							$author$project$View$Form$textField,
							form,
							{ct: 'username', dX: 'MY USERNAME'})),
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnRegister, $author$project$Type$Register$FormMsg),
						A2(
							$author$project$View$Form$emailField,
							form,
							{ct: 'email', dX: 'MY EMAIL ADDRESS'})),
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnRegister, $author$project$Type$Register$FormMsg),
						A2(
							$author$project$View$Form$passwordField,
							form,
							{ct: 'password', dX: 'MY PASSWORD'})),
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnRegister, $author$project$Type$Register$FormMsg),
						A2(
							$author$project$View$Form$passwordField,
							form,
							{ct: 'passwordConfirmation', dX: 'MY PASSWORD AGAIN'})),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$styles.jb)
							]),
						_List_fromArray(
							[
								$author$project$View$Form$submitButton(submitting)
							]))
					])),
				$author$project$Page$Register$disclaimer
			]));
};
var $author$project$Page$Register$view = function (appModel) {
	var _v0 = appModel;
	var device = _v0.kQ;
	if (!device.$) {
		return $author$project$Page$Register$renderRegistrationForm(appModel);
	} else {
		return $author$project$Page$Register$renderRegistrationForm(appModel);
	}
};
var $author$project$View$homePage = function (model) {
	if ($author$project$NativeBridge$isMobileApp(model.kQ)) {
		var _v0 = model.j1;
		if (!_v0.$) {
			return A2($author$project$View$authPage, model, $author$project$View$profilesView);
		} else {
			return _Utils_Tuple2(
				0,
				$author$project$Page$Register$view(model));
		}
	} else {
		return _Utils_Tuple2(1, $author$project$Page$Home$view);
	}
};
var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp3 = F4(
	function (fn, arg1, arg2, arg3) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A3(fn, arg1, arg2, arg3));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy3 = F4(
	function (fn, arg1, arg2, arg3) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A5($elm$virtual_dom$VirtualDom$lazy4, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp3, fn, arg1, arg2, arg3));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy3 = $rtfeldman$elm_css$VirtualDom$Styled$lazy3;
var $author$project$View$Display$notFoundView = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap(
				$author$project$View$Theme$defaultStyles.kd,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$px(20)),
						$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					])))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$View$Theme$defaultStyles.lC,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$px(30))
							])))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Page not found')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Please check your URL again.')
				]))
		]));
var $author$project$Page$Deactivate$styles = {
	fE: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
		]),
	fJ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lt,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(90)),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(5)),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$normal),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(22))
			])),
	f1: F2(
		function (_v0, hasAlert) {
			var screenHeight = _v0.ni;
			return _Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN)
					]),
				A2($author$project$View$Theme$defaultStyles.kA, screenHeight, hasAlert));
		}),
	ge: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	gf: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(40))
			])),
	gT: $author$project$View$Theme$defaultStyles.lC,
	lP: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(400)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	lS: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg)
			])),
	jJ: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(15),
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		])
};
var $author$project$Page$Deactivate$processingView = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Deactivate$styles.ge)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Deactivate$styles.gf)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Deleting Your Profile')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Please wait a moment while we are deleting your profile.\nYou will be redirected automatically once the deletion is completed.')
				]))
		]));
var $author$project$Page$AboutUs$styles = {
	fl: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(30))
		]),
	gX: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(550))
		]),
	af: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og)
		]),
	g0: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og)
		]),
	g1: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(80),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$paddingBottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(80))
				]))
		]),
	ht: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
				]))
		]),
	d0: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN)
		]),
	h1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(210)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(80)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-130)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.lw),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(80),
					$rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero)
				]))
		]),
	dd: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$px(48))
				]))
		])
};
var $author$project$View$Hero$title = function (content) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h1,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$px(45)),
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$lineHeight(
						$rtfeldman$elm_css$Css$px(60)),
						$author$project$View$Theme$forDinosaurMobileScreen(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$px(25)),
								$rtfeldman$elm_css$Css$lineHeight(
								$rtfeldman$elm_css$Css$px(35))
							]))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(content)
			]));
};
var $author$project$Page$AboutUs$Future$styles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	gT: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j6),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					]))
			])),
	af: $author$project$View$Theme$defaultStyles.kd,
	bZ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(25)),
				$rtfeldman$elm_css$Css$maxWidth(
				$rtfeldman$elm_css$Css$px(770))
			]))
};
var $author$project$Page$AboutUs$Future$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Future$styles.f1)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Future$styles.gT)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Our Future')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Future$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Despite being a recent entrant to General Dating, HappyMatches carries the hopes and dreams of all online daters all around the world to revolutionize dating on the internet – to make it safe, easy, reliable and effective.')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Future$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('It is with this vision and objective in mind, that we continue to charge forward, so as to be able to serve you better with each passing day.')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Future$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Whether you are living in the United States, United Kingdom, Canada, Australia or New Zealand. Or you’re residing elsewhere in North America, Europe, South America, Asia Pacific or the Middle East, you’re always first in our minds as we strive to meet your dating needs.')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Future$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('We thank you always for your strong support and valuable feedback, to help HappyMatches become the most extraordinary and trusted dating partner the world has ever seen to date.')
				]))
		]));
var $author$project$Page$AboutUs$HowItWorks$styles = {
	fz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(60))
		]),
	fD: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
				]))
		]),
	fK: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(380)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	fL: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(80)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(60))
				]))
		]),
	fM: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(30)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(20))
			])),
	fN: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j4),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	fO: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	gT: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j6),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					]))
			]))
};
var $author$project$Page$AboutUs$HowItWorks$card = F3(
	function (imageUrl, title, content) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowItWorks$styles.fK)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowItWorks$styles.fL),
							$rtfeldman$elm_css$Html$Styled$Attributes$src(imageUrl)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowItWorks$styles.fN)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(title)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowItWorks$styles.fM)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(content)
						]))
				]));
	});
var $author$project$Page$AboutUs$HowItWorks$view = function (registerUrl) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowItWorks$styles.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowItWorks$styles.gT)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('How it works')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowItWorks$styles.fO)
					]),
				_List_fromArray(
					[
						A3($author$project$Page$AboutUs$HowItWorks$card, $author$project$View$Theme$images.jN.kS, 'Discover', 'Browse through the profiles of quality Suitors and Dates in your locality. Identify those profiles which match your aspirations and expectations.'),
						A3($author$project$Page$AboutUs$HowItWorks$card, $author$project$View$Theme$images.jN.kx, 'Connect', 'Interact with suitable profiles using the portal’s real-time chat. Exchange pictures, and get to know each other better.'),
						A3($author$project$Page$AboutUs$HowItWorks$card, $author$project$View$Theme$images.jN.l8, 'Meetup', 'When comfortable, arrange your first and subsequent meetups through the portal. Enjoy your dates and let romance blossom.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowItWorks$styles.fz)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href(registerUrl),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap($author$project$View$Theme$defaultStyles.kj, $author$project$Page$AboutUs$HowItWorks$styles.fD))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Find Charming Suitors ')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('and Attractive Dates Now')
									]))
							]))
					]))
			]));
};
var $rtfeldman$elm_css$Css$boxShadow4 = $rtfeldman$elm_css$Css$prop4('box-shadow');
var $author$project$Page$AboutUs$HowWeCome$styles = {
	fK: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(10)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(40),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(160)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A4(
			$rtfeldman$elm_css$Css$boxShadow4,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(10),
			$author$project$View$Theme$colors.gO),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	fM: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(25))
			])),
	fN: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j4),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.eh)
		]),
	fO: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	gT: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j6),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					]))
			])),
	af: $author$project$View$Theme$defaultStyles.kd,
	bZ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A4(
				$rtfeldman$elm_css$Css$padding4,
				$rtfeldman$elm_css$Css$px(30),
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$maxWidth(
				$rtfeldman$elm_css$Css$px(770)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(20))
			]))
};
var $author$project$Page$AboutUs$HowWeCome$card = F2(
	function (title, content) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowWeCome$styles.fK)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowWeCome$styles.fN)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(title)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowWeCome$styles.fM)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(content)
						]))
				]));
	});
var $author$project$Page$AboutUs$HowWeCome$cardWithCustomContent = F2(
	function (title, content) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowWeCome$styles.fK)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowWeCome$styles.fN)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(title)
						])),
					content
				]));
	});
var $author$project$Page$AboutUs$HowWeCome$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowWeCome$styles.f1)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowWeCome$styles.gT)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('How Happy Matches came about')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowWeCome$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('In the area of Dating and Relationships, each of us wants to find someone charming and attractive for our '),
					A3($author$project$View$Display$unobviousLink, 'casual dates', 'https://www.happymatches.com/blog/casual-dating/casual-dating', $author$project$Page$AboutUs$HowWeCome$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(' and '),
					A3($author$project$View$Display$unobviousLink, 'serious dates', 'https://www.happymatches.com/blog/serious-relationship/serious-relationship-advice', $author$project$Page$AboutUs$HowWeCome$styles.af),
					$rtfeldman$elm_css$Html$Styled$text('. Besides the difficulty of finding and meeting such people online or in real life, the unique aspirations and expectations of each individual adds to the complexity of finding compatible matches.')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowWeCome$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Whilst analyzing all the established '),
					A3($author$project$View$Display$unobviousLink, 'online dating sites', 'https://www.happymatches.com/blog/online-dating/online-dating-sites', $author$project$Page$AboutUs$HowWeCome$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(' and '),
					A3($author$project$View$Display$unobviousLink, 'online dating apps', 'https://www.happymatches.com/blog/online-dating/online-dating-apps', $author$project$Page$AboutUs$HowWeCome$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', the team at HappyMatches realized that users commonly face the following pains and frustrations:')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowWeCome$styles.fO)
				]),
			_List_fromArray(
				[
					A2($author$project$Page$AboutUs$HowWeCome$card, '01', 'Difficult, time-consuming, frustrating and tedious to identify possible potential matches.'),
					A2($author$project$Page$AboutUs$HowWeCome$card, '02', 'Lack of clarity on the type of relationship(s) these potential matches are looking for and their expectations.'),
					A2(
					$author$project$Page$AboutUs$HowWeCome$cardWithCustomContent,
					'03',
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$HowWeCome$styles.fM)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Low quality profiles: lots of '),
								A3($author$project$View$Display$unobviousLink, 'scammers', 'https://www.happymatches.com/blog/online-dating/online-dating-safety-tips', $author$project$Page$AboutUs$HowWeCome$styles.af),
								$rtfeldman$elm_css$Html$Styled$text(', bots, spammers, fake profiles and duplicate accounts.')
							]))),
					A2($author$project$Page$AboutUs$HowWeCome$card, '04', 'Unverified profiles: difficult to differentiate between genuine users and insincere timewasters.'),
					A2($author$project$Page$AboutUs$HowWeCome$card, '05', 'Frustrating to use and difficult to interact with other users due to poor design, bugs, performance issues and irritating advertisements.'),
					A2($author$project$Page$AboutUs$HowWeCome$card, '06', 'Limited access to profiles: purposeless swiping leading to a “black-hole”, and restricted access to only a few poorly suggested profiles each day.'),
					A2($author$project$Page$AboutUs$HowWeCome$card, '07', 'Prohibitive costs: costly paid memberships offering little “value-for-money”, and overpriced “likes” or “super likes” merely to indicate one’s interest in a profile.')
				]))
		]));
var $author$project$Page$AboutUs$Mission$styles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	gT: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j6),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					]))
			])),
	af: $author$project$View$Theme$defaultStyles.kd,
	bZ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(25)),
				$rtfeldman$elm_css$Css$maxWidth(
				$rtfeldman$elm_css$Css$px(770))
			]))
};
var $author$project$Page$AboutUs$Mission$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Mission$styles.f1)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Mission$styles.gT)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Matching Aspirations & Expectations')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Mission$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('HappyMatches embraces an individual’s freedom to choose the Type of Relationship(s) you want, and Who you want to Date.')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Mission$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Find gorgeous partners for '),
					A3($author$project$View$Display$unobviousLink, 'Casual Dating', 'https://www.happymatches.com/casual-dating', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(' and '),
					A3($author$project$View$Display$unobviousLink, 'Open Relationship', 'https://www.happymatches.com/open-relationship', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(' (such as a '),
					A3($author$project$View$Display$unobviousLink, 'hook up', 'https://www.happymatches.com/hook-up', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'friends with benefits', 'https://www.happymatches.com/friends-with-benefits', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'one night stand', 'https://www.happymatches.com/one-night-stand', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'fling', 'https://www.happymatches.com/fling', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'casual encounters', 'https://www.happymatches.com/casual-encounters', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'nsa relationship', 'https://www.happymatches.com/nsa-relationship', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'non monogamous relationship', 'https://www.happymatches.com/non-monogamous-relationship', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'short term relationship', 'https://www.happymatches.com/short-term-relationship', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'casual sex', 'https://www.happymatches.com/casual-sex', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'open marriage', 'https://www.happymatches.com/open-marriage', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(' or '),
					A3($author$project$View$Display$unobviousLink, 'booty call', 'https://www.happymatches.com/booty-call', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(').')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Mission$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Or seek a '),
					A3($author$project$View$Display$unobviousLink, 'Serious Relationship', 'https://www.happymatches.com/serious-relationship', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(' for '),
					A3($author$project$View$Display$unobviousLink, 'monogamous', 'https://www.happymatches.com/monogamous-relationship', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'long term', 'https://www.happymatches.com/long-term-relationship', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(' and '),
					A3($author$project$View$Display$unobviousLink, 'romantic dating', 'https://www.happymatches.com/romantic-relationship', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(' to '),
					A3($author$project$View$Display$unobviousLink, 'settle down', 'https://www.happymatches.com/settle-down', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text('. Perhaps, you might even be looking for a Travel Companion, to make more '),
					A3($author$project$View$Display$unobviousLink, 'Friends', 'https://www.happymatches.com/platonic-friendship', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', or to Network.')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Mission$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('State Upfront what you are looking for, and stop wasting your time on Unsuitable Profiles.')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Mission$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('We fully support and encourage Straight '),
					A3($author$project$View$Display$unobviousLink, 'Heterosexual Dating', 'https://www.happymatches.com/heterosexual-dating', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'Gay Dating', 'https://www.happymatches.com/gay-dating', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'Lesbian Dating', 'https://www.happymatches.com/lesbian-dating', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'Bisexual Dating', 'https://www.happymatches.com/bisexual-dating', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(', '),
					A3($author$project$View$Display$unobviousLink, 'Bi Curious Dating', 'https://www.happymatches.com/bi-curious-dating', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(' and '),
					A3($author$project$View$Display$unobviousLink, 'Senior Dating', 'https://www.happymatches.com/senior-dating', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text('/'),
					A3($author$project$View$Display$unobviousLink, 'Mature Dating', 'https://www.happymatches.com/mature-dating', $author$project$Page$AboutUs$Mission$styles.af),
					$rtfeldman$elm_css$Html$Styled$text('. However, Sugar Dating or Compensated Dating is strictly prohibited.')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$Mission$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Let us Partner with you to find your Happy Matches!')
				]))
		]));
var $author$project$Page$AboutUs$OurSolutions$styles = {
	fK: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(10)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(40),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(160)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A4(
			$rtfeldman$elm_css$Css$boxShadow4,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(10),
			$author$project$View$Theme$colors.gO),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	fM: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(25))
			])),
	fN: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j4),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.eh)
		]),
	fO: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	gT: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j6),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					]))
			])),
	af: $author$project$View$Theme$defaultStyles.kd,
	bZ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A4(
				$rtfeldman$elm_css$Css$padding4,
				$rtfeldman$elm_css$Css$px(30),
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$maxWidth(
				$rtfeldman$elm_css$Css$px(770)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(20))
			]))
};
var $author$project$Page$AboutUs$OurSolutions$card = F2(
	function (title, content) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.fK)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.fN)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(title)
						])),
					content
				]));
	});
var $author$project$Page$AboutUs$OurSolutions$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.f1)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.gT)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Our Solutions')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('At HappyMatches, we recognize all these key challenges and issues which users in the Online Dating world face.')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.bZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Our high-performing '),
					A3($author$project$View$Display$unobviousLink, 'dating site', 'https://www.happymatches.com/blog/online-dating/best-dating-sites', $author$project$Page$AboutUs$OurSolutions$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(' and '),
					A3($author$project$View$Display$unobviousLink, 'dating apps', 'https://www.happymatches.com/blog/online-dating/best-dating-apps', $author$project$Page$AboutUs$OurSolutions$styles.af),
					$rtfeldman$elm_css$Html$Styled$text(' offer the following features and benefits, so that finding your perfect match and ideal type of relationship become so easy, effective and hassle-free:')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.fO)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Page$AboutUs$OurSolutions$card,
					'01',
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.fM)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Clarity (and customized recommendations of potential matches) based on the Type of Relationship(s) you are looking for and matching expectations.')
							]))),
					A2(
					$author$project$Page$AboutUs$OurSolutions$card,
					'02',
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.fM)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('“Live Chat” allows real-time interaction between Suitors and Dates to get to know each other better and build connection quickly, to facilitate moving to the next phase of meeting up.')
							]))),
					A2(
					$author$project$Page$AboutUs$OurSolutions$card,
					'03',
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.fM)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Absolutely FREE usage for all “Date” profiles, with an incredibly low 1 USD first-month entry subscription for “Suitor” profiles. Suitors can upgrade anytime to stand out from competition.')
							]))),
					A2(
					$author$project$Page$AboutUs$OurSolutions$card,
					'04',
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.fM)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('World’s First “Face Verification” process for all Suitors and Dates to ensure real and authenticated profiles, and eradicate '),
								A3($author$project$View$Display$unobviousLink, 'scammers', 'https://www.happymatches.com/blog/online-dating/online-dating-scams', $author$project$Page$AboutUs$OurSolutions$styles.af),
								$rtfeldman$elm_css$Html$Styled$text(', fake profiles, bots and insincere timewasters.')
							]))),
					A2(
					$author$project$Page$AboutUs$OurSolutions$card,
					'05',
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.fM)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('State-of-the-art mobile-friendly '),
								A3($author$project$View$Display$unobviousLink, 'website', 'https://www.happymatches.com/blog/online-dating/best-dating-websites', $author$project$Page$AboutUs$OurSolutions$styles.af),
								$rtfeldman$elm_css$Html$Styled$text(' and '),
								A3($author$project$View$Display$unobviousLink, 'apps', 'https://www.happymatches.com/blog/online-dating/top-dating-apps', $author$project$Page$AboutUs$OurSolutions$styles.af),
								$rtfeldman$elm_css$Html$Styled$text(' deliver real-time information, optimal performance, with a highly intuitive, elegant and user-friendly design.')
							]))),
					A2(
					$author$project$Page$AboutUs$OurSolutions$card,
					'06',
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.fM)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Continuous improvement, innovation and new cutting-edge features and concepts being rolled out regularly, to deliver the best '),
								A3($author$project$View$Display$unobviousLink, 'online dating experience', 'https://www.happymatches.com/blog/online-dating/online-dating-tips-for-success', $author$project$Page$AboutUs$OurSolutions$styles.af),
								$rtfeldman$elm_css$Html$Styled$text(' and highest quality profiles.')
							]))),
					A2(
					$author$project$Page$AboutUs$OurSolutions$card,
					'07',
					A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$OurSolutions$styles.fM)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Huge '),
								A3($author$project$View$Display$unobviousLink, 'Dating Resource', 'https://www.happymatches.com/blog/online-dating/dating-advice', $author$project$Page$AboutUs$OurSolutions$styles.af),
								$rtfeldman$elm_css$Html$Styled$text(' Database: authoritative, insightful, valuable and practical '),
								A3($author$project$View$Display$unobviousLink, 'dating advice', 'https://www.happymatches.com/online-dating/dating-advice', $author$project$Page$AboutUs$OurSolutions$styles.af),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'tips', 'https://www.happymatches.com/online-dating/dating-tips', $author$project$Page$AboutUs$OurSolutions$styles.af),
								$rtfeldman$elm_css$Html$Styled$text(', '),
								A3($author$project$View$Display$unobviousLink, 'rules', 'https://www.happymatches.com/online-dating/dating-rules', $author$project$Page$AboutUs$OurSolutions$styles.af),
								$rtfeldman$elm_css$Html$Styled$text(' and '),
								A3($author$project$View$Display$unobviousLink, 'insights', 'https://www.happymatches.com/blog/online-dating/dating-advice', $author$project$Page$AboutUs$OurSolutions$styles.af),
								$rtfeldman$elm_css$Html$Styled$text(' across all dating areas to help you succeed in your dating and relationship life.')
							])))
				]))
		]));
var $author$project$Page$AboutUs$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_Nil,
	_List_fromArray(
		[
			A5(
			$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
			$author$project$View$Hero$view,
			$author$project$View$Theme$images.jN.mj,
			$author$project$View$Theme$images.jN.j3,
			$author$project$Page$AboutUs$styles.gX,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$styles.dd)
						]),
					_List_fromArray(
						[
							$author$project$View$Hero$title('Our Mission')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$styles.fl)
						]),
					_List_fromArray(
						[
							$author$project$View$Hero$paragraph(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('HappyMatches prides itself as the World’s No. 1 Top '),
									A3($author$project$View$Display$unobviousLink, 'Dating Site', 'https://www.happymatches.com/online-dating/dating-sites', $author$project$Page$AboutUs$styles.af),
									$rtfeldman$elm_css$Html$Styled$text(' and Best '),
									A3($author$project$View$Display$unobviousLink, 'Dating App', 'https://www.happymatches.com/online-dating/dating-apps', $author$project$Page$AboutUs$styles.af),
									$rtfeldman$elm_css$Html$Styled$text(' for '),
									A3($author$project$View$Display$unobviousLink, 'Online Dating', 'https://www.happymatches.com/online-dating/dating-apps', $author$project$Page$AboutUs$styles.af),
									$rtfeldman$elm_css$Html$Styled$text(', particularly for finding '),
									A3($author$project$View$Display$unobviousLink, 'Casual Relationships', 'https://www.happymatches.com/casual-relationship', $author$project$Page$AboutUs$styles.af),
									$rtfeldman$elm_css$Html$Styled$text(' and '),
									A3($author$project$View$Display$unobviousLink, 'Committed Relationship', 'https://www.happymatches.com/committed-relationship', $author$project$Page$AboutUs$styles.af),
									$rtfeldman$elm_css$Html$Styled$text(' partners.')
								])),
							$author$project$View$Hero$paragraph(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('We match the Aspirations and Expectations of Users, and bring Attractive People and Charming People together for amazing Dates and Romance.')
								])),
							$author$project$View$Hero$paragraph(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('This makes Modern Dating and Relationships very Simple and Straightforward.')
								])),
							$author$project$View$Hero$paragraph(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Simply '),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$styles.ht),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.na)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Register for Free')
										])),
									$rtfeldman$elm_css$Html$Styled$text(' to use our World-Class HM '),
									A3($author$project$View$Display$unobviousLink, 'Dating Website', 'https://www.happymatches.com/online-dating/dating-websites', $author$project$Page$AboutUs$styles.af),
									$rtfeldman$elm_css$Html$Styled$text(' and '),
									A3($author$project$View$Display$unobviousLink, 'Dating Apps', 'https://www.happymatches.com/blog/online-dating/dating-apps', $author$project$Page$AboutUs$styles.af),
									$rtfeldman$elm_css$Html$Styled$text('.')
								]))
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$styles.d0)
				]),
			_List_fromArray(
				[$author$project$Page$AboutUs$Mission$view])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$styles.g0)
				]),
			_List_fromArray(
				[
					$author$project$Page$AboutUs$HowItWorks$view($author$project$Data$Route$routeUrl.na)
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$styles.g1)
				]),
			_List_fromArray(
				[$author$project$Page$AboutUs$HowWeCome$view])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$styles.h1)
				]),
			_List_fromArray(
				[$author$project$Page$AboutUs$OurSolutions$view])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AboutUs$styles.d0)
				]),
			_List_fromArray(
				[$author$project$Page$AboutUs$Future$view]))
		]));
var $author$project$Type$Block$LoadMore = {$: 0};
var $author$project$Type$Block$UnBlock = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$alignSelf = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignSelf',
		'align-self',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$View$Theme$forLargeDesktopScreen = $rtfeldman$elm_css$Css$Media$withMedia(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$only,
			$rtfeldman$elm_css$Css$Media$screen,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Media$minWidth(
					$rtfeldman$elm_css$Css$px(1536))
				]))
		]));
var $author$project$Page$Block$styles = {
	cc: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$backgroundPosition2,
			$rtfeldman$elm_css$Css$pct(50),
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
			$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	ci: _Utils_ap(
		$author$project$View$Theme$defaultStyles.ci,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$flexEnd)
			])),
	fz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	f1: F2(
		function (_v0, hasAlert) {
			var screenHeight = _v0.ni;
			return _Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexStart),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.lw),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll)
					]),
				A2($author$project$View$Theme$defaultStyles.kA, screenHeight, hasAlert));
		}),
	k1: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(13)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(10))
			])),
	ha: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	dY: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$zero)
		]),
	hR: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	iu: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(50),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(60))),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$pct(100),
						$rtfeldman$elm_css$Css$minus,
						$rtfeldman$elm_css$Css$px(60)))
				])),
			$author$project$View$Theme$forLargeDesktopScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$pct(33.3),
						$rtfeldman$elm_css$Css$minus,
						$rtfeldman$elm_css$Css$px(60)))
				]))
		]),
	iw: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	dh: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(14)),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(15))
			]))
};
var $author$project$Page$Block$displayProfile = function (_v0) {
	var uid = _v0.eX;
	var username = _v0.dh;
	var avatar = _v0.cc;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Block$styles.iu)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(
						$author$project$Data$Route$routeUrl.m2(uid))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Css$backgroundImage(
										$rtfeldman$elm_css$Css$url(avatar)),
									$author$project$Page$Block$styles.cc))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Block$styles.ha)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Block$styles.dh)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(username)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Block$styles.fz)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Type$Block$UnBlock(uid)),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Block$styles.ci),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'unblock')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('UnBlock')
									]))
							]))
					]))
			]));
};
var $author$project$Page$Block$displayProfiles = F2(
	function (profiles, ableToShowEmpty) {
		return ($elm$core$List$isEmpty(profiles) && ableToShowEmpty) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Block$styles.iw),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'blockList')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Block$styles.hR)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('There is no blocked profiles')
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Block$styles.iw),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'blockList')
				]),
			A2($elm$core$List$map, $author$project$Page$Block$displayProfile, profiles));
	});
var $author$project$Page$Block$view = F2(
	function (_v0, authState) {
		var dimension = _v0.kR;
		var toAppHtml = A2(
			$elm$core$Basics$composeR,
			$rtfeldman$elm_css$Html$Styled$map($author$project$Types$OnBlock),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Types$OnAuth));
		var model = authState.j7;
		var unBlockView = function () {
			var _v2 = model.n3;
			if (!_v2.$) {
				var unBlockUser = _v2.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Type$Block$OnUnBlockUser,
					$author$project$Helpers$UnBlockUser$View$view(unBlockUser));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}();
		var containerStyle = A2(
			$author$project$Page$Block$styles.f1,
			dimension,
			$author$project$View$Helpers$UserInfo$isMissingAvatar(authState));
		return toAppHtml(
			function () {
				var _v1 = model.iv;
				switch (_v1.$) {
					case 0:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv)
										]),
									_List_Nil)
								]));
					case 1:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv)
										]),
									_List_Nil)
								]));
					case 2:
						var profiles = _v1.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Block$displayProfiles, profiles, false),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Block$styles.dY)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kj),
													$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Type$Block$LoadMore)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Load More')
												]))
										])),
									unBlockView
								]));
					case 3:
						var profiles = _v1.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Block$displayProfiles, profiles, false),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Block$styles.dY)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kj)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Loading..')
												]))
										])),
									unBlockView
								]));
					default:
						var profiles = _v1.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Block$displayProfiles, profiles, true),
									unBlockView
								]));
				}
			}());
	});
var $rtfeldman$elm_css$Css$borderRight = $rtfeldman$elm_css$Css$prop1('border-right');
var $rtfeldman$elm_css$Css$overflowX = $rtfeldman$elm_css$Css$prop1('overflow-x');
var $author$project$Page$Chat$calculateStyles = F2(
	function (hasCurrentRoom, _v0) {
		var screenWidth = _v0.nj;
		var screenHeight = _v0.ni;
		return {
			f1: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(screenHeight - 65)),
					$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden)
				]),
			a: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px((screenWidth * 2) / 3)),
					$author$project$View$Theme$forMobileScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
							A2(
							$author$project$View$Theme$applyStyleIf,
							hasCurrentRoom,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(100))
								]))
						]))
				]),
			iM: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(screenWidth / 3)),
					A3(
					$rtfeldman$elm_css$Css$borderRight3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$View$Theme$colors.gN),
					$author$project$View$Theme$forMobileScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$px(screenWidth)),
							$rtfeldman$elm_css$Css$borderRight($rtfeldman$elm_css$Css$zero),
							A2(
							$author$project$View$Theme$applyStyleIf,
							hasCurrentRoom,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
								]))
						]))
				])
		};
	});
var $author$project$Helpers$BlockUser$Types$Submit = {$: 2};
var $author$project$Helpers$BlockUser$View$styles = {
	ci: _Utils_ap(
		$author$project$View$Theme$defaultStyles.ci,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(100))
			])),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	k1: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
			])),
	lS: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(15))
			])),
	c7: $author$project$View$Theme$defaultStyles.kd,
	dd: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(15))
			]))
};
var $author$project$Helpers$BlockUser$View$view = function (model) {
	var _v0 = model;
	var status = _v0.eQ;
	var popup = _v0.bN;
	var body = function () {
		switch (status.$) {
			case 0:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$BlockUser$View$styles.c7)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Do you want to block this user?'),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								$rtfeldman$elm_css$Html$Styled$text('You will not receive any message from this user!'),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Helpers$BlockUser$Types$Submit),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$BlockUser$View$styles.ci),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Submit')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Block User')
							]))
					]);
			case 1:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$BlockUser$View$styles.c7)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Blocking this user...'),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
							]))
					]);
			case 2:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$BlockUser$View$styles.c7)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('User blocked successfully.'),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
							]))
					]);
			default:
				var errorMessage = status.a;
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$BlockUser$View$styles.k1)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(errorMessage),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Helpers$BlockUser$Types$Submit),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$BlockUser$View$styles.ci),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Submit')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Retry')
							]))
					]);
		}
	}();
	var html = A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$BlockUser$View$styles.f1),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'blockPopup')
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Helpers$BlockUser$View$styles.dd)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('BLOCK USER')
					])),
			body));
	return A2($author$project$CustomPopup$view, html, popup);
};
var $author$project$Data$Chat$Message$getLoadStatus = F2(
	function (partnerID, state) {
		return A2($elm$core$Dict$get, partnerID, state.H);
	});
var $author$project$Data$Chat$getMessageLoadStatus = F2(
	function (partnerID, _v0) {
		var state = _v0;
		return A2($author$project$Data$Chat$Message$getLoadStatus, partnerID, state.h);
	});
var $author$project$Core$Data$Profile$OnlineStatus$Checking = 2;
var $author$project$Data$Chat$Room$getPartnerOnlineStatus = F2(
	function (partnerID, state) {
		return A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Dict$get, partnerID, state.bK));
	});
var $author$project$Data$Chat$getPartnerOnlineStatus = F2(
	function (partnerID, _v0) {
		var state = _v0;
		return A2($author$project$Data$Chat$Room$getPartnerOnlineStatus, partnerID, state.a);
	});
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp = F2(
	function (fn, arg) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			fn(arg));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy = F2(
	function (fn, arg) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A3($elm$virtual_dom$VirtualDom$lazy2, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp, fn, arg));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy = $rtfeldman$elm_css$VirtualDom$Styled$lazy;
var $author$project$Data$Chat$listMessages = F2(
	function (_v0, partnerID) {
		var state = _v0;
		return A2($author$project$Data$Chat$Message$list, state.h, partnerID);
	});
var $author$project$Page$Chat$Room$styles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero)
		]),
	hv: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		])
};
var $author$project$Core$Data$Profile$SponsorLevel$sponsorLevelGreaterThan = F2(
	function (a, b) {
		return _Utils_cmp(
			$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(a),
			$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(b)) > 0;
	});
var $author$project$Page$Chat$Room$userHasLowerLevelThanSugar = F2(
	function (userProfile, partner) {
		var _v0 = userProfile.eY;
		if (_v0 === 1) {
			return false;
		} else {
			return A2($author$project$Core$Data$Profile$SponsorLevel$sponsorLevelGreaterThan, partner.bY, userProfile.bY);
		}
	});
var $author$project$Type$Chat$ChangeMenuStatus = function (a) {
	return {$: 21, a: a};
};
var $author$project$Helpers$BlockUser$Types$OpenPopup = {$: 0};
var $author$project$Data$Chat$Room$isEmpty = function (_v0) {
	var lastMessageCreatedAt = _v0.ai;
	return _Utils_eq(lastMessageCreatedAt, $author$project$Data$Chat$Room$futurePosix);
};
var $author$project$Data$Chat$isEmptyRoom = function (room) {
	return $author$project$Data$Chat$Room$isEmpty(room);
};
var $author$project$Type$Chat$SetCurrentRoom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Chat$Header$mobileBackButton = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Events$onClick(
			$author$project$Types$OnAuth(
				$author$project$Types$OnChat(
					$author$project$Type$Chat$SetCurrentRoom($elm$core$Maybe$Nothing)))),
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$author$project$View$Theme$forDesktopScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
						]))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.kr)
				]),
			_List_Nil)
		]));
var $rtfeldman$elm_css$Html$Styled$nav = $rtfeldman$elm_css$Html$Styled$node('nav');
var $author$project$Page$Chat$Header$onlineStatusIndicator = function (status) {
	var color = function () {
		switch (status) {
			case 2:
				return $author$project$View$Theme$colors.gO;
			case 0:
				return $author$project$View$Theme$colors.lv;
			default:
				return $author$project$View$Theme$colors.m8;
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$pct(50)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(7)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(7)),
						$rtfeldman$elm_css$Css$backgroundColor(color)
					]))
			]),
		_List_Nil);
};
var $author$project$Page$Chat$RoomsNav$renderAvatar = function (_v0) {
	var avatar = _v0.cc;
	var sponsorLevel = _v0.bY;
	var imageUrl = $elm$core$String$isEmpty(avatar) ? $author$project$View$Theme$images.k0 : avatar;
	return A2(
		$rtfeldman$elm_css$Html$Styled$img,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$src(imageUrl),
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(30)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(30)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$pct(50)),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(2),
						$rtfeldman$elm_css$Css$solid,
						$author$project$Data$Membership$getMembershipColor(sponsorLevel))
					]))
			]),
		_List_Nil);
};
var $author$project$Page$Chat$Header$statusString = function (onlineStatus) {
	switch (onlineStatus) {
		case 2:
			return '...';
		case 0:
			return 'Online';
		default:
			return 'Offline';
	}
};
var $author$project$Page$Chat$Header$styles = {
	e1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	e2: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexGrow(
			$rtfeldman$elm_css$Css$num(2)),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	e3: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(2)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gN),
			A2($rtfeldman$elm_css$Css$property, 'animation-duration', '0.2s'),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$padding(
					$rtfeldman$elm_css$Css$px(10))
				]))
		]),
	g6: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$paddingLeft(
				$rtfeldman$elm_css$Css$px(15))
			])),
	ht: $author$project$View$Theme$defaultStyles.ht,
	hE: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none)
		]),
	cJ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.ht,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(30)),
				$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
					]))
			])),
	hQ: function (openMenu) {
		return _Utils_ap(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$top(
					$rtfeldman$elm_css$Css$px(58)),
					$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(1000)),
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
					A2($rtfeldman$elm_css$Css$property, 'transition', 'transform 0.3s ease'),
					A2($rtfeldman$elm_css$Css$property, 'transform-origin', '0 top'),
					A3(
					$rtfeldman$elm_css$Css$borderLeft3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$View$Theme$colors.gN),
					A3(
					$rtfeldman$elm_css$Css$borderBottom3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$View$Theme$colors.gN)
				]),
			openMenu ? _List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$scaleY(1))
				]) : _List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$scaleY(0))
				]));
	},
	h2: function (element) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$paddingLeft(
							$rtfeldman$elm_css$Css$px(7))
						]))
				]),
			_List_fromArray(
				[element]));
	},
	eQ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO)
		]),
	dh: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
		])
};
var $author$project$Page$Chat$Header$view = F3(
	function (openMenu, room, onlineStatus) {
		var blockMenu = $author$project$Data$Chat$isEmptyRoom(room) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.cJ),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnChat(
									$author$project$Type$Chat$Block($author$project$Helpers$BlockUser$Types$OpenPopup)))),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'blockMenu')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Block user')
						]))
				]));
		var _v0 = room;
		var partner = _v0.q;
		var profileDetailUrl = $author$project$Data$Route$routeUrl.m2(partner.eX);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.f1),
					$author$project$Animate$animate(20)
				]),
			_List_fromArray(
				[
					$author$project$Page$Chat$Header$mobileBackButton,
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href(profileDetailUrl),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.ht)
						]),
					_List_fromArray(
						[
							$author$project$Page$Chat$RoomsNav$renderAvatar(partner)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.g6)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(profileDetailUrl),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.ht)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.dh)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(partner.dh),
											$author$project$Page$Chat$Header$styles.h2(
											$author$project$Page$Chat$Header$onlineStatusIndicator(onlineStatus))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.eQ)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Page$Chat$Header$statusString(onlineStatus))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.e2)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnChat(
											$author$project$Type$Chat$ChangeMenuStatus(!openMenu)))),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.e1),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'chatMenu')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.e3),
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.ml)
										]),
									_List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$nav,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									$author$project$Page$Chat$Header$styles.hQ(openMenu))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.hE)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$a,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$href(profileDetailUrl),
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.cJ)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('View profile')
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Header$styles.cJ),
															$rtfeldman$elm_css$Html$Styled$Events$onClick(
															$author$project$Types$OnAuth(
																$author$project$Types$OnChat(
																	$author$project$Type$Chat$Report($author$project$Helpers$ReportUser$Types$OpenPopup)))),
															A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'reportMenu')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Report user')
														]))
												])),
											blockMenu
										]))
								]))
						]))
				]));
	});
var $author$project$Type$Chat$SendTextMessage = F4(
	function (a, b, c, d) {
		return {$: 8, a: a, b: b, c: c, d: d};
	});
var $author$project$Type$Chat$WriteMessage = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Data$Emoji$Activity = 3;
var $author$project$Type$Chat$ChangeEmojiCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Data$Emoji$Foods = 2;
var $author$project$Data$Emoji$Nature = 1;
var $author$project$Data$Emoji$Objects = 5;
var $author$project$Data$Emoji$Places = 4;
var $author$project$Data$Emoji$Symbols = 6;
var $author$project$Page$Chat$Emoji$styles = {
	fQ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(20))
			])),
	_: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A2($rtfeldman$elm_css$Css$property, 'transition', 'all 0.3s ease'),
			A2($rtfeldman$elm_css$Css$property, 'transform-origin', '0 bottom')
		]),
	Q: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	du: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			A2($rtfeldman$elm_css$Css$property, 'align-content', 'flex-start'),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.j5),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$vh(20)),
			$rtfeldman$elm_css$Css$minHeight(
			$rtfeldman$elm_css$Css$px(200))
		]),
	g_: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$transform(
			$rtfeldman$elm_css$Css$scaleY(0))
		]),
	i0: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$transform(
			$rtfeldman$elm_css$Css$scaleY(1))
		]),
	eV: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	eW: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(24))
		])
};
var $author$project$Page$Chat$Emoji$categoryMenu = function () {
	var changeMsg = A2(
		$elm$core$Basics$composeL,
		A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
		$author$project$Type$Chat$ChangeEmojiCategory);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles.fQ)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles._),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						changeMsg(0))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('People')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(' | ')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles._),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						changeMsg(1))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Nature')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(' | ')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles._),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						changeMsg(2))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Foods')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(' | ')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles._),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						changeMsg(3))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Activity')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(' | ')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles._),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						changeMsg(4))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Places')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(' | ')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles._),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						changeMsg(5))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Objects')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(' | ')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles._),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						changeMsg(6))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Symbols')
					]))
			]));
}();
var $author$project$Type$Chat$SelectEmoji = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Page$Chat$Emoji$displayEmoji = F2(
	function (partnerID, emoji) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles.Q),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnChat(
							A2($author$project$Type$Chat$SelectEmoji, partnerID, emoji))))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(emoji + ' ')
				]));
	});
var $author$project$Data$Emoji$get = function (category) {
	switch (category) {
		case 0:
			return _List_fromArray(
				['😀', '😬', '😁', '😂', '😃', '😄', '😅', '😆', '😇', '😉', '😊', '🙂', '\uD83D\uDE43', '😋', '😌', '😍', '😘', '😗', '😙', '😚', '😜', '😝', '😛', '\uD83E\uDD11', '\uD83E\uDD13', '😎', '\uD83E\uDD17', '😏', '😶', '😐', '😑', '😒', '\uD83D\uDE44', '\uD83E\uDD14', '😳', '😞', '😟', '😠', '😡', '😔', '😕', '🙁', '😣', '😖', '😫', '😩', '😤', '😮', '😱', '😨', '😰', '😯', '😦', '😧', '😢', '😥', '😪', '😓', '😭', '😵', '😲', '\uD83E\uDD10', '😷', '\uD83E\uDD12', '\uD83E\uDD15', '😴', '💤', '💩', '😈', '👿', '👹', '👺', '👻', '💀', '☠', '👽', '👾', '\uD83E\uDD16', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾', '🙌', '👏', '👍', '👎', '👊', '✊', '👋', '👈', '👉', '👆', '👇', '👌', '☝', '✌', '✋', '🖐', '👐', '💪', '🙏', '🖖', '\uD83E\uDD18', '🖕', '✍', '💅', '👄', '👅', '👂', '👃', '👁', '👀', '🗣', '👤', '👥', '👶', '👦', '👧', '👨', '👩', '👱', '👴', '👵', '👲', '👳', '👮', '👷', '💂', '🎅', '👸', '👰', '👼', '🙇', '💁', '🙅', '🙆', '🙋', '🙎', '🙍', '💇', '💆', '💃', '👯', '🚶', '🏃', '👫', '👭', '👬', '💑', '👩\u200D❤\u200D👩', '👨\u200D❤\u200D👨', '💏', '👩\u200D❤\u200D💋\u200D👩', '👨\u200D❤\u200D💋\u200D👨', '👪', '👨\u200D👩\u200D👧', '👨\u200D👩\u200D👧\u200D👦', '👨\u200D👩\u200D👦\u200D👦', '👨\u200D👩\u200D👧\u200D👧', '👩\u200D👩\u200D👦', '👩\u200D👩\u200D👧', '👩\u200D👩\u200D👧\u200D👦', '👩\u200D👩\u200D👦\u200D👦', '👩\u200D👩\u200D👧\u200D👧', '👨\u200D👨\u200D👦', '👨\u200D👨\u200D👧', '👨\u200D👨\u200D👧\u200D👦', '👨\u200D👨\u200D👦\u200D👦', '👨\u200D👨\u200D👧\u200D👧', '👚', '👕', '👖', '👔', '👗', '👙', '👘', '💄', '💋', '👣', '👠', '👡', '👢', '👞', '👟', '👒', '🎩', '🎓', '👑', '⛑', '🎒', '👝', '👛', '👜', '💼', '👓', '🕶', '💍', '🌂']);
		case 1:
			return _List_fromArray(
				['🐶', '🐱', '🐭', '🐹', '🐰', '🐻', '🐼', '🐨', '🐯', '\uD83E\uDD81', '🐮', '🐷', '🐽', '🐸', '🐙', '🐵', '🙈', '🙉', '🙊', '🐒', '🐔', '🐧', '🐦', '🐤', '🐣', '🐥', '🐺', '🐗', '🐴', '\uD83E\uDD84', '🐝', '🐛', '🐌', '🐞', '🐜', '🕷', '\uD83E\uDD82', '\uD83E\uDD80', '🐍', '🐢', '🐠', '🐟', '🐡', '🐬', '🐳', '🐋', '🐊', '🐆', '🐅', '🐃', '🐂', '🐄', '🐪', '🐫', '🐘', '🐐', '🐏', '🐑', '🐎', '🐖', '🐀', '🐁', '🐓', '\uD83E\uDD83', '🕊', '🐕', '🐩', '🐈', '🐇', '🐿', '🐾', '🐉', '🐲', '🌵', '🎄', '🌲', '🌳', '🌴', '🌱', '🌿', '☘', '🍀', '🎍', '🎋', '🍃', '🍂', '🍁', '🌾', '🌺', '🌻', '🌹', '🌷', '🌼', '🌸', '💐', '🍄', '🌰', '🎃', '🐚', '🕸', '🌎', '🌍', '🌏', '🌕', '🌖', '🌗', '🌘', '🌑', '🌒', '🌓', '🌔', '🌚', '🌝', '🌛', '🌜', '🌞', '🌙', '⭐', '🌟', '💫', '✨', '☄', '☀', '🌤', '⛅', '🌥', '🌦', '☁', '🌧', '⛈', '🌩', '⚡', '🔥', '💥', '❄', '🌨', '☃', '⛄', '🌬', '💨', '🌪', '🌫', '☂', '☔', '💧', '💦', '🌊']);
		case 4:
			return _List_fromArray(
				['🚗', '🚕', '🚙', '🚌', '🚎', '🏎', '🚓', '🚑', '🚒', '🚐', '🚚', '🚛', '🚜', '🏍', '🚲', '🚨', '🚔', '🚍', '🚘', '🚖', '🚡', '🚠', '🚟', '🚃', '🚋', '🚝', '🚄', '🚅', '🚈', '🚞', '🚂', '🚆', '🚇', '🚊', '🚉', '🚁', '🛩', '✈', '🛫', '🛬', '⛵', '🛥', '🚤', '⛴', '🛳', '🚀', '🛰', '💺', '⚓', '🚧', '⛽', '🚏', '🚦', '🚥', '🗺', '🚢', '🎡', '🎢', '🎠', '🏗', '🌁', '🗼', '🏭', '⛲', '🎑', '⛰', '🏔', '🗻', '🌋', '🗾', '🏕', '⛺', '🏞', '🛣', '🛤', '🌅', '🌄', '🏜', '🏖', '🏝', '🌇', '🌆', '🏙', '🌃', '🌉', '🌌', '🌠', '🎇', '🎆', '🌈', '🏘', '🏰', '🏯', '🏟', '🗽', '🏠', '🏡', '🏚', '🏢', '🏬', '🏣', '🏤', '🏥', '🏦', '🏨', '🏪', '🏫', '🏩', '💒', '🏛', '⛪', '\uD83D\uDD4C', '\uD83D\uDD4D', '\uD83D\uDD4B', '⛩']);
		case 6:
			return _List_fromArray(
				['❤', '💛', '💚', '💙', '💜', '💔', '❣', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '☮', '✝', '☪', '🕉', '☸', '✡', '🔯', '\uD83D\uDD4E', '☯', '☦', '\uD83D\uDED0', '⛎', '♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑', '♒', '♓', '🆔', '⚛', '🈳', '🈹', '☢', '☣', '📴', '📳', '🈶', '🈚', '🈸', '🈺', '🈷', '✴', '🆚', '🉑', '💮', '🉐', '㊙', '㊗', '🈴', '🈵', '🈲', '🅰', '🅱', '🆎', '🆑', '🅾', '🆘', '⛔', '📛', '🚫', '❌', '⭕', '💢', '♨', '🚷', '🚯', '🚳', '🚱', '🔞', '📵', '❗', '❕', '❓', '❔', '‼', '⁉', '💯', '🔅', '🔆', '🔱', '⚜', '〽', '⚠', '🚸', '🔰', '♻', '🈯', '💹', '❇', '✳', '❎', '✅', '🌐', 'Ⓜ', '💠', '🌀', '➿', '🏧', '🈂', '🛂', '🛃', '🛄', '🛅', '♿', '🚭', '🚾', '🅿', '🚰', '🚹', '🚺', '🚼', '🚻', '🚮', '🎦', '📶', '🈁', '🔤', '🔡', '🔠', '🔣', 'ℹ', '🆖', '🆗', '🆙', '🆒', '🆕', '🆓', '0️', '1️', '2️', '3️', '4️', '5️', '6️', '7️', '8️', '9️', '🔟', '🔢', '#️', '*️', '▶', '⏸', '⏯', '⏹', '⏺', '⏭', '⏮', '⏩', '⏪', '⏫', '⏬', '◀', '🔼', '🔽', '➡', '⬅', '⬆', '⬇', '↗', '↘', '↙', '↖', '↕', '↔', '↪', '↩', '⤴', '⤵', '🔀', '🔁', '🔂', '🔄', '🔃', '🎵', '🎶', '〰', '➰', '✔', '➕', '➖', '➗', '✖', '💲', '💱', '™', '©', '®', '🔚', '🔙', '🔛', '🔝', '🔜', '☑', '🔘', '⚪', '⚫', '🔴', '🔵', '🔺', '🔻', '🔸', '🔹', '🔶', '🔷', '🔳', '🔲', '▪', '▫', '◾', '◽', '◼', '◻', '⬛', '⬜', '🔇', '🔈', '🔉', '🔊', '🔕', '🔔', '📣', '📢', '👁\u200D🗨', '💬', '💭', '🗯', '🃏', '🀄', '🎴', '♠', '♣', '♥', '♦', '🕐', '🕑', '🕒', '🕓', '🕔', '🕕', '🕖', '🕗', '🕘', '🕙', '🕚', '🕛', '🕜', '🕝', '🕞', '🕟', '🕠', '🕡', '🕢', '🕣', '🕤', '🕥', '🕦', '🕧']);
		case 2:
			return _List_fromArray(
				['🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍈', '🍒', '🍑', '🍍', '🍅', '🍆', '🌶', '🌽', '🍠', '🍯', '🍞', '\uD83E\uDDC0', '🍗', '🍖', '🍤', '🍳', '🍔', '🍟', '\uD83C\uDF2D', '🍕', '🍝', '\uD83C\uDF2E', '\uD83C\uDF2F', '🍜', '🍲', '🍥', '🍣', '🍱', '🍛', '🍙', '🍚', '🍘', '🍢', '🍡', '🍧', '🍨', '🍦', '🍰', '🎂', '🍮', '🍬', '🍭', '🍫', '\uD83C\uDF7F', '🍩', '🍪', '🍺', '🍻', '🍷', '🍸', '🍹', '\uD83C\uDF7E', '🍶', '🍵', '☕', '🍼', '🍴', '🍽']);
		case 5:
			return _List_fromArray(
				['⌚', '📱', '📲', '💻', '⌨', '🖥', '🖨', '🖱', '🖲', '🕹', '🗜', '💽', '💾', '💿', '📀', '📼', '📷', '📸', '📹', '🎥', '📽', '🎞', '📞', '☎', '📟', '📠', '📺', '📻', '🎙', '🎚', '🎛', '⏱', '⏲', '⏰', '🕰', '⏳', '⌛', '📡', '🔋', '🔌', '💡', '🔦', '🕯', '🗑', '🛢', '💸', '💵', '💴', '💶', '💷', '💰', '💳', '💎', '⚖', '🔧', '🔨', '⚒', '🛠', '⛏', '🔩', '⚙', '⛓', '🔫', '💣', '🔪', '🗡', '⚔', '🛡', '🚬', '⚰', '⚱', '\uD83C\uDFFA', '🔮', '\uD83D\uDCFF', '💈', '⚗', '🔭', '🔬', '🕳', '💊', '💉', '🌡', '🚽', '🚿', '🛁', '🛎', '🔑', '🗝', '🚪', '🛋', '🛌', '🛏', '🖼', '⛱', '🗿', '🛍', '🎁', '🎈', '🎏', '🎀', '🎊', '🎉', '🎐', '🏮', '🎎', '✉', '📩', '📨', '📧', '💌', '📥', '📤', '📦', '🏷', '🔖', '📪', '📫', '📬', '📭', '📮', '📯', '📜', '📃', '📄', '📑', '📊', '📈', '📉', '🗒', '🗓', '📆', '📅', '📇', '🗃', '🗳', '🗄', '📋', '📁', '📂', '🗂', '🗞', '📰', '📓', '📔', '📒', '📕', '📗', '📘', '📙', '📚', '📖', '🔗', '📎', '🖇', '📐', '📏', '✂', '📌', '📍', '🚩', '🎌', '🏴', '🏁', '🖌', '🖍', '🖊', '🖋', '✒', '📝', '✏', '🔏', '🔐', '🔒', '🔓', '🔍', '🔎']);
		default:
			return _List_fromArray(
				['⚽', '🏀', '🏈', '⚾', '🎾', '\uD83C\uDFD0', '🏉', '🎱', '\uD83C\uDFD3', '\uD83C\uDFF8', '\uD83C\uDFD2', '\uD83C\uDFD1', '\uD83C\uDFCF', '\uD83C\uDFF9', '⛳', '🎣', '⛸', '🎿', '⛷', '🏂', '🏄', '🏊', '🚣', '🏇', '🚴', '🚵', '🛀', '🕴', '🎗', '🎽', '🏅', '🎖', '🏆', '🏵', '🎯', '🎫', '🎟', '🎭', '🎨', '🎪', '🎬', '🎤', '🎧', '🎼', '🎹', '🎷', '🎺', '🎸', '🎻', '🎮', '🎰', '🎲', '🎳']);
	}
};
var $author$project$Page$Chat$Emoji$emojis = F2(
	function (partnerID, state) {
		if (state.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap($author$project$Page$Chat$Emoji$styles.f1, $author$project$Page$Chat$Emoji$styles.g_))
					]),
				_List_fromArray(
					[
						$author$project$Page$Chat$Emoji$categoryMenu,
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles.du)
							]),
						_List_Nil)
					]));
		} else {
			var category = state.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap($author$project$Page$Chat$Emoji$styles.f1, $author$project$Page$Chat$Emoji$styles.i0))
					]),
				_List_fromArray(
					[
						$author$project$Page$Chat$Emoji$categoryMenu,
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles.du)
							]),
						A2(
							$elm$core$List$map,
							$author$project$Page$Chat$Emoji$displayEmoji(partnerID),
							$author$project$Data$Emoji$get(category)))
					]));
		}
	});
var $author$project$Page$Chat$Input$keyCodeAndShiftDecoder = A3(
	$elm$json$Json$Decode$map2,
	function (keyCode) {
		return function (shiftKey) {
			return {hm: keyCode, i$: shiftKey};
		};
	},
	A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $author$project$Page$Chat$Input$onEnter = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keyup',
		A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var keyCode = _v0.hm;
				var shiftKey = _v0.i$;
				return ((keyCode === 13) && (!shiftKey)) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail(
					$elm$core$String$fromInt(keyCode));
			},
			$author$project$Page$Chat$Input$keyCodeAndShiftDecoder));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$rows = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $rtfeldman$elm_css$Css$resize = $rtfeldman$elm_css$Css$prop1('resize');
var $author$project$Page$Chat$Input$styles = {
	fA: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(24))
		]),
	fB: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(1))
		]),
	f1: function (_v0) {
		var screenWidth = _v0.nj;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(60)),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
				A3(
				$rtfeldman$elm_css$Css$borderTop3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				$author$project$View$Theme$colors.gN),
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
				$rtfeldman$elm_css$Css$zIndex(
				$rtfeldman$elm_css$Css$int(2)),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(screenWidth))
					]))
			]);
	},
	lP: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$flexGrow(
				$rtfeldman$elm_css$Css$num(2)),
				$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
				$rtfeldman$elm_css$Css$resize($rtfeldman$elm_css$Css$none),
				$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$px(14),
						$rtfeldman$elm_css$Css$px(10))
					]))
			])),
	iV: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(36)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(36)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50))
		]),
	iW: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(36)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(36)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	iX: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(36)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(36)),
			$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
			A3($rtfeldman$elm_css$Css$border3, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$solid, $rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(2))
		])
};
var $author$project$Type$Chat$CloseEmoji = {$: 11};
var $author$project$Type$Chat$OpenEmoji = {$: 10};
var $author$project$Page$Chat$Emoji$toggle = function (state) {
	if (state.$ === 1) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles.eV),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnChat($author$project$Type$Chat$OpenEmoji)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.nu),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles.eW)
						]),
					_List_Nil)
				]));
	} else {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles.eV),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnChat($author$project$Type$Chat$CloseEmoji)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.j0),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Emoji$styles.eW)
						]),
					_List_Nil)
				]));
	}
};
var $author$project$Type$Chat$OnWebSelectedImage = F4(
	function (a, b, c, d) {
		return {$: 14, a: a, b: b, c: c, d: d};
	});
var $author$project$Type$Chat$StartCameraOnMobile = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$Chat$UploadImage$styles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(2)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	cA: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(20))
		]),
	lP: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
		])
};
var $author$project$Page$Chat$UploadImage$view = F3(
	function (device, userProfile, room) {
		var partnerID = room.q.eX;
		var fieldName = 'ChatImage-' + partnerID;
		return $author$project$NativeBridge$isMobileApp(device) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$UploadImage$styles.f1),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnChat(
							$author$project$Type$Chat$StartCameraOnMobile(partnerID))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.fa),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$UploadImage$styles.cA)
						]),
					_List_Nil)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$UploadImage$styles.f1),
					$rtfeldman$elm_css$Html$Styled$Attributes$for(fieldName)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.fa),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$UploadImage$styles.cA)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('file'),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$UploadImage$styles.lP),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(fieldName),
							A2(
							$rtfeldman$elm_css$Html$Styled$Events$on,
							'change',
							$elm$json$Json$Decode$succeed(
								$author$project$Types$WithCurrentTime(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
										A3($author$project$Type$Chat$OnWebSelectedImage, userProfile, room, fieldName)))))
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Chat$Input$renderInput = F6(
	function (dimension, device, emojiState, userProfile, room, inputValue) {
		var sendMessageMsg = $author$project$Types$WithCurrentTime(
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
				A3($author$project$Type$Chat$SendTextMessage, userProfile, room, inputValue)));
		var buttonView = $author$project$NativeBridge$isDesktop(device) ? A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$View$Theme$defaultStyles.ci, $author$project$Page$Chat$Input$styles.iV)),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(sendMessageMsg)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.iU),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Input$styles.fA)
						]),
					_List_Nil)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$View$Theme$defaultStyles.ci, $author$project$Page$Chat$Input$styles.iW))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Input$styles.iX),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(sendMessageMsg)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.iU),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Input$styles.fB)
						]),
					_List_Nil)
				]));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					$author$project$Page$Chat$Input$styles.f1(dimension))
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Chat$Emoji$emojis, room.q.eX, emojiState),
					$author$project$Page$Chat$Emoji$toggle(emojiState),
					A3($author$project$Page$Chat$UploadImage$view, device, userProfile, room),
					A2(
					$rtfeldman$elm_css$Html$Styled$textarea,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Model$Chat$pageChatInputID),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
								$author$project$Type$Chat$WriteMessage(room.q.eX))),
							$author$project$Page$Chat$Input$onEnter(sendMessageMsg),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(inputValue),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Input$styles.lP),
							$rtfeldman$elm_css$Html$Styled$Attributes$placeholder('Type your message here'),
							$rtfeldman$elm_css$Html$Styled$Attributes$rows(1)
						]),
					_List_Nil),
					buttonView
				]));
	});
var $author$project$Page$Chat$Input$view = F7(
	function (userHasLowerLevelThanSugar, dimension, device, emojiState, userProfile, room, inputValue) {
		return userHasLowerLevelThanSugar ? $rtfeldman$elm_css$Html$Styled$text('') : A6($author$project$Page$Chat$Input$renderInput, dimension, device, emojiState, userProfile, room, inputValue);
	});
var $author$project$Type$Chat$OnMessageDivClicked = {$: 4};
var $author$project$Type$Chat$OnMessageScroll = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Data$Scroll$Coordinate = F3(
	function (scrollTop, scrollHeight, clientHeight) {
		return {dp: clientHeight, eG: scrollHeight, bT: scrollTop};
	});
var $author$project$Data$Scroll$Position = $elm$core$Basics$identity;
var $author$project$Data$Scroll$decodeEvent = function (tagger) {
	return A2(
		$elm$json$Json$Decode$map,
		A2($elm$core$Basics$composeL, tagger, $elm$core$Basics$identity),
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Data$Scroll$Coordinate,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'scrollTop']),
				$elm$json$Json$Decode$float),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'scrollHeight']),
				$elm$json$Json$Decode$float),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'clientHeight']),
				$elm$json$Json$Decode$float)));
};
var $ryannhg$date_format$DateFormat$DayOfMonthSuffix = {$: 6};
var $ryannhg$date_format$DateFormat$dayOfMonthSuffix = $ryannhg$date_format$DateFormat$DayOfMonthSuffix;
var $ryannhg$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryannhg$date_format$DateFormat$monthNameAbbreviated = $ryannhg$date_format$DateFormat$MonthNameAbbreviated;
var $ryannhg$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryannhg$date_format$DateFormat$text = $ryannhg$date_format$DateFormat$Text;
var $author$project$Page$Chat$Message$dateFormat = _List_fromArray(
	[
		$ryannhg$date_format$DateFormat$monthNameAbbreviated,
		$ryannhg$date_format$DateFormat$text(' '),
		$ryannhg$date_format$DateFormat$dayOfMonthSuffix,
		$ryannhg$date_format$DateFormat$text(', '),
		$ryannhg$date_format$DateFormat$yearNumber
	]);
var $author$project$Page$Chat$Message$isSameDay = F2(
	function (t1, t2) {
		return _Utils_eq(
			A2($elm$time$Time$toYear, $elm$time$Time$utc, t1),
			A2($elm$time$Time$toYear, $elm$time$Time$utc, t2)) && (_Utils_eq(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, t1),
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, t2)) && _Utils_eq(
			A2($elm$time$Time$toDay, $elm$time$Time$utc, t1),
			A2($elm$time$Time$toDay, $elm$time$Time$utc, t2)));
	});
var $rtfeldman$elm_css$Css$borderRadius4 = $rtfeldman$elm_css$Css$prop4('border-radius');
var $author$project$Page$Chat$Message$styles = {
	f1: function (_v0) {
		var screenWidth = _v0.nj;
		var screenHeight = _v0.ni;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
				$rtfeldman$elm_css$Css$zIndex(
				$rtfeldman$elm_css$Css$int(1)),
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(((screenHeight - 60) - 60) - 65)),
				$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto),
				$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(screenWidth))
					]))
			]);
	},
	dF: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(300)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(300)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$backgroundImage(
			$rtfeldman$elm_css$Css$url($author$project$View$Theme$images.hv)),
			$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
			$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$minWidth(
					$rtfeldman$elm_css$Css$px(250)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(200))
				]))
		]),
	dH: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
			$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover)
		]),
	cW: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A4(
				$rtfeldman$elm_css$Css$padding4,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(15),
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$minWidth(
				$rtfeldman$elm_css$Css$px(50)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				$author$project$View$Theme$colors.gO),
				A4(
				$rtfeldman$elm_css$Css$borderRadius4,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(15),
				$rtfeldman$elm_css$Css$px(15),
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left)
			])),
	cY: {
		fC: _Utils_ap(
			$author$project$View$Theme$defaultStyles.ci,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$px(10)),
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(6),
					$rtfeldman$elm_css$Css$px(14)),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.ly)
				])),
		fF: _Utils_ap(
			$author$project$View$Theme$defaultStyles.ci,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(6),
					$rtfeldman$elm_css$Css$px(14))
				])),
		f1: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$paddingTop(
				$rtfeldman$elm_css$Css$px(5)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100))
			])
	},
	eQ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO)
			])),
	eZ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A4(
				$rtfeldman$elm_css$Css$padding4,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(15),
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh),
				A4(
				$rtfeldman$elm_css$Css$borderRadius4,
				$rtfeldman$elm_css$Css$px(15),
				$rtfeldman$elm_css$Css$px(15),
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og)
			])),
	e_: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(50)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.m8),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(90))
					]))
			]))
};
var $author$project$Page$Chat$Message$renderInfoBlock = F2(
	function (key, content) {
		return _Utils_Tuple2(
			key,
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$margin(
								$rtfeldman$elm_css$Css$px(10)),
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Message$styles.eQ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(content)
							]))
					])));
	});
var $rtfeldman$elm_css$Css$flexShrink = $rtfeldman$elm_css$Css$prop1('flex-shrink');
var $author$project$Page$Chat$Message$isImageLocalFile = function (url) {
	return $elm$core$String$isEmpty(url) || (A2($elm$core$String$startsWith, 'blob:', url) || A2($elm$core$String$startsWith, 'data:', url));
};
var $author$project$Page$Chat$Message$showLoadingIfImageIsLocalFile = function (url) {
	return $author$project$Page$Chat$Message$isImageLocalFile(url) ? A2(
		$rtfeldman$elm_css$Html$Styled$img,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv)
			]),
		_List_Nil) : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Page$Chat$Message$renderImageMessage = function (_v0) {
	var sender = _v0.iY;
	var content = _v0.cl;
	if (sender === 1) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$Page$Chat$Message$styles.dF,
						_List_fromArray(
							[
								A3(
								$rtfeldman$elm_css$Css$border3,
								$rtfeldman$elm_css$Css$px(1),
								$rtfeldman$elm_css$Css$solid,
								$author$project$View$Theme$colors.eh),
								A4(
								$rtfeldman$elm_css$Css$borderRadius4,
								$rtfeldman$elm_css$Css$px(15),
								$rtfeldman$elm_css$Css$px(15),
								$rtfeldman$elm_css$Css$zero,
								$rtfeldman$elm_css$Css$px(15))
							]))),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A3(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
						$author$project$Type$Chat$Popup,
						A2(
							$author$project$PopupPhoto$openGalleryMsg,
							_List_fromArray(
								[content]),
							0)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap(
								$author$project$Page$Chat$Message$styles.dH,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$backgroundImage(
										$rtfeldman$elm_css$Css$url(content)),
										A4(
										$rtfeldman$elm_css$Css$borderRadius4,
										$rtfeldman$elm_css$Css$px(15),
										$rtfeldman$elm_css$Css$px(15),
										$rtfeldman$elm_css$Css$zero,
										$rtfeldman$elm_css$Css$px(15))
									])))
						]),
					_List_fromArray(
						[
							$author$project$Page$Chat$Message$showLoadingIfImageIsLocalFile(content)
						]))
				]));
	} else {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$Page$Chat$Message$styles.dF,
						_List_fromArray(
							[
								A3(
								$rtfeldman$elm_css$Css$border3,
								$rtfeldman$elm_css$Css$px(1),
								$rtfeldman$elm_css$Css$solid,
								$author$project$View$Theme$colors.gO),
								A4(
								$rtfeldman$elm_css$Css$borderRadius4,
								$rtfeldman$elm_css$Css$zero,
								$rtfeldman$elm_css$Css$px(15),
								$rtfeldman$elm_css$Css$px(15),
								$rtfeldman$elm_css$Css$px(15))
							]))),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A3(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
						$author$project$Type$Chat$Popup,
						A2(
							$author$project$PopupPhoto$openGalleryMsg,
							_List_fromArray(
								[content]),
							0)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap(
								$author$project$Page$Chat$Message$styles.dH,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$backgroundImage(
										$rtfeldman$elm_css$Css$url(content)),
										A4(
										$rtfeldman$elm_css$Css$borderRadius4,
										$rtfeldman$elm_css$Css$zero,
										$rtfeldman$elm_css$Css$px(15),
										$rtfeldman$elm_css$Css$px(15),
										$rtfeldman$elm_css$Css$px(15))
									])))
						]),
					_List_Nil)
				]));
	}
};
var $author$project$Type$Chat$AcceptPrivatePhotoRequest = F3(
	function (a, b, c) {
		return {$: 19, a: a, b: b, c: c};
	});
var $author$project$Type$Chat$RejectPrivatePhotoRequest = F3(
	function (a, b, c) {
		return {$: 20, a: a, b: b, c: c};
	});
var $author$project$Page$Chat$Message$renderPrivatePhotoRequest = F3(
	function (userProfile, room, _v0) {
		var sender = _v0.iY;
		var rejectMsg = $author$project$Types$WithCurrentTime(
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
				A2($author$project$Type$Chat$RejectPrivatePhotoRequest, userProfile, room)));
		var content = 'May I have permission to view your Private Photos?';
		var acceptMsg = $author$project$Types$WithCurrentTime(
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
				A2($author$project$Type$Chat$AcceptPrivatePhotoRequest, userProfile, room)));
		if (sender === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Message$styles.eZ)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(content)
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Message$styles.cW)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(content),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Message$styles.cY.f1)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Message$styles.cY.fF),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(acceptMsg)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Accept')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Message$styles.cY.fC),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(rejectMsg)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Cancel')
									]))
							]))
					]));
		}
	});
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Page$Chat$Message$wordToLinkOrText = function (word) {
	var isHyperLink = function (str) {
		return A2($elm$core$String$contains, '.', str) && ((!A2($elm$core$String$startsWith, '.', str)) && (!A2($elm$core$String$endsWith, '.', str)));
	};
	var addHttpProtocol = function (str) {
		return A2($elm$core$String$startsWith, 'http', str) ? str : ('http://' + word);
	};
	return isHyperLink(word) ? A2(
		$rtfeldman$elm_css$Html$Styled$a,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href(
				addHttpProtocol(word)),
				$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(word)
			])) : $rtfeldman$elm_css$Html$Styled$text(word);
};
var $author$project$Page$Chat$Message$lineToLinkOrText = function (line) {
	return A2(
		$elm$core$List$intersperse,
		$rtfeldman$elm_css$Html$Styled$text(' '),
		A2(
			$elm$core$List$map,
			$author$project$Page$Chat$Message$wordToLinkOrText,
			$elm$core$String$words(line)));
};
var $author$project$Page$Chat$Message$formatMessage = function (content) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$intersperse,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Page$Chat$Message$lineToLinkOrText,
				$elm$core$String$lines(content))));
};
var $author$project$Page$Chat$Message$renderTextMessage = function (_v0) {
	var sender = _v0.iY;
	var content = _v0.cl;
	if (sender === 1) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Message$styles.eZ)
				]),
			$author$project$Page$Chat$Message$formatMessage(content));
	} else {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Message$styles.cW)
				]),
			$author$project$Page$Chat$Message$formatMessage(content));
	}
};
var $author$project$Page$Chat$Message$renderMessageContent = F3(
	function (userProfile, room, message) {
		var _v0 = message.ho;
		switch (_v0) {
			case 0:
				return $author$project$Page$Chat$Message$renderTextMessage(message);
			case 1:
				return $author$project$Page$Chat$Message$renderImageMessage(message);
			default:
				return A3($author$project$Page$Chat$Message$renderPrivatePhotoRequest, userProfile, room, message);
		}
	});
var $author$project$Page$Chat$Message$renderPartnerAvatar = function (url) {
	var avatarUrl = $elm$core$String$isEmpty(url) ? $author$project$View$Theme$images.k0 : url;
	return A2(
		$rtfeldman$elm_css$Html$Styled$img,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$src(avatarUrl),
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$num(0)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(30)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(30)),
						$rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$px(10)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$pct(50))
					]))
			]),
		_List_Nil);
};
var $author$project$Page$Chat$Message$readStatus = F4(
	function (content, messageKind, messageCreatedAt, partnerLastRead) {
		return ((messageKind === 1) && $author$project$Page$Chat$Message$isImageLocalFile(content)) ? 'Uploading' : ((_Utils_cmp(
			$elm$time$Time$posixToMillis(partnerLastRead),
			$elm$time$Time$posixToMillis(messageCreatedAt)) > -1) ? 'R' : 'S');
	});
var $rtfeldman$elm_css$Css$textShadow4 = $rtfeldman$elm_css$Css$prop4('text-shadow');
var $ryannhg$date_format$DateFormat$AmPmUppercase = {$: 22};
var $ryannhg$date_format$DateFormat$amPmUppercase = $ryannhg$date_format$DateFormat$AmPmUppercase;
var $ryannhg$date_format$DateFormat$HourNumber = {$: 26};
var $ryannhg$date_format$DateFormat$hourNumber = $ryannhg$date_format$DateFormat$HourNumber;
var $author$project$Page$Chat$Message$timeFormat = _List_fromArray(
	[
		$ryannhg$date_format$DateFormat$hourNumber,
		$ryannhg$date_format$DateFormat$text(':'),
		$ryannhg$date_format$DateFormat$minuteFixed,
		$ryannhg$date_format$DateFormat$text(' '),
		$ryannhg$date_format$DateFormat$amPmUppercase
	]);
var $author$project$Page$Chat$Message$renderStatus = F3(
	function (partnerLastRead, timezone, _v0) {
		var content = _v0.cl;
		var kind = _v0.ho;
		var sender = _v0.iY;
		var createdAt = _v0.cm;
		if (sender === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
								$rtfeldman$elm_css$Css$bottom(
								$rtfeldman$elm_css$Css$px(13)),
								$rtfeldman$elm_css$Css$right(
								$rtfeldman$elm_css$Css$px(10)),
								$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
								$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.i2),
								$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
								A2(
								$author$project$View$Theme$applyStyleIf,
								kind === 1,
								_List_fromArray(
									[
										A4(
										$rtfeldman$elm_css$Css$textShadow4,
										$rtfeldman$elm_css$Css$px(1),
										$rtfeldman$elm_css$Css$px(1),
										$rtfeldman$elm_css$Css$px(3),
										$author$project$View$Theme$colors.fs)
									]))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A3($ryannhg$date_format$DateFormat$format, $author$project$Page$Chat$Message$timeFormat, timezone, createdAt)),
						$rtfeldman$elm_css$Html$Styled$text(' - '),
						$rtfeldman$elm_css$Html$Styled$text(
						A4($author$project$Page$Chat$Message$readStatus, content, kind, createdAt, partnerLastRead))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							$author$project$View$Theme$defaultStyles.kd,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$flexEnd),
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
									$rtfeldman$elm_css$Css$bottom(
									$rtfeldman$elm_css$Css$px(2)),
									$rtfeldman$elm_css$Css$right(
									$rtfeldman$elm_css$Css$px(50)),
									$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
									$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.i2),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
									A2(
									$author$project$View$Theme$applyStyleIf,
									kind === 1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
											A4(
											$rtfeldman$elm_css$Css$textShadow4,
											$rtfeldman$elm_css$Css$px(1),
											$rtfeldman$elm_css$Css$px(1),
											$rtfeldman$elm_css$Css$px(3),
											$author$project$View$Theme$colors.fs)
										]))
								])))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A3($ryannhg$date_format$DateFormat$format, $author$project$Page$Chat$Message$timeFormat, timezone, createdAt))
					]));
		}
	});
var $author$project$Page$Chat$Message$renderUpgradeMessage = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Message$styles.cW)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l9),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$View$Theme$defaultStyles.ht,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA)
							])))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Upgrade to view message')
				]))
		]));
var $author$project$Page$Chat$Message$renderPartnerMessage = F2(
	function (_v0, message) {
		var userHasLowerLevelThanSugar = _v0.b2;
		var userProfile = _v0.oa;
		var room = _v0.a;
		var timezone = _v0.jp;
		var divContainer = $rtfeldman$elm_css$Html$Styled$div(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexShrink(
							$rtfeldman$elm_css$Css$num(0)),
							$rtfeldman$elm_css$Css$margin(
							$rtfeldman$elm_css$Css$px(10)),
							$rtfeldman$elm_css$Css$maxWidth(
							$rtfeldman$elm_css$Css$pct(90))
						]))
				]));
		return userHasLowerLevelThanSugar ? divContainer(
			_List_fromArray(
				[
					$author$project$Page$Chat$Message$renderPartnerAvatar(room.q.cc),
					$author$project$Page$Chat$Message$renderUpgradeMessage
				])) : divContainer(
			_List_fromArray(
				[
					$author$project$Page$Chat$Message$renderPartnerAvatar(room.q.cc),
					A3($author$project$Page$Chat$Message$renderMessageContent, userProfile, room, message),
					A3($author$project$Page$Chat$Message$renderStatus, room.q.aV, timezone, message)
				]));
	});
var $author$project$Page$Chat$Message$renderUserMessage = F2(
	function (_v0, message) {
		var userProfile = _v0.oa;
		var room = _v0.a;
		var timezone = _v0.jp;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$flexEnd),
							$rtfeldman$elm_css$Css$margin(
							$rtfeldman$elm_css$Css$px(10)),
							$rtfeldman$elm_css$Css$minWidth(
							$rtfeldman$elm_css$Css$px(80)),
							$rtfeldman$elm_css$Css$maxWidth(
							$rtfeldman$elm_css$Css$pct(90)),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$Page$Chat$Message$renderMessageContent, userProfile, room, message),
					A3($author$project$Page$Chat$Message$renderStatus, room.q.aV, timezone, message)
				]));
	});
var $author$project$Page$Chat$Message$renderMessage = F2(
	function (context, message) {
		var _v0 = message.iY;
		if (_v0 === 1) {
			return _Utils_Tuple2(
				message.lK,
				A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Page$Chat$Message$renderUserMessage, context, message));
		} else {
			return _Utils_Tuple2(
				message.lK,
				A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Page$Chat$Message$renderPartnerMessage, context, message));
		}
	});
var $author$project$Page$Chat$Message$renderMessagesWithTime = F2(
	function (context, messages) {
		if (messages.b) {
			if (messages.b.b) {
				var current = messages.a;
				var _v1 = messages.b;
				var next = _v1.a;
				var rest = _v1.b;
				return A2($author$project$Page$Chat$Message$isSameDay, current.cm, next.cm) ? A2(
					$elm$core$List$cons,
					A2($author$project$Page$Chat$Message$renderMessage, context, current),
					A2(
						$author$project$Page$Chat$Message$renderMessagesWithTime,
						context,
						A2($elm$core$List$cons, next, rest))) : A2(
					$elm$core$List$cons,
					A2($author$project$Page$Chat$Message$renderMessage, context, current),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Page$Chat$Message$renderInfoBlock,
							'ChatMessage-' + $elm$core$String$fromInt(
								$elm$time$Time$posixToMillis(next.cm)),
							A3($ryannhg$date_format$DateFormat$format, $author$project$Page$Chat$Message$dateFormat, context.jp, next.cm)),
						A2(
							$author$project$Page$Chat$Message$renderMessagesWithTime,
							context,
							A2($elm$core$List$cons, next, rest))));
			} else {
				var last = messages.a;
				return _List_fromArray(
					[
						A2($author$project$Page$Chat$Message$renderMessage, context, last)
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Page$Chat$Message$renderWarningMessages = _List_fromArray(
	[
		_Utils_Tuple2(
		'ChatMessage-FirstWarningKey',
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Message$styles.e_)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Keep ALL chats within the site. Do not share your contact details until you have met in person.')
				]))),
		_Utils_Tuple2(
		'ChatMessage-SecondWarningKey',
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Message$styles.e_)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Do not give your bank info or credit card details. Report any money scams or improper user behavior immediately using the \"Report user\" feature.')
				])))
	]);
var $author$project$Page$Chat$Message$renderTopOfScroll = function (loadStatus) {
	switch (loadStatus) {
		case 0:
			return _List_fromArray(
				[
					A2($author$project$Page$Chat$Message$renderInfoBlock, 'ChatMessage-Loading', 'Loading...')
				]);
		case 1:
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'ChatMessage-CanLoadMore',
					$rtfeldman$elm_css$Html$Styled$text(''))
				]);
		default:
			return $author$project$Page$Chat$Message$renderWarningMessages;
	}
};
var $author$project$Page$Chat$Message$view = function (_v0) {
	var userHasLowerLevelThanSugar = _v0.b2;
	var dimension = _v0.kR;
	var timezone = _v0.jp;
	var userProfile = _v0.oa;
	var loadStatus = _v0.T;
	var room = _v0.a;
	var messages = _v0.hF;
	var sortedMessages = A2(
		$elm$core$List$sortBy,
		A2(
			$elm$core$Basics$composeL,
			$elm$time$Time$posixToMillis,
			function ($) {
				return $.cm;
			}),
		messages);
	var context = {a: room, jp: timezone, b2: userHasLowerLevelThanSugar, oa: userProfile};
	return A3(
		$rtfeldman$elm_css$Html$Styled$Keyed$node,
		'div',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Model$Chat$pageChatMessageID),
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				$author$project$Page$Chat$Message$styles.f1(dimension)),
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$on,
				'scroll',
				$author$project$Data$Scroll$decodeEvent(
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
						$author$project$Type$Chat$OnMessageScroll(room.q.eX)))),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				A3($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat, $author$project$Type$Chat$OnMessageDivClicked))
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					$author$project$Page$Chat$Message$renderTopOfScroll(loadStatus),
					A2($author$project$Page$Chat$Message$renderMessagesWithTime, context, sortedMessages)
				])));
};
var $author$project$Page$Chat$Room$displayRoom = F2(
	function (_v0, room) {
		var dimension = _v0.kR;
		var device = _v0.kQ;
		var userProfile = _v0.oa;
		var timezone = _v0.jp;
		var model = _v0.mk;
		var _v1 = room;
		var partner = _v1.q;
		var isLowerSponsorLevel = A2($author$project$Page$Chat$Room$userHasLowerLevelThanSugar, userProfile, partner);
		var loadStatus = A2(
			$elm$core$Maybe$withDefault,
			1,
			A2($author$project$Data$Chat$getMessageLoadStatus, partner.eX, model.i8));
		var _v2 = model;
		var state = _v2.i8;
		var inputValue = _v2.ah;
		var openMenu = _v2.ee;
		var inputValue_ = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, partner.eX, inputValue));
		var partnerOnlineStatus = A2($author$project$Data$Chat$getPartnerOnlineStatus, partner.eX, state);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$Room$styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy,
					A2($author$project$Page$Chat$Header$view, openMenu, room),
					partnerOnlineStatus),
					A2(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy,
					$author$project$Page$Chat$Message$view,
					{
						kR: dimension,
						T: loadStatus,
						hF: A2($author$project$Data$Chat$listMessages, model.i8, partner.eX),
						a: room,
						jp: timezone,
						b2: isLowerSponsorLevel,
						oa: userProfile
					}),
					A7($author$project$Page$Chat$Input$view, isLowerSponsorLevel, dimension, device, model.Q, userProfile, room, inputValue_)
				]));
	});
var $author$project$Page$Chat$Room$view = function (params) {
	var currentRoom = $author$project$Data$Chat$getCurrentRoom(params.mk.i8);
	if (!currentRoom.$) {
		var room = currentRoom.a;
		return A2($author$project$Page$Chat$Room$displayRoom, params, room);
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Type$Chat$OnRoomScroll = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Chat$Room$getLoadStatus = function (state) {
	return state.T;
};
var $author$project$Data$Chat$getRoomLoadStatus = function (_v0) {
	var state = _v0;
	return $author$project$Data$Chat$Room$getLoadStatus(state.a);
};
var $rtfeldman$elm_css$Html$Styled$h2 = $rtfeldman$elm_css$Html$Styled$node('h2');
var $author$project$Data$Chat$listRooms = function (_v0) {
	var state = _v0;
	return $author$project$Data$Chat$Room$list(state.a);
};
var $author$project$Page$Chat$RoomsNav$renderLoadStatus = function (loadStatus) {
	switch (loadStatus.$) {
		case 0:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							$author$project$View$Theme$defaultStyles.kd,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$padding2,
									$rtfeldman$elm_css$Css$px(10),
									$rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
								])))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Loading...')
					]));
		case 1:
			return $rtfeldman$elm_css$Html$Styled$text('');
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $rtfeldman$elm_css$Css$flex = $rtfeldman$elm_css$Css$prop1('flex');
var $author$project$Page$Chat$RoomsNav$styles = {
	e5: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.lx)
		]),
	f1: function (_v0) {
		var screenHeight = _v0.ni;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(screenHeight - 65)),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(15),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
			]);
	},
	gT: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingLeft(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA)
			])),
	gZ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO)
		]),
	bx: function (hasUnreadMessages) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
				$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
				$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
				$rtfeldman$elm_css$Css$flex(
				$rtfeldman$elm_css$Css$num(1)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
				A2(
				$author$project$View$Theme$applyStyleIf,
				hasUnreadMessages,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA)
					]))
			]);
	},
	eF: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A2($rtfeldman$elm_css$Css$property, 'animation-duration', '0.2s')
		]),
	iL: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
				$rtfeldman$elm_css$Css$flex(
				$rtfeldman$elm_css$Css$num(1)),
				$rtfeldman$elm_css$Css$paddingLeft(
				$rtfeldman$elm_css$Css$px(10))
			])),
	dh: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		])
};
var $author$project$Page$Chat$RoomsNav$displayLastMessage = F2(
	function (userProfile, _v0) {
		var partner = _v0.q;
		var lastMessage = _v0.bx;
		var unreadCount = _v0.df;
		var userHasLowerSponsorLevel = A2($author$project$Core$Data$Profile$SponsorLevel$sponsorLevelGreaterThan, partner.bY, userProfile.bY);
		var hasUnreadMessages = unreadCount > 0;
		return ((!userProfile.eY) && userHasLowerSponsorLevel) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$RoomsNav$styles.gZ)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Upgrade to View')
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					$author$project$Page$Chat$RoomsNav$styles.bx(hasUnreadMessages))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(lastMessage)
				]));
	});
var $author$project$Page$Chat$RoomsNav$displayUnreadCount = function (unreadCount) {
	return (!unreadCount) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$px(5)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$px(15)),
						$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
						$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh),
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$pct(50)),
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$elm$core$String$fromInt(unreadCount))
			]));
};
var $author$project$Page$Chat$RoomsNav$roomItem = F3(
	function (currentRoom, userProfile, room) {
		var onClickMsg = $author$project$Types$OnAuth(
			$author$project$Types$OnChat(
				$author$project$Type$Chat$SetCurrentRoom(
					$elm$core$Maybe$Just(room))));
		var _v0 = room;
		var partner = _v0.q;
		var isRoomActive = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(partner.eX),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.q;
						},
						function ($) {
							return $.eX;
						}),
					currentRoom)));
		var containerCss = isRoomActive ? _Utils_ap($author$project$Page$Chat$RoomsNav$styles.eF, $author$project$Page$Chat$RoomsNav$styles.e5) : $author$project$Page$Chat$RoomsNav$styles.eF;
		return _Utils_Tuple2(
			'ChatRoomNav-' + room.q.eX,
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(room.q.eX),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(containerCss),
						$author$project$Animate$animate(20),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(onClickMsg)
					]),
				_List_fromArray(
					[
						$author$project$Page$Chat$RoomsNav$renderAvatar(partner),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$RoomsNav$styles.iL)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$RoomsNav$styles.dh)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(partner.dh)
									])),
								A2($author$project$Page$Chat$RoomsNav$displayLastMessage, userProfile, room)
							])),
						$author$project$Page$Chat$RoomsNav$displayUnreadCount(room.df)
					])));
	});
var $author$project$Page$Chat$RoomsNav$view = F3(
	function (dimension, userProfile, chatState) {
		var rooms = $elm$core$List$reverse(
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeL,
					$elm$time$Time$posixToMillis,
					function ($) {
						return $.ai;
					}),
				$author$project$Data$Chat$listRooms(chatState)));
		var currentRoom = $author$project$Data$Chat$getCurrentRoom(chatState);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					$author$project$Page$Chat$RoomsNav$styles.f1(dimension)),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$on,
					'scroll',
					$author$project$Data$Scroll$decodeEvent(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
							$author$project$Type$Chat$OnRoomScroll))),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'chatNav')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Chat$RoomsNav$styles.gT)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('MESSENGER')
						])),
					A3(
					$rtfeldman$elm_css$Html$Styled$Keyed$node,
					'div',
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Page$Chat$RoomsNav$roomItem, currentRoom, userProfile),
						rooms)),
					$author$project$Page$Chat$RoomsNav$renderLoadStatus(
					$author$project$Data$Chat$getRoomLoadStatus(chatState))
				]));
	});
var $author$project$Page$Chat$view = F2(
	function (appModel, authState) {
		var _v0 = appModel;
		var dimension = _v0.kR;
		var device = _v0.kQ;
		var timezone = _v0.jp;
		var _v1 = authState;
		var chat = _v1.km;
		var blockUserHtml = A2(
			$elm$core$Maybe$withDefault,
			$rtfeldman$elm_css$Html$Styled$text(''),
			A2($elm$core$Maybe$map, $author$project$Helpers$BlockUser$View$view, chat.ka));
		var hasCurrentRoom = !_Utils_eq(
			$author$project$Data$Chat$getCurrentRoom(chat.i8),
			$elm$core$Maybe$Nothing);
		var styles = A2($author$project$Page$Chat$calculateStyles, hasCurrentRoom, dimension);
		var reportUserHtml = A2(
			$elm$core$Maybe$withDefault,
			$rtfeldman$elm_css$Html$Styled$text(''),
			A2($elm$core$Maybe$map, $author$project$Helpers$ReportUser$View$view, chat.aA));
		var _v2 = authState.iu;
		if (!_v2.$) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var profile = _v2.a.iu;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.iM)
							]),
						_List_fromArray(
							[
								A3($author$project$Page$Chat$RoomsNav$view, dimension, profile, chat.i8)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.a)
							]),
						_List_fromArray(
							[
								$author$project$Page$Chat$Room$view(
								{kQ: device, kR: dimension, mk: chat, jp: timezone, oa: profile})
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
							$author$project$Type$Chat$Popup),
						$author$project$PopupPhoto$view(chat.bN)),
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
							$author$project$Type$Chat$Report),
						reportUserHtml),
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnChat),
							$author$project$Type$Chat$Block),
						blockUserHtml)
					]));
		}
	});
var $author$project$Page$ContactUs$styles = {
	fl: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(30))
		]),
	gX: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(550))
		]),
	ht: _Utils_ap(
		$author$project$View$Theme$defaultStyles.ht,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
			])),
	dd: _List_fromArray(
		[
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingTop(
					$rtfeldman$elm_css$Css$px(48))
				]))
		])
};
var $author$project$Page$ContactUs$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_Nil,
	_List_fromArray(
		[
			A5(
			$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
			$author$project$View$Hero$view,
			$author$project$View$Theme$images.jN.mj,
			$author$project$View$Theme$images.jN.j3,
			$author$project$Page$ContactUs$styles.gX,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ContactUs$styles.dd)
						]),
					_List_fromArray(
						[
							$author$project$View$Hero$title('Contact Us')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ContactUs$styles.fl)
						]),
					_List_fromArray(
						[
							$author$project$View$Hero$paragraph(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('At HappyMatches.com, we will always do our very best to ensure that your use of the HappyMatches Dating Site is smooth, effective and enjoyable.')
								])),
							$author$project$View$Hero$paragraph(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('As such, if you encounter any issues or have any questions about using the HappyMatches Dating Website and HappyMatches Dating Apps, you can contact us via email at '),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:hello@happymatches.com'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ContactUs$styles.ht)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('hello@happymatches.com')
										])),
									$rtfeldman$elm_css$Html$Styled$text(', so that we can assist you accordingly. Do provide us with as much details as possible about the issues and concerns you face, and also send us the relevant screenshots, so that we can help you resolve your issues and concerns in the quickest possible time.')
								])),
							$author$project$View$Hero$paragraph(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please rest assured that all Personal Information which you share with us will be kept in the strictest confidence. We will only use the Personal information which you provide to address your issues and concerns, and to provide the services and products of the HappyMatches Site and HappyMatches Apps, in line with our Terms of Use and Privacy Policy.')
								])),
							$author$project$View$Hero$paragraph(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Your Personal Information will never be used, sold or given to third parties for any other purpose without your consent. Any use of your Personal Information will be in accordance with our Terms of Use and Privacy Policy, to facilitate the provision of the HappyMatches services and products to you. We are strongly committed to protecting your privacy online, and have taken all reasonable steps to protect the Personal Information you share with us. Please note that no staff of HappyMatches will ever ask you to divulge the password to your user account, and you should never give out your password to anyone in any circumstances.')
								])),
							$author$project$View$Hero$paragraph(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('We also strongly urge you to adhere to all policies and the Terms of Use of the HappyMatches Online Dating Site and HappyMatches Online Dating Apps. All users must be at least 18 years old. You shall not put any contact information on any part of your profile. The promotion of any illegal commercial activities (such as prostitution, social escorting and payment-for-sex) is strictly prohibited. You shall not engage in any scamming or spamming activities, nor exhibit any rude, bullying or abusive behavior towards any other user. We would also like to reiterate that HappyMatches is not a compensated dating site, and must not be used for any sugar dating activities. Any users in breach of our policies and Terms of Use face their accounts being terminated immediately without notice, with no refund for any payments made to us.')
								])),
							$author$project$View$Hero$paragraph(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('For any questions, you can contact us at '),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:hello@happymatches.com'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ContactUs$styles.ht)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('hello@happymatches.com')
										])),
									A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
									A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('/'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ContactUs$styles.ht)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com')
										])),
									A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
									$rtfeldman$elm_css$Html$Styled$text('27 Hazel Park Terrace, #17-08, Singapore 678949')
								]))
						]))
				]))
		]));
var $author$project$View$Display$errorView = function (message) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap(
					$author$project$View$Theme$defaultStyles.kd,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$px(20)),
							$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
						])))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							$author$project$View$Theme$defaultStyles.lC,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$px(30))
								])))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Error Occurred')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('This is embarrassing but we appeared to have an error here. Please contact the administrator for support.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Error message: ')
							])),
						$rtfeldman$elm_css$Html$Styled$text(message)
					]))
			]));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = $rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
var $rtfeldman$elm_css$Html$Styled$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
var $author$project$View$Display$loadingHtml = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap(
				$author$project$View$Theme$defaultStyles.kd,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$px(20)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$vh(100)),
						$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
					])))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.lC)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Loading your experience...')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv)
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Some people (and HappyMatches.com) are worth waiting for 😘')
				]))
		]));
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.c, s.iN, s.f0, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.g)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.c, newOffset) < 0,
			0,
			{f0: newCol, g: s.g, i: s.i, c: newOffset, iN: newRow, b: s.b});
	};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$comment = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($hecrj$html_parser$Html$Parser$Comment),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {f0: s.f0 + (newOffset - s.c), g: s.g, i: s.i, c: newOffset, iN: s.iN, b: s.b};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.c, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.b);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.iN, s.f0 - (floatOffset + s.c), invalid, s.g));
		} else {
			if (_Utils_eq(s.c, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.c, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.c, floatOffset, s.b));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.c, s.b)) {
			var zeroOffset = s.c + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.lT,
				c.gY,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.b),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.lT,
				c.hZ,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.b),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.lT,
				c.fp,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.b),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.lT,
				c.gu,
				c.hg,
				c.gC,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.lT,
				c.gu,
				c.hg,
				c.gC,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.c, s.b),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				fp: $elm$core$Result$Err(invalid),
				gu: expecting,
				gC: $elm$core$Result$Err(invalid),
				gY: $elm$core$Result$Err(invalid),
				hg: $elm$core$Result$Ok($elm$core$Basics$identity),
				lT: invalid,
				hZ: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$View$Display$loadingView = function (preRenderedHtml) {
	if ($elm$core$String$isEmpty(preRenderedHtml)) {
		return $author$project$View$Display$loadingHtml;
	} else {
		var _v0 = $hecrj$html_parser$Html$Parser$run(preRenderedHtml);
		if (!_v0.$) {
			var parsedNodes = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$rtfeldman$elm_css$Html$Styled$fromUnstyled,
							$hecrj$html_parser$Html$Parser$Util$toVirtualDom(parsedNodes)))
					]));
		} else {
			return $author$project$View$Display$errorView('Cannot parse HTML');
		}
	}
};
var $author$project$Page$Content$renderArticleStatus = F5(
	function (preRenderedHtml, processedHtml, articles, url, articleView) {
		var _v0 = A2($author$project$Data$Content$findArticleByUrl, url, articles);
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 2:
					var message = _v0.a.a;
					return $author$project$View$Display$errorView(message);
				case 0:
					var article = _v0.a.a;
					return A2(articleView, processedHtml, article);
				case 1:
					return $author$project$View$Display$loadingView(preRenderedHtml);
				default:
					return $author$project$View$Display$notFoundView;
			}
		} else {
			return $author$project$View$Display$simpleLoadingView;
		}
	});
var $rtfeldman$elm_css$Css$margin4 = $rtfeldman$elm_css$Css$prop4('margin');
var $author$project$Page$Content$styles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$pct(80)),
			A4($rtfeldman$elm_css$Css$margin4, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$auto, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$auto),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	cC: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(270))),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMedia,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Media$only,
					$rtfeldman$elm_css$Css$Media$screen,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Media$minWidth(
							$rtfeldman$elm_css$Css$px(1)),
							$rtfeldman$elm_css$Css$Media$maxWidth(
							$rtfeldman$elm_css$Css$px(1000))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	cF: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.lw)
		]),
	c1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(270)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMedia,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Media$only,
					$rtfeldman$elm_css$Css$Media$screen,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Media$minWidth(
							$rtfeldman$elm_css$Css$px(1)),
							$rtfeldman$elm_css$Css$Media$maxWidth(
							$rtfeldman$elm_css$Css$px(1000))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	dd: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(80)),
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$paddingLeft(
					$rtfeldman$elm_css$Css$px(20))
				]))
		])
};
var $author$project$Page$Content$Page$view = F2(
	function (processedHtml, article) {
		var styles = {
			dd: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(80)),
					A4(
					$rtfeldman$elm_css$Css$margin4,
					$rtfeldman$elm_css$Css$px(40),
					$rtfeldman$elm_css$Css$auto,
					$rtfeldman$elm_css$Css$px(20),
					$rtfeldman$elm_css$Css$auto),
					$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
					$rtfeldman$elm_css$Css$fontSize(
					$rtfeldman$elm_css$Css$px(24)),
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
					$author$project$View$Theme$forMobileScreen(
					_List_fromArray(
						[
							A4(
							$rtfeldman$elm_css$Css$margin4,
							$rtfeldman$elm_css$Css$px(40),
							$rtfeldman$elm_css$Css$px(20),
							$rtfeldman$elm_css$Css$px(20),
							$rtfeldman$elm_css$Css$px(20))
						]))
				])
		};
		var _v0 = article;
		var title = _v0.dd;
		var _v1 = $hecrj$html_parser$Html$Parser$run(processedHtml);
		if (!_v1.$) {
			var parsedNodes = _v1.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.dd)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(title)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pageContent')
							]),
						A2(
							$elm$core$List$map,
							$rtfeldman$elm_css$Html$Styled$fromUnstyled,
							$hecrj$html_parser$Html$Parser$Util$toVirtualDom(parsedNodes)))
					]));
		} else {
			return $author$project$View$Display$errorView('Cannot parse HTML');
		}
	});
var $author$project$Page$Content$Helpers$categoryLink = F3(
	function (category, attributes, children) {
		var urlSafeCategory = A2(
			$elm$core$String$join,
			'-',
			A2(
				$elm$core$String$split,
				' ',
				$elm$core$String$toLower(category)));
		var targetUrl = $author$project$Data$Route$routeUrl.kb + ('/' + urlSafeCategory);
		var preventDefaultAttrs = _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href(targetUrl)
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_Utils_ap(preventDefaultAttrs, attributes),
			children);
	});
var $author$project$Page$Content$Post$styles = {
	fP: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$zero,
					$rtfeldman$elm_css$Css$px(15))
				]))
		]),
	ck: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(15),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(6),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			$rtfeldman$elm_css$Css$scale(1))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	dd: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(40))),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(35)),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					A4(
					$rtfeldman$elm_css$Css$margin4,
					$rtfeldman$elm_css$Css$px(40),
					$rtfeldman$elm_css$Css$px(20),
					$rtfeldman$elm_css$Css$px(15),
					$rtfeldman$elm_css$Css$px(20))
				]))
		])
};
var $author$project$Page$Content$Post$renderCategories = function (categories) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$Post$styles.fP)
			]),
		A2(
			$elm$core$List$map,
			function (category) {
				return A3(
					$author$project$Page$Content$Helpers$categoryLink,
					category,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$Post$styles.ck)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(category)
						]));
			},
			categories));
};
var $author$project$Page$Content$Post$view = F2(
	function (processedHtml, article) {
		var _v0 = article;
		var title = _v0.dd;
		var categories = _v0.fP;
		var _v1 = $hecrj$html_parser$Html$Parser$run(processedHtml);
		if (!_v1.$) {
			var parsedNodes = _v1.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$Post$styles.f1)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$Post$styles.dd)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(title)
							])),
						$author$project$Page$Content$Post$renderCategories(categories),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('pageContent blogContent')
							]),
						A2(
							$elm$core$List$map,
							$rtfeldman$elm_css$Html$Styled$fromUnstyled,
							$hecrj$html_parser$Html$Parser$Util$toVirtualDom(parsedNodes)))
					]));
		} else {
			return $author$project$View$Display$errorView('Cannot parse HTML');
		}
	});
var $author$project$Page$Content$PostSideBar$styles = {
	bS: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20))
		]),
	eu: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
				]))
		]),
	ev: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A4(
			$rtfeldman$elm_css$Css$boxShadow4,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(10),
			$author$project$View$Theme$colors.gN),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gN)
		]),
	ew: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gN)
		])
};
var $author$project$Page$Content$PostSideBar$displayCategory = function (category) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$PostSideBar$styles.bS)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Page$Content$Helpers$categoryLink,
				category,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$PostSideBar$styles.eu)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(category)
					]))
			]));
};
var $author$project$Page$Content$PostSideBar$displayCategories = function (categoriesStatus) {
	var categoriesHtml = function () {
		if (!categoriesStatus.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$PostSideBar$styles.bS)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Loading categories...')
						]))
				]);
		} else {
			var categories = categoriesStatus.a;
			return A2(
				$elm$core$List$map,
				$author$project$Page$Content$PostSideBar$displayCategory,
				$elm$core$Dict$keys(categories));
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$PostSideBar$styles.ev),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'categories')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$PostSideBar$styles.ew)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Categories')
						]))
				]),
			categoriesHtml));
};
var $author$project$Page$Content$Helpers$articleLink = F3(
	function (_v0, attributes, children) {
		var url = _v0.n8;
		var targetUrl = $author$project$Data$Route$routeUrl.kb + ('/' + url);
		var preventDefaultAttrs = _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href(targetUrl)
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_Utils_ap(preventDefaultAttrs, attributes),
			children);
	});
var $author$project$Page$Content$PostSideBar$displayRecentPost = function (article) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$PostSideBar$styles.bS)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Page$Content$Helpers$articleLink,
				article,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$PostSideBar$styles.eu)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(article.dd)
					]))
			]));
};
var $author$project$Page$Content$PostSideBar$displayRecentPosts = function (postsStatus) {
	var postsHtml = function () {
		if (!postsStatus.$) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$PostSideBar$styles.bS)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Loading posts...')
						]))
				]);
		} else {
			var articles = $elm$core$List$reverse(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.iz;
					},
					$author$project$Data$Content$getListArticleData(postsStatus)));
			return A2(
				$elm$core$List$take,
				5,
				A2($elm$core$List$map, $author$project$Page$Content$PostSideBar$displayRecentPost, articles));
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$PostSideBar$styles.ev),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'recentPosts')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$PostSideBar$styles.ew)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Recent Posts')
						]))
				]),
			postsHtml));
};
var $author$project$Page$Content$PostSideBar$view = function (model) {
	var _v0 = model;
	var postsStatus = _v0.M;
	var categoriesStatus = _v0.I;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Page$Content$PostSideBar$displayRecentPosts(postsStatus),
				$author$project$Page$Content$PostSideBar$displayCategories(categoriesStatus)
			]));
};
var $author$project$Page$Content$ListPosts$styles = {
	j3: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
			$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A2($rtfeldman$elm_css$Css$property, '-webkit-transition', 'transform 0.5s'),
			A2($rtfeldman$elm_css$Css$property, 'transition', 'transform 0.5s'),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$scale(1.1))
				]))
		]),
	fm: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(300)),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	ci: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lt,
		_List_fromArray(
			[
				A4(
				$rtfeldman$elm_css$Css$margin4,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$px(7)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(150)),
				$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
				A2($rtfeldman$elm_css$Css$property, '-webkit-transition', 'background 0.5s, color 0.5s'),
				A2($rtfeldman$elm_css$Css$property, 'transition', 'background 0.5s, color 0.5s'),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh),
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
						$rtfeldman$elm_css$Css$borderColor($author$project$View$Theme$colors.eh)
					]))
			])),
	fz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$zero)
		]),
	fP: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	ck: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(14)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(6),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN),
			$rtfeldman$elm_css$Css$transform(
			$rtfeldman$elm_css$Css$scale(1)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$auto)
				]))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(40))),
			A2($rtfeldman$elm_css$Css$margin2, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	lS: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA)
		]),
	hk: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(50),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(15))),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A4(
			$rtfeldman$elm_css$Css$boxShadow4,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(10),
			$author$project$View$Theme$colors.gN),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gN),
			A2(
			$rtfeldman$elm_css$Css$Media$withMedia,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Media$only,
					$rtfeldman$elm_css$Css$Media$screen,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Media$minWidth(
							$rtfeldman$elm_css$Css$px(1)),
							$rtfeldman$elm_css$Css$Media$maxWidth(
							$rtfeldman$elm_css$Css$px(1500))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	hx: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(40))
		]),
	dd: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20))
		]),
	jq: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.gT),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(22)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(35)),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA)
				]))
		])
};
var $author$project$Page$Content$ListPosts$loadingView = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.hx)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv)
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.lS)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Loading posts...')
				]))
		]));
var $author$project$Type$Content$LoadMore = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Content$ListPosts$buttonLoadMore = F2(
	function (category, postsStatus) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$author$project$Types$OnContent,
			function () {
				switch (postsStatus.$) {
					case 1:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.fz)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kj)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Loading...')
										]))
								]));
					case 2:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.fz)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kj),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Type$Content$LoadMore(category))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Load More')
										]))
								]));
					default:
						return $rtfeldman$elm_css$Html$Styled$text('');
				}
			}());
	});
var $author$project$Page$Content$ListPosts$categoryLabel = function (categories) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.fP)
			]),
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$rtfeldman$elm_css$Html$Styled$div(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.ck)
							])),
					$elm$core$List$singleton),
				$rtfeldman$elm_css$Html$Styled$text),
			categories));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$property = $rtfeldman$elm_css$VirtualDom$Styled$property;
var $author$project$Page$Content$ListPosts$displayItem = function (article) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('<\\/?[^>]+>'));
	var plainIntro = A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$take,
			50,
			$elm$core$String$words(
				A3(
					$elm$regex$Regex$replace,
					regex,
					$elm$core$Basics$always(''),
					article.cg))));
	var intro = (plainIntro === '') ? '' : (plainIntro + '...');
	var image = (article.cA === '') ? $author$project$View$Theme$images.lG.j3 : article.cA;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.hk)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.fm)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Page$Content$Helpers$articleLink,
						article,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_Utils_ap(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$backgroundImage(
													$rtfeldman$elm_css$Css$url(image))
												]),
											$author$project$Page$Content$ListPosts$styles.j3))
									]),
								_List_Nil),
								$author$project$Page$Content$ListPosts$categoryLabel(article.fP)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.dd)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Page$Content$Helpers$articleLink,
						article,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.jq)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(article.dd)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.lS),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$property,
						'innerHTML',
						$elm$json$Json$Encode$string(intro))
					]),
				_List_Nil),
				A3(
				$author$project$Page$Content$Helpers$articleLink,
				article,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.ci)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Read More ...')
					]))
			]));
};
var $author$project$Page$Content$ListPosts$viewPost = F2(
	function (category, postsStatus) {
		if (!postsStatus.$) {
			return $author$project$Page$Content$ListPosts$loadingView;
		} else {
			var postItems = A2(
				$elm$core$List$map,
				$author$project$Page$Content$ListPosts$displayItem,
				$elm$core$List$reverse(
					A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.iz;
						},
						$author$project$Data$Content$getListArticleData(postsStatus))));
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'postList')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$ListPosts$styles.f1)
							]),
						postItems),
						A2($author$project$Page$Content$ListPosts$buttonLoadMore, category, postsStatus)
					]));
		}
	});
var $author$project$Page$Content$ListPosts$viewCategory = F2(
	function (category, categoriesStatus) {
		if (!categoriesStatus.$) {
			return $author$project$Page$Content$ListPosts$loadingView;
		} else {
			var categories = categoriesStatus.a;
			var _v1 = A2($author$project$Data$Content$categoryUrlNameToName, categories, category);
			if (!_v1.$) {
				var categoryName = _v1.a;
				var _v2 = A2($elm$core$Dict$get, category, categories);
				if (!_v2.$) {
					var postsStatus = _v2.a;
					return A2(
						$author$project$Page$Content$ListPosts$viewPost,
						$elm$core$Maybe$Just(categoryName),
						postsStatus);
				} else {
					return $author$project$View$Display$notFoundView;
				}
			} else {
				return $author$project$View$Display$notFoundView;
			}
		}
	});
var $author$project$Page$Content$view = F3(
	function (route, preRenderedHtml, content) {
		var _v0 = content;
		var postsStatus = _v0.M;
		var categoriesStatus = _v0.I;
		var processedHtml = _v0.ir;
		switch (route.$) {
			case 0:
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.cF)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.dd)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Blog')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.f1)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.cC)
										]),
									_List_fromArray(
										[
											A2($author$project$Page$Content$ListPosts$viewPost, $elm$core$Maybe$Nothing, postsStatus)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.c1)
										]),
									_List_fromArray(
										[
											$author$project$Page$Content$PostSideBar$view(content)
										]))
								]))
						]));
			case 3:
				var category = route.a;
				if (!categoriesStatus.$) {
					return $author$project$View$Display$loadingView(preRenderedHtml);
				} else {
					var categories = categoriesStatus.a;
					var _v3 = A2($author$project$Data$Content$categoryUrlNameToName, categories, category);
					if (!_v3.$) {
						var categoryName = _v3.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.cF)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.dd)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(categoryName)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.f1)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.cC)
												]),
											_List_fromArray(
												[
													A2($author$project$Page$Content$ListPosts$viewCategory, categoryName, categoriesStatus)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.c1)
												]),
											_List_fromArray(
												[
													$author$project$Page$Content$PostSideBar$view(content)
												]))
										]))
								]));
					} else {
						return $author$project$View$Display$notFoundView;
					}
				}
			case 2:
				var url = route.a;
				var articles = $author$project$Model$Content$getListArticle(content);
				return A5(
					$author$project$Page$Content$renderArticleStatus,
					preRenderedHtml,
					processedHtml,
					articles,
					url,
					F2(
						function (processedHtml_, article) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.cF)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.f1)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.cC)
													]),
												_List_fromArray(
													[
														A2($author$project$Page$Content$Post$view, processedHtml_, article)
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Content$styles.c1)
													]),
												_List_fromArray(
													[
														$author$project$Page$Content$PostSideBar$view(content)
													]))
											]))
									]));
						}));
			default:
				var url = route.a;
				var articles = $elm$core$Dict$values(content.ax);
				return A5(
					$author$project$Page$Content$renderArticleStatus,
					preRenderedHtml,
					processedHtml,
					articles,
					url,
					F2(
						function (processedHtml_, article) {
							return A2($author$project$Page$Content$Page$view, processedHtml_, article);
						}));
		}
	});
var $author$project$Type$Deactivate$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$Deactivate$SubmitForm = {$: 1};
var $author$project$Page$Deactivate$view = F2(
	function (dimension, authState) {
		var containerStyle = A2(
			$author$project$Page$Deactivate$styles.f1,
			dimension,
			$author$project$View$Helpers$UserInfo$isMissingAvatar(authState));
		var _v0 = authState.gc;
		var form = _v0.ln;
		var apiError = _v0.dk;
		var _v1 = form;
		var submitting = _v1.jc;
		return A2(
			$rtfeldman$elm_css$Html$Styled$form,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle),
					$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
					$author$project$Types$OnAuth(
						$author$project$Types$OnDeactivate($author$project$Type$Deactivate$SubmitForm)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Deactivate$styles.jJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Deactivate$styles.gT)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete Your Profile')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Deactivate$styles.lS)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('This action cannot be undone. This will permanently delete your account and you will no longer be able to login, view profiles and chat with other users.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Deactivate$styles.lS)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please type in your password below to confirm.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Deactivate$styles.lP)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$map,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnDeactivate),
										$author$project$Type$Deactivate$FormMsg),
									A2(
										$author$project$View$Form$passwordField,
										form,
										{ct: 'password', dX: ''}))
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$rtfeldman$elm_css$Html$Styled$text(''),
							A2(
								$elm$core$Maybe$map,
								function (message) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(message)
											]));
								},
								apiError)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Deactivate$styles.fE)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$submitButton(submitting),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Deactivate$styles.fJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.mp)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel')
										]))
								]))
						]))
				]));
	});
var $author$project$Page$EmailVerifiedFail$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kd)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.lC)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Email Verification Failed'),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil)
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('There is an error verifying your email.')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Please check that you have clicked on the verification link in your email'),
					$rtfeldman$elm_css$Html$Styled$text(' or copy and paste the link from the email carefully into your browser again.')
				]))
		]));
var $author$project$Page$EmailVerifiedSuccess$view = function (authState) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kd)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.lC)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Email Verification Success'),
						A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Thank you for verifying your email.')
					])),
				function () {
				if (!authState.$) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.ht),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.mp)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Complete Your Profile')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(' to Start Viewing the Exciting Profiles of Other Users Now!')
									]))
							]));
				} else {
					return A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.ht),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l1)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Login Now')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(' to Start Viewing the Exciting Profiles of Other Users!')
									]))
							]));
				}
			}()
			]));
};
var $author$project$Type$FaceVerification$StartFaceVerification = {$: 0};
var $author$project$Page$FaceVerification$startVerificationButton = function (device) {
	if (!device.$) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$View$Theme$defaultStyles.ci,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$margin2,
								$rtfeldman$elm_css$Css$px(20),
								$rtfeldman$elm_css$Css$zero)
							]))),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnFaceVerification($author$project$Type$FaceVerification$StartFaceVerification)))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Start Face Verification')
				]));
	}
};
var $rtfeldman$elm_css$Css$justify = $rtfeldman$elm_css$Css$prop1('justify');
var $author$project$Page$FaceVerification$styles = {
	ke: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs)
		]),
	gT: $author$project$View$Theme$defaultStyles.lC,
	ht: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
		]),
	bJ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(23)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$justify)
			])),
	nD: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingTop(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(18))
			])),
	jn: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(40),
			$rtfeldman$elm_css$Css$px(10)),
			A2($rtfeldman$elm_css$Css$margin2, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(800))
		])
};
var $author$project$Page$FaceVerification$view = function (device) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A5(
				$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
				$author$project$View$Hero$view,
				$author$project$View$Theme$images.jN.mj,
				$author$project$View$Theme$images.jN.j3,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$View$Hero$title('Human Verification'),
						$author$project$View$Hero$paragraph(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('At Happy Matches, we care deeply about the authenticity of every user while '),
								$rtfeldman$elm_css$Html$Styled$text('weeding out scammers, fakers and time-wasters.')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerification$styles.jn)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h1,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerification$styles.gT)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Why Human Verification?')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerification$styles.bJ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com respects your privacy. '),
								$rtfeldman$elm_css$Html$Styled$text('At the same time, we need to ensure that every user on the platform is a real user.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerification$styles.bJ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('To meet this demand, we have implemented a real-time human verification technology through our mobile app '),
								$rtfeldman$elm_css$Html$Styled$text('which helps to ensure that a real human being is behind the account on our website.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerification$styles.bJ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Through the mobile app, you will be asked to perform simple facial gestures such as smiling and blinking '),
								$rtfeldman$elm_css$Html$Styled$text('so that our algorithms will be able to detect if you are a real human being or not. '),
								$rtfeldman$elm_css$Html$Styled$text('Thereafter, a chosen frame of the session will be captured and stored on our server to detect and weed out flagged users such as scammers or multiple account holders. '),
								$rtfeldman$elm_css$Html$Styled$text('The frame stored is subjected to our Privacy Policy and is NEVER exposed on your profile so you can rest assured that your privacy is respected.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerification$styles.bJ)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Help us to work towards a more authentic user base where you can be assured that you are talking to a real human being '),
								$rtfeldman$elm_css$Html$Styled$text('instead of a faker or a time-waster. '),
								$rtfeldman$elm_css$Html$Styled$text('Together, we can make HappyMatches a place where real beautiful and successful people can meet for dates and romance.')
							])),
						$author$project$Page$FaceVerification$startVerificationButton(device)
					]))
			]));
};
var $author$project$View$Display$mobileAppBadges = function (_v0) {
	var appleStoreUrl = _v0.j_;
	var playStoreUrl = _v0.mT;
	var styles = {
		fh: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(150)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(54))
			]),
		fk: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
				$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
			])
	};
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.fk)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(appleStoreUrl)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.jZ),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.fh)
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(playStoreUrl)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.lu),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.fh)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Page$FaceVerificationProcessing$styles = {
	f1: F2(
		function (_v0, hasAlert) {
			var screenHeight = _v0.ni;
			return _Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$height(
						A3(
							$rtfeldman$elm_css$Css$calc,
							$rtfeldman$elm_css$Css$vh(100),
							$rtfeldman$elm_css$Css$minus,
							$rtfeldman$elm_css$Css$px(30))),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN)
					]),
				A2($author$project$View$Theme$defaultStyles.kA, screenHeight, hasAlert));
		}),
	cl: $author$project$View$Theme$defaultStyles.kd,
	gs: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
			])),
	gS: $author$project$View$Theme$defaultStyles.lC,
	hw: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	jJ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		])
};
var $author$project$Page$FaceVerificationProcessing$view = F2(
	function (_v0, authState) {
		var dimension = _v0.kR;
		var device = _v0.kQ;
		var configs = _v0.kw;
		var header = A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerificationProcessing$styles.gS)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Human Verification'),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil)
				]));
		var containerStyle = A2(
			$author$project$Page$FaceVerificationProcessing$styles.f1,
			dimension,
			$author$project$View$Helpers$UserInfo$isMissingAvatar(authState));
		var _v1 = configs;
		var urls = _v1.n9;
		var subViews = function () {
			if (!device.$) {
				return _List_fromArray(
					[
						header,
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerificationProcessing$styles.cl)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('In order to ensure that all our users are REAL users, we have adopted a real-time human verification technology through our mobile app.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerificationProcessing$styles.cl)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Please download our mobile app and complete the human verification process.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerificationProcessing$styles.cl)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('You can continue to use the website after you have completed the human verification on our mobile app.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap(
									$author$project$Page$FaceVerificationProcessing$styles.cl,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$marginBottom(
											$rtfeldman$elm_css$Css$px(30))
										])))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('If you wish to understand more about our human verification technology and process, please click '),
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.ht),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.lb)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('here')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('.')
									]))
							])),
						$author$project$View$Display$mobileAppBadges(urls)
					]);
			} else {
				var _v3 = authState.gx;
				switch (_v3.$) {
					case 0:
						return _List_fromArray(
							[
								header,
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerificationProcessing$styles.cl)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('In order to ensure that all our users are REAL users, we have adopted a real-time human verification technology through our mobile app.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_Utils_ap(
											$author$project$Page$FaceVerificationProcessing$styles.cl,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$marginBottom(
													$rtfeldman$elm_css$Css$px(30))
												])))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('If you wish to understand more about our human verification technology and process, please click '),
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.ht),
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.lb)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('here')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('.')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.ci),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Types$OnAuth(
											$author$project$Types$OnFaceVerification($author$project$Type$FaceVerification$StartFaceVerification)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Start Human Verification')
									]))
							]);
					case 1:
						return _List_fromArray(
							[
								header,
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerificationProcessing$styles.hw)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$img,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hv)
											]),
										_List_Nil)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerificationProcessing$styles.cl)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Processing Human Verification...')
									]))
							]);
					case 2:
						return _List_fromArray(
							[
								header,
								A2(
								$rtfeldman$elm_css$Html$Styled$h4,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerificationProcessing$styles.cl)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Verification Completed!')
									]))
							]);
					default:
						var message = _v3.a;
						return _List_fromArray(
							[
								header,
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerificationProcessing$styles.gs)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(message)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerificationProcessing$styles.cl)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Human Verification Fail. Please try again.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.ci),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Types$OnAuth(
											$author$project$Types$OnFaceVerification($author$project$Type$FaceVerification$StartFaceVerification)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Start Human Verification')
									]))
							]);
				}
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FaceVerificationProcessing$styles.jJ)
						]),
					subViews)
				]));
	});
var $author$project$Type$ForgetPassword$FormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$ForgetPassword$SubmitForm = {$: 0};
var $author$project$Page$ForgetPassword$view = function (_v0) {
	var forgetPassword = _v0.lm;
	var _v1 = forgetPassword;
	var form = _v1.ln;
	var apiError = _v1.dk;
	var isSuccess = _v1.hi;
	var _v2 = form;
	var submitting = _v2.jc;
	return isSuccess ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.lC)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Forget Password')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kd)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Reset password email is sent successfully!')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kd)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Please check your email to reset your password.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.e$),
						$rtfeldman$elm_css$Html$Styled$Attributes$href('/#')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Back to home')
					]))
			])) : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.lC)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Forget Password')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kd)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Enter the email you used to register with us and we will send a reset password link to your email.')
					])),
				A2(
				$elm$core$Maybe$withDefault,
				$rtfeldman$elm_css$Html$Styled$text(''),
				A2(
					$elm$core$Maybe$map,
					function (message) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(message)
								]));
					},
					apiError)),
				A2(
				$rtfeldman$elm_css$Html$Styled$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
						$author$project$Types$OnForgetPassword($author$project$Type$ForgetPassword$SubmitForm))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnForgetPassword, $author$project$Type$ForgetPassword$FormMsg),
						A2(
							$author$project$View$Form$emailField,
							form,
							{ct: 'email', dX: 'Email'})),
						A2($rtfeldman$elm_css$Html$Styled$p, _List_Nil, _List_Nil),
						$author$project$View$Form$submitButton(submitting)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.e$),
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l1)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Back to sign in')
							]))
					]))
			]));
};
var $author$project$Page$Login$loggedInMessage = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(10),
					$rtfeldman$elm_css$Css$zero)
				]))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.lC)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('You are already signed in!')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$View$Theme$defaultStyles.lt,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$px(20)),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$px(200))
							]))),
					$rtfeldman$elm_css$Html$Styled$Attributes$href('/')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Go to Homepage')
				]))
		]));
var $author$project$Type$Login$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$Login$SubmitForm = {$: 1};
var $author$project$Page$Login$header = function (registerUrl) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
						$author$project$View$Theme$forMobileScreen(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.lC)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Sign in')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$author$project$View$Theme$forMobileScreen(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
									]))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.kd)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Don\'t have an account?')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap(
									$author$project$View$Theme$defaultStyles.lt,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$marginLeft(
											$rtfeldman$elm_css$Css$px(15))
										]))),
								$rtfeldman$elm_css$Html$Styled$Attributes$href(registerUrl)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('SIGN UP')
							]))
					]))
			]));
};
var $author$project$Page$Login$loginForm = function (_v0) {
	var login = _v0.l1;
	var _v1 = login;
	var apiError = _v1.dk;
	var form = _v1.ln;
	var _v2 = form;
	var submitting = _v2.jc;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Page$Login$header($author$project$Data$Route$routeUrl.na),
				A2(
				$rtfeldman$elm_css$Html$Styled$hr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A3(
								$rtfeldman$elm_css$Css$borderTop3,
								$rtfeldman$elm_css$Css$px(1),
								$rtfeldman$elm_css$Css$solid,
								$author$project$View$Theme$colors.gO),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$pct(100))
							]))
					]),
				_List_Nil),
				A2(
				$elm$core$Maybe$withDefault,
				$rtfeldman$elm_css$Html$Styled$text(''),
				A2(
					$elm$core$Maybe$map,
					function (message) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(message)
								]));
					},
					apiError)),
				A2(
				$rtfeldman$elm_css$Html$Styled$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
						$author$project$Types$OnLogin($author$project$Type$Login$SubmitForm))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnLogin, $author$project$Type$Login$FormMsg),
						A2(
							$author$project$View$Form$emailField,
							form,
							{ct: 'email', dX: 'Email'})),
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnLogin, $author$project$Type$Login$FormMsg),
						A2(
							$author$project$View$Form$passwordField,
							form,
							{ct: 'password', dX: 'Password'})),
						A2($rtfeldman$elm_css$Html$Styled$p, _List_Nil, _List_Nil),
						$author$project$View$Form$submitButton(submitting)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.e$),
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.lm)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Forgot password?')
							])),
						A2($rtfeldman$elm_css$Html$Styled$p, _List_Nil, _List_Nil)
					]))
			]));
};
var $author$project$Page$Login$view = function (appModel) {
	var _v0 = appModel.j1;
	if (_v0.$ === 1) {
		return $author$project$Page$Login$loginForm(appModel);
	} else {
		return $author$project$Page$Login$loggedInMessage;
	}
};
var $author$project$Page$Membership$styles = {
	f1: F2(
		function (_v0, hasAlert) {
			var screenHeight = _v0.ni;
			return _Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.lw)
					]),
				A2($author$project$View$Theme$defaultStyles.kA, screenHeight, hasAlert));
		}),
	jJ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		])
};
var $author$project$Data$Membership$Mobile$plans = _List_fromArray(
	[
		{jT: 499, mq: 'BRONZE', bY: 1, nR: 'Your Adventure Begins'},
		{jT: 999, mq: 'SILVER', bY: 2, nR: 'You\'re Going Places'},
		{jT: 1499, mq: 'GOLD', bY: 3, nR: 'Stand Out & Be Noticed'},
		{jT: 1999, mq: 'PLATINUM', bY: 4, nR: 'Success Awaits You'},
		{jT: 2499, mq: 'DIAMOND', bY: 5, nR: 'Your Dating Wonderland'},
		{jT: 2999, mq: 'STAR', bY: 6, nR: 'You’re the Star'},
		{jT: 3499, mq: 'ULTIMATE', bY: 7, nR: 'You’re Unbeatable'}
	]);
var $author$project$Page$Membership$Android$styles = {
	k1: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
			])),
	bq: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$pseudoElement,
			'before',
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'content', '\"* \"')
				])),
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	gB: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero)
		]),
	bw: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$justify),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(24)),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(30))
			])),
	hv: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(20))
			])),
	mS: function (sponsorLevel) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(240)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$solid,
				$author$project$Data$Membership$getMembershipColor(sponsorLevel)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(5))
			]);
	},
	em: _Utils_ap(
		$author$project$View$Theme$defaultStyles.ci,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(160)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	am: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$px(5)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16))
			])),
	cX: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(22)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs)
			])),
	en: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero)
		]),
	eo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	iI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	jm: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	da: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
			])),
	dd: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	de: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		])
};
var $author$project$Page$Membership$Android$renderFullView = function (plans) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.de)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.dd)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('MEMBERSHIP')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.bw)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Dates can select the Minimum Suitor Levels they want to interact with.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Upgrade Your Level* to Stand Out from the Crowd, Increase Your Profile’s Visibility, and Gain a Huge Edge Over Your Competitors! '),
							$rtfeldman$elm_css$Html$Styled$text('You will get to Interact with More Dates and Attract Your Dream Dates. '),
							$rtfeldman$elm_css$Html$Styled$text('Each Level takes You a Notch Higher, Upgrade Your Level Now to Increase the Appeal & Attractiveness of Your Profile to Dates.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Select Your preferred Monthly Suitor Level below for Your Dating SUCCESS...')
						]))
				])),
			plans,
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.bw)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.jm)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.da),
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.nS)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Term and Conditions')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.gB)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.bq)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('All membership subscriptions are in USD, charged monthly and non-refundable.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.bq)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Any membership upgrade will be immediate. You will be charged that month\'s pro-rated amount, and the full subscription thereafter each month.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.bq)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Any membership downgrade will only take effect on your next monthly renewal.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.bq)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('If you are upgrading or downgrading your plan, kindly wait upto 10 minutes for the update.')
								]))
						]))
				]))
		]);
};
var $author$project$Type$Membership$Android$ConfirmedPlan = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$Membership$Android$ConfirmingPlan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$Membership$Android$OpenPlan = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$preWrap = {v: 'pre-wrap', aq: 0};
var $author$project$Page$Membership$Helpers$styles = {
	mS: function (sponsorLevel) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(240)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$solid,
				$author$project$Data$Membership$getMembershipColor(sponsorLevel)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(5))
			]);
	},
	em: _Utils_ap(
		$author$project$View$Theme$defaultStyles.ci,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(20)),
				A2(
				$rtfeldman$elm_css$Css$margin2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(160)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	ia: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	ib: _Utils_ap(
		$author$project$View$Theme$defaultStyles.ci,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(20)),
				A2(
				$rtfeldman$elm_css$Css$margin2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(80)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.fs)
			])),
	bM: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(17)),
				$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$preWrap),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(20))
			])),
	id: _Utils_ap(
		$author$project$View$Theme$defaultStyles.ci,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(20)),
				A2(
				$rtfeldman$elm_css$Css$margin2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(80)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	en: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero)
		])
};
var $author$project$Page$Membership$Helpers$buttonView = F6(
	function (openPlanMsg, confirmPlanMsg, confirmedPlanMsg, selectedPlan, plan, buttonLabel) {
		if (selectedPlan.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.em),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						openPlanMsg(plan))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(buttonLabel)
					]));
		} else {
			var selectedPlan_ = selectedPlan.a;
			if (!_Utils_eq(selectedPlan_.mS.bY, plan.bY)) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.em),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							openPlanMsg(plan))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(buttonLabel)
						]));
			} else {
				var _v1 = selectedPlan_.od;
				switch (_v1) {
					case 0:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.em),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									confirmPlanMsg(plan))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(buttonLabel)
								]));
					case 1:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.ia)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.ib),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											openPlanMsg(plan))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.id),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											confirmedPlanMsg(plan))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('OK')
										]))
								]));
					case 2:
						return $rtfeldman$elm_css$Html$Styled$text('');
					default:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.em),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									openPlanMsg(plan))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Try Again')
								]));
				}
			}
		}
	});
var $ryannhg$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryannhg$date_format$DateFormat$dayOfMonthNumber = $ryannhg$date_format$DateFormat$DayOfMonthNumber;
var $author$project$Page$Membership$Helpers$formatDate = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$monthNameAbbreviated,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$dayOfMonthNumber
		]));
var $author$project$Page$Membership$Android$formatPrice = function (amountInCents) {
	return $elm$core$String$fromFloat(amountInCents / 100);
};
var $author$project$Page$Membership$Helpers$isPlanSelected = F2(
	function (selectedPlan, plan) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.mS;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bY;
						},
						$elm$core$Basics$eq(plan.bY))),
				selectedPlan));
	});
var $author$project$Page$Membership$Helpers$planDiv = F3(
	function (openPlanMsg, selectedPlan, plan) {
		return A2($author$project$Page$Membership$Helpers$isPlanSelected, selectedPlan, plan) ? $rtfeldman$elm_css$Html$Styled$div(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.en),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', plan.mq)
				])) : $rtfeldman$elm_css$Html$Styled$div(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.en),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', plan.mq),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					openPlanMsg(plan))
				]));
	});
var $author$project$Type$Membership$Android$ManageSubscriptions = function (a) {
	return {$: 6, a: a};
};
var $author$project$Data$Membership$Mobile$getPlan = function (sponsorLevel) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (plan) {
				return _Utils_eq(plan.bY, sponsorLevel);
			},
			$author$project$Data$Membership$Mobile$plans));
};
var $author$project$Page$Membership$Android$renderCurrentPlan = F4(
	function (timezone, apiState, _v0, plan) {
		var status = _v0.eQ;
		var downgradeSponsorLevel = _v0.kX;
		var nextRebillingDate = _v0.mt;
		var renewable = _v0.nb;
		var errorMessage = A2(
			$elm$core$Maybe$withDefault,
			$rtfeldman$elm_css$Html$Styled$text(''),
			A2(
				$elm$core$Maybe$map,
				function (message) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.k1)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(message)
							]));
				},
				apiState.dk));
		var defaultRenewText = 'Will be renew on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextRebillingDate);
		var planInfoText = function () {
			var _v1 = _Utils_Tuple2(status, renewable);
			if (!_v1.a) {
				if (_v1.b) {
					var _v2 = _v1.a;
					return A2(
						$elm$core$Maybe$withDefault,
						defaultRenewText,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Maybe$Just(defaultRenewText),
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Data$Membership$Mobile$getPlan,
									$elm$core$Maybe$map(
										function (_v3) {
											var name = _v3.mq;
											return 'You\'ll be downgraded to ' + (name + (' on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextRebillingDate)));
										})),
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Core$Data$Profile$SponsorLevel$toSponsorLevel, $elm$core$Result$toMaybe),
										downgradeSponsorLevel)))));
				} else {
					var _v4 = _v1.a;
					return 'Will be end on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextRebillingDate);
				}
			} else {
				var _v5 = _v1.a;
				return 'This plan had been expired on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextRebillingDate);
			}
		}();
		var currentPlanText = (!status) ? 'Your Current Suitor Level' : 'Your Last Suitor Level';
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.en)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$Page$Membership$Android$styles.mS(plan.bY))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.am)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(currentPlanText)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.cX)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(plan.mq)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.am)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(planInfoText)
								])),
							errorMessage,
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.em),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Type$Membership$Android$ManageSubscriptions(plan.bY))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Manage Subscriptions')
								]))
						]))
				]));
	});
var $author$project$Page$Membership$Android$renderDowngradePlan = F3(
	function (timezone, _v0, plan) {
		var nextRebillingDate = _v0.mt;
		var planInfoText = 'You\'ll be downgraded to this plan on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextRebillingDate);
		var currentPlanText = 'Your Downgrade Suitor Level';
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.en)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$Page$Membership$Android$styles.mS(plan.bY))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.am)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(currentPlanText)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.cX)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(plan.mq)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.am)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(planInfoText)
								]))
						]))
				]));
	});
var $author$project$Animate$Tada = 7;
var $author$project$Page$Membership$Helpers$displayApiLoading = function (status) {
	return (status === 1) ? A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Processing your request now...')
			])) : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Page$Membership$Helpers$displaySuccessMessage = F2(
	function (status, apiError) {
		return ((status === 2) && _Utils_eq(apiError, $elm$core$Maybe$Nothing)) ? A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Membership is updated successfully!')
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Page$Membership$Helpers$displayApiState = function (_v0) {
	var apiError = _v0.dk;
	var status = _v0.eQ;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Page$Membership$Helpers$displaySuccessMessage, status, apiError),
				A2(
				$elm$core$Maybe$withDefault,
				$rtfeldman$elm_css$Html$Styled$text(''),
				A2(
					$elm$core$Maybe$map,
					function (message) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(message)
								]));
					},
					apiError)),
				$author$project$Page$Membership$Helpers$displayApiLoading(status)
			]));
};
var $author$project$Page$Membership$Helpers$renderPlanBody = F5(
	function (selectedPlan, plan, apiState, confirmText, defaultDescription) {
		if (selectedPlan.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var selectedPlan_ = selectedPlan.a;
			if (!_Utils_eq(selectedPlan_.mS.bY, plan.bY)) {
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				var _v1 = selectedPlan_.od;
				switch (_v1) {
					case 0:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.bM),
									$author$project$Animate$animate(7)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(defaultDescription)
								]));
					case 1:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.bM)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(confirmText)
								]));
					case 2:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.bM)
								]),
							_List_fromArray(
								[
									$author$project$Page$Membership$Helpers$displayApiState(apiState)
								]));
					default:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Helpers$styles.bM)
								]),
							_List_fromArray(
								[
									$author$project$Page$Membership$Helpers$displayApiState(apiState)
								]));
				}
			}
		}
	});
var $author$project$Page$Membership$Android$renderPlan = F6(
	function (timezone, currentTime, model, subscriptionInformation, withTrial, plan) {
		var trialText = withTrial ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.am)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('FREE 2 WEEKS TRIAL')
				])) : $rtfeldman$elm_css$Html$Styled$text('');
		var price = $author$project$Page$Membership$Android$formatPrice(plan.jT);
		var endPlanTime = $elm$time$Time$millisToPosix(
			$elm$time$Time$posixToMillis(currentTime) + ((((13 * 24) * 60) * 60) * 1000));
		var description = 'Pay $' + (price + ('/mth from ' + (A2($author$project$Page$Membership$Helpers$formatDate, timezone, endPlanTime) + '. Cancel anytime.')));
		var confirmText = 'Confirm subscribe to ' + plan.mq;
		var buttonLabel = 'Only $' + (price + '/mth');
		var _v0 = plan;
		var name = _v0.mq;
		var tagline = _v0.nR;
		var sponsorLevel = _v0.bY;
		var _v1 = model;
		var selectedPlan = _v1.c4;
		var apiState = _v1.n;
		var planView = A4(
			$author$project$Page$Membership$Helpers$planDiv,
			$author$project$Type$Membership$Android$OpenPlan,
			selectedPlan,
			plan,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$Page$Membership$Android$styles.mS(sponsorLevel))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.cX)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(name)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.am)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(tagline)
								])),
							trialText,
							A5($author$project$Page$Membership$Helpers$renderPlanBody, selectedPlan, plan, apiState, confirmText, description),
							A6($author$project$Page$Membership$Helpers$buttonView, $author$project$Type$Membership$Android$OpenPlan, $author$project$Type$Membership$Android$ConfirmingPlan, $author$project$Type$Membership$Android$ConfirmedPlan, selectedPlan, plan, buttonLabel)
						]))
				]));
		if (subscriptionInformation.$ === 1) {
			return planView;
		} else {
			var subscriptionInformation_ = subscriptionInformation.a;
			var _v3 = subscriptionInformation_.kX;
			if (_v3.$ === 1) {
				return _Utils_eq(
					subscriptionInformation_.kF,
					$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(sponsorLevel)) ? A4($author$project$Page$Membership$Android$renderCurrentPlan, timezone, model.n, subscriptionInformation_, plan) : planView;
			} else {
				var downgradeSponsorLevel = _v3.a;
				return _Utils_eq(
					subscriptionInformation_.kF,
					$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(sponsorLevel)) ? A4($author$project$Page$Membership$Android$renderCurrentPlan, timezone, model.n, subscriptionInformation_, plan) : (_Utils_eq(
					downgradeSponsorLevel,
					$author$project$Core$Data$Profile$SponsorLevel$sponsorLevelNumber(sponsorLevel)) ? A3($author$project$Page$Membership$Android$renderDowngradePlan, timezone, subscriptionInformation_, plan) : planView);
			}
		}
	});
var $author$project$Type$Membership$Android$RestorePurchase = {$: 4};
var $author$project$Page$Membership$Android$restoreButtonView = F2(
	function (label, model) {
		var childView = (!model.n.eQ) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.em),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Type$Membership$Android$RestorePurchase)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.am)
				]),
			_List_fromArray(
				[
					$author$project$Page$Membership$Helpers$displayApiState(model.n)
				]));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.iI)
				]),
			_List_fromArray(
				[childView]));
	});
var $author$project$Page$Membership$Android$view = F4(
	function (timezone, currentTime, sponsorLevel, model) {
		var _v0 = model.a$;
		switch (_v0) {
			case 0:
				return (!(!sponsorLevel)) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.de)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.dd)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('MEMBERSHIP')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.bw)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('This user has belonged to another Payment gateway.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Please'),
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.da),
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.ky)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(' contact us ')
											])),
										$rtfeldman$elm_css$Html$Styled$text('if you want to change your subscription Payment gateway.')
									]))
							]))
					]) : $author$project$Page$Membership$Android$renderFullView(
					A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.eo)
							]),
						A2(
							$elm$core$List$append,
							A2(
								$elm$core$List$map,
								A5($author$project$Page$Membership$Android$renderPlan, timezone, currentTime, model, $elm$core$Maybe$Nothing, true),
								$author$project$Data$Membership$Mobile$plans),
							_List_fromArray(
								[
									A2($author$project$Page$Membership$Android$restoreButtonView, 'Restore Purchase', model)
								]))));
			case 2:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.de)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.dd)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('MEMBERSHIP')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.bw)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Current PlayStore Account has been subscribed for another user.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Please'),
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.da),
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.ky)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(' contact us ')
											])),
										$rtfeldman$elm_css$Html$Styled$text('if you want to change your subscription user.')
									]))
							]))
					]);
			default:
				var _v1 = model.je;
				if (_v1.$ === 1) {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.de)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.dd)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('MEMBERSHIP')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.k1)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Missing subscription information')
								]))
						]);
				} else {
					var subscriptionInformation = _v1.a;
					return $author$project$Page$Membership$Android$renderFullView(
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Android$styles.eo)
								]),
							A2(
								$elm$core$List$map,
								A5(
									$author$project$Page$Membership$Android$renderPlan,
									timezone,
									currentTime,
									model,
									$elm$core$Maybe$Just(subscriptionInformation),
									false),
								$author$project$Data$Membership$Mobile$plans)));
				}
		}
	});
var $author$project$Type$Membership$Ios$ManagePlans = {$: 5};
var $author$project$Page$Membership$Ios$styles = {
	k1: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
			])),
	bq: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$pseudoElement,
			'before',
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'content', '\"* \"')
				])),
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	gB: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero)
		]),
	bw: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$justify),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(24)),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(30))
			])),
	hv: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(20))
			])),
	mS: function (sponsorLevel) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(240)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$solid,
				$author$project$Data$Membership$getMembershipColor(sponsorLevel)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(5))
			]);
	},
	em: _Utils_ap(
		$author$project$View$Theme$defaultStyles.ci,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(160)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	am: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$px(5)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16))
			])),
	cX: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(22)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs)
			])),
	en: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero)
		]),
	eo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	jm: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	da: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
			])),
	dd: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	de: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		])
};
var $author$project$Page$Membership$Ios$renderCurrentPlan = F3(
	function (timezone, apiState, _v0) {
		var status = _v0.eQ;
		var downgradeSponsorLevel = _v0.kX;
		var nextRebillingDate = _v0.mt;
		var currentSponsorLevel = _v0.kF;
		var renewable = _v0.nb;
		var currentPlan = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				$author$project$Data$Membership$Mobile$getPlan,
				$elm$core$Result$toMaybe(
					$author$project$Core$Data$Profile$SponsorLevel$toSponsorLevel(currentSponsorLevel))));
		if (currentPlan.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.en)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								$author$project$Page$Membership$Ios$styles.mS(0))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.am)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Missing plan, please contact us!')
									]))
							]))
					]));
		} else {
			var plan = currentPlan.a;
			var errorMessage = A2(
				$elm$core$Maybe$withDefault,
				$rtfeldman$elm_css$Html$Styled$text(''),
				A2(
					$elm$core$Maybe$map,
					function (message) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.k1)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(message)
								]));
					},
					apiState.dk));
			var defaultRenewText = 'Will be renew on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextRebillingDate);
			var planInfoText = function () {
				var _v2 = _Utils_Tuple2(status, renewable);
				if (!_v2.a) {
					if (_v2.b) {
						var _v3 = _v2.a;
						return A2(
							$elm$core$Maybe$withDefault,
							defaultRenewText,
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Maybe$Just(defaultRenewText),
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Data$Membership$Mobile$getPlan,
										$elm$core$Maybe$map(
											function (_v4) {
												var name = _v4.mq;
												return 'You\'ll be downgraded to ' + (name + (' on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextRebillingDate)));
											})),
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Maybe$Nothing,
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Core$Data$Profile$SponsorLevel$toSponsorLevel, $elm$core$Result$toMaybe),
											downgradeSponsorLevel)))));
					} else {
						var _v5 = _v2.a;
						return 'Will be end on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextRebillingDate);
					}
				} else {
					var _v6 = _v2.a;
					return 'This plan had been expired on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextRebillingDate);
				}
			}();
			var currentPlanText = (!status) ? 'Your Current Suitor Level' : 'Your Last Suitor Level';
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.en)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								$author$project$Page$Membership$Ios$styles.mS(plan.bY))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.am)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(currentPlanText)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.cX)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(plan.mq)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.am)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(planInfoText)
									])),
								errorMessage,
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.em),
										$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Type$Membership$Ios$ManagePlans)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Manage Subscriptions')
									]))
							]))
					]));
		}
	});
var $author$project$Page$Membership$Ios$renderFullView = function (plans) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.de)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.dd)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('MEMBERSHIP')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.bw)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Dates can select the Minimum Suitor Levels they want to interact with.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Upgrade Your Level* to Stand Out from the Crowd, Increase Your Profile’s Visibility, and Gain a Huge Edge Over Your Competitors! '),
							$rtfeldman$elm_css$Html$Styled$text('You will get to Interact with More Dates and Attract Your Dream Dates. '),
							$rtfeldman$elm_css$Html$Styled$text('Each Level takes You a Notch Higher, Upgrade Your Level Now to Increase the Appeal & Attractiveness of Your Profile to Dates.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Select Your preferred Monthly Suitor Level below for Your Dating SUCCESS...')
						]))
				])),
			plans,
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.bw)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.jm)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.da),
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.nS)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Term and Conditions')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.gB)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.bq)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('All membership subscriptions are in USD, charged monthly and non-refundable.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.bq)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Any membership upgrade will be immediate. You will be charged that month\'s pro-rated amount, and the full subscription thereafter each month.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.bq)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Any membership downgrade will only take effect on your next monthly renewal.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.bq)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('If you are upgrading or downgrading your plan, kindly wait upto 10 minutes for the update.')
								]))
						]))
				]))
		]);
};
var $author$project$Type$Membership$Ios$ConfirmedPlan = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$Membership$Ios$ConfirmingPlan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$Membership$Ios$OpenPlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Membership$Ios$formatPrice = function (amountInCents) {
	return $elm$core$String$fromFloat(amountInCents / 100);
};
var $author$project$Page$Membership$Ios$renderPlan = F4(
	function (timezone, currentTime, model, plan) {
		var price = $author$project$Page$Membership$Ios$formatPrice(plan.jT);
		var endPlanTime = $elm$time$Time$millisToPosix(
			$elm$time$Time$posixToMillis(currentTime) + ((((13 * 24) * 60) * 60) * 1000));
		var description = 'Pay $' + (price + ('/mth from ' + (A2($author$project$Page$Membership$Helpers$formatDate, timezone, endPlanTime) + '. Cancel anytime.')));
		var confirmText = 'Confirm subscribe to ' + plan.mq;
		var buttonLabel = 'Only $' + (price + '/mth');
		var _v0 = plan;
		var name = _v0.mq;
		var tagline = _v0.nR;
		var sponsorLevel = _v0.bY;
		var _v1 = model;
		var selectedPlan = _v1.c4;
		var apiState = _v1.n;
		return A4(
			$author$project$Page$Membership$Helpers$planDiv,
			$author$project$Type$Membership$Ios$OpenPlan,
			selectedPlan,
			plan,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$Page$Membership$Ios$styles.mS(sponsorLevel))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.cX)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(name)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.am)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(tagline)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.am)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('FREE 2 WEEKS TRIAL')
								])),
							A5($author$project$Page$Membership$Helpers$renderPlanBody, selectedPlan, plan, apiState, confirmText, description),
							A6($author$project$Page$Membership$Helpers$buttonView, $author$project$Type$Membership$Ios$OpenPlan, $author$project$Type$Membership$Ios$ConfirmingPlan, $author$project$Type$Membership$Ios$ConfirmedPlan, selectedPlan, plan, buttonLabel)
						]))
				]));
	});
var $author$project$Type$Membership$Ios$CheckReceipt = {$: 6};
var $author$project$Page$Membership$Ios$restoreButtonView = F2(
	function (label, model) {
		return (!model.n.eQ) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.em),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Type$Membership$Ios$CheckReceipt)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.am)
				]),
			_List_fromArray(
				[
					$author$project$Page$Membership$Helpers$displayApiState(model.n)
				]));
	});
var $author$project$Page$Membership$Ios$view = F4(
	function (timezone, currentTime, sponsorLevel, model) {
		var _v0 = model.a$;
		switch (_v0) {
			case 0:
				return (!(!sponsorLevel)) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.de)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.dd)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('MEMBERSHIP')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.bw)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('This user has belonged to another Payment gateway.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Please'),
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.da),
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.ky)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(' contact us ')
											])),
										$rtfeldman$elm_css$Html$Styled$text('if you want to change your subscription Payment gateway.')
									]))
							]))
					]) : $author$project$Page$Membership$Ios$renderFullView(
					A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.eo)
							]),
						A2(
							$elm$core$List$append,
							A2(
								$elm$core$List$map,
								A3($author$project$Page$Membership$Ios$renderPlan, timezone, currentTime, model),
								$author$project$Data$Membership$Mobile$plans),
							_List_fromArray(
								[
									A2($author$project$Page$Membership$Ios$restoreButtonView, 'Restore Purchase', model)
								]))));
			case 1:
				var _v1 = model.je;
				if (_v1.$ === 1) {
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.de)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.dd)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('MEMBERSHIP')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.k1)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Missing subscription information')
								]))
						]);
				} else {
					var subscriptionInformation = _v1.a;
					return $author$project$Page$Membership$Ios$renderFullView(
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.eo)
								]),
							_List_fromArray(
								[
									A3($author$project$Page$Membership$Ios$renderCurrentPlan, timezone, model.n, subscriptionInformation),
									A2($author$project$Page$Membership$Ios$restoreButtonView, 'Restore Purchase', model)
								])));
				}
			case 2:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.de)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.dd)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('MEMBERSHIP')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.bw)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Current AppStore Account has been subscribed for another user.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Please'),
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.da),
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.ky)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(' contact us ')
											])),
										$rtfeldman$elm_css$Html$Styled$text('if you want to change your subscription user.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.eo)
									]),
								_List_fromArray(
									[
										A2($author$project$Page$Membership$Ios$restoreButtonView, 'Restore Purchase', model)
									]))
							]))
					]);
			default:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.de)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.dd)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('MEMBERSHIP')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.bw)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('This user has been subscribed by another AppStore Account.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Please'),
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.da),
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.ky)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(' contact us ')
											])),
										$rtfeldman$elm_css$Html$Styled$text('if you want to change your subscription AppStore Account.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Ios$styles.eo)
									]),
								_List_fromArray(
									[
										A2($author$project$Page$Membership$Ios$restoreButtonView, 'Restore Purchase', model)
									]))
							]))
					]);
		}
	});
var $author$project$Type$Membership$Web$ConfirmedPlan = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$Membership$Web$ConfirmingPlan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$Membership$Web$OpenPlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Membership$Web$styles = {
	bq: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$pseudoElement,
			'before',
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'content', '\"* \"')
				])),
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(10))
				]))
		]),
	gB: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero)
		]),
	lp: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.lx),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og)
		]),
	gD: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(22)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs)
			])),
	dy: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$justify),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(24)),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(30))
			])),
	bw: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$justify),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(24)),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(30))
			])),
	mS: function (sponsorLevel) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(300)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$solid,
				$author$project$Data$Membership$getMembershipColor(sponsorLevel)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(5)),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(240))
					]))
			]);
	},
	bM: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(17)),
				$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$preWrap),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(20))
			])),
	am: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$px(5)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(16))
			])),
	cX: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(22)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs)
			])),
	ic: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(12)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lz)
			])),
	en: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$margin2,
					$rtfeldman$elm_css$Css$px(10),
					$rtfeldman$elm_css$Css$zero)
				]))
		]),
	eo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	dd: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			])),
	de: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		])
};
var $author$project$Page$Membership$Web$renderFreePlan = F4(
	function (timezone, currentTime, currentSponsorLevel, model) {
		if (!currentSponsorLevel) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var _v0 = A5($author$project$Data$Membership$Web$getSwitchPlanAction, currentTime, currentSponsorLevel, $author$project$Data$Membership$Web$config.lp, model.mt, model.kX);
			if (_v0.$ === 5) {
				var plan = _v0.a;
				var endPeriod = _v0.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.lp)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.gD)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(plan.mq)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.dy)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									'Your subscription will end on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, endPeriod))
								]))
						]));
			} else {
				var description = 'Are you sure you want to cancel your membership?';
				var confirmText = 'We are sad to see you go! Please click OK to proceed with your cancellation.';
				var buttonLabel = 'CANCEL MEMBERSHIP';
				var _v1 = model;
				var selectedPlan = _v1.c4;
				var apiState = _v1.n;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.lp)
						]),
					_List_fromArray(
						[
							A5($author$project$Page$Membership$Helpers$renderPlanBody, selectedPlan, $author$project$Data$Membership$Web$config.lp, apiState, confirmText, description),
							A6($author$project$Page$Membership$Helpers$buttonView, $author$project$Type$Membership$Web$OpenPlan, $author$project$Type$Membership$Web$ConfirmingPlan, $author$project$Type$Membership$Web$ConfirmedPlan, selectedPlan, $author$project$Data$Membership$Web$config.lp, buttonLabel),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.dy)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('- Click to stop your paid monthly subscription.')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('- Your credit card will no longer be charged.')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('- Your current month\'s membership will continue until expiry.')
										]))
								]))
						]));
			}
		}
	});
var $author$project$Page$Membership$Web$formatPrice = function (amountInCents) {
	return $elm$core$String$fromInt((amountInCents / 100) | 0);
};
var $author$project$Page$Membership$Web$planFinePrints = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.ic)
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text('*T&Cs apply')
		]));
var $author$project$Page$Membership$Web$renderPlan = F5(
	function (timezone, currentTime, currentSponsorLevel, model, plan) {
		var _v0 = plan;
		var name = _v0.mq;
		var tagline = _v0.nR;
		var sponsorLevel = _v0.bY;
		var _v1 = model;
		var selectedPlan = _v1.c4;
		var apiState = _v1.n;
		var nextRebillingDate = _v1.mt;
		var downgradeSponsorLevel = _v1.kX;
		var _v2 = A5($author$project$Data$Membership$Web$getSwitchPlanAction, currentTime, currentSponsorLevel, plan, nextRebillingDate, downgradeSponsorLevel);
		switch (_v2.$) {
			case 0:
				var description = 'Pay $' + ($author$project$Page$Membership$Web$formatPrice(plan.jT) + '/mth from today');
				var confirmText = 'Confirm subscribe to ' + plan.mq;
				var buttonLabel = 'Only $' + ($author$project$Page$Membership$Web$formatPrice(plan.jT) + '/mth');
				return A4(
					$author$project$Page$Membership$Helpers$planDiv,
					$author$project$Type$Membership$Web$OpenPlan,
					selectedPlan,
					plan,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									$author$project$Page$Membership$Web$styles.mS(sponsorLevel))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.cX)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(name)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.am)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(tagline)
										])),
									A5($author$project$Page$Membership$Helpers$renderPlanBody, selectedPlan, plan, apiState, confirmText, description),
									A6($author$project$Page$Membership$Helpers$buttonView, $author$project$Type$Membership$Web$OpenPlan, $author$project$Type$Membership$Web$ConfirmingPlan, $author$project$Type$Membership$Web$ConfirmedPlan, selectedPlan, plan, buttonLabel),
									$author$project$Page$Membership$Web$planFinePrints
								]))
						]));
			case 1:
				var endPlanTime = $elm$time$Time$millisToPosix(
					$elm$time$Time$posixToMillis(currentTime) + ((((30 * 24) * 60) * 60) * 1000));
				var description = 'Only $1 for your first month, then Pay $' + ($author$project$Page$Membership$Web$formatPrice(plan.jT) + ('/mth from ' + (A2($author$project$Page$Membership$Helpers$formatDate, timezone, endPlanTime) + '. Cancel anytime.')));
				var confirmText = 'Confirm subscribe to ' + plan.mq;
				var buttonLabel = 'Only $' + ($author$project$Page$Membership$Web$formatPrice(plan.jT) + '/mth');
				return A4(
					$author$project$Page$Membership$Helpers$planDiv,
					$author$project$Type$Membership$Web$OpenPlan,
					selectedPlan,
					plan,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									$author$project$Page$Membership$Web$styles.mS(sponsorLevel))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.cX)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(name)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.am)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('FIRST MONTH SPECIAL'),
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											$rtfeldman$elm_css$Html$Styled$text('*** Pay $1 Only! ***')
										])),
									A5($author$project$Page$Membership$Helpers$renderPlanBody, selectedPlan, plan, apiState, confirmText, description),
									A6($author$project$Page$Membership$Helpers$buttonView, $author$project$Type$Membership$Web$OpenPlan, $author$project$Type$Membership$Web$ConfirmingPlan, $author$project$Type$Membership$Web$ConfirmedPlan, selectedPlan, plan, buttonLabel),
									$author$project$Page$Membership$Web$planFinePrints
								]))
						]));
			case 2:
				var nextBillingDate = _v2.b;
				var topupAmountInCents = _v2.c;
				var description = 'Pay $' + ($author$project$Page$Membership$Web$formatPrice(topupAmountInCents) + (' now & $' + ($author$project$Page$Membership$Web$formatPrice(plan.jT) + ('/mth thereafter from ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextBillingDate)))));
				var confirmText = 'Confirm upgrade of $' + $author$project$Page$Membership$Web$formatPrice(topupAmountInCents);
				var buttonLabel = 'Only $' + ($author$project$Page$Membership$Web$formatPrice(plan.jT) + '/mth');
				return A4(
					$author$project$Page$Membership$Helpers$planDiv,
					$author$project$Type$Membership$Web$OpenPlan,
					selectedPlan,
					plan,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									$author$project$Page$Membership$Web$styles.mS(sponsorLevel))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.cX)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(name)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.am)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(tagline)
										])),
									A5($author$project$Page$Membership$Helpers$renderPlanBody, selectedPlan, plan, apiState, confirmText, description),
									A6($author$project$Page$Membership$Helpers$buttonView, $author$project$Type$Membership$Web$OpenPlan, $author$project$Type$Membership$Web$ConfirmingPlan, $author$project$Type$Membership$Web$ConfirmedPlan, selectedPlan, plan, buttonLabel),
									$author$project$Page$Membership$Web$planFinePrints
								]))
						]));
			case 3:
				var nextBillingDate = _v2.b;
				var description = 'Pay $' + ($author$project$Page$Membership$Web$formatPrice(plan.jT) + ('/mth from ' + (A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextBillingDate) + ('. Your current ' + ($author$project$Core$Data$Profile$SponsorLevel$sponsorLevelString(currentSponsorLevel) + (' subscription will expire on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextBillingDate)))))));
				var confirmText = 'Confirm downgrade of Suitor Level';
				var buttonLabel = 'Only $' + ($author$project$Page$Membership$Web$formatPrice(plan.jT) + '/mth');
				return A4(
					$author$project$Page$Membership$Helpers$planDiv,
					$author$project$Type$Membership$Web$OpenPlan,
					selectedPlan,
					plan,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									$author$project$Page$Membership$Web$styles.mS(sponsorLevel))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.cX)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(name)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.am)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(tagline)
										])),
									A5($author$project$Page$Membership$Helpers$renderPlanBody, selectedPlan, plan, apiState, confirmText, description),
									A6($author$project$Page$Membership$Helpers$buttonView, $author$project$Type$Membership$Web$OpenPlan, $author$project$Type$Membership$Web$ConfirmingPlan, $author$project$Type$Membership$Web$ConfirmedPlan, selectedPlan, plan, buttonLabel),
									$author$project$Page$Membership$Web$planFinePrints
								]))
						]));
			case 4:
				var nextBillingDate = _v2.b;
				var description = 'You\'ll remain at this level until ' + (A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextBillingDate) + (' or resubscribe back at $' + ($author$project$Page$Membership$Web$formatPrice(plan.jT) + ' per month')));
				var confirmText = 'Confirm Resubscription';
				var buttonLabel = 'Resubscribe';
				return A4(
					$author$project$Page$Membership$Helpers$planDiv,
					$author$project$Type$Membership$Web$OpenPlan,
					selectedPlan,
					plan,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									$author$project$Page$Membership$Web$styles.mS(sponsorLevel))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.cX)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(name)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.am)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(tagline)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap(
												$author$project$Page$Membership$Web$styles.bM,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
														$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
													])))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Your Current Suitor Level')
										])),
									A5($author$project$Page$Membership$Helpers$renderPlanBody, selectedPlan, plan, apiState, confirmText, description),
									A6($author$project$Page$Membership$Helpers$buttonView, $author$project$Type$Membership$Web$OpenPlan, $author$project$Type$Membership$Web$ConfirmingPlan, $author$project$Type$Membership$Web$ConfirmedPlan, selectedPlan, plan, buttonLabel)
								]))
						]));
			case 6:
				var plan_ = _v2.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.en),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', plan_.mq)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									$author$project$Page$Membership$Web$styles.mS(sponsorLevel))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.cX)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(name)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.am)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(tagline)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap(
												$author$project$Page$Membership$Web$styles.bM,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
														$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
													])))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Your Current Suitor Level')
										]))
								]))
						]));
			default:
				var plan_ = _v2.a;
				var nextBillingDate = _v2.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.en),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', plan_.mq)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									$author$project$Page$Membership$Web$styles.mS(sponsorLevel))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.cX)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(name)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.am)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(tagline)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.bM)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											'You\'ll be downgraded on ' + A2($author$project$Page$Membership$Helpers$formatDate, timezone, nextBillingDate))
										]))
								]))
						]));
		}
	});
var $author$project$Page$Membership$Web$renderPlans = F4(
	function (timezone, currentTime, currentSponsorLevel, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.eo)
				]),
			A2(
				$elm$core$List$map,
				A4($author$project$Page$Membership$Web$renderPlan, timezone, currentTime, currentSponsorLevel, model),
				$author$project$Data$Membership$Web$config.mK));
	});
var $rtfeldman$elm_css$Html$Styled$strong = $rtfeldman$elm_css$Html$Styled$node('strong');
var $author$project$Page$Membership$Web$view = F4(
	function (timezone, currentTime, sponsorLevel, model) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.de)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.dd)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('MEMBERSHIP')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.bw)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Dates can select the Minimum Suitor Levels they want to interact with.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Upgrade Your Level* to Stand Out from the Crowd, Increase Your Profile’s Visibility, and Gain a Huge Edge Over Your Competitors! '),
								$rtfeldman$elm_css$Html$Styled$text('You will get to Interact with More Dates and Attract Your Dream Dates. '),
								$rtfeldman$elm_css$Html$Styled$text('Each Level takes You a Notch Higher, Upgrade Your Level Now to Increase the Appeal & Attractiveness of Your Profile to Dates.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Select Your preferred Monthly Suitor Level below for Your Dating SUCCESS...')
							]))
					])),
				A4($author$project$Page$Membership$Web$renderPlans, timezone, currentTime, sponsorLevel, model),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.bw)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.gB)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.bq)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('All membership subscriptions are in USD, charged monthly and non-refundable.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.bq)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Paid subscriptions will be reflected as \"'),
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
														$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('2BUYSAFE.COM/HAPPYMATCH')
											])),
										$rtfeldman$elm_css$Html$Styled$text('\" in your credit card statement.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.bq)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Any membership upgrade will be immediate. You will be charged that month\'s pro-rated amount, and the full subscription thereafter each month.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$Web$styles.bq)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Any membership downgrade will only take effect on your next monthly renewal.')
									]))
							]))
					])),
				A4($author$project$Page$Membership$Web$renderFreePlan, timezone, currentTime, sponsorLevel, model)
			]);
	});
var $author$project$Page$Membership$view = F2(
	function (appModel, authState) {
		var _v0 = authState.iu;
		if (!_v0.$) {
			return $author$project$View$Display$simpleLoadingView;
		} else {
			var profile = _v0.a;
			var hasAlert = $author$project$View$Helpers$UserInfo$isMissingAvatar(authState);
			var _v1 = appModel;
			var dimension = _v1.kR;
			var timezone = _v1.jp;
			var currentTime = _v1.kG;
			var plansView = function () {
				var _v2 = authState.l9;
				switch (_v2.$) {
					case 0:
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('')
							]);
					case 1:
						var webState = _v2.a;
						return A2(
							$elm$core$List$map,
							$rtfeldman$elm_css$Html$Styled$map($author$project$Type$Membership$OnWeb),
							A4($author$project$Page$Membership$Web$view, timezone, currentTime, profile.iu.bY, webState));
					case 2:
						var iOsState = _v2.a;
						return A2(
							$elm$core$List$map,
							$rtfeldman$elm_css$Html$Styled$map($author$project$Type$Membership$OnIos),
							A4($author$project$Page$Membership$Ios$view, timezone, currentTime, profile.iu.bY, iOsState));
					default:
						var androidState = _v2.a;
						return A2(
							$elm$core$List$map,
							$rtfeldman$elm_css$Html$Styled$map($author$project$Type$Membership$OnAndroid),
							A4($author$project$Page$Membership$Android$view, timezone, currentTime, profile.iu.bY, androidState));
				}
			}();
			return A2(
				$rtfeldman$elm_css$Html$Styled$map,
				$author$project$Types$OnAuth,
				A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Types$OnMembership,
					A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								A2($author$project$Page$Membership$styles.f1, dimension, hasAlert))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Membership$styles.jJ)
									]),
								plansView)
							]))));
		}
	});
var $rtfeldman$elm_css$Html$Styled$b = $rtfeldman$elm_css$Html$Styled$node('b');
var $author$project$Page$Privacy$styles = {
	ke: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs)
		]),
	gT: $author$project$View$Theme$defaultStyles.lC,
	ht: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
		]),
	bJ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(23)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$justify)
			])),
	nD: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingTop(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(18))
			])),
	jn: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(40),
			$rtfeldman$elm_css$Css$px(10)),
			A2($rtfeldman$elm_css$Css$margin2, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(800))
		])
};
var $author$project$Page$Privacy$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_Nil,
	_List_fromArray(
		[
			A5(
			$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
			$author$project$View$Hero$view,
			$author$project$View$Theme$images.jN.mj,
			$author$project$View$Theme$images.jN.j3,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Hero$title('Privacy Policy'),
					$author$project$View$Hero$paragraph(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('At Happy Matches, we care deeply about your privacy.')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.jn)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.gT)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('PRIVACY POLICY')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('(Last revised on 28 December 2020)')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com respects your privacy. '),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('All personal information you submit to HappyMatches.com will be kept in the strictest confidence. ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('Personal information you provide to us will only be used by the HappyMatches.com portal, including through any mobile applications and/or Z9 Tech Private Limited (the '),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('“Company”')
								])),
							$rtfeldman$elm_css$Html$Styled$text(') (collectively, the '),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('“Portal”')
								])),
							$rtfeldman$elm_css$Html$Styled$text('), and the services and products provided through the Portal (the '),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('“Services”')
								])),
							$rtfeldman$elm_css$Html$Styled$text(').')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('This Agreement applies to all registered account holders of HappyMatches.com, visitors to the Portal, and users of the Services.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Your personal information will never be sold or given to third parties for any purpose without your consent, except to facilitate the provision of the Services to you. We are strongly committed to protecting your privacy online and have taken steps to protect information you share with us. For example, we use SSL encryption to safeguard your credit card data when used in E-commerce transactions. To help us protect your privacy, please maintain secrecy of username and password used in connection with your participation in any Services of HappyMatches.com.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('1. OUR COMMITMENT')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('We are committed to protecting the privacy of our users. We want to provide a safe and secure user experience. We will use our best efforts to ensure that the information submitted to us remains private, and is used only for the purposes set forth herein.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('2. PRIVACY SCOPE')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('This Privacy Policy covers HappyMatches.com’s treatment of personally identifiable information that is collected when you are on the HappyMatches.com Portal, and when you use our Services.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('3. INFORMATION COLLECTED')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('When you interact with the HappyMatches.com Portal and our Services, we may collect the following categories of personal information:')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('A) Registration and Your Information.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('If you want to use certain features of the HappyMatches.com Portal and our Services, you will have to create a user account (“'),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Account')
								])),
							$rtfeldman$elm_css$Html$Styled$text('”).')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('B) Accuracy of Account Information.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('It is important that you provide us with accurate, complete and up-to-date information for your Account and you agree to update such information to keep it accurate, complete and up-to-date. If you don’t, we might have to suspend or terminate your Account.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('You agree that you won’t disclose your Account password to anyone, and you’ll notify us immediately of any unauthorized use of your Account. You agree that you’re fully responsible for all activities that occur under your Account, whether or not you know about them.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('C) Face Verification Information:')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('To facilitate trust between our registered account holders and provide high quality profiles, empower the authenticity and security of interactions between users, significantly minimize the existence of scammers and fake profiles on the Portal, which together, would greatly enhance the safety of our Portal’s registered account holders and uplift their user experience, we have incorporated an identity verification service through the use of our HappyMatches.com Face Verification Process (“'),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Face Verification Services')
								])),
							$rtfeldman$elm_css$Html$Styled$text('”), to verify users who agree to undertake the verification process.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('We provide the Face Verification Services through the use of our proprietary platform and third party verification services, which utilizes and combines human authenticity checks, facial recognition technology, database and algorithmic checks, and all enhancements, features and improvements thereto.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('By using our Face Verification Services, you agree to the collection and use of your relevant personal data by us and our trusted third party verification services partners for the purposes of our face verification process and procedures. We have put in place process checks to verify that it is a real person in front of the camera (through a series of actions such as smiling and blinking), procedures to capture and store an image (and related information) of you in the databases to aid us in our anti-scammer detection and prevention measures (which uses advanced image detection and verification technology and algorithms, and also converts your image into user-unidentifiable image vertices data). Your image (and related information) obtained under our Face Verification Services will only be used as described in this section and will not be accessible to other users and visitors of the Portal, and we will strictly use such personal information in accordance with this Privacy Policy.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('D) Collection of Personal Information:')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('When you use the HappyMatches.com Portal and Services, we may collect personal information which includes the following:')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('1. name and email address;'),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							$rtfeldman$elm_css$Html$Styled$text('2. photos and videos;'),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							$rtfeldman$elm_css$Html$Styled$text('3. profile information, including age, birthday, gender, ethnicity, height, body type, location(s), preferred types of relationships and profile description;  '),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							$rtfeldman$elm_css$Html$Styled$text('4. face verification information (see above); and'),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							$rtfeldman$elm_css$Html$Styled$text('5. payment information to subscribe to our paid Services (see below).')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Our Portal also automatically receives and records information on our server logs from your browser, including your IP address, browser type and HappyMatches.com cookie information. HappyMatches.com uses this information to personalize the content you see, to fulfil your requests for Services, to inform you of updates to our Services, and you agree that we may alert you and send you information and materials on our new and existing services and products which we believe may be of interest to you.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('E) Interactive Features:')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('We may offer interactive features such as forums, blogs, chat and messaging services, and social media pages. We and others who use the Portal and our Services may collect the information you submit or make available through these interactive features. Any content you provide on the public sections of these features will be considered “public” and is not subject to the privacy protections referenced herein. By using these interactive features, you assume the risk that the personal information provided by you may be viewed and used by third parties for their own purposes.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('F) Information Collected Automatically:')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('We may collect certain information automatically when you use the Portal and our Services. This information may include your registration date, Internet protocol (IP) address, user settings, MAC address, cookie identifiers, mobile carrier, details about your browser, operating system or device, location information (including inferred location based off of your IP address), Internet service provider, pages that you visit before, during and after using the Portal and the Services, information about the links you click, information about how you interact with the Portal and the Services, including the frequency and duration of your activities, and other information about how you use the Services. Information we collect may be associated with accounts and other devices.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('We only use such data anonymously and in the aggregate. This information helps us determine what is the most beneficial for our users and how we can continually create a better overall user experience. We may share this information with our partners, but only in the aggregate, so that they may also understand how our visitors use our Portal.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('4. SPECIFIC INFORMATION')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('In certain cases, when you signup to use a Service, respond to an offer, submit your profile, or purchase a product or Service, for example, we may collect more specific information about you, such as your name, address, phone number, email, credit card number, etc. During your visit to our Portal, we may also ask you for other information, such as information on your interests, likes and dislikes regarding the Portal, etc., in an effort to deliver the best user experience. Personal information collected are used solely by HappyMatches.com and are never sold or given to third parties for any purpose without your explicit consent. We also provide you with the opportunity to opt-opt out of several types of communications at the time of registration. If you choose to receive these types of communications at the time of registration, but later decide you no longer want to receive them, simply change your preferences on your account setting or communicate your preferences to us via email.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('5. GENERAL DISCLOSURE INFORMATION')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Except as described in this Privacy Policy, we do not disclose information about your individual visits to HappyMatches.com, or personal information you provide, such as your name, address, email, phone number, credit card number, etc., to any third parties, except when we believe it is required by law or regulatory bodies, or to protect HappyMatches.com, our users or others. However, we may record and share aggregate information with our partners. We employ other companies and individuals to perform functions on our behalf. Examples may include hosting our web servers, analyzing data, providing marketing services, processing credit card payments, and other services. These companies may have access to your personal information as necessary to perform their functions, but they may not share that information with any third party.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('6. DISCLOSURE FOR ACCOUNTS PAYABLE OR COLLECTIONS')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('It is your duty to make sure that your keep your account(s) in good standing with us.   If you have an outstanding balance, or if you dispute you payment to us with your credit card or financial institution for any reason, please note that all information collected from your activity on our Portal may be disclosed to the bank and/or collections agency we work with for the purposes of establishing proof of user’s identify, proof of use, proof that Services were provided, and/or collecting any outstanding debt owed to us.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('7. UPDATING ACCOUNT INFORMATION')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com allows you to change your personal information at any time. To do so, simply logon to HappyMatches.com with your username and password, and you will be able to update the information you have submitted.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('8. ONLINE TRANSACTIONS')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('When you place an order online, your personal details and credit card information are encrypted using SSL encryption technology before being sent over the Internet. Although we cannot guarantee encryption or the privacy of your personal details, SSL makes it very difficult for your information to be stolen or intercepted while being transferred.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('9. COOKIES')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('To enhance your experience at HappyMatches.com and to access member Services, we use a feature on your Internet browser called a ‘cookie’. Cookies are small files that your web browser places on your computer’s hard drive. We use cookies for remembering user preferences, user sessions, tracking visits to understand visitor behavior, and planning for increased loads. Because of our use of cookies, we can deliver faster and better Services and a more personalized portal experience. You have the option of setting your browser to reject cookies. However, doing so may affect the speed and performance when you use the Portal and our Services.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('10. PRIVACY POLICY CHANGES')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('If we decide to change our Privacy Policy, we will post those changes here so that you will always know what information we gather, how we might use that information, and whether we will disclose it to anyone. If at any time you have questions or concerns about our Privacy Policy, please feel free to email us at '),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ht),
									$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto: hello@happymatches.com')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$b,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Privacy$styles.ke)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('hello@happymatches.com')
										]))
								])),
							$rtfeldman$elm_css$Html$Styled$text('. HappyMatches.com uses reasonable precautions to keep personal information disclosed to us secure. However, we are not responsible for any breach of security. This Privacy Policy is not intended to, and does not, create any contractual or other legal rights in or on behalf of any party.')
						]))
				]))
		]));
var $rtfeldman$elm_css$Css$lowerAlpha = {f: 0, e: 0, v: 'lower-alpha'};
var $rtfeldman$elm_css$Css$lowerRoman = {f: 0, e: 0, v: 'lower-roman'};
var $author$project$Page$Terms$styles = {
	ke: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs)
		]),
	kf: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.fs),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	gT: $author$project$View$Theme$defaultStyles.lC,
	ht: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
		]),
	G: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$lowerAlpha)
			])),
	hu: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$lowerRoman)
			])),
	bJ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(23)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$justify)
			])),
	nD: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lC,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingTop(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(18))
			])),
	jn: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(40),
			$rtfeldman$elm_css$Css$px(10)),
			A2($rtfeldman$elm_css$Css$margin2, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(800))
		])
};
var $author$project$Page$Terms$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_Nil,
	_List_fromArray(
		[
			A5(
			$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
			$author$project$View$Hero$view,
			$author$project$View$Theme$images.jN.mj,
			$author$project$View$Theme$images.jN.j3,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Hero$title('Terms of Use'),
					$author$project$View$Hero$paragraph(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Everyone has to play by the rules so we can ensure a fair and safe place for everybody.')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.jn)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.gT)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('AGREEMENT FOR USE OF HAPPYMATCHES.COM')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('(Last revised on 28 December 2020)')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('By accessing the HappyMatches.com portal, including through any mobile applications (and any social media/social networking sites of third parties used by HappyMatches.com and/or the Company) (collectively, the '),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('“Portal”')
								])),
							$rtfeldman$elm_css$Html$Styled$text('), you agree to be bound by these Terms of Use (this '),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('“Agreement”')
								])),
							$rtfeldman$elm_css$Html$Styled$text(' and the Company\'s '),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ht),
									$rtfeldman$elm_css$Html$Styled$Attributes$href('/privacy-policy')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Privacy Policy')
								])),
							$rtfeldman$elm_css$Html$Styled$text(', regardless whether or not you register as a member of HappyMatches.com.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com is operated by Z9 Tech Private Limited, which is sometimes referred to herein as '),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('“HappyMatches.com”')
								])),
							$rtfeldman$elm_css$Html$Styled$text(' or the '),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('“Company”')
								])),
							$rtfeldman$elm_css$Html$Styled$text('. If you wish to visit the Portal or to become a member and make use of the services of HappyMatches.com (the '),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('“Services”')
								])),
							$rtfeldman$elm_css$Html$Styled$text('), please read this Agreement carefully.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('The Terms of Use are as set forth in English. You should not rely on any non-English translation. You shall refer to the English Terms in the event of any discrepancies or inconsistencies.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('In particular, you confirm that you have complied/will comply with the following:')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('1. Age: ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('You must be at least 18 years of age to use the Services. You will not use the Services if you are currently under 18 years of age.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('2. Illegal Activities: ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('You will not promote any illegal commercial activities (such as prostitution, escorting, payment-for-sex, gambling, scams, etc.).')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('3. Be Respectful: ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('You will treat every Member of the HappyMatches Portal politely and with utmost respect.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('4. Be Authentic: ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('You will display your real photos, personal information and be honest about the type of relationship you want, and what you are looking for in your Suitor/Date.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('5. Enjoy the Interaction and Make the Most of It: ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('Get to know the Suitors/Dates who interest you, and enjoy your interactions with them on the HappyMatches Portal. Make it a point to meet up with those whom you like and feel comfortable with.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('6. Take All Necessary Precautions for Your Personal Safety: ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('For your own safety, you should not share your mobile phone number, personal contact details and home/work address with any Suitor/Date, unless you have met up with him/her in person and feel sufficiently comfortable with him/her. The REAL-TIME CHAT function of the HappyMatches Portal offers you a safe and reliable platform to communicate with Suitors/Dates, arrange your first meet up and engage in subsequent interactions.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('We hold our community to very high standards and will not hesitate to remove any members (and report you to the police/relevant government authorities) if you violate any of the above requirements or the terms of this Agreement.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('IF YOU DO NOT ACCEPT AND AGREE TO BE BOUND BY ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT OR YOU DO NOT MEET OR COMPLY WITH ITS PROVISIONS, DO NOT USE THE PORTAL OR THE SERVICES.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please review this Agreement carefully, including the Arbitration provision below, which describes how Disputes (defined below) will be resolved between us, and that no class actions may be brought under this Agreement. In order to proceed with this Agreement and to access the Services of the Portal, you must agree to these terms and click the “I Agree” Box to acknowledge you agree that this Agreement is subject to an Arbitration agreement. I Agree.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('1. Binding Agreement')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.G)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('This Agreement is an electronic contract that sets out the legally binding terms you must accept to use the Portal and to become a “Member.” For purposes of this Agreement, the term “Member” or “Membership” means a person who provides information to the Company on the Portal to participate in the Services in any manner, whether such person uses the Services as a free member or a paid subscriber. '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('This Agreement may be modified by HappyMatches.com in its sole discretion at any time, and any such modifications will be posted onto the Portal. Your continued use of the Portal or the Services after the posting of modifications to this Agreement will constitute your acceptance of such revisions.')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('This Agreement includes HappyMatches.com’s Acceptable Use Policy below for Content (as herein defined) posted on the Portal, HappyMatches.com’s Privacy Policy, any notices regarding the Portal, and terms disclosed and agreed to by you if you become a Member or if you purchase or accept additional features, products, or services we offer on the Portal, such as state-specific terms and terms governing features, billing, free trials, discounts, and promotions.')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('2. Eligibility')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.G)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You must be at least eighteen (18) years old to access and register as a Member, use the Portal and/or the Services. You note that you may violate (and/or cause others to violate) the applicable laws of a country or state if you access and register as a Member, use the Portal and/or the Services before you turn eighteen (18) years old, and therefore you '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('SHALL NOT')
												])),
											$rtfeldman$elm_css$Html$Styled$text(' access and register as a Member, use the Portal and/or the Services unless and until you are eighteen (18) years old and above.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Membership in the Services is void where prohibited or illegal in any country or state. You shall not access and register as a Member, use the Portal and/or the Services if the Services are prohibited or illegal in your country or state. In particular, you shall not access and register as a Member, use the Portal and/or the Services, anywhere in the world, if you are a citizen or permanent resident of the Republic of Singapore.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('By using the Portal, you represent and warrant that you have the right, authority, and capacity to enter into this Agreement and to abide by all of the terms and conditions of this Agreement.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('If you become a Member of the Portal, you represent and warrant that you have never been convicted of a felony or any criminal act (whether in your country, state or in any other country or state), and that you are not required to register as a sex offender or with any reciprocal designation with any government entity.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You will only use the Services in a manner consistent with this Agreement and any and all applicable local, state, national and international laws and regulations, including, but not limited to, United States export control laws.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('By using the Services, you represent that you have not been designated by the United States government (or the government of any other country or state) as a “Specially Designated National” (or its equivalent) or other person to whom the provisions of the Services are prohibited. Registration for, and use of, the Services are void where prohibited.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You are responsible for determining whether the use of the Services is legal or illegal in your jurisdiction.')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('3. Term and Termination')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('This Agreement will remain in full force and effect while you use the Portal and/or are a Member. You may terminate your Membership at any time, for any reason by following the instructions on the Deactivate Account section in Account Settings, by writing an email to HappyMatches.com at '),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ht),
									$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto: hello@happymatches.com')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$b,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('hello@happymatches.com')
										]))
								])),
							$rtfeldman$elm_css$Html$Styled$text(', upon receipt by HappyMatches.com of your written or email notice of termination, or simply upon deletion of your Membership at any time at the sole discretion of HappyMatches.com (with or without providing a reason).')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com may terminate your Membership for any reason, which shall be effective upon either (1) the deletion of your Membership at any time at the sole discretion of HappyMatches.com (with or without providing a reason), or (2) sending notice to you at the email address you have provided in your application for Membership, or such other email address as you may later provide to HappyMatches.com.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('If HappyMatches.com terminates your Membership in the Services because it believes you have breached the Agreement, you will not be entitled to any refund of unused subscription fees or unused credits.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('If your Membership is terminated for any reason, all terms of this Agreement survive such termination, and continue in full force and effect, except for any terms that by their nature expire or are fully satisfied.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('4. Non-Commercial Use by Members')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('The Portal and the Services is for personal use only. Members may not use the Services in connection with any commercial endeavors such as (i) advertising or soliciting any user to buy or sell any products or services not offered by the Company or (ii) soliciting others to attend parties or other social functions, or networking, for commercial purposes. Organizations, companies, agencies, and/or businesses may not become Members and should not use the Services or the Portal for any purpose. Illegal and/or unauthorized uses of the Portal, including collecting usernames and/or email addresses of Members by electronic or other means for the purpose of sending unsolicited email and unauthorized framing of or linking to the Portal may be investigated, and appropriate legal action may be taken, including without limitation, civil, criminal, and injunctive redress. Users of the Portal may not use any information obtained from the Services to contact, advertise, solicit, or sell to any other user without his or her prior explicit consent. The Company may investigate and take any available legal action in response to illegal and/or unauthorized uses of the Portal, including referring activities the Company deems suspicious to governmental authorities.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('5. Account Security')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Your account is for your personal use only. You are responsible for maintaining the confidentiality of the username and password you designate during the registration process, and you are solely responsible for all activities that occur under your username and password. You acknowledge that HappyMatches.com is not responsible for third-party access to your account that results from theft or misappropriation of your username or password.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('6. Risk Assumption and Precautions')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.G)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('IS NOT RESPONSIBLE FOR THE CONDUCT, WHETHER ONLINE OR OFFLINE, OF ANY USER OF THE PORTAL OR MEMBER OF THE SERVICES. YOU ASSUME ALL RISKS WHEN USING THE SERVICES, INCLUDING BUT NOT LIMITED TO ALL OF THE RISKS ASSOCIATED WITH ANY ONLINE OR OFFLINE INTERACTIONS WITH OTHER MEMBERS, INCLUDING DATING OR SENDING MONEY TO ANOTHER MEMBER. YOU AGREE TO TAKE ALL NECESSARY PRECAUTIONS WHEN MEETING INDIVIDUALS THROUGH THE SERVICES.')
												])),
											$rtfeldman$elm_css$Html$Styled$text('You should not provide your financial information (for example, your credit card or bank account information), or wire or otherwise send money, to other Members. Even if you have met them in person and feel sufficiently comfortable with them, any provision of your financial information to them is entirely of your own decision for which the Company is neither liable nor responsible for.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com DOES NOT CURRENTLY CONDUCT CRIMINAL BACKGROUND SCREENINGS ON ITS MEMBERS. ')
												])),
											$rtfeldman$elm_css$Html$Styled$text('However, HappyMatches.com reserves the right to conduct any criminal background check, at any time and using available public records. '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('BY AGREEING TO THESE TERMS AND CONDITIONS, YOU HEREBY AUTHORIZE ANY SUCH CHECK.')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Whilst HappyMatches.com does verify some Members based on the relevant information/documents which the Member provides to HappyMatches.com (and Members who pass such a background verification will have a “Verified” mark/badge displayed on their profile), you understand and agree that HappyMatches.com makes no guarantees, express or implied, regarding the accuracy or reliability of such background verification and/or “Verified” mark/badge, and in no event will HappyMatches.com be liable for any damages whatsoever, whether direct, indirect, general, special, compensatory, consequential, and/or incidental, arising out of or relating to the background verification and/or “Verified” mark/badge.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You understand that HappyMatches.com makes no guarantees, either express or implied, regarding your ultimate compatibility with individuals you meet through the Services or as to the conduct of such individuals.')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('7. Proprietary Rights')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Z9 Tech Inc. owns and retain all proprietary rights in the Portal and the Services, and in all content, trademarks, trade names, service marks, and other intellectual property rights related thereto. The Portal contains the copyrighted material, trademarks, and other proprietary information of Z9 Tech Inc.. Except for that information which is in the public domain or for which you have been given written permission, you may not copy, modify, publish, transmit, distribute, perform, display, or sell any such proprietary information. You agree to not remove, obscure or otherwise alter any proprietary notices appearing on any content, including copyright, trademark and other intellectual property notices.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('8. Acceptable Portal Use')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.G)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('(You are solely responsible for the content and information that you post, upload, publish, link to, transmit, record, display or otherwise make available (hereinafter, “Post” or “Posting”) on the Portal or as part of the Services or transmit to other Members, including emails, videos (including streaming videos), photographs, voice notes, recordings or profile text, whether publicly posted or privately transmitted (collectively, “Content”). You may not Post on the Portal or as part of the Services, or transmit to HappyMatches.com or any other Member (either on or off the Portal), any material (i) in violation of any applicable laws or regulations, (ii) in a manner that will infringe the copyright, trademark, trade secret or other intellectual property rights of others or violate the privacy, publicity or other personal rights of others, or (iii) in a manner that is offensive, inaccurate, profane, intimidating, defamatory, obscene, threatening, abusive or hateful. You represent and warrant that all information that you submit upon registration is accurate and truthful and that you will promptly update any information provided by you that subsequently becomes inaccurate, misleading or false.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com reserves the right, but has no obligation, to monitor any Content you post on the Portal or as part of the Services. HappyMatches.com will have the right to remove any Content that in its sole opinion violates, or may violate any applicable law or either the letter or spirit of this Agreement or upon the request of any third party.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('By Posting Content on the Portal or as part of the Services, you automatically grant an irrevocable, perpetual, non-exclusive, fully paid-up, worldwide right and license to (i) use, copy, store, perform, display, reproduce, record, play, adapt, modify and distribute the Content, (ii) prepare derivative works of the Content or incorporate the Content into other works, and (iii) grant and authorize sublicenses of the foregoing in any media now known or hereafter created.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You are prohibited from violating or attempting to violate the security of the Portal, including, without limitation, (i) accessing data not intended for you or logging into a server or account which you are not authorized to access; (ii) attempting to probe, scan, or test the vulnerability of a system or network or to breach security or authentication measures without proper authorization; (iii) attempting to interfere with or disrupt the Services or the Portal including, without limitation, by way of submitting a virus to the Portal, overloading, flooding, spamming, mail bombing, or crashing; (iv) sending unsolicited email, including promotions and/or advertising of products or services; (v) forging headers or otherwise manipulating identifiers in order to disguise the origin of any information transmitted to or through the Portal or Services (either directly or indirectly through use of third-party software); (vi) using (or attempting to use) any engine, software tool, agent, or other device or mechanism any robot, spider, site search/retrieval application, or other manual or automatic device or process to retrieve, index, “data mine,” or in any way reproduce or circumvent the navigational structure or presentation of the Portal, the Services or its Contents; (vii) modifying, adapting, sublicensing, translating, selling, reverse engineering, deciphering, decompiling or otherwise disassembling any portion of the Services or the Portal or any software used on or for the Services or the Portal, or cause others to do so.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('The Portal may be used only for lawful purposes by individuals seeking friendship and love. As one of the conditions of your use of the Portal and the Services, you represent, warrant, and agree that you will not use (or plan, encourage, or help others to use) the Portal and the Services for any purpose or in any manner that is prohibited by these terms, conditions and notices, or by applicable law (including but not limited to any applicable export controls). It is your responsibility to ensure that your use of the Portal and the Services complies with this Agreement and to seek prior written consent from HappyMatches.com for any uses not permitted or not expressly specified herein. HappyMatches.com specifically prohibits any use of the Portal or the Services, and you hereby agree not to use the Portal or the Services, for any of the following:'),
											A2(
											$rtfeldman$elm_css$Html$Styled$ul,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.hu)
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Posting any incomplete, false, misleading, or inaccurate Content about yourself and/or your profile;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Posting any Content that is not entirely your own or for which you do not have full rights to use;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Impersonating, or otherwise misrepresenting an affiliation, connection or association with, any person or entity;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('If you have a password, allowing any other person to access a non-public area of the Portal, disclosing to or sharing your password with any third parties, or using your password for any unauthorized purpose; using meta tags or code or other devices containing any reference to the HappyMatches.com, the Portal or the Services (or any trademark, trade name, service mark, logo or slogan of HappyMatches.com) to direct any person to any other website or URL for any purpose;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Soliciting passwords or personal identifying information for commercial or unlawful purposes from other users;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Posting or sending material that exploits people under the age of 18, or solicits personal information from anyone under 18, furthermore, failing to report knowledge of a person under the age of 18 to HappyMatches.com, or continuing to use the site to interact in any way with anyone you know is under the age of 18 will result in termination of your Membership.')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Engaging in advertising to, or solicitation of, other Members to send money, buy or sell any products or services. You may not transmit any chain letters or junk email to other Members. If you breach the terms of this subsection and send or post unsolicited bulk email, “spam,” or other unsolicited communications of any kind through the Services, you acknowledge that you will have caused substantial harm to HappyMatches.com, but that the amount of such harm would be extremely difficult to ascertain. As a reasonable estimation of such harm, you agree to pay HappyMatches.com USD 500 for each such unsolicited communication you sent through the Services;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Soliciting gambling or engaging in any gambling or similar activity;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Using the Portal as an escort or prostitute or using the Services to solicit clients for an escort or prostitution service;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Initiating contact with members off site by any other means, without first obtaining explicit permission from them to do so via the Portal;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Posting advertisements or solicitations of employment, business, or pyramid schemes;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Using the Portal or Services to promote, solicit, or engage in prostitution;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Using the Portal or Services for activities that violate any law, statute, ordinance, or regulations;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Using the Portal or Services to encourage, promote, facilitate, or instruct others to engage in illegal activity;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Engage in any activity that violates criminal laws of the jurisdiction in which the Member resides, visits or contacts Members;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Engage in any activity that facilitates or constitutes human trafficking;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Stalking or otherwise harassing any other Members or Company employees or representatives;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('\"Frame\" or \"mirror\" any part of the Services or the Portal, without the Company\'s prior written authorization;')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Any competitive purpose, including copying, soliciting, competitive or market analysis, or any other use by a competitor; and')
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$p,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Recruiting for (including pornography, modelling, prostitution, escort or brothels), or for any other prohibited or illegal activities.')
																]))
														]))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Commercial and Competitive Violations; Liquidated Damages; No Right to Arbitration for Commercial and Competitive Violations. ')
												])),
											$rtfeldman$elm_css$Html$Styled$text('Commercial and competitive users in violation of the Portal acknowledge that they are not actual users of the Portal and do not have available to them any of the rights or protections afforded to genuine users under this Agreement or the law. '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Each and every commercial or competitive use of the site in violation of this Agreement is subject to a USD 500,000 award for damages as liquidated damages for such breach. ')
												])),
											$rtfeldman$elm_css$Html$Styled$text('You acknowledge that any commercial or competitive use of this Portal will cause harm in an amount that would be extremely difficult to ascertain and that USD 500,000 for each and every commercial or competitor violation is a reasonable estimate of such harm. Commercial and competitive violations are not subject to the arbitration provisions herein and in no event are able to invoke arbitration rights as to any claims by any party concerning commercial and competitive violations of this Agreement, including expressly waiving herein any right to determine the arbitrability of such claims.')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('9. No Harassment of HappyMatches.com Personnel')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('You will not harass, annoy, intimidate, or threaten any HappyMatches.com personnel engaged in providing any portion of the Services to you. If we feel that your behavior towards any of our personnel is at any time threatening or offensive, we reserve the right to immediately terminate your membership and you will not be entitled to any refund of unused subscription fees.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('10. Copyright Policy; Notice and Procedure for Making Claims of Copyright Infringement')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('You may not post, distribute, or reproduce in any way any copyrighted material, trademarks, or other proprietary information without obtaining the prior written consent of the owner of such proprietary rights. Without limiting the foregoing, if you believe that your work has been copied and posted on the Services in a way that constitutes copyright infringement, please provide our Copyright Agent at '),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ht),
									$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto: hello@happymatches.com')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$b,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('hello@happymatches.com')
										]))
								])),
							$rtfeldman$elm_css$Html$Styled$text(', with the following information: an electronic or physical signature of a person authorized to act on behalf of the copyright owner; identification of the copyrighted work that you claim is being infringed; identification the material that is claimed to be infringing and where it is located on the Portal; information reasonably sufficient to permit HappyMatches.com to contact you, such as your address, telephone number, and email address; a statement that you have a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law; and a statement, made under penalty of perjury, that you are the copyright owner or authorized to act on the copyright owner\'s behalf. Only copyright notices will be accepted at the above email address. All other inquiries or requests will be discarded.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('11. Subscription and Membership')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.G)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You must provide current, complete, and accurate information for your Billing Account. You must promptly update all information to keep your Billing Account current, complete, and accurate (such as a change in billing address, card number, or expiration date), and you must promptly notify HappyMatches.com if your payment method is cancelled (including if you lose your card or it is stolen), or if you become aware of a potential breach of security (such as an unauthorized disclosure or use of your name or password). Changes to such information can be made at “Account Settings” on the Portal. If you fail to provide us any of the foregoing information, you agree that you are responsible for fees accrued under your Billing Account. In addition, you authorize us to obtain updated or replacement expiration dates and card numbers for your credit or debit card as provided by your credit or debit card issuer.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You agree that all payments made on the Portal are final, and you will not challenge or dispute the charge with your bank. You further agree that should you have any issues relating to your payment (such as duplicate billing), you will open a support ticket through the Portal to resolve the issue. Should a dispute be initiated with your bank, you agree that you will be held responsible for any outstanding balance owed to us plus any dispute case fees charged by our bank, which may be as much as USD 100. You agree that you will pay any outstanding balance you have with HappyMatches.com within 30 days from the date of notification. Any outstanding balance left unpaid after 30 days may be submitted to a collections agency, and you agree that a collections fee of up to 50% of the outstanding balance or USD 150 (whichever is higher) will be added to the amount that you owe.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('In order to provide continuous service, HappyMatches.com provides the option for automatic renewal. '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('IF THE AUTOMATIC RENEWAL OPTION OR CHECKBOX IS SELECTED DURING THE PAYMENT PROCESS, HappyMatches.com WILL AUTOMATICALLY RENEW ALL PAID SUBSCRIPTIONS FOR THE SERVICES ON THE DATE SUCH SUBSCRIPTIONS EXPIRE. ')
												])),
											$rtfeldman$elm_css$Html$Styled$text('After your initial subscription commitment period, and again after any subsequent subscription period, your subscription will automatically continue for an additional equivalent period. By entering into this Agreement, you acknowledge that your account will be subject to the above-described automatic renewals if you selected the automatic renewal option. If you do not wish your account to renew automatically, or if you want to change or terminate your subscription, please log in and go to “Account Settings” on the Portal and follow the directions contained therein.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com MAINTAINS A STRICT NO-REFUND POLICY. ALL PURCHASES MADE ON THE PORTAL ARE FINAL. IF YOU CHOOSE TO PURCHASE A SUBSCRIPTION PACKAGE ON THE PORTAL, YOU AGREE THAT ABSOLUTELY NO REFUNDS, EITHER FULL OR PARTIAL, WILL BE ISSUED FOR ANY REASON OR FOR ANY UNUSED OR REMAINING SUBSCRIPTION. FURTHER, YOU AGREE THAT NO REFUNDS WILL BE MADE ON ANY REMAINING OR UNUSED SUBSCRIPTION OR CREDITS.')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('When you deactivate your HappyMatches.com account or when your account is suspended for violating this Agreement or other policies, you agree that any remaining or unused subscription and credits will be forfeited and no refunds will be issued for any remaining or unused membership subscription and credits. Further, if your deactivated HappyMatches.com account is reinstated at a later date, you agree that any remaining or unused membership subscription and credits you have remaining at the time of your account deactivation will not be reinstated with your account.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Subscription or credits purchased for a specific HappyMatches.com account is strictly non-transferable. You agree that any remaining or unused membership subscription or credits associated with an active or deactivated HappyMatches.com account will not be transferred to any other account belonging to you or someone else.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com reserves the right to offer free or discounted membership to any person(s) of its choice at any given time, for any duration, while charging other members, at the same time. HappyMatches.com also reserves the right to cancel the free trial period at any time, for all or any of its Members. A Member profile (both subscribers and a free membership) may remain posted on the Portal even if that Member is not actively using the Services. You acknowledge that although a member’s profile may be viewed, you may not (even as a subscriber) be able to use the Services to communicate with that member if he or she is not then actively using the Services.')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('12. Services and Modification to the Portal')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com does not guarantee that the Portal will be fully operational all the time. Members may face significant service disturbances. Only in the event that the Portal is offline for a period of more than 72 hours, will a pro-rated refund be given. HappyMatches.com '),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('DOES NOT OFFER TECHNICAL SUPPORT')
								])),
							$rtfeldman$elm_css$Html$Styled$text('. We will offer support only for the Services related to the Portal. The Company reserves the right at any time to modify or discontinue, temporarily or permanently, the Portal or the Services (or any part thereof) with or without notice to any Member, group of Members or all Members. You agree that the Company shall not be liable to you or to any third party for any modification, suspension or discontinuance of the Services. To protect the integrity of the Portal or the Services, the Company reserves the right at any time in its sole discretion to block users from certain IP addresses from accessing the Portal or Services.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('13. User Information')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.G)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('When you register for our Services on the Portal, you will be asked to provide us with certain information, including but not limited to a valid email address (your “User Information”). HappyMatches.com\'s right to use your User Information is described in our Privacy Policy. Please see our Privacy Policy for further details regarding use of your User Information. HappyMatches.com reserves the right to offer third-party services and products to you based on the preferences that you identify in your User Information and at any time thereafter; such offers may be made by us or by third parties.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You acknowledge and agree that HappyMatches.com may disclose in whole or in part your User Information if required to do so by law, at the request of a third party, or if we, in our sole discretion, believe that disclosure is reasonable to (1) comply with the law, requests or orders from law enforcement, or any legal process (whether or not such disclosure is required by applicable law); (2) protect or defend HappyMatches.com’s, or a third party’s, rights or property; or (3) protect someone’s health or safety, such as when harm or violence against any person (including the user) is threatened.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Notwithstanding any other provision of this Agreement or the Privacy Policy, HappyMatches.com reserves the right, but has no obligation, to disclose any information that you submit to the Services, if in its sole opinion, HappyMatches.com suspects or has reason to suspect, that the information involves a party who may be the victim of abuse in any form. Abuse may include, without limitation, elder abuse, child abuse, spousal abuse, neglect, or domestic violence. Information may be disclosed to authorities that HappyMatches.com, in its sole discretion, deems appropriate to handle such disclosure. Appropriate authorities may include, without limitation, law enforcement agencies, child protection agencies, or court officials. You hereby acknowledge and agree that HappyMatches.com is permitted to make such disclosure.')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('14. Links')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('The Portal may contain, and the Services may provide, links to sites that are not maintained by HappyMatches.com. While we try to include links only to those sites which are in good taste and safe for our users, we are not responsible for the content or accuracy of those sites and cannot guarantee that sites will not change without our knowledge. The inclusion of a link in the Portal does not imply our endorsement of the linked site. If you decide to access linked third-party websites, you do so at your own risk. Your correspondence or business dealings with, or participation in promotions of, third parties found on or through the Portal or Services, including payment and delivery of related goods or services, and any other terms, conditions, warranties or representations associated with such dealings, are solely between you and such third party. You further acknowledge and agree that HappyMatches.com shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of, or reliance upon, any such content, information, statements, advertising, goods or services or other materials available on or through any such website or resource.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('15. Disclaimers')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.G)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com is not responsible for any incorrect or inaccurate Content posted on the Portal or in connection with the Services, whether caused by users of the Portal, Members or by any of the equipment or programming associated with or utilized in the Services.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com is not responsible for the conduct, whether online or offline, of any user of the Portal or Member of the Services.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com is not responsible for any error, omission, interruption, deletion, defect, delay in operation or transmission, communications line failure, theft or destruction or unauthorized access to, or alteration of, user or Member communications.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com is not responsible for any problems or technical malfunction of any telephone network or lines, computer online systems, servers or providers, computer equipment, software, failure of email or players on account of technical problems or traffic congestion on the Internet or at any website or combination thereof, including injury or damage to users and/or Members or to any other person’s computer related to or resulting from participating or downloading materials in connection with the Web and/or in connection with the Services.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Under no circumstances will HappyMatches.com be responsible for any liability, loss, damage, costs or expenses, including money, property, personal injury or death, resulting from anyone’s use of the Portal or the Services, any Content posted on the Portal or transmitted to Members, or any interaction or contact between users of the Portal, whether online or offline.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('THIS SITE IS FOR ENTERTAINMENT AND INFORMATIONAL PURPOSES ONLY. TO THE MAXIMUM EXTENT ALLOWED BY APPLICABLE LAW, HappyMatches.com PROVIDES THE PORTAL AND SERVICES ON AN “AS IS” AND “AS AVAILABLE” BASIS AND GRANTS NO WARRANTIES OF ANY KIND, EITHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE WITH RESPECT TO THE SERVICES OR THE PORTAL (INCLUDING ALL CONTENT CONTAINED THEREIN) INCLUDING (WITHOUT LIMITATION) ANY IMPLIED WARRANTIES OF SATISFACTORY QUALITY, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, EXPECTATIONS OF PRIVACY, OR NON-INFRINGEMENT. HappyMatches.com DOES NOT WARRANT THAT THE PORTAL OR SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, SECURE, OR THAT ANY DEFECTS OR ERRORS WILL BE CORRECTED.')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('ANY MATERIAL DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE SERVICES OR PORTAL IS ACCESSED AT YOUR OWN DISCRETION AND RISK, AND YOU WILL BE SOLELY RESPONSIBLE FOR AND HEREBY WAIVE ANY AND ALL CLAIMS AND CAUSES OF ACTION WITH RESPECT TO ANY DAMAGE TO YOUR COMPUTER SYSTEM, INTERNET ACCESS, DOWNLOAD OR DISPLAY DEVICE, OR LOSS OR CORRUPTION OF DATA THAT RESULTS OR MAY RESULT FROM THE DOWNLOAD OF ANY SUCH MATERIAL. IF YOU DO NOT ACCEPT THIS LIMITATION OF LIABILITY, YOU ARE NOT AUTHORIZED TO DOWNLOAD OR OBTAIN ANY MATERIAL THROUGH THE SERVICES OR PORTAL.')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('From time to time, HappyMatches.com may make third-party opinions, advice, statements, offers, or other third-party information or content available on the Portal and/or through the Services. All third-party content is the responsibility of the respective authors thereof and should not necessarily be relied upon. Such third-party authors are solely responsible for such content. '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com DOES NOT: (I) GUARANTEE THE ACCURACY, COMPLETENESS, OR USEFULNESS OF ANY THIRD-PARTY CONTENT ON THE PORTAL OR PROVIDED THROUGH THE SERVICES, OR (II) ADOPT, ENDORSE OR ACCEPT RESPONSIBILITY FOR THE ACCURACY OR RELIABILITY OF ANY OPINION, ADVICE, OR STATEMENT MADE BY ANY PARTY THAT APPEARS ON THE PORTAL OR SERVICES. UNDER NO CIRCUMSTANCES WILL HappyMatches.com OR ITS AFFILIATES BE RESPONSIBLE OR LIABLE FOR ANY LOSS OR DAMAGE RESULTING FROM YOUR RELIANCE ON INFORMATION OR OTHER CONTENT POSTED ON THE PORTAL OR SERVICES, OR TRANSMITTED TO OR BY ANY MEMBERS.')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('HappyMatches.com cannot guarantee and does not promise any specific results from use of the Portal and/or the Services.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('This Portal is only a venue – it acts as a venue for individuals to post personal and contact information for the purposes of dating and relationships. HappyMatches.com is not required to screen or censor information posted on the Portal, including but not limited to the identity of any user. We are not involved in any actual communication between Members. As a result, we have no control over the quality, safety, or legality of the information or profiles posted, or the truth or accuracy of such information. You agree you are solely responsible for your interactions with other Members. HappyMatches.com reserves the right, but has no obligation, to monitor disputes between you and other Members. This includes, but is not limited to, conversations via regular email, dates, relationships, phone calls, meetings, he said/she said accusations or any other correspondence or interaction that occur outside of the scope of the Portal. The Portal is a tool for providing the initial contact between Members, anything beyond that is not in our control and is done so at the Members’ own risk. Members have to use common sense about what information they reveal to others via email or any other means of communication. It is your responsibility to investigate Members and agree that you will verify they are legitimate date seekers. There are many different frauds, schemes, and deceptions on the Internet, and we strongly caution you to be skeptical of any Member until you learn more about them and verify their background.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('In addition to the preceding information under this Agreement, any advice or thoughts that may be posted on the Portal or through the Services provided for under this Agreement is for informational and entertainment purposes only and is not intended to replace or substitute for any professional financial, medical, legal, or other advice. The Company makes no representations or warranties and expressly disclaims any and all liability concerning any treatment, action by, or effect on any person following the information offered or provided within or through the Portal. If you have specific concerns or a situation arises in which you require professional or medical advice, you should consult with an appropriately trained and qualified specialist and seek immediate attention of the proper personnel.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You specifically acknowledge and agree that HappyMatches.com is not liable for your defamatory, offensive, infringing or illegal materials or conduct or that of third parties, and we reserve the right to remove such materials from the Portal without liability.')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('16. Limitation of Liability')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.G)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL HappyMatches.com BE LIABLE FOR ANY INCIDENTAL, SPECIAL, CONSEQUENTIAL OR INDIRECT DAMAGES ARISING OUT OF OR RELATING TO THE USE OR INABILITY TO USE THE SERVICES, INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OR CORRUPTION OF DATA OR PROGRAMS, SERVICES INTERRUPTIONS AND PROCUREMENT OF SUBSTITUTE SERVICES, EVEN IF HappyMatches.com KNOWS OR HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, UNDER NO CIRCUMSTANCES WILL HappyMatches.com’s AGGREGATE LIABILITY, IN ANY FORM OF ACTION WHATSOEVER IN CONNECTION WITH THIS AGREEMENT OR THE USE OF THE SERVICES OR THE PORTAL, EXCEED THE PRICE PAID BY YOU FOR YOUR MEMBERSHIP, OR, IF YOU HAVE NOT PAID HappyMatches.com FOR THE USE OF ANY SERVICES, THE AMOUNT OF USD 10 OR ITS EQUIVALENT.')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL HappyMatches.com BE LIABLE FOR ANY DAMAGES WHATSOEVER, WHETHER DIRECT, INDIRECT, GENERAL, SPECIAL, COMPENSATORY, CONSEQUENTIAL, AND/OR INCIDENTAL, ARISING OUT OF OR RELATING TO THE CONDUCT OF YOU OR ANYONE ELSE IN CONNECTION WITH THE USE OF THE SERVICES, INCLUDING WITHOUT LIMITATION, BODILY INJURY, EMOTIONAL DISTRESS, AND/OR ANY OTHER DAMAGES RESULTING FROM COMMUNICATIONS OR MEETINGS WITH OTHER MEMBERS OF THE SERVICES. THIS INCLUDES ANY CLAIMS, LOSSES OR DAMAGES ARISING FROM THE CONDUCT OF MEMBERS WHO HAVE REGISTERED UNDER FALSE PRETENSES OR WHO ATTEMPT TO DEFRAUD OR HARM YOU.')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('To the fullest extent permitted by applicable law, you release the Company from responsibility, liability, claims, demands, or damages of every kind and nature, known and unknown (including, but not limited to, claims of negligence), arising out of or related to disputes between users and the acts or omissions of third parties. You expressly waive any rights you may have under all applicable laws (including the California Civil Code § 1542 as well as any other statute, regulation, Civil Law, Common Law or equitable principles) that would otherwise limit the coverage of this release to include only those claims which you may know or suspect to exist in your favor at the time of agreeing to this release.')
												]))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('17. Arbitration')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.G)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Arbitration is the submission of a dispute to an unbiased third party designated by the parties to the controversy, who agree in advance to comply with the ruling, decisions, award or judgment after a hearing at which all parties to the controversy have an opportunity to be heard. '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('YOU AND HappyMatches.com AGREE THAT WE ARE EACH GIVING UP OUR RIGHT TO GO TO COURT ')
												])),
											$rtfeldman$elm_css$Html$Styled$text('in connection with any Dispute, and that our rights will be determined by a '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('NEUTRAL ARBITRATOR, NOT A JUDGE OR JURY.')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You and HappyMatches.com agree that any disputes arising out of or related to the Portal, the Services, this Agreement and/or any policies or practices of HappyMatches.com (a '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('“Dispute”')
												])),
											$rtfeldman$elm_css$Html$Styled$text(') will be subject to '),
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('FINAL AND BINDING ARBITRATION')
												])),
											$rtfeldman$elm_css$Html$Styled$text('. The only exceptions to this agreement to arbitrate Disputes are matters that may be taken to small-claims court or claims of infringement or misappropriation of HappyMatches.com’s copyright, patent, trade secret, trademark, service mark, trade dress or other intellectual property or proprietary rights, which HappyMatches.com may elect to have resolved by means other than arbitration. Notwithstanding the above, HappyMatches.com is always interested in attempting to resolve any Disputes by amicable and informal means, and we encourage you to contact us at '),
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ht),
													$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto: hello@happymatches.com')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$b,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('hello@happymatches.com')
														]))
												])),
											$rtfeldman$elm_css$Html$Styled$text('before resorting to arbitration.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$b,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('YOU AND HappyMatches.com ACKNOWLEDGE THAT NEITHER OF US WILL BRING OR PARTICIPATE IN ANY CLASS ACTION OR OTHER CLASS PROCEEDING IN CONNECTION WITH ANY DISPUTE WITH THE OTHER PARTY. ')
												])),
											$rtfeldman$elm_css$Html$Styled$text('Further, neither you nor HappyMatches.com agrees to class arbitration or any arbitration where a person brings a dispute as a representative of other person(s).')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('If the parties are unable to resolve a Dispute by informal means, the arbitration of Disputes will be administered by a third-party arbitrator not affiliated with HappyMatches.com, in accordance with commercial arbitration rules, and if deemed appropriate by the arbitrator, any supplementary procedures for consumer disputes.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Any proceeding to enforce this arbitration agreement, including any proceeding to confirm, modify, or vacate an arbitration award, may be brought in any court of competent jurisdiction. In the event that this arbitration agreement is for any reason held to be unenforceable, any litigation against HappyMatches.com (except for small-claims court actions) may be commenced only in the federal or state courts located in San Francisco, California. You hereby irrevocably consent to the jurisdiction of and venue in those courts for such purposes.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Regardless of any statute or law to the contrary, and to the maximum extent permitted by applicable law, any Dispute must be filed within one (1) year after the date in which the incident giving rise to the Dispute occurred. Failure to file an arbitration claim as described above within the applicable limitations period constitutes a waiver of such claim and serves as complete bar to any claim based on any Dispute.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('This Agreement, and any Dispute between you and HappyMatches.com, shall be governed by the laws of the State of San Francisco, California without regard to principles of conflicts of law, provided that this arbitration agreement shall be governed by the Federal Arbitration Act.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('If you access the Portal or use the Services from outside the United States, you waive all rights under the laws and regulations of the territory from which you access or use the Portal or Services. Regardless of whether you access the Portal or use the Services from outside the United States, all Disputes shall be resolved in the United States as described above.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You have the right to opt out of binding arbitration within thirty (30) days of the date you first accepted the terms of this Section by emailing hello@HappyMatches.com. In order to be effective, the opt-out notice must include your full name and clearly indicate your intent to opt out of binding arbitration. By opting out of binding arbitration, you are agreeing to resolve Disputes in accordance with the choice or law, forum and venue provisions herein.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('This section providing for arbitration of claims does not apply to commercial and competitor violations as described above.')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('18. Indemnity')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('You agree to defend, indemnify, and hold harmless HappyMatches.com, its officers, directors, employees, and agents and affiliates from and against any claims, actions, or demands, including without limitation reasonable legal and accounting fees, arising from your use of the Portal, the Services or your breach of the terms of this Agreement (including any breach of your representations and warranties contained herein), any postings or Content you post on the Portal or as a result of the Services, and the violation of any law or regulation by you. You, and your estate in the case of your death, further agree that this indemnification provision covers all third-party claims, actions or demands, including those filed by your spouse, children, or family. HappyMatches.com reserves the right to assume the exclusive defense and control of any matter otherwise subject to indemnification by you, in which event you will fully cooperate with HappyMatches.com in connection therewith.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('19.  General Provisions')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.G)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Violation of this Agreement may cause HappyMatches.com irreparable harm, and you therefore agree that HappyMatches.com will be entitled to seek extraordinary relief in court, including but not limited to temporary restraining orders, preliminary injunctions and permanent injunctions without the necessity of posting a bond or other security, in addition to and without prejudice to any other rights or remedies that HappyMatches.com may have for a breach of this Agreement.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('This Agreement, accepted upon use of the Portal and further affirmed by becoming a Member of the Services, the Privacy Policy located on the Portal, and any applicable payment, renewal, additional Services terms, comprise the entire agreement between you and HappyMatches.com regarding the use of the Portal and/or the Services, superseding any prior agreements between you and HappyMatches.com related to your use the Portal or Services (including, but not limited to, any prior versions of this Agreement).')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Unless otherwise explicitly stated, the Agreement will survive termination of your registration to the Services.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('If any provision of this Agreement is held invalid, the remainder of this Agreement shall continue in full force and effect.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('The failure of HappyMatches.com to exercise or enforce any right or provision of this Agreement shall not constitute a waiver of such right or provision.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('You agree that your online account is non-transferable and all of your rights to your profile or contents within your account terminate upon your death.')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('No agency, partnership, joint venture or employment is created as a result of this Agreement and you may not make any representations or bind HappyMatches.com in any manner.')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('20. Special State Terms')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('The following provisions are added to this Agreement for subscribers residing in Arizona, California, Connecticut, Illinois, Iowa, Minnesota, New York, North Carolina, Ohio and Wisconsin:')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('You, the buyer, may cancel this Agreement, without penalty or obligation, at any time prior to midnight of the third business day following the original date of this contract, excluding Sundays and holidays. To cancel this Agreement, email a signed and dated notice (using the same email you registered your Membership account with HappyMatches) which states that you, the buyer, are cancelling this Agreement, or words of similar effect to hello@happymatches.com. Please include your HappyMatches.com username in any correspondence or your refund may be delayed. If you cancel, HappyMatches.com will return, within Sixty (60) days of the date on which you give notice of cancellation, any payments you have made. If you send or deliver the notice to cancel your subscription agreement within such three-day period, we will refund the full amount of your subscription. Any charges or deductions incurred in the refund will be borne by you.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('In the event that you die before the end of your subscription period, your estate shall be entitled to a refund of that portion of any payment you had made for your subscription which is allocable to the period after your death. In the event that you become disabled (such that you are unable to use the Services of HappyMatches.com) before the end of your subscription period, you shall be entitled to a refund of that portion of any payment you had made for your subscription which is allocable to the period after your disability by providing the Company notice at the same address as listed above.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('21. Notice')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('The Company may provide you with notices, including those regarding changes to this Agreement, using any reasonable means now known or hereafter developed, including by email, regular mail, SMS, MMS, text message, postings or real-time chat on the Portal. Such notices may not be received if you violate this Agreement by accessing the Services in an unauthorized manner. You agree that you are deemed to have received any and all notices that would have been delivered had you accessed the Services in an authorized manner.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.nD)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('22. Revision Date and Amendment')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.ke)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('This Agreement is subject to change by the Company at any time. If you are a non-subscribing Member at the time of any change, the revised terms will be effective upon posting on the Portal and your use of the Services after such posting will constitute acceptance by you of the revised Agreement. If you are a subscribing Member at the time of any change, the then-existing Agreement will continue to govern your membership until such time that you renew your subscription as contemplated herein. If you continue your subscription, your renewal will constitute acceptance by you of the revised Agreement. Alternatively, if you terminate your subscription at such time, your use of the Services after your termination will constitute acceptance by you of the Agreement.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Terms$styles.bJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('This Agreement was last revised on April 1, 2018.')
						]))
				]))
		]));
var $author$project$Type$UpdatePassword$FormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$UpdatePassword$SubmitForm = {$: 0};
var $author$project$Page$UpdatePassword$styles = {
	f1: F2(
		function (_v0, hasAlert) {
			var screenHeight = _v0.ni;
			return _Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.gN),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$pct(100))
					]),
				A2($author$project$View$Theme$defaultStyles.kA, screenHeight, hasAlert));
		}),
	c7: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(13)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
			])),
	dd: $author$project$View$Theme$defaultStyles.lC,
	de: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	jJ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$View$Theme$colors.gO),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		])
};
var $author$project$Page$UpdatePassword$displaySuccessMessage = function (isSuccess) {
	return isSuccess ? A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UpdatePassword$styles.c7)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Password is updated successfully!')
			])) : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Page$UpdatePassword$view = F2(
	function (dimension, authState) {
		var toAppMsg = A2(
			$elm$core$Basics$composeR,
			$rtfeldman$elm_css$Html$Styled$map($author$project$Types$OnUpdatePassword),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Types$OnAuth));
		var containerStyle = A2(
			$author$project$Page$UpdatePassword$styles.f1,
			dimension,
			$author$project$View$Helpers$UserInfo$isMissingAvatar(authState));
		var _v0 = authState.n6;
		var form = _v0.ln;
		var apiError = _v0.dk;
		var isSuccess = _v0.hi;
		var _v1 = form;
		var submitting = _v1.jc;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UpdatePassword$styles.jJ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UpdatePassword$styles.de)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UpdatePassword$styles.dd)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Update Password')
										]))
								])),
							$author$project$Page$UpdatePassword$displaySuccessMessage(isSuccess),
							A2(
							$elm$core$Maybe$withDefault,
							$rtfeldman$elm_css$Html$Styled$text(''),
							A2(
								$elm$core$Maybe$map,
								function (message) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.m8)
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(message)
											]));
								},
								apiError)),
							A2(
							$rtfeldman$elm_css$Html$Styled$form,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
									$author$project$Types$OnAuth(
										$author$project$Types$OnUpdatePassword($author$project$Type$UpdatePassword$SubmitForm)))
								]),
							_List_fromArray(
								[
									toAppMsg(
									A2(
										$rtfeldman$elm_css$Html$Styled$map,
										$author$project$Type$UpdatePassword$FormMsg,
										A2(
											$author$project$View$Form$passwordField,
											form,
											{ct: 'oldPassword', dX: 'Current Password'}))),
									toAppMsg(
									A2(
										$rtfeldman$elm_css$Html$Styled$map,
										$author$project$Type$UpdatePassword$FormMsg,
										A2(
											$author$project$View$Form$passwordField,
											form,
											{ct: 'newPassword', dX: 'New Password'}))),
									toAppMsg(
									A2(
										$rtfeldman$elm_css$Html$Styled$map,
										$author$project$Type$UpdatePassword$FormMsg,
										A2(
											$author$project$View$Form$passwordField,
											form,
											{ct: 'passwordConfirmation', dX: 'Type New Password Again'}))),
									A2($rtfeldman$elm_css$Html$Styled$p, _List_Nil, _List_Nil),
									$author$project$View$Form$submitButton(submitting)
								]))
						]))
				]));
	});
var $author$project$View$page = function (model) {
	var _v0 = model;
	var device = _v0.kQ;
	var _v1 = model.ng;
	switch (_v1.$) {
		case 0:
			return $author$project$View$homePage(model);
		case 1:
			return _Utils_Tuple2(1, $author$project$Page$AboutUs$view);
		case 2:
			return _Utils_Tuple2(1, $author$project$Page$ContactUs$view);
		case 3:
			return _Utils_Tuple2(1, $author$project$Page$Terms$view);
		case 4:
			return _Utils_Tuple2(1, $author$project$Page$Privacy$view);
		case 5:
			return _Utils_Tuple2(
				1,
				$author$project$Page$FaceVerification$view(device));
		case 7:
			return _Utils_Tuple2(
				0,
				$author$project$Page$EmailVerifiedSuccess$view(model.j1));
		case 8:
			return _Utils_Tuple2(0, $author$project$Page$EmailVerifiedFail$view);
		case 12:
			return _Utils_Tuple2(
				0,
				$author$project$Page$Register$view(model));
		case 10:
			return _Utils_Tuple2(
				0,
				$author$project$Page$Login$view(model));
		case 11:
			return _Utils_Tuple2(1, $author$project$Page$Home$view);
		case 9:
			return _Utils_Tuple2(
				0,
				$author$project$Page$ForgetPassword$view(model));
		case 15:
			return _Utils_Tuple2(0, $author$project$Page$Deactivate$processingView);
		case 6:
			return A2($author$project$View$authPage, model, $author$project$Page$FaceVerificationProcessing$view);
		case 13:
			return A2($author$project$View$authPage, model, $author$project$Page$Profile$view);
		case 16:
			return A2(
				$author$project$View$authPage,
				model,
				function (_v2) {
					return $author$project$Page$UpdatePassword$view(model.kR);
				});
		case 17:
			return A2($author$project$View$authPage, model, $author$project$Page$Membership$view);
		case 14:
			return A2(
				$author$project$View$authPage,
				model,
				function (_v3) {
					return $author$project$Page$Deactivate$view(model.kR);
				});
		case 18:
			return A2($author$project$View$authPage, model, $author$project$View$profilesView);
		case 19:
			switch (_v1.a) {
				case 0:
					var _v4 = _v1.a;
					return A2($author$project$View$authPage, model, $author$project$View$profilesView);
				case 1:
					var _v5 = _v1.a;
					return A2($author$project$View$authPage, model, $author$project$View$profilesView);
				default:
					var _v6 = _v1.a;
					return A2($author$project$View$authPage, model, $author$project$View$profilesView);
			}
		case 20:
			return A2($author$project$View$authPage, model, $author$project$View$profilesView);
		case 21:
			return A2($author$project$View$authPage, model, $author$project$Page$Chat$view);
		case 22:
			return A2($author$project$View$authPage, model, $author$project$Page$Block$view);
		case 23:
			var contentRoute = _v1.a;
			return _Utils_Tuple2(
				2,
				A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Page$Content$view, contentRoute, model.mZ, model.cl));
		default:
			return _Utils_Tuple2(0, $author$project$View$Display$notFoundView);
	}
};
var $author$project$Animate$SlideInDown = 68;
var $author$project$Types$CloseAlert = function (a) {
	return {$: 16, a: a};
};
var $rtfeldman$elm_css$Css$animationDuration = function (arg) {
	return A2($rtfeldman$elm_css$Css$prop1, 'animation-duration', arg);
};
var $rtfeldman$elm_css$Css$breakWord = {ej: 0, v: 'break-word'};
var $rtfeldman$elm_css$Css$ms = function (amount) {
	return {
		gk: 0,
		v: $elm$core$String$fromFloat(amount) + 'ms'
	};
};
var $rtfeldman$elm_css$Css$overflowWrap = $rtfeldman$elm_css$Css$prop1('overflow-wrap');
var $author$project$View$Alert$style = {
	aG: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$margin(
				$rtfeldman$elm_css$Css$px(2)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(5)),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(10))
			])),
	fZ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	f1: function (_v0) {
		var screenWidth = _v0.nj;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$zIndex(
				$rtfeldman$elm_css$Css$int(10)),
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(screenWidth)),
				$rtfeldman$elm_css$Css$animationDuration(
				$rtfeldman$elm_css$Css$ms(400)),
				$author$project$View$Theme$forDesktopScreen(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$px(20)),
						$rtfeldman$elm_css$Css$left(
						$rtfeldman$elm_css$Css$px(screenWidth * 0.2)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(screenWidth * 0.6))
					]))
			]);
	},
	f9: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('FFFFFF')),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('DC3545'))
		]),
	gy: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('721C24')),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('F8D7DA'))
		]),
	ag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('004085')),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('CCE5FF'))
		]),
	h: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord),
			A2($rtfeldman$elm_css$Css$property, 'word-wrap', 'break-word'),
			A2($rtfeldman$elm_css$Css$property, 'word-break', 'break-word')
		]),
	jf: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('155724')),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('D4EDDA'))
		]),
	e_: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('856404')),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('FFF3CD'))
		])
};
var $author$project$View$Alert$alertStyle = function (alert) {
	switch (alert.$) {
		case 0:
			return _Utils_ap($author$project$View$Alert$style.aG, $author$project$View$Alert$style.jf);
		case 1:
			return _Utils_ap($author$project$View$Alert$style.aG, $author$project$View$Alert$style.ag);
		case 2:
			return _Utils_ap($author$project$View$Alert$style.aG, $author$project$View$Alert$style.gy);
		case 3:
			return _Utils_ap($author$project$View$Alert$style.aG, $author$project$View$Alert$style.e_);
		default:
			return _Utils_ap($author$project$View$Alert$style.aG, $author$project$View$Alert$style.f9);
	}
};
var $author$project$Data$Alert$message = function (alert) {
	switch (alert.$) {
		case 0:
			var text = alert.a;
			return text;
		case 1:
			var text = alert.a;
			return text;
		case 2:
			var text = alert.a;
			return text;
		case 3:
			var text = alert.a;
			return text;
		default:
			var text = alert.a;
			return text;
	}
};
var $rtfeldman$elm_css$Svg$Styled$Attributes$fill = $rtfeldman$elm_css$VirtualDom$Styled$attribute('fill');
var $rtfeldman$elm_css$Svg$Styled$Attributes$height = $rtfeldman$elm_css$VirtualDom$Styled$attribute('height');
var $rtfeldman$elm_css$VirtualDom$Styled$nodeNS = $rtfeldman$elm_css$VirtualDom$Styled$NodeNS;
var $rtfeldman$elm_css$Svg$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$nodeNS('http://www.w3.org/2000/svg');
var $rtfeldman$elm_css$Svg$Styled$line = $rtfeldman$elm_css$Svg$Styled$node('line');
var $rtfeldman$elm_css$Svg$Styled$Attributes$stroke = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke');
var $rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke-linecap');
var $rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke-linejoin');
var $rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke-width');
var $rtfeldman$elm_css$Svg$Styled$svg = $rtfeldman$elm_css$Svg$Styled$node('svg');
var $rtfeldman$elm_css$Svg$Styled$Attributes$viewBox = $rtfeldman$elm_css$VirtualDom$Styled$attribute('viewBox');
var $rtfeldman$elm_css$Svg$Styled$Attributes$width = $rtfeldman$elm_css$VirtualDom$Styled$attribute('width');
var $rtfeldman$elm_css$Svg$Styled$Attributes$x1 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('x1');
var $rtfeldman$elm_css$Svg$Styled$Attributes$x2 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('x2');
var $rtfeldman$elm_css$Svg$Styled$Attributes$y1 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('y1');
var $rtfeldman$elm_css$Svg$Styled$Attributes$y2 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('y2');
var $author$project$View$Svg$close = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('24'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$stroke('currentColor'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$line,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$x1('18'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$y1('6'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$x2('6'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$y2('18')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$line,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$x1('6'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$y1('6'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$x2('18'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$y2('18')
				]),
			_List_Nil)
		]));
var $author$project$View$Svg$exports = {kt: $author$project$View$Svg$close};
var $author$project$View$Theme$svg = $author$project$View$Svg$exports;
var $author$project$View$Alert$renderAlert = function (_v0) {
	var alert = _v0.b;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				$author$project$View$Alert$alertStyle(alert))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Alert$style.h)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Data$Alert$message(alert))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Alert$style.fZ),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$CloseAlert(alert))
					]),
				_List_fromArray(
					[$author$project$View$Theme$svg.kt]))
			]));
};
var $author$project$Data$Alert$toList = function (_v0) {
	var state = _v0;
	return $elm$core$Dict$toList(state);
};
var $author$project$View$Alert$view = F2(
	function (dimension, alertState) {
		var alerts = $author$project$Data$Alert$toList(alertState);
		return $elm$core$List$isEmpty(alerts) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					$author$project$View$Alert$style.f1(dimension)),
					$author$project$Animate$animate(68)
				]),
			A2($elm$core$List$map, $author$project$View$Alert$renderAlert, alerts));
	});
var $author$project$View$Layout$noMenuLayout = F2(
	function (model, subView) {
		var styles = {
			fW: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(30)),
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(30),
					$rtfeldman$elm_css$Css$px(50)),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$px(500)),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(20)),
					$author$project$View$Theme$forMobileScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$px(20))
						]))
				]),
			f1: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.lA),
					$rtfeldman$elm_css$Css$minHeight(
					$rtfeldman$elm_css$Css$px(model.kR.ni)),
					A4(
					$rtfeldman$elm_css$Css$padding4,
					$rtfeldman$elm_css$Css$px(30),
					$rtfeldman$elm_css$Css$px(15),
					$rtfeldman$elm_css$Css$px(60),
					$rtfeldman$elm_css$Css$px(15)),
					$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden),
					$author$project$View$Theme$forDesktopScreen(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$backgroundImage(
							$rtfeldman$elm_css$Css$url($author$project$View$Theme$images.kC)),
							$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$right),
							$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover)
						]))
				])
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
				]),
			_List_fromArray(
				[
					A2($author$project$View$Alert$view, model.kR, model.b8),
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href('/'),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.l3)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.fW)
						]),
					_List_fromArray(
						[subView]))
				]));
	});
var $rtfeldman$elm_css$Css$Global$class = F2(
	function (str, styles) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$Structure$ClassSelector(str)
					])));
	});
var $rtfeldman$elm_css$Css$Global$global = function (snippets) {
	return $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode(
		A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			$elm$core$List$singleton(
				A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					_List_Nil,
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(
							$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
								$rtfeldman$elm_css$Css$Preprocess$stylesheet(snippets))))))));
};
var $rtfeldman$elm_css$Css$translateX = function (_v0) {
	var value = _v0.v;
	return {
		l: 0,
		v: A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'translateX',
			_List_fromArray(
				[value]))
	};
};
var $author$project$View$Menu$Orange$Public$menuGlobalCss = $rtfeldman$elm_css$Css$Global$global(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Global$class,
			'mobile-menu-closed',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform($rtfeldman$elm_css$Css$none)
				])),
			A2(
			$rtfeldman$elm_css$Css$Global$class,
			'mobile-menu-opened',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$translateX(
						$rtfeldman$elm_css$Css$pct(-100)))
				]))
		]));
var $author$project$Types$UpdateMenuStatus = function (a) {
	return {$: 14, a: a};
};
var $rtfeldman$elm_css$Css$Transitions$CubicBezier = F4(
	function (a, b, c, d) {
		return {$: 7, a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$Css$Transitions$cubicBezier = F4(
	function (f1, f2, f3, f4) {
		return A4($rtfeldman$elm_css$Css$Transitions$CubicBezier, f1, f2, f3, f4);
	});
var $rtfeldman$elm_css$Css$Transitions$Transform = 89;
var $rtfeldman$elm_css$Css$Transitions$Transition = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Transitions$fullTransition = F4(
	function (animation, duration, delay, timing) {
		return {
			b9: animation,
			co: $elm$core$Maybe$Just(delay),
			gk: duration,
			dc: $elm$core$Maybe$Just(timing)
		};
	});
var $rtfeldman$elm_css$Css$Transitions$transform3 = $rtfeldman$elm_css$Css$Transitions$fullTransition(89);
var $rtfeldman$elm_css$Css$Transitions$propToString = function (prop) {
	switch (prop) {
		case 0:
			return 'background';
		case 1:
			return 'background-color';
		case 2:
			return 'background-position';
		case 3:
			return 'background-size';
		case 4:
			return 'border';
		case 5:
			return 'border-bottom';
		case 6:
			return 'border-bottom-color';
		case 7:
			return 'border-bottom-left-radius';
		case 8:
			return 'border-bottom-right-radius';
		case 9:
			return 'border-bottom-width';
		case 10:
			return 'border-color';
		case 11:
			return 'border-left';
		case 12:
			return 'border-left-color';
		case 13:
			return 'border-left-width';
		case 14:
			return 'border-radius';
		case 15:
			return 'border-right';
		case 16:
			return 'border-right-color';
		case 17:
			return 'border-right-width';
		case 18:
			return 'border-top';
		case 19:
			return 'border-top-color';
		case 20:
			return 'border-top-left-radius';
		case 21:
			return 'border-top-right-radius';
		case 22:
			return 'border-top-width';
		case 23:
			return 'border-width';
		case 24:
			return 'bottom';
		case 25:
			return 'box-shadow';
		case 26:
			return 'caret-color';
		case 27:
			return 'clip';
		case 28:
			return 'clip-path';
		case 29:
			return 'color';
		case 30:
			return 'column-count';
		case 31:
			return 'column-gap';
		case 32:
			return 'column-rule';
		case 33:
			return 'column-rule-color';
		case 34:
			return 'column-rule-width';
		case 35:
			return 'column-width';
		case 36:
			return 'columns';
		case 37:
			return 'filter';
		case 38:
			return 'flex';
		case 39:
			return 'flex-basis';
		case 40:
			return 'flex-grow';
		case 41:
			return 'flex-shrink';
		case 42:
			return 'font';
		case 43:
			return 'font-size';
		case 44:
			return 'font-size-adjust';
		case 45:
			return 'font-stretch';
		case 46:
			return 'font-variation-settings';
		case 47:
			return 'font-weight';
		case 48:
			return 'grid-column-gap';
		case 49:
			return 'grid-gap';
		case 50:
			return 'grid-row-gap';
		case 51:
			return 'height';
		case 52:
			return 'left';
		case 53:
			return 'letter-spacing';
		case 54:
			return 'line-height';
		case 55:
			return 'margin';
		case 56:
			return 'margin-bottom';
		case 57:
			return 'margin-left';
		case 58:
			return 'margin-right';
		case 59:
			return 'margin-top';
		case 60:
			return 'mask';
		case 61:
			return 'mask-position';
		case 62:
			return 'mask-size';
		case 63:
			return 'max-height';
		case 64:
			return 'max-width';
		case 65:
			return 'min-height';
		case 66:
			return 'min-width';
		case 67:
			return 'object-position';
		case 68:
			return 'offset';
		case 69:
			return 'offset-anchor';
		case 70:
			return 'offset-distance';
		case 71:
			return 'offset-path';
		case 72:
			return 'offset-rotate';
		case 73:
			return 'opacity';
		case 74:
			return 'order';
		case 75:
			return 'outline';
		case 76:
			return 'outline-color';
		case 77:
			return 'outline-offset';
		case 78:
			return 'outline-width';
		case 79:
			return 'padding';
		case 80:
			return 'padding-bottom';
		case 81:
			return 'padding-left';
		case 82:
			return 'padding-right';
		case 83:
			return 'padding-top';
		case 84:
			return 'right';
		case 85:
			return 'tab-size';
		case 86:
			return 'text-indent';
		case 87:
			return 'text-shadow';
		case 88:
			return 'top';
		case 89:
			return 'transform';
		case 90:
			return 'transform-origin';
		case 91:
			return 'vertical-align';
		case 92:
			return 'visibility';
		case 93:
			return 'width';
		case 94:
			return 'word-spacing';
		default:
			return 'z-index';
	}
};
var $rtfeldman$elm_css$Css$Transitions$timeToString = function (time) {
	return $elm$core$String$fromFloat(time) + 'ms';
};
var $rtfeldman$elm_css$Css$Transitions$timingFunctionToString = function (tf) {
	switch (tf.$) {
		case 0:
			return 'ease';
		case 1:
			return 'linear';
		case 2:
			return 'ease-in';
		case 3:
			return 'ease-out';
		case 4:
			return 'ease-in-out';
		case 5:
			return 'step-start';
		case 6:
			return 'step-end';
		default:
			var _float = tf.a;
			var float2 = tf.b;
			var float3 = tf.c;
			var float4 = tf.d;
			return 'cubic-bezier(' + ($elm$core$String$fromFloat(_float) + (' , ' + ($elm$core$String$fromFloat(float2) + (' , ' + ($elm$core$String$fromFloat(float3) + (' , ' + ($elm$core$String$fromFloat(float4) + ')')))))));
	}
};
var $rtfeldman$elm_css$Css$Transitions$transition = function (options) {
	var v = A3(
		$elm$core$String$slice,
		0,
		-1,
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, s) {
					var animation = _v0.b9;
					var duration = _v0.gk;
					var delay = _v0.co;
					var timing = _v0.dc;
					return s + ($rtfeldman$elm_css$Css$Transitions$propToString(animation) + (' ' + ($rtfeldman$elm_css$Css$Transitions$timeToString(duration) + (' ' + (A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Transitions$timeToString, delay)) + (' ' + (A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Transitions$timingFunctionToString, timing)) + ',')))))));
				}),
			'',
			options));
	return A2($rtfeldman$elm_css$Css$property, 'transition', v);
};
var $author$project$View$Menu$Orange$Public$styles = {
	ci: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lt,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$margin(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$borderColor($author$project$View$Theme$colors.og),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$borderColor($author$project$View$Theme$colors.eh)
					])),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
						$rtfeldman$elm_css$Css$borderColor($author$project$View$Theme$colors.gO)
					]))
			])),
	hE: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
					$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$left(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(1000)),
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.ly),
					$rtfeldman$elm_css$Css$Transitions$transition(
					_List_fromArray(
						[
							A3(
							$rtfeldman$elm_css$Css$Transitions$transform3,
							300,
							0,
							A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0.17, 0.04, 0.03, 0.94))
						]))
				]))
		]),
	cJ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO)
					])),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Css$margin2,
						$rtfeldman$elm_css$Css$px(10),
						$rtfeldman$elm_css$Css$zero)
					]))
			])),
	hJ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$top(
					$rtfeldman$elm_css$Css$px(38)),
					$rtfeldman$elm_css$Css$right(
					$rtfeldman$elm_css$Css$px(30))
				]))
		]),
	hK: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$top(
					$rtfeldman$elm_css$Css$px(38)),
					$rtfeldman$elm_css$Css$right(
					$rtfeldman$elm_css$Css$px(30))
				]))
		])
};
var $author$project$View$Menu$Orange$Public$mobileCloseButton = A2(
	$rtfeldman$elm_css$Html$Styled$li,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Events$onClick(
			$author$project$Types$UpdateMenuStatus(1)),
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$Public$styles.hJ),
			$rtfeldman$elm_css$Html$Styled$Attributes$id('mobile-close-button')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.kv)
				]),
			_List_Nil)
		]));
var $author$project$View$Menu$Orange$Public$mobileCssClass = function (menuStatus) {
	if (!menuStatus) {
		return 'mobile-menu-opened';
	} else {
		return 'mobile-menu-closed';
	}
};
var $author$project$Types$OpenedMenu = 0;
var $author$project$View$Menu$Orange$Public$mobileOpenButton = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Events$onClick(
			$author$project$Types$UpdateMenuStatus(0)),
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$Public$styles.hK),
			$rtfeldman$elm_css$Html$Styled$Attributes$id('mobile-open-button')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hE)
				]),
			_List_Nil)
		]));
var $author$project$View$Menu$Orange$Public$view = function (menuStatus) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$View$Menu$Orange$Public$menuGlobalCss,
				$author$project$View$Menu$Orange$Public$mobileOpenButton,
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$Public$styles.hE),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						$author$project$View$Menu$Orange$Public$mobileCssClass(menuStatus))
					]),
				_List_fromArray(
					[
						$author$project$View$Menu$Orange$Public$mobileCloseButton,
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$Public$styles.cJ),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.jN)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('About Us')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$Public$styles.cJ),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.kb)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Blog')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$Public$styles.ci),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.na)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Login / Sign Up')
									]))
							]))
					]))
			]));
};
var $author$project$View$Header$orangePublicHeader = function (appModel) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$px(30),
						$rtfeldman$elm_css$Css$px(15)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href('/'),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.l4)
							]),
						_List_Nil)
					])),
				$author$project$View$Menu$Orange$Public$view(appModel.d$)
			]));
};
var $rtfeldman$elm_css$Css$borderWidth = $rtfeldman$elm_css$Css$prop1('border-width');
var $rtfeldman$elm_css$Css$PtUnits = 0;
var $rtfeldman$elm_css$Css$pt = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'pt');
var $author$project$View$Header$Orange$Auth$styles = {
	fi: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(14)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$left(
					$rtfeldman$elm_css$Css$px(25))
				]))
		]),
	fj: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.lv),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(65)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.eh)
		]),
	gi: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	hr: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero)
		]),
	hz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(15))
		]),
	d1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$author$project$View$Theme$forDesktopScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	eD: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$borderWidth(
			$rtfeldman$elm_css$Css$pt(2)),
			$rtfeldman$elm_css$Css$borderColor($author$project$View$Theme$colors.og)
		])
};
var $author$project$View$Header$Orange$Auth$alertBadge = function (_v0) {
	var chat = _v0.km;
	var hasUnreadMessages = A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.df;
			},
			function (count) {
				return count > 0;
			}),
		$author$project$Data$Chat$listRooms(chat.i8));
	return hasUnreadMessages ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.fi)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.fj)
					]),
				_List_Nil)
			])) : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$View$Header$Orange$Auth$desktopNotification = function (authState) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$a,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.gi),
				$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.km)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.mC)
					]),
				_List_Nil),
				$author$project$View$Header$Orange$Auth$alertBadge(authState)
			]));
};
var $author$project$Model$Route$profilesUrl = function (authState) {
	var _v0 = authState.kE;
	if (!_v0.$) {
		if (!_v0.a.$) {
			var _v1 = _v0.a;
			return $author$project$Data$Route$routeUrl.nm;
		} else {
			var relatedProfilesKind = _v0.a.a;
			switch (relatedProfilesKind) {
				case 0:
					return $author$project$Data$Route$routeUrl.oe;
				case 1:
					return $author$project$Data$Route$routeUrl.li;
				default:
					return $author$project$Data$Route$routeUrl.lh;
			}
		}
	} else {
		return $author$project$Data$Route$routeUrl.nm;
	}
};
var $author$project$View$Header$Orange$Auth$tabStyles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexEnd),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	hE: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none)
		]),
	cJ: F2(
		function (currentPath, path) {
			return _Utils_ap(
				$author$project$View$Theme$defaultStyles.kd,
				_Utils_ap(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							A2(
							$rtfeldman$elm_css$Css$padding2,
							$rtfeldman$elm_css$Css$px(20),
							$rtfeldman$elm_css$Css$px(40)),
							$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
							A4(
							$rtfeldman$elm_css$Css$borderRadius4,
							$rtfeldman$elm_css$Css$px(20),
							$rtfeldman$elm_css$Css$px(20),
							$rtfeldman$elm_css$Css$zero,
							$rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
							$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
							$rtfeldman$elm_css$Css$hover(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
								]))
						]),
					_Utils_eq(path, currentPath) ? _List_fromArray(
						[
							$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
							$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.lA),
							A3(
							$rtfeldman$elm_css$Css$borderBottom3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$View$Theme$colors.og)
						]) : _List_Nil));
		}),
	hQ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero)
		])
};
var $author$project$View$Header$Orange$Auth$desktopTabs = F2(
	function (_v0, authState) {
		var url = _v0.n8;
		var currentPath = url.mM;
		var displayIcon = F3(
			function (activeIcon, icon, path) {
				return _Utils_eq(path, currentPath) ? A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src(activeIcon),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$paddingRight(
									$rtfeldman$elm_css$Css$px(10))
								]))
						]),
					_List_Nil) : A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src(icon),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$paddingRight(
									$rtfeldman$elm_css$Css$px(10))
								]))
						]),
					_List_Nil);
			});
		var itemStyle = function (path) {
			return A2($author$project$View$Header$Orange$Auth$tabStyles.cJ, currentPath, path);
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$tabStyles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$nav,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$tabStyles.hQ)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$tabStyles.hE)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													itemStyle(
														$author$project$Model$Route$profilesUrl(authState))),
													$rtfeldman$elm_css$Html$Styled$Attributes$href(
													$author$project$Model$Route$profilesUrl(authState))
												]),
											_List_fromArray(
												[
													A3(
													displayIcon,
													$author$project$View$Theme$images.m4,
													$author$project$View$Theme$images.m3,
													$author$project$Model$Route$profilesUrl(authState)),
													$rtfeldman$elm_css$Html$Styled$text('Profiles')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													itemStyle($author$project$Data$Route$routeUrl.km)),
													$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.km)
												]),
											_List_fromArray(
												[
													A3(displayIcon, $author$project$View$Theme$images.kn, $author$project$View$Theme$images.km, $author$project$Data$Route$routeUrl.km),
													$rtfeldman$elm_css$Html$Styled$text('Messages')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													itemStyle($author$project$Data$Route$routeUrl.kb)),
													$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.kb)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Blog')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$View$Header$Orange$Auth$mobileChatIcon = function (authState) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$a,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.km),
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.d1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.km)
					]),
				_List_Nil),
				$author$project$View$Header$Orange$Auth$alertBadge(authState)
			]));
};
var $author$project$View$Header$Orange$Auth$mobileSearchIcon = A2(
	$rtfeldman$elm_css$Html$Styled$a,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.nm),
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.d1)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.nn)
				]),
			_List_Nil)
		]));
var $author$project$View$Menu$Orange$AuthMobile$styles = {
	f1: _List_Nil,
	gv: _Utils_ap(
		$author$project$View$Theme$defaultStyles.ht,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(5),
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.l$),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				$author$project$View$Theme$colors.eh),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(30))
			])),
	gw: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	hE: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.ly),
			$rtfeldman$elm_css$Css$Transitions$transition(
			_List_fromArray(
				[
					A3(
					$rtfeldman$elm_css$Css$Transitions$transform3,
					300,
					0,
					A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0.17, 0.04, 0.03, 0.94))
				]))
		]),
	cJ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
					])),
				A2(
				$rtfeldman$elm_css$Css$margin2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$zero)
			])),
	hI: function (color_) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(120)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(120)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$pct(50)),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(2),
				$rtfeldman$elm_css$Css$solid,
				color_)
			]);
	},
	hJ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(38)),
			$rtfeldman$elm_css$Css$right(
			$rtfeldman$elm_css$Css$px(30))
		]),
	hK: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	hL: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		])
};
var $author$project$View$Menu$Orange$AuthMobile$openButton = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Events$onClick(
			$author$project$Types$UpdateMenuStatus(0)),
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.hK)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hE)
				]),
			_List_Nil)
		]));
var $rtfeldman$elm_css$Css$Transitions$Ease = {$: 0};
var $rtfeldman$elm_css$Css$Transitions$ease = $rtfeldman$elm_css$Css$Transitions$Ease;
var $author$project$View$Menu$Orange$AuthDesktop$styles = {
	hE: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none)
		]),
	cJ: F2(
		function (currentPath, path) {
			return _Utils_ap(
				$author$project$View$Theme$defaultStyles.ht,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$px(10),
						$rtfeldman$elm_css$Css$px(30)),
						$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO),
						$rtfeldman$elm_css$Css$hover(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
							])),
						A2(
						$author$project$View$Theme$applyStyleIf,
						_Utils_eq(currentPath, path),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
							]))
					]));
		}),
	hQ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.og),
			A2($rtfeldman$elm_css$Css$property, 'transform-origin', 'top'),
			$rtfeldman$elm_css$Css$Transitions$transition(
			_List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Transitions$transform3, 300, 0, $rtfeldman$elm_css$Css$Transitions$ease)
				]))
		])
};
var $author$project$View$Menu$Orange$AuthDesktop$membershipLinkForSponsorOnly = F2(
	function (currentPath, userKind) {
		if (!userKind) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								A2($author$project$View$Menu$Orange$AuthDesktop$styles.cJ, currentPath, $author$project$Data$Route$routeUrl.l9)),
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l9)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('My Membership')
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$View$Helpers$UserInfo$defaultUserInfo = {
	cc: $author$project$View$Theme$images.go,
	d_: $author$project$Data$Membership$getMembershipColor(0),
	el: false,
	bY: 0,
	dh: '...'
};
var $author$project$View$Helpers$UserInfo$avatarUrl = function (url) {
	return $elm$core$String$isEmpty(url) ? $author$project$View$Theme$images.go : url;
};
var $author$project$View$Helpers$UserInfo$toUserInfo = function (profile) {
	return {
		cc: $author$project$View$Helpers$UserInfo$avatarUrl(profile.cc),
		d_: $author$project$Data$Membership$getMembershipColor(profile.bY),
		el: profile.ob.mP,
		bY: profile.bY,
		dh: profile.dh
	};
};
var $author$project$View$Helpers$UserInfo$getUserInfo = function (authState) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$View$Helpers$UserInfo$defaultUserInfo,
		A2(
			$elm$core$Maybe$map,
			$author$project$View$Helpers$UserInfo$toUserInfo,
			$author$project$Helpers$getCurrentUserProfile(authState)));
};
var $author$project$View$Menu$Orange$AuthDesktop$menuButtonStyles = {
	cc: function (color_) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(30)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(30)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$pct(50)),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(2),
				$rtfeldman$elm_css$Css$solid,
				color_),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$px(10))
			]);
	},
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	dh: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og)
			]))
};
var $author$project$View$Menu$Orange$AuthDesktop$menuButton = F2(
	function (menuStatus, authState) {
		var _v0 = (!menuStatus) ? _Utils_Tuple2(
			$author$project$Types$UpdateMenuStatus(1),
			$author$project$View$Theme$images.k4) : _Utils_Tuple2(
			$author$project$Types$UpdateMenuStatus(0),
			$author$project$View$Theme$images.k5);
		var msg = _v0.a;
		var menuIcon = _v0.b;
		var _v1 = $author$project$View$Helpers$UserInfo$getUserInfo(authState);
		var avatar = _v1.cc;
		var username = _v1.dh;
		var membershipColor = _v1.d_;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg),
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthDesktop$menuButtonStyles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src(avatar),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$View$Menu$Orange$AuthDesktop$menuButtonStyles.cc(membershipColor))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthDesktop$menuButtonStyles.dh)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(username)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src(menuIcon)
						]),
					_List_Nil)
				]));
	});
var $author$project$View$Menu$Orange$AuthDesktop$menuGlobalCss = $rtfeldman$elm_css$Css$Global$global(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Global$class,
			'mobile-menu-closed',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$scaleY(0))
				])),
			A2(
			$rtfeldman$elm_css$Css$Global$class,
			'mobile-menu-opened',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$scaleY(1))
				]))
		]));
var $author$project$View$Menu$Orange$AuthDesktop$mobileCssClass = function (menuStatus) {
	if (!menuStatus) {
		return 'mobile-menu-opened';
	} else {
		return 'mobile-menu-closed';
	}
};
var $author$project$View$Menu$Orange$AuthDesktop$view = F3(
	function (currentPath, menuStatus, authState) {
		var profilePath = $author$project$Model$Route$profilesUrl(authState);
		var itemStyle = function (path) {
			return A2($author$project$View$Menu$Orange$AuthDesktop$styles.cJ, currentPath, path);
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Menu$Orange$AuthDesktop$menuGlobalCss,
					A2($author$project$View$Menu$Orange$AuthDesktop$menuButton, menuStatus, authState),
					A2(
					$rtfeldman$elm_css$Html$Styled$nav,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthDesktop$styles.hQ),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							$author$project$View$Menu$Orange$AuthDesktop$mobileCssClass(menuStatus)),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'authMenuItems')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthDesktop$styles.hE)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													itemStyle(profilePath)),
													$rtfeldman$elm_css$Html$Styled$Attributes$href(profilePath)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Profiles')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													itemStyle($author$project$Data$Route$routeUrl.km)),
													$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.km)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Messages')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													itemStyle($author$project$Data$Route$routeUrl.kb)),
													$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.kb)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Blog')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													itemStyle($author$project$Data$Route$routeUrl.mp)),
													$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.mp)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('My Profile')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													itemStyle($author$project$Data$Route$routeUrl.j7)),
													$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.j7)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Block List')
												]))
										])),
									A2($author$project$View$Menu$Orange$AuthDesktop$membershipLinkForSponsorOnly, currentPath, authState.j2.ho),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													itemStyle($author$project$Data$Route$routeUrl.n6)),
													$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.n6)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Update Password')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													itemStyle($author$project$Data$Route$routeUrl.l5)),
													$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l5)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Logout')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$View$Menu$Orange$AuthMobile$membershipLinkForSponsorOnly = F2(
	function (device, userKind) {
		if (!userKind) {
			return $author$project$Data$Membership$availableForApp(device) ? A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.cJ),
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l9)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('My Membership')
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$View$Menu$Orange$AuthMobile$menuGlobalCss = $rtfeldman$elm_css$Css$Global$global(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Global$class,
			'mobile-menu-closed',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform($rtfeldman$elm_css$Css$none)
				])),
			A2(
			$rtfeldman$elm_css$Css$Global$class,
			'mobile-menu-opened',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$translateX(
						$rtfeldman$elm_css$Css$pct(-100)))
				]))
		]));
var $author$project$View$Menu$Orange$AuthMobile$mobileCloseButton = A2(
	$rtfeldman$elm_css$Html$Styled$li,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Events$onClick(
			$author$project$Types$UpdateMenuStatus(1)),
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.hJ)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.kv)
				]),
			_List_Nil)
		]));
var $author$project$View$Menu$Orange$AuthMobile$mobileCssClass = function (menuStatus) {
	if (!menuStatus) {
		return 'mobile-menu-opened';
	} else {
		return 'mobile-menu-closed';
	}
};
var $author$project$View$Menu$Orange$AuthMobile$profilesUrl = function (authState) {
	var _v0 = authState.kE;
	if (!_v0.$) {
		if (!_v0.a.$) {
			var _v1 = _v0.a;
			return $author$project$Data$Route$routeUrl.nm;
		} else {
			var relatedProfilesKind = _v0.a.a;
			switch (relatedProfilesKind) {
				case 0:
					return $author$project$Data$Route$routeUrl.oe;
				case 1:
					return $author$project$Data$Route$routeUrl.li;
				default:
					return $author$project$Data$Route$routeUrl.lh;
			}
		}
	} else {
		return $author$project$Data$Route$routeUrl.nm;
	}
};
var $author$project$View$Menu$Orange$AuthMobile$view = F3(
	function (menuStatus, device, authState) {
		var isFaceVerificationAvailable = function () {
			if (device.$ === 1) {
				if (!device.a.$) {
					var version = device.a.a;
					return A2($author$project$NativeBridge$versionComparison, version, '1.0.0') !== 2;
				} else {
					var version = device.a.a;
					return A2($author$project$NativeBridge$versionComparison, version, '1.0.2') !== 2;
				}
			} else {
				return false;
			}
		}();
		var faceVerificationText = function () {
			if ((device.$ === 1) && (!device.a.$)) {
				return 'Face Verification';
			} else {
				return 'Face Verification beta';
			}
		}();
		var _v0 = $author$project$View$Helpers$UserInfo$getUserInfo(authState);
		var photoVerifyStatus = _v0.el;
		var avatar = _v0.cc;
		var username = _v0.dh;
		var membershipColor = _v0.d_;
		var photoVerificationMenu = (photoVerifyStatus || (!isFaceVerificationAvailable)) ? A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.gw)
				]),
			_List_Nil) : A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.gv),
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.lb)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(faceVerificationText)
						]))
				]));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.f1)
				]),
			_List_fromArray(
				[
					$author$project$View$Menu$Orange$AuthMobile$menuGlobalCss,
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.hE),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							$author$project$View$Menu$Orange$AuthMobile$mobileCssClass(menuStatus))
						]),
					_List_fromArray(
						[
							$author$project$View$Menu$Orange$AuthMobile$mobileCloseButton,
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.hL)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.mp)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$img,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$src(avatar),
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													$author$project$View$Menu$Orange$AuthMobile$styles.hI(membershipColor))
												]),
											_List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.mp),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.cJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(username)
										]))
								])),
							photoVerificationMenu,
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											$author$project$View$Menu$Orange$AuthMobile$profilesUrl(authState))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Profiles')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.km)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Messages')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.kb)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Blog')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.mp)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('My Profile')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.j7)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Block List')
										]))
								])),
							A2($author$project$View$Menu$Orange$AuthMobile$membershipLinkForSponsorOnly, device, authState.j2.ho),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.n6)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Update Password')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Orange$AuthMobile$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l5)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Logout')
										]))
								]))
						]))
				]));
	});
var $author$project$View$Header$Orange$Auth$view = F2(
	function (appModel, authState) {
		return (appModel.kR.nj > 767) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.hr)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.hz)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('/'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$img,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hA)
												]),
											_List_Nil)
										]))
								])),
							A2($author$project$View$Header$Orange$Auth$desktopTabs, appModel, authState)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.eD)
						]),
					_List_fromArray(
						[
							$author$project$View$Header$Orange$Auth$desktopNotification(authState),
							A3($author$project$View$Menu$Orange$AuthDesktop$view, appModel.n8.mM, appModel.d$, authState)
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.f1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.hz)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href('/'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hA)
										]),
									_List_Nil)
								]))
						])),
					A3($author$project$View$Menu$Orange$AuthMobile$view, appModel.d$, appModel.kQ, authState),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$Orange$Auth$styles.eD)
						]),
					_List_fromArray(
						[
							$author$project$View$Header$Orange$Auth$mobileSearchIcon,
							$author$project$View$Header$Orange$Auth$mobileChatIcon(authState),
							$author$project$View$Menu$Orange$AuthMobile$openButton
						]))
				]));
	});
var $author$project$View$Header$orangeHeader = function (appModel) {
	var _v0 = appModel.j1;
	if (_v0.$ === 1) {
		return $author$project$View$Header$orangePublicHeader(appModel);
	} else {
		var authState = _v0.a;
		return A2($author$project$View$Header$Orange$Auth$view, appModel, authState);
	}
};
var $author$project$View$Layout$missingAvatar = function () {
	var styles = {
		f1: _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(15),
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.l$),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
			]),
		ht: _Utils_ap(
			$author$project$View$Theme$defaultStyles.ht,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
					$rtfeldman$elm_css$Css$lineHeight(
					$rtfeldman$elm_css$Css$px(18))
				]))
	};
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.f1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.ht),
						$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.mp)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Upload your Profile Photo now to ')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('increase your profile views significantly.')
							]))
					]))
			]));
}();
var $author$project$View$Layout$showMissingAvatarWarning = F2(
	function (authState, route) {
		return ($author$project$View$Helpers$UserInfo$isMissingAvatar(authState) && (!_Utils_eq(route, $author$project$Data$Route$ChatRoute))) ? $author$project$View$Layout$missingAvatar : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$View$Footer$styles = {
	f1: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(50),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.lA),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
				]))
		]),
	cl: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$lineHeight($author$project$View$Theme$fonts.ns.mB),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly)
		]),
	f7: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$flexGrow(
			$rtfeldman$elm_css$Css$num(2))
		]),
	gl: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(-3))
		]),
	dC: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(140))
		]),
	ht: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$lineHeight($author$project$View$Theme$fonts.ns.j4),
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.nt),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.ly),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
				])),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB)
				]))
		]),
	hz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(188))
		]),
	bX: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(20))
		]),
	i5: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100))
		]),
	dd: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies($author$project$View$Theme$fonts.lf.cg),
			$rtfeldman$elm_css$Css$fontSize($author$project$View$Theme$fonts.ns.mB),
			$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.gO)
		]),
	aE: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(50)),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(20))
				]))
		])
};
var $author$project$View$Footer$connectWithUs = function () {
	var padLeft = function (element) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginLeft(
							$rtfeldman$elm_css$Css$px(6))
						]))
				]),
			_List_fromArray(
				[element]));
	};
	var email = 'hello@happymatches.com';
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.aE)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.dd)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Connect')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.i5)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.facebook.com/Happy-Matches-604669763239304/'),
								$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.c5.ld),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.bX)
									]),
								_List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href('https://twitter.com/happymatches'),
								$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.c5.n$),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.bX)
									]),
								_List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.instagram.com/happymatches/'),
								$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.c5.lR),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.bX)
									]),
								_List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.linkedin.com/company/happymatches-com/'),
								$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.c5.l0),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.bX)
									]),
								_List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:' + email),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap($author$project$View$Footer$styles.gl, $author$project$View$Footer$styles.ht))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.dt)
									]),
								_List_Nil),
								padLeft(
								$rtfeldman$elm_css$Html$Styled$text(email))
							]))
					]))
			]));
}();
var $author$project$View$Footer$credits = function (currentTime) {
	var year = $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, $elm$time$Time$utc, currentTime));
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap($author$project$View$Footer$styles.aE, $author$project$View$Footer$styles.f7))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.l2),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.hz)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.cl)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Copyright © ' + (year + ' by HappyMatches.com'))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.cl)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('All rights reserved.')
					]))
			]));
};
var $author$project$View$Footer$discover = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.aE)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.dd)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Discover')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.ht),
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.jN)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('How It Works')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.ht),
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.kb)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Blog')
				]))
		]));
var $author$project$View$Footer$download = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.aE)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.dd)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Download')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href('https://play.google.com/store/apps/details?id=com.app.happymatches'),
					$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.lu),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.dC)
						]),
					_List_Nil)
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href('https://apps.apple.com/app/happy-matches/id1460563032'),
					$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.jZ),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.dC)
						]),
					_List_Nil)
				]))
		]));
var $author$project$View$Footer$explore = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.aE),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'exploreMenu')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.dd)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Explore')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.ht),
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.nS)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Terms of Use')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.ht),
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.m$)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Privacy Policy')
				]))
		]));
var $author$project$View$Footer$support = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.aE)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.dd)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Support')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.ht),
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l1)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Login')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.ht),
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.na)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Sign Up')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.ht),
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.ky)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Contact Us')
				]))
		]));
var $author$project$View$Footer$view = function (currentTime) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.f1)
			]),
		_List_fromArray(
			[
				$author$project$View$Footer$credits(currentTime),
				$author$project$View$Footer$download,
				$author$project$View$Footer$discover,
				$author$project$View$Footer$explore,
				$author$project$View$Footer$support,
				$author$project$View$Footer$connectWithUs
			]));
};
var $author$project$View$Layout$orangeLayout = F2(
	function (model, subView) {
		var _v0 = model.j1;
		if (_v0.$ === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden)
							]))
					]),
				_List_fromArray(
					[
						A2($author$project$View$Alert$view, model.kR, model.b8),
						$author$project$View$Header$orangeHeader(model),
						subView,
						$author$project$View$Footer$view(model.kG)
					]));
		} else {
			var authState = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden)
							]))
					]),
				_List_fromArray(
					[
						A2($author$project$View$Alert$view, model.kR, model.b8),
						$author$project$View$Header$orangeHeader(model),
						A2($author$project$View$Layout$showMissingAvatarWarning, authState, model.ng),
						subView
					]));
		}
	});
var $author$project$View$Menu$Transparent$styles = {
	ci: _Utils_ap(
		$author$project$View$Theme$defaultStyles.lt,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$margin(
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh),
				$rtfeldman$elm_css$Css$borderColor($author$project$View$Theme$colors.eh),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og)
					]))
			])),
	hE: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
					$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$left(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(1000)),
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.ly),
					$rtfeldman$elm_css$Css$Transitions$transition(
					_List_fromArray(
						[
							A3(
							$rtfeldman$elm_css$Css$Transitions$transform3,
							300,
							0,
							A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0.17, 0.04, 0.03, 0.94))
						]))
				]))
		]),
	cJ: _Utils_ap(
		$author$project$View$Theme$defaultStyles.kd,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(15)),
				$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
				$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.og),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color($author$project$View$Theme$colors.eh)
					])),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Css$margin2,
						$rtfeldman$elm_css$Css$px(10),
						$rtfeldman$elm_css$Css$zero)
					]))
			])),
	hI: function (color_) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
				$author$project$View$Theme$forMobileScreen(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(120)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(120)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$pct(50)),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(2),
						$rtfeldman$elm_css$Css$solid,
						color_)
					]))
			]);
	},
	hJ: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$top(
					$rtfeldman$elm_css$Css$px(38)),
					$rtfeldman$elm_css$Css$right(
					$rtfeldman$elm_css$Css$px(30))
				]))
		]),
	hK: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$top(
					$rtfeldman$elm_css$Css$px(38)),
					$rtfeldman$elm_css$Css$right(
					$rtfeldman$elm_css$Css$px(30))
				]))
		]),
	hL: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
			$author$project$View$Theme$forMobileScreen(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(50))
				]))
		])
};
var $author$project$View$Menu$Transparent$membershipLinkForSponsorOnly = function (userKind) {
	if (!userKind) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.cJ),
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l9)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('My Membership')
						]))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$View$Menu$Transparent$mobileCloseButton = A2(
	$rtfeldman$elm_css$Html$Styled$li,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Events$onClick(
			$author$project$Types$UpdateMenuStatus(1)),
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.hJ),
			$rtfeldman$elm_css$Html$Styled$Attributes$id('mobile-close-button')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.kv)
				]),
			_List_Nil)
		]));
var $author$project$View$Menu$Transparent$mobileCssClass = function (menuStatus) {
	if (!menuStatus) {
		return 'mobile-menu-opened';
	} else {
		return 'mobile-menu-closed';
	}
};
var $author$project$View$Menu$Transparent$mobileOpenButton = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Events$onClick(
			$author$project$Types$UpdateMenuStatus(0)),
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.hK),
			$rtfeldman$elm_css$Html$Styled$Attributes$id('mobile-open-button')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.hE)
				]),
			_List_Nil)
		]));
var $author$project$View$Menu$Transparent$authMenu = F2(
	function (menuStatus, authState) {
		var _v0 = $author$project$View$Helpers$UserInfo$getUserInfo(authState);
		var avatar = _v0.cc;
		var username = _v0.dh;
		var membershipColor = _v0.d_;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Menu$Transparent$mobileOpenButton,
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.hE),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							$author$project$View$Menu$Transparent$mobileCssClass(menuStatus))
						]),
					_List_fromArray(
						[
							$author$project$View$Menu$Transparent$mobileCloseButton,
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.hL)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.mp)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$img,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$src(avatar),
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													$author$project$View$Menu$Transparent$styles.hI(membershipColor))
												]),
											_List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.mp),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.cJ)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(username)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											$author$project$Model$Route$profilesUrl(authState))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Profiles')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.km)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Messages')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.kb)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Blog')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.mp)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('My Profile')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.j7)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Block List')
										]))
								])),
							$author$project$View$Menu$Transparent$membershipLinkForSponsorOnly(authState.j2.ho),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.n6)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Update Password')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.cJ),
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.l5)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Logout')
										]))
								]))
						]))
				]));
	});
var $author$project$View$Menu$Transparent$menuGlobalCss = $rtfeldman$elm_css$Css$Global$global(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Global$class,
			'mobile-menu-closed',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform($rtfeldman$elm_css$Css$none)
				])),
			A2(
			$rtfeldman$elm_css$Css$Global$class,
			'mobile-menu-opened',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$translateX(
						$rtfeldman$elm_css$Css$pct(-100)))
				]))
		]));
var $author$project$View$Menu$Transparent$publicMenu = function (menuStatus) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$View$Menu$Transparent$mobileOpenButton,
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.hE),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						$author$project$View$Menu$Transparent$mobileCssClass(menuStatus))
					]),
				_List_fromArray(
					[
						$author$project$View$Menu$Transparent$mobileCloseButton,
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.cJ),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.jN)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('About Us')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.cJ),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.kb)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Blog')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Transparent$styles.ci),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.na)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Login / Sign Up')
									]))
							]))
					]))
			]));
};
var $author$project$View$Menu$Transparent$view = function (_v0) {
	var authState = _v0.j1;
	var menuStatus = _v0.d$;
	if (authState.$ === 1) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Menu$Transparent$menuGlobalCss,
					A2(
					$rtfeldman$elm_css$Html$Styled$nav,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$View$Menu$Transparent$publicMenu(menuStatus)
						]))
				]));
	} else {
		var authState_ = authState.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Menu$Transparent$menuGlobalCss,
					A2(
					$rtfeldman$elm_css$Html$Styled$nav,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$View$Menu$Transparent$authMenu, menuStatus, authState_)
						]))
				]));
	}
};
var $author$project$View$Header$transparentHeader = function (appModel) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
						$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$px(30),
						$rtfeldman$elm_css$Css$px(15)),
						$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href('/'),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.l3)
							]),
						_List_Nil)
					])),
				$author$project$View$Menu$Transparent$view(appModel)
			]));
};
var $author$project$View$Layout$transparentLayout = F2(
	function (model, subView) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$View$Alert$view, model.kR, model.b8),
					$author$project$View$Header$transparentHeader(model),
					subView,
					$author$project$View$Footer$view(model.kG)
				]));
	});
var $author$project$View$Layout$view = F2(
	function (model, _v0) {
		var layout = _v0.a;
		var subView = _v0.b;
		switch (layout) {
			case 0:
				return A2($author$project$View$Layout$noMenuLayout, model, subView);
			case 1:
				return A2($author$project$View$Layout$transparentLayout, model, subView);
			default:
				return A2($author$project$View$Layout$orangeLayout, model, subView);
		}
	});
var $author$project$View$body = function (model) {
	return A2(
		$author$project$View$Layout$view,
		model,
		$author$project$View$page(model));
};
var $author$project$View$title = function (model) {
	var defaultTitle = 'HappyMatches | Best Free Dating App & Site for Hookup Fling ONS & FWB';
	var getCategoryMetaTitle = function (category) {
		var _v3 = model.cl.I;
		if (!_v3.$) {
			return defaultTitle;
		} else {
			var categories = _v3.a;
			return A2(
				$elm$core$Maybe$withDefault,
				defaultTitle,
				A2(
					$elm$core$Maybe$map,
					function (categoryName) {
						return 'Online Dating Blog for ' + (categoryName + ' | Modern Dating & Conventional Dating');
					},
					A2($author$project$Data$Content$categoryUrlNameToName, categories, category)));
		}
	};
	var getContentMetaTitle = function (content) {
		if (!content.$) {
			var metaTitle = content.a.cL;
			return metaTitle;
		} else {
			return defaultTitle;
		}
	};
	var _v0 = model.ng;
	switch (_v0.$) {
		case 1:
			return 'About Us | HappyMatches Dating App & Site for Hookup Fling ONS & FWB';
		case 12:
			return 'Account Sign Up: Meet Charming Suitors and Attractive Dates';
		case 10:
			return 'Account Login/Sign In: Meet Charming Suitors and Attractive Dates';
		case 23:
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return 'Online Dating Blog | Modern Dating & Conventional Dating';
				case 1:
					var url = _v0.a.a;
					return getContentMetaTitle(
						A2($author$project$Model$Content$findPage, url, model.cl));
				case 2:
					var url = _v0.a.a;
					return getContentMetaTitle(
						A2($author$project$Model$Content$findPost, url, model.cl));
				default:
					var category = _v0.a.a;
					return getCategoryMetaTitle(category);
			}
		default:
			return defaultTitle;
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $author$project$View$view = function (model) {
	return {
		cg: _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$toUnstyled(
				A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$View$body, model))
			]),
		dd: $author$project$View$title(model)
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{lN: $author$project$Model$initialModel, mF: $author$project$Types$OnUrlChange, mG: $author$project$Types$OnUrlRequest, nF: $author$project$Subscriptions$subscriptions, n4: $author$project$Model$update, oc: $author$project$View$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (timezoneOffset) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (preRenderedHtml) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (multiCardsConfig) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (initialPushNotification) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (dimension) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (device) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (currentTime) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (bundleID) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (authUser) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (appVersion) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (apiUrls) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (adminUserIDs) {
																									return $elm$json$Json$Decode$succeed(
																										{jQ: adminUserIDs, jX: apiUrls, jY: appVersion, j2: authUser, ki: bundleID, kG: currentTime, kQ: device, kR: dimension, lO: initialPushNotification, mn: multiCardsConfig, mZ: preRenderedHtml, nV: timezoneOffset});
																								},
																								A2(
																									$elm$json$Json$Decode$field,
																									'adminUserIDs',
																									A2(
																										$elm$json$Json$Decode$andThen,
																										function (male) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (female) {
																													return $elm$json$Json$Decode$succeed(
																														{lj: female, l6: male});
																												},
																												A2($elm$json$Json$Decode$field, 'female', $elm$json$Json$Decode$string));
																										},
																										A2($elm$json$Json$Decode$field, 'male', $elm$json$Json$Decode$string))));
																						},
																						A2(
																							$elm$json$Json$Decode$field,
																							'apiUrls',
																							A2(
																								$elm$json$Json$Decode$andThen,
																								function (sendEmailVerificationUrl) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (membershipReactivateUrl) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (membershipDowngradeUrl) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (membershipCancelUrl) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (iOsCheckReceiptUrl) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (getRandomProfilesUrl) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (androidCheckTokenUrl) {
																																					return $elm$json$Json$Decode$succeed(
																																						{jV: androidCheckTokenUrl, ls: getRandomProfilesUrl, lJ: iOsCheckReceiptUrl, ma: membershipCancelUrl, mb: membershipDowngradeUrl, mc: membershipReactivateUrl, np: sendEmailVerificationUrl});
																																				},
																																				A2($elm$json$Json$Decode$field, 'androidCheckTokenUrl', $elm$json$Json$Decode$string));
																																		},
																																		A2($elm$json$Json$Decode$field, 'getRandomProfilesUrl', $elm$json$Json$Decode$string));
																																},
																																A2($elm$json$Json$Decode$field, 'iOsCheckReceiptUrl', $elm$json$Json$Decode$string));
																														},
																														A2($elm$json$Json$Decode$field, 'membershipCancelUrl', $elm$json$Json$Decode$string));
																												},
																												A2($elm$json$Json$Decode$field, 'membershipDowngradeUrl', $elm$json$Json$Decode$string));
																										},
																										A2($elm$json$Json$Decode$field, 'membershipReactivateUrl', $elm$json$Json$Decode$string));
																								},
																								A2($elm$json$Json$Decode$field, 'sendEmailVerificationUrl', $elm$json$Json$Decode$string))));
																				},
																				A2($elm$json$Json$Decode$field, 'appVersion', $elm$json$Json$Decode$string));
																		},
																		A2(
																			$elm$json$Json$Decode$field,
																			'authUser',
																			$elm$json$Json$Decode$oneOf(
																				_List_fromArray(
																					[
																						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																						A2(
																						$elm$json$Json$Decode$map,
																						$elm$core$Maybe$Just,
																						A2(
																							$elm$json$Json$Decode$andThen,
																							function (uid) {
																								return A2(
																									$elm$json$Json$Decode$andThen,
																									function (photoURL) {
																										return A2(
																											$elm$json$Json$Decode$andThen,
																											function (isAnonymous) {
																												return A2(
																													$elm$json$Json$Decode$andThen,
																													function (emailVerified) {
																														return A2(
																															$elm$json$Json$Decode$andThen,
																															function (email) {
																																return A2(
																																	$elm$json$Json$Decode$andThen,
																																	function (displayName) {
																																		return $elm$json$Json$Decode$succeed(
																																			{ds: displayName, dt: email, k_: emailVerified, lU: isAnonymous, mQ: photoURL, eX: uid});
																																	},
																																	A2(
																																		$elm$json$Json$Decode$field,
																																		'displayName',
																																		$elm$json$Json$Decode$oneOf(
																																			_List_fromArray(
																																				[
																																					$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																				]))));
																															},
																															A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string));
																													},
																													A2($elm$json$Json$Decode$field, 'emailVerified', $elm$json$Json$Decode$bool));
																											},
																											A2($elm$json$Json$Decode$field, 'isAnonymous', $elm$json$Json$Decode$bool));
																									},
																									A2(
																										$elm$json$Json$Decode$field,
																										'photoURL',
																										$elm$json$Json$Decode$oneOf(
																											_List_fromArray(
																												[
																													$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																													A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																												]))));
																							},
																							A2($elm$json$Json$Decode$field, 'uid', $elm$json$Json$Decode$string)))
																					]))));
																},
																A2(
																	$elm$json$Json$Decode$field,
																	'bundleID',
																	$elm$json$Json$Decode$oneOf(
																		_List_fromArray(
																			[
																				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																			]))));
														},
														A2($elm$json$Json$Decode$field, 'currentTime', $elm$json$Json$Decode$int));
												},
												A2($elm$json$Json$Decode$field, 'device', $elm$json$Json$Decode$string));
										},
										A2(
											$elm$json$Json$Decode$field,
											'dimension',
											A2(
												$elm$json$Json$Decode$andThen,
												function (screenWidth) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (screenHeight) {
															return $elm$json$Json$Decode$succeed(
																{ni: screenHeight, nj: screenWidth});
														},
														A2($elm$json$Json$Decode$field, 'screenHeight', $elm$json$Json$Decode$float));
												},
												A2($elm$json$Json$Decode$field, 'screenWidth', $elm$json$Json$Decode$float))));
								},
								A2(
									$elm$json$Json$Decode$field,
									'initialPushNotification',
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
											]))));
						},
						A2(
							$elm$json$Json$Decode$field,
							'multiCardsConfig',
							A2(
								$elm$json$Json$Decode$andThen,
								function (pageOrderID) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (merchantID) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (checkoutUrl) {
													return $elm$json$Json$Decode$succeed(
														{kq: checkoutUrl, md: merchantID, mJ: pageOrderID});
												},
												A2($elm$json$Json$Decode$field, 'checkoutUrl', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'merchantID', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'pageOrderID', $elm$json$Json$Decode$string))));
				},
				A2($elm$json$Json$Decode$field, 'preRenderedHtml', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'timezoneOffset', $elm$json$Json$Decode$int)))(0)}});}(this));